window.USER_SETTINGS = window.USER_SETTINGS || {};
window.NOOP = () => {};

var APP = APP || function () {};
window.APP = APP;


function Arti() {
    var exports = {},
        partials = {},
        helpers = {
            'each': function (object, contentBlock) {
                var content = '';

                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        content += contentBlock(object[key], {key: key, index: key});
                    }

                }

                return content;

            },
            'with': function (object, contentBlock) {
                return contentBlock(object || {});
            }

        },

        fnBegin = 'function(meta,root,parent,helpers,partials,nth){meta=meta||{};' +
            'meta.context=this;meta.parent=parent;var out="',

        regexp = [
            // handle multi matches :
            [/}}/g, '}}\r\n'],
            // remove comments {{!-- xy --}} or {{! xy}} :
            [/({{!--.+?--}}|{{!.+?}})/g, ''],
            // handle double quotes :
            [/(")(?![^{]*}})/g, '\\"'],
            // if :
            [/{{#if (.+?)}}/g, '";if($1){out+="'],
            // else if :
            [/{{#elseif (.+?)}}/g, '"}else if($1){out+="'],
            // else :
            [/{{#else}}/g, '"}else{out+="'],
            // end if :
            [/{{\/if}}/g, '"}out+="'],
            // singe helper :
            [/{{#(.+?) (.+?)\/}}/g, '"+helpers.$1.call(this,($2))+"'],
            // singe helper without arguments :
            [/{{#(.+?)\/}}/g, '"+helpers.$1.call(this)+"'],
            // open block helper :
            [/{{#(.+?) (.+?)}}/g, '"+helpers.$1.call(this,($2),function(c,m){return(' + fnBegin],
            // open block helper without arguments :
            [/{{#(.+?)}}/g, '"+helpers.$1(function(c,m){return(' + fnBegin],
            // end block helper :
            [/{{\/(.+?)}}/g, '";return out}).call(c,m,root,meta,helpers,partials)})+"'],
            // partial :
            [/{{>(.+?) (.+?)}}/g, '"+partials.$1($2)+"'],
            // partial without arguments :
            [/{{>(.+?)}}/g, '"+partials.$1()+"'],
            // default :
            [/{{(.+?)}}/g, '"+($1)+"'],
            [/\r\n/g, '']
        ];

    function getTemplateFunction(_templateString) {
        return eval('(' + fnBegin + (function () {
                for (var i = 0; i < regexp.length; i++) {
                    _templateString = _templateString && _templateString.replace(regexp[i][0], regexp[i][1]);
                }

                return _templateString;
            })() + '";return out})');
    }

    exports.template = function (_templateString) {
        var fn = getTemplateFunction(_templateString);
        return function (_context) {
            _context = _context || {};
            return fn.call(_context, {}, _context, false, helpers, partials, function (object, index) {
                return object[index];
            });
        }

    };

    exports.addHelper = function (_helperName, _function) {
        helpers[_helperName] = _function;
    };

    exports.addPartial = function (_partialName, _templateString) {
        partials[_partialName] = exports.template(_templateString);
    };

    return exports;
}


APP.Pro = (function () {
    var exports = {},
        initialized = false,
        $payButton,
        groupMinimum = 10,
        schoolMinimum = 100;

    function init() {
        $payButton = $body.find('[data-pay-whit-cart]');
        initProBindings();
        initialized = true;
        initPaymentUi();
    }

    function initPaymentUi() {
        $body.find('[data-payment-method-select]').trigger('change');
        checkRememberContainerVisibility();
    }

    function getPrice(quantity, period, currency) {
        // TODO HANDLE THIS!
        var price = window.PRICE[currency || 'actual'][period].default;

        if (quantity >= schoolMinimum) {
            price = window.PRICE[currency || 'actual'][period].school;
        } else if (quantity >= groupMinimum) {
            price = window.PRICE[currency || 'actual'][period].group;
        }

        return price;
    }

    function initProBindings() {
        if (initialized) {
            $body.find('[data-pro-quantity-input]').trigger('input');
            return;
        }

        $body.on('change', '[data-pro-quantity-input]', function () {
            var $this = $(this),
                quantity = parseInt($this.val() || 1) || 1;

            if (quantity <= 1) {
                $this.val(quantity);
                if ($body.find('[data-pro-group-plan]').length) {
                    $this.val(2);
                    $this.trigger('input');
                    APP.Layout.openOverlay('go-pro-with-one');
                }
            }
        });

        $body.on('input', '[data-pro-quantity-input]', function () {
            var $this = $(this),
                currency = $body.find('[data-pro-currency]').val().toUpperCase(),
                quantity = parseInt($this.val()) || 1,
                period = $body.find('[data-pro-period]').val(),
                finalPrice = getPrice(quantity, period, currency);

            $body.find('[data-pro-quantitiy]').html(quantity);
            $body.find('[data-pro-price]').html((function () {
                var price = quantity * finalPrice;

                if (price !== Math.round(price)) {
                    price = (price).toFixed(2);
                }

                return price;
            })().toString(10).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));

            $body.find('[data-pro-curr]').html(currency);
            $body.find('[data-pro-one-price]').html((finalPrice).toString(10).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
            $body.find('[data-pro-discount-alert]').hide();
            if (quantity >= 5 && quantity < 10) {
                $body.find('[data-pro-optimum-quantity]').text(10);
                $body.find('[data-pro-discount-alert]').css('display', 'block');
            } else if (quantity >= 67 && quantity < 100) {
                $body.find('[data-pro-optimum-quantity]').text(100);
                $body.find('[data-pro-discount-alert]').css('display', 'block');
            }
        });

        $body.find('[data-pro-quantity-input]').trigger('input');

        $body.on('change', '[data-pro-period]', function () {
            $body.find('[data-pro-quantity-input]').trigger('input');
        });

        $body.on('change', '[data-pro-currency]', function () {
            $body.find('[data-pro-quantity-input]').trigger('input');
        });

        $body.on('click', '[data-buy-packages]', function () {
            var name = $body.find('[data-pro-name]').val();

            if (name) {
                buyPackages({
                    billName: name,
                    quantity: parseInt($body.find('[data-pro-quantity-input]').val(), 10),
                    activateUserPro: $body.find('[data-activate-user-account]').prop('checked'),
                    groupNeed: $body.find('[data-pro-need-group]').prop('checked'),
                    groupName: name,
                    period: $body.find('[data-pro-period]').val(),
                    renew: $body.find('[name="renew"]').prop('checked'),
                    code: $body.find('[data-code-input]').val(),
                    codeMode: $body.find('[data-activation-code-mode]').val(),
                    ownerId: $body.find('[data-subscription-owner]').val(),
                    currency: $body.find('[data-pro-currency]').val(),
                    schoolData: {
                        name: $body.find('[data-pro-school-name]').val(),
                        year: $body.find('[data-pro-school-year]').val()
                    }
                });
            } else {
                $body.find('[data-pro-name]').addClass('form--error-show');
            }
        });

        $body.on('click', '[data-show-code-payment]', function () {
            $body.find('[data-payment-wrapper]').hide();
            $body.find('[data-code-payment-wrapper]').show();
            $body.find('[data-code-input]').focus();
            $body.find('[data-activation-code-mode]').val('1');
        });

        $body.on('click', '[data-hide-code-payment]', function () {
            $body.find('[data-payment-wrapper]').show();
            $body.find('[data-code-payment-wrapper]').hide();
            $body.find('[data-activation-code-mode]').val('0');
        });

        $body.on('click', '[data-activate-packages]', function () {
            var name = $body.find('[data-pro-name]').val();

            if (name) {
                activatePackage({
                    'code': $body.find('[data-pro-activation-code]').val(),
                    'school-name': $body.find('[data-pro-school-name]').val(),
                    'school-year': $body.find('[data-pro-school-year]').val()
                });
            } else {
                $body.find('[data-pro-name]').addClass('form--error-show');
            }
        });

        $body.on('change', '[data-activation-code]', function () {
            $body.find('[data-hidden-activation-code]').val($(this).val());
        });

        $body.on('click', '[data-delete-subscription]', function () {
            deleteSubscription($(this).attr('data-delete-subscription'));
        });

        $body.on('click', '[data-remove-pro]', function () {
            removePro($(this).attr('data-remove-pro'), $(this).attr('data-remove-pro-code'));
        });

        $body.on('click', '[data-set-renew]', function () {
            setRenew($(this).attr('data-set-renew') === 'true', $body.find('[data-bill-id]').attr('data-bill-id'));
        });

        $body.on('click', '[data-add-pro]', function () {
            addPro($(this).attr('data-add-pro'));
        });

        $body.on('click', '[data-go-pro]', function (event) {
            event.preventDefault();
            event.stopPropagation();
            APP.Page.applyPageByUrl('/hu/pro');
        });

        $body.on('click', '[data-wire-promise]', function (event) {
            var $this = $(this),
                url = $this.attr('data-wire-promise');

            APP.Ajax.post(url).then(function () {
                if ($body.find('.application').hasClass('user--logedin')) {
                    APP.Page.applyPageByUrl('/hu/pro/success-wire-transfer');
                } else {
                    APP.Page.applyPageByUrl('/hu/pro/success-wire-transfer?signup=true');
                }
            }, window.NOOP);
        });

        $body.on('input', '[data-pro-activation-code]', function () {
            var $this = $(this);

            if ($this.val().length > 0) {
                $body.find('[data-activate-packages]').show();
                $body.find('[data-buy-packages]').hide();
            } else {
                $body.find('[data-activate-packages]').hide();
                $body.find('[data-buy-packages]').show();
            }
        });

        $body.on('click', '[data-generate-new-activation-code]', function () {
            var $this = $(this),
                id = $this.attr('data-generate-new-activation-code');

            APP.Ajax.post('/hu/service/pro/new-activation-code/' + $this.attr('data-generate-new-activation-code'))
                .then(function (result) {
                    if (result.success) {
                        APP.Page.applyPageByUrl('/hu/pro/subscription/' + id);
                    } else {
                        APP.Layout.openOverlay('generate-new-activation-error');
                    }
                }, function () {
                    APP.Layout.openOverlay('generate-new-activation-error');
                });
        });

        $body.on('click', '[data-revert-subscription]', function () {
            var $this = $(this),
                id = $this.attr('data-revert-subscription');

            $body.find('[data-revert-sub]').attr('data-revert-sub', id);
            APP.Layout.openOverlay('revert-subscription');
        });

        $body.on('click', '[data-revert-sub]', function () {
            var $this = $(this),
                id = $this.attr('data-revert-sub');

            APP.Ajax.post('/hu/service/pro/revert-subscription/' + id)
                .then(function (result) {
                    if (result.success) {
                        APP.Page.reloadPage();
                    } else {
                        APP.Layout.closeOverlay();
                        APP.Layout.openOverlay('revert-subscription-error');
                    }
                }, function () {
                    APP.Layout.closeOverlay();
                    APP.Layout.openOverlay('revert-subscription-error');
                });
        });

        $body.on('change', '[data-payment-method-select]', function () {
            var $this = $(this),
                value = $this.val(),
                $container = $body.find('[data-card-container]');

            if (value === 'card') {
                $container.show();
            } else {
                $container.hide();
            }
        });

        $body.on('change', '[data-card-container] [name="card"]', checkRememberContainerVisibility);
        $body.on('change', '[data-card-container] [name="remember"]', function () {
            var $this = $(this),
                checked = $this.is(':checked');

            if (!checked) {
                $body.find('input[type="checkbox"][name="renew"]').prop('checked', false);
            }
        });
        $body.on('change', '[data-card-container] [name="renew"]', function () {
            var $this = $(this),
                checked = $this.is(':checked');

            if (checked) {
                $body.find('input[type="checkbox"][name="remember"]').prop('checked', true);
            }
        });

    }

    function checkRememberContainerVisibility() {
        var value = $body.find('[data-card-container] [name="card"]:checked').val(),
            $rememberContainer = $body.find('[data-card-remember-container]');

        if (value === 'new') {
            $rememberContainer.show();
        } else {
            $rememberContainer.hide();
        }
    }

    function deleteSubscription(id) {
        APP.Ajax.post('/hu/service/pro/delete/' + id).then(function (result) {
            //todo: prompt window!
            if (result.success) {
                $body.find('[data-delete-subscription="' + id + '"]').parents('tbody').remove();
            } else {
                APP.Layout.openOverlay('fail-action');
            }
        }, function () {
            APP.Layout.openOverlay('fail-action');
        });
    }

    function removePro(id, code) {
        APP.Ajax.post('/hu/service/pro/remove-user/', {
            userId: id,
            code: code,
            billId: $body.find('[data-bill-id]').attr('data-bill-id')
        }).then(function (result) {
            if (result.success) {
                APP.Page.applyPageByUrl(document.location.href);
            }
        }, function () {
            APP.Layout.openOverlay('fail-action');
        });
    }

    function setRenew(value, billId) {
        APP.Ajax.post('/hu/service/pro/set-renew/', {
            billId: billId,
            value: value
        }).then(function (result) {
            APP.Page.applyPageByUrl(document.location.href);
        }, window.NOOP);
    }

    function addPro(id) {
        APP.Ajax.post('/hu/service/pro/add-user/', {
            userId: id,
            billId: $body.find('[data-bill-id]').attr('data-bill-id')
        }).then(function (result) {
            if (result.success) {
                APP.Page.applyPageByUrl(document.location.href);
            } else {
                APP.Layout.openOverlay('fail-action');
            }
        }, function () {
            APP.Layout.openOverlay('fail-action');
        });
    }

    function buyPackages(data) {
        APP.Ajax.post('/hu/service/pro/create-bill', data).then(function (result) {
            if (result.success) {
                if (result.result) {
                    APP.Page.applyPageByUrl('/hu/pro/billing/' + result.result);
                } else if (result.billId) {
                    APP.Page.applyPageByUrl('/hu/pro/subscription/' + result.billId);
                } else {
                    APP.Page.applyPageByUrl('/hu/');
                }
            } else {
                $body.find('[data-buy-error-text]').text((result.error || {}).global ||
                    $body.find('[data-buy-error-text]').attr('data-buy-error-text'));
                APP.Layout.openOverlay('buy-error');
            }
        }, function () {
            $body.find('[data-buy-error-text]').text($body.find('[data-buy-error-text]').attr('data-buy-error-text'));
            APP.Layout.openOverlay('buy-error');
        });
    }

    function activatePackage(data) {
        APP.Ajax.post('/hu/service/pro/activate', data).then(function (result) {
            if (result.success) {
                APP.Page.applyPageByUrl('/hu/');
            } else {
                APP.Layout.alert(result.error.global);
            }
        }, () => {
            APP.Layout.alert(result.error.global);
        });
    }

    function successBillingSettings(data) {
        if (data.redirect) {
            document.location.href = data.redirect;
        } else {
            APP.Page.applyPageByUrl('/hu/pro/pay-review/' + $body.find('[data-bill-id]').attr('data-bill-id'));
        }
    }

    function successSelectPayment(data) {
        if (data.redirect) {
            document.location.href = data.redirect;
        } else {
            APP.Page.applyPageByUrl('/hu/pro/pay-wire-transfer/' + $body.find('[name="billId"]').val());
        }
    }

    function successActivationCode() {
        APP.Page.applyPageByUrl('/hu/');
    }

    function successActivationCodeModification() {
        APP.Page.applyPageByUrl(document.location.href);
    }

    exports.init = init;
    exports.successBillingSettings = successBillingSettings;
    exports.successSelectPayment = successSelectPayment;
    exports.successActivationCode = successActivationCode;
    exports.successActivationCodeModification = successActivationCodeModification;
    exports.getPrice = getPrice;
    return exports;

})();

APP.Tpl = (function () {
    var exports = {},
        initialized = false,
        templates = {},
        engine;

    function init() {
        engine = new Arti();
        engine.addPartial('icon', APP.$store.templates.icon);
        engine.addPartial('newsFeedCard', APP.$store.templates['newsfeed-card']);
        engine.addPartial('newsFeedCardActions', APP.$store.templates['newsfeed-card-actions']);
        engine.addHelper('safe', function (str) {
            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        });
        engine.addHelper('postReplacer', function (str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(
                    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig,
                    '<a href="$1" target="_blank">$1</a>'
                );
        });
        engine.addHelper('base64', base64Encode);
        engine.addHelper('lowercase', function (str) {
            return String(str).toLowerCase();
        });
    }

    function run(tpl, ctx) {
        if (templates.hasOwnProperty(tpl)) {
            return templates[tpl](ctx || {});
        } else if (APP.$store.templates.hasOwnProperty(tpl)) {
            templates[tpl] = engine.template(APP.$store.templates[tpl]);
            return run(tpl, ctx);
        } else if ($body.find('[data-tpl="' + tpl + '"]').length > 0) {
            var tplString = $body.find('[data-tpl="' + tpl + '"]').html();

            tplString = tplString.replace(/\n/g, '\\n');
            tplString = tplString.replace(/\(\(/g, '{{');
            tplString = tplString.replace(/\)\)/g, '}}');
            templates[tpl] = engine.template(tplString);
            return run(tpl, ctx);
        }
        throw new Error('no tmplate like: ' + tpl);
    }

    exports = {
        init: init,
        run: run
    };

    return exports;

})();
(function () {

    window.setCookie = function (cname, cvalue, exdays) {
        var d = new Date(),
            expires;
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';path=/; ' + expires;
    };


    window.getCookie = function (cname) {
        var name = cname + '=',
            ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };

    window.queryEncode = function (object) {
        var str = [];
        for (var p in object) {
            if (object.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(object[p]));
            }
        }
        return str.join("&");
    };

    window.queryDecode = function () {
        var args = document.location.search.substring(1).split('&'),
            arg,
            object = {},
            i;

        for (i = 0; i < args.length; i++) {
            arg = decodeURIComponent(args[i]);
            if (arg.indexOf('=') === -1) {
                object[arg.trim()] = true;
            } else {
                var kvp = arg.split('=');
                object[kvp[0].trim()] = kvp[1].trim();
            }

        }

        return object;

    };

    window.async = function (fn, timeout) {
        requestAnimationFrame(function () {
            setTimeout(fn, timeout || 8);
        });
    };

    window.showLog = function () {
        window.log = true;
        window.setCookie('show-log', 'true', 3);

    };

    window.hideLog = function () {
        window.log = false;
        window.setCookie('show-log', 'false', 100);
    };

    window.log = window.getCookie('show-log') === 'true';

    window.base64Encode = function (str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    };

    window.base64Decode = function (str) {
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };

    window.toB64 = function (string) {
        return replaceCharacters(btoa(string));
    };

    window.fromB64 = function (string) {
        return atob(replaceCharacters(string, true));
    };


    window.deepClone = function (object) {
        return (typeof structuredClone === 'function')
            ? structuredClone(object)
            : JSON.parse(JSON.stringify(object));
    };

    function replaceCharacters(string, backward) {
        var b64ReplaceTable = [
            ['/', '-'] // url pattern friendly
        ];

        b64ReplaceTable.forEach(function (item) {
            if (backward) {
                string = string.replace(new RegExp(item[1], 'g'), item[0]);
            } else {
                string = string.replace(new RegExp(item[0], 'g'), item[1]);

            }
        });

        return string;
    }
}());


APP.Ajax = (function () {
    var AJAX_REQUEST_ABORTED = 'ajax_request_aborted',
        AJAX_REQUEST_ABORTED_EVENT = 'ajax-request-aborted',
        exports = {},
        waitForResponse = 0,
        documentUnloading = false;

    function post(serviceUrl, data, silence, options) {
        return load(applyOptions({
            url: serviceUrl,
            data: data || {},
            method: 'POST',
            dataType: 'json'
        }, options), silence);
    }

    function get(url, silence, onRedirect) {
        return load({
            url: url,
            method: 'GET',
            dataType: 'html',
        }, silence, onRedirect);
    }

    function load(ajaxSettings, silence, onRedirect) {
        return new Promise(function (resolve, reject) {
            var detailedError,
                errorData,
                jqXHR,
                nativeXhr,
                urlObj,
                finalUrl;

            ajaxSettings = ajaxSettings || {};
            if (isMissingUrl(ajaxSettings.url)) {
                detailedError = new Error('Ajax Error: missing url for ' + getMethod(ajaxSettings) + ' request');
                errorData = getErrorData(ajaxSettings, {
                    status: 0,
                    statusText: 'missing_url',
                    responseText: ''
                }, 'missing_url');
                detailedError.ajax = errorData;
                handleAjaxError('ajax-client-error', ajaxSettings, detailedError, errorData);
                reject(detailedError);
                return;
            }

            ajaxSettings.timeout = ajaxSettings.timeout || 30000;
            ajaxSettings.xhr = function () {
                nativeXhr = $.ajaxSettings.xhr();
                return nativeXhr;
            };

            jqXHR = $.ajax(ajaxSettings);

            if (!silence) {
                subscribePromise(jqXHR);
            }

            jqXHR.done(function (res) {
                try {
                    urlObj = new URL(nativeXhr.responseURL);
                    urlObj.searchParams.delete('_');
                    finalUrl = urlObj.pathname + urlObj.search;
                    if (onRedirect && finalUrl && finalUrl !== ajaxSettings.url) {
                        onRedirect(finalUrl);
                    }
                } catch (e) {
                    APP.Error.logError(e, {
                        source: 'APP.Ajax.redirect-url',
                        context: {
                            requestUrl: String(ajaxSettings.url || ''),
                            responseUrl: nativeXhr && nativeXhr.responseURL || ''
                        }
                    });
                }
                resolve(res);
            }).fail(function (err, textStatus) {
                detailedError = new Error('Ajax Error: ' + textStatus + ' (' + getStatus(err) + ') on ' + ajaxSettings.url);
                errorData = getErrorData(ajaxSettings, err, textStatus, nativeXhr);
                detailedError.ajax = errorData;
                if (isExpectedStatusZeroAbort(ajaxSettings, err, textStatus)) {
                    markExpectedAbort(errorData);
                    detailedError.reported = true;
                    reportExpectedStatusZeroAbort(ajaxSettings, errorData);
                } else if (isExpectedAjaxAbort(err, textStatus)) {
                    markExpectedAbort(errorData);
                    reportExpectedAjaxAbort(detailedError, errorData);
                } else if (shouldReportAjaxFailure(err, textStatus)) {
                    handleAjaxError('ajax-server-error', ajaxSettings, detailedError, errorData);
                }
                reject(detailedError);
            });
        });
    }

    function applyOptions(settings, options) {
        var key;

        options = options || {};
        for (key in options) {
            if (options.hasOwnProperty(key)) {
                settings[key] = options[key];
            }
        }
        return settings;
    }

    function isMissingUrl(url) {
        var normalized = String(url || '').trim();

        return url === undefined ||
            url === null ||
            normalized === '' ||
            normalized === 'undefined' ||
            normalized.indexOf('undefined?') === 0 ||
            normalized.indexOf('undefined#') === 0;
    }

    function getMethod(ajaxSettings) {
        return (ajaxSettings.method || ajaxSettings.type || 'GET').toUpperCase();
    }

    function getErrorData(ajaxSettings, err, textStatus, nativeXhr) {
        return {
            url: String(ajaxSettings.url),
            method: getMethod(ajaxSettings),
            dataType: ajaxSettings.dataType || '',
            status: getStatus(err),
            statusText: err && err.statusText || textStatus || '',
            textStatus: textStatus || '',
            readyState: getReadyState(err, nativeXhr),
            expectedAbort: false,
            code: '',
            responseText: err && err.responseText ? err.responseText.substring(0, 500) : '',
            page: document.location.pathname,
            operation: getExpectedStatusZeroOperation(ajaxSettings)
        };
    }

    function getStatus(err) {
        if (err && err.status !== undefined && err.status !== null) {
            return err.status;
        }
        return '';
    }

    function getReadyState(err, nativeXhr) {
        if (err && typeof err.readyState === 'number') {
            return err.readyState;
        }
        if (nativeXhr && typeof nativeXhr.readyState === 'number') {
            return nativeXhr.readyState;
        }
        return null;
    }

    function getExpectedStatusZeroOperation(ajaxSettings) {
        return ajaxSettings &&
            ajaxSettings.expectedStatusZeroAbort &&
            ajaxSettings.expectedStatusZeroAbort.operation ||
            '';
    }

    function isExpectedStatusZeroAbort(ajaxSettings, err, textStatus) {
        return ajaxSettings &&
            ajaxSettings.expectedStatusZeroAbort &&
            isZeroStatus(err) &&
            textStatus !== 'timeout';
    }

    function serializeError(error) {
        return {
            name: error.name || 'Error',
            message: error.message || String(error),
            stack: error.stack || '',
            ajax: error.ajax || null
        };
    }

    function handleAjaxError(eventName, ajaxSettings, error, errorData) {
        if (isClientErrorLogRequest(ajaxSettings)) {
            return;
        }
        reportAjaxException(eventName, error, errorData);
    }

    function isExpectedAjaxAbort(err, textStatus) {
        return isZeroStatus(err) &&
            (textStatus === 'abort' || err && err.statusText === 'abort' || documentUnloading);
    }

    function isZeroStatus(err) {
        return err && err.status !== undefined && err.status !== null && Number(err.status) === 0;
    }

    function shouldReportAjaxFailure(err, textStatus) {
        return !isZeroStatus(err) || textStatus === 'timeout';
    }

    function markExpectedAbort(errorData) {
        errorData.expectedAbort = true;
        errorData.code = AJAX_REQUEST_ABORTED;
    }

    function reportExpectedAjaxAbort(error, errorData) {
        reportAjaxEvent(AJAX_REQUEST_ABORTED_EVENT, error, errorData);
    }

    function isExpectedAbort(error) {
        return !!(error && error.ajax && error.ajax.expectedAbort);
    }

    function reportAjaxException(eventName, error, errorData) {
        APP.Error.logError(error, {
            source: 'APP.Ajax.' + eventName,
            context: errorData
        });
        reportAjaxEvent(eventName, error, errorData);
    }

    function isClientErrorLogRequest(ajaxSettings) {
        return String(ajaxSettings && ajaxSettings.url || '').indexOf('/service/log-client-error') > -1;
    }

    function reportAjaxEvent(eventName, error, errorData) {
        if (APP.Analytics && APP.Analytics.capture) {
            APP.Analytics.capture(eventName, {
                error_details: errorData,
                exception: serializeError(error)
            });
        }
    }

    function reportExpectedStatusZeroAbort(ajaxSettings, errorData) {
        if (APP.Analytics && APP.Analytics.capture) {
            APP.Analytics.capture(
                ajaxSettings.expectedStatusZeroAbort.eventName || 'ajax-expected-status-zero-abort',
                {
                    ajax: errorData,
                    operation: errorData.operation,
                    route: errorData.page
                }
            );
        }
    }

    function subscribePromise(jqXHR) {
        waitForResponse++;
        updateLoadingState();
        jqXHR.always(function () {
            waitForResponse--;
            updateLoadingState();
        });
    }

    function updateLoadingState() {
        if (waitForResponse <= 0) {
            $body.removeClass('application--loading');
            waitForResponse = 0;
        } else {
            $body.addClass('application--loading');
        }
    }

    function bindPageLifecycle() {
        if (typeof window === 'undefined' || !window.addEventListener) {
            return;
        }
        window.addEventListener('pagehide', markDocumentUnloading);
        window.addEventListener('beforeunload', markDocumentUnloading);
        window.addEventListener('pageshow', markDocumentActive);
    }

    function markDocumentUnloading() {
        documentUnloading = true;
    }

    function markDocumentActive() {
        documentUnloading = false;
    }

    bindPageLifecycle();
    exports.post = post;
    exports.get = get;
    exports.load = load;
    exports.isExpectedAbort = isExpectedAbort;
    return exports;

})();

APP.Akri = (function () {
    var exports = {};

    function Akri($element) {
        var _self = this,
            settings = {
                blinkSpeed: 3,
                eyeSpeed: 3,
                lightSpeed: 30,
                wingSpeed: 3
            },
            EPS = 0.01,
            rafId = null,
            data = {
                akri: {
                    top: 0,
                    topt: 0
                },
                top: {
                    cpl: -38.7, // curve point left
                    cplt: -38.7, // curve point left target
                    cpr: 101.3, // curve point right
                    cprt: 101.3, // curve point right target
                    mp: -70, // middle point
                    mpt: -70 // middle point target
                },
                bottom: {
                    cpl: -38.7, // curve point left
                    cplt: -38.7, // curve point left target
                    cpr: 101.3, // curve point right
                    cprt: 101.3, // curve point right target
                    mp: -70, // middle point
                    mpt: -70 // middle point target
                },
                pupil: {
                    scale: 0.5,
                    scalet: 0.5,
                    x: 50,
                    xt: 50,
                    y: 50,
                    yt: 50
                },
                iris: {
                    scale: 1,
                    scalet: 1,
                    x: 0,
                    xt: 0,
                    y: 0,
                    yt: 0
                },
                lights: {
                    scale1: 0,
                    scale1t: 0,
                    scale2: 0,
                    scale2t: 0,
                    scale3: 0,
                    scale3t: 0,
                    scale4: 0,
                    scale4t: 0
                },
                wing: {
                    left: {
                        rotate: 0,
                        rotatet: 0
                    },
                    right: {
                        rotate: 0,
                        rotatet: 0
                    }
                }
            },
            $e = {
                $body: $element.querySelector('[data-akri="body"]'),
                $hat: $element.querySelector('[data-akri="hat"]'),
                $blinkPathTop: $element.querySelector('[data-akri-path="top"]'),
                $blinkPathBottom: $element.querySelector('[data-akri-path="bottom"]'),
                $pupil: $element.querySelector('[data-akri="pupil"]'),
                $iris: $element.querySelector('[data-akri="iris"]'),
                $lights: $element.querySelector('[data-akri="lights"]'),
                $eyeball: $element.querySelector('[data-akri="eyeball"]'),
                $leftWing: $element.querySelector('[data-akri="left-wing"]'),
                $rightWing: $element.querySelector('[data-akri="right-wing"]'),
                $light1: $element.querySelector('[data-akri="light-1"]'),
                $light2: $element.querySelector('[data-akri="light-2"]'),
                $light3: $element.querySelector('[data-akri="light-3"]'),
                $light4: $element.querySelector('[data-akri="light-4"]'),
                $shadow: $element.querySelector('[data-akri="shadow"]')
            };

        function fmt(n, digits) {
            return Number(n).toFixed(digits == null ? 2 : digits);
        }

        function setStyleIfChanged(el, prop, value) {
            if (el && el.style[prop] !== value) {
                el.style[prop] = value;
            }
        }

        function setAttrIfChanged(el, attr, value) {
            if (el && el.getAttribute(attr) !== value) {
                el.setAttribute(attr, value);
            }
        }

        function tween(obj, key, targetKey, speed, eps) {
            eps = eps == null ? EPS : eps;
            var current = obj[key];
            var target = obj[targetKey];
            var delta = target - current;

            if (Math.abs(delta) <= eps) {
                if (current !== target) {
                    obj[key] = target;
                    return true;
                }
                return false;
            }

            obj[key] = current + delta / speed;
            return true;
        }

        function requestRender() {
            if (rafId !== null) return;
            rafId = requestAnimationFrame(onFrame);
        }

        function onFrame() {
            rafId = null;
            var stillMoving = animate();

            if (stillMoving) {
                requestRender();
            }
        }

        _self.lookAtMe = function () {
            _self.eyeMove(0, 0);
        };

        _self.lookAtMyEyes = function () {
            data.iris.x = data.pupil.x = -0.1;
            data.iris.y = data.pupil.y = 0;
            requestRender();
        };

        _self.eyeMove = function (x, y, preventOthers) {
            var radius = 2.5,
                deg = (Math.atan2(x, y) * (180 / Math.PI)) || 0,
                xPos = radius * Math.sin(Math.PI * 2 * deg / 360),
                yPos = radius * Math.cos(Math.PI * 2 * deg / 360);

            setLights(x, y);

            if (x >= 0) {
                xPos = Math.min(x * radius, xPos);
            } else {
                xPos = Math.max(x * radius, xPos);
            }

            if (y >= 0) {
                yPos = Math.min(y * radius, yPos);
            } else {
                yPos = Math.max(y * radius, yPos);
            }

            data.iris.xt = xPos;
            data.iris.yt = yPos;

            var maxPercent = 66;
            data.pupil.xt = ((100 - maxPercent) / 2 + ((1 + x) / 2) * maxPercent);
            data.pupil.yt = ((100 - maxPercent) / 2 + ((1 + y) / 2) * maxPercent);

            if (!preventOthers) {
                setBlinkPosByIrisY(y);
            }

            requestRender();
        };

        _self.pupilScale = function (weight) {
            data.pupil.scalet = 0.3 * weight + 0.3;
            requestRender();
        };

        _self.irisScale = function (weight) {
            data.iris.scalet = 0.7 * weight + 0.3;
            requestRender();
        };

        _self.blinkTop = function (weight) {
            data.top.cplt = -38.7 + 38.7 * weight;
            data.top.cprt = 101.3 + 38.7 * weight;
            data.top.mpt = -70 * (1 - weight);
            requestRender();
        };

        _self.blinkBottom = function (weight) {
            data.bottom.cplt = -38.7 + 38.7 * weight;
            data.bottom.cprt = 101.3 + 38.7 * weight;
            data.bottom.mpt = -70 * (1 - weight);
            requestRender();
        };

        _self.blinkTo = function (weight) {
            _self.blinkTop(weight);
            _self.blinkBottom(weight);
        };

        _self.whiskLeftWing = function (weight) {
            data.wing.left.rotatet = weight * 75;
            requestRender();
        };

        _self.whiskRightWing = function (weight) {
            data.wing.right.rotatet = weight * 75;
            requestRender();
        };

        _self.whiskWings = function (weight) {
            _self.whiskLeftWing(weight);
            _self.whiskRightWing(weight);
        };

        function setBlinkPosByIrisY(y) {
            var defInterval = 1.11,
                scale = 0.5 * (defInterval - y);
            _self.blinkTop(y + scale);
            _self.blinkBottom(defInterval - y - scale);
        }

        function setLights(x, y) {
            data.lights.scale1t = 0;
            data.lights.scale2t = 0;
            data.lights.scale3t = 0;
            data.lights.scale4t = 0;

            if (x < 0 && y < 0) {
                data.lights.scale3t = 1 + x * y;
            } else if (x <= 0 && y >= 0) {
                data.lights.scale2t = 1 + x * -y;
            } else if (x > 0 && y > 0) {
                data.lights.scale1t = 1 + x * y;
            } else {
                data.lights.scale4t = 1 + x * -y;
            }
        }

        function animate() {
            var moving = false;

            moving = tween(data.top, 'cpl', 'cplt', settings.blinkSpeed) || moving;
            moving = tween(data.top, 'cpr', 'cprt', settings.blinkSpeed) || moving;
            moving = tween(data.top, 'mp', 'mpt', settings.blinkSpeed) || moving;

            moving = tween(data.bottom, 'cpl', 'cplt', settings.blinkSpeed) || moving;
            moving = tween(data.bottom, 'cpr', 'cprt', settings.blinkSpeed) || moving;
            moving = tween(data.bottom, 'mp', 'mpt', settings.blinkSpeed) || moving;

            moving = tween(data.pupil, 'scale', 'scalet', settings.eyeSpeed) || moving;
            moving = tween(data.pupil, 'x', 'xt', settings.eyeSpeed) || moving;
            moving = tween(data.pupil, 'y', 'yt', settings.eyeSpeed) || moving;

            moving = tween(data.iris, 'scale', 'scalet', settings.eyeSpeed) || moving;
            moving = tween(data.iris, 'x', 'xt', settings.eyeSpeed) || moving;
            moving = tween(data.iris, 'y', 'yt', settings.eyeSpeed) || moving;

            moving = tween(data.lights, 'scale1', 'scale1t', settings.eyeSpeed) || moving;
            moving = tween(data.lights, 'scale2', 'scale2t', settings.eyeSpeed) || moving;
            moving = tween(data.lights, 'scale3', 'scale3t', settings.eyeSpeed) || moving;
            moving = tween(data.lights, 'scale4', 'scale4t', settings.eyeSpeed) || moving;

            moving = tween(data.wing.right, 'rotate', 'rotatet', settings.wingSpeed) || moving;
            moving = tween(data.wing.left, 'rotate', 'rotatet', settings.wingSpeed) || moving;

            var topPath =
                'M140,140c0 ' + fmt(data.top.cpl, 1) +
                '-31.3 ' + fmt(data.top.mp, 1) +
                '-70 ' + fmt(data.top.mp, 1) +
                'S0,' + fmt(data.top.cpr, 1) +
                ',0,140V0h140V140z';

            var bottomPath =
                'M140,140c0 ' + fmt(data.bottom.cpl, 1) +
                '-31.3 ' + fmt(data.bottom.mp, 1) +
                '-70 ' + fmt(data.bottom.mp, 1) +
                'S0,' + fmt(data.bottom.cpr, 1) +
                ',0,140V0h140V140z';

            var pupilTransform = 'scale(' + fmt(data.pupil.scale, 3) + ')';
            var pupilOrigin = fmt(data.pupil.x, 2) + '% ' + fmt(data.pupil.y, 2) + '%';
            var irisTransform = 'scale(' + fmt(data.iris.scale, 3) + ') translate3d(' + fmt(data.iris.x, 2) + 'em,' + fmt(data.iris.y, 2) + 'em,0)';
            var light1Transform = 'scale(' + fmt(data.lights.scale1, 2) + ')';
            var light2Transform = 'scale(' + fmt(data.lights.scale2, 2) + ')';
            var light3Transform = 'scale(' + fmt(data.lights.scale3, 2) + ')';
            var light4Transform = 'scale(' + fmt(data.lights.scale4, 2) + ')';
            var rightWingTransform = 'rotate(' + fmt(data.wing.right.rotate, 1) + 'deg)';
            var leftWingTransform = 'rotate(' + fmt(-data.wing.left.rotate, 1) + 'deg)';
            var bodyTransform =
                'rotate(' + fmt((data.wing.left.rotate - data.wing.right.rotate) / 5, 1) + 'deg) ' +
                'translate3d(0, ' + fmt(-(data.wing.left.rotate + data.wing.right.rotate) / 5, 1) + 'px, 0)';
            var lightsTransform = 'rotate(' + fmt(-(data.wing.left.rotate - data.wing.right.rotate), 1) + 'deg)';
            var shadowTransform = 'scale(' + fmt(1 - (data.wing.left.rotate + data.wing.right.rotate) / 300, 2) + ')';

            setAttrIfChanged($e.$blinkPathTop, 'd', topPath);
            setAttrIfChanged($e.$blinkPathBottom, 'd', bottomPath);

            setStyleIfChanged($e.$pupil, 'transform', pupilTransform);
            setStyleIfChanged($e.$pupil, 'transformOrigin', pupilOrigin);
            setStyleIfChanged($e.$iris, 'transform', irisTransform);
            setStyleIfChanged($e.$light1, 'transform', light1Transform);
            setStyleIfChanged($e.$light2, 'transform', light2Transform);
            setStyleIfChanged($e.$light3, 'transform', light3Transform);
            setStyleIfChanged($e.$light4, 'transform', light4Transform);
            setStyleIfChanged($e.$rightWing, 'transform', rightWingTransform);
            setStyleIfChanged($e.$leftWing, 'transform', leftWingTransform);
            setStyleIfChanged($e.$body, 'transform', bodyTransform);
            setStyleIfChanged($e.$lights, 'transform', lightsTransform);
            setStyleIfChanged($e.$shadow, 'transform', shadowTransform);

            return moving;
        }

        function initBindings() {
            var preventMouseMove = false,
                hatMouseDown = false,
                leftWingMouseDown = false,
                rightWingMouseDown = false,
                eyeBallMouseDown = false;

            $e.$eyeball.addEventListener('mouseenter', function () {
                preventMouseMove = true;
                _self.lookAtMe();
                _self.pupilScale(0.9);
            });

            $e.$eyeball.addEventListener('mousedown', function () {
                eyeBallMouseDown = true;
                _self.pupilScale(0.5);
                _self.blinkTo(1);
            });

            $e.$eyeball.addEventListener('touchstart', function () {
                eyeBallMouseDown = true;
                _self.pupilScale(0.5);
                _self.blinkTo(1);
            });

            $e.$eyeball.addEventListener('mouseleave', function () {
                _self.irisScale(1);
                _self.pupilScale(1);
                _self.blinkTop(0.4);
                _self.blinkBottom(0.15);
                preventMouseMove = false;
            });

            $e.$leftWing.addEventListener('mouseenter', function () {
                _self.pupilScale(0.7);
                _self.eyeMove(-1, 0);
                _self.blinkTo(0.2);
            });

            $e.$rightWing.addEventListener('mouseenter', function () {
                _self.pupilScale(0.8);
                _self.eyeMove(1, 0);
                _self.blinkTo(0.2);
            });

            $e.$leftWing.addEventListener('mousedown', function () {
                leftWingMouseDown = true;
                _self.whiskLeftWing(1);
            });

            $e.$rightWing.addEventListener('mousedown', function () {
                rightWingMouseDown = true;
                _self.whiskRightWing(1);
            });

            $e.$hat.addEventListener('mousedown', function () {
                hatMouseDown = true;
                _self.whiskWings(1);
            });

            $e.$leftWing.addEventListener('touchstart', function () {
                leftWingMouseDown = true;
                _self.whiskLeftWing(1);
            });

            $e.$rightWing.addEventListener('touchstart', function () {
                rightWingMouseDown = true;
                _self.whiskRightWing(1);
            });

            $e.$hat.addEventListener('touchstart', function () {
                hatMouseDown = true;
                _self.whiskWings(1);
            });

            window.addEventListener('mousemove', function (event) {
                var offset = getCoords($e.$eyeball),
                    x = event.pageX - (offset.left + $e.$eyeball.offsetWidth / 2),
                    y = event.pageY - (offset.top + $e.$eyeball.offsetHeight / 2),
                    xorX = x < 0 ? -1 : 1,
                    xorY = y < 0 ? -1 : 1;

                if (preventMouseMove) {
                    x = x / ($e.$eyeball.offsetWidth / 2);
                    y = y / ($e.$eyeball.offsetHeight / 2);
                    _self.eyeMove(x, y, eyeBallMouseDown);
                } else {
                    _self.pupilScale(Math.min(1 / ((Math.abs(x) + Math.abs(y)) / 200), 1));
                    if (Math.abs(x) > Math.abs(y)) {
                        y = (Math.abs(y / x) || 0) * xorY;
                        x = xorX;
                    } else {
                        x = (Math.abs(x / y) || 0) * xorX;
                        y = xorY;
                    }
                    _self.eyeMove(x, y);
                }
            });

            var fnMouseup = function () {
                if (eyeBallMouseDown) {
                    eyeBallMouseDown = false;
                    _self.irisScale(1);
                    _self.pupilScale(0.7);
                    _self.blinkTo(0.3);
                }

                if (leftWingMouseDown) {
                    leftWingMouseDown = false;
                    _self.whiskLeftWing(0);
                }

                if (rightWingMouseDown) {
                    rightWingMouseDown = false;
                    _self.whiskRightWing(0);
                }

                if (hatMouseDown) {
                    hatMouseDown = false;
                    _self.whiskWings(0);
                }
            };

            window.addEventListener('mouseup', fnMouseup);
            window.addEventListener('touchend', fnMouseup);
        }

        function getCoords(elem) {
            var box = elem.getBoundingClientRect(),
                body = document.body || {},
                docEl = document.documentElement || {},
                scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
                scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
                clientTop = docEl.clientTop || body.clientTop || 0,
                clientLeft = docEl.clientLeft || body.clientLeft || 0,
                top = box.top + scrollTop - clientTop,
                left = box.left + scrollLeft - clientLeft;

            return {
                top: Math.round(top),
                left: Math.round(left)
            };
        }

        _self.eyeMove(0, 0);
        setLights(0, 0);
        requestRender();
        initBindings();

        return _self;
    }

    exports.init = function () {
        initializeAll();
    };

    function initializeAll() {
        $body.find('.akri:not(.akri--ready)').each(function () {
            $(this).addClass('akri--ready');
            new Akri(this);
        });
    }

    return exports;
})();
APP.Exam = (function () {
    var initialized = false,
        inputType = 'solution',
        reloadTimer,
        pageReloadInFlight = false,
        pageReloadPending = false,
        liveTableRefreshInFlight = {},
        liveTableRefreshPending = {},
        liveTableSubscriptions = {},
        exports = {};
    var checking = false;

    function init() {
        if (!initialized) {
            initialized = true;
            initBindings();
            timerTick(true);
        }
        timerTick();
        groupExamsLiveTableInit();
        initializeLiveTables();
        pageReLoaderInit();
        checking = false;
    }

    function initBindings() {
        $body.on('click', '[data-start-exam]', function () {
            generateExam($(this).attr('data-start-exam')).then(function (id) {
                APP.Page.applyPageByUrl('/hu/exam/' + id);
            }, function () {
                // para van!
            });
        });

        $body.on('click', '[data-exam-send]', function () {
            var $button = $(this),
                answer = $body.find('[data-learn-input]').attr('data-value');

            if (answer !== '[]') {
                checkExam({
                    examId: $body.find('[name="exam-id"]').val(),
                    examNth: $body.find('[name="exam-nth"]').val(),
                    answer: answer
                }, $button);
            } else {
                APP.Layout.openOverlay('empty-exam-input');
            }
        });


        $body.on('click', '[data-exam-save-step]', function () {
            var $button = $(this),
                answer = $body.find('[data-learn-input]').attr('data-value');

            if (answer !== '[]') {
                checkExam({
                    examId: $body.find('[name="exam-id"]').val(),
                    examNth: $body.find('[name="exam-nth"]').val(),
                    answer: answer
                }, $button, $button.attr('data-href'));
            } else {
                if ($button.attr('data-notify-empty') && $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length === 0) {
                    APP.Calculator.Keyboard.hide(true);
                    APP.Layout.openOverlay('empty-exam-input-next');
                } else {
                    APP.Page.applyPageByUrl($button.attr('data-href'));
                }
            }
        });

        $body.on('click', '[data-exam-cta-resolve]', function () {
            var $this = $(this);
            checkExam({
                examId: $body.find('[name="exam-id"]').val(),
                examNth: $body.find('[name="exam-nth"]').val(),
                answer: $this.attr('data-exam-cta-resolve'),
                display: $this.attr('data-exam-cta-display'),
                type: 'cta'
            }, $this);
        });

        $body.on('click', '[data-switch-type]', function () {
            inputType = $(this).attr('data-switch-type');
        });

        $body.on('click', '[data-submit-exam-comment]', function () {
            var type = $(this).attr('data-submit-exam-comment'),
                comment = $body.find('[data-comment]').val();

            if (type === 'comment-formula') {
                comment = $body.find('[data-learn-input]').attr('data-value');
            }

            APP.Ajax.post('/hu/service/exam/' + $body.find('[name="exam-id"]').val() + '/comment', {
                examId: $body.find('[name="exam-id"]').val(),
                examNth: $body.find('[name="exam-nth"]').val(),
                type: type,
                comment: comment
            }).then(function (result) {
                APP.Live.ping();
                if (result.success) {
                    addFormulaToHistory(result.display, type);
                    showFormulaInput();
                } else if (result.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-exam-answer-edit]', function () {
            var nth = parseInt($(this).attr('data-exam-answer-edit'), 10),
                length = $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length - 1,
                i;

            APP.Calculator.Keyboard.clean();
            APP.Calculator.Keyboard.paste(
                $(this).parents('[data-exam-answer-formula]').attr('data-exam-answer-formula')
            );

            showFormulaInput();
            switchToCtas('edit');
            $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
            $body.find('[data-exam-answer="' + nth + '"]').addClass('invisible');
            $body.find('[data-exam-answers="2"]').addClass('invisible');
            $body.find('[name="edit-item"]').val(nth);

            if (nth !== length) {
                $body.find('[data-exam-answers="2"]').removeClass('invisible');
            }

            for (i = 0; i <= length; i++) {
                if (nth < i) {
                    $body.find('[data-exam-answers="1"] [data-exam-answer="' + i + '"]').addClass('invisible');
                } else if (nth > i) {
                    $body.find('[data-exam-answers="2"] [data-exam-answer="' + i + '"]').addClass('invisible');
                }
            }

        });

        $body.on('click', '[data-exam-text-edit]', function () {
            var nth = parseInt($(this).attr('data-exam-text-edit'), 10),
                length = $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length - 1,
                i;

            inputType = 'comment-text';
            $body.find('[data-dashboard-input]').hide();
            $body.find('[data-prime-box]').hide();
            $body.find('[data-comment-box]').show();
            $body.find('[data-comment]').val($(this).parents('[data-exam-answer]').find('p').text()).focus();
            switchToCtas('edit');

            $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
            $body.find('[data-exam-answer="' + nth + '"]').addClass('invisible');
            $body.find('[data-exam-answers="2"]').addClass('invisible');
            $body.find('[name="edit-item"]').val(nth);

            if (nth !== length) {
                $body.find('[data-exam-answers="2"]').removeClass('invisible');
            }

            for (i = 0; i <= length; i++) {
                if (nth < i) {
                    $body.find('[data-exam-answers="1"] [data-exam-answer="' + i + '"]').addClass('invisible');
                } else if (nth > i) {
                    $body.find('[data-exam-answers="2"] [data-exam-answer="' + i + '"]').addClass('invisible');
                }
            }

        });

        $body.on('click', '[data-exam-answer-delete]', function () {
            var examId = $body.find('[name="exam-id"]').val(),
                itemIndex = $body.find('[name="item-index"]').val(),
                nth = $(this).attr('data-exam-answer-delete');

            APP.Ajax.post('/hu/service/exam/' + examId + '/delete', {
                itemIndex: itemIndex,
                answerIndex: nth
            }).then(function (response) {
                APP.Live.ping();
                if (response.success) {
                    $body.find('[data-exam-answer="' + nth + '"]').remove();
                    updateIndexes($body.find('[data-exam-answers="1"]'));
                    updateIndexes($body.find('[data-exam-answers="2"]'));
                } else if (response.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-exam-edit-save]', function () {
            var examId = $body.find('[name="exam-id"]').val(),
                itemIndex = $body.find('[name="item-index"]').val(),
                nth = $body.find('[name="edit-item"]').val(),
                type = inputType,
                answer;

            if (type === 'comment-text') {
                answer = $body.find('[data-comment]').val();
            } else {
                answer = $body.find('[data-learn-input]').attr('data-value');
            }

            APP.Ajax.post('/hu/service/exam/' + examId + '/update', {
                itemIndex: itemIndex,
                answerIndex: nth,
                answer: answer,
                type: type
            }).then(function (response) {
                APP.Live.ping();
                if (response.success) {
                    var $actual = $body.find('[data-exam-answer="' + nth + '"]'),
                        $formula = $(APP.Tpl.run('exam-solution', {
                            index: nth,
                            type: type,
                            displayJson: $body.find('[data-calculator]').attr('data-value'),
                            display: response.display
                        }));
                    $formula.insertBefore($actual);
                    $actual.remove();
                    APP.Formula.fillFormulas();
                    switchToCtas('default');
                    $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
                    $body.find('[data-exam-answers="2"]').addClass('invisible');
                    // APP.Calculator.Keyboard.clean();
                    $body.find('[data-comment]').val('');
                    inputType = 'solution';
                    showFormulaInput();
                } else if (response.reason === 'done') {
                    APP.Layout.openOverlay('exam-finished');
                } else {
                    APP.ProblemWorker.run('learn-error', response).then(function (content) {
                        $body.find('[data-learn-error-content]').html(content);
                        APP.Layout.openOverlay('learn-error');
                        $body.find('[data-close-learn-error]').focus();
                    });
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-exam-edit-cancel]', function () {
            inputType = 'solution';
            showFormulaInput();
            $body.find('[data-exam-answers] [data-exam-answer]').removeClass('invisible');
            $body.find('[data-exam-answers="2"]').addClass('invisible');
            APP.Calculator.Keyboard.clean();
        });

        $body.on('click', '[data-group-exam]', function () {
            var groupId = $(this).attr('data-group-exam'),
                examTemplateId = $body.find('[name="templateId"]').val(),
                members = [];

            $body.find('[name="member"]:checked').each(function () {
                members.push($(this).val());
            });
            APP.Ajax.post('/hu/service/group-exam/create', {
                groupId: groupId,
                examTemplateId: examTemplateId,
                members: members
            }).then(function (response) {
                if (response.success) {
                    APP.Page.applyPageByUrl('/hu/group/exam/' + response.examId + '/live');
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-start-group-exam]', function () {
            var groupExamId = $(this).attr('data-start-group-exam');

            APP.Ajax.post('/hu/service/group-exam/start', {
                groupExamId: groupExamId,
            }).then(function (response) {
                if (response.success) {
                    APP.Page.applyPageByUrl('/hu/exam/' + response.examId);
                }
            }, window.NOOP);
        });

        $body.on('click', '[data-finish-exams]', function () {
            var $this = $(this),
                groupExamId = $this.attr('data-finish-exams');

            APP.Ajax.post('/hu/service/group-exam/finish', {
                groupExamId: groupExamId,
            }).then(function (response) {
                if (response.success) {
                    APP.Page.reloadPage();
                }
            }, window.NOOP);
        });

    }

    function checkExam(data, $button, redirection) {
        if (checking) {
            return;
        }
        checking = true;
        $button.addClass('disabled');
        APP.Ajax.post('/hu/service/exam/check', data).then(function (result) {
            APP.Live.ping();
            if (!redirection) {
                checking = false;
            }
            $button.removeClass('disabled');
            if (redirection && (result.success || (!result.success && result.reason === 'redundant'))) {
                APP.Page.applyPageByUrl(redirection);
            } else if (result.success) {
                checking = false;
                if (result.display) {
                    addFormulaToHistory(result.display, data.type || 'solution');
                }
            } else if (result.reason === 'redundant') {
                checking = false;
                APP.Layout.openOverlay('exam-redundant');
            } else if (result.reason === 'done') {
                checking = false;
                APP.Layout.openOverlay('exam-finished');
            } else {
                checking = false;
                APP.ProblemWorker.run('learn-error', result).then(function (content) {
                    $body.find('[data-learn-error-content]').html(content);
                    APP.Layout.openOverlay('learn-error');
                    $body.find('[data-close-learn-error]').focus();
                });
            }
        }, function () {
            checking = false;
            $button.removeClass('disabled');
        });
    }

    function initializeLiveTables() {
        $body.find('[data-group-exam-live]').each(function () {
            var $this = $(this);
            $this.html(APP.Tpl.run('exam-live', JSON.parse($this.attr('data-group-exam-live'))));
            APP.Layout.setMoments();
        });
    }

    function showTextInput() {
        inputType = 'comment-text';
        $body.find('[data-dashboard-input]').hide();
        $body.find('[data-comment-box]').show();
        $body.find('[data-prime-box]').hide();
        switchToCtas('default');
    }

    function showFormulaInput() {
        $body.find('[data-dashboard-input]').show();
        $body.find('[data-comment-box]').hide();
        $body.find('[data-prime-box]').hide();
        switchToCtas('default');
    }

    function addFormulaToHistory(formula, type) {
        var index = $body.find('[data-exam-answers="1"] [data-previous-good-answers] [data-exam-answer]').length,
            $formula = $(APP.Tpl.run('exam-solution', {
                index: index,
                type: type,
                displayJson: type === 'cta' ? '[]' : $body.find('[data-calculator]').attr('data-value'),
                display: formula
            }));

        $body.find('[data-exam-answers="1"]').removeClass('invisible');
        $body.find('[data-previous-good-answers]').append($formula);
        APP.Formula.fillFormulas();
    }

    function generateExam(id) {
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/hu/service/exam/generate/' + id).then(function (response) {
                if (response.success) {
                    resolve(response.id);
                } else {
                    var error = new Error('app.exam.generateExam invalid_response');
                    APP.Error.logError(error, {
                        source: 'APP.Exam.generateExam',
                        context: {
                            id: id,
                            response: JSON.stringify(response || {})
                        }
                    });
                    reject(error);
                }
            }, function (error) {
                reject(error);
            });
        });
    }

    function formatTimerDuration(delta, $timer) {
        var totalSeconds = Math.floor(delta / 1000),
            minutes,
            seconds,
            minuteLabel = $timer.attr('data-timer-minute-label'),
            secondLabel = $timer.attr('data-timer-second-label');

        if (!isFinite(totalSeconds) || totalSeconds < 0) {
            totalSeconds = 0;
        }
        minutes = Math.floor(totalSeconds / 60);
        seconds = totalSeconds % 60;

        if (!minuteLabel || !secondLabel) {
            return minutes + ':' + ('0' + seconds).slice(-2);
        }
        return minutes + ' ' + minuteLabel + ' ' + seconds + ' ' + secondLabel;
    }

    function timerTick(repeat) {
        if (repeat) {
            setTimeout(function () {
                timerTick(true);
            }, 1000);
        }
        $body.find('[data-timer]').each(function () {
            var $this = $(this),
                start = new Date($this.attr('data-timer')),
                delta = Date.now() - start;
            $this.text(formatTimerDuration(delta, $this));
        });
    }

    function groupExamsLiveTableInit() {
        $body.find('[data-group-exam-live]:not(.done)').each(function () {
            var $table = $(this),
                groupExamId = $table.attr('data-group-exam-live-id'),
                groupId = $table.attr('data-group-exam-live-group-id');

            loadExamLiveTable(groupExamId);
            subscribeGroupExamLiveTable(groupId, groupExamId);
        });
    }

    function subscribeGroupExamLiveTable(groupId, groupExamId) {
        var subscriptionKey = groupId + '@' + groupExamId;

        if (!groupId || !groupExamId || liveTableSubscriptions[subscriptionKey]) {
            return;
        }

        liveTableSubscriptions[subscriptionKey] = true;
        APP.Live.onGroupEvent(groupId, function (event) {
            if (!event || event.type !== 'group-exam-live' || String(event.groupExamId) !== String(groupExamId)) {
                return;
            }
            requestExamLiveTableRefresh(groupExamId);
        });
    }

    function requestExamLiveTableRefresh(groupExamId) {
        if (liveTableRefreshInFlight[groupExamId]) {
            liveTableRefreshPending[groupExamId] = true;
            return;
        }

        loadExamLiveTable(groupExamId);
    }

    function loadExamLiveTable(groupExamId) {
        var allDone = true,
            $table;

        if (!groupExamId || liveTableRefreshInFlight[groupExamId]) {
            return;
        }
        liveTableRefreshInFlight[groupExamId] = true;
        APP.Ajax.post('/hu/service/group-exam/live', {
            groupExamId: groupExamId
        }, true).then(function (response) {
            if (response.success) {
                $table = $body.find('[data-group-exam-live-id="' + groupExamId + '"]');
                $table.attr('data-group-exam-live', JSON.stringify(response.result));
                response.result.forEach(function (exam) {
                    if (!exam.done) {
                        allDone = false;
                    }
                });

                if (allDone) {
                    $table.addClass('done');
                }
                initializeLiveTables();
            }
            finishExamLiveTableRefresh(groupExamId);
        }, function () {
            finishExamLiveTableRefresh(groupExamId);
        });
    }

    function finishExamLiveTableRefresh(groupExamId) {
        liveTableRefreshInFlight[groupExamId] = false;
        if (liveTableRefreshPending[groupExamId]) {
            liveTableRefreshPending[groupExamId] = false;
            loadExamLiveTable(groupExamId);
        }
    }

    function switchToCtas(name) {
        $body.find('[data-formula-default-ctas]').hide();
        $body.find('[data-formula-comment-ctas]').hide();
        $body.find('[data-formula-edit-ctas]').hide();
        $body.find('[data-formula-' + name + '-ctas]').show();
    }

    function updateIndexes($wrapper) {
        $wrapper.find('[data-exam-answer]').each(function (index) {
            var $this = $(this);

            $this.attr('data-exam-answer', index);
            $this.find('[data-exam-answer-edit]').attr('data-exam-answer-edit', index);
            $this.find('[data-exam-answer-delete]').attr('data-exam-answer-delete', index);
        });
    }

    function pageReLoaderInit() {
        var $indicator = $body.find('[data-page-reload]'),
            interval = parseInt($indicator.attr('data-page-reload'), 10);

        clearTimeout(reloadTimer);
        if ($indicator.length) {
            reloadTimer = setTimeout(function () {
                refreshReloadingExamPage();
            }, interval);
        }
    }

    function getPageScrollTop() {
        var documentElement = document.documentElement,
            body = document.body;

        return window.pageYOffset || documentElement && documentElement.scrollTop || body && body.scrollTop || 0;
    }

    function refreshReloadingExamPage() {
        var url = document.location.href;

        if (pageReloadInFlight) {
            pageReloadPending = true;
            return;
        }
        pageReloadInFlight = true;
        APP.Ajax.get(url, true).then(function (html) {
            applyReloadedExamPage(html, url);
            finishReloadingExamPage();
        }, function () {
            finishReloadingExamPage();
        });
    }

    function finishReloadingExamPage() {
        pageReloadInFlight = false;
        if (pageReloadPending) {
            pageReloadPending = false;
            refreshReloadingExamPage();
            return;
        }
        pageReLoaderInit();
    }

    function applyReloadedExamPage(html, url) {
        var page = document.createElement('html'),
            $page,
            anchor,
            changedWorkWrappers,
            changed;

        if (url !== document.location.href) {
            return;
        }
        page.innerHTML = html;
        if (APP.Initializer.needUpdate(page)) {
            APP.Page.reloadPageSilence();
            return;
        }
        $page = $(page);
        anchor = getPageReloadAnchor();
        changedWorkWrappers = refreshExamReviewWork($page);
        changed = changedWorkWrappers.length > 0;
        changed = refreshExamReviewPointContainers($page) || changed;
        changed = refreshExamReviewSemanticElement($page, '[data-exam-review-summary]', getExamReviewTextSignature) || changed;
        changed = refreshExamReviewSemanticElement($page, '[data-exam-review-result]', getExamReviewTextSignature) || changed;
        changed = refreshExamReviewActionPresence($page) || changed;
        changed = refreshPageReloadMarker($page) || changed;
        changedWorkWrappers.forEach(function ($wrapper) {
            APP.Formula.fillFormulas($wrapper);
        });
        if (changed) {
            APP.Layout.setMoments();
            timerTick();
        }
        restorePageReloadAnchor(anchor);
    }

    function refreshExamReviewWork($page) {
        var changedWrappers = [];

        $page.find('[data-exam-review-work]').each(function () {
            var $next = $(this),
                key = $next.attr('data-exam-review-work'),
                $current = $body.find('[data-exam-review-work="' + key + '"]');

            if ($current.length && syncExamReviewWorkItems($current, $next)) {
                changedWrappers.push($current);
            }
        });
        return changedWrappers;
    }

    function syncExamReviewWorkItems($current, $next) {
        var changed = false,
            currentByIndex = {};

        $current.find('[data-exam-review-work-item]').each(function () {
            currentByIndex[$(this).attr('data-exam-review-work-item')] = this;
        });
        $next.find('[data-exam-review-work-item]').each(function () {
            var index = $(this).attr('data-exam-review-work-item'),
                current = currentByIndex[index],
                next = this.cloneNode(true);

            delete currentByIndex[index];
            if (!current) {
                $current.append(next);
                changed = true;
            } else if (getExamReviewWorkSignature(current) !== getExamReviewWorkSignature(this)) {
                $(current).replaceWith(next);
                changed = true;
            }
        });
        Object.keys(currentByIndex).forEach(function (index) {
            $(currentByIndex[index]).remove();
            changed = true;
        });
        return changed;
    }

    function getExamReviewWorkSignature(element) {
        return [
            element.getAttribute('data-exam-review-work-type') || '',
            element.getAttribute('data-exam-review-work-display') || '',
            element.getAttribute('data-exam-review-work-result') || '',
            element.getAttribute('data-exam-review-work-done') || ''
        ].join('\u001f');
    }

    function refreshExamReviewPointContainers($page) {
        var changed = false;

        $page.find('[data-exam-review-point]').each(function () {
            var key = $(this).attr('data-exam-review-point');

            changed = refreshExamReviewSemanticElement(
                $page,
                '[data-exam-review-point="' + key + '"]',
                getExamReviewTextSignature
            ) || changed;
        });
        return changed;
    }

    function refreshExamReviewSemanticElement($page, selector, getSignature) {
        var $current = $body.find(selector),
            $next = $page.find(selector);

        if ($current.length && $next.length) {
            if (getSignature($current[0]) === getSignature($next[0])) {
                return false;
            }
            $current.replaceWith($next[0].cloneNode(true));
            return true;
        }
        if ($current.length && !$next.length) {
            $current.remove();
            return true;
        }
        if (!$current.length && $next.length) {
            return insertMissingExamReviewElement(selector, $next[0].cloneNode(true));
        }
        return false;
    }

    function getExamReviewTextSignature(element) {
        var clone = element.cloneNode(true);

        $(clone).find('[data-timer], [data-date-moment], [data-datetime-moment]').empty();
        return clone.textContent.replace(/\s+/g, ' ').trim();
    }

    function refreshExamReviewActionPresence($page) {
        var $current = $body.find('[data-exam-review-actions]'),
            $next = $page.find('[data-exam-review-actions]');

        if ($current.length && !$next.length) {
            $current.remove();
            return true;
        }
        if (!$current.length && $next.length) {
            return insertMissingExamReviewElement('[data-exam-review-actions]', $next[0].cloneNode(true));
        }
        return false;
    }

    function refreshPageReloadMarker($page) {
        var $current = $body.find('[data-page-reload]'),
            $next = $page.find('[data-page-reload]');

        if ($current.length && !$next.length) {
            $current.remove();
            return true;
        }
        if (!$current.length && $next.length) {
            $body.append($next[0].cloneNode(true));
            return true;
        }
        if ($current.length && $next.length && $current.attr('data-page-reload') !== $next.attr('data-page-reload')) {
            $current.attr('data-page-reload', $next.attr('data-page-reload'));
            return true;
        }
        return false;
    }

    function insertMissingExamReviewElement(selector, element) {
        if (selector === '[data-exam-review-result]') {
            $body.find('[data-exam-review-summary]').after(element);
            return true;
        }
        if (selector === '[data-exam-review-actions]') {
            $body.find('[data-exam-review]').after(element);
            return true;
        }
        if (selector === '[data-page-reload]') {
            $body.append(element);
            return true;
        }
        return false;
    }

    function getPageReloadAnchor() {
        var element,
            selector;

        if (!document.elementFromPoint) {
            return false;
        }
        element = document.elementFromPoint(Math.max(1, Math.floor(window.innerWidth / 2)), Math.max(1, Math.floor(window.innerHeight / 3)));
        selector = getPageReloadAnchorSelector(element);
        if (!selector) {
            return false;
        }
        return {
            selector: selector,
            top: $body.find(selector)[0].getBoundingClientRect().top
        };
    }

    function getPageReloadAnchorSelector(element) {
        while (element && element !== document.body) {
            if (element.hasAttribute('data-exam-review-problem')) {
                return '[data-exam-review-problem="' + element.getAttribute('data-exam-review-problem') + '"]';
            }
            if (element.hasAttribute('data-exam-review-summary')) {
                return '[data-exam-review-summary]';
            }
            if (element.hasAttribute('data-exam-review-result')) {
                return '[data-exam-review-result]';
            }
            element = element.parentNode;
        }
        return false;
    }

    function restorePageReloadAnchor(anchor) {
        var element,
            delta;

        if (!anchor) {
            return;
        }
        element = $body.find(anchor.selector)[0];
        if (!element) {
            return;
        }
        delta = element.getBoundingClientRect().top - anchor.top;
        if (delta) {
            window.scrollTo(window.pageXOffset || 0, getPageScrollTop() + delta);
        }
    }

    exports.init = init;
    exports.addFormulaToHistory = addFormulaToHistory;
    exports.showFormulaInput = showFormulaInput;
    return exports;

})();

APP.Form = (function () {
    var exports = {};

    function init() {
        initBindings();
    }

    function initBindings() {
        $body.on('submit', 'form:not([data-native])', submitForm);

        $body.on('focus', 'form input, form textarea, form select', function () {
            var $this = $(this);
            APP.Analytics.trackEvent('form', 'focus', $this.parents('form').attr('action'), $this.attr('name'));
        });

        $body.on('change', '[data-toggle-list]', function () {
            var $this = $(this);

            $body.find('[data-toggle-item="' + $this.attr('data-toggle-list') + '"]').prop('checked', $this.prop('checked'));
        });

        $body.on('change input', '[data-show-on-select]', function () {
            var $this = $(this);
            var res = $this.attr('data-show-on-select');

            $body.find('[data-id="' + res + '"]').css('display', 'block');
        });
    }

    function submitForm(event) {
        var $form = $(this),
            action = $form.attr('action'),
            data = $form.serialize(),
            key,
            formErrorOffset,
            callback = $form.attr('data-callback');

        event.preventDefault();
        event.stopPropagation();

        if (!action) {
            return;
        }

        $form.find('[data-submit-loading]').addClass('button--loading');
        if ($form.attr('data-submitting') !== 'true') {
            $form.attr('data-submitting', 'true');
        } else {
            return;
        }

        $form.find('.form--error-show').removeClass('form--error-show');

        APP.Analytics.trackFormSubmit(action, $form);
        APP.Ajax.load({
            method: $form.attr('method') || 'get',
            url: action,
            data: data,
            timeout: Number($form.attr('data-timeout')) || undefined,
            dataType: 'json'
        }).then(function (result) {
            $body.find('.button--loading').removeClass('button--loading');
            if (result.success) {
                callback = getCallbackByName(callback);
                APP.Analytics.trackEvent('form', 'success', action);
                if (callback) {
                    callback(result);
                }
            } else {
                APP.Analytics.trackEvent('form', 'fail', action, result);
                for (key in result.error) {
                    if (result.error.hasOwnProperty(key)) {
                        if (typeof result.error[key] === 'number') {
                            $form.find('[data-form-error="' + key + '"][data-form-error-id="' + result.error[key] + '"]')
                                .addClass('form--error-show');
                        } else {
                            $form.find('[data-form-error="' + key + '"]:not([data-form-error-id])').text(result.error[key]).addClass('form--error-show');
                            $form.find('[name="' + key + '"], [data-input-group="' + key + '"]').addClass('form--error-show');
                        }
                    }
                }
                formErrorOffset = $body.find('.form--error-show').offset();
                if (formErrorOffset) {
                    APP.Layout.scrollTo(formErrorOffset.top - 60);
                }
                if (result.error && result.error.hasOwnProperty('robot') && window.hasOwnProperty('grecaptcha')) {
                    window.grecaptcha.reset();
                }
            }
            setTimeout(function () {
                $form.attr('data-submitting', 'false');
            }, 1000);
        }, function () {
            $body.find('.button--loading').removeClass('button--loading');
            setTimeout(function () {
                $form.attr('data-submitting', 'false');
            }, 1000);
        });
    }

    function getCallbackByName(callbackName) {
        if (!callbackName) {
            return false;
        }

        // because of minify.
        switch (callbackName) {
            case 'APP.Page.reloadPage':
                return APP.Page.reloadPage;
            case 'APP.Premium.successWallOfLoveApply':
                return APP.Premium.successWallOfLoveApply;
            case 'APP.Premium.successPremiumSent':
                return APP.Premium.successPremiumSent;
            case 'APP.User.successComment':
                return APP.User.successComment;
            case 'APP.User.successAlert':
                return APP.User.successAlert;
            case 'APP.User.successPassReset':
                return APP.User.successPassReset;
            case 'APP.User.successInvitationRequest':
                return APP.User.successInvitationRequest;
            case 'APP.User.successInvitationUse':
                return APP.User.successInvitationUse;
            case 'APP.User.successLoggedIn':
                return APP.User.successLoggedIn;
            case 'APP.User.successUserSettings':
                return APP.User.successUserSettings;
            case 'APP.User.successPhoneSettings':
                return APP.User.successPhoneSettings;
            case 'APP.User.successSignUp':
                return APP.User.successSignUp;
            case 'APP.User.successAndReload':
                return APP.User.successAndReload;
            case 'APP.User.mailSent':
                return APP.User.mailSent;
            case 'APP.Pro.successBillingSettings':
                return APP.Pro.successBillingSettings;
            case 'APP.Pro.successSelectPayment':
                return APP.Pro.successSelectPayment;
            case 'APP.Pro.successActivationCode':
                return APP.Pro.successActivationCode;
            case 'APP.Pro.successActivationCodeModification':
                return APP.Pro.successActivationCodeModification;
            case 'APP.NewsFeed.reloadNewsFeedContent':
                return APP.NewsFeed.reloadNewsFeedContent;
            case 'APP.NewsFeed.redirectToGroup':
                return APP.NewsFeed.redirectToGroup;
            case 'APP.NewsFeed.groupSettingsSaved':
                return APP.NewsFeed.groupSettingsSaved;
            case 'APP.User.successPreRegistration':
                return APP.User.successPreRegistration;
            case 'APP.User.successEmailModification':
                return APP.User.successEmailModification;
            case 'APP.User.successDelete':
                return APP.User.successDelete;
            case 'APP.NewsFeed.successCodeConnect':
                return APP.NewsFeed.successCodeConnect;
            case 'APP.User.successForgottenEmailAdded':
                return APP.User.successForgottenEmailAdded;
            case 'APP.User.demoBooked':
                return APP.User.demoBooked;
            case 'APP.User.trialBooked':
                return APP.User.trialBooked;
            case 'APP.Locale.successUISettings':
                return APP.Locale.successUISettings;
            case 'APP.User.successGroupSubscription':
                return APP.User.successGroupSubscription;
            case 'APP.Group.successAction':
                return function () {
                    APP.Layout.closeOverlay();
                    APP.Layout.openOverlay('success-action');
                };
            case 'APP.Group.successMemberNameEdit':
                return function () {
                    APP.Layout.closeOverlay();
                    APP.Page.reloadPage();
                };
            case 'APP.Group.successStudyRangeSettings':
                return function () {
                    APP.Layout.closeOverlay();
                    APP.Race.setActivityThreshold();
                };
            case 'APP.Group.successGroupRegistration':
                return function (result) {
                    APP.Layout.closeOverlay();
                    APP.Layout.alert(result.message);
                };
            case 'APP.Forms.redirect':
                return function (result) {
                    var url = result.redirect || result.url;
                    if (url) {
                        APP.Page.applyPageByUrl(url);
                    }
                };
            default:
                return false;
        }
    }

    function customSelect(element) {
        new Choices(element, {
            shouldSort: false,
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: ''
        });
        if (element.classList.contains('math-font')) {
            element.parentElement.parentElement.classList.add('math-font');
        }
    }

    function getSearchSelectCount(list) {
        return list.reduce(function (sum, item) {
            return sum + (item.choices ? item.choices.length : 1);
        }, 0);
    }

    function getSearchSelectSource(element) {
        const FLAT_DOM_MASTER_LIST = [];
        const DOM_MASTER_LIST = [];

        Array.from(element.children).forEach(child => {
            const tagName = child.tagName.toLowerCase();

            if (tagName === 'option') {
                if (child.value && child.value !== '') {
                    const option = {
                        value: child.value,
                        label: child.label
                    };

                    DOM_MASTER_LIST.push(option);
                    FLAT_DOM_MASTER_LIST.push(option);
                }
            } else if (tagName === 'optgroup') {
                const group = {
                    label: child.label,
                    choices: []
                };

                Array.from(child.children).forEach(option => {
                    if (option.value && option.value !== '') {
                        const item = {
                            value: option.value,
                            label: option.label
                        };

                        group.choices.push(item);
                        FLAT_DOM_MASTER_LIST.push(item);
                    }
                });
                if (group.choices.length > 0) {
                    DOM_MASTER_LIST.push(group);
                }
            }
        });

        return {
            list: DOM_MASTER_LIST,
            flatList: FLAT_DOM_MASTER_LIST,
            count: getSearchSelectCount(DOM_MASTER_LIST)
        };
    }

    function setSearchSelectPlaceholder(element, choices) {
        if (!(element.selectedOptions && element.selectedOptions.length && !!element.selectedOptions[0].value)) {
            choices.setValue([
                {value: '-', label: element.getAttribute('data-placeholder'), disabled: true, selected: true}
            ]);
        }
    }

    function trackSearchSelectResetAnomaly(element, state, currentCount, searchValue) {
        if (!element.hasAttribute('data-search-select-challenge') ||
            currentCount > 2 ||
            state.source.count <= 10 ||
            (searchValue && searchValue.trim() !== '') ||
            !APP.Analytics ||
            !APP.Analytics.capture) {
            return;
        }

        APP.Analytics.capture('search select reset anomaly', {
            name: element.getAttribute('name'),
            sourceCount: state.source.count,
            currentCount: currentCount,
            searchSelectChallenge: true
        });
    }

    function resetSearchSelect(element, state) {
        const input = state.choices.input && state.choices.input.element,
            searchValue = input && input.value ? input.value : '',
            currentSource = getSearchSelectSource(element);

        trackSearchSelectResetAnomaly(element, state, currentSource.count, searchValue);

        if (input) {
            input.value = '';
        }
        state.choices.removeActiveItems();
        state.choices.setChoices(
            state.source.list,
            'value', 'label', true
        );
        setSearchSelectPlaceholder(element, state.choices);
    }

    function searchSelect(element) {
        const source = getSearchSelectSource(element);

        if (element._appSearchSelect) {
            resetSearchSelect(element, element._appSearchSelect);
            return;
        }

        const choices = new Choices(element, {
            shouldSort: false,
            searchEnabled: true,
            searchFloor: 1,
            searchResultLimit: 10000,
            noResultsText: window.TXT['learn.no_result'],
            noChoicesText: window.TXT['learn.no_result'],
            itemSelectText: '',
            searchPlaceholderValue: '🔍︎',
            searchChoices: true,
        });
        const state = {
            choices: choices,
            source: source
        };
        const myCustomFilter = function (item, searchTerm) {
            const lowerSearch = searchTerm.toLowerCase().trim();
            const label = item.label.toLowerCase();

            return label.includes(lowerSearch);
        };
        const eventHandler = function (event) {
            const searchTerm = event.target.value;

            choices.removeActiveItems();
            if (!searchTerm || searchTerm.trim() === '') {
                choices.setChoices(
                    state.source.list,
                    'value', 'label', true
                );
                setSearchSelectPlaceholder(element, choices);
            } else {
                choices.setChoices(
                    state.source.flatList.filter(item => myCustomFilter(item, searchTerm)),
                    'value', 'label', true
                );
            }
        };

        if (choices.input) {
            choices.input.element.addEventListener('input', eventHandler, false);
            if (element.hasAttribute('data-goto-topic')) {
                choices.input.element.addEventListener('focus', eventHandler, false);
            }
            // csak akkor tegyük be a placeholder-t, ha NINCS valódi selected
            setSearchSelectPlaceholder(element, choices);
        }
        element._appSearchSelect = state;

    }

    exports.init = init;
    exports.searchSelect = searchSelect;
    exports.customSelect = customSelect;

    return exports;

})();

APP.Live = (function () {
    var exports = {},
        initialized = false,
        binded = false,
        observerBinded = false,
        socket,
        observer,
        observing = false,
        winId,
        ignoreScrollEvents,
        liveAllowed,
        handShake = false,
        s = (function (options) {
            var _self = this;

            _self.default_options = {
                selectors: ['id', 'tag', 'nthchild'],
                prefix_tag: true,
                attribute_blacklist: [],
                attribute_whitelist: [],
                quote_attribute_when_needed: false,
                id_blacklist: [],
                class_blacklist: []
            };

            _self.setOptions = function (options) {
                var key, results, val;
                if (options === null) {
                    options = {};
                }
                results = [];
                for (key in options) {
                    val = options[key];
                    if (_self.default_options.hasOwnProperty(key)) {
                        results.push(_self.options[key] = val);
                    } else {
                        results.push(void 0);
                    }
                }
                return results;
            };

            _self.isElement = function (element) {
                return !!((element !== null ? element.nodeType : void 0) === 1);
            };

            _self.getParents = function (element) {
                var current_element, result;
                result = [];
                if (_self.isElement(element)) {
                    current_element = element;
                    while (_self.isElement(current_element)) {
                        result.push(current_element);
                        current_element = current_element.parentNode;
                    }
                }
                return result;
            };

            _self.getTagSelector = function (element) {
                return _self.sanitizeItem(element.tagName.toLowerCase());
            };

            _self.sanitizeItem = function (item) {
                var characters;
                characters = (item.split('')).map(function (character) {
                    if (character === ':') {
                        return "\\" + (':'.charCodeAt(0).toString(16).toUpperCase()) + " ";
                    } else if (/[ !"#$%&'()*+,.\/;<=>?@\[\\\]^`{|}~]/.test(character)) {
                        return "\\" + character;
                    } else {
                        return escape(character).replace(/\%/g, '\\');
                    }
                });
                return characters.join('');
            };

            _self.sanitizeAttribute = function (item) {
                var characters;
                if (_self.options.quote_attribute_when_needed) {
                    return _self.quoteAttribute(item);
                }
                characters = (item.split('')).map(function (character) {
                    if (character === ':') {
                        return "\\" + (':'.charCodeAt(0).toString(16).toUpperCase()) + " ";
                    } else if (/[ !"#$%&'()*+,.\/;<=>?@\[\\\]^`{|}~]/.test(character)) {
                        return "\\" + character;
                    } else {
                        return escape(character).replace(/\%/g, '\\');
                    }
                });
                return characters.join('');
            };

            _self.quoteAttribute = function (item) {
                var characters, quotesNeeded;
                quotesNeeded = false;
                characters = (item.split('')).map(function (character) {
                    if (character === ':') {
                        quotesNeeded = true;
                        return character;
                    } else if (character === "'") {
                        quotesNeeded = true;
                        return "\\" + character;
                    } else {
                        quotesNeeded = quotesNeeded || (escape(character === !character));
                        return character;
                    }
                });
                if (quotesNeeded) {
                    return "'" + (characters.join('')) + "'";
                }
                return characters.join('');
            };

            _self.getIdSelector = function (element) {
                var id, id_blacklist, prefix, sanitized_id;
                prefix = _self.options.prefix_tag ? _self.getTagSelector(element) : '';
                id = element.getAttribute('id');
                id_blacklist = _self.options.id_blacklist.concat(['', /\s/, /^\d/]);
                if (!!id && _self.notInList(id, id_blacklist)) {
                    sanitized_id = prefix + ("#" + (_self.sanitizeItem(id)));
                    if (element.ownerDocument.querySelectorAll(sanitized_id).length === 1) {
                        return sanitized_id;
                    }
                }
                return null;
            };

            _self.notInList = function (item, list) {
                return !list.find(function (x) {
                    if (typeof x === 'string') {
                        return x === item;
                    }
                    return x.exec(item);
                });
            };

            _self.getClassSelectors = function (element) {
                var class_string, item, k, len, ref, result;
                result = [];
                class_string = element.getAttribute('class');
                if (class_string !== null) {
                    class_string = class_string.replace(/\s+/g, ' ');
                    class_string = class_string.replace(/^\s|\s$/g, '');
                    if (class_string !== '') {
                        ref = class_string.split(/\s+/);
                        for (k = 0, len = ref.length; k < len; k++) {
                            item = ref[k];
                            if (_self.notInList(item, _self.options.class_blacklist)) {
                                result.push("." + (_self.sanitizeItem(item)));
                            }
                        }
                    }
                }
                return result;
            };

            _self.getAttributeSelectors = function (element) {
                var a, attr, blacklist, k, l, len, len1, ref, ref1, ref2, result, whitelist;
                result = [];
                whitelist = _self.options.attribute_whitelist;
                for (k = 0, len = whitelist.length; k < len; k++) {
                    attr = whitelist[k];
                    if (element.hasAttribute(attr)) {
                        result.push("[" + attr + "=" + (_self.sanitizeAttribute(element.getAttribute(attr))) + "]");
                    }
                }
                blacklist = _self.options.attribute_blacklist.concat(['id', 'class']);
                ref = element.attributes;
                for (l = 0, len1 = ref.length; l < len1; l++) {
                    a = ref[l];
                    if (!((ref1 = a.nodeName, indexOf.call(blacklist, ref1) >= 0) || (ref2 = a.nodeName, indexOf.call(whitelist, ref2) >= 0))) {
                        result.push("[" + a.nodeName + "=" + (_self.sanitizeAttribute(a.nodeValue)) + "]");
                    }
                }
                return result;
            };

            _self.getNthChildSelector = function (element) {
                var counter, k, len, parent_element, prefix, sibling, siblings;
                parent_element = element.parentNode;
                prefix = _self.options.prefix_tag ? _self.getTagSelector(element) : '';
                if (parent_element !== null) {
                    counter = 0;
                    siblings = parent_element.childNodes;
                    for (k = 0, len = siblings.length; k < len; k++) {
                        sibling = siblings[k];
                        if (_self.isElement(sibling)) {
                            counter++;
                            if (sibling === element) {
                                return prefix + (":nth-child(" + counter + ")");
                            }
                        }
                    }
                }
                return null;
            };

            _self.testSelector = function (element, selector) {
                var is_unique, result;
                is_unique = false;
                if ((selector !== null) && selector !== '') {
                    result = element.ownerDocument.querySelectorAll(selector);
                    if (result.length === 1 && result[0] === element) {
                        is_unique = true;
                    }
                }
                return is_unique;
            };

            _self.testUniqueness = function (element, selector) {
                var found_elements, parent;
                parent = element.parentNode;
                found_elements = parent ? parent.querySelectorAll(selector) : [];
                return found_elements.length === 1 && found_elements[0] === element;
            };

            _self.testCombinations = function (element, items, tag) {
                var item, k, l, len, len1, len2, len3, m, n,
                    combinations = _self.getCombinations(items),
                    prefixedCombinations;
                if (tag === null) {
                    tag = _self.getTagSelector(element);
                }
                if (!_self.options.prefix_tag) {
                    for (k = 0, len = combinations.length; k < len; k++) {
                        item = combinations[k];
                        if (_self.testSelector(element, item)) {
                            return item;
                        }
                    }
                    for (l = 0, len1 = combinations.length; l < len1; l++) {
                        item = combinations[l];
                        if (_self.testUniqueness(element, item)) {
                            return item;
                        }
                    }
                }
                prefixedCombinations = combinations.map(function (combination) {
                    return tag + combination;
                });
                for (m = 0, len2 = prefixedCombinations.length; m < len2; m++) {
                    item = prefixedCombinations[m];
                    if (_self.testSelector(element, item)) {
                        return item;
                    }
                }
                for (n = 0, len3 = prefixedCombinations.length; n < len3; n++) {
                    item = prefixedCombinations[n];
                    if (_self.testUniqueness(element, item)) {
                        return item;
                    }
                }
                return null;
            };

            _self.getUniqueSelector = function (element) {
                var k, len, ref, selector, selector_type, selectors, tag_selector;
                tag_selector = _self.getTagSelector(element);
                ref = _self.options.selectors;
                for (k = 0, len = ref.length; k < len; k++) {
                    selector_type = ref[k];
                    switch (selector_type) {
                        case 'id':
                            selector = _self.getIdSelector(element);
                            break;
                        case 'tag':
                            if (tag_selector && _self.testUniqueness(element, tag_selector)) {
                                selector = tag_selector;
                            }
                            break;
                        case 'class':
                            selectors = _self.getClassSelectors(element);
                            if ((selectors !== null) && selectors.length !== 0) {
                                selector = _self.testCombinations(element, selectors, tag_selector);
                            }
                            break;
                        case 'attribute':
                            selectors = _self.getAttributeSelectors(element);
                            if ((selectors !== null) && selectors.length !== 0) {
                                selector = _self.testCombinations(element, selectors, tag_selector);
                            }
                            break;
                        case 'nthchild':
                            selector = _self.getNthChildSelector(element);
                    }
                    if (selector) {
                        return selector;
                    }
                }
                return '*';
            };

            _self.getSelector = function (element) {
                var item, k, len, parents, result, selector, selectors;
                selectors = [];
                parents = _self.getParents(element);

                for (k = 0, len = parents.length; k < len; k++) {
                    item = parents[k];
                    selector = _self.getUniqueSelector(item);
                    if (selector !== null) {
                        selectors.unshift(selector);
                        result = selectors.join(' > ');
                        if (_self.testSelector(element, result)) {
                            return result;
                        }
                    }
                }
                return null;
            };

            _self.getCombinations = function (items) {
                var i, j, k, l, ref, ref1, result;
                if (items === null) {
                    items = [];
                }
                result = [[]];
                for (i = k = 0, ref = items.length - 1; 0 <= ref ? k <= ref : k >= ref; i = 0 <= ref ? ++k : --k) {
                    for (j = l = 0, ref1 = result.length - 1; 0 <= ref1 ? l <= ref1 : l >= ref1; j = 0 <= ref1 ? ++l : --l) {
                        result.push(result[j].concat(items[i]));
                    }
                }
                result.shift();
                result = result.sort(function (a, b) {
                    return a.length - b.length;
                });
                result = result.map(function (item) {
                    return item.join('');
                });
                return result;
            };

            // constructor:
            if (options === null) {
                options = {};
            }

            _self.options = {};
            _self.setOptions(_self.default_options);
            _self.setOptions(options);

            return _self;

        })(),
        $cursor,
        observerStopper,
        observerCounter = 0,
        observerSessions = {},
        headObserver,
        headDebounceTimer,
        clientContentsRetryTimer,
        pingTimer,
        pendingMeta = {},
        serverConnectionLostTimer,
        SERVER_CONNECTION_LOST_DELAY = 6000,
        ACTIVITY_CHANNEL_PREFIX = 'activity-',
        RACE_CHANNEL_PREFIX = 'race-',
        MIRROR_STATUS_CHANNEL_PREFIX = 'mirror-status-',
        groupEventSubscriptions = {},
        groupEventHandlers = {},
        reconnectCallbacks = [],
        hasCompletedHandshake = false,
        reconnectPending = false;

    function getUserIdFromChannel(channel) {
        var value = String(channel || '');
        var prefixes = ['winId-', 'active-', ACTIVITY_CHANNEL_PREFIX, RACE_CHANNEL_PREFIX, MIRROR_STATUS_CHANNEL_PREFIX];

        prefixes.forEach(function (prefix) {
            if (value.indexOf(prefix) === 0) {
                value = value.slice(prefix.length);
            }
        });

        return value.split('@')[0] || '';
    }

    function getActivityChannel(channel) {
        var userId = getUserIdFromChannel(channel);

        return userId ? (ACTIVITY_CHANNEL_PREFIX + userId) : '';
    }

    function getRaceChannel(channel) {
        var userId = getUserIdFromChannel(channel);

        return userId ? (RACE_CHANNEL_PREFIX + userId) : '';
    }

    function getMirrorStatusChannel(channel) {
        var userId = getUserIdFromChannel(channel);

        return userId ? (MIRROR_STATUS_CHANNEL_PREFIX + userId) : '';
    }

    function subscribeTemplateChanges(templateName, clientId, callback) {
        if (templateName === 'live-client') {
            subscribeActivityChanges(clientId, callback);
            return;
        }

        subscribeMetaChanges(clientId, callback);
    }

    function init() {
        if (!initialized) {
            initialized = true;
            $cursor = $body.find('[data-cursor]');
            if (window.WINID) {
                winId = window.WINID;
                setUpObserve();
                loadIo().then(setupIo, function (error) {
                    scheduleServerConnectionLost('load-error');
                    APP.Error.logError(error, {
                        source: 'APP.Live.loadIo',
                        context: {
                            script: '/socket.io/socket.io.js'
                        }
                    });
                });
            }
            $body.on('click', '[data-allow-live]', function () {
                liveAllowed = true;
                socket.emit('add-access', true);
            });
        } else {
            unsubscribeAllMetaChanges();
            unsubscribeAllGroupEvents();
            watchMetas();
        }
    }

    function watchMetas() {
        initLiveTemplate();
    }

    function initLiveTemplate() {
        $body.find('[data-live-template]').each(function () {
            var $this = $(this),
                $html,
                templateName = $this.attr('data-live-template'),
                clientId = $this.attr('data-live-client'),
                singleBlock = $this.attr('data-live-client-type') === 'single',
                newMeta;

            subscribeTemplateChanges(templateName, clientId, function (meta) {
                newMeta = meta;
                runCtx();
            });

            function runCtx() {
                var meta = JSON.parse(newMeta.value || '{}'),
                    userName = $this.attr('data-live-user-name');

                // The group page has a current name; activity metadata may predate a rename.
                if (userName !== undefined) {
                    meta.userName = userName;
                }

                APP.ProblemWorker.run(templateName, meta).then(function (html) {
                    if (meta.closed || $this.find('[data-live-client-block]').length === 0) {
                        $this.html(html);
                        if (singleBlock) {
                            $this.find('[data-live-client-block-type="list"]').remove();
                        } else {
                            $this.find('[data-live-client-block-type="single"]').remove();
                        }
                    } else {
                        $html = $(html);
                        $html.find('[data-live-client-block]').each(function () {
                            var $block = $(this),
                                stamp = $block.attr('data-live-client-stamp'),
                                index = $block.attr('data-live-client-block'),
                                $oldBlock = $this.find('[data-live-client-block="' + index + '"]'),
                                oldStamp = $oldBlock.attr('data-live-client-stamp');

                            if (stamp !== oldStamp) {
                                $oldBlock.replaceWith($block);
                            }
                        });
                    }
                    APP.Formula.fillFormulas($this);
                    APP.Formula.cosmeticFormulaByWrapper($this);
                    APP.Layout.setMoments();
                    $this.css('opacity', 1);
                });
            }
        });
    }

    function loadIo() {
        var script;

        return new Promise(function (resolve, reject) {
            script = document.createElement('script');
            script.onload = resolve;
            script.onerror = reject;
            script.src = '/socket.io/socket.io.js';
            document.body.appendChild(script);
        });
    }

    function setupIo() {
        socket = window.io(document.location.origin, {
            transports: ['websocket', 'polling'],
            reconnectionDelay: 5000,
            reconnectionDelayMax: 30000,
            // reconnectionAttempts: 5,
            timeout: 20000
        });
        Object.keys(metaChangeCallbacks).forEach(function (eventName) {
            metaChangeCallbacks[eventName].forEach(function (callback) { socket.on(eventName, callback); });
        });
        Object.keys(groupEventHandlers).forEach(function (groupId) {
            socket.on(getGroupEventChannel(groupId), groupEventHandlers[groupId]);
        });
        document.addEventListener('visibilitychange', function () {
            saveClientMeta('focus', !document.hidden && document.hasFocus());
        });
        socket.on('presence-reset', function () {
            if (!socket.connected || !handShake) return;
            socket.disconnect();
            socket.connect();
        });
        socket.on('hello', function () {
            if (handShake || !socket.connected) return;
            if (!binded) {
                socket.on('start-live', observe);
                socket.on('finish-live', ignore);
                socket.on('client-event', onClientEvent);
                binded = true;
            }
            socket.emit('hello', winId);
        });
        socket.on('ready', function () {
            if (handShake || !socket.connected) return;
            var isReconnect = hasCompletedHandshake && reconnectPending;
            var initialHandshake = !hasCompletedHandshake;

            clearServerConnectionLost('ready');
            clearTimeout(observerStopper);
            if (hasCompletedHandshake) sendClientContents();
            handShake = true;
            hasCompletedHandshake = true;
            reconnectPending = false;
            metaSubscriptionVersion++;
            activeMetaSubscriptions = {};
            saveClientMeta('focus', !document.hidden && document.hasFocus());
            sendMetas();
            if (initialHandshake) watchMetas();
            resubscribeAllMetaChanges();
            Object.keys(groupEventSubscriptions).forEach(function (groupId) {
                socket.emit('subscribeGroupEvents', {groupId: groupId});
            });
            if (isReconnect) {
                notifyReconnectCallbacks();
            }
        });
        socket.on('disconnect', function () {
            if (hasCompletedHandshake) {
                reconnectPending = true;
            }
            handShake = false;
            activeMetaSubscriptions = {};
            scheduleServerConnectionLost('disconnect');
        });
        socket.on('connect_error', function () {
            scheduleServerConnectionLost('connect-error');
        });
    }

    function reportServerConnectionLost(isLost, reason) {
        if (APP.Error && APP.Error.reportServerConnectionLost) {
            APP.Error.reportServerConnectionLost(isLost, {
                source: 'APP.Live',
                reason: reason
            });
        }
    }

    function scheduleServerConnectionLost(reason) {
        clearTimeout(serverConnectionLostTimer);
        serverConnectionLostTimer = setTimeout(function () {
            reportServerConnectionLost(true, reason);
        }, SERVER_CONNECTION_LOST_DELAY);
    }

    function clearServerConnectionLost(reason) {
        clearTimeout(serverConnectionLostTimer);
        serverConnectionLostTimer = null;
        reportServerConnectionLost(false, reason);
    }

    function notifyReconnectCallbacks() {
        reconnectCallbacks.forEach(function (callback, index) {
            try {
                callback();
            } catch (error) {
                APP.Error.logError(error, {
                    source: 'APP.Live.notifyReconnectCallbacks',
                    context: {
                        callbackIndex: index
                    }
                });
            }
        });
    }

    function sendMetas() {
        var metaArray = [],
            fields = {};

        Object.keys(pendingMeta).forEach(function (key) {
            // Page and focus state below is sampled now; queued progress/input keeps its latest value.
            if (key !== 'focus' && key !== 'closed' && key !== 'ping') metaArray.push(key, pendingMeta[key]);
        });
        pendingMeta = {};
        metaArray.push('focus', !document.hidden && document.hasFocus());

        if ($body.find('[data-live-meta="problem.instruction"]').length) {
            metaArray.push('problemInstruction');
            metaArray.push($body.find('[data-live-meta="problem.instruction"]').val());
            metaArray.push('problemClone');
            metaArray.push($body.find('[data-live-meta="problem.clone"]').val());
            metaArray.push('problemSolutionLink');
            metaArray.push('');
        } else {
            metaArray.push('problemInstruction');
            metaArray.push('');
            metaArray.push('problemClone');
            metaArray.push('');
            metaArray.push('problemSolutionLink');
            metaArray.push('');
        }
        metaArray.push('url');
        metaArray.push(document.location.href);
        metaArray.push('title');
        metaArray.push(document.title);
        metaArray.push('historyId');
        metaArray.push($body.find('[name="lesson-history-id"]').val() || '');
        metaArray.push('examId');
        metaArray.push($body.find('[name="exam-id"]').val() || '');
        metaArray.push('examNth');
        metaArray.push($body.find('[name="exam-nth"]').val() || '');
        for (var index = 0; index < metaArray.length; index += 2) fields[metaArray[index]] = metaArray[index + 1];
        metaArray = [];
        Object.keys(fields).forEach(function (key) { metaArray.push(key, fields[key]); });
        saveClientMeta(metaArray);
    }

    let pendingChanges = new Map();
    let debounceTimer = null;
    let maxWaitTimer = null;

    function setUpObserve() {
        observer = new MutationObserver(function (mutationList) {
            let hasChanged = false;
            mutationList.forEach(function (mutation) {
                const newChanges = processMutation(mutation);

                newChanges.forEach(change => {
                    const selector = change[0];
                    const type = change[1];
                    let key;

                    if (type === 'attr') {
                        const attrName = change[2];
                        key = `${selector}|attr|${attrName}`;
                    } else {
                        key = `${selector}|${type}`;
                    }
                    if (pendingChanges.has(key)) {
                        pendingChanges.delete(key);
                    }
                    pendingChanges.set(key, change);
                    hasChanged = true;
                });
            });

            if (hasChanged) {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(emitPendingChanges, 50);
                if (!maxWaitTimer) {
                    maxWaitTimer = setTimeout(emitPendingChanges, 1000 / 6);
                }
            }
        });
    }

    function emitPendingChanges() {
        clearTimeout(debounceTimer);
        clearTimeout(maxWaitTimer);
        maxWaitTimer = null;
        const changesToSend = Array.from(pendingChanges.values());

        if (changesToSend.length > 0 && socket && socket.connected) {
            socket.emit('change', changesToSend);
            pendingChanges.clear();
        }
    }

    function processMutation(mutation) {
        var changes = [],
            val,
            selector;

        switch (mutation.type) {
            case 'childList':
                selector = s.getSelector(mutation.target);
                if (selector) {
                    changes.push([selector, 'html', mutation.target.innerHTML]);
                }
                break;
            case 'attributes':
                val = mutation.target.getAttribute(mutation.attributeName);
                if (mutation.attributeName && mutation.oldValue !== val && (mutation.attributeName !== 'id' && val !== null)) {
                    selector = s.getSelector(mutation.target);
                    if (selector) {
                        changes.push([selector, 'attr', mutation.attributeName, val]);
                    }
                }
                break;
            case 'characterData':
                selector = s.getSelector(mutation.target);
                if (selector) {
                    changes.push([selector, 'text', mutation.target.textContent]);
                }
                break;
        }

        return changes;
    }

    let eventBuffers = {
        scroll: new Map(),
        input: new Map(),
        resize: null,
        mousemove: null
    };
    let eventTimeout = null;

    function observe(sessionId) {
        var hasSessionId = typeof sessionId === 'string' && sessionId;

        if (hasSessionId) {
            if (!observerSessions[sessionId]) {
                observerSessions[sessionId] = true;
                observerCounter++;
            }
        } else {
            observerCounter++;
        }
        clearTimeout(observerStopper);
        sendClientContents();
        startHeadObserver();

        if (!observing) {
            observing = true;
            observer.observe(window.document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true,
                attributeOldValue: true
            });

            if (!observerBinded) {
                observerBinded = true;

                window.addEventListener('scroll', function (event) {
                    var target,
                        data;

                    if (!observing || ignoreScrollEvents) {
                        ignoreScrollEvents = false;
                        return;
                    }

                    target = event.target.parentElement ? s.getSelector(event.target) : 'window';
                    if (event.target.parentElement && !target) {
                        return;
                    }
                    data = event.target.parentElement
                        ? [event.target.scrollLeft, event.target.scrollTop, target]
                        : [window.scrollX, window.scrollY];

                    eventBuffers.scroll.set(target, data);
                    scheduleEventFlush();
                }, true);

                window.addEventListener('resize', function () {
                    if (!observing) return;
                    eventBuffers.resize = [window.innerWidth, window.innerHeight];
                    scheduleEventFlush();
                });

                window.addEventListener('mousemove', function (event) {
                    if (!observing) return;
                    eventBuffers.mousemove = [event.pageX - window.scrollX, event.pageY - window.scrollY];
                    scheduleEventFlush();
                });

                window.addEventListener('input', function (event) {
                    var selector,
                        val;

                    if (!observing) return;
                    selector = s.getSelector(event.target);
                    if (!selector) {
                        return;
                    }
                    val = event.target.getAttribute('type') !== 'password'
                        ? event.target.value
                        : '*'.repeat(event.target.value.length);

                    eventBuffers.input.set(selector, [selector, val]);
                    scheduleEventFlush();
                }, true);
            }
        }
    }

    function scheduleEventFlush() {
        if (eventTimeout) return;
        eventTimeout = setTimeout(flushEvents, 50); // 50ms-enként ürítjük a puffert
    }

    function flushEvents() {
        if (!socket || !socket.connected) {
            eventTimeout = null;
            return;
        }

        eventBuffers.scroll.forEach(data => socket.emit('scroll', data));
        eventBuffers.scroll.clear();
        if (eventBuffers.resize) {
            socket.emit('resize', eventBuffers.resize);
            eventBuffers.resize = null;
        }
        if (eventBuffers.mousemove) {
            socket.emit('mousemove', eventBuffers.mousemove);
            eventBuffers.mousemove = null;
        }
        eventBuffers.input.forEach(data => socket.emit('input', data));
        eventBuffers.input.clear();
        eventTimeout = null;
    }

    function copyMirrorAttributes(source, target, attributes) {
        attributes.forEach(function (attribute) {
            const value = source.getAttribute(attribute);
            if (value !== null) {
                target.setAttribute(attribute, value);
            }
        });
    }

    function getMirrorHeadHtml() {
        const head = window.document.head;
        const stylesheets = {};
        const result = [];

        if (!head) {
            return '';
        }

        [...head.querySelectorAll('style, link')].forEach(function (element) {
            const tagName = element.tagName.toLowerCase();
            const rel = (element.getAttribute('rel') || '').toLowerCase().split(/\s+/);
            const isStylesheet = tagName === 'link' && rel.indexOf('stylesheet') > -1;
            const isStylePreload = tagName === 'link' && rel.indexOf('preload') > -1 && (element.getAttribute('as') || '').toLowerCase() === 'style';
            let clone,
                href;

            if (tagName === 'style') {
                clone = window.document.createElement('style');
                clone.textContent = element.textContent;
                copyMirrorAttributes(element, clone, ['id', 'media', 'title']);
                result.push(clone.outerHTML);
                return;
            }

            if (!isStylesheet && !isStylePreload) {
                return;
            }

            href = element.href || element.getAttribute('href');
            if (!href || stylesheets[href]) {
                return;
            }
            stylesheets[href] = true;

            clone = window.document.createElement('link');
            clone.setAttribute('rel', 'stylesheet');
            clone.setAttribute('href', href);
            copyMirrorAttributes(element, clone, ['media', 'integrity', 'crossorigin', 'referrerpolicy', 'title']);
            if (element.disabled) {
                clone.setAttribute('disabled', '');
            }
            result.push(clone.outerHTML);
        });

        return result.join('');
    }

    function getMirrorBodyHtml() {
        const body = window.document.body.cloneNode(true);

        [...body.querySelectorAll('script')].forEach(script => script.remove());
        return body.outerHTML;
    }

    function sendMirrorHead() {
        if (socket && socket.connected) {
            socket.emit('head', getMirrorHeadHtml());
        }
    }

    function scheduleHeadFlush() {
        clearTimeout(headDebounceTimer);
        headDebounceTimer = setTimeout(function () {
            headDebounceTimer = null;
            sendMirrorHead();
        }, 50);
    }

    function startHeadObserver() {
        if (!headObserver && window.document.head) {
            headObserver = new MutationObserver(scheduleHeadFlush);
            headObserver.observe(window.document.head, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true,
                attributeFilter: ['rel', 'href', 'as', 'media', 'integrity', 'crossorigin', 'referrerpolicy', 'title', 'disabled']
            });
        }
    }

    function stopHeadObserver() {
        clearTimeout(headDebounceTimer);
        headDebounceTimer = null;
        if (headObserver) {
            headObserver.disconnect();
            headObserver = null;
        }
    }

    function sendClientContents() {
        if (socket && socket.connected) {
            clearTimeout(clientContentsRetryTimer);
            clientContentsRetryTimer = null;
            sendMirrorHead();
            socket.emit('resize', [window.innerWidth, window.innerHeight]);
            socket.emit('body', getMirrorBodyHtml());
            socket.emit('scroll', [window.scrollX, window.scrollY]);
            socket.emit('change', [['html', 'attr', 'class', $('html').attr('class')]]);
        } else {
            if (!clientContentsRetryTimer) {
                clientContentsRetryTimer = setTimeout(function () {
                    clientContentsRetryTimer = null;
                    sendClientContents();
                }, 1000);
            }
        }
    }

    function ignore(sessionId) {
        var hasSessionId = typeof sessionId === 'string' && sessionId;

        if (hasSessionId) {
            if (observerSessions[sessionId]) {
                delete observerSessions[sessionId];
                observerCounter = Math.max(0, observerCounter - 1);
            }
        } else {
            observerCounter = Math.max(0, observerCounter - 1);
        }
        $cursor.css({display: 'none'});
        observerStopper = setTimeout(function () {
            if (observing && observerCounter === 0) {
                observing = false;
                observer.disconnect();
                stopHeadObserver();
            }
        }, 15000);
    }

    function onClientEvent(e) {
        var event = e.event,
            message = e.message;

        clearTimeout(observerStopper);
        if (!liveAllowed) {
            if (event === 'live-access') {
                $body.find('[data-access-name]').text(message);
                APP.Layout.openOverlay('live-access');
            }
            return;
        }

        switch (event) {
            case 'mousemove':
                $cursor.css({
                    display: 'block',
                    left: message[0] + 'px',
                    top: message[1] + 'px',
                });
                break;
            case 'click':
                var element = document.elementFromPoint(message[0], message[1]);
                if (element) {
                    simulateFullClick(element, message[0], message[1]);
                }
                break;
            case 'scroll':
                var target;

                if (message.length > 2) {
                    target = findElement(message[2]);
                    scrollTo(target, message[0], message[1]);
                } else if (message.length === 2) {
                    scrollTo(window, message[0], message[1]);
                }
                break;
            case 'input':
                var inputEl = findElement(message[0]);
                if (inputEl) {
                    inputEl.value = message[1];
                    inputEl.dispatchEvent(new Event('input', {bubbles: true}));
                    inputEl.dispatchEvent(new Event('change', {bubbles: true}));
                }
                break;
        }
    }

    function simulateFullClick(element, x, y) {
        const eventOptions = {
            bubbles: true,
            cancelable: true,
            view: window,
            clientX: x,
            clientY: y,
            button: 0
        };

        if (typeof element.focus === 'function') {
            element.focus();
        }

        const mousedown = new MouseEvent('mousedown', eventOptions);
        const mouseup = new MouseEvent('mouseup', eventOptions);
        const click = new MouseEvent('click', eventOptions);

        element.dispatchEvent(mousedown);
        element.dispatchEvent(mouseup);
        element.dispatchEvent(click);
    }

    function findElement(selector) {
        if (!selector) {
            return null;
        }

        try {
            return document.querySelector(selector);
        } catch (error) {
            APP.Error.logError(error, {
                source: 'APP.Live.findElement',
                context: {
                    selector: selector
                }
            });
            return null;
        }
    }

    function scrollTo(element, x, y) {
        if (!element || typeof element.scrollTo !== 'function') {
            return;
        }
        ignoreScrollEvents = true;
        element.scrollTo(x, y);
    }

    function saveClientMeta(key, value) {
        clearTimeout(pingTimer);
        if (socket && socket.connected && handShake) {
            if (arguments.length === 1) {
                socket.emit('client-metas', key);
            } else {
                socket.emit('client-meta', {
                    key: key,
                    value: typeof value === 'object' ? JSON.stringify(value) : value
                });
            }
            pingTimer = setTimeout(ping, 1000 * 60 * 2);
        } else {
            var fields = arguments.length === 1 ? key : [key, typeof value === 'object' ? JSON.stringify(value) : value];
            for (var index = 0; index < fields.length; index += 2) pendingMeta[fields[index]] = fields[index + 1];
        }
    }

    var metaChangeCallbacks = {},
        requestedMetaSubscriptions = {},
        activeMetaSubscriptions = {},
        metaSubscriptionVersion = 0;

    function normalizeMetaClientId(clientId) {
        return String(clientId || '').replace(/winId-/g, '');
    }

    function ensureMetaSubscription(clientId) {
        var normalizedClientId = normalizeMetaClientId(clientId);

        if (!normalizedClientId || !socket || !handShake) {
            return false;
        }

        if (activeMetaSubscriptions[normalizedClientId] === metaSubscriptionVersion) {
            return true;
        }

        socket.emit('subscribeMetaChanges', {clientId: normalizedClientId});
        activeMetaSubscriptions[normalizedClientId] = metaSubscriptionVersion;
        return true;
    }

    function resubscribeAllMetaChanges() {
        Object.keys(requestedMetaSubscriptions).forEach(function (clientId) {
            ensureMetaSubscription(clientId);
        });
    }

    function subscribeMetaChanges(clientId, callback) {
        var normalizedClientId,
            eventName;

        normalizedClientId = normalizeMetaClientId(clientId);
        if (!normalizedClientId) {
            return;
        }

        requestedMetaSubscriptions[normalizedClientId] = true;
        eventName = 'clientMetaChange-' + normalizedClientId;
        metaChangeCallbacks[eventName] = metaChangeCallbacks[eventName] || [];

        if (metaChangeCallbacks[eventName].indexOf(callback) === -1) {
            if (socket) socket.on(eventName, callback);
            metaChangeCallbacks[eventName].push(callback);
        }

        ensureMetaSubscription(normalizedClientId);
    }

    function subscribeActivityChanges(clientId, callback) {
        subscribeMetaChanges(getActivityChannel(clientId), callback);
    }

    function subscribeRaceChanges(clientId, callback) {
        subscribeMetaChanges(getRaceChannel(clientId), callback);
    }

    function onReconnect(callback) {
        if (typeof callback !== 'function' || reconnectCallbacks.indexOf(callback) !== -1) {
            return;
        }

        reconnectCallbacks.push(callback);
    }

    function subscribeMirrorStatusChanges(clientId, callback) {
        subscribeMetaChanges(getMirrorStatusChannel(clientId), callback);
    }

    function unsubscribeAllMetaChanges() {
        if (socket) {
            Object.keys(metaChangeCallbacks).forEach((eventName) => {
                metaChangeCallbacks[eventName].forEach(function (callback) {
                    socket.off(eventName, callback);
                });
            });
            socket.emit('unsubscribeAllMetaChanges');
        }
        metaChangeCallbacks = {};
        requestedMetaSubscriptions = {};
        activeMetaSubscriptions = {};
    }

    function subscribeUserEvent(callback) {
        if (socket && handShake) {
            socket.on('user-event', callback);
        } else {
            setTimeout(() => subscribeUserEvent(callback), 1000);
        }

    }

    function ping() {
        saveClientMeta('ping', 1);
    }

    function getGroupEventChannel(groupId) {
        return 'group-event@' + groupId;
    }

    function onGroupEvent(groupId, callback) {
        var channel = getGroupEventChannel(groupId);

        if (!groupEventHandlers[groupId]) {
                groupEventHandlers[groupId] = function (event) {
                    var callbacks = groupEventSubscriptions[groupId] || [];
                    callbacks.forEach(function (cb) {
                        cb(event);
                    });
                };
                if (socket) socket.on(channel, groupEventHandlers[groupId]);
            }
            groupEventSubscriptions[groupId] = groupEventSubscriptions[groupId] || [];
            if (groupEventSubscriptions[groupId].indexOf(callback) === -1) {
                groupEventSubscriptions[groupId].push(callback);
            }
            if (socket && handShake) socket.emit('subscribeGroupEvents', {groupId: groupId});
    }

    function unsubscribeAllGroupEvents() {
        if (socket) {
            socket.emit('unsubscribeAllGroupEvents');
        }

        Object.keys(groupEventHandlers).forEach(function (groupId) {
            var channel = getGroupEventChannel(groupId);
            var handler = groupEventHandlers[groupId];

            if (socket && handler) {
                if (typeof socket.off === 'function') {
                    socket.off(channel, handler);
                } else if (typeof socket.removeListener === 'function') {
                    socket.removeListener(channel, handler);
                }
            }
        });

        groupEventSubscriptions = {};
        groupEventHandlers = {};
    }

    exports.init = init;
    exports.saveClientMeta = saveClientMeta;
    exports.sendMetas = sendMetas;
    exports.subscribeUserEvent = subscribeUserEvent;
    exports.subscribeMetaChanges = subscribeMetaChanges;
    exports.subscribeActivityChanges = subscribeActivityChanges;
    exports.subscribeRaceChanges = subscribeRaceChanges;
    exports.subscribeMirrorStatusChanges = subscribeMirrorStatusChanges;
    exports.onReconnect = onReconnect;
    exports.getActivityChannel = getActivityChannel;
    exports.getRaceChannel = getRaceChannel;
    exports.getMirrorStatusChannel = getMirrorStatusChannel;
    exports.onGroupEvent = onGroupEvent;
    exports.ping = ping;

    return exports;
})();

APP.Page = (function () {
    var exports = {},
        $pageBody,
        interPageUrl,
        isPageLoading;

    function init() {
        $pageBody = $body.find('#body');
        initBindings();
        setUpNotAjaxState();
        if (typeof window.onPageReady !== 'undefined') {
            requestAnimationFrame(window.onPageReady);
        }
    }

    function setUpNotAjaxState() {
        var data = {
            title: $('title').text(),
            url: document.location.pathname + document.location.search + document.location.hash,
            body: $('#body').html(),
            pageType: $('meta[name="akriel-page-type"]').attr('content')
        };

        try {
            window.history.replaceState(data, data.title, data.url);
            if (document.location.hash) {
                pageLoaded($(document.location.hash));
            }

        } catch (e) {
            APP.Error.logError(e, {
                source: 'APP.Page.setUpNotAjaxState',
                context: {
                    url: data.url
                }
            });
        }
    }

    function initBindings() {
        var ignoreSelection = '[href="#void"], [href*="://"],[target="_blank"],[href^="#"],[href^="mailto:"],[data-enable-href]';
        $body.on('click', 'a[href]:not(' + ignoreSelection + ')', function (event) {
            var $this = $(this);
            if ($this.attr('data-prevent-default') !== 'false') {
                event.preventDefault();
            }
            clickOnElement($this);
        });

        $body.on('click', 'a[href="#void"]', function (event) {
            event.preventDefault();
        });

        virtualKeyboardDetector.init();

        window.onpopstate = function (event) {
            if (event.state) {
                applyPageByUrl(event.state.url, true).then(() => window.scrollTo(0, 0));
            }
        };
    }

    function clickOnElement($element) {
        applyPageByUrl($element.attr('href'));
    }

    function applyPageByUrl(pageUrl, noPushState) {
        if (isPageLoading) {
            return Promise.resolve();
        }

        return new Promise(function (resolve) {
            var url;
            var finish = function () {
                setTimeout(() => {
                    isPageLoading = false;
                }, 120);
            };

            if (interPageUrl) {
                url = interPageUrl.replace('{0}', pageUrl);
                interPageUrl = false;
                applyPageByUrl(url, noPushState).then(resolve);
            } else {
                url = pageUrl;
                isPageLoading = true;
                APP.Ajax.get(pageUrl, false, (redirection) => {
                    url = redirection;
                }).then(function (html) {
                    try {
                        applyPageByHtml(html, url, noPushState);
                        if (pageUrl.indexOf('#') > -1) {
                            var hash = pageUrl.split('#')[1];
                            var $element = $(document.getElementById(hash));
                            if ($element.length > 0) {
                                pageLoaded($element);
                            } else {
                                document.location.hash = hash;
                            }
                        }
                    } catch (error) {
                        APP.Error.logError(error, {
                            source: 'APP.Page.applyPageByUrl',
                            context: {
                                url: url || pageUrl
                            }
                        });
                        if (url || pageUrl) {
                            window.location.href = url || pageUrl;
                        } else {
                            finish();
                        }
                    }
                    finish();
                    resolve();
                }, function () {
                    finish();
                    resolve();
                });
            }
        });
    }

    function applyPageByHtml(pageContent, url, noPushState) {
        var page = document.createElement('html'),
            data;

        APP.Live.saveClientMeta('input', '');
        page.innerHTML = pageContent;
        if (APP.Initializer.needUpdate(page)) {
            window.location.href = url;
        } else {
            data = {
                title: $('title', page).text(),
                url: url,
                body: $('#body', page).html(),
                pageType: $('meta[name="akriel-page-type"]', page).attr('content')
            };
            applyPageByData(data, noPushState);
            APP.Live.sendMetas();
        }
    }

    function applyPageByData(data, noPushState) {
        if (!noPushState) {
            try {
                window.history.pushState(data, data.title, data.url);
            } catch (e) {
                APP.Error.logError(e, {
                    source: 'APP.Page.applyPageByData',
                    context: {
                        url: data.url,
                        title: data.title
                    }
                });
            }
        }

        document.title = data.title;

        if (!data.target) {
            async(APP.Calculator.Keyboard.hide);
            APP.Layout.closeOverlay();
            $pageBody.html(data.body);
            setPageClass(data.pageType);
            pageLoaded($pageBody, noPushState);
        } else {
            $body.find(data.target).html(data.body);
        }

        APP.Initializer.init();
    }

    function setPageClass(pageClass) {
        var prefix = 'page--',
            app = $body.find('.application')[0],
            classes = app.className.split(' ').filter(function (c) {
                return c.lastIndexOf(prefix, 0) !== 0;
            });

        app.className = classes.join(' ').trim();
        if (pageClass) {
            $(app).addClass('page--' + pageClass);
        }
    }

    function pageLoaded($target, preventScroll) {
        setTimeout(function () {
            if ($target.attr('id') === 'body') {
                if ($body.find('[data-auto-input-scroll-top]').length === 0 && !preventScroll) {
                    APP.Layout.scrollTo(0);
                }
            } else if ($target.length) {
                APP.Layout.scrollTo($target.offset().top - 52);
            }
            if (typeof window.onPageReady !== 'undefined') {
                requestAnimationFrame(window.onPageReady);
            }
        }, 120);
    }

    function getContentOfUrl(url, selector, callback, innerHtml) {
        APP.Ajax.get(url).then(function (html) {
            var page = document.createElement('html'),
                found;

            page.innerHTML = html;
            found = $(selector, page)[0];

            if (found) {
                if (innerHtml) {
                    callback(found.innerHTML);
                } else {
                    callback(found.outerHTML);
                }
            }
        }, window.NOOP);
    }

    function removeLocalFromHref(href) {
        var path = href.split('/');
        path.splice(3, 1);
        return path.join('/');
    }

    function reloadPage(autoLocal) {
        var href = document.location.href;
        if (autoLocal) {
            href = removeLocalFromHref(href);
        }
        applyPageByUrl(href);
    }

    function refreshPage(autoLocal) {
        if (autoLocal) {
            document.location.href = removeLocalFromHref(document.location.href);
        } else {
            document.location.reload();
        }
    }

    function reloadPageSilence() {
        var pageUrl = document.location.href;

        APP.Ajax.get(pageUrl, true).then(function (html) {
            applyPageByHtml(html, pageUrl, true);
        }, window.NOOP);
    }

    function isDevice() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

        var mq = function (query) {
            return window.matchMedia(query).matches;
        };

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    function hasVirtualKeyboard() {
        return isDevice() && (localStorage.hasKeyboardVirtual || !localStorage.hasKeyboardHardwer);
    }

    function addInterPage(url) {
        if (url.indexOf('{0}') > -1) {
            interPageUrl = url;
        }
    }

    exports.init = init;
    exports.getContentOfUrl = getContentOfUrl;
    exports.applyPageByUrl = applyPageByUrl;
    exports.reloadPage = reloadPage;
    exports.refreshPage = refreshPage;
    exports.reloadPageSilence = reloadPageSilence;
    exports.isDevice = isDevice;
    exports.hasVirtualKeyboard = hasVirtualKeyboard;
    exports.addInterPage = addInterPage;
    return exports;

})();

/* global $body, moment, requestAnimationFrame, cancelAnimationFrame */
APP.Race = (function () {
    var _self = {},
        minutes = 1,
        activityThreshold = 60000 * minutes,
        activityCheckTimeout = null,
        activityCheckRefreshRate = 1000,
        onUpdate = {},
        initialized = false,
        resolveCallbacks = {},
        requestStates = {},
        renderTimers = {},
        renderMaxTimers = {},
        renderStates = {},
        liveReconnectBound = false,
        liveReconnectRefreshTimer = null,
        userSubscriptions = {},
        presenceByUser = {},
        nextPeriodWrapperKey = 0,
        diagnostics = {
            invalidRaceProgress: {},
            renderMaxWait: {}
        },
        collator = new Intl.Collator(undefined, {
            sensitivity: 'variant',
            numeric: true
        });

    const RENDER_DEBOUNCE_MS = 120;
    const RENDER_MAX_WAIT_MS = 450;

    var player = false;
    var isPlaying = false;
    var baseEvents = null;
    var extendedEvents = [];
    var playerFrame = 0;
    var playerBaseContext = null;
    var playerCurrentContext = null;
    var playerWrapperId = null;
    var playerRender = null;
    var playerAnimationFrame = null;
    var playerLastFrameAt = 0;
    var playerFrameDuration = 1000 / 24;
    var playerRaceByUserId = {};
    var playerStateByUserId = {};
    var raceSessions = {};
    var playerGeneration = 0;
    var playerPhase = '';
    var playerRange = null;
    var playerSelectionKey = '';
    var playerSnapshotAt = null;
    var playerCatchUp = null;
    const RACE_REFRESH_MS = 1000;
    const RACE_RECONCILE_MS = 30000;
    const STUDY_RANGE_STORAGE_PREFIX = 'group-study-range:';
    const DEFAULT_STUDY_RANGE_ACTION = 'today';

    function getActualGroupId() {
        return $body.find('[data-actual-group-id]').attr('data-actual-group-id') || '';
    }

    function getStudyRangeStorageKey(groupId = getActualGroupId()) {
        return groupId ? (STUDY_RANGE_STORAGE_PREFIX + groupId) : '';
    }

    function getClientTimezone() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    }

    function parseStudyRangeDate(value) {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    function getRelativeStudyRange(action) {
        switch (action) {
            case 'today':
                return {
                    start: moment().startOf('day'),
                    end: moment().endOf('day')
                };
            case 'this_week':
                return {
                    start: moment().startOf('week').startOf('day'),
                    end: moment().endOf('week').endOf('day')
                };
            case 'this_month':
                return {
                    start: moment().startOf('month').startOf('day'),
                    end: moment().endOf('month').endOf('day')
                };
            case 'last_7_days':
                return {
                    start: moment().subtract(6, 'days').startOf('day'),
                    end: moment().endOf('day')
                };
            case 'last_30_days':
                return {
                    start: moment().subtract(29, 'days').startOf('day'),
                    end: moment().endOf('day')
                };
            default:
                return null;
        }
    }

    function readStudyRangePreference() {
        const key = getStudyRangeStorageKey();

        if (!key || !window.localStorage) {
            return null;
        }

        try {
            const raw = window.localStorage.getItem(key);

            return raw ? JSON.parse(raw) : null;
        } catch (error) {
            APP.Error.logError(error, {
                source: 'APP.Race.readStudyRangePreference',
                context: {
                    key: key
                }
            });
            return null;
        }
    }

    function normalizeStudyRangePreference(preference) {
        const timezone = (preference && preference.timezone) || getClientTimezone();
        const action = (preference && preference.action) || DEFAULT_STUDY_RANGE_ACTION;
        const relativeRange = getRelativeStudyRange(action);

        if (relativeRange) {
            return {
                action: action,
                timezone: timezone,
                start: relativeRange.start,
                end: relativeRange.end
            };
        }

        const start = moment(parseStudyRangeDate(preference && preference.start));
        const end = moment(parseStudyRangeDate(preference && preference.end));

        if (start.isValid() && end.isValid() && !end.isBefore(start)) {
            return {
                action: 'custom',
                timezone: timezone,
                start: start,
                end: end
            };
        }

        return {
            action: DEFAULT_STUDY_RANGE_ACTION,
            timezone: getClientTimezone(),
            start: moment().startOf('day'),
            end: moment().endOf('day')
        };
    }

    function getActiveStudyRangePreference() {
        return normalizeStudyRangePreference(readStudyRangePreference());
    }

    function saveStudyRangePreference(action, start, end, timezone = getClientTimezone()) {
        const key = getStudyRangeStorageKey();

        if (!key || !window.localStorage) {
            return;
        }

        const startMoment = moment.isMoment(start) ? start.clone() : moment(start);
        const endMoment = moment.isMoment(end) ? end.clone() : moment(end);
        const payload = {
            action: action || 'custom',
            timezone: timezone
        };

        if (startMoment.isValid()) {
            payload.start = startMoment.toDate().toISOString();
        }
        if (endMoment.isValid()) {
            payload.end = endMoment.toDate().toISOString();
        }

        try {
            window.localStorage.setItem(key, JSON.stringify(payload));
        } catch (error) {
            APP.Error.logError(error, {
                source: 'APP.Race.saveStudyRangePreference',
                context: {
                    key: key,
                    action: payload.action
                }
            });
        }
    }

    function getStudyRangeRequestData() {
        const range = getPickerRange();
        const start = range.start && range.start.isValid() ? range.start.toDate().toISOString() : '';
        const end = range.end && range.end.isValid() ? range.end.toDate().toISOString() : '';

        return {
            studyRangeAction: range.action || 'custom',
            studyRangeStart: start,
            studyRangeEnd: end,
            studyRangeTimezone: getClientTimezone()
        };
    }

    function getStudyRangeKey(range = getStudyRangeRequestData()) {
        return JSON.stringify(range);
    }

    function init() {
        clearPlayer();
        Object.keys(raceSessions).forEach((id) => clearTimeout(raceSessions[id].timer));
        raceSessions = {};
        requestStates = {};
        Object.keys(renderTimers).forEach((key) => {
            clearTimeout(renderTimers[key]);
        });
        Object.keys(renderMaxTimers).forEach((key) => {
            clearTimeout(renderMaxTimers[key]);
        });

        onUpdate = {};
        resolveCallbacks = {};
        renderTimers = {};
        renderMaxTimers = {};
        renderStates = {};
        userSubscriptions = {};
        presenceByUser = {};

        if (!initialized) {
            initBindings();
            initialized = true;
        }

        initDateRangePicker();
        bindLiveReconnectRefresh();
        setActivityThreshold();
    }

    function initBindings() {
        $body.on('click', '[data-id="player-backward"]', () => backward());
        $body.on('click', '[data-id="player-stop"]', () => stop());
        $body.on('click', '[data-id="player-play-pause"]', () => playPause());
        $body.on('click', '[data-id="player-forward"]', () => forward());
        $body.on('click', '[data-id="player-play-it"]', () => playIt());
        $(document).on('visibilitychange', function () {
            if (!document.hidden && !player) {
                Object.keys(raceSessions).forEach((id) => queueRaceRefresh(raceSessions[id]));
            }
        });
    }

    function initDateRangePicker() {
        const $picker = $body.find('[data-id="study-range-picker"]');
        if (!$picker.length) {
            return;
        }

        const $display = $picker.find('span');
        const customLabel = 'Egyéni';
        const initialRange = getActiveStudyRangePreference();

        const rangeDefinitions = [
            {
                action: 'today',
                label: 'Ma',
                getRange: () => {
                    const range = getRelativeStudyRange('today');
                    return [range.start, range.end];
                }
            },
            {
                action: 'this_week',
                label: 'Ez a hét',
                getRange: () => {
                    const range = getRelativeStudyRange('this_week');
                    return [range.start, range.end];
                }
            },
            {
                action: 'this_month',
                label: 'Ez a hónap',
                getRange: () => {
                    const range = getRelativeStudyRange('this_month');
                    return [range.start, range.end];
                }
            },
            {
                action: 'last_7_days',
                label: 'Utóbbi 7 nap',
                getRange: () => {
                    const range = getRelativeStudyRange('last_7_days');
                    return [range.start, range.end];
                }
            },
            {
                action: 'last_30_days',
                label: 'Utóbbi 30 nap',
                getRange: () => {
                    const range = getRelativeStudyRange('last_30_days');
                    return [range.start, range.end];
                }
            }
        ];

        const ranges = {};
        const labelToAction = {};
        const actionToLabel = {};
        const actionToDefinition = {};

        rangeDefinitions.forEach((definition) => {
            ranges[definition.label] = definition.getRange();
            labelToAction[definition.label] = definition.action;
            actionToLabel[definition.action] = definition.label;
            actionToDefinition[definition.action] = definition;
        });

        const start = initialRange.start.clone();
        const end = initialRange.end.clone();

        function syncPickerAttributes(startMoment, endMoment, action) {
            $picker.attr('data-date-start', startMoment.toDate().toISOString());
            $picker.attr('data-date-end', endMoment.toDate().toISOString());
            $picker.attr('data-date-action', action || 'custom');
        }

        function cb(start, end, label, autoplay) {
            const action = label ? (labelToAction[label] || 'custom') : ($picker.attr('data-date-action') || 'custom');

            syncPickerAttributes(start, end, action);
            if (label) {
                APP.NewsFeed.setStudyRange(
                    action,
                    start.toDate(),
                    end.toDate(),
                    autoplay
                );
            } else {
                label = actionToLabel[$picker.attr('data-date-action')] || customLabel;
            }

            if (label !== customLabel) {
                $display.html(label);
                return;
            }

            if (end.isAfter(moment())) {
                $display.html('{0} óta'.replace('{0}', start.format('MMMM D, YYYY HH:mm')));
            } else {
                $display.html(start.format('MMMM D, YYYY HH:mm') + ' – ' + end.format('MMMM D, YYYY HH:mm'));
            }
        }

        $picker.daterangepicker({
            startDate: start,
            endDate: end,
            timePicker: true,
            timePicker24Hour: true,
            linkedCalendars: false,
            maxYear: new Date().getFullYear(),
            applyButtonClasses: 'button',
            cancelClass: 'button button--gray',
            ranges,
            drops: 'auto',
            locale: {
                applyLabel: 'Alkalmaz',
                cancelLabel: 'Mégsem',
                customRangeLabel: customLabel
            }
        }, cb);

        _self.picker = $picker.data('daterangepicker');
        _self.pickerCustomLabel = customLabel;
        _self.pickerCallback = cb;
        _self.pickerLabelToAction = labelToAction;
        _self.pickerActionToLabel = actionToLabel;
        _self.syncPickerAttributes = syncPickerAttributes;
        _self.picker.chosenLabel = actionToLabel[initialRange.action] || customLabel;

        syncPickerAttributes(start, end, initialRange.action);
        cb(start, end);
    }

    function getPickerRange() {
        const $picker = $body.find('[data-id="study-range-picker"]');
        const picker = _self.picker;

        if (picker && picker.startDate && picker.endDate) {
            const action = $picker.attr('data-date-action') || 'custom';
            const relative = getRelativeStudyRange(action);
            return {
                start: relative ? relative.start : picker.startDate.clone(),
                end: relative ? relative.end : picker.endDate.clone(),
                action: action
            };
        }

        return getActiveStudyRangePreference();
    }

    function setActivityThreshold() {
        const minute = Math.max(0, parseInt($body.find('[name="activity-threshold-minute"]').val(), 10) || 0);
        const second = Math.max(0, parseInt($body.find('[name="activity-threshold-second"]').val(), 10) || 0);
        const currentFrame = playerFrame;

        $body.find('[data-id="activity-threshold"]').text(minute + ':' + ('0' + second).slice(-2));
        activityThreshold = Math.max(1000, (60000 * minute) + (1000 * second));

        if (player && baseEvents && playerBaseContext && playerRender) {
            extendedEvents = extendEvents(baseEvents);
            playerCurrentContext = null;
            setPlayerFrame(Math.min(currentFrame, extendedEvents.length));
        }

        checkInactivity();
    }

    function load(autoPlay) {
        const promises = [];

        clearPlayer();
        Object.keys(raceSessions).forEach((id) => clearTimeout(raceSessions[id].timer));
        raceSessions = {};

        $body.find('[data-period-wrapper]').each(function () {
            promises.push(refreshLearnPeriod($(this).attr('data-period-wrapper')));
        });
        return Promise.all(promises).then(function () {
            if (autoPlay) {
                return playIt();
            }
        }, reportLearnPeriodRefreshError);
    }

    function refreshAfterLiveReconnect() {
        if (player) {
            return;
        }

        clearTimeout(liveReconnectRefreshTimer);
        liveReconnectRefreshTimer = setTimeout(function () {
            load();
        }, 0);
    }

    function bindLiveReconnectRefresh() {
        if (liveReconnectBound || !APP.Live || typeof APP.Live.onReconnect !== 'function') {
            return;
        }

        liveReconnectBound = true;
        APP.Live.onReconnect(refreshAfterLiveReconnect);
    }

    function getRaceMax(race) {
        const max = (race || []).reduce((result, row) => Math.max(result, row.count || 0), 0);
        return Math.max(1, Math.ceil(max * 1.25));
    }

    function parseRaceTimestamp(value) {
        return APP.RaceHelpers.parseTimestamp(value);
    }

    function pickLatestRaceTimestamp(currentValue, nextValue) {
        return APP.RaceHelpers.pickLatestTimestamp(currentValue, nextValue);
    }

    function getRaceVisualState(lastProgressAt, nowValue) {
        return APP.RaceHelpers.getRaceVisualState(lastProgressAt, activityThreshold, nowValue);
    }

    function isRaceSignalActive(focus, lastSignalAt, nowValue, focusKnown) {
        return APP.RaceHelpers.isRaceActive(focus, lastSignalAt, activityThreshold, nowValue, focusKnown);
    }

    function getDiagnosticKey(userId, rawValue) {
        return String(userId || '') + '|' + String(rawValue || '');
    }

    function logInvalidRaceProgress(userId, rawValue) {
        const key = getDiagnosticKey(userId, rawValue);

        if (!rawValue || diagnostics.invalidRaceProgress[key]) {
            return;
        }

        diagnostics.invalidRaceProgress[key] = true;
        APP.Error.logError(new Error('race invalid progress timestamp'), {
            source: 'APP.Race.logInvalidRaceProgress',
            context: {
                userId: userId,
                value: rawValue
            }
        });
    }

    function logRenderMaxWait(wrapperId) {
        const now = Date.now();
        const state = diagnostics.renderMaxWait[wrapperId] = diagnostics.renderMaxWait[wrapperId] || {
            count: 0,
            windowStartedAt: now,
            lastLoggedAt: 0
        };

        if (now - state.windowStartedAt > 10000) {
            state.count = 0;
            state.windowStartedAt = now;
        }

        state.count++;
        if (state.count < 5 || now - state.lastLoggedAt < 30000) {
            return;
        }

        state.lastLoggedAt = now;
        if (APP.Analytics && APP.Analytics.capture) {
            APP.Analytics.capture('race-render-backpressure', {
                source: 'APP.Race.logRenderMaxWait',
                wrapperId: wrapperId,
                thresholdMs: RENDER_MAX_WAIT_MS,
                hitCount: state.count
            });
        }
    }

    function getRaceRowProgressValue(row) {
        return (row && (row.lastProgressAt || row.earnStar)) || '';
    }

    function getRaceRowSignalValue(row) {
        return (row && (row.lastRaceSignalAt || row.lastProgressAt || row.earnStar)) || '';
    }

    function normalizeRaceRow(row) {
        if (!row) {
            return row;
        }

        if (typeof row.focusKnown === 'undefined') {
            row.focusKnown = Object.prototype.hasOwnProperty.call(row, 'focus');
        }
        row.focus = !!row.focus;
        row.closed = !!row.closed;
        row.lastFocusChangeAt = row.lastFocusChangeAt || '';
        row.lastProgressAt = pickLatestRaceTimestamp('', getRaceRowProgressValue(row));
        row.earnStar = row.lastProgressAt || '';
        row.lastRaceSignalAt = pickLatestRaceTimestamp(row.lastRaceSignalAt, row.lastProgressAt);
        row.isRaceActive = !row.closed && isRaceSignalActive(row.focus, getRaceRowSignalValue(row), Date.now(), row.focusKnown);
        return row;
    }

    function normalizeRaceContext(ctx) {
        if (!ctx || !ctx.race) {
            return ctx;
        }

        ctx.race.forEach(normalizeRaceRow);
        return ctx;
    }

    function getRaceRowByUserId(list, userId) {
        return (list || []).find((row) => row && row.user && row.user.id === userId) || null;
    }

    function getMetaSignalTimestamp(meta, hasSignal) {
        if (!hasSignal || !meta) {
            return '';
        }

        return pickLatestRaceTimestamp(
            pickLatestRaceTimestamp(meta.timeStamp, meta.earnStar),
            meta.earnCup
        );
    }

    function updateRaceRowMeta(row, meta, hasSignal) {
        if (!row || !meta) {
            return row;
        }

        if (Object.prototype.hasOwnProperty.call(meta, 'focus')) {
            const currentFocusChange = parseRaceTimestamp(row.lastFocusChangeAt);
            const incomingChange = parseRaceTimestamp(meta.timeStamp);
            const acceptFocus = currentFocusChange.state !== 'valid' ||
                incomingChange.state !== 'valid' ||
                incomingChange.value >= currentFocusChange.value;

            if (acceptFocus) {
                row.focusKnown = true;
                row.focus = !!meta.focus;
                row.lastFocusChangeAt = pickLatestRaceTimestamp(row.lastFocusChangeAt, meta.timeStamp);
            }
        }
        if (Object.prototype.hasOwnProperty.call(meta, 'closed')) {
            row.closed = !!meta.closed;
        }
        if (meta.topic !== undefined) {
            row.topic = meta.topic;
        }
        if (meta.earnStar) {
            row.lastProgressAt = pickLatestRaceTimestamp(row.lastProgressAt, meta.earnStar);
        }
        row.earnStar = row.lastProgressAt || '';
        if (hasSignal) {
            row.lastRaceSignalAt = pickLatestRaceTimestamp(getRaceRowSignalValue(row), getMetaSignalTimestamp(meta, hasSignal));
        } else if (!row.lastRaceSignalAt && row.lastProgressAt) {
            row.lastRaceSignalAt = row.lastProgressAt;
        }
        row.isRaceActive = !row.closed && isRaceSignalActive(row.focus, getRaceRowSignalValue(row), Date.now(), row.focusKnown);
        return row;
    }

    function getRaceRowVisualState(row, nowValue = Date.now()) {
        const visual = getRaceVisualState(getRaceRowProgressValue(row), nowValue);

        if (visual.invalid && parseRaceTimestamp(getRaceRowProgressValue(row)).state === 'invalid') {
            logInvalidRaceProgress(row && row.user ? row.user.id : '', getRaceRowProgressValue(row));
        }

        return visual;
    }

    function applyRaceVisualStateToRow($row, row, nowValue = Date.now()) {
        const $bar = $row.find('[data-lp-bar]');
        const isActive = !!(row && !row.closed && isRaceSignalActive(row.focus, getRaceRowSignalValue(row), nowValue, row.focusKnown));
        const visual = getRaceRowVisualState(row, nowValue);

        if (row) {
            row.isRaceActive = isActive;
        }
        $row.attr('data-lp-user-last-progress', getRaceRowProgressValue(row) || '');
        $row.attr('data-lp-user-last-signal', getRaceRowSignalValue(row) || '');
        $row.attr('data-lp-user-last-focus-change', row && row.lastFocusChangeAt ? row.lastFocusChangeAt : '');
        $row.attr('data-lp-user-focus', row && row.focus ? 'true' : 'false');
        $row.attr('data-lp-user-focus-known', row && row.focusKnown ? 'true' : 'false');
        $row.attr('data-lp-user-closed', row && row.closed ? 'true' : 'false');
        $row.attr('data-lp-user-active', isActive ? 'true' : 'false');
        $row.toggleClass('row--inactive', !isActive);
        setRaceTimeoutState($row, visual, isActive);
        $bar.css('background-color', '');

        if (!isActive) {
            return;
        }

        if (visual.timeout) {
            return;
        }

        if (visual.color) {
            $bar.css('background-color', visual.color);
        }
    }

    function setRaceTimeoutState($row, visual, active) {
        const timeout = !!(active && visual && visual.timeout);
        const blink = !!(timeout && visual.blink);
        if (blink && !$row.hasClass('row--urgent')) {
            // Keep the pulse phase across worker DOM replacements during busy live updates.
            $row.css('--race-pulse-delay', -(Date.now() % 1500) + 'ms');
        }
        $row.toggleClass('row--timeout', timeout);
        $row.toggleClass('row--urgent', blink);
    }

    function patchRaceRowDom($container, ctx, meta) {
        const row = ctx && ctx.race ? getRaceRowByUserId(ctx.race, meta.userId) : null;
        const $row = $container.find(`[data-lp-user-row="${meta.userId}"]`);
        const $bar = $row.find('[data-lp-bar]');
        let percentage;

        if (!row || !$row.length) {
            return;
        }

        $row.find('.learn-period__chart__i3').text(row.count || 0);
        if ($bar.length && ctx && ctx.max) {
            percentage = Math.max(0, Math.min(100, ((row.count || 0) / ctx.max) * 100));
            $bar.css('width', percentage + '%');
            $row.find('.learn-period__chart__i3').css('width', (100 - percentage) + '%');
        }

        applyRaceVisualStateToRow($row, row);
        updateRaceStarTotal($container, ctx);
    }

    function syncRaceDomState($container, renderCtx) {
        if (!renderCtx || !renderCtx.race) {
            return;
        }

        renderCtx.race.forEach((row) => {
            const $row = $container.find(`[data-lp-user-row="${row.user.id}"]`);

            if ($row.length) {
                applyRaceVisualStateToRow($row, row);
            }
        });

        updateRaceStarTotal($container, renderCtx);
    }

    function updateRaceStarTotal($container, ctx) {
        const total = (ctx && ctx.race ? ctx.race : []).reduce((sum, row) => sum + (Number(row.count) || 0), 0);
        const $star = $container.closest('.learn-period').find('[data-race-star]');

        $star.find('[data-race-star-all]').text(total);
        $star.css('display', total > 0 ? 'inline' : 'none');
    }

    function compareByCountAndName(a, b) {
        const count = (b.count || 0) - (a.count || 0);
        if (count !== 0) {
            return count;
        }

        const aName = (a.user ? a.user.name : a.name) || '';
        const bName = (b.user ? b.user.name : b.name) || '';
        return collator.compare(aName, bName);
    }

    function compareByActualAndName(a, b) {
        return APP.RaceHelpers.compareByDirectProgress(a, b, function (left, right) {
            const aName = left.name || left.title || '';
            const bName = right.name || right.title || '';

            return collator.compare(aName, bName);
        });
    }

    function compareByTopicIndex(a, b) {
        return APP.RaceHelpers.compareByTopicIndex(a, b, function (left, right) {
            return collator.compare(left.title || '', right.title || '');
        });
    }

    function findPeriodWrappers(url) {
        return $body.find('[data-period-wrapper]').filter(function () {
            return $(this).attr('data-period-wrapper') === url;
        });
    }

    function getResolveCallbackKey(topicId, userId) {
        return `${topicId}:${userId}`;
    }

    function getPeriodWrapperKey($wrapper) {
        let key = $wrapper.attr('data-period-wrapper-key');

        if (!key) {
            nextPeriodWrapperKey++;
            key = `period-wrapper-${nextPeriodWrapperKey}`;
            $wrapper.attr('data-period-wrapper-key', key);
        }

        return key;
    }

    function registerPeriodRequest($wrapper) {
        const key = getPeriodWrapperKey($wrapper);
        const sequence = (requestStates[key] || 0) + 1;

        requestStates[key] = sequence;
        return {key, sequence};
    }

    function isLatestPeriodRequest(key, sequence) {
        return requestStates[key] === sequence;
    }

    function addResolveCallback(topicId, userId, callback) {
        const key = getResolveCallbackKey(topicId, userId);

        resolveCallbacks[key] = resolveCallbacks[key] || [];
        resolveCallbacks[key].push(callback);
        return key;
    }

    function runResolveCallbacks(key) {
        const callbacks = resolveCallbacks[key] || [];

        delete resolveCallbacks[key];
        callbacks.forEach((callback) => {
            if (typeof callback === 'function') {
                callback();
            }
        });
    }

    function refreshLearnPeriod(url, topicId, userId) {
        return new Promise((resolve, reject) => {
            const action = () => {
                const requests = [];
                const $wrappers = findPeriodWrappers(url);
                const requestPayload = getStudyRangeRequestData();

                if (!$wrappers.length) {
                    resolve();
                    return;
                }

                $wrappers.each(function () {
                    const $wrapper = $(this);
                    const requestState = registerPeriodRequest($wrapper);

                    requests.push(APP.Ajax.post(url, requestPayload, true).then(function (result) {
                        if (!isLatestPeriodRequest(requestState.key, requestState.sequence)) {
                            return;
                        }

                        if (result.success) {
                            renderLearnPeriod($wrapper, result.period, requestPayload);
                        } else if (isExpectedLearnPeriodNotFound(result)) {
                            handleExpectedLearnPeriodNotFound();
                        } else {
                            return Promise.reject(createLearnPeriodRefreshError(url, topicId, userId, result));
                        }
                    }));
                });

                Promise.all(requests).then(function () {
                    resolve();
                }, function (error) {
                    APP.Error.logError(error, {
                        source: 'APP.Race.refreshLearnPeriodWrappers',
                        context: {
                            topicId: topicId || '',
                            userId: userId || '',
                            url: url
                        }
                    });
                    error.reported = true;
                    reject(error);
                });
            };

            if (topicId && userId) {
                let handled = false;
                let fallbackTimer = null;

                const runAction = () => {
                    if (handled) {
                        return;
                    }

                    handled = true;
                    clearTimeout(fallbackTimer);
                    action();
                };

                addResolveCallback(topicId, userId, runAction);
                fallbackTimer = setTimeout(runAction, 1000);
                return;
            }

            action();
        });
    }

    function isExpectedLearnPeriodNotFound(result) {
        var code = result && result.error && result.error.code;

        return code === 'group_not_found' ||
            code === 'group_filter_user_not_found';
    }

    function handleExpectedLearnPeriodNotFound() {
        if (APP.Page && APP.Page.reloadPageSilence) {
            APP.Page.reloadPageSilence();
        }
    }

    function createLearnPeriodRefreshError(url, topicId, userId, result) {
        const error = new Error('learn-period refresh failed');

        error.learnPeriod = {
            url: url,
            topicId: topicId || '',
            userId: userId || '',
            code: result && result.error && result.error.code || ''
        };
        return error;
    }

    function reportLearnPeriodRefreshError(error) {
        if (error && (error.ajax || error.reported)) {
            return;
        }
        APP.Error.logError(error, {
            source: 'APP.Race.refreshLearnPeriod'
        });
    }

    function refreshRelatedLearnPeriod(url, meta) {
        refreshLearnPeriod(url, meta.topic.id, meta.userId).then(window.NOOP, reportLearnPeriodRefreshError);
    }

    function shouldRefreshRelatedPeriod(found, meta, addStar, addCup, bestExam) {
        return !found &&
            meta.topic &&
            meta.userId &&
            Object.prototype.hasOwnProperty.call(meta, 'focus') &&
            (addStar || addCup || bestExam);
    }

    function markCupState(target, meta) {
        const hadCup = !!(target && (target.cup || target.defaultCup));

        if (!target || !meta || !meta.earnCupType) {
            return false;
        }

        if (meta.earnCupType === 'default-cup') {
            target.defaultCup = true;
        } else {
            target.cup = true;
        }

        return !hadCup && !!(target.cup || target.defaultCup);
    }

    function updateUsers(list, meta, addStar = 0, addCup = 0, bestExam, id) {
        let found = false;

        for (let i = 0; i < list.length; i++) {
            const user = list[i];

            if (user.id !== meta.userId) {
                continue;
            }

            user.focus = !!meta.focus;

            for (let j = 0; j < user.topics.length; j++) {
                const topic = user.topics[j];

                if (meta.topic && meta.topic.id === topic.id) {
                    user.summary = user.summary || {};
                    user.summary.stars = user.summary.stars || 0;
                    user.summary.cups = user.summary.cups || 0;
                    user.summary.stars += addStar;
                    if (addCup > 0 && markCupState(topic, meta)) {
                        user.summary.cups += 1;
                    }
                    topic.counting -= addStar;
                    topic.actual += addStar;
                    found = true;
                }

                if (bestExam && bestExam.topicId === topic.id) {
                    topic.bestExam = bestExam;
                    found = true;
                }
            }

            if (found) {
                user.topics.sort(compareByTopicIndex);
            }

            break;
        }

        if (shouldRefreshRelatedPeriod(found, meta, addStar, addCup, bestExam)) {
            refreshRelatedLearnPeriod(id, meta);
        }

        return list;
    }

    function updateTopics(list, meta, addStar = 0, addCup = 0, bestExam, id) {
        let found = false;

        for (let i = 0; i < list.length; i++) {
            const topic = list[i];
            let topicChanged = false;

            for (let j = 0; j < topic.users.length; j++) {
                const user = topic.users[j];

                if (user.id !== meta.userId) {
                    continue;
                }

                user.focus = !!meta.focus;

                if (meta.topic && meta.topic.id === topic.id) {
                    topic.summary = topic.summary || {};
                    topic.summary.stars = topic.summary.stars || 0;
                    topic.summary.cups = topic.summary.cups || 0;
                    topic.summary.stars += addStar;
                    if (addCup > 0 && markCupState(user, meta)) {
                        topic.summary.cups += 1;
                    }
                    user.counting -= addStar;
                    user.actual += addStar;
                    found = true;
                    topicChanged = true;
                }

                if (bestExam && bestExam.topicId === topic.id) {
                    user.bestExam = bestExam;
                    found = true;
                    topicChanged = true;
                }

                break;
            }

            if (topicChanged) {
                topic.users.sort(compareByActualAndName);
            }
        }

        if (shouldRefreshRelatedPeriod(found, meta, addStar, addCup, bestExam)) {
            refreshRelatedLearnPeriod(id, meta);
        }

        return list;
    }

    function updateRankingList(list, meta, delta) {
        let found = false;

        for (let i = 0; i < list.length; i++) {
            const row = list[i];
            if (row.user.id !== meta.userId) {
                continue;
            }

            row.count += delta;
            found = true;
            break;
        }

        if (!found) {
            list.push({
                _id: {userId: meta.userId},
                count: delta,
                user: {name: meta.userName, id: meta.userId}
            });
        }

        list.sort(compareByCountAndName);
        return list;
    }

    function updateCupsAndStars(list, meta, addStar = 0, addCup = 0) {
        if (addStar > 0) {
            list.allStars += addStar;
            list.averageStars = (list.allStars / list.allUserCount).toFixed(1).replace('.0', '');
            list.sortedStars = updateRankingList(list.sortedStars, meta, addStar);
        }

        if (addCup > 0) {
            list.allCups += addCup;
            list.averageCups = (list.allCups / list.allUserCount).toFixed(1).replace('.0', '');
            list.sortedCups = updateRankingList(list.sortedCups, meta, addCup);
        }

        return list;
    }

    function rememberPresence(userId, payload) {
        const previous = presenceByUser[userId];
        const previousTime = previous && new Date(previous.timeStamp).getTime();
        const incomingTime = new Date(payload.timeStamp).getTime();
        if (previousTime > incomingTime) return null;
        if (payload.presenceMissing) {
            if (!previous || !Object.prototype.hasOwnProperty.call(previous, 'focus') || previousTime >= incomingTime) return null;
            payload = Object.assign({}, previous, {focus: false, closed: true, timeStamp: payload.timeStamp});
        }
        return presenceByUser[userId] = Object.assign({}, previous, payload);
    }

    function renderLearnPeriod($container, ctx, requestedRange, finishReplay = false) {
        const id = $container.attr('data-period-wrapper');
        const renderState = renderStates[id] = renderStates[id] || {};
        const renderRevision = (renderState.revision || 0) + 1;
        const userLastStar = {};
        const userLastCup = {};
        const userBestExam = {};
        const userLastResolve = {};
        let raceSession;

        renderState.revision = renderRevision;
        renderState.inFlight = false;
        renderState.pending = false;
        renderState.nextContext = null;
        clearTimeout(renderTimers[id]);
        clearTimeout(renderMaxTimers[id]);
        renderTimers[id] = null;
        renderMaxTimers[id] = null;
        normalizeRaceContext(ctx);
        if (ctx.race) {
            if (ctx.liveEligible && ctx.presence) Object.keys(ctx.presence).forEach((userId) => {
                rememberPresence(userId, ctx.presence[userId]);
            });
            raceSession = raceSessions[id] = raceSessions[id] || {
                id: id, meta: {}, signals: {}, dirty: false, inFlight: false, timer: null
            };
            raceSession.ctx = ctx;
            raceSession.selectionKey = requestedRange ? getStudyRangeKey(requestedRange) :
                (raceSession.selectionKey || getStudyRangeKey());
            raceSession.lastRefresh = Date.now();
            raceSession.container = $container;
            raceSession.render = renderNow;
            raceSession.schedule = scheduleRender;
            ctx.race.forEach((row) => {
                const meta = presenceByUser[row.user.id] || raceSession.meta[row.user.id];
                if (meta) {
                    raceSession.meta[row.user.id] = meta;
                    if (ctx.liveEligible) updateRaceRowMeta(row, meta, false);
                }
            });
        }

        function isActiveRenderRevision() {
            return renderStates[id] && renderStates[id].revision === renderRevision;
        }

        function afterRender(renderedCtx) {
            if (player && !(finishReplay && renderedCtx === ctx) && playerWrapperId === id && renderedCtx && renderedCtx.race) {
                applyPlayerVisualState($container, renderedCtx);
                return;
            }

            if (finishReplay && renderedCtx.liveEligible) renderedCtx.race.forEach((row) => {
                const meta = presenceByUser[row.user.id];
                if (meta) updateRaceRowMeta(row, meta, false);
            });
            syncRaceDomState($container, renderedCtx);
            if (renderedCtx.race) setPlayerPhase(renderedCtx.liveEligible ? 'live' : 'history');
            checkInactivity();
        }

        function flushScheduledRender() {
            clearTimeout(renderTimers[id]);
            clearTimeout(renderMaxTimers[id]);
            renderTimers[id] = null;
            renderMaxTimers[id] = null;
            requestRender(renderState.nextContext || ctx);
        }

        function renderNow(renderCtx = ctx) {
            let applied = false;
            const generation = playerGeneration;
            const finishing = finishReplay && renderCtx === ctx;
            if (!isActiveRenderRevision()) {
                return Promise.resolve();
            }

            normalizeRaceContext(renderCtx);
            clearTimeout(renderTimers[id]);
            clearTimeout(renderMaxTimers[id]);
            renderTimers[id] = null;
            renderMaxTimers[id] = null;
            renderState.inFlight = true;
            renderState.pending = false;
            renderState.nextContext = null;
            const attempt = renderState.attempt = (renderState.attempt || 0) + 1;

            return APP.ProblemWorker.run('learn-period', renderCtx).then(function (response) {
                if (!isActiveRenderRevision() || renderState.attempt !== attempt || (finishing && generation !== playerGeneration)) {
                    return;
                }

                try {
                    $container.html(response);
                    APP.Formula.fillFormulas();
                    APP.Layout.setMoments();
                    afterRender(renderCtx);
                    applied = true;
                } catch (error) {
                    failRaceRender();
                    APP.Error.logError(error, {
                        source: 'APP.Race.learnPeriodRenderApply',
                        context: {
                            wrapperId: id
                        }
                    });
                }
            }, function (error) {
                if (!isActiveRenderRevision() || renderState.attempt !== attempt || (finishing && generation !== playerGeneration)) return;
                failRaceRender();
                APP.Error.logError(error, {
                    source: 'APP.Race.learnPeriodRender',
                    context: {
                        wrapperId: id
                    }
                });
            }).then(function () {
                if (!isActiveRenderRevision() || renderState.attempt !== attempt || (finishing && generation !== playerGeneration)) {
                    return;
                }

                renderState.inFlight = false;
                if (renderState.pending) {
                    return renderNow(renderState.nextContext || ctx);
                }
                return applied;
            });
        }

        function failRaceRender() {
            if (!ctx.race || !isActiveRenderRevision()) return;
            stopPlayerAnimation();
            setPlayerPhase('error');
            updatePlayerUi();
        }

        function requestRender(renderCtx = ctx) {
            if (!isActiveRenderRevision()) {
                return;
            }

            renderState.nextContext = renderCtx;
            if (renderState.inFlight) {
                renderState.pending = true;
                return;
            }

            renderNow(renderCtx);
        }

        function scheduleRender(renderCtx = ctx) {
            renderState.nextContext = renderCtx;
            renderState.pending = true;
            clearTimeout(renderTimers[id]);
            renderTimers[id] = setTimeout(flushScheduledRender, RENDER_DEBOUNCE_MS);
            if (!renderMaxTimers[id]) {
                renderMaxTimers[id] = setTimeout(function () {
                    logRenderMaxWait(id);
                    flushScheduledRender();
                }, RENDER_MAX_WAIT_MS);
            }
        }

        function updateContextByUserMeta(meta, updateId) {
            if (ctx.race) {
                updateRaceSession(raceSession, meta);
                return;
            }
            let addStar = 0;
            let addCup = 0;
            let addExam = false;
            const earnStar = meta.earnStar;
            const earnCup = meta.earnCup;
            const bestExam = meta.bestExam;
            const checkResolved = meta.checkResolved;
            userLastStar[meta.userId] = userLastStar[meta.userId] || meta.timeStamp;
            if (earnStar && userLastStar[meta.userId] !== earnStar) {
                if (new Date(userLastStar[meta.userId]) < new Date(earnStar)) {
                    addStar++;
                }
                userLastStar[meta.userId] = earnStar;
            }

            userLastCup[meta.userId] = userLastCup[meta.userId] || meta.timeStamp;
            if (earnCup && userLastCup[meta.userId] !== earnCup) {
                if (new Date(userLastCup[meta.userId]) < new Date(earnCup)) {
                    addCup++;
                }
                userLastCup[meta.userId] = earnCup;
            }

            if (bestExam && bestExam.examId && userBestExam[meta.userId] !== bestExam.examId) {
                userBestExam[meta.userId] = bestExam.examId;
                addExam = bestExam;
            }

            if (ctx.users) {
                ctx.users = updateUsers(ctx.users, meta, addStar, addCup, addExam, updateId);
            }
            if (ctx.topics) {
                ctx.topics = updateTopics(ctx.topics, meta, addStar, addCup, addExam, updateId);
            }
            if (ctx.sortedCups && ctx.sortedStars) {
                ctx = updateCupsAndStars(ctx, meta, addStar, addCup);
            }

            if (checkResolved) {
                const separatorIndex = checkResolved.lastIndexOf('-');
                const callbackName = separatorIndex > -1 ? checkResolved.slice(0, separatorIndex) : checkResolved;
                const checkingId = separatorIndex > -1 ? checkResolved.slice(separatorIndex + 1) : '';

                if (userLastResolve[meta.userId] !== checkingId) {
                    runResolveCallbacks(callbackName);
                    userLastResolve[meta.userId] = checkingId;
                }
            }

            scheduleRender();
        }

        onUpdate[id] = updateContextByUserMeta;
        userSubscriptions[id] = userSubscriptions[id] || {};

        if (ctx.userIds) {
            const activeUserIds = {};

            ctx.userIds.forEach((rawUserId) => {
                const userId = String(rawUserId);
                let subscription = userSubscriptions[id][userId];

                activeUserIds[userId] = true;
                if (subscription) {
                    subscription.active = true;
                    return;
                }

                subscription = {
                    active: true
                };
                subscription.callback = function (meta) {
                    const wrapperSubscriptions = userSubscriptions[id];
                    const currentSubscription = wrapperSubscriptions && wrapperSubscriptions[userId];
                    let payload;

                    if (currentSubscription !== subscription) {
                        return;
                    }

                    try {
                        payload = JSON.parse(meta.value || '{}');
                    } catch (error) {
                        APP.Error.logError(error, {
                            source: 'APP.Race.learnPeriodMetaParse',
                            context: {
                                userId: userId,
                                metaKey: meta && meta.key || '',
                                rawValue: meta && meta.value || ''
                            }
                        });
                        return;
                    }

                    payload = rememberPresence(userId, payload);
                    if (!payload) return;
                    if (!currentSubscription.active) return;
                    Object.keys(onUpdate).forEach((key) => {
                        if (typeof onUpdate[key] === 'function') {
                            onUpdate[key](payload, key);
                        }
                    });
                };
                userSubscriptions[id][userId] = subscription;
                APP.Live.subscribeRaceChanges(userId, subscription.callback);
            });

            Object.keys(userSubscriptions[id]).forEach((userId) => {
                if (!activeUserIds[userId]) {
                    userSubscriptions[id][userId].active = false;
                }
            });
        } else if (userSubscriptions[id]) {
            Object.keys(userSubscriptions[id]).forEach((userId) => {
                userSubscriptions[id][userId].active = false;
            });
        }

        if (!ctx.race && player && playerWrapperId === id) {
            clearPlayer();
        }

        if (finishReplay) return renderNow(ctx);
        scheduleRender(player && playerWrapperId === id ? (playerCurrentContext || ctx) : ctx);
    }

    function setPlayerPhase(phase) {
        playerPhase = phase;
        $body.find('[data-player]').attr('data-playback-state', phase);
        updatePlayerBusy();
    }

    function updatePlayerBusy() {
        $body.find('[data-id="player-play-it"]').attr('aria-busy', playerPhase === 'loading' ? 'true' : 'false');
        $body.find('[data-id="player-stop"]').attr('aria-busy', playerPhase === 'catching_up' && isPlaying ? 'true' : 'false');
    }

    function readRaceSnapshot(session, range, includeEvents) {
        const generation = playerGeneration;
        return APP.Ajax.post(session.id, Object.assign({}, range, {includeRaceEvents: includeEvents}), true)
            .then(function (result) {
                if (raceSessions[session.id] !== session || playerGeneration !== generation) return null;
                if (result.success && result.period && Array.isArray(result.period.race) &&
                    (!includeEvents || Array.isArray(result.period.events))) return result.period;
                if (isExpectedLearnPeriodNotFound(result)) {
                    clearPlayer();
                    handleExpectedLearnPeriodNotFound();
                    return null;
                }
                throw createLearnPeriodRefreshError(session.id, null, null, result);
            });
    }

    function queueRaceRefresh(session) {
        if (raceSessions[session.id] !== session || !session.ctx.liveEligible) return;
        session.dirty = true;
        if (session.timer || session.inFlight || player || document.hidden) return;
        session.timer = setTimeout(function () {
            session.timer = null;
            refreshRaceSession(session);
        }, RACE_REFRESH_MS);
    }

    function refreshRaceSession(session) {
        const generation = playerGeneration;
        const range = getStudyRangeRequestData();
        if (raceSessions[session.id] !== session || player) return Promise.resolve();
        session.inFlight = true;
        session.dirty = false;
        return readRaceSnapshot(session, range, false).then(function (ctx) {
            if (!ctx || raceSessions[session.id] !== session || playerGeneration !== generation) return;
            renderLearnPeriod(session.container, ctx, range);
        }).catch(function (error) {
            if (raceSessions[session.id] !== session || playerGeneration !== generation) return;
            setPlayerPhase('error');
            reportLearnPeriodRefreshError(error);
        }).then(function () {
            session.inFlight = false;
            if (session.dirty) queueRaceRefresh(session);
        });
    }

    function updateRaceSession(session, meta) {
        const row = getRaceRowByUserId(session.ctx.race, meta.userId);
        const previous = session.meta[meta.userId];
        const signal = [meta.earnStar || '', meta.earnCup || '', meta.checkResolved || ''].join('|');
        if (!row || raceSessions[session.id] !== session) return;
        if (previous && new Date(previous.timeStamp) > new Date(meta.timeStamp)) return;
        session.meta[meta.userId] = meta;
        if (session.signals[meta.userId] !== signal) {
            session.signals[meta.userId] = signal;
            if (meta.earnStar || meta.earnCup || meta.checkResolved) queueRaceRefresh(session);
        }
        if (player || !session.ctx.liveEligible) return;
        // Socket timestamps cannot identify persisted stars; totals come only from snapshots.
        updateRaceRowMeta(row, meta, !!meta.focus);
        patchRaceRowDom(session.container, session.ctx, meta);
        session.schedule(session.ctx);
    }

    function createPlayerBaseContext(ctx) {
        const baseContext = {
            ...ctx,
            race: (ctx.race || []).map((row) => ({
                ...row,
                user: row.user ? {...row.user} : row.user,
                topic: row.topic ? {...row.topic} : row.topic
            }))
        };

        delete baseContext.events;
        return baseContext;
    }

    function getDateRangeValue(attrName) {
        const range = getPickerRange();

        if (attrName === 'data-date-start') {
            return range.start.isValid() ? range.start.toDate() : null;
        }
        if (attrName === 'data-date-end') {
            return range.end.isValid() ? range.end.toDate() : null;
        }

        return null;
    }

    function getEventTimestamp(event) {
        if (!event) {
            return null;
        }
        if (Number.isFinite(event.ts)) {
            return event.ts;
        }
        if (!event.time) {
            return null;
        }

        const ts = new Date(event.time).getTime();
        if (Number.isNaN(ts)) {
            return null;
        }

        event.ts = ts;
        return ts;
    }

    function getEventDate(event) {
        const ts = getEventTimestamp(event);
        return Number.isFinite(ts) ? new Date(ts) : null;
    }

    function getFrameTime(frameIndex = playerFrame) {
        const start = playerBaseContext && playerBaseContext.rangeStart
            ? new Date(playerBaseContext.rangeStart) : getDateRangeValue('data-date-start');
        if (!extendedEvents.length) {
            return start;
        }
        if (frameIndex <= 0) {
            return start || getEventDate(extendedEvents[0]);
        }

        return getEventDate(extendedEvents[Math.min(frameIndex, extendedEvents.length) - 1]);
    }

    function getFrameTitle(frameIndex = playerFrame) {
        const date = getFrameTime(frameIndex);
        return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '';
    }

    function sortReplayEvents(events) {
        return events.sort((a, b) => {
            const time = getEventTimestamp(a) - getEventTimestamp(b);
            if (time !== 0) {
                return time;
            }
            if (a.type === b.type) {
                return 0;
            }
            return a.type === 'event' ? -1 : 1;
        });
    }

    function normalizePlayerEvents(events) {
        return sortReplayEvents((events || []).map((event) => ({
            id: event.id,
            type: 'event',
            userId: String(event.userId),
            topic: event.topic,
            time: event.time,
            ts: getEventTimestamp(event)
        })).filter((event) => Number.isFinite(event.ts)));
    }

    function stopPlayerAnimation() {
        isPlaying = false;

        if (playerAnimationFrame) {
            cancelAnimationFrame(playerAnimationFrame);
            playerAnimationFrame = null;
        }

        playerLastFrameAt = 0;
    }

    function clearPlayerUi() {
        $body.find('[data-player]').attr('data-player', 'false');
        $body.find('[data-id="player-play-it"]').css('display', '');
        $body.find('[data-id="player"]').attr('data-playing', 'false');
        $body.find('[data-id="player-actual-frame"]').text('0').attr('title', '');
        $body.find('[data-id="player-all-frame"]').text('0');
        $body.find('[data-player]').closest('.learn-period').attr('data-replay-paused', 'false');
    }

    function clearPlayer() {
        stopPlayerAnimation();
        playerGeneration++;
        playerCatchUp = null;
        playerRange = null;
        playerSelectionKey = '';
        playerSnapshotAt = null;

        player = false;
        baseEvents = null;
        extendedEvents = [];
        playerFrame = 0;
        playerBaseContext = null;
        playerCurrentContext = null;
        playerWrapperId = null;
        playerRender = null;
        playerRaceByUserId = {};
        playerStateByUserId = {};

        clearPlayerUi();
        setPlayerPhase('');
    }

    function setUpPlayer(events, ctx, id, renderNow, startAtZero = false) {
        const hasPlayer = !!(events && ctx && ctx.race);

        if (!hasPlayer) {
            if (player && playerWrapperId === id) {
                clearPlayer();
            } else {
                clearPlayerUi();
            }
            return;
        }

        player = true;
        baseEvents = normalizePlayerEvents(events);
        playerBaseContext = createPlayerBaseContext(ctx);
        playerWrapperId = id;
        playerRender = renderNow;
        playerSnapshotAt = ctx.snapshotAt || null;

        stopPlayerAnimation();

        $body.find('[data-player]').attr('data-player', 'true');
        $body.find('[data-id="player-play-it"]').css('display', 'none');
        $body.find('[data-id="player"]').attr('data-playing', 'false');

        extendedEvents = extendEvents(baseEvents);
        playerFrame = startAtZero ? 0 : extendedEvents.length;
        rebuildPlayerContext(playerFrame);
        updatePlayerUi();
    }

    function extendEvents(events) {
        if (!playerBaseContext || !playerBaseContext.race) {
            return events || [];
        }

        const realEvents = events || [];
        const eventsByUser = {};
        const endTime = playerSnapshotAt
            ? new Date(Math.min(new Date(playerSnapshotAt).getTime(), new Date(playerBaseContext.rangeEnd || playerSnapshotAt).getTime()))
            : getDateRangeValue('data-date-end');
        const endTimeTs = endTime ? endTime.getTime() : getEventTimestamp(realEvents[realEvents.length - 1]);
        const timeoutEvents = [];

        playerBaseContext.race.forEach((row) => {
            eventsByUser[String(row.user.id)] = [];
        });

        realEvents.forEach((event) => {
            eventsByUser[event.userId] = eventsByUser[event.userId] || [];
            eventsByUser[event.userId].push(event);
        });

        if (!Number.isFinite(endTimeTs)) {
            return realEvents;
        }

        Object.keys(eventsByUser).forEach((userId) => {
            const userEvents = eventsByUser[userId];

            userEvents.forEach((event, index) => {
                const currentTs = getEventTimestamp(event);
                const nextTs = index + 1 < userEvents.length
                    ? getEventTimestamp(userEvents[index + 1])
                    : endTimeTs;
                [activityThreshold, activityThreshold * 2].forEach((offset) => {
                    const timeoutTs = currentTs + offset;
                    if (timeoutTs <= endTimeTs && timeoutTs < nextTs) {
                        timeoutEvents.push({
                            type: 'timeout', userId,
                            time: new Date(timeoutTs).toISOString(), ts: timeoutTs
                        });
                    }
                });
            });
        });

        return sortReplayEvents(realEvents.concat(timeoutEvents));
    }

    function createPlayerRaceRow(row) {
        return {
            ...row,
            count: 0,
            topic: null,
            earnStar: null,
            lastProgressAt: '',
            lastRaceSignalAt: '',
            focus: false,
            isRaceActive: false
        };
    }

    function resetPlayerContext() {
        if (!playerBaseContext) {
            playerCurrentContext = null;
            playerRaceByUserId = {};
            playerStateByUserId = {};
            return;
        }

        playerRaceByUserId = {};
        playerStateByUserId = {};
        playerCurrentContext = {
            ...playerBaseContext,
            race: playerBaseContext.race.map((row) => {
                const replayRow = createPlayerRaceRow(row);
                const userId = String(replayRow.user.id);

                playerRaceByUserId[userId] = replayRow;
                playerStateByUserId[userId] = {
                    appliedFrames: [],
                    eventFrames: []
                };

                return replayRow;
            })
        };
        playerCurrentContext.max = getRaceMax(playerCurrentContext.race);
    }

    function syncPlayerRow(userId) {
        const row = playerRaceByUserId[userId];
        const state = playerStateByUserId[userId];

        if (!row || !state) {
            return;
        }

        const lastEvent = state.eventFrames.length ? state.eventFrames[state.eventFrames.length - 1] : null;

        row.focus = !!lastEvent;
        row.count = state.eventFrames.length;
        row.topic = lastEvent ? lastEvent.topic : null;
        row.earnStar = lastEvent ? lastEvent.time : null;
        row.lastProgressAt = row.earnStar || '';
        row.lastRaceSignalAt = row.earnStar || '';
        row.isRaceActive = !!lastEvent;
    }

    function applyPlayerFrame(frame, direction = 1) {
        const userId = String(frame.userId);
        const state = playerStateByUserId[userId];

        if (!state) {
            return false;
        }

        if (direction > 0) {
            state.appliedFrames.push(frame);
            if (frame.type === 'event') {
                const previous = state.eventFrames[state.eventFrames.length - 1];
                // Retain the latest progress per step, including when older records arrive late.
                state.eventFrames.push(previous && new Date(previous.time) > new Date(frame.time) ? previous : frame);
            }
        } else {
            const removedFrame = state.appliedFrames.pop();
            if (!removedFrame) {
                return false;
            }
            if (removedFrame.type === 'event') {
                state.eventFrames.pop();
            }
        }

        syncPlayerRow(userId);
        return frame.type === 'event';
    }

    function sortPlayerRace() {
        if (!playerCurrentContext || !playerCurrentContext.race) {
            return;
        }

        playerCurrentContext.race.sort(compareByCountAndName);
        playerCurrentContext.max = getRaceMax(playerCurrentContext.race);
    }

    function rebuildPlayerContext(frameCount = playerFrame) {
        resetPlayerContext();

        let needsSort = false;
        for (let i = 0; i < frameCount; i++) {
            needsSort = applyPlayerFrame(extendedEvents[i], 1) || needsSort;
        }

        if (needsSort) {
            sortPlayerRace();
        }
    }

    function setPlayerFrame(frame) {
        const nextFrame = Math.max(0, Math.min(frame, extendedEvents.length));

        if (!player) {
            return Promise.resolve();
        }

        if (nextFrame === playerFrame && playerCurrentContext) {
            updatePlayerUi();
            return Promise.resolve();
        }

        let needsSort = false;

        if (!playerCurrentContext) {
            rebuildPlayerContext(nextFrame);
        } else if (nextFrame > playerFrame) {
            for (let i = playerFrame; i < nextFrame; i++) {
                needsSort = applyPlayerFrame(extendedEvents[i], 1) || needsSort;
            }
            if (needsSort) {
                sortPlayerRace();
            }
        } else {
            for (let i = playerFrame - 1; i >= nextFrame; i--) {
                needsSort = applyPlayerFrame(extendedEvents[i], -1) || needsSort;
            }
            if (needsSort) {
                sortPlayerRace();
            }
        }

        playerFrame = nextFrame;
        return renderPlayerFrame();
    }

    function updatePlayerUi() {
        updatePlayerBusy();
        $body.find('[data-id="player-actual-frame"]')
            .text(player ? playerFrame : 0)
            .attr('title', player ? getFrameTitle() : '');
        $body.find('[data-id="player-all-frame"]').text(player ? extendedEvents.length : 0);
        $body.find('[data-id="player"]').attr('data-playing', isPlaying ? 'true' : 'false');
        $body.find('[data-player]').attr('data-replay-paused', player && !isPlaying ? 'true' : 'false');
        $body.find('[data-player]').closest('.learn-period')
            .attr('data-replay-paused', player && !isPlaying ? 'true' : 'false');
    }

    function applyPlayerVisualState($container, renderCtx) {
        if (!player || !renderCtx || !renderCtx.race) {
            return;
        }

        const currentTime = getFrameTime();

        renderCtx.race.forEach((row) => {
            const $row = $container.find(`[data-lp-user-row="${row.user.id}"]`);
            const $bar = $row.find('[data-lp-bar]');
            const visual = currentTime ? getRaceRowVisualState(row, currentTime.getTime()) : null;

            setRaceTimeoutState($row, visual, row.focus && row.earnStar);
            $bar.css('background-color', '');

            if (!row.focus || !row.earnStar) {
                return;
            }

            if (!currentTime) {
                return;
            }

            if (visual.timeout) {
                return;
            }

            if (visual.color) {
                $bar.css('background-color', visual.color);
            }
        });

        updateRaceStarTotal($container, renderCtx);
    }

    function renderPlayerFrame() {
        if (!player || !playerRender) {
            return Promise.resolve();
        }

        updatePlayerUi();
        return playerRender(playerCurrentContext);
    }

    function playNextFrame(timestamp) {
        const generation = playerGeneration;
        if (!player || !isPlaying) {
            return;
        }

        if (!playerLastFrameAt) {
            playerLastFrameAt = timestamp;
        }

        if ((timestamp - playerLastFrameAt) < playerFrameDuration) {
            playerAnimationFrame = requestAnimationFrame(playNextFrame);
            return;
        }

        playerLastFrameAt = timestamp;

        if (playerFrame >= extendedEvents.length) {
            reconcilePlayer();
            return;
        }

        setPlayerFrame(playerFrame + 1).then(() => {
            if (generation === playerGeneration && player && isPlaying) {
                playerAnimationFrame = requestAnimationFrame(playNextFrame);
            }
        });
    }

    function playIt() {
        const session = Object.values(raceSessions)[0];
        if (!session || playerPhase === 'loading') return Promise.resolve();
        if (session.selectionKey !== getStudyRangeKey()) return load().then(playIt);
        clearPlayer();
        const generation = playerGeneration;
        player = true;
        playerWrapperId = session.id;
        playerRange = getStudyRangeRequestData();
        playerSelectionKey = getStudyRangeKey(playerRange);
        // Freeze only the replay request, never the selected or persisted filter.
        playerRange.studyRangeAction = 'custom';
        playerRange.studyRangeStart = session.ctx.rangeStart || playerRange.studyRangeStart;
        playerRange.studyRangeEnd = session.ctx.rangeEnd || playerRange.studyRangeEnd;
        clearTimeout(session.timer);
        session.timer = null;
        setPlayerPhase('loading');
        return readRaceSnapshot(session, playerRange, true).then(function (ctx) {
            if (!ctx || generation !== playerGeneration || raceSessions[session.id] !== session) return;
            setUpPlayer(ctx.events, ctx, session.id, session.render, true);
            setPlayerPhase('replay');
            playPause();
        }).catch(function (error) {
            if (generation !== playerGeneration) return;
            clearPlayer();
            setPlayerPhase('error');
            reportLearnPeriodRefreshError(error);
        });
    }

    function reconcilePlayer() {
        const session = raceSessions[playerWrapperId];
        const generation = playerGeneration;
        if (!session || !player || !isPlaying || playerCatchUp) return;
        setPlayerPhase('catching_up');
        session.dirty = false;
        playerCatchUp = readRaceSnapshot(session, playerRange, true).then(function (ctx) {
            if (!ctx || generation !== playerGeneration || !player || !isPlaying) return;
            // One authoritative snapshot ends replay even while the classroom keeps making progress.
            return finishPlayer(session, ctx);
        }).catch(function (error) {
            if (generation !== playerGeneration) return;
            playerCatchUp = null;
            stopPlayerAnimation();
            setPlayerPhase('error');
            updatePlayerUi();
            reportLearnPeriodRefreshError(error);
        });
    }

    function finishPlayer(session, ctx) {
        const generation = playerGeneration;
        const relative = getRelativeStudyRange(getPickerRange().action);
        const rangeChanged = playerSelectionKey !== getStudyRangeKey();
        if (!ctx.liveEligible && !relative) {
            setUpPlayer(ctx.events, ctx, session.id, session.render);
            setPlayerPhase('history');
            playerCatchUp = null;
            return renderPlayerFrame();
        }
        const rendering = renderLearnPeriod(session.container, ctx, undefined, true);
        playerRender = session.render;
        return rendering.then(function (applied) {
            if (generation !== playerGeneration) return;
            playerCatchUp = null;
            if (!applied) return;
            clearPlayer();
            setPlayerPhase(ctx.liveEligible ? 'live' : 'history');
            if (relative && rangeChanged) return load();
            if (session.dirty) queueRaceRefresh(session);
        });
    }

    function playPause() {
        if (!player) {
            return;
        }

        if (isPlaying) {
            stopPlayerAnimation();
            playerGeneration++;
            playerCatchUp = null;
            updatePlayerUi();
            return;
        }

        if (playerFrame >= extendedEvents.length && playerPhase !== 'catching_up' && playerPhase !== 'error') {
            playerFrame = 0;
            rebuildPlayerContext(playerFrame);
        }

        isPlaying = true;
        const generation = playerGeneration;
        setPlayerPhase('replay');
        updatePlayerUi();
        renderPlayerFrame().then(() => {
            if (generation === playerGeneration && player && isPlaying) {
                playerAnimationFrame = requestAnimationFrame(playNextFrame);
            }
        });
    }

    function stop() {
        if (!player) {
            return;
        }

        stopPlayerAnimation();
        playerGeneration++;
        playerCatchUp = null;
        setPlayerPhase('replay');
        setPlayerFrame(0);
    }

    function backward() {
        if (!player) {
            return;
        }

        stopPlayerAnimation();
        playerGeneration++;
        playerCatchUp = null;
        setPlayerFrame(playerFrame - 1);
    }

    function forward() {
        if (!player) {
            return;
        }

        stopPlayerAnimation();
        playerGeneration++;
        playerCatchUp = null;
        setPlayerFrame(playerFrame + 1);
    }

    function checkInactivity() {
        clearTimeout(activityCheckTimeout);
        activityCheckTimeout = setTimeout(checkInactivity, activityCheckRefreshRate);

        if (player) {
            return;
        }

        Object.keys(raceSessions).forEach((id) => {
            const session = raceSessions[id];
            const range = getPickerRange();
            if (getRelativeStudyRange(range.action) && session.selectionKey !== getStudyRangeKey()) {
                load();
            } else if (Date.now() - session.lastRefresh >= RACE_RECONCILE_MS) {
                queueRaceRefresh(session);
            }
        });

        $body.find('[data-lp-user-row]').each(function () {
            const $this = $(this);
            const userId = $this.attr('data-lp-user-row');
            const row = {
                user: {id: userId},
                focus: $this.attr('data-lp-user-focus') === 'true',
                focusKnown: $this.attr('data-lp-user-focus-known') === 'true',
                closed: $this.attr('data-lp-user-closed') === 'true',
                lastFocusChangeAt: $this.attr('data-lp-user-last-focus-change') || '',
                lastProgressAt: $this.attr('data-lp-user-last-progress') || '',
                lastRaceSignalAt: $this.attr('data-lp-user-last-signal') || '',
                isRaceActive: $this.attr('data-lp-user-active') === 'true'
            };

            applyRaceVisualStateToRow($this, row);
        });
    }

    _self.load = load;
    _self.init = init;
    _self.setActivityThreshold = setActivityThreshold;
    _self.getStudyRangeStorageKey = getStudyRangeStorageKey;
    _self.saveStudyRangePreference = saveStudyRangePreference;
    _self.getStudyRangeRequestData = getStudyRangeRequestData;

    return _self;
})();

APP.User = (function () {
    var exports = {},
        initialized = false,
        ref,
        amIPro,
        amLoggedIn,
        $application,
        previousUserId = window.USER_ID,
        previousAmIPro,

        userId = window.USER_ID;

    function init() {
        $application = $body.find('.application');
        initInvitationPageBindings();
        initSubscriptionEmailChecker();

        if (!initialized) {
            previousUserId = userId;
            amIPro = $application.hasClass('user--pro');
            amLoggedIn = $application.hasClass('user--logedin');
            initialized = true;
            initBindings();
            setSettingsCheckbox();
            userId && sendDataToServiceWorker(userId);
        }

        handleUserAccountSwitch();
        if (ref = window.queryDecode()['ref']) {
            setReferral(ref);
        }

        setUTM();
        initReferral();
    }

    function sendDataToServiceWorker(userId) {
        if (navigator.serviceWorker) {
            try {
                return navigator.serviceWorker.register(document.location.origin + '/hu/sw.js')
                    .then(() => sendUserIdToServiceWorker(userId), reportServiceWorkerRegistrationFailure);
            } catch (error) {
                reportServiceWorkerRegistrationFailure(error);
            }
        }
        return Promise.resolve();
    }

    function sendUserIdToServiceWorker(userId) {
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage(userId);
            return Promise.resolve();
        }
        return navigator.serviceWorker.ready.then(registration => {
            if (registration.active) {
                registration.active.postMessage(userId);
            }
        });
    }

    function reportServiceWorkerRegistrationFailure(error) {
        if (APP.Analytics && APP.Analytics.capture) {
            APP.Analytics.capture('service-worker-registration-failed', {
                code: 'service_worker_registration_rejected',
                source: 'APP.User.serviceWorker',
                page: document.location.pathname,
                serviceWorkerSupported: !!navigator.serviceWorker,
                hasController: !!(navigator.serviceWorker && navigator.serviceWorker.controller),
                hasReadyPromise: !!(navigator.serviceWorker && navigator.serviceWorker.ready),
                protocol: document.location.protocol,
                reason: {
                    name: error && error.name || 'Error',
                    message: error && error.message || String(error || 'Unknown service worker registration failure'),
                    code: error && error.code || ''
                }
            });
        }
    }

    function initBindings() {
        $body.on('click', '[data-simple-sign-up-login]', loginFromSimpleSignUp);
        $body.on('click', '[data-simple-sign-up-other-name]', function () {
            var $form = $(this).closest('[data-simple-sign-up]');
            dismissSimpleSignUpDuplicate($form);
            $form.find('[name="name"]').trigger('focus').trigger('select');
        });
        $body.on('input', '[data-simple-sign-up] [name="code"], [data-simple-sign-up] [name="name"]', function () {
            dismissSimpleSignUpDuplicate($(this).closest('[data-simple-sign-up]'));
        });
        $body.on('click', '[data-send-verification-email]', function () {
            APP.Ajax.post('/hu/service/user-verification', {
                id: $(this).attr('data-send-verification-email')
            }, true).then(function (result) {
                APP.Layout.openOverlay(result.success ? 'success-resend' : 'failed-resend');
            });

        });

        $body.on('change', '[data-user-setting-checkbox]', function () {
            var $this = $(this),
                checked = $this.prop('checked');

            setSetting($this.attr('data-user-setting-checkbox'), $this.attr('data-negate') ? !checked : checked);
        });

        $body.on('click', '[data-user-setting-true]', function () {
            var $this = $(this);

            setSetting($this.attr('data-user-setting-true'), true);
        });

        $body.on('click', '[data-activation-submit]', function () {
            APP.Page.applyPageByUrl('/hu/pro/activate/' + $body.find('[data-activation-code]').val())
        });

        $body.on('click', '[data-activate-free]', function () {
            var $this = $(this);

            activateFree($this.attr('data-activate-free'), $this.attr('data-activation-code'));
        });

        $body.on('click', '[data-generate-new-group-code]', function () {
            var $this = $(this),
                id = $this.attr('data-generate-new-group-code');

            APP.Ajax.post('/hu/service/group/new-group-code/' + $this.attr('data-generate-new-group-code'))
                .then(function (result) {
                    if (result.success) {
                        APP.Page.applyPageByUrl('/hu/group/' + id);
                    } else {
                        APP.Layout.openOverlay('generate-new-group-code-error');
                    }
                }, function () {
                    APP.Layout.openOverlay('generate-new-group-code-error');
                });
        });
    }

    function dismissSimpleSignUpDuplicate($form) {
        $form.find('[data-form-error="name"][data-form-error-id="1"]').removeClass('form--error-show');
    }

    function loginFromSimpleSignUp(event) {
        event.preventDefault();
        var $form = $(this).closest('[data-simple-sign-up]'),
            $button = $(this),
            $error = $form.find('[data-form-error="global"]'),
            $controls = $form.find('input:enabled, button:enabled'),
            data = {code: $form.find('[name="code"]').val(), name: $form.find('[name="name"]').val()};

        if ($form.attr('data-login-pending') === 'true') {
            return;
        }
        $form.attr('data-login-pending', 'true');
        $controls.prop('disabled', true);
        $button.addClass('button--loading');
        $error.removeClass('form--error-show');

        function release() {
            $form.removeAttr('data-login-pending');
            $controls.prop('disabled', false);
            $button.removeClass('button--loading');
        }

        function showError(message) {
            release();
            $error.text(message || $form.attr('data-simple-login-error')).addClass('form--error-show');
        }

        APP.Ajax.post('/hu/service/simple/login', data).then(function (result) {
            if (result.success) {
                release();
                exports.successLoggedIn(result);
            } else {
                showError(result.error && result.error.global);
            }
        }, function () {
            showError();
        });
    }

    function setSettingsCheckbox() {
        if (window.USER_SETTINGS) {
            $body.find('[data-user-setting-checkbox]').each(function () {
                var $this = $(this),
                    checked = window.USER_SETTINGS[$this.attr('data-user-setting-checkbox')];

                $this.prop('checked', $this.attr('data-negate') ? !checked : checked);
            });
        }
    }

    function initInvitationPageBindings() {
        if ($body.find('[data-invitation-page]').length > 0) {
            var formOpen = false,
                $accordionForm = $body.find('[data-invitation-accordion="form"]'),
                $accordionMoreItem = $body.find('[data-invitation-accordion="more-item"]'),
                $selectRequestCont = $body.find('[data-invitation-request-count]'),
                $sendRequest = $body.find('[data-invitation-request]'),
                $overlay = $body.find('[data-overlay="use-invitation"]');

            $selectRequestCont.on('change', function () {
                if ($selectRequestCont.val() === '0') {
                    $accordionMoreItem.addClass('open');
                } else {
                    $accordionMoreItem.removeClass('open');
                }
            });

            $sendRequest.on('click', function () {
                if (!formOpen) {
                    formOpen = true;
                    $accordionForm.addClass('open');
                } else {
                    $accordionForm.submit();
                }
            });

            $body.find('[data-use-invitation]').on('click', function () {
                $overlay.addClass('overlay--show');
                $overlay.find('[name="code"]').val($(this).attr('data-use-invitation'));
            });
        }
    }

    function initSubscriptionEmailChecker() {
        var $mailChecker = $body.find('[data-mail-check]'),
            $error = $body.find('[data-form-error="mail-checker"]'),
            oldMail,
            name,
            newMail;

        if ($mailChecker.length > 0) {
            $mailChecker.on('click', function () {
                newMail = $body.find('[data-checking-mail]').val();
                oldMail = decodeURIComponent(window.getCookie('email'));
                name = decodeURIComponent(window.getCookie('name'));
                $error.removeClass('form--error-show');

                APP.Ajax.post('/hu/service/subscribe', {
                    url: window.document.location.pathname,
                    name: name,
                    email: newMail
                }).then(function (result) {
                    if (result.success) {
                        APP.Layout.closeOverlay();
                        if (oldMail === newMail) {
                            APP.Layout.openOverlay('email-not-arrived-3');
                        } else {
                            APP.Layout.openOverlay('email-not-arrived-4');
                        }
                    } else {
                        $error.text(result.error.email);
                        $error.addClass('form--error-show');
                    }
                }, window.NOOP);
            });
        }
    }

    function activateFree(id, code) {
        APP.Ajax.post('/hu/service/pro/activate-free/', {
            id: id,
            code: code
        }).then(function (result) {
            if (result.success) {
                APP.Layout.openOverlay('success-activation');
            } else {
                APP.Layout.openOverlay('failed-activation');
            }
            APP.Layout.onOverlayClose(function () {
                APP.Page.applyPageByUrl('/hu/dashboard');
            });
        }, () => {
            APP.Layout.openOverlay('failed-activation');
        });

    }

    function successInvitationRequest() {
        $body.find('[data-invitation-accordion]').removeClass('open');
        $body.find('[data-invitation-accordion="success"]').addClass('open');
    }

    function successLoggedIn(data) {
        if (data.verified) {
            var pathParts = window.location.pathname.split('/').filter(function (part) {
                return part.length > 0;
            });
            pathParts[0] = data.language;
            window.location.href = '/' + (pathParts.join('/') + '/?login=true');
        } else {
            window.location.href = '/' + data.language + '/user/verify';
        }
    }

    function successEmailModification() {
        window.location.href = '/hu/user/verify';
    }

    function successForgottenEmailAdded() {
        APP.Page.applyPageByUrl('/hu/user/forgotten-password/sent/' + $body.find('[data-forgotten-email]').val());
    }

    function successSignUp() {
        var url = $body.find('[data-success-url]').attr('data-success-url');

        window.setTimeout(function () {
            document.location.href = url;
        }, 100);
    }

    function successSignUpConfirm() {
        window.location.href = '/hu/?signup=true';
    }

    function successInvitationUse() {
        window.location.href = '?invited=true';

    }

    function successDelete() {
        APP.Layout.openOverlay('success-delete-user');
        APP.Layout.onOverlayClose(function () {
            window.location.href = '/hu/?deleted=true';
        });
    }

    function successGroupSubscription() {
        APP.Layout.openOverlay('activate-group-success');
        APP.Layout.onOverlayClose(function () {
            APP.Page.applyPageByUrl('/hu/group/' + $body.find('[name="group-id"]').val());
        });
    }

    function mailSent() {
        APP.Layout.openOverlay('mailSent');
        APP.Layout.onOverlayClose(function () {
            var redirectUrl = $body.find('[data-redirect-url]').val() || '/hu/dashboard';
            APP.Page.applyPageByUrl(redirectUrl);
        });
    }

    function demoBooked() {
        APP.Layout.openOverlay('mailSent');
        APP.Layout.onOverlayClose(function () {
            window.location.reload();
        });
    }

    function trialBooked() {
        APP.Layout.openOverlay('mailSent');
        APP.Layout.onOverlayClose(function () {
            APP.Page.applyPageByUrl('/hu/dashboard');
        });
    }

    function successAndReload() {
        window.location.reload();
    }

    function successComment() {
        APP.Layout.closeOverlay();
        APP.Layout.alert($body.find('[data-comment-succes-message]').attr('data-comment-succes-message'));
        $body.find('[data-overlay="problem-comment"] textarea[name="comment"]').val('');
    }

    function successAlert() {
        APP.Layout.alert($body.find('[data-succes-message]').attr('data-succes-message'));
    }

    function successPassReset() {
        APP.Layout.openOverlay('success-pass-reset');
        APP.Layout.onOverlayClose(function () {
            document.location.href = '/hu/';
        });
    }

    function successUserSettings() {
        APP.Layout.openOverlay('success-user-settings');
        APP.Layout.onOverlayClose(() => APP.Page.refreshPage(true));
    }

    function successPhoneSettings() {
        document.location.href = '/?signup=true';
    }

    function setSetting(property, value) {
        window.USER_SETTINGS[property] = value;
        setSettingsCheckbox();
        APP.Analytics.trackEvent('userSettins', 'set', property, value);
        if (property === 'proHeader') {
            if (value === true) {
                $body.find('[data-header]').addClass('header--pro');
            } else {
                $body.find('[data-header]').removeClass('header--pro');
            }
        }
        return APP.Ajax.post('/hu/service/user-set-settings', {
            key: property,
            value: value
        }, true);
    }

    function setReferral(referral) {
        window.setCookie('referral', encodeURIComponent(referral));
    }

    function setUTM() {
        var utm = {},
            hasUTM = false,
            query = window.queryDecode();

        Object.keys(query).forEach(function (key) {
            if (key.indexOf('utm') === 0) {
                utm[key] = query[key];
                hasUTM = true;
            }
        });

        if (hasUTM) {
            window.setCookie('UTM', encodeURIComponent(JSON.stringify(utm)));
        }
    }

    function initReferral() {
        $body.find('[data-referral-id]').val(window.getCookie('referral'));
        $body.find('[data-utm]').val(decodeURIComponent(window.getCookie('UTM')));
    }

    function successPreRegistration(data) {
        APP.Page.applyPageByUrl(
            '/hu/user/sign-up/select-plan/' +
            window.base64Encode(JSON.stringify(data))
        );
    }

    function setUserPro(isPro, hasNotified) {
        previousAmIPro = amIPro;
        amIPro = isPro;
        window.IS_USER_PRO = isPro;

        if (!hasNotified && isPro) {
            APP.Layout.openOverlay('pro-activated');
            APP.Layout.onOverlayClose(function () {
                APP.Ajax.post('/hu/service/user/state-change', {
                    method: 'notified-pro'
                }, true);
            });
        }
    }

    window.setUserPro = setUserPro;

    function handleUserProChange() {
        if (amIPro) {
            $application.addClass('user--pro');
        } else {
            $application.removeClass('user--pro');
            APP.Layout.openOverlay('pro-deactivated');
        }
    }

    function handleUserAccountSwitch() {
        var actualUserId = $body.find('[data-akriel-user-id]').attr('data-akriel-user-id');

        if (actualUserId !== previousUserId) {
            previousUserId = actualUserId;
            if (actualUserId.length > 0) {
                if (amLoggedIn) {
                    APP.Layout.openOverlay('user-account-logged-in-other-user');
                    APP.Layout.onOverlayClose(function () {
                        document.location.reload();
                    });
                }
            } else {
                APP.Layout.openOverlay('user-account-logged-out');
                APP.Layout.onOverlayClose(function () {
                    document.location.reload();
                });
            }
        } else if (actualUserId === previousUserId && previousAmIPro !== amIPro && previousAmIPro !== undefined) {
            handleUserProChange();
        }
    }

    window.setUserSetting = setSetting;

    exports = {
        init: init,
        setSetting: setSetting,
        successLoggedIn: successLoggedIn,
        successSignUp: successSignUp,
        successSignUpConfirm: successSignUpConfirm,
        successInvitationRequest: successInvitationRequest,
        successInvitationUse: successInvitationUse,
        successAndReload: successAndReload,
        successComment: successComment,
        successAlert: successAlert,
        successPassReset: successPassReset,
        successUserSettings: successUserSettings,
        successPhoneSettings: successPhoneSettings,
        successPreRegistration: successPreRegistration,
        successEmailModification: successEmailModification,
        successForgottenEmailAdded: successForgottenEmailAdded,
        setUserPro: setUserPro,
        successDelete: successDelete,
        successGroupSubscription: successGroupSubscription,
        mailSent: mailSent,
        demoBooked: demoBooked,
        trialBooked: trialBooked
    };

    return exports;

})();

APP.Decor = (function () {
    var exports = {},
        initialized = false,
        targetX = 0,
        targetY = 0,
        map = {
            s1: {
                x: 0,
                y: 0
            },
            s2: {
                x: 0,
                y: 0
            },
            s3: {
                x: 0,
                y: 0
            },
            s4: {
                x: 0,
                y: 0
            }
        },
        w = window.innerWidth,
        h = window.innerHeight,
        scrollTimer,
        $gifImages;

    function init() {
        w = window.innerWidth;
        h = window.innerHeight;
        map.s1.e = $body.find('.decoration--active .decoration__bg--1');
        map.s2.e = $body.find('.decoration--active .decoration__bg--2');
        map.s3.e = $body.find('.decoration--active .decoration__bg--3');
        map.s4.e = $body.find('.decoration--active .decoration__bg--4');

        if (!initialized) {
            initialized = true;
            animate();
            initBindings();
        } else {
            $gifImages = $body.find('img[data-bg]');
            setVisibility();
        }
    }

    function initBindings() {
        document.addEventListener('mousemove', function (event) {
            var x = event.clientX - (w / 2),
                y = event.clientY - (h / 2);
            targetX = x * 0.21;
            targetY = y * 0.21;
        });

        $body.on('click', '[data-splash] [data-more-testimonial]', function () {
            $(this).hide();
            $body.find('[data-hidden-testiomonials]').show();
        });

        bindVisibility();
    }

    function bindVisibility() {
        $gifImages = $body.find('img[data-bg]');
        $window.on('scroll.decor', setVisibility);
        setVisibility();
    }

    function setVisibility() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
            $gifImages.each(function () {
                var $this = $(this);
                if ($this.visible(true)) {
                    $this.removeClass('passive');
                } else {
                    $this.addClass('passive');
                }
            });
        }, 80);
    }

    function animate() {
        var originalS4 = map.s4.y;

        map.s4.x += (targetX - map.s4.x) / 9;
        map.s4.y += (targetY - map.s4.y) / 9;
        if (originalS4.toFixed(3) !== map.s4.y.toFixed(3)) {
            map.s1.x += (targetX - map.s1.x) / 6;
            map.s1.y += (targetY - map.s1.y) / 6;
            map.s2.x += (targetX - map.s2.x) / 7;
            map.s2.y += (targetY - map.s2.y) / 7;
            map.s3.x += (targetX - map.s3.x) / 8;
            map.s3.y += (targetY - map.s3.y) / 8;
            updateStyle();
        }
        window.requestAnimationFrame(animate);
    }

    function updateStyle() {
        if (map.s1.e.length > 0) {
            map.s1.e.css('transform', 'translate3d(' + (0 - map.s1.x) + 'px, ' + (0 - map.s1.y) + 'px, 0)');
            map.s2.e.css('transform', 'translate3d(' + (0 - map.s2.x) + 'px, ' + (0 - map.s2.y) + 'px, 0)');
            map.s3.e.css('transform', 'translate3d(' + (0 - map.s3.x) + 'px, ' + (0 - map.s3.y) + 'px, 0)');
            map.s4.e.css('transform', 'translate3d(' + (0 - map.s4.x) + 'px, ' + (0 - map.s4.y) + 'px, 0)');
        }
    }

    exports.init = init;
    return exports;

})();
APP.Error = (function () {
    var TRANSIENT_NETWORK_EVENT = 'client-transient-network-condition',
        TRANSIENT_RESOURCE_LOAD_FAILURE = 'transient_resource_load_failure',
        THIRD_PARTY_RECAPTCHA_FAILURE = 'third_party_recaptcha_failure',
        THIRD_PARTY_AWS_RUM_FAILURE = 'third_party_aws_rum_failure',
        BOOTSTRAP_ASSET_SOURCES = {
            fonts: true,
            stylesheets: true
        },
        RESOURCE_ERROR_TAGS = {
            AUDIO: true,
            EMBED: true,
            IFRAME: true,
            IMG: true,
            LINK: true,
            OBJECT: true,
            SCRIPT: true,
            SOURCE: true,
            TRACK: true,
            VIDEO: true
        },
        initialized = false,
        exports = {},
        $offlineNotification,
        $serverConnectionNotification,
        serverConnectionLost = false,
        serverConnectionContext = {},
        lastConnectivityStatus = '';

    function init() {
        if (!initialized) {
            initialized = true;
            $offlineNotification = $body.find('.offline-notification');
            $serverConnectionNotification = $body.find('.server-connection-notification');
            window.addEventListener('error', function (e) {
                logError(e, {
                    source: 'window.error',
                    skipLoadedSdkPostHogCapture: true
                });
                return false;
            });
            window.addEventListener('unhandledrejection', function (e) {
                logError(e, {
                    source: 'window.unhandledrejection',
                    skipLoadedSdkPostHogCapture: true
                });
                return false;
            });
            window.addEventListener('online', function () {
                updateConnectivityStatus('browser-online');
            });
            window.addEventListener('offline', function () {
                updateConnectivityStatus('browser-offline');
            });
            flushBootstrapErrors();
            checkOnLineStatus();
        }
    }

    function flushBootstrapErrors() {
        var errors = window.AKRIEL_BOOTSTRAP_ERRORS || [];

        window.AKRIEL_BOOTSTRAP_ERRORS = [];
        errors.forEach(function (item) {
            var error = new Error(item.message || 'Unknown bootstrap error');

            error.stack = item.stack || error.stack;
            logError(error, {
                source: 'bootstrap',
                context: item.context || {}
            });
        });
    }

    function checkOnLineStatus() {
        updateConnectivityStatus('poll');
        setTimeout(checkOnLineStatus, 1000);
    }

    function setNotificationVisible($notification, className, visible) {
        if (!$notification || !$notification.length) {
            return;
        }
        if (visible) {
            $notification.addClass(className);
        } else {
            $notification.removeClass(className);
        }
    }

    function reportConnectivityStatus(status, source, context) {
        var payload,
            pageType = document.querySelector('[name="akriel-page-type"]');

        if (status === lastConnectivityStatus) {
            return;
        }
        payload = mergeContext({
            status: status,
            previousStatus: lastConnectivityStatus,
            source: source || '',
            online: !!window.navigator.onLine,
            serverConnectionLost: !!serverConnectionLost,
            pageType: pageType && pageType.getAttribute('content') || ''
        }, context || {});
        lastConnectivityStatus = status;
        if (APP.Analytics && APP.Analytics.capture) {
            APP.Analytics.capture('client-connectivity-status-change', payload);
        }
        if (window.__AK_TEST_EVENTS__) {
            window.__AK_TEST_EVENTS__.push({
                event: 'client-connectivity-status-change',
                properties: payload
            });
        }
    }

    function updateConnectivityStatus(source, context) {
        var offline = !window.navigator.onLine,
            showServerConnectionLost = !offline && serverConnectionLost,
            status = offline ? 'offline' : (showServerConnectionLost ? 'server-connection-lost' : 'online');

        setNotificationVisible($offlineNotification, 'offline-notification--show', offline);
        setNotificationVisible($serverConnectionNotification, 'server-connection-notification--show', showServerConnectionLost);
        reportConnectivityStatus(status, source, context || (showServerConnectionLost ? serverConnectionContext : {}));
    }

    function reportServerConnectionLost(isLost, context) {
        serverConnectionLost = !!isLost;
        serverConnectionContext = serverConnectionLost ? (context || {}) : {};
        updateConnectivityStatus(context && context.source || 'server-connection', context);
    }

    function normalizeError(error) {
        var normalized,
            message;

        if (error && error.error instanceof Error) {
            return error.error;
        }
        if (error && error.reason instanceof Error) {
            return error.reason;
        }
        if (error instanceof Error) {
            return error;
        }

        message = getErrorMessage(error);
        normalized = new Error(message);
        if (error && error.filename) {
            normalized.fileName = error.filename;
        }
        if (error && error.lineno) {
            normalized.lineNumber = error.lineno;
        }
        if (error && error.colno) {
            normalized.columnNumber = error.colno;
        }
        return normalized;
    }

    function getErrorMessage(error) {
        if (typeof error === 'string') {
            return error;
        }
        if (error && error.message) {
            return error.message;
        }
        if (error && error.reason) {
            return 'Unhandled promise rejection: ' + getErrorMessage(error.reason);
        }
        if (error && error.type) {
            return error.type;
        }
        return 'Unknown client error';
    }

    function getErrorContext(error, normalizedError, options) {
        var context = {
            url: document.location.href,
            message: normalizedError.message,
            source: options && options.source || normalizedError.source || '',
            filename: error && error.filename || normalizedError.fileName || '',
            lineno: error && error.lineno || normalizedError.lineNumber || '',
            colno: error && error.colno || normalizedError.columnNumber || '',
            type: error && error.type || '',
            target: error && error.target && error.target.tagName || '',
            resourceUrl: getTargetResourceUrl(error)
        };

        if (normalizedError.ajax) {
            context.ajax = normalizedError.ajax;
        }
        if (normalizedError.learnPeriod) {
            context.learnPeriod = normalizedError.learnPeriod;
        }
        if (normalizedError.clientContext) {
            context.clientContext = normalizedError.clientContext;
        }
        if (options && options.context) {
            context.clientContext = mergeContext(context.clientContext, options.context);
        }
        return context;
    }

    function getTargetResourceUrl(error) {
        var target = error && error.target;

        return target && (
            target.currentSrc ||
            target.src ||
            target.href ||
            target.data ||
            ''
        ) || '';
    }

    function mergeContext(a, b) {
        var merged = {},
            key;

        a = a || {};
        b = b || {};
        for (key in a) {
            if (a.hasOwnProperty(key)) {
                merged[key] = a[key];
            }
        }
        for (key in b) {
            if (b.hasOwnProperty(key)) {
                merged[key] = b[key];
            }
        }
        return merged;
    }

    function errorToString(error) {
        var object = {};

        if(typeof error === 'string') {
            return error;
        }

        try {
            Object.getOwnPropertyNames(error).forEach(function (key) {
                object[key] = error[key];
            });
            return JSON.stringify(object);
        } catch (e) {
            return error && error.toString();
        }
    }

    function shouldCapturePostHogException(options) {
        return window.posthog &&
            window.posthog.captureException &&
            !(options && options.skipLoadedSdkPostHogCapture && window.posthog.__loaded);
    }

    function getTransientNetworkClassification(error, context, options) {
        if (isBootstrapAssetFailure(context) || isResourceLoadEvent(error, options)) {
            return {
                code: TRANSIENT_RESOURCE_LOAD_FAILURE
            };
        }
        if (isRecaptchaFailure(error, context)) {
            return {
                code: THIRD_PARTY_RECAPTCHA_FAILURE
            };
        }
        if (isAwsRumFailure(error, context)) {
            return {
                code: THIRD_PARTY_AWS_RUM_FAILURE
            };
        }
        return null;
    }

    function isBootstrapAssetFailure(context) {
        return context.source === 'bootstrap' &&
            context.clientContext &&
            BOOTSTRAP_ASSET_SOURCES[context.clientContext.source];
    }

    function isResourceLoadEvent(error, options) {
        return options &&
            options.source === 'window.error' &&
            error &&
            error.target &&
            RESOURCE_ERROR_TAGS[String(error.target.tagName || '').toUpperCase()] &&
            !(error.error instanceof Error);
    }

    function isRecaptchaFailure(error, context) {
        var stackFrames;

        if (isStructuredRecaptchaContext(context)) {
            return true;
        }
        stackFrames = getStackFrameLines(getErrorStack(error));
        if (stackFrames.some(isAkrielApplicationFrame)) {
            return false;
        }
        return isRecaptchaScriptUrl(context.filename) ||
            isRecaptchaScriptUrl(context.resourceUrl) ||
            isRecaptchaScriptUrl(getErrorStack(error));
    }

    function isStructuredRecaptchaContext(context) {
        return context.clientContext &&
            context.clientContext.thirdParty === 'google-recaptcha';
    }

    function isRecaptchaScriptUrl(value) {
        value = String(value || '');
        return value.indexOf('://www.google.com/recaptcha/') !== -1 ||
            value.indexOf('://www.gstatic.com/recaptcha/') !== -1;
    }

    function isAwsRumFailure(error, context) {
        var stackFrames = getStackFrameLines(getErrorStack(error)),
            topFrame = stackFrames[0] || '';

        return (topFrame ? isAwsRumScriptUrl(topFrame) : isAwsRumScriptUrl(context.filename)) &&
            !stackFrames.some(isAkrielApplicationFrame);
    }

    function isAwsRumScriptUrl(value) {
        value = String(value || '');
        return value.indexOf('://client.rum.') !== -1 &&
            value.indexOf('.amazonaws.com/') !== -1 &&
            value.indexOf('/cwr.js') !== -1;
    }

    function isAkrielApplicationFrame(value) {
        value = String(value || '');
        return value.indexOf('cdn.akriel.io') !== -1 ||
            value.indexOf('/static/') !== -1 ||
            value.indexOf('build/src/js/app/') !== -1 ||
            value.indexOf('build/src/js/worker/') !== -1 ||
            value.indexOf('app.hu.js') !== -1 ||
            value.indexOf('app.en.js') !== -1 ||
            value.indexOf('worker.hu.js') !== -1 ||
            value.indexOf('worker.en.js') !== -1;
    }

    function getErrorStack(error) {
        if (error && error.error instanceof Error) {
            return error.error.stack;
        }
        if (error && error.reason instanceof Error) {
            return error.reason.stack;
        }
        if (error instanceof Error) {
            return error.stack;
        }
        return '';
    }

    function getStackFrameLines(stack) {
        return String(stack || '').split('\n').filter(isStackFrameLine);
    }

    function isStackFrameLine(line) {
        line = String(line || '');
        return line.indexOf('    at ') === 0 ||
            line.indexOf('\tat ') === 0 ||
            line.indexOf('at ') === 0 ||
            line.indexOf('@http') !== -1 ||
            line.indexOf('@webpack://') !== -1 ||
            line.indexOf('://') === 0 ||
            line.indexOf('webpack://') === 0;
    }

    function reportTransientNetworkCondition(normalizedError, context, classification) {
        if (window.posthog && window.posthog.capture) {
            window.posthog.capture(TRANSIENT_NETWORK_EVENT, {
                code: classification.code,
                source: context.source,
                url: context.url,
                message: normalizedError.message,
                filename: context.filename,
                type: context.type,
                target: context.target,
                resourceUrl: context.resourceUrl,
                context: context.clientContext || {}
            });
        }
    }

    function logError(error, options) {
        var normalizedError = normalizeError(error),
            context = getErrorContext(error, normalizedError, options),
            classification = getTransientNetworkClassification(error, context, options || {});

        if (normalizedError.reported && options && options.skipLoadedSdkPostHogCapture) {
            return;
        }
        normalizedError.reported = true;
        if (classification) {
            reportTransientNetworkCondition(normalizedError, context, classification);
            return;
        }
        console.error('> error', normalizedError);
        APP.Ajax.post('/hu/service/log-client-error', {
            error: errorToString(normalizedError),
            url: document.location.href,
            context: context
        }, true).then(window.NOOP, window.NOOP);
        if (shouldCapturePostHogException(options)) {
            window.posthog.captureException(normalizedError, context);
        }
    }

    exports.init = init;
    exports.logError = logError;
    exports.normalizeError = normalizeError;
    exports.errorToString = errorToString;
    exports.reportServerConnectionLost = reportServerConnectionLost;
    return exports;

})();

APP.Learn = (function () {
    var exports = {},
        initialized = false,
        $answerOverlay,
        $answersWrapper,
        $learnDataWrapper,
        isChecking,
        soundFiles = [
            'show-star',
            'show-medal',
            'show-cup',
            'hide-star',
            'hide-medal',
            'hide-cup',
            'okay',
            'fail'
        ],
        sounds = {},
        preCheckResult,
        lastSolution,
        loadingData = false,
        topOffset = 60;

    var hasFailed = false;

    function init() {
        $answerOverlay = $body.find('[data-overlay="learn-answer"]');
        $answersWrapper = $body.find('[data-previous-good-answers]');
        $learnDataWrapper = $body.find('[data-load-learn-data]');
        if ($answerOverlay.length > 0) {
            initSounds();
        }
        initBindings();
        initialized = true;
        lastSolution = false;
        formulaCommentPhase(false);
        // APP.Formula.fillFormulas();

        if ($learnDataWrapper.length > 0) {
            requestAnimationFrame(() => {
                loadDataPage($learnDataWrapper);
            });
        } else {
            afterLoadInit();
        }

        if ($body.find('[name="question-id"]').length > 0) {
            preCheckProblem($body.find('[name="question-id"]').val());
        }

        requestAnimationFrame(function () {
            if ($body.find('[data-auto-input-scroll-top]').length > 0) {
                APP.Layout.scrollTo($body.find('[data-auto-input-scroll-top]').offset().top - topOffset, 0);
            }
            if ($body.find('[data-auto-open-input]').length > 0) {
                APP.Calculator.Keyboard.focus();
            }
        });

    }

    function afterLoadInit() {
        if (window.location.hash) {
            var hash = window.location.hash,
                $anchorElement = $body.find('[data-learn-anchor="' + hash.replace('#', '') + '"]');

            if (hash.indexOf('#topic-') === 0) {
                $anchorElement = $body.find('[data-topic-card="' + hash.replace('#topic-', '') + '"]');
            }

            if ($anchorElement && $anchorElement.offset()) {
                requestAnimationFrame(function () {
                    APP.Layout.scrollTo($anchorElement.offset().top - topOffset, 0);
                });
            }
        }
        $body.find('[data-doodle-formula-preview]').html(
            '<div data-f="' + $body.find('[data-learn-sample]').attr('data-f') + '"><div data-f-content></div></div>'
        );
    }

    function initBindings() {
        $body.find('[data-learn]').on('click', function (event) {
            var $this = $(this),
                solutions = $this.attr('data-learn-solutions');

            event.stopPropagation();
            event.preventDefault();

            if (solutions === '_' || solutions === '_0') {
                $body.find('[data-no-solution-link]').attr('href', '/hu/learn/question/' + $this.attr('data-learn'));
                APP.Layout.openOverlay('no-solution');
            } else if (solutions) {
                loadSolutions($this);
            } else {
                APP.Page.applyPageByUrl('/hu/learn/question/' + $this.attr('data-learn'));
            }
        });

        $body.find('[data-learn-send]').on('click', function () {
            var input = $body.find('[data-learn-input]').attr('data-value');

            if (input !== '[]') {
                checkProblem(
                    $body.find('[name="question-id"]').val(),
                    input
                );
            } else {
                APP.Layout.openOverlay('empty-learn-input');
            }
        });

        $body.find('[data-learn-cta-resolve]').on('click', function () {
            checkProblem($body.find('[name="question-id"]').val(), $(this).attr('data-learn-cta-resolve'));
        });

        $body.find('[data-learn-cta]').on('click', function () {
            APP.Layout.onOverlayClose(window.NOOP);
        });

        $body.find('[data-learn-fail]').on('click', giveUp);
        $body.find('[data-reset-learn-tree]').on('click', cutLearnTree);

        if ($body.find('[data-search-select]').length) {
            APP.Form.searchSelect($body.find('[data-search-select]')[0]);
            if ($body.find('[data-goto-topic][data-search-select]').length) {
                $body.find('[data-goto-topic][data-search-select]')[0].addEventListener(
                    'choice', function () {
                        APP.Page.applyPageByUrl('/hu/learn/topic/' + $(this).val());
                    }, false
                );
            }
        }

        $body.find('[data-custom-select]').each(function () {
            APP.Form.customSelect(this);
        });

        $body.find('[data-goto-anchor]').on('click', function () {
            var $this = $(this),
                $anchorElement = $body.find('[data-learn-anchor="' + $this.attr('data-goto-anchor') + '"]');

            if ($anchorElement.offset()) {
                APP.Layout.scrollTo($anchorElement.offset().top - topOffset, 0);
            } else if (loadingData) {
                document.location.hash = $this.attr('data-goto-anchor');
                $anchorElement = $body.find('[data-load-learn-data]');
                if ($anchorElement && $anchorElement.offset()) {
                    requestAnimationFrame(function () {
                        APP.Layout.scrollTo($anchorElement.offset().top - topOffset, 0);
                    });
                }
            } else {
                APP.Page.applyPageByUrl('/hu/learn#' + $this.attr('data-goto-anchor'));
            }
        });

        $body.find('[data-show-topic-after]').on('click', function () {
            $(this).hide();
            $body.find('[data-topic-after]').removeClass('newsfeed__item--hide');
        });

        $body.find('[data-hide-topic-after]').on('click', function () {
            $body.find('[data-show-topic-after]').show();
            $body.find('[data-topic-after]').addClass('newsfeed__item--hide');
        });

        $body.find('[data-show-topic-before]').on('click', function () {
            $(this).hide();
            $body.find('[data-topic-before]').removeClass('newsfeed__item--hide');
        });

        $body.find('[data-hide-topic-before]').on('click', function () {
            $body.find('[data-show-topic-before]').show();
            $body.find('[data-topic-before]').addClass('newsfeed__item--hide');
        });

        if (!initialized) {
            $body.on('click', '[data-focus-input]', function () {
                $body.find('[data-calculator-focus-hunter]').focus();
            });

            $body.on('click', '.newsfeed-button--short', function () {
                $body.find('.newsfeed').attr('class', 'newsfeed newsfeed--short');
                APP.Layout.scrollTo(0, 200);
            });

            $body.on('click', '.newsfeed-button--long', function () {
                $body.find('.newsfeed').attr('class', 'newsfeed newsfeed--long');
                APP.Layout.scrollTo(0, 200);
            });

            $body.on('click', '[data-solutions]', function (e) {
                e.stopPropagation();
                e.preventDefault();
                APP.Page.applyPageByUrl($(this).parents('a').attr('href') + '?solutions=true');
            });

            $body.on('click', '[data-question-copy]', function (e) {
                APP.Calculator.Keyboard.paste($(this).attr('data-question-copy'));
            });

            $body.on('click', '[data-open-comment]', function () {
                $body.find('[data-dashboard-input]').hide();
                $body.find('[data-prime-box]').hide();
                $body.find('[data-comment-box]').show();
                $body.find('[data-comment]').val('').focus();
            });

            $body.on('click', '[data-open-formula-comment]', function () {
                formulaCommentPhase(true);
            });

            $body.on('click', '[data-close-formula-comment]', function () {
                formulaCommentPhase(false);
            });

            $body.on('click', '[data-open-doodle-comment]', function () {
                APP.Doodle.newDoodle();
                APP.Doodle.openDoodleInput();
                APP.Doodle.onDoodled(function (doodleId) {
                    $body.find('[data-previous-good-answers-wrapper]').show();
                    $answersWrapper.append($(APP.Tpl.run('exam-solution', {
                        index: $answersWrapper.first().find('> [data-exam-answer]').length,
                        type: 'comment-doodle',
                        display: doodleId
                    })));
                });
            });

            $body.on('click', '[data-close-comment]', function () {
                $body.find('[data-dashboard-input]').show();
                $body.find('[data-comment-box]').hide();
                $body.find('[data-prime-box]').hide();
            });

            $body.on('click', '[data-submit-comment]', function () {
                var type = $(this).attr('data-submit-comment'),
                    comment = type === 'comment-formula' ?
                        $body.find('[data-learn-input]').attr('data-value') :
                        $body.find('[data-comment]').val();

                saveComments(type, comment, function (result) {
                    var $formula = $('<div class="formula-flack" />');

                    if (result.success) {
                        $body.find('[data-previous-good-answers-wrapper]').show();
                        if (type === 'comment-formula') {
                            $formula.html('<div data-f="' + result.comment + '"><div data-f-content></div></div>');
                            formulaCommentPhase(false);
                        } else {
                            $formula.text(comment);
                        }
                        $answersWrapper.append($formula);
                        APP.Formula.fillFormulas();
                        $body.find('[data-dashboard-input]').show();
                        $body.find('[data-comment-box]').hide();
                        $body.find('[data-prime-box]').hide();
                    }
                });
            });
        }
    }

    function loadDataPage($wrapper) {
        loadingData = true;
        if (window.location.hash) {
            var $anchorElement = $body.find('[data-load-learn-data]');
            if ($anchorElement && $anchorElement.offset()) {
                requestAnimationFrame(function () {
                    APP.Layout.scrollTo($anchorElement.offset().top - topOffset, 0);
                });
            }
        }

        APP.Ajax.post('/hu/learn/data', null, true).then(function (result) {
            if (result.success) {
                APP.ProblemWorker.run('learn-data', result.result).then(function (html) {
                    $wrapper.html(html);
                    afterLoadInit();
                    loadingData = false;
                });
            } else {
                APP.Layout.alert(window.TXT['learn_error.error'], false);
            }
        }, function () {
            APP.Layout.alert(window.TXT['learn_error.error'], false);
        });
    }

    function saveComments(type, comment, callback) {
        APP.Ajax.post('/hu/learn/post-comment', {
            questionId: $body.find('[name="question-id"]').val(),
            historyId: $body.find('[name="lesson-history-id"]').val(),
            data: {
                type: type || 'text',
                content: comment
            }
        }).then(function (result) {
            callback && callback(result);
        }, window.NOOP);
    }

    function initSounds() {
        var i;

        if (window.Audio) {
            for (i = 0; i < soundFiles.length; i++) {
                sounds[soundFiles[i]] = sounds[soundFiles[i]] || new Audio(CDN.sound + soundFiles[i] + '.mp3');
            }
        }
    }

    function loadSolutions($element) {
        if ($element.hasClass('opened-solutions')) {
            $element.removeClass('opened-solutions');
            $element.next().remove();
        } else {
            $element.addClass('opened-solutions');
            APP.Ajax.post('/hu/service/solutions', {
                questionId: $element.attr('data-learn')
            }).then(function (result) {
                APP.ProblemWorker.run('learn-solutions', result.result).then(function (result) {
                    var $solutions = $('<li data-opened-solutions />');
                    $solutions.html(result);
                    $solutions.insertAfter($element);
                    APP.Layout.setMoments();
                    APP.Formula.fillFormulas();
                });
            }, window.NOOP);
        }
    }

    function playSound(name) {
        name = name === 'show-cup-default' ? 'show-cup' : name;
        if (window.USER_SETTINGS && window.USER_SETTINGS.audio && sounds.hasOwnProperty(name)) {
            try {
                sounds[name].play().catch(function (error) {
                    /*
                    APP.Error.logError(error, {
                        source: 'APP.Learn.playSound',
                        context: {
                            sound: name
                        }
                    });
                    */
                });
            } catch (e) {
                /*
                APP.Error.logError(e, {
                    source: 'APP.Learn.playSound',
                    context: {
                        sound: name
                    }
                });
                */
            }
        }
    }

    function preCheckProblem(questionId) {
        preCheckResult = false;
        hasFailed = false;
        APP.Ajax.post('/hu/learn/pre-check', {
            questionId: questionId,
            questionCheck: $body.find('[data-learn-question]').attr('data-learn-check'),
            questionSample: $body.find('[data-learn-question]').attr('data-learn-sample'),
            historyId: $body.find('[name="lesson-history-id"]').val(),
            language: window.LANGUAGE,
        }).then(function (result) {
            if (result.success) {
                preCheckResult = result.result;
            } else {
                APP.Calculator.Keyboard.hide(true);
                APP.Layout.alert(window.TXT['learn_error.error'], false, function () {
                    APP.Page.reloadPage();
                });
            }
        }, function () {
            APP.Calculator.Keyboard.hide(true);
            APP.Layout.alert(window.TXT['learn_error.error'], false, function () {
                APP.Page.reloadPage();
            });
        });
    }

    function checkProblem(questionId, answer) {
        fastCheckProblem(questionId, answer);
    }

    function getCompetition(questionId) {
        const $wrapper = $body.find('[data-learn-element="competition"]');

        $wrapper.addClass('loading');
        APP.Ajax.post('/hu/learn/get-competition', {
            questionId: questionId
        }).then(function (result) {
            $wrapper.removeClass('loading');
            if (result.success) {
                APP.ProblemWorker.run('learn-competition', result.result).then(function (response) {
                    $wrapper.html(response);
                });
            }
        }, window.NOOP);
    }

    function fastCheckProblem(questionId, answer) {
        if (!isChecking) {
            isChecking = true;
            $body.find('[data-learn-send]').addClass('disabled');
            APP.Live.saveClientMeta('focus', true);

            APP.Ajax.post('/hu/learn/fast-check', {
                questionId: questionId,
                answer: prefixWithMultipleAnswer(answer),
                questionCheck: $body.find('[data-learn-question]').attr('data-learn-check'),
                questionSample: $body.find('[data-learn-question]').attr('data-learn-sample'),
                historyId: $body.find('[name="lesson-history-id"]').val(),
            }).then(function (result) {
                isChecking = false;
                $body.find('[data-learn-send]').removeClass('disabled');

                if (result.success && result.result && preCheckResult) {
                    var display = result.result.display;
                    var actionId = result.result.result;
                    var r = {success: true};

                    if (actionId === 0) {
                        hasFailed = true;
                    } else if (actionId === 1 && display === lastSolution) {
                        actionId = 5;
                    } else if (actionId === 2 && hasFailed) {
                        actionId = 6;
                    }
                    lastSolution = display;
                    r.result = preCheckResult[actionId];
                    if (actionId !== 0 && actionId !== 5) {
                        r.result.display = display;
                    }
                    if (result.result.getback) {
                        r.result.getback = result.result.getback;
                    }
                    if (window.USER_SETTINGS.competitionNotification > 0) {
                        if (window.USER_SETTINGS.competitionNotification === 1) {
                            if (preCheckResult && preCheckResult[actionId] && preCheckResult[actionId].action.emocard === 'show-medal') {
                                getCompetition(questionId);
                            }
                        } else if (window.USER_SETTINGS.competitionNotification === 2) {
                            if (actionId === 2) {
                                getCompetition(questionId);
                            }
                        }
                    }
                    handleChecking(r);
                } else {
                    var message = result.error_message || window.TXT['learn_error.error'];
                    APP.Layout.alert(message, false);
                }
            }, function () {
                isChecking = false;
                $body.find('[data-learn-send]').removeClass('disabled');
                APP.Layout.alert(window.TXT['learn_error.error'], false);
            });
        }
    }

    function updateProgressStars(count) {
        var $stars = $body.find('[data-question-stars] .learn__star'),
            before = $stars.filter('.learn__star--active').length,
            $total = $body.find('[data-lesson-star-count]');

        $stars.each(function (index) {
            $(this).toggleClass('learn__star--active', index < count);
        });
        $total.text(Number($total.text()) + $stars.filter('.learn__star--active').length - before);
    }

    function handleChecking(result) {
        var i,
            action;

        if (result.success && result.result) {
            action = result.result.action;
            $answerOverlay.find('[data-learn-element="text"]').text(action.text);
            playSound(action.emocard);
            $answerOverlay.find('[data-learn-element="emocard"]').html(
                APP.Tpl.run('learn/emocard', {type: action.emocard})
            );
            $answerOverlay.find('[data-learn-cta]').hide();
            for (i = 0; i < action.actionButtons.length; i++) {
                $answerOverlay.find('[data-learn-cta="' + action.actionButtons[i] + '"]').show();
            }
            $answerOverlay.find('[data-learn-cta="' + action.actionButtons[0] + '"]').focus();
            APP.Layout.openOverlay('learn-answer');
            if (action.actionButtons[0] > 0) {
                APP.Layout.onOverlayClose(function () {
                    APP.Page.applyPageByUrl(document.location.href);
                });
            }
            if (action.emocard === 'show-star' || action.emocard === 'show-medal' || action.emocard === 'show-cup' || action.emocard === 'show-cup-default') {
                updateProgressStars(action.score.a);
                APP.Live.saveClientMeta('earnStar', 1);
                if (action.emocard === 'show-cup' || action.emocard === 'show-cup-default') {
                    APP.Live.saveClientMeta('earnCupType', action.emocard === 'show-cup-default' ? 'default-cup' : 'cup');
                    APP.Live.saveClientMeta('earnCup', 1);
                }
            } else if (action.emocard === 'hide-star') {
                updateProgressStars(action.score.a);
            }
            if (result.result.display && action.emocard !== 'redundant') {
                APP.Live.ping();
                $body.find('[data-previous-good-answers-wrapper]').show();
                APP.ProblemWorker.run('formula', result.result.display).then(function (formula) {
                    var $formula = $(formula),
                        $copy = $('<a style="position: absolute; right: 15px" data-question-copy=\'' + result.result.display + '\'><i class="icon-wrapper"><svg viewBox="0 0 256 256"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-symbol-copy"></use></svg></i></a>');
                    $body.find('[data-doodle-formula-preview]').html(formula);
                    $formula.prepend($copy);
                    if (result.result.result === 3 || result.result.result === 2) {
                        $formula.addClass('formula-flack--result');
                    }
                    $answersWrapper.append($formula);
                    APP.Formula.fillFormulas();
                });
            }
            if (action.interPage) {
                APP.Page.addInterPage(action.interPage);
            }
            if (result.result.getback && action.emocard !== 'redundant') {
                pushToMultipleAnswer(result.result.getback);
            }
        } else {
            APP.ProblemWorker.run('learn-error', result).then(function (content) {
                $body.find('[data-learn-error-content]').html(content);
                APP.Layout.openOverlay('learn-error');
                $body.find('[data-close-learn-error]').focus();
            });
        }
    }

    function pushToMultipleAnswer(answer) {
        var $ma = $body.find('[data-multiple-answer]'),
            splitChar = '@@',
            value = $ma.attr('data-multiple-answer'),
            splited = value ? value.split(splitChar) : [];

        splited.push(answer);
        $ma.attr('data-multiple-answer', splited.join(splitChar));
    }

    function prefixWithMultipleAnswer(answer) {
        var $ma = $body.find('[data-multiple-answer]'),
            splitChar = '@@',
            value = $ma.attr('data-multiple-answer'),
            splited = value ? value.split(splitChar) : [];

        splited.push(answer);
        if (splited.length > 2 && false) {
            splited = [
                splited[splited.length - 2],
                splited[splited.length - 1]
            ];
        }

        return splited.join(';');
    }

    function giveUp() {
        var questionId = $body.find('[name="question-id"]').val(),
            answerData = $body.find('[name="answer-data"]').val(),
            historyId = $body.find('[name="lesson-history-id"]').val();

        APP.Ajax.post('/hu/learn/give-up', {
            questionId: questionId,
            answerData: answerData,
            historyId: historyId
        }).then(function () {
            APP.Page.applyPageByUrl('/hu/learn/answer/' + answerData + '/' + questionId);
        }, window.NOOP);
    }

    function cutLearnTree() {
        APP.Ajax.post('/hu/learn/cut-tree').then(function () {
            APP.Page.applyPageByUrl('/hu/learn/');
        }, window.NOOP);
    }

    function formulaCommentPhase(show) {
        var $ctas = $('[data-formula-comment-ctas]'),
            $defaultCtas = $('[data-formula-default-ctas]');

        if (show) {
            $body.addClass('show-extended-keyboard');
            $ctas.show();
            $defaultCtas.hide();
            $('#new-input').focus();
        } else {
            $body.removeClass('show-extended-keyboard');
            $ctas.hide();
            $defaultCtas.show();
        }

    }

    exports.init = init;
    exports.saveComments = saveComments;

    return exports;

})();

APP.Video = (function () {
    var exports = {},
        initialized = false;

    function init() {
        var $videoIndicator;
        initBindings();

        if (document.location.hash === '#video') {
            $videoIndicator = $body.find('[data-play-youtube]');

            if ($videoIndicator.length > 0) {
                playYoutube($videoIndicator.first().attr('data-play-youtube'));
            }
        }
    }

    function initBindings() {
        if (!initialized) {
            initialized = true;

            $body.on('click', '[data-play-youtube]', function () {
                var $this = $(this),
                    customEvent = $this.attr('data-custom-event'),
                    id = $this.attr('data-play-youtube');

                if (customEvent) {
                    console.log('customEvent', customEvent);
                    APP.Analytics.logCustomUserEvent(customEvent, id);
                }
                playYoutube(id);
                APP.Analytics.trackEvent('landing-click', 'play-youtube', id);
            });
        }
    }

    function playYoutube(id) {
        $body.find('[data-youtube-video-wrapper]').html(APP.Tpl.run('youtube-video', {
            id: id,
            language: window.LANGUAGE
        }));
        setTimeout(function () {
            APP.Layout.openOverlay('youtube-video-overlay');
            APP.Layout.onOverlayClose(function () {
                $body.find('[data-youtube-video-wrapper]').html('');
            });
        }, 300);
    }

    exports.init = init;
    return exports;

})();

APP.Assets = (function () {
    var exports = {};

    function init() {
        var spriteEl = document.getElementById('sprite');
        if (spriteEl) {
            spriteEl.innerHTML = APP.$store.svg;
        } else {
            setTimeout(init, 1500);
        }
    }

    exports.init = init;
    return exports;

})();
APP.Doodle = (function () {
    var adtualDoodleId,
        Doodle,
        doodlers = [],
        doodlerIndex = 0;

    function init() {
        var $input = $body.find('[data-doodle-input]:not([data-doodle-input-initialized])');

        if ($input.length) {
            Doodle = new DoodleInput($input);
        }
    }

    function newDoodle() {
        Doodle.readAndWrite('doodle');
        Doodle.setMode('doodle');
        Doodle.setDoodleId(undefined);
        Doodle.loadPath([]);
    }

    function editDoodle(id) {
        return new Promise(function (resolve, reject) {
            getDoodlePath(id).then(function (path) {
                Doodle.setDoodleId(id);
                Doodle.loadPath(path);
                openDoodleInput();
                resolve();
                onDoodled(function (doodleId) {
                    $body.find('img[data-doodle-id="' + doodleId + '"]')
                        .attr('src', '/doodle/' + doodleId + '.svg?' + new Date());
                });
            });
        });
    }

    function getDoodlePath(id) {
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/hu/service/doodle/get', {
                id: id
            }).then(function (result) {
                console.log('AJAX result');
                if (result.success) {
                    resolve(result.path);
                } else {
                    var error = new Error('app.doodle.getDoodlePath invalid_response');
                    APP.Error.logError(error, {
                        source: 'APP.Doodle.getDoodlePath',
                        context: {
                            id: id,
                            response: JSON.stringify(result || {})
                        }
                    });
                    error.reported = true;
                    reject(error);
                }
            }, function (error) {
                reject(error);
            });
        });

    }

    function openDoodleInput() {
        Doodle.setMode('doodle');
        Doodle.fullScreen();
    }

    function closeDoodleInput() {

    }

    function showLastStep() {

    }

    function hideLastStep() {

    }

    function DoodleInput($element) {
        var _self = this,
            doodleId,
            offsetX,
            offsetY,
            idSeeker = 0,
            editable = false,
            isMouseDown = false,
            fullscreen = false,
            MODES = {
                DOODLE: 1,
                PAN: 2,
                RUBBER: 3
            },
            MODE = MODES.DOODLE,
            panStartCoordinates = [0, 0],
            panOffset = [0, 0],
            simplifyTolerance = 3,
            $path,
            $points = $element.find('[data-points]'),
            paths = [],
            pathHistory = [],
            tpmDoodleId;

        _self.init = function () {
            $element.attr('data-doodle-input-initialized', 'true');
            initBindings();
        };

        _self.setMode = function (mode) {
            MODE = MODES[mode.toUpperCase()];
            $element.attr('data-doodle-input-mode', mode.toLowerCase());
        };

        function initBindings() {
            $element.find('[data-doodle-control="fullscreen-close"]').on('click', function () {
                toggleFullscreen();
            });

            $element.find('[data-doodle-control="save"]').on('click', function () {
                _self.save();
                toggleFullscreen();
            });

            $element.find('[data-doodle-control="doodle"]').on('click', function () {
                _self.setMode('doodle');
            });

            $element.find('[data-doodle-control="pan"]').on('click', function () {
                _self.setMode('pan');
            });

            $element.find('[data-doodle-control="rubber"]').on('click', function () {
                _self.setMode('rubber');
            });

            $element.find('[data-doodle-control="undo"]').on('click', undo);

            $element.on('touchmove', function (event) {
                if (isMouseDown) {
                    event.preventDefault();
                }
            });

            $element.find('svg').on('mousedown touchstart', function (event) {
                var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                    clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY;

                setMouseDown(true);
                updateOffset();

                if (MODE === MODES.DOODLE) {
                    addToHistory();
                    createPath(getCoordinate('x', clientX - 1), getCoordinate('y', clientY - 1));
                    updatePath(getCoordinate('x', clientX), getCoordinate('y', clientY));
                } else if (MODE === MODES.PAN) {
                    panStart(getCoordinate('x', clientX), getCoordinate('y', clientY));
                } else if (MODE === MODES.RUBBER) {
                    addToHistory();
                }
            });

            $window.off('.doodle');
            $body.off('.doodle');

            $window.on('touchmove.doodle', '[data-address]', function (event) {
                event.preventDefault();
            });

            $window.on('mousemove.doodle touchmove.doodle', function (event) {
                if (isMouseDown) {
                    var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                        clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY;

                    if (typeof clientX !== 'number' || typeof  clientY !== 'number') {
                        return;
                    }

                    if (MODE === MODES.DOODLE) {
                        updatePath(getCoordinate('x', clientX), getCoordinate('y', clientY));
                    } else if (MODE === MODES.PAN) {
                        pan(getCoordinate('x', clientX), getCoordinate('y', clientY));
                    } else if (MODE === MODES.RUBBER) {
                        var elemet = document.elementFromPoint(clientX, clientY),
                            address = elemet ? elemet.getAttribute('data-address') : false;

                        if (address) {
                            clearPoint(address);
                        }
                    }
                }
            });

            $window.on('scroll.doodle', updateOffset);

            $window.on('mouseup.doodle touchend.doodle', function (event) {
                if (isMouseDown) {
                    var clientX = event.clientX || event.originalEvent.changedTouches && event.originalEvent.changedTouches[0].clientX,
                        clientY = event.clientY || event.originalEvent.changedTouches && event.originalEvent.changedTouches[0].clientY;

                    setMouseDown(false);
                    if (MODE === MODES.DOODLE) {
                        closePath();
                        saveDoodle(paths, tpmDoodleId, true).then(function (id) {
                            tpmDoodleId = id;
                            APP.Live.saveClientMeta('input', {
                                type: 'doodle',
                                value: id
                            });
                        });
                    } else if (MODE === MODES.PAN) {
                        panEnd(getCoordinate('x', clientX), getCoordinate('y', clientY));
                    }
                }
            });

            $body.on('click.doodle', '[data-doodle-id]', function () {
                var $this = $(this),
                    doodleId = $this.attr('data-doodle-id');

                editable = !!$this.attr('data-editable');
                editDoodle(doodleId).then(function () {
                    _self.setMode('pan');
                    if (!editable) {
                        _self.readOnly();
                    } else {
                        _self.readAndWrite();
                    }
                });
            });

        }

        function addToHistory() {
            pathHistory.push(JSON.parse(JSON.stringify(paths)));
            $element.addClass('doodle-table__show-undo');
        }

        _self.clearHistory = function () {
            $element.removeClass('doodle-table__show-undo');
            pathHistory = [];
        };

        function undo() {
            var recovery = pathHistory.splice(-1, 1)[0];

            Doodle.loadPath(recovery, true);
            if (!pathHistory.length) {
                $element.removeClass('doodle-table__show-undo');
            }
        }

        function setMouseDown(value) {
            isMouseDown = value;
            if (value) {
                $points.show();
            } else {
                $points.hide();
            }
        }

        function getId() {
            return ++idSeeker;
        }

        function newPath() {
            var id = getId();

            $element.find('svg [data-paths]')[0].innerHTML += '<path data-path-id="' + id + '" />';
            $path = $element.find('path:last-child');
            return id;
        }

        function getCoordinate(coordinate, value) {
            if (coordinate === 'x') {
                return value - offsetX;
            }
            return value - offsetY;
        }

        function createPath(x, y) {
            var id = newPath(),
                points = x ? [{x: x - panOffset[0], y: y - panOffset[1]}] : [];

            paths.push({
                id: id,
                points: points
            });

            return id;
        }

        function updatePath(x, y) {
            paths[paths.length - 1].points.push({x: x - panOffset[0], y: y - panOffset[1]});
            drawPaths();
        }

        function updateOffset() {
            offsetX = $element.offset().left - window.scrollX;
            offsetY = $element.offset().top - window.scrollY;
        }

        function getPathById(id) {
            var i;

            for (i = 0; i < paths.length; i++) {
                if (paths[i].id === id) {
                    return paths[i];
                }
            }
        }

        function deletePathById(id) {
            var i;

            for (i = 0; i < paths.length; i++) {
                if (paths[i].id === id) {
                    paths.splice(i, 1);
                }
            }
        }

        function updatePathById(id, points) {
            var i;

            for (i = 0; i < paths.length; i++) {
                if (paths[i].id === id) {
                    paths[i].points = points;
                    return true;
                }
            }
        }

        function closePath() {
            var path = paths[paths.length - 1] = simplifyPath(paths[paths.length - 1]);

            drawPaths();
            drawCircles(path.id);
        }

        function drawCircles(id) {
            var path = getPathById(id),
                i,
                endpoint,
                points = '',
                pathPoints = path.points;

            for (i = 0; i < pathPoints.length; i++) {
                endpoint = (i === 0 || i === pathPoints.length - 1);
                points += '<circle cx="' + pathPoints[i].x + '" cy="' + pathPoints[i].y + '" fill="' + (endpoint ? 'blue' : 'green') + '" r="20" data-address="' + path.id + ';' + i + '" />';
            }
            $element.find('svg [data-points]')[0].innerHTML += points;
        }

        function clearCircles(id) {
            $element.find('svg circle[data-address^="' + id + ';"]').remove();
        }

        function drawPaths() {
            var path = getCurvedPath(decodeXY(paths[paths.length - 1].points));
            $path.attr('d', path);
        }

        function drawPath(id) {
            var points = getPathById(id).points;

            if (points.length > 0) {
                $element.find('[data-path-id="' + id + '"]').attr('d', getCurvedPath(decodeXY(points)));
                drawCircles(id);
            } else {
                deletePathById(id);
                $element.find('[data-path-id="' + id + '"]').remove();
            }
        }

        function simplifyPath(data) {
            data.points = simplify(data.points, simplifyTolerance, true);
            return data;
        }

        function panStart(x, y) {
            panStartCoordinates = [x, y];
        }

        function pan(x, y) {
            var X = x - panStartCoordinates[0] + panOffset[0],
                Y = y - panStartCoordinates[1] + panOffset[1];

            $element.find('svg [data-canvas]').css('transform', 'translate3d(' + X + 'px,' + Y + 'px, 0)');
            $element.css('background-position', X + 'px ' + Y + 'px')
        }

        function panEnd(x, y) {
            panOffset = [x - panStartCoordinates[0] + panOffset[0], y - panStartCoordinates[1] + panOffset[1]];
        }

        function drawNewPath(points) {
            var id = createPath(),
                path = getPathById(id);

            path.points = points;
            drawPath(id);
        }

        function clearPoint(address) {
            var addressParts = address.split(';'),
                pathId = parseInt(addressParts[0], 10),
                nth = parseInt(addressParts[1], 10),
                path = getPathById(pathId),
                pathPoints = path.points,
                newPathPoints = pathPoints.splice(0, nth);

            clearCircles(pathId);
            updatePathById(pathId, newPathPoints);
            drawPath(pathId);
            drawNewPath(pathPoints.splice(1, pathPoints.length));
            $element.find('[data-address="' + address + '"]').remove();
        }

        function continuePoint() {

        }

        function toggleFullscreen() {
            fullscreen = !fullscreen;
            if (fullscreen) {
                _self.fullScreen();
            } else {
                $element.removeClass('doodle-table__fullscreen');
            }
        }

        _self.readOnly = function () {
            $element.addClass('doodle-table__readonly');
        };

        _self.readAndWrite = function () {
            $element.removeClass('doodle-table__readonly');
        };

        _self.loadPath = function (_paths, original) {
            paths = [];
            $element.find('[data-paths]').html('');
            $element.find('[data-points]').html('');
            _paths.forEach(function (path) {
                // paths
                if (original) {
                    drawNewPath(path.points);
                } else {
                    drawNewPath(encodeXY(path));
                }
            });
        };

        _self.fullScreen = function () {
            APP.Calculator.Keyboard.hide(true);
            fullscreen = true;
            $element.addClass('doodle-table__fullscreen');
            _self.clearHistory();
            APP.Formula.fillFormulas($element);
        };

        _self.save = function () {
            var examId = $body.find('[name="exam-id"]').val(),
                examNth = $body.find('[name="exam-nth"]').val(),
                commentType = 'comment-doodle';

            if (doodleId) {
                updateDoodle(doodleId, paths);
            } else {
                saveDoodle(paths).then(function (id) {
                    doodleId = id;
                    if (examId) {
                        APP.Ajax.post('/hu/service/exam/' + examId + '/comment', {
                            examId: examId,
                            examNth: examNth,
                            type: commentType,
                            comment: id
                        }).then(function (result) {
                            if (result.success) {
                                APP.Exam.showFormulaInput();
                                $body.find('[data-exam-answers="1"]').removeClass('invisible');
                            } else if (result.reason === 'done') {
                                APP.Layout.openOverlay('exam-finished');
                            }
                        }, window.NOOP);
                    } else {
                        APP.Learn.saveComments(commentType, id);
                    }
                });
            }
        };

        _self.setDoodleId = function (value) {
            doodleId = value;
        };

        _self.init();
        return _self;
    }

    function getCurvedPath(data) {
        var k = 1,
            size = data.length,
            last = size - 4,
            path = 'M' + [data[0], data[1]],
            i,
            x0, y0, x1, y1, x2, y2, x3, y3, cp1x, cp1y, cp2x, cp2y;

        for (i = 0; i < size - 2; i += 2) {
            x0 = i ? data[i - 2] : data[0];
            y0 = i ? data[i - 1] : data[1];
            x1 = data[i];
            y1 = data[i + 1];
            x2 = data[i + 2];
            y2 = data[i + 3];
            x3 = i !== last ? data[i + 4] : x2;
            y3 = i !== last ? data[i + 5] : y2;
            cp1x = x1 + (x2 - x0) / 6 * k;
            cp1y = y1 + (y2 - y0) / 6 * k;
            cp2x = x2 - (x3 - x1) / 6 * k;
            cp2y = y2 - (y3 - y1) / 6 * k;
            path += 'C' + [cp1x, cp1y, cp2x, cp2y, x2, y2];
        }
        return path;
    }

    function encodeXY(data) {
        var result = [];

        for (var i = 0; i < data.length; i += 2) {
            result.push({x: data[i], y: data[i + 1]});
        }

        return result;

    }

    function decodeXY(data) {
        var result = [];

        (data || []).forEach(function (d) {
            result.push(d.x);
            result.push(d.y);
        });

        return result;

    }

    function saveDoodle(path, id, preventCallback) {
        if (id) {
            return updateDoodle(id, path, preventCallback);
        }
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/hu/service/doodle/save', {
                path: JSON.stringify(path.map(function (p) {
                    return decodeXY(p.points)
                }))
            }, false, getDoodleSaveAjaxOptions()).then(function (result) {
                if (result.success) {
                    !preventCallback && onDoodledCallback(result.id);
                    resolve(result.id);
                } else {
                    var error = new Error('app.doodle.saveDoodle invalid_response');
                    APP.Error.logError(error, {
                        source: 'APP.Doodle.saveDoodle',
                        context: {
                            id: id || '',
                            response: JSON.stringify(result || {})
                        }
                    });
                    error.reported = true;
                    reject(error);
                }
            }, function (error) {
                reject(error);
            });
        });
    }

    function updateDoodle(id, path, preventCallback) {
        return new Promise(function (resolve, reject) {
            APP.Ajax.post('/hu/service/doodle/save', {
                id: id,
                path: JSON.stringify(path.map(function (p) {
                    return decodeXY(p.points)
                }))
            }, false, getDoodleSaveAjaxOptions()).then(function (result) {
                if (result.success) {
                    !preventCallback && onDoodledCallback(result.id);
                    resolve(result.id);
                } else {
                    var error = new Error('app.doodle.updateDoodle invalid_response');
                    APP.Error.logError(error, {
                        source: 'APP.Doodle.updateDoodle',
                        context: {
                            id: id,
                            response: JSON.stringify(result || {})
                        }
                    });
                    error.reported = true;
                    reject(error);
                }
            }, function (error) {
                reject(error);
            });
        });

    }

    function getDoodleSaveAjaxOptions() {
        return {
            expectedStatusZeroAbort: {
                eventName: 'doodle-save-expected-abort',
                operation: 'doodle.save'
            }
        };
    }

    var onDoodledCallback = function (id) {
        console.log('doodled', id);
    };

    function onDoodled(callback) {
        onDoodledCallback = callback;
    }

    function openDoodle(id, editable) {

    }

    return {
        newDoodle: newDoodle,
        editDoodle: editDoodle,
        openDoodleInput: openDoodleInput,
        openDoodle: openDoodle,
        saveDoodle: saveDoodle,
        onDoodled: onDoodled,
        init: init
    };

})();

APP.Cd = (function () {

    var initialized = false,
        exports = {};

    function init() {
        $body.find('[data-hcflcm]:not([data-hcflcm-initialized])').each(function () {
            var $this = $(this);
            initCd($this);
        });
    }

    function initCd($element) {
        $element.attr('data-hcflcm-initialized', 'true');

        APP.Ajax.post('/hu/service/hcflcm', {
            cmd: $element.attr('data-hcflcm-cmd'),
            formula: $element.attr('data-hcflcm-formula')
        }).then(function (result) {
            APP.ProblemWorker.run('hcflcm', result).then(function (compiled) {
                $element.html(compiled);
                APP.Formula.fillFormulas();
                APP.Formula.cosmeticFormulaByWrapper($element);
            });
        }, window.NOOP);
    }

    exports.init = init;

    return exports;

})();


APP.Layout = (function () {
    var exports = {},
        inited = false,
        overlayCloseCallback = false,
        momentInitialized = false,
        $html,
        $body$html,

        lastOverlay,

        inputCloseTimer;

    function init() {
        loadOverlays();
        initBindings();
        initMoment();
        initLazyImages();
        scheduleBackgroundPreload();
        addMails();
        ajaxContentBuild();
        requestAnimationFrame(checkStickiness);

        $body.find('[data-header-tooltip]').removeClass('show');
        $body.addClass(APP.Page.isDevice() ? 'device' : 'desktop');
        $html = $('html');
        $body$html = $('html, body');
    }

    function initBindings() {
        $body.find('[data-prevent]').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
        });
        initCarousels();
        initPriceTable();
        if (!inited) {
            setCookieNotification();
            iosClickHack();

            $body.on('click', '[data-open-overlay]', function () {
                var overlay = $(this).attr('data-open-overlay');
                openOverlay(overlay);

                if (overlay === 'group-registration') {
                    $body.find('[data-overlay=' + overlay + '] [name="groupId"]').val(
                        $body.find('[data-actual-group-id]').attr('data-actual-group-id')
                    )
                }
            });

            $body.on('click', '[data-close-overlay]', () => closeOverlay());
            $body.on('click', '[data-close-last-overlay]', () => closeOverlay(true));
            $body.find('[data-language-selector]').on('change', function () {
                var pathPeaces = document.location.pathname.split('/');

                pathPeaces[1] = $(this).val();
                document.location.href = pathPeaces.join('/')
                    + document.location.search
                    + document.location.hash;
            });

            $body.on('click', '[data-scroll-to-top]', function () {
                scrollTo(0, 200);
            });

            $body.find('[data-header-tooltip-show]').on('click', function (event) {
                var $tooltip = $body.find('[data-header-tooltip="' + $(this).attr('data-header-tooltip-show') + '"]');

                if ($(this).attr('data-header-tooltip-show') === 'menu') {
                    APP.Calculator.Keyboard.hide(true);
                }
                event.originalEvent.attribute = 'click-from-tooltip';
                $body.find('[data-header-tooltip]').removeClass('show');
                $tooltip.addClass('show');
                $tooltip.on('click.header-tooltip', function (event) {
                    event.originalEvent.attribute = 'click-from-tooltip';
                });

                setTimeout(function () {
                    $body.on('click.header-tooltip', function (event) {
                        if (event.originalEvent && event.originalEvent.attribute !== 'click-from-tooltip') {
                            $tooltip.off('click.header-tooltip');
                            $body.find('[data-header-tooltip]').off('click.header-tooltip');
                            $body.off('click.header-tooltip');
                            $body.find('[data-header-tooltip]').removeClass('show');
                        }
                    });
                }, 8);

            });

            $body.on('click', '[data-load-more]', function (e) {
                e.preventDefault();
                var $this = $(this),
                    fromSelector = $this.attr('data-load-more').split(':')[0],
                    toSelector = $this.attr('data-load-more').split(':')[1],
                    promise = APP.Ajax.get($this.attr('href'), true);

                APP.Analytics.trackEvent('loadMore', $this.attr('href'), '', {
                    from: fromSelector,
                    to: toSelector
                });
                promise.then(function (result) {
                    $body.find(toSelector).replaceWith($(fromSelector, result).html());
                    setMoments();
                    APP.Formula.fillFormulas();
                });
            });

            $body.on('change', '[data-query]', function () {
                var queryStrings = [],
                    $this;

                $body.find('[data-query]').each(function () {
                    $this = $(this);
                    queryStrings.push($this.attr('data-query') + '=' + $this.val());
                });

                document.location.href = '?' + queryStrings.join('&');
            });

            $body.on('change', '[name="change-currency-onchange"]', function () {
                APP.Page.applyPageByUrl(document.location.href.split('?')[0] + '?currency=' + $(this).val());
            });

            $body.find('.made-in__heart').on('click', function () {
                var $this = $(this);

                $this.removeClass('made-in__heart__pulse');
                async(function () {
                    $this.addClass('made-in__heart__pulse');
                });
            });

            $body.find('[data-copy-text]').on('click', function () {
                document.execCommand('copy');
            });

            $body.find('[data-copy-text]').on('copy', function (event) {
                var $this = $(this),
                    clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;

                clipboardData.setData('text/plain', $this.attr('data-copy-text'));
                event.preventDefault();
            });

            $body.on('click', '[data-show-password]', function () {
                var $pw = $(this).parents('[data-password-wrapper]');

                $pw.addClass('password-show');
                $pw.find('input').attr('type', 'text');
            });

            $body.on('click', '[data-hide-password]', function () {
                var $pw = $(this).parents('[data-password-wrapper]');

                $pw.removeClass('password-show');
                $pw.find('input').attr('type', 'password');
            });

            $body.on('click', '[data-show-block]', function () {
                var id = $(this).attr('data-show-block');

                $body.find('[data-block-indicator="' + id + '"]').hide();
                $body.find('[data-block-id="' + id + '"]').show();
                loadLazyImages($body.find('[data-block-id="' + id + '"]'));
                initCarousels();
                APP.Analytics.trackEvent('landing-click', 'show-block', id);
            });

            var resizeTimer;
            window.addEventListener('resize', function () {
                window.clearTimeout(resizeTimer);
                resizeTimer = window.setTimeout(checkStickiness, 120);
            });
        }
        inited = true;
    }

    function iosClickHack() {
        var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (!isIOS) return;

        var lastTouchTime = 0;
        var startX = 0;
        var startY = 0;
        var moveThreshold = 10;

        document.addEventListener('touchstart', function (event) {
            var touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
        }, {passive: true});

        document.addEventListener('touchend', function (event) {
            var now = Date.now();
            var touch = event.changedTouches[0];
            var diffX = Math.abs(touch.clientX - startX);
            var diffY = Math.abs(touch.clientY - startY);
            if (diffX > moveThreshold || diffY > moveThreshold) return;
            if (now - lastTouchTime <= 300) return;
            var target = event.target.closest('button, a, .button, [data-close-overlay]');

            if (target) {
                event.preventDefault();
                target.click();
                lastTouchTime = now;
            }
        }, {passive: false});
    }

    function ajaxContentBuild() {
        $body.find('[data-ajax-load-content]').each(function () {
            var $this = $(this),
                url = $this.attr('data-ajax-load-content'),
                tpl = $this.attr('data-ajax-load-top'),
                data = JSON.parse($this.attr('data-ajax-load-data') || '{}');
            APP.Ajax.post(url, data, true).then((result) => {
                $this.html(APP.Tpl.run(tpl, result));
                setMoments();
                checkStickiness();
            }, function (error) {
                if (APP.Ajax.isExpectedAbort(error) || error && error.reported) {
                    return;
                }
                throw error;
            });
        });
    }

    function checkStickiness() {
        $body.find('[data-sticky-class]').each(function () {
            var $this = $(this),
                className = $this.attr('data-sticky-class'),
                top = parseInt($this.css('top')),
                height = $this.height();

            if (top + height > window.innerHeight) {
                $this.removeClass(className);
            } else {
                $this.addClass(className);
            }
        });
    }

    function initCarousels() {
        $body.find('[data-carousel]:visible:not([data-initialized-carousel])').each(function () {
            var $this = $(this),
                fade = $this.hasClass('fade');

            $this.attr('data-initialized-carousel', true);
            $this.slick({
                infinite: true,
                autoplay: true,
                cssEase: fade ? 'ease' : 'cubic-bezier(0.76, 0, 0.24, 1)',
                speed: fade ? 120 : 300,
                fade: fade,
                autoplaySpeed: fade ? 3000 : 5000,
                prevArrow: $this.parent().find('[data-carousel-prev]'),
                nextArrow: $this.parent().find('[data-carousel-next]')
            });
        });
    }

    function initPriceTable() {
        const roots = document.querySelectorAll('[data-ak-pricing]');
        if (!roots.length) return;

        function updateCtaLinks(root) {
            const period = root.getAttribute('data-period');
            const currency = root.getAttribute('data-currency');
            root.querySelectorAll('[data-ak-cta-link]').forEach((a) => {
                const tpl = a.getAttribute('data-href-template');
                if (!tpl) return;
                a.setAttribute('href', tpl
                    .replace('{period}', encodeURIComponent(period))
                    .replace('{currency}', encodeURIComponent(currency))
                );
            });
        }

        function setActivePeriod(root, period, periodButtons) {
            root.setAttribute('data-period', period);
            periodButtons.forEach((btn) => {
                btn.classList.toggle('is-active', btn.getAttribute('data-period') === period);
            });
            updateCtaLinks(root);
        }

        function setCurrency(root, cur) {
            root.setAttribute('data-currency', cur);
            updateCtaLinks(root);
        }

        roots.forEach((root) => {
            const periodButtons = root.querySelectorAll('[data-ak-period-btn]');
            const currencySelect = root.querySelector('[data-ak-currency-select]');

            periodButtons.forEach((btn) => {
                btn.addEventListener('click', () => setActivePeriod(root, btn.getAttribute('data-period'), periodButtons));
            });
            if (currencySelect) {
                currencySelect.addEventListener('change', (e) => setCurrency(root, e.target.value));
            }
            updateCtaLinks(root);
        });
    }

    function loadOverlays() {
        document.getElementById('overlays').innerHTML = APP.Tpl.run('overlays');
    }

    function initLazyImages() {
        var images = document.querySelectorAll('img[data-lazy-src]:not([data-lazy-bound])');

        if (!images.length) {
            return;
        }

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        loadLazyImage(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, {rootMargin: '300px 0px'});

            images.forEach(function (image) {
                image.setAttribute('data-lazy-bound', 'true');
                observer.observe(image);
            });
        } else {
            setTimeout(function () {
                loadLazyImages($body);
            }, 900);
        }
    }

    function loadLazyImages($root) {
        $root.find('img[data-lazy-src]').each(function () {
            loadLazyImage(this);
        });
    }

    function loadLazyImage(image) {
        var src = image.getAttribute('data-lazy-src');

        if (!src) {
            return;
        }
        image.setAttribute('src', src);
        image.removeAttribute('data-lazy-src');
    }

    function addMails() {
        $body.find('[data-mail-to-placeholder]').each(function () {
            var $this = $(this);

            $this.removeAttr('data-mail-to-placeholder');
            $this.html(APP.Tpl.run('mail-to', {support: !!$this.attr('data-support')}));
        });
    }

    function scheduleBackgroundPreload() {
        if (window.requestIdleCallback) {
            window.requestIdleCallback(preloadBackgrounds, {timeout: 1800});
        } else {
            setTimeout(preloadBackgrounds, 900);
        }
    }

    function preloadBackgrounds() {
        $body.find('[data-bg]:not([data-bg-loaded])').each(function () {
            var $this = $(this),
                src = $this.attr('data-bg'),
                img = new Image();

            $this.attr('data-bg-loaded', 'true');
            $this.css('background-image', 'url(' + src + ')');
            img.src = src;
        });
    }

    function closeOverlay(justTheLast) {
        let overlaySelector = '[data-overlay]';

        if (justTheLast) {
            overlaySelector = '[data-overlay="' + lastOverlay + '"]';
        }
        if ($body.find(overlaySelector + '.overlay--show').length > 0) {
            $body.find(overlaySelector).removeClass('overlay--show');
            APP.Analytics.trackEvent('overlay', 'close');
        }
        if (overlayCloseCallback) {
            overlayCloseCallback();
            overlayCloseCallback = false;
        }
    }

    function openOverlay(name) {
        var $overlay = $body.find('[data-overlay="' + name + '"]');
        var $primary = $overlay.find('[data-primary-button]');

        $overlay.addClass('overlay--show');
        $overlay.find('.overlay--content').scrollTop(0);
        lastOverlay = name;
        $overlay.find('[data-src]').each(function () {
            var $this = $(this);
            $this.attr('src', $this.attr('data-src'));
        });
        if ($primary) {
            $primary.focus();
        }
        APP.Analytics.trackEvent('overlay', 'open', name);
    }

    function initMoment() {
        if (!momentInitialized) {
            momentInitialized = true;
            moment.locale($('html').attr('lang'));
            moment().add(window.SERVER_TIME_OFFSET, 'milliseconds');
            setInterval(setMoments, 30000);
        }
        setMoments();
    }

    function setMoments() {
        $body.find('[data-ago-moment]:not(.old)').each(function () {
            var $this = $(this),
                ago = new Date($this.attr('data-ago-moment')),
                m = moment(ago);

            if ((new Date() - ago) > 25 * 60 * 60 * 1000) {
                $this.addClass('old');
            }

            $this.text(m.fromNow());
            $this.attr('title', m.format('LLLL'));
        });

        $body.find('[data-date-moment]:not(.inited)').each(function () {
            var $this = $(this),
                date = new Date($this.attr('data-date-moment')),
                m = moment(date).format('LL');
            $this.addClass('inited');
            $this.text(m);
            $this.attr('title', m);
        });

        $body.find('[data-datetime-moment]:not(.inited)').each(function () {
            var $this = $(this),
                date = new Date($this.attr('data-datetime-moment')),
                m = moment(date).format('LL - HH:mm');

            $this.addClass('inited');
            $this.text(m);
            $this.attr('title', m);
        });
    }

    function alert(message, keepOtherOverlays, callback) {
        if (!keepOtherOverlays) {
            closeOverlay();
        }
        overlayCloseCallback = callback;
        $body.find('[data-alert-content]').html(message);
        APP.Analytics.trackEvent('overlay', 'alert', '', {
            message: message
        });
        openOverlay('alert');
    }

    function scrollTo(top, duration) {
        // console.log('scrollTo', top, duration);
        if (!duration) {
            window.scrollTo(0, top);
        } else {
            $body$html.stop(1, 1, 1).animate({scrollTop: top}, duration || 300);
        }
    }

    function setCookieNotification() {
        if (!navigator.cookieEnabled) {
            $body.find('#notification-container').append(APP.Tpl.run('cookie-notification'));
            $body.find('[data-cookie-notification]').removeClass('cookie-notification--show');
            $body.find('[data-no-cookie-notification]').addClass('no-cookie-notification--show');
        } else if (!window.getCookie('cookie-notified')) {
            var $cookieNotification;
            $body.find('#notification-container').append(APP.Tpl.run('cookie-notification'));
            $cookieNotification = $body.find('[data-cookie-notification]');
            $document.on('click.cookie', function () {
                window.setCookie('cookie-notified', 'true', 999999);
                $document.off('click.cookie');
                $cookieNotification.removeClass('cookie-notification--show');
            });
        }
    }

    function inputFullScreen() {
        if (inputCloseTimer) {
            window.clearTimeout(inputCloseTimer);
        }
        $body.find('[data-close-banner]').addClass('keyboard__close-banner--show');
    }

    function onOverlayClose(callback) {
        overlayCloseCallback = callback;
    }

    exports.init = init;
    exports.openOverlay = openOverlay;
    exports.closeOverlay = closeOverlay;
    exports.alert = alert;
    exports.scrollTo = scrollTo;
    exports.onOverlayClose = onOverlayClose;
    exports.inputFullScreen = inputFullScreen;
    exports.setMoments = setMoments;
    exports.initCarousels = initCarousels;
    exports.checkStickiness = checkStickiness;
    return exports;

})();

APP.Locale = (function () {
    var exports = {},
        initialized = false,
        replaceTable;

    function init() {
        if (!initialized) {
            setTable();

            $body.find('[data-keyboard-character]').each(function () {
                var $this = $(this);

                $this.html(replace($this.html()))
            });
            initialized = true;
        }

        $body.find('[data-ui-settings]').each(function () {
            var $this = $(this);
            var replaceTableStringify = replaceTable.map(function (element) {
                return element.join('-');
            });

            if (window.USER_SETTINGS.audio) {
                $this.find('[name="audio"]').val('true');
            }

            $this.find('[name="competitionNotification"]')
                .val(window.USER_SETTINGS.competitionNotification);
            $this.find('[name="charTable[]"] option').each(function () {
                var $this = $(this);

                if (replaceTableStringify.indexOf((JSON.parse($this.attr('value')) || []).join('-')) > -1) {
                    $this.attr('selected', 'selected');
                }
            });
        });
    }

    function setTable() {
        replaceTable = window.MATH_CHAR_REPLACE_TABLE;
        if (window.USER_SETTINGS && window.USER_SETTINGS.hasOwnProperty('charTable')) {
            replaceTable = window.USER_SETTINGS.charTable;
        }
    }

    function replace(input) {
        if (replaceTable.length && input && input.replace) {
            replaceTable.forEach(function (item) {
                if (item && item.length === 2) {
                    input = input.replace(new RegExp('\\' + item[0], 'g'), item[1]);
                }
            });
        }
        return input;
    }

    function successUISettings(response) {
        if (response.success) {
            APP.Layout.openOverlay('success-ui-settings');
            replaceTable = response.result.charTable;
            window.USER_SETTINGS.audio =  response.result.audio;
            window.USER_SETTINGS.competitionNotification =  response.result.competitionNotification;
            APP.ProblemWorker.sendRequest({method: 'addReplaceTable', data: replaceTable});
        }
    }

    exports.init = init;
    exports.replaceMathCharacters = replace;
    exports.successUISettings = successUISettings;
    exports.getReplaceTable = function () {
        setTable();
        return replaceTable;
    };

    return exports;

})();

APP.Formula = (function () {
    var exports = {},
        initialized = false;

    function init() {
        fillFormulas();
        fillVisibleFormulas();
        initBindings();
        initialized = true;
    }

    function fillFormulas($wrapper, force) {
        $wrapper = $wrapper || $body;
        $wrapper.find('[data-f]:not(.filled)').each(function () {
            var $this = $(this);

            if (force || $this.parents('[data-onscroll-cosmetic]').length === 0) {
                $this.addClass('filled');
                APP.ProblemWorker.getDom($this.attr('data-f'), $this.attr('data-f-mode')).then((dom) => {
                    $this.find('[data-f-content]').html(dom);
                    cosmeticFormulaByWrapper($this);
                    if (this.hasAttribute('data-learn-question')) {
                        setResponsiveFormulaSize(this, $this);
                    }
                    async(() => $this.addClass('loaded'));
                });
            }
        });

        $wrapper.find('[data-fromto]:not(.filled)').each(function () {
            var $this = $(this);

            if (force || $this.parents('[data-onscroll-cosmetic]').length === 0) {
                $this.addClass('filled');
                APP.ProblemWorker.getDom({
                    from: $this.attr('data-from'),
                    to: $this.attr('data-to'),
                    action: $this.attr('data-action'),
                    vertical: $this.attr('data-vertical') === 'true'
                }, 'fromto').then(function (dom) {
                    $this.html(dom);
                    cosmeticFormulaByWrapper($this);
                    async(function () {
                        $this.addClass('loaded');
                    });
                });
            }
        });
    }

    function fillVisibleFormulas() {
        $body.find('[data-onscroll-cosmetic]').each(function () {
            var $this = $(this);
            if ($this.visible()) {
                fillFormulas($this, true)
            }
        });
    }

    function initBindings() {
        var resizeeTimer;
        if (!initialized) {
            document.onscroll = fillVisibleFormulas;
            window.addEventListener('resize', () => {
                clearTimeout(resizeeTimer);
                resizeeTimer = setTimeout(() => {
                    $body.find('[data-f][data-learn-question]').each(function () {
                        setResponsiveFormulaSize(this);
                    });
                }, 60);
            });
        }
    }

    function cosmeticFormulaByWrapper($wrapper) {
        if ($wrapper.length > 0) {
            if ($wrapper.find('[data-f]:not(.filled)').length === 0) {
                setAllParenthesis($wrapper);
                setAllSupSubAlignment($wrapper);
                APP.Formula.Setup.setUpElement($wrapper);
            } else {
                async(function () {
                    cosmeticFormulaByWrapper($wrapper);
                });
            }

        }
    }

    function setResponsiveFormulaSize(element, $this) {
        $this = $this || $(element);
        $this.css('font-size', '');
        var originalSize = parseInt($this.css('font-size'));
        var ww = element.offsetWidth;
        var cw = element.scrollWidth;

        if (cw > ww) {
            var scale = Math.max(Math.floor(originalSize * (ww / cw)), 16);
            $this.css('font-size', scale + 'px');
        }
    }

    function setAllParenthesis($wrapper) {
        var selector = '[data-parenthesis]:not([data-formula-ghost-p="inactive"])',
            $elements = $wrapper.find(selector);

        $($elements.get().reverse()).each(function () {
            var $this = $(this);

            $this.parents(selector).first().attr('data-parenthesis-type', getParentParenthesisType($this));
        });

        function getParentParenthesisType($this) {
            var type = $this.attr('data-parenthesis-type');

            switch (type) {
                case '3':
                    return 1;
                case '2':
                    return 3;
                case '1':
                default:
                    return 2;
            }
        }
    }

    function setAllSupSubAlignment($wrapper) {
        $wrapper.find('[data-sup-sub="setted"]').attr('data-sup-sub', 'not-set');
        iterateExpSubs($wrapper);

        function iterateExpSubs($element) {
            var $elements = $element.find('[data-sup-sub="not-set"].exp-sup');

            $($elements.get().reverse()).each(function () {
                handleSubSupIfReady($(this));
            });

            function handleSubSupIfReady($this) {
                handleSubSup($this);
            }

            function handleSubSup($this) {
                var height = $this.parent().find('>.inline-block').height();

                $this.css('margin-bottom', Math.max(height * 0.6, height - 15));
                $this.attr('data-sup-sub', 'setted');
            }
        }
    }

    exports.init = init;
    exports.cosmeticFormulaByWrapper = cosmeticFormulaByWrapper;
    exports.setResponsiveFormulaSize = setResponsiveFormulaSize;
    exports.fillFormulas = fillFormulas;
    exports.fillVisibleFormulas = fillVisibleFormulas;
    return exports;

})();

APP.Formula.Setup = (function () {
    // TODO REVIEW!

    var exports = {},

        elementSelector,
        fitBoxSelector,
        calculatorActually,
        dimensionCache,
        activeDimensionElements,

        wGroupSeeker = 0;

    function setUpElement($wrapper) {
        elementSelector = '[data-formula]';
        fitBoxSelector = '[data-fit-box]';
        calculatorActually = false;

        if ($wrapper.find('[data-calculator-element]').length > 0) {
            elementSelector = '[data-calculator-element]:not([data-calculator-element-type="wrapper"])';
            calculatorActually = true;
        }
        dimensionCache = new WeakMap();
        activeDimensionElements = new WeakMap();
        $wrapper.find('.skipme').removeClass('skipme');
        $wrapper.find(elementSelector).each(function () {
            var $element = $(this),
                dimension;

            if ($element.attr('data-calculator-element-type') === 'log') {
                dimension = getDimensionOfElement($element);
                $element.find('> [data-formula="log"] > div > [data-formula-part="fnsub"]')
                    .css('padding-top', (dimension.top - 5) + 'px');
            } else if ($element.attr('data-formula') === 'log') {
                dimension = getDimensionOfElement($element);
                $element.find('> div > [data-formula-part="fnsub"]')
                    .css('padding-top', (dimension.top) + 'px');
            }
        });

        $wrapper.find('[data-wgroup]').removeAttr('data-wgroup');

        try {
            setUpElements(getFormula($wrapper));
        } finally {
            dimensionCache = null;
            activeDimensionElements = null;
        }
        APP.Operations.init();
    }

    function getFormula($element) {
        return collectTopLevel($element, elementSelector, fitBoxSelector);
    }

    function getFitBox($element) {
        return collectTopLevel($element, fitBoxSelector, elementSelector);
    }

    function collectTopLevel($element, targetSelector, stopSelector) {
        var root = $element.get(0),
            result = [],
            stack = [],
            i,
            node;

        if (!root) {
            return $(result);
        }

        for (i = root.children.length - 1; i >= 0; i--) {
            stack.push(root.children[i]);
        }

        while (stack.length > 0) {
            node = stack.pop();
            if (node.matches(targetSelector)) {
                result.push(node);
            } else if (!stopSelector || !node.matches(stopSelector)) {
                for (i = node.children.length - 1; i >= 0; i--) {
                    stack.push(node.children[i]);
                }
            }
        }

        return $(result);
    }


    function getDimensionOfElement($element) {
        var returnDimension = {top: 0},
            fitBoxDimension,
            element = $element.get(0),

            $fitBox = getFitBox($element),
            $child = getFormula($element);

        if (dimensionCache && dimensionCache.has(element)) {
            return dimensionCache.get(element);
        }

        if (activeDimensionElements && activeDimensionElements.has(element)) {
            return {top: $element.outerHeight() / 2};
        }

        activeDimensionElements && activeDimensionElements.set(element, true);

        try {
            if ($fitBox.length > 0) {
                setUpElements($child);
                fitBoxDimension = getDimensionOfFitBox($fitBox);
                returnDimension.top = ($fitBox.offset().top - $element.offset().top - (calculatorActually ? 5 : 0)) + fitBoxDimension.top;
                if ($fitBox.find('> [data-calculator-element-type="wrapper"] > .calculator--placeholder').length > 0) {
                    returnDimension.top += (calculatorActually ? 5 : 0);
                }
            } else if ($child.length > 0) {
                returnDimension = setUpOneLevelElements($child);
            } else {
                returnDimension.top = $element.outerHeight() / 2;
            }
        } finally {
            activeDimensionElements && activeDimensionElements.delete(element);
        }

        dimensionCache && dimensionCache.set(element, returnDimension);

        return returnDimension;

    }

    function getDimensionOfFitBox($fitBox) {
        var $child = getFormula($fitBox);
        if ($child.length > 0) {
            return setUpOneLevelElements(getFormula($fitBox));
        }
        return {top: $fitBox.outerHeight() / 2};
    }

    function getDimensionOfElements($elements) {
        var $this,
            dimension,
            returnDimension = {top: 0};

        $elements.each(function () {
            $this = $(this);
            dimension = getDimensionOfElement($this);
            if (dimension.top > returnDimension.top) {
                returnDimension.top = dimension.top;
            }

        });

        return returnDimension;

    }

    function setUpElements($child) {
        var $this,
            $parent;

        $child.each(function () {
            $this = $(this);
            $parent = $this.parent();
            if (!$parent.attr('data-wgroup')) {
                $parent.attr('data-wgroup', ++wGroupSeeker);
                setUpOneLevelElements($parent.find('> ' + elementSelector));
            }
        });
    }

    function setUpOneLevelElements($elements) {
        var $this,
            dimension,
            groupDimension = getDimensionOfElements($elements),
            negativeMargin = 0;

        if ($elements.length < 2) {
            $elements.addClass('skipme');
        }

        if ($elements.length > 1) {
            $elements.each(function () {
                $this = $(this);
                dimension = getDimensionOfElement($this);
                negativeMargin = Math.min(calculatorActually ? -5 : 0, parseInt($this.css('margin-top'), 10));
                $this.css('margin-top', negativeMargin + groupDimension.top - dimension.top);
            });
        }
        return groupDimension;
    }


    exports.setUpElement = setUpElement;
    return exports;

})();

APP.Premium = (function () {

	var exports = {};

	function init() {

	}

	function successWallOfLoveApply() {

	}

	function successPremiumSent() {

	}


	exports.init = init;
	exports.successWallOfLoveApply = successWallOfLoveApply;
	exports.successPremiumSent = successPremiumSent;
	return exports;

})();
APP.Problem = (function () {
    var exports = {},
        $problemWrapper,
        animationDuration = 150,
        resizeTimer = null,
        inited = false,
        $header,
        $htmlBody,

        problemId,
        problemSource,

        actualRowIndex;

    function init() {
        $problemWrapper = $body.find('[data-problem]');
        $header = $body.find('[data-header-gutter]');
        $htmlBody = $('html, body');
        problemId = $problemWrapper.attr('data-id');
        problemSource = $problemWrapper.attr('data-source');
        initBindings();

        if ($problemWrapper.length > 0) {
            $problemWrapper.attr('data-problem', 'initialized');
            APP.ProblemWorker.buildResult(problemId).then(function () {
                clearTimeout(resizeTimer);
                $problemWrapper.attr('data-problem', 'initialized');
                onResize();
                APP.Formula.cosmeticFormulaByWrapper($problemWrapper);
                /*
                    var $mainRows = $body.find('[data-formulas-root] > [data-row-aceholder]');

                    if ($mainRows.length <= 2) {
                        async(function () {
                            $mainRows.first().find('> [data-problem-main-row]').trigger('click');
                        });
                    }
                */
            });
        }
    }

    function initBindings() {
        $body.find('[data-pillar-scroller]').on('scroll', function () {
            $body.find('[data-problem-scroll-wrapper]').parent()
                .css('overflow', 'hidden')
                .scrollLeft($(this).scrollLeft());
        });

        if (!inited) {
            $body.on('click', '[data-problem-row]', clickOnRow);
            $body.on('click', '[data-open-all-main-row]', toggleAllMainRow);
            $body.on('click', '.button[data-academy-trigger]', function () {
                loadAcademyItem($(this));
            });
            $body.on('click', '[data-academy-overlay-trigger]', loadAcademyOverlay);

            $body.on('click', '[data-blank-href]', function () {
                window.open($(this).attr('data-blank-href'));
            });

            $body.on('click', '[data-main-row-close]', function (e) {
                var $row = $(this).parents('[data-problem-main-row]');
                if ($row.attr('data-problem-main-row') === '1') {
                    $row.attr('data-problem-main-row', '0');
                    e.stopPropagation();
                }
            });

            $body.on('click', '[data-problem-main-row] > .problem--border > .problem--row__close', function (e) {
                var $row = $(this).parents('[data-problem-main-row]');

                if (!$row.hasClass('problem--multiple-main-row') && $row.attr('data-row-fullymarked') !== 'true') {
                    async(function () {
                        $row.attr('data-problem-main-row', '1');
                    });
                }

            });

            $body.on('click', '[data-open-secondary-child]', function () {
                var $row = $(this).parents('[data-problem-row]').first();

                $row.removeClass('problem--open-primary-child').addClass('problem--open-secondary-child');
            });

            $body.on('click', '[data-open-primary-child]', function () {
                var $row = $(this).parents('[data-problem-row]').first();

                $row.removeClass('problem--open-secondary-child').addClass('problem--open-primary-child');
            });
            $window.on('resize', onResize);
            $window.on('scroll', APP.ProblemWorker.checkMainRows);
            inited = true;
        }

    }

    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initVerticalScroll, 60);
    }

    function logRowClick($row, event) {
        var open = $row.hasClass('problem--row-hide'),
            deep = $row.parents('[data-problem-row]').length,
            mainRow = $row.attr('data-problem-main-row') === '0';

        if (open && event.originalEvent !== undefined) {
            if (mainRow) {
                APP.Analytics.logCustomUserEvent('view-main-row');
            } else if ($row.attr('data-academy-trigger')){
                APP.Analytics.logCustomUserEvent('view-pictogram');
            } else {
                APP.Analytics.logCustomUserEvent('view-multilevel');
            }
        }

        APP.Analytics.trackEvent('problem', open ? 'open' : 'close', mainRow ? 'mainRow' : 'row', {
            problemId: problemId,
            deep: deep,
            source: problemSource
        });

    }

    function clickOnRow(event) {
        var $row = $(this),
            open = $row.hasClass('problem--row-hide'),
            mainRowPhase;

        event.stopPropagation();
        event.preventDefault();
        logRowClick($row, event);

        if (!$row.hasClass('problem--row-no-child')) {
            mainRowPhase = $row.attr('data-problem-main-row');
            if (mainRowPhase) {
                if (open) {
                    animateToAutoHeight(findInRow($row, '[data-problem-mainrow-accordion]'));
                    closeAllNotParent($row);
                    closeMainRows();
                    $row.attr('data-problem-main-row', 2);
                    openRow($row);
                } else {
                    if ($row.parents('[data-problem-main-row]').length === 0) {
                        closeMainRows();
                        animateToNullHeight(findInRow($row, '[data-problem-mainrow-accordion]'));
                        $row.attr('data-problem-main-row', 0);
                        closeRow($row);
                    } else {
                        closeMainRows();
                        animateToAutoHeight(findInRow($row, '[data-problem-mainrow-accordion]'));
                        $row.attr('data-problem-main-row', 1);
                        closeRow($row);
                    }
                }
            } else {
                if (open) {
                    openRow($row);
                } else {
                    closeRow($row);
                    activateRowIndexes($row.parents('[data-problem-row]').first());
                }
            }
        }
    }

    function activateRowIndexes($row) {
        if (window.USER_SETTINGS.autoCollapseProblem) {
            $problemWrapper.find('.problem--index--active').removeClass('problem--index--active');
            $row.find('.problem--child .problem--index').addClass('problem--index--active');
        } else {
            $row.find('.problem--index:not(.problem--index--active)').addClass('problem--index--active');
        }
    }

    function closeMainRows() {
        var $this;
        if (window.USER_SETTINGS.autoCollapseProblem && false) {
            $problemWrapper.find('[data-problem-main-row]:not([data-problem-main-row="0"])').each(function () {
                $this = $(this);
                $this.attr('data-problem-main-row', 0);
                closeRow($this, true);
            });
        }
    }

    function loadAcademyItem($this) {
        var $wrapper = $body.find($this.attr('data-academy-trigger')).not('[data-academy-loaded]'),
            index = parseInt($this.attr('data-academy-index'), 10),
            open = $this.hasClass('problem--row-hide');

        if (index === 0) {
            index = 'first';
        } else {
            index--;
        }

        APP.Analytics.trackEvent('problem', $this.hasClass('problem--row-hide') ? 'open' : 'close', 'academy', {
            traceid: $this.attr('data-traceid'),
            problemid: problemId,
            source: problemSource
        });

        if ($wrapper.length === 0) {
            return;
        }

        APP.Page.getContentOfUrl($this.attr('data-href'), '[data-ajax-content-' + index + ']', function (source) {
            $wrapper.attr('data-academy-loaded', true).html(source);
            APP.Formula.fillFormulas();
        }, true);
    }

    function loadAcademyOverlay(event) {
        var $this = $(this);

        event.stopPropagation();
        event.preventDefault();

        APP.Analytics.trackEvent('problem', 'open', 'academy-overlay', {
            traceid: $this.attr('data-traceid'),
            url: $this.attr('data-href'),
            problemid: problemId,
            source: problemSource
        });

        if ($this.attr('data-href')) {
            APP.Page.getContentOfUrl($this.attr('data-href'), '[data-ajax-content]', function (result) {
                $body.find('[data-academy-overlay]').html(result);
                APP.Formula.fillFormulas();
                APP.Layout.openOverlay('academy-item');
            });

        }

    }

    function toggleAllMainRow() {
        if (!putAllMaiRowInSecondPhase()) {
            animateToNullHeight($body.find('[data-problem-mainrow-accordion]'));
            $body.find('[data-problem-main-row]').attr('data-problem-main-row', 0);
            $body.find('[data-problem-main-row]').each(function () {
                var $row = $(this);
                closeRow($row);
            });
        } else {
            animateToAutoHeight($body.find('[data-problem-mainrow-accordion]'));
            $body.find('[data-problem-main-row="2"]').each(function () {
                var $this = $(this);
                if (!$this.find('[data-problem-main-row]').length) {
                    closeRow($(this));
                }
            });
            $body.find('[data-problem-main-row]').attr('data-problem-main-row', 1);
            $body.find('[data-problem-main-row].problem--multiple-main-row').each(function () {
                $(this).attr('data-problem-main-row', 2);
                openRow($(this), true);
            });
        }

    }

    function putAllMaiRowInSecondPhase() {
        return $body.find('[data-problem-main-row="0"]').length > 1;
    }


    function findInRow($row, selector) {
        return $row.find(selector).not($row.find('[data-problem-gate] ' + selector));
    }

    function openRow($row, preventScrollTo) {
        var hasMultipleOpener = $row.find('> div .problem--wrapper > .problem--toggler-button--wrapper > [data-open-secondary-child]').length > 0
            && !$row.hasClass('problem--multiple-main-row');

        styleRow($row);
        $row.find('[data-operation].show').removeClass('show');
        setTimeout(function() {
            $row.find('[data-operation]').addClass('show');
        }, 120);

        APP.ProblemWorker.openRow($row.parents('[data-row-placeholder]').attr('data-row-placeholder'));
        if ($row.attr('data-academy-trigger')) {
            loadAcademyItem($row);
        }

        if (hasMultipleOpener && !$row.hasClass('problem--open-primary-child') && !$row.hasClass('problem--open-secondary-child')) {
            // prevent open because of multiple opener.
        } else if ($row.hasClass('problem--row-hide')) {
            var $childWrapper = findInRow($row, '[data-problem-child]');
            closeAllNotParent($row);
            actualRowIndex = parseInt($row.attr('data-row-index'), 10);


            animateToAutoHeight(findInRow($row, '[data-problem-accordion]'), function () {
                $row.removeClass('problem--row-hide');
                fadeIn($childWrapper, function () {
                    $childWrapper
                        .removeClass('problem--child-no-gutter')
                        .removeClass('problem--child-hide');
                    findInRow($childWrapper, '[data-problem-row]:not(.problem--row-never-borderize)')
                        .addClass('problem--row-borderize');
                    if (!preventScrollTo) {
                        setTimeout(function () {
                            scrollToRow($row);
                        }, 300);
                    }
                });
            });
        }
        activateRowIndexes($row);
    }

    function closeAllNotParent($row) {
        var $this;

        if (window.USER_SETTINGS.autoCollapseProblem && false) {
            $problemWrapper.find('.problem--row-open-it').removeClass('problem--row-open-it');
            $row.addClass('problem--row-open-it');
            $problemWrapper.find('.problem--row:not(.problem--row-hide)').each(function () {
                $this = $(this);
                if (
                    $this.find('.problem--row-open-it').length === 0 &&
                    (
                        $this.parents('.problem--row:not(.problem--row-hide)').find('.problem--row-open-it').length > 0 ||
                        $this.parents('.problem--row:not(.problem--row-hide)').length === 0
                    )
                ) {
                    closeRow($this, actualRowIndex < parseInt($row.attr('data-row-index'), 10));
                    $this.addClass('problem--row-hide');

                }
            });
        }

    }

    function styleRow($row) {
        styleFormulas(getSubRowFormulas($row));
    }

    function styleFormulas($formula) {
        var $this;
        $formula.each(function () {
            $this = $(this);
            if ($this.attr('data-formula-styled') !== 'true') {
                $this.attr('data-formula-styled', 'true');
                APP.Formula.cosmeticFormulaByWrapper($this);
                styleMessage($this);
            }
        });
    }

    function styleMessage($this) {
        $this.find('[data-message-insert]').each(function () {
            var $insert = $(this),
                $formulaTest = $insert.find('[data-formula-test]'),
                topDistance = parseInt($formulaTest.css('margin-top'), 10),
                bottomDistance = $insert.height() - $formulaTest.height() - topDistance;
            $insert.css({
                'margin-bottom': Math.max(0, topDistance - bottomDistance),
                'margin-top': Math.max(0, bottomDistance - topDistance)
            });
        });
    }

    function getSubRowFormulas($row) {
        var $rowArea = $row.find('[data-problem-row]').not($row.find('[data-problem-row] [data-problem-row]'));
        return findInRow($rowArea, '.problem--formula-wrapper');
    }

    function closeRow($row, preventScroll) {
        APP.ProblemWorker.closeRow($row.parents('[data-row-placeholder]').attr('data-row-placeholder'));
        $body.find('.problem--open-secondary-child, .problem--open-primary-child')
            .removeClass('problem--open-secondary-child')
            .removeClass('problem--open-primary-child');


        var originalHeight = $row.outerHeight(),
            scrollTop = document.body.scrollTop;

        $row.find('[data-operation]').removeClass('show');
        $row.addClass('notransition');
        $row.css('height', '');
        closeRowViaClass($row);
        $row.removeClass('notransition');
        if ($row.attr('data-problem-main-row')) {
            $row.attr('data-problem-main-row', '0');
        }
        if ($row.offset().top + originalHeight < scrollTop + window.innerHeight / 2)
            async(function () {
                bodyScroll(scrollTop + $row.outerHeight() - originalHeight);
            });


        if ($row.attr('data-problem-main-row')) {
            $row.attr('data-problem-main-row', '0');
        }

        function closeRowViaClass($actualRow) {
            $actualRow.addClass('problem--row-hide');
            $actualRow.find('[data-problem-row]')
                .addClass('problem--row-hide')
                .removeClass('problem--row-borderize');
            $actualRow.find('[data-problem-child]')
                .addClass('problem--child-no-gutter')
                .addClass('problem--child-hide');

        }

    }

    function bodyScroll(distance) {
        document.body.scrollTop = distance;
        if (distance < 0) {
            $header.addClass('no-transition');
            $header.css('padding-top', -distance);
            async(function () {
                $header.removeClass('no-transition');
                $header.css('padding-top', 0);
            });
        }
    }

    function initVerticalScroll() {
        var $pillarBox = $body.find('[data-problem-pillar-wrapper]'),
            $scrollWrapper = $body.find('[data-problem-scroll-wrapper]'),
            gutter = 30,
            contentWidth,
            wrapperWidth;

        $pillarBox.removeClass('pillar-box--scroller');
        $pillarBox.removeClass('pillar-box--growing');
        $scrollWrapper.css('width', 'auto');
        contentWidth = $scrollWrapper.outerWidth();
        wrapperWidth = $pillarBox.outerWidth();
        $scrollWrapper.css('width', '100%');

        $body.find('[data-pillar-scroller] div').css('width', 0);

        if (contentWidth > wrapperWidth) {
            $pillarBox.addClass('pillar-box--growing');
            if (contentWidth > $window.width() - gutter) {
                $pillarBox.addClass('pillar-box--scroller');
                $body.find('[data-pillar-scroller] div').css('width', $scrollWrapper.outerWidth() + gutter);
            } else {
                $pillarBox.removeClass('pillar-box--scroller');
            }

        }

    }

    function animateToAutoHeight($elements, callback) {
        $elements.each(function (index, element) {
            var $element = $(element);

            if ($element.height() !== 0) {
                return;
            }

            $element.css('height', 'auto');
            if (!index && callback) {
                callback();
            }
            $element.css('height', 0);
            async(function () {
                $element.css('height', '');
            });
        });
    }

    function animateToNullHeight($elements, callback) {
        $elements.each(function (index, element) {
            var $element = $(element);

            if ($element.height() === 0) {
                return;
            }
            $element.css('height', '');
            if (!index && callback) {
                callback();
            }
        });
    }

    function fadeIn($elements, callback) {
        $elements.each(function (index, element) {
            var $element = $(element);
            $element.animate({
                opacity: 1
            }, {
                duration: animationDuration,
                queue: false,
                complete: function () {
                    callback();
                    $element.css('opacity', '');
                }
            });
        });
    }

    function scrollToRow($row) {
        var winHeight = $window.height() - 60,
            rowHeight = $row.height(),
            rowTop = $row.offset().top,
            scrollTop = rowTop - Math.min(Math.max(0, winHeight - rowHeight), winHeight),
            winScrollTop = $window.scrollTop();

        if (winScrollTop < scrollTop) {
            $htmlBody.animate({scrollTop: scrollTop - 60}, 300);
        } else if (rowTop < winScrollTop || (rowTop + rowHeight) > (scrollTop + winHeight)) {
            $htmlBody.animate({scrollTop: rowTop - 60}, 300);
        }

    }

    exports.init = init;
    exports.scrollToRow = scrollToRow;
    exports.initVerticalScroll = initVerticalScroll;
    exports.onResize = onResize;
    exports.openRow = openRow;
    return exports;

})();

APP.NewsFeed = (function () {

    var exports = {},
        initialized = false,
        windowFocused = true,
        windowFocusedCallback = false,
        latestRefresh = new Date(0),

        refreshCallback,

        storyTimer = {},

        actualFeedFilterId,

        userCount = -1;

    function init() {
        actualFeedFilterId = 'all';
        userCount = -1;
        initBindings();
        loadNewsFeed();
        refreshUnapprovedUsers();
        autoRefreshGroup();
        $body.find('[data-newsfeed-story-initialize]').each(function () {
            refreshStory($(this).attr('data-newsfeed-story'));
        });
    }

    function loadNewsFeed(reset) {
        $body.find('[data-newsfeed]').each(function () {
            var $this = $(this);

            if (reset) {
                $this.html('<div class="newsfeed__item newsfeed__item--loading" data-hide-when-loaded></div>'.repeat(4));
            }
            initNewsFeed($this, $this.attr('data-newsfeed'));
        });
    }

    function initBindings() {
        if (!initialized) {
            initialized = true;

            window.addEventListener('focus', function () {
                windowFocused = true;
                if (windowFocusedCallback) {
                    windowFocusedCallback();
                }
            }, false);

            window.addEventListener('blur', function () {
                windowFocused = false;
            }, false);

            $body.on('click', '[data-newsfeed-refresh]', function () {
                APP.Page.reloadPage();
            });

            $body.on('click', '[data-newsfeed-load-more]', function () {
                var $this = $(this);
                $this.hide();
                initNewsFeed(
                    $this.parent(),
                    $body.find('[data-newsfeed]').attr('data-newsfeed'),
                    {before: $this.attr('data-newsfeed-load-more')},
                    true
                );
            });

            $body.on('click', '[data-like-story]', function (event) {
                var $this = $(this),
                    $counter = $this.find('[data-count]'),
                    index = parseInt($counter.text()) || 0;

                event.stopPropagation();
                likeUnLikeStory(true, $this.attr('data-like-story'));
                $this.addClass('button--red').removeClass('button--gray');
                $counter.text(++index);
            });

            $body.on('click', '[data-unlike-story]', function (event) {
                var $this = $(this),
                    $counter = $this.find('[data-count]'),
                    index = parseInt($counter.text()) || 0;
                event.stopPropagation();
                likeUnLikeStory(false, $this.attr('data-unlike-story'));
                $this.removeClass('button--secondary').addClass('button--gray');
                $counter.text(--index || '');
            });
/*
            $body.on('click', '[data-newsfeed-story]', function () {
                var id = $(this).attr('data-newsfeed-story');
                refreshStory(id);
            });
*/
            $body.on('click', '[data-show-group-users]', function () {
                var targetId = $(this).attr('data-show-group-users');
                loadUsersList('group-users', targetId);
            });

            $body.on('click', '[data-show-unapproved-users]', function () {
                var targetId = $(this).attr('data-show-unapproved-users');
                loadUsersList('group-unapproved-users', targetId);
            });

            $body.on('click', '[data-show-story-likes]', function () {
                var targetId = $(this).attr('data-show-story-likes');
                loadUsersList('story-likes', targetId);
            });

            $body.on('click', '[data-group-show-details]', function () {
                expandOwnSolutionDetails($(this));
            });

            $body.on('click', '[data-group-hide-details]', function () {
                collapseOwnSolutionDetails($(this));
            });

            $body.on('change', '[data-user-setting-checkbox="autoExpandOwnSolutions"]', function () {
                applyAutoExpandSetting($body);
            });

            $body.on('click', '[data-open-overlay="new-group-challenge"]', function () {
                $body.find('[data-overlay="new-group-challenge"] [name="popup"]').prop('checked', true);
                APP.Ajax.post('/hu/service/get-user-list', {
                    listType: 'group-active-members',
                    targetId: $body.find('[data-actual-group-id]').attr('data-actual-group-id')
                }).then(function (result) {
                    if (result.success) {
                        var members = (result.result && result.result['group-member']) || [];
                        var $overlay = $body.find('[data-overlay="new-group-challenge"]');

                        $overlay.find('[data-challenge-empty-state]').toggle(members.length === 0);
                        $overlay.find('[data-challenge-form-content]').toggle(members.length > 0);

                        if (members.length > 0) {
                            APP.Form.searchSelect($body.find('[data-search-select-challenge]')[0]);
                            $body.find('[data-challenge-users-list]').html(
                                APP.Tpl.run('challenge-users-list', result.result)
                            );
                        }
                    }
                }, window.NOOP);
            });

            $body.on('click', '[data-refresh-user-list]', function () {
                if (refreshCallback) {
                    refreshCallback();
                }
            });

            $body.on('click', '[data-user-action]', function () {
                var $this = $(this),
                    action = $this.attr('data-user-action').split(':'),
                    actionName = action[0],
                    targetId = action[1],
                    groupId = $body.find('[data-actual-group-id]').attr('data-actual-group-id');

                APP.Ajax.post('/hu/service/group/action', {
                    actionName: actionName,
                    targetId: targetId,
                    groupId: groupId
                }).then(function (response) {
                    if (response.success) {
                        APP.Layout.closeOverlay();
                        APP.Layout.openOverlay('success-action');
                        APP.Layout.onOverlayClose(function () {
                            APP.Page.reloadPage();
                        });
                    } else {
                        APP.Layout.closeOverlay();
                        APP.Layout.openOverlay('fail-action');
                    }
                }, window.NOOP);
            });

            $body.on('click', '[data-user-edit]', function () {
                var $this = $(this),
                    attr = $this.attr('data-user-edit').split('::'),
                    id = attr[0],
                    email = attr[1],
                    name = attr[2],
                    $overlay,
                    groupId = $body.find('[data-actual-group-id]').attr('data-actual-group-id');

                if (email.indexOf('/') > -1) {
                    $overlay = $body.find('[data-overlay="edit-user-name"]');
                    $overlay.find('[name="name"]').val(name);
                    $overlay.find('[name="userId"]').val(id);
                    $overlay.find('[name="groupId"]').val(groupId);
                    APP.Layout.openOverlay('edit-user-name');
                } else {
                    $overlay = $body.find('[data-overlay="edit-user-email"]');
                    $overlay.find('[name="email"]').val(email);
                    $overlay.find('[name="userId"]').val(id);
                    $overlay.find('[name="groupId"]').val(groupId);
                    APP.Layout.openOverlay('edit-user-email');
                }
            });

            $body.on('change', '[data-group-hide-user-actions]', function () {
                var $this = $(this),
                    checked = $this.prop('checked');

                APP.User.setSetting('hide-user-activity-in-group', checked).then(function () {
                    loadNewsFeed(true);
                });
            });

            $body.on('click', '[data-delete-group]', function () {
                var $this = $(this),
                    groupId = $this.attr('data-delete-group'),
                    password = $body.find('[data-delete-password]').val();

                APP.Ajax.post('/hu/service/group/delete', {
                    groupId: groupId,
                    password: password
                }).then(function (result) {
                    if (result.success) {
                        APP.Layout.openOverlay('success-delete-group');
                        APP.Layout.onOverlayClose(function () {
                            APP.Page.applyPageByUrl('/hu/');
                        });
                    } else {
                        APP.Layout.openOverlay('failed-delete-group');
                    }
                }, window.NOOP);
            });

            $body.on('click', '[data-feed-filter]', function (e) {
                var $this = $(this),
                    feedFilterId = $this.attr('data-feed-filter');

                actualFeedFilterId = feedFilterId;
                loadNewsFeed(true);
                $body.find('[data-feed-filter]')
                    .removeClass('button--gray')
                    .addClass('button--white');
                $body.find(`[data-feed-filter="${feedFilterId}"]`)
                    .addClass('button--gray')
                    .removeClass('button--white');
                e.preventDefault();
                e.stopPropagation();
            });

        }
    }

    function expandOwnSolutionDetails($trigger) {
        var details = JSON.parse(base64Decode($trigger.attr('data-group-show-details'))),
            $story = $trigger.parents('[data-newsfeed-story]').first(),
            solutionDataParts,
            solutionData;

        if (((details.details || {}).problem || {}).solutionLink) {
            solutionDataParts = details.details.problem.solutionLink.split('/');
            if (solutionDataParts.length > 2) {
                try {
                    solutionData = JSON.parse(base64Decode(solutionDataParts[3]));
                    if ((solutionData.clone || {}).message) {
                        details.details.problem.instruction = solutionData.clone.message;
                    }
                } catch (e) {
                    APP.Error.logError(e, {
                        source: 'APP.NewsFeed.expandOwnSolutionDetails',
                        context: {
                            solutionLink: details.details.problem.solutionLink
                        }
                    });
                }
            }
        }

        APP.ProblemWorker.run('newsfeed-input-details', details).then(function (result) {
            var $item = $story.find('[data-nf-input-details]');
            $item.html(result);
            APP.Formula.cosmeticFormulaByWrapper($item);
            $trigger.hide();
        });
    }

    function collapseOwnSolutionDetails($trigger) {
        var $story = $trigger.parents('[data-newsfeed-story]').first(),
            $show = $story.find('[data-group-show-details]'),
            $item = $story.find('[data-nf-input-details]');

        $item.empty();
        $show.css('display', '');
    }

    function applyAutoExpandSetting($scope) {
        if (!window.USER_SETTINGS) {
            return;
        }

        var shouldExpand = !!window.USER_SETTINGS.autoExpandOwnSolutions;

        $scope.find('[data-newsfeed-story]').each(function () {
            var $story = $(this),
                $show = $story.find('[data-group-show-details]'),
                isExpanded;

            if (!$show.length) {
                return;
            }

            isExpanded = $show.css('display') === 'none';
            if (shouldExpand && !isExpanded) {
                expandOwnSolutionDetails($show);
            } else if (!shouldExpand && isExpanded) {
                collapseOwnSolutionDetails($story.find('[data-group-hide-details]'));
            }
        });
    }

    function initNewsFeed($wrapper, serviceUrl, data, ignoreCount) {
        serviceUrl += document.location.search;
        data = data || {};
        if (!window.USER_SETTINGS['hide-user-activity-in-group']) {
            data.feedFilterId = actualFeedFilterId;
        }
        return APP.Ajax.post(serviceUrl, data).then(function (result) {
            var firstDate = result.result.firstDate;
            var count = result.result.count;

            if (new Date(firstDate) > new Date(latestRefresh)) {
                latestRefresh = firstDate;
                $body.find('[data-newsfeed-first-date]').attr('data-newsfeed-first-date', latestRefresh);
            }
            $wrapper.find('[data-hide-when-loaded]').hide();
            APP.ProblemWorker.run('newsfeed', result.result).then(function (result) {
                $wrapper.prepend(result);
                APP.Layout.setMoments();
                APP.Formula.fillFormulas();
                applyAutoExpandSetting($wrapper);
            });
            if (count && !ignoreCount) {
                Object.keys(count).forEach(function (key) {
                    $body.find(`[data-feed-filter="${key}"] span`).text(`(${count[key]})`);
                });
            }
        }, window.NOOP);
    }

    function loadNewNewsFeedContent($wrapper, serviceUrl, data) {
        if (!serviceUrl) {
            return Promise.resolve();
        }

        serviceUrl += document.location.search;

        return APP.Ajax.post(serviceUrl, data, true).then(function (result) {
            var firstDate = result.result.firstDate;
            var count = result.result.count;
            var $item, value;

            if (new Date(firstDate) > new Date(latestRefresh)) {
                latestRefresh = firstDate;
                $body.find('[data-newsfeed-first-date]').attr('data-newsfeed-first-date', latestRefresh);
            }
            $wrapper.find('[data-hide-when-loaded]').hide();
            if (result.result.items) {
                APP.ProblemWorker.run('newsfeed', result.result).then(function (result) {
                    $wrapper.prepend(result);
                    APP.Layout.setMoments();
                    APP.Formula.fillFormulas();
                    applyAutoExpandSetting($wrapper);
                });
            }
            if (count) {
                Object.keys(count).forEach(function (key) {
                    if (count[key] > 0) {
                        $item = $body.find(`[data-feed-filter="${key}"] span`);
                        value = $item.text();
                        value = parseInt(value.substr(1, value.length - 2), 10);
                        $item.text(`(${(value + count[key])})`);
                    }
                });
            }
        }, window.NOOP);
    }

    function setStudyRange(action, start, end, autoPlay) {
        var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        APP.Race.saveStudyRangePreference(action, start, end, timezone);
        APP.Race.load(autoPlay);
    }

    function refreshUnapprovedUsers() {
        var $wrapper = $body.find('[data-group-unapproveds]'),
            $target = $body.find('[data-actual-group-id]');

        if ($wrapper.length + $target.length > 1) {
            APP.Ajax.post('/hu/service/get-user-list', {
                listType: 'group-unapproved-users',
                targetId: $target.attr('data-actual-group-id')
            }, true).then(function (result) {
                if (result.success && result.result) {
                    if (result.userCount && userCount !== result.userCount[1]) {
                        userCount = result.userCount[1];
                        $body.find('[data-group-users-count]').text(result.userCount[1]);
                        APP.Race.load();
                    }
                    $wrapper.html(
                        APP.Tpl.run('group-unapproveds', {users: result.result['unapproved-group-member']})
                    );
                }
            }, window.NOOP);
        } else {
            APP.Race.load();
        }
    }

    function refreshStory(storyId) {
        window.clearTimeout(storyTimer[storyId]);
        storyTimer[storyId] = window.setTimeout(function () {
            APP.Ajax.post('/hu/service/story/refresh', {
                id: storyId
            }, true).then(function (result) {
                if (result.success) {
                    var $storyCard = $body.find('[data-newsfeed-story="' + storyId + '"]'),
                        $storyCardActions = $storyCard.find('[data-nf-card-actions]');
                    if ($storyCardActions.length) {
                        $storyCardActions.html(
                            APP.Tpl.run('newsfeed-card-actions', result.result)
                        );
                    } else {
                        $storyCard.html(APP.Tpl.run('newsfeed-card', result.result));
                        APP.Layout.setMoments();
                        APP.Formula.fillFormulas();
                    }
                    applyAutoExpandSetting($storyCard);
                }
            }, window.NOOP);
        }, 500);
    }

    var autoRefreshTimeout;
    var refreshCounter = 0;

    function autoRefreshGroup() {
        windowFocusedCallback = false;
        var groupId = $body.find('[data-actual-group-id]').attr('data-actual-group-id');
        if (groupId) {
            APP.Live.onGroupEvent(groupId, (event) => {
                if (event === 'changed-users') {
                    refreshUnapprovedUsers();
                } else if (event === 'activity') {
                    $body.find('[data-last-activity]').attr('data-ago-moment', new Date());
                    if (++refreshCounter < 20) {
                        clearTimeout(autoRefreshTimeout);
                        autoRefreshTimeout = setTimeout(() => {
                            refreshCounter = 0;
                            refreshGroupPage();
                            APP.Layout.setMoments();
                        }, 3000);
                    }
                }
            });
        }
    }


    function refreshGroupPage() {
        var $wrapper = $('<div />'),
            $nf = $body.find('[data-newsfeed]'),
            data = {after: latestRefresh};

        if (!$nf.length || !$nf.attr('data-newsfeed')) {
            return;
        }

        if (!window.USER_SETTINGS['hide-user-activity-in-group']) {
            data.feedFilterId = actualFeedFilterId;
        }
        $wrapper.prependTo($nf);
        loadNewNewsFeedContent($wrapper, $nf.attr('data-newsfeed'), data).then(function () {
            window.requestAnimationFrame(function () {
                $wrapper.find('[data-newsfeed-content]').remove();
            });
        });
    }

    function likeUnLikeStory(like, storyId) {
        APP.Ajax.post('/hu/service/story/' + (like ? 'like' : 'unlike'), {
            id: storyId
        }).then(function () {
            refreshStory(storyId);
        }, window.NOOP);
    }

    function loadUsersList(listType, targetId) {
        APP.Ajax.post('/hu/service/get-user-list', {
            listType: listType,
            targetId: targetId
        }).then(function (result) {
            if (result.success) {
                showUsersList(result.result, listType, targetId);
            }
        }, window.NOOP);
    }

    function showUsersList(users, listType, targetId) {
        $body.find('[data-users-list]').html(
            APP.Tpl.run('users-list', users)
        );
        refreshCallback = function () {
            loadUsersList(listType, targetId);
        };
        APP.Layout.openOverlay('users-list');
    }

    function reloadNewsFeedContent() {
        APP.Layout.closeOverlay();
        refreshGroupPage();
    }

    function redirectToGroup(result) {
        APP.Page.applyPageByUrl('/hu/group/' + result.result);
    }

    function groupSettingsSaved() {
        APP.Layout.openOverlay('group-settings-saved');
    }

    function successCodeConnect(result) {
        var topic = result.message.topic,
            url = '/hu/learn/' + (topic ? 'topic/' + topic : '');

        $body.find('[data-go-to-learn]').attr('href', url);
        APP.Layout.openOverlay('group-success-code-' + result.message.mode);
        APP.Layout.onOverlayClose(function () {
            APP.Page.applyPageByUrl(url);
        });
    }

    exports.init = init;
    exports.reloadNewsFeedContent = reloadNewsFeedContent;
    exports.redirectToGroup = redirectToGroup;
    exports.groupSettingsSaved = groupSettingsSaved;
    exports.successCodeConnect = successCodeConnect;
    exports.setStudyRange = setStudyRange;
    return exports;

})();

/* global module */
(function (root, factory) {
    var helpers = factory();

    root.APP = root.APP || {};
    root.APP.RaceHelpers = helpers;

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = helpers;
    }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    var GREEN = '#38d090';

    function parseTimestamp(value) {
        if (value === null || typeof value === 'undefined' || value === '') {
            return {
                state: 'missing',
                value: null
            };
        }

        var ms = new Date(value).getTime();
        if (!Number.isFinite(ms)) {
            return {
                state: 'invalid',
                value: null
            };
        }

        return {
            state: 'valid',
            value: ms
        };
    }

    function pickLatestTimestamp(currentValue, nextValue) {
        var current = parseTimestamp(currentValue);
        var next = parseTimestamp(nextValue);

        if (next.state === 'valid' && current.state === 'valid') {
            return next.value >= current.value ? nextValue : currentValue;
        }
        if (next.state === 'valid') {
            return nextValue;
        }
        if (current.state === 'valid') {
            return currentValue;
        }

        return '';
    }

    function getRaceVisualState(lastProgressAt, thresholdMs, nowValue) {
        var threshold = Number(thresholdMs);
        var now = Number(nowValue);
        var progress = parseTimestamp(lastProgressAt);
        var timePassed;

        if (!Number.isFinite(threshold) || threshold <= 0 || !Number.isFinite(now)) {
            return {
                timeout: false,
                color: '',
                invalid: true
            };
        }

        if (progress.state === 'missing') {
            return {
                timeout: true,
                color: '',
                invalid: false
            };
        }

        if (progress.state !== 'valid') {
            return {
                timeout: false,
                color: '',
                invalid: true
            };
        }

        timePassed = Math.max(0, now - progress.value);
        if (timePassed >= threshold) {
            return {
                timeout: true,
                blink: timePassed >= threshold * 2,
                color: '',
                invalid: false
            };
        }

        return {
            timeout: false,
            color: GREEN,
            invalid: false
        };
    }

    function getDirectProgressTotal(item) {
        item = item || {};

        return (Number(item.before) || 0) +
            (Number(item.actual) || 0) +
            (Number(item.after) || 0);
    }

    function getDirectProgressActual(item) {
        item = item || {};

        return Number(item.actual) || 0;
    }

    function compareByDirectProgress(a, b, compareNames) {
        var total = getDirectProgressTotal(b) - getDirectProgressTotal(a);
        var actual;

        if (total !== 0) {
            return total;
        }

        actual = getDirectProgressActual(b) - getDirectProgressActual(a);
        if (actual !== 0) {
            return actual;
        }

        return typeof compareNames === 'function' ? compareNames(a, b) : 0;
    }

    function compareByTopicIndex(a, b, compareNames) {
        var aIndex = (a && a.idx) || '';
        var bIndex = (b && b.idx) || '';

        if (aIndex !== bIndex) {
            return String(aIndex).localeCompare(String(bIndex), undefined, {numeric: true});
        }

        return typeof compareNames === 'function' ? compareNames(a, b) : 0;
    }

    function isRaceActive(focus, lastSignalAt, thresholdMs, nowValue, focusKnown) {
        if (focusKnown === true) {
            return focus === true;
        }

        if (focus === true) {
            return true;
        }

        var signal = parseTimestamp(lastSignalAt);
        var threshold = Number(thresholdMs);
        var now = Number(nowValue);

        if (signal.state !== 'valid' || !Number.isFinite(threshold) || threshold <= 0 || !Number.isFinite(now)) {
            return false;
        }

        return Math.max(0, now - signal.value) <= threshold;
    }

    return {
        GREEN: GREEN,
        parseTimestamp: parseTimestamp,
        pickLatestTimestamp: pickLatestTimestamp,
        getRaceVisualState: getRaceVisualState,
        getDirectProgressTotal: getDirectProgressTotal,
        getDirectProgressActual: getDirectProgressActual,
        compareByDirectProgress: compareByDirectProgress,
        compareByTopicIndex: compareByTopicIndex,
        isRaceActive: isRaceActive
    };
});

var Row = function () {
    var _self = this,
        _element,
        $element,

        id,
        callbacks = {open: [], close: [], check: []},

        filled = false,
        rendering = false,
        opened = false,
        visible,
        inGame = false;

    _self.Parent = null;
    _self.Children = [];

    _self.init = function (_$element, _Parent) {
        _element = _$element[0];
        $element = _$element;
        id = _$element.attr('data-row-placeholder');
        $element.addClass('problem-row-placeholder--inited');
        _self.Parent = _Parent;

        if (_self.Parent) {
            inGame = _self.Parent.isOpened();
            _self.Parent.onOpen(function () {
                inGame = true;
                checkOnScreen();
            });
            _self.Parent.onClose(function () {
                inGame = false;
            });
            _self.Parent.onCheck(checkOnScreen);
            _self.Parent.addChild(_self);
        } else {
            inGame = true;
            checkOnScreen();
        }
    };

    _self.getId = function () {
        return id;
    };

    _self.onOpen = function (callback) {
        callbacks.open.push(callback);
    };

    _self.onClose = function (callback) {
        callbacks.close.push(callback);
    };

    _self.onCheck = function (callback) {
        callbacks.check.push(callback);
    };

    _self.isOpened = function () {
        return opened;
    };

    _self.addChild = function (child) {
        _self.Children.push(child);
    };

    _self.getElement = function () {
        return $element;
    };

    _self.open = function () {
        opened = true;
        APP.ProblemWorker.fillPlaceholderStackByWrapper($element);
        callAll(callbacks.open);
        setTimeout(function () {
            _self.Children.forEach(function (child) {
                child.parentOpened();
            });
        }, 120);
    };

    _self.parentOpened = function () {
        if (amIOnlyChild()) {
            APP.Problem.openRow($element.find('> [data-problem-row]'), true);
        }
    };

    _self.close = function () {
        opened = false;
        callAll(callbacks.close);
        setTimeout(APP.ProblemWorker.checkMainRows, 300);
    };
    _self.check = function () {
        async(checkOnScreen);
    };

    function callAll(cb) {
        var i;
        for (i = 0; i < cb.length; i++) {
            cb[i]();
        }
    }

    function onScreen() {
        show();
    }

    function offScreen() {
        hide();
    }

    function show() {
        if (visible !== true) {
            $element.removeClass('problem-row-placeholder--hide');
            _element.style.height = 'auto';
            visible = true;
            APP.Problem.onResize();
            if (!filled) {
                render();
            }
        }
    }

    function hide() {
        if (visible !== false) {
            _element.style.height = _element.offsetHeight + 'px';
            $element.addClass('problem-row-placeholder--hide');
            visible = false;
            APP.Problem.onResize();
        }
    }

    function render() {
        rendering = true;
        filled = true;
        APP.ProblemWorker.getContent(id, function (content) {
            $element.html(content);
            prepare();
            window.requestAnimationFrame(function () {
                $element.addClass('problem-row-placeholder--loaded');
                rendering = false;
                window.requestAnimationFrame(function () {
                    APP.ProblemWorker.fillPlaceholderStackByWrapper($element);
                });
            });
        });
    }

    function prepare() {
        APP.Formula.cosmeticFormulaByWrapper($element);
    }

    function checkOnScreen() {
        if (inGame && !rendering) {
            var rect = _element.getBoundingClientRect(),
                clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                viewHeight = Math.max(clientHeight, window.innerHeight);

            if (rect.bottom < 0 || rect.top - viewHeight >= 0) {
                offScreen();
            } else {
                onScreen();
                callAll(callbacks.check);
            }
        }
    }

    function amIOnlyChild() {
        return _self.Parent && _self.Parent.Children.length <= 1;
    }

    return _self;

};

APP.Analytics = (function () {
    var exports = {},
        logedIn,
        initialized = false;

    function init() {
        logedIn = $body.find('.application').hasClass('user--logedin');
        userInitialization();
        initBindings();
    }

    function userInitialization() {
        if (!initialized && window.TRACK) {
            const isLogout = new URLSearchParams(window.location.search).get('logout') === 'true';
            const properties = {
                app_language: window.LANGUAGE,
                subscription_status: window.IS_USER_PRO ? 'pro' : 'free',
                is_admin: !!window.IS_ADMIN
            };

            if (window.posthog) {
                if (logedIn) {
                    window.posthog.identify(window.USER_ID, properties);
                } else if (isLogout) {
                    window.posthog.reset();
                }
            }
            if (window.gtag) {
                if (logedIn) {
                    window.gtag('set', { user_id: window.USER_ID });
                    window.gtag('set', 'user_properties', properties);
                } else if (isLogout) {
                    window.gtag('set', { user_id: undefined });
                    window.gtag('set', 'user_properties', {
                        app_language: undefined,
                        subscription_status: undefined
                    });
                }
            }
        }
        initialized = true;
    }

    function checkStuffs() {
        $body.find('[data-track-purchase]').each(function () {
            var $this = $(this),
                val = $this.attr('data-track-purchase').split(';');

            APP.Analytics.successPayment(val[0], val[1], val[2], val[3]);
        });
        $body.find('[data-track-custom]').each(function () {
            var $this = $(this),
                val = $this.attr('data-track-custom').split(';');

            APP.Analytics.logCustomUserEvent(val[0], val[1]);
        });
    }

    function phCapture(eventName, props) {
        if (!window.posthog) {
            console.log('send to posthog', eventName, props);
            return;
        }

        window.posthog.capture(eventName, props || {});
    }

    function pageView() {
        if (window.TRACK) {
            phCapture('$pageview', {
                url: document.location.pathname,
                title: document.title
            });
            logCustomUserEvent('page-view', {url: document.location.pathname, title: document.title});
            checkStuffs();
            if (window.gtag) {
                window.gtag('event', 'page_view', {
                    page_location: window.location.href,
                    page_title: document.title
                });
            }
        }
    }

    function initBindings() {
        $body.on('click', '[data-ga-event]', logEvent);
        $window.focus(function () {
            trackEvent('window', 'focus');
            APP.Live.saveClientMeta('focus', true);
        }).blur(function () {
            trackEvent('window', 'blur');
            APP.Live.saveClientMeta('focus', '');
        }).on("beforeunload", function () {
            APP.Live.saveClientMeta('closed', true);
        });
    }

    function logEvent() {
        var $this = $(this),
            label = $this.attr('data-ga-event').split(':');

        trackEvent(label[0], 'click', label[1]);
    }

    function trackEvent(category, action, label, value) {
        sendLocalEvent(category, action, label, value);

        if (window.TRACK) {
            phCapture('ui event', {
                category: category,
                action: action,
                label: label,
                value: value
            });
            if (window.gtag) {
                window.gtag('event', action, {
                    event_category: category,
                    event_label: label,
                    value: value
                });
            }
        }
    }

    function trackFormSubmit(action, $form) {
        var data = serializeForm($form);

        logCustomUserEvent('form-submit', {data: data, action: $form.attr('action')});
        phCapture('form submitted', {data: data, action: $form.attr('action')});
    }

    function serializeForm($form) {
        var o = {},
            a = $form.serializeArray();

        a.forEach(function (field) {
            let value = field.value || '';

            if (field.name.includes('password')) {
                value = '***';
            }

            if (o[field.name] !== undefined) {
                if (!Array.isArray(o[field.name])) {
                    o[field.name] = [o[field.name]];
                }
                o[field.name].push(value);
            } else {
                o[field.name] = value;
            }
        });

        return o;
    }

    function sendLocalEvent(category, action, label, value) {
        if (window.log) {
            console.log(window.TRACK ? 'track:' : 'not tracked:', [category || null, action || null, label || null, value || null]);
        }
    }

    function logError(error) {
        APP.Error.logError(error, {
            source: 'APP.Analytics',
            context: {
                url: window.location.href
            }
        });
    }

    function normalizeAnalyticsError(error) {
        if (APP.Error && APP.Error.normalizeError) {
            return APP.Error.normalizeError(error);
        }
        if (error instanceof Error) {
            return error;
        }
        return new Error(error && error.message || String(error || 'Unknown analytics error'));
    }

    function stringifyAnalyticsError(error) {
        if (APP.Error && APP.Error.errorToString) {
            return APP.Error.errorToString(error);
        }
        return error && error.stack || error && error.message || String(error);
    }

    function successPayment(billId, quantity, summary, currency) {
        var price = Math.round(summary / quantity);

        if (window.TRACK) {
            phCapture('purchase_completed', {
                bill_id: billId,
                quantity: quantity,
                revenue: summary,          // figyelj: PostHog jellemzően "minor unit" (pl. cent) szemléletet ír
                currency: currency,
                product: 'subscription',
                plan: quantity >= 10 ? 'group' : 'basic',
                unit_price: price
            });
            if (window.gtag) {
                window.gtag('event', 'purchase', {
                    transaction_id: billId,
                    currency: currency,
                    value: summary,
                    items: [{
                        item_name: 'subscription',
                        item_category: quantity >= 10 ? 'group' : 'basic',
                        quantity: quantity,
                        price: price
                    }]
                });
            }
        }

        logCustomUserEvent('purchase', {currency: currency, value: summary});
    }

    function logCustomUserEvent(type, data) {
        if (window.USER_LOGGED_IN && window.TRACK) {
            APP.Ajax.post('/hu/service/log-custom-event', {
                type: type,
                data: data
            }, true).then(window.NOOP, window.NOOP);
        }
    }

    exports.init = init;
    exports.trackEvent = trackEvent;
    exports.trackFormSubmit = trackFormSubmit;
    exports.logError = logError;
    exports.successPayment = successPayment;
    exports.pageView = pageView;
    exports.logCustomUserEvent = logCustomUserEvent;
    exports.capture = phCapture;
    return exports;

})();


/*! jQuery v4.0.0 | (c) OpenJS Foundation and other contributors | jquery.com/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=t(e,!0):t(e)}("undefined"!=typeof window?window:this,function(e,t){"use strict";if(!e.document)throw Error("jQuery requires a window with a document");var n=[],r=Object.getPrototypeOf,i=n.slice,o=n.flat?function(e){return n.flat.call(e)}:function(e){return n.concat.apply([],e)},a=n.push,s=n.indexOf,u={},l=u.toString,c=u.hasOwnProperty,f=c.toString,p=f.call(Object),d={};function h(e){return null==e?e+"":"object"==typeof e?u[l.call(e)]||"object":typeof e}function g(e){return null!=e&&e===e.window}function v(e){var t=!!e&&e.length,n=h(e);return!("function"==typeof e||g(e))&&("array"===n||0===t||"number"==typeof t&&t>0&&t-1 in e)}var y=e.document,m={type:!0,src:!0,nonce:!0,noModule:!0};function x(e,t,n){var r,i=(n=n||y).createElement("script");for(r in i.text=e,m)t&&t[r]&&(i[r]=t[r]);n.head.appendChild(i).parentNode&&i.parentNode.removeChild(i)}var b="4.0.0",w=/HTML$/i,T=function(e,t){return new T.fn.init(e,t)};function C(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}T.fn=T.prototype={jquery:b,constructor:T,length:0,toArray:function(){return i.call(this)},get:function(e){return null==e?i.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=T.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return T.each(this,e)},map:function(e){return this.pushStack(T.map(this,function(t,n){return e.call(t,n,t)}))},slice:function(){return this.pushStack(i.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(T.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(T.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()}},T.extend=T.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"!=typeof a&&"function"!=typeof a&&(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(T.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||T.isPlainObject(n)?n:{},i=!1,a[t]=T.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},T.extend({expando:"jQuery"+(b+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!!e&&"[object Object]"===l.call(e)&&(!(t=r(e))||"function"==typeof(n=c.call(t,"constructor")&&t.constructor)&&f.call(n)===p)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){x(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(v(e))for(n=e.length;r<n&&!1!==t.call(e[r],r,e[r]);r++);else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=T.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(v(Object(e))?T.merge(n,"string"==typeof e?[e]:e):a.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:s.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!w.test(t||n&&n.nodeName||"HTML")},contains:function(e,t){var n=t&&t.parentNode;return e===n||!!(n&&1===n.nodeType&&(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,a=0,s=[];if(v(e))for(r=e.length;a<r;a++)null!=(i=t(e[a],a,n))&&s.push(i);else for(a in e)null!=(i=t(e[a],a,n))&&s.push(i);return o(s)},guid:1,support:d}),"function"==typeof Symbol&&(T.fn[Symbol.iterator]=n[Symbol.iterator]),T.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){u["[object "+t+"]"]=t.toLowerCase()});var j=n.pop,E="[\\x20\\t\\r\\n\\f]",k=y.documentMode,S=k&&RegExp(":enabled|:disabled|\\["+E+"*name"+E+"*="+E+"*(?:''|\"\")"),D=RegExp("^"+E+"+|((?:^|[^\\\\])(?:\\\\.)*)"+E+"+$","g"),A="(?:\\\\[\\da-fA-F]{1,6}"+E+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",N=RegExp("^"+E+"*([>+~]|"+E+")"+E+"*"),q=RegExp(E+"|>"),O=/[+~]/,L=y.documentElement,H=L.matches||L.msMatchesSelector;function P(){var e=[];function t(n,r){return e.push(n+" ")>T.expr.cacheLength&&delete t[e.shift()],t[n+" "]=r}return t}function R(e){return e&&void 0!==e.getElementsByTagName&&e}var M="\\["+E+"*("+A+")(?:"+E+"*([*^$|!~]?=)"+E+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+A+"))|)"+E+"*\\]",W=":("+A+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",$={ID:RegExp("^#("+A+")"),CLASS:RegExp("^\\.("+A+")"),TAG:RegExp("^("+A+"|[*])"),ATTR:RegExp("^"+M),PSEUDO:RegExp("^"+W),CHILD:RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+E+"*(even|odd|(([+-]|)(\\d*)n|)"+E+"*(?:([+-]|)"+E+"*(\\d+)|))"+E+"*\\)|)","i")},I=new RegExp(W),F=RegExp("\\\\[\\da-fA-F]{1,6}"+E+"?|\\\\([^\\r\\n\\f])","g"),B=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))};function _(e){return e.replace(F,B)}function U(e){T.error("Syntax error, unrecognized expression: "+e)}var X=RegExp("^"+E+"*,"+E+"*"),z=P();function Y(e,t){var n,r,i,o,a,s,u,l=z[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=T.expr.preFilter;while(a){for(o in(!n||(r=X.exec(a)))&&(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=N.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(D," ")}),a=a.slice(n.length)),$)(r=T.expr.match[o].exec(a))&&(!u[o]||(r=u[o](r)))&&(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?U(e):z(e,s).slice(0)}function G(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function V(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===h(n))for(s in i=!0,n)V(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,"function"!=typeof r&&(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(T(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o}var Q=/[^\x20\t\r\n\f]+/g;T.fn.extend({attr:function(e,t){return V(this,T.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){T.removeAttr(this,e)})}}),T.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return void 0===e.getAttribute?T.prop(e,t,n):(1===o&&T.isXMLDoc(e)||(i=T.attrHooks[t.toLowerCase()]),void 0!==n)?null===n||!1===n&&0!==t.toLowerCase().indexOf("aria-")?void T.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=e.getAttribute(t))?void 0:r},attrHooks:{},removeAttr:function(e,t){var n,r=0,i=t&&t.match(Q);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),k&&(T.attrHooks.type={set:function(e,t){if("radio"===t&&C(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}});var J=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function K(e,t){return t?"\0"===e?"\uFFFD":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}T.escapeSelector=function(e){return(e+"").replace(J,K)};var Z=n.sort,ee=n.splice;function et(e,t){if(e===t)return en=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n?n:1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)?e==y||e.ownerDocument==y&&T.contains(y,e)?-1:t==y||t.ownerDocument==y&&T.contains(y,t)?1:0:4&n?-1:1}T.uniqueSort=function(e){var t,n=[],r=0,i=0;if(en=!1,Z.call(e,et),en){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)ee.call(e,n[r],1)}return e},T.fn.uniqueSort=function(){return this.pushStack(T.uniqueSort(i.apply(this)))};var en,er,ei,eo,ea,es,eu=0,el=0,ec=P(),ef=P(),ep=P(),ed=RegExp(E+"+","g"),eh=RegExp("^"+A+"$"),eg=T.extend({needsContext:RegExp("^"+E+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+E+"*((?:-\\d)?\\d*)"+E+"*\\)|)(?=[^-]|$)","i")},$),ev=/^(?:input|select|textarea|button)$/i,ey=/^h\d$/i,em=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ex=function(){eE()},eb=eS(function(e){return!0===e.disabled&&C(e,"fieldset")},{dir:"parentNode",next:"legend"});function ew(e,t,n,r){var i,o,s,u,l,c,f,p=t&&t.ownerDocument,d=t?t.nodeType:9;if(n=n||[],"string"!=typeof e||!e||1!==d&&9!==d&&11!==d)return n;if(!r&&(eE(t),t=t||eo,es)){if(11!==d&&(l=em.exec(e))){if(i=l[1]){if(9===d)return(s=t.getElementById(i))&&a.call(n,s),n;else if(p&&(s=p.getElementById(i))&&T.contains(t,s))return a.call(n,s),n}else if(l[2])return a.apply(n,t.getElementsByTagName(e)),n;else if((i=l[3])&&t.getElementsByClassName)return a.apply(n,t.getElementsByClassName(i)),n}if(!ep[e+" "]&&(!S||!S.test(e))){if(f=e,p=t,1===d&&(q.test(e)||N.test(e))){((p=O.test(e)&&R(t.parentNode)||t)!=t||k)&&((u=t.getAttribute("id"))?u=T.escapeSelector(u):t.setAttribute("id",u=T.expando)),o=(c=Y(e)).length;while(o--)c[o]=(u?"#"+u:":scope")+" "+G(c[o]);f=c.join(",")}try{return a.apply(n,p.querySelectorAll(f)),n}catch(t){ep(e,!0)}finally{u===T.expando&&t.removeAttribute("id")}}}return eq(e.replace(D,"$1"),t,n,r)}function eT(e){return e[T.expando]=!0,e}function eC(e){return function(t){if("form"in t){if(t.parentNode&&!1===t.disabled){if("label"in t)if("label"in t.parentNode)return t.parentNode.disabled===e;else return t.disabled===e;return t.isDisabled===e||!e!==t.isDisabled&&eb(t)===e}return t.disabled===e}return"label"in t&&t.disabled===e}}function ej(e){return eT(function(t){return t*=1,eT(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}function eE(e){var t,n=e?e.ownerDocument||e:y;n!=eo&&9===n.nodeType&&(ea=(eo=n).documentElement,es=!T.isXMLDoc(eo),k&&y!=eo&&(t=eo.defaultView)&&t.top!==t&&t.addEventListener("unload",ex))}for(er in ew.matches=function(e,t){return ew(e,null,null,t)},ew.matchesSelector=function(e,t){if(eE(e),es&&!ep[t+" "]&&(!S||!S.test(t)))try{return H.call(e,t)}catch(e){ep(t,!0)}return ew(t,eo,null,[e]).length>0},T.expr={cacheLength:50,createPseudo:eT,match:eg,find:{ID:function(e,t){if(void 0!==t.getElementById&&es){var n=t.getElementById(e);return n?[n]:[]}},TAG:function(e,t){return void 0!==t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},CLASS:function(e,t){if(void 0!==t.getElementsByClassName&&es)return t.getElementsByClassName(e)}},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=_(e[1]),e[3]=_(e[3]||e[4]||e[5]||""),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||U(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&U(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return $.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&I.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{ID:function(e){var t=_(e);return function(e){return e.getAttribute("id")===t}},TAG:function(e){var t=_(e).toLowerCase();return"*"===e?function(){return!0}:function(e){return C(e,t)}},CLASS:function(e){var t=ec[e+" "];return t||(t=RegExp("(^|"+E+")"+e+"("+E+"|$)"))&&ec(e,function(e){return t.test("string"==typeof e.className&&e.className||void 0!==e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=T.attr(r,e);return null==i?"!="===t:!t||((i+="","="===t)?i===n:"!="===t?i!==n:"^="===t?n&&0===i.indexOf(n):"*="===t?n&&i.indexOf(n)>-1:"$="===t?n&&i.slice(-n.length)===n:"~="===t?(" "+i.replace(ed," ")+" ").indexOf(n)>-1:"|="===t&&(i===n||i.slice(0,n.length+1)===n+"-"))}},CHILD:function(e,t,n,r,i){var o="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,u){var l,c,f,p,d,h=o!==a?"nextSibling":"previousSibling",g=t.parentNode,v=s&&t.nodeName.toLowerCase(),y=!u&&!s,m=!1;if(g){if(o){while(h){f=t;while(f=f[h])if(s?C(f,v):1===f.nodeType)return!1;d=h="only"===e&&!d&&"nextSibling"}return!0}if(d=[a?g.firstChild:g.lastChild],a&&y){m=(p=(l=(c=g[T.expando]||(g[T.expando]={}))[e]||[])[0]===eu&&l[1])&&l[2],f=p&&g.childNodes[p];while(f=++p&&f&&f[h]||(m=p=0)||d.pop())if(1===f.nodeType&&++m&&f===t){c[e]=[eu,p,m];break}}else if(y&&(m=p=(l=(c=t[T.expando]||(t[T.expando]={}))[e]||[])[0]===eu&&l[1]),!1===m){while(f=++p&&f&&f[h]||(m=p=0)||d.pop())if((s?C(f,v):1===f.nodeType)&&++m&&(y&&((c=f[T.expando]||(f[T.expando]={}))[e]=[eu,m]),f===t))break}return(m-=i)===r||m%r==0&&m/r>=0}}},PSEUDO:function(e,t){var n=T.expr.pseudos[e]||T.expr.setFilters[e.toLowerCase()]||U("unsupported pseudo: "+e);return n[T.expando]?n(t):n}},pseudos:{not:eT(function(e){var t=[],n=[],r=eN(e.replace(D,"$1"));return r[T.expando]?eT(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),t[0]=null,!n.pop()}}),has:eT(function(e){return function(t){return ew(e,t).length>0}}),contains:eT(function(e){return e=_(e),function(t){return(t.textContent||T.text(t)).indexOf(e)>-1}}),lang:eT(function(e){return eh.test(e||"")||U("unsupported lang: "+e),e=_(e).toLowerCase(),function(t){var n;do if(n=es?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-");while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===ea},focus:function(e){return e===eo.activeElement&&eo.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:eC(!1),disabled:eC(!0),checked:function(e){return C(e,"input")&&!!e.checked||C(e,"option")&&!!e.selected},selected:function(e){return k&&e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!T.expr.pseudos.empty(e)},header:function(e){return ey.test(e.nodeName)},input:function(e){return ev.test(e.nodeName)},button:function(e){return C(e,"input")&&"button"===e.type||C(e,"button")},text:function(e){return C(e,"input")&&"text"===e.type},first:ej(function(){return[0]}),last:ej(function(e,t){return[t-1]}),eq:ej(function(e,t,n){return[n<0?n+t:n]}),even:ej(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ej(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ej(function(e,t,n){var r;for(r=n<0?n+t:n>t?t:n;--r>=0;)e.push(r);return e}),gt:ej(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}},T.expr.pseudos.nth=T.expr.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})T.expr.pseudos[er]=function(e){return function(t){return C(t,"input")&&t.type===e}}(er);for(er in{submit:!0,reset:!0})T.expr.pseudos[er]=function(e){return function(t){return(C(t,"input")||C(t,"button"))&&t.type===e}}(er);function ek(){}function eS(e,t,n){var r=t.dir,i=t.next,o=i||r,a=n&&"parentNode"===o,s=el++;return t.first?function(t,n,i){while(t=t[r])if(1===t.nodeType||a)return e(t,n,i);return!1}:function(t,n,u){var l,c,f=[eu,s];if(u){while(t=t[r])if((1===t.nodeType||a)&&e(t,n,u))return!0}else while(t=t[r])if(1===t.nodeType||a)if(c=t[T.expando]||(t[T.expando]={}),i&&C(t,i))t=t[r]||t;else{if((l=c[o])&&l[0]===eu&&l[1]===s)return f[2]=l[2];if(c[o]=f,f[2]=e(t,n,u))return!0}return!1}}function eD(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function eA(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(!n||n(o,r,i))&&(a.push(o),l&&t.push(s));return a}function eN(e,t){var n,r,i,o,u=[],l=[],c=ef[e+" "];if(!c){t||(t=Y(e)),o=t.length;while(o--)(c=function e(t){for(var n,r,i,o=t.length,u=T.expr.relative[t[0].type],l=u||T.expr.relative[" "],c=+!!u,f=eS(function(e){return e===n},l,!0),p=eS(function(e){return s.call(n,e)>-1},l,!0),d=[function(e,t,r){var i=!u&&(r||t!=ei)||((n=t).nodeType?f(e,t,r):p(e,t,r));return n=null,i}];c<o;c++)if(r=T.expr.relative[t[c].type])d=[eS(eD(d),r)];else{if((r=T.expr.filter[t[c].type].apply(null,t[c].matches))[T.expando]){for(i=++c;i<o&&!T.expr.relative[t[i].type];i++);return function e(t,n,r,i,o,u){return i&&!i[T.expando]&&(i=e(i)),o&&!o[T.expando]&&(o=e(o,u)),eT(function(e,u,l,c){var f,p,d,h,g=[],v=[],y=u.length,m=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)ew(e,t[r],n);return n}(n||"*",l.nodeType?[l]:l,[]),x=t&&(e||!n)?eA(m,g,t,l,c):m;if(r?r(x,h=o||(e?t:y||i)?[]:u,l,c):h=x,i){f=eA(h,v),i(f,[],l,c),p=f.length;while(p--)(d=f[p])&&(h[v[p]]=!(x[v[p]]=d))}if(e){if(o||t){if(o){f=[],p=h.length;while(p--)(d=h[p])&&f.push(x[p]=d);o(null,h=[],f,c)}p=h.length;while(p--)(d=h[p])&&(f=o?s.call(e,d):g[p])>-1&&(e[f]=!(u[f]=d))}}else h=eA(h===u?h.splice(y,h.length):h),o?o(null,u,h,c):a.apply(u,h)})}(c>1&&eD(d),c>1&&G(t.slice(0,c-1).concat({value:" "===t[c-2].type?"*":""})).replace(D,"$1"),r,c<i&&e(t.slice(c,i)),i<o&&e(t=t.slice(i)),i<o&&G(t))}d.push(r)}return eD(d)}(t[o]))[T.expando]?u.push(c):l.push(c);(c=ef(e,(n=u.length>0,r=l.length>0,i=function(e,t,i,o,s){var c,f,p,d=0,h="0",g=e&&[],v=[],y=ei,m=e||r&&T.expr.find.TAG("*",s),x=eu+=null==y?1:Math.random()||.1;for(s&&(ei=t==eo||t||s);null!=(c=m[h]);h++){if(r&&c){f=0,t||c.ownerDocument==eo||(eE(c),i=!es);while(p=l[f++])if(p(c,t||eo,i)){a.call(o,c);break}s&&(eu=x)}n&&((c=!p&&c)&&d--,e&&g.push(c))}if(d+=h,n&&h!==d){f=0;while(p=u[f++])p(g,v,t,i);if(e){if(d>0)while(h--)g[h]||v[h]||(v[h]=j.call(o));v=eA(v)}a.apply(o,v),s&&!e&&v.length>0&&d+u.length>1&&T.uniqueSort(o)}return s&&(eu=x,ei=y),g},n?eT(i):i))).selector=e}return c}function eq(e,t,n,r){var i,o,s,u,l,c="function"==typeof e&&e,f=!r&&Y(e=c.selector||e);if(n=n||[],1===f.length){if((o=f[0]=f[0].slice(0)).length>2&&"ID"===(s=o[0]).type&&9===t.nodeType&&es&&T.expr.relative[o[1].type]){if(!(t=(T.expr.find.ID(_(s.matches[0]),t)||[])[0]))return n;c&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=eg.needsContext.test(e)?0:o.length;while(i--){if(s=o[i],T.expr.relative[u=s.type])break;if((l=T.expr.find[u])&&(r=l(_(s.matches[0]),O.test(o[0].type)&&R(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&G(o)))return a.apply(n,r),n;break}}}return(c||eN(e,f))(r,t,!es,n,!t||O.test(e)&&R(t.parentNode)||t),n}function eO(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&T(e).is(n))break;r.push(e)}return r}function eL(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n}ek.prototype=T.expr.pseudos,T.expr.setFilters=new ek,eE(),T.find=ew,ew.compile=eN,ew.select=eq,ew.setDocument=eE,ew.tokenize=Y;var eH=T.expr.match.needsContext,eP=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function eR(e){return"<"===e[0]&&">"===e[e.length-1]&&e.length>=3}function eM(e,t,n){return"function"==typeof t?T.grep(e,function(e,r){return!!t.call(e,r,e)!==n}):t.nodeType?T.grep(e,function(e){return e===t!==n}):"string"!=typeof t?T.grep(e,function(e){return s.call(t,e)>-1!==n}):T.filter(t,e,n)}T.filter=function(e,t,n){var r=t[0];return(n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType)?T.find.matchesSelector(r,e)?[r]:[]:T.find.matches(e,T.grep(t,function(e){return 1===e.nodeType}))},T.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(T(e).filter(function(){for(t=0;t<r;t++)if(T.contains(i[t],this))return!0}));for(t=0,n=this.pushStack([]);t<r;t++)T.find(e,i[t],n);return r>1?T.uniqueSort(n):n},filter:function(e){return this.pushStack(eM(this,e||[],!1))},not:function(e){return this.pushStack(eM(this,e||[],!0))},is:function(e){return!!eM(this,"string"==typeof e&&eH.test(e)?T(e):e||[],!1).length}});var eW,e$=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(T.fn.init=function(e,t){var n,r;if(!e)return this;if(e.nodeType)return this[0]=e,this.length=1,this;if("function"==typeof e)return void 0!==eW.ready?eW.ready(e):e(T);if(eR(n=e+""))n=[null,e,null];else{if("string"!=typeof e)return T.makeArray(e,this);n=e$.exec(e)}if(n&&(n[1]||!t))if(!n[1])return(r=y.getElementById(n[2]))&&(this[0]=r,this.length=1),this;else{if(t=t instanceof T?t[0]:t,T.merge(this,T.parseHTML(n[1],t&&t.nodeType?t.ownerDocument||t:y,!0)),eP.test(n[1])&&T.isPlainObject(t))for(n in t)"function"==typeof this[n]?this[n](t[n]):this.attr(n,t[n]);return this}return!t||t.jquery?(t||eW).find(e):this.constructor(t).find(e)}).prototype=T.fn,eW=T(y);var eI=/^(?:parents|prev(?:Until|All))/,eF={children:!0,contents:!0,next:!0,prev:!0};function eB(e,t){while((e=e[t])&&1!==e.nodeType);return e}function e_(e){return e}function eU(e){throw e}function eX(e,t,n,r){var i;try{e&&"function"==typeof(i=e.promise)?i.call(e).done(t).fail(n):e&&"function"==typeof(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n(e)}}T.fn.extend({has:function(e){var t=T(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(T.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&T(e);if(!eH.test(e)){for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&T.find.matchesSelector(n,e))){o.push(n);break}}return this.pushStack(o.length>1?T.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?s.call(T(e),this[0]):s.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(T.uniqueSort(T.merge(this.get(),T(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),T.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return eO(e,"parentNode")},parentsUntil:function(e,t,n){return eO(e,"parentNode",n)},next:function(e){return eB(e,"nextSibling")},prev:function(e){return eB(e,"previousSibling")},nextAll:function(e){return eO(e,"nextSibling")},prevAll:function(e){return eO(e,"previousSibling")},nextUntil:function(e,t,n){return eO(e,"nextSibling",n)},prevUntil:function(e,t,n){return eO(e,"previousSibling",n)},siblings:function(e){return eL((e.parentNode||{}).firstChild,e)},children:function(e){return eL(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(C(e,"template")&&(e=e.content||e),T.merge([],e.childNodes))}},function(e,t){T.fn[e]=function(n,r){var i=T.map(this,t,n);return"Until"!==e.slice(-5)&&(r=n),r&&"string"==typeof r&&(i=T.filter(r,i)),this.length>1&&(eF[e]||T.uniqueSort(i),eI.test(e)&&i.reverse()),this.pushStack(i)}}),T.Callbacks=function(e){e="string"==typeof e?(t=e,n={},T.each(t.match(Q)||[],function(e,t){n[t]=!0}),n):T.extend({},e);var t,n,r,i,o,a,s=[],u=[],l=-1,c=function(){for(a=a||e.once,o=r=!0;u.length;l=-1){i=u.shift();while(++l<s.length)!1===s[l].apply(i[0],i[1])&&e.stopOnFalse&&(l=s.length,i=!1)}e.memory||(i=!1),r=!1,a&&(s=i?[]:"")},f={add:function(){return s&&(i&&!r&&(l=s.length-1,u.push(i)),!function t(n){T.each(n,function(n,r){"function"==typeof r?e.unique&&f.has(r)||s.push(r):r&&r.length&&"string"!==h(r)&&t(r)})}(arguments),i&&!r&&c()),this},remove:function(){return T.each(arguments,function(e,t){var n;while((n=T.inArray(t,s,n))>-1)s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?T.inArray(e,s)>-1:s.length>0},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=i="",this},disabled:function(){return!s},lock:function(){return a=u=[],i||r||(s=i=""),this},locked:function(){return!!a},fireWith:function(e,t){return!a&&(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),r||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},T.extend({Deferred:function(t){var n=[["notify","progress",T.Callbacks("memory"),T.Callbacks("memory"),2],["resolve","done",T.Callbacks("once memory"),T.Callbacks("once memory"),0,"resolved"],["reject","fail",T.Callbacks("once memory"),T.Callbacks("once memory"),1,"rejected"]],r="pending",i={state:function(){return r},always:function(){return o.done(arguments).fail(arguments),this},catch:function(e){return i.then(null,e)},pipe:function(){var e=arguments;return T.Deferred(function(t){T.each(n,function(n,r){var i="function"==typeof e[r[4]]&&e[r[4]];o[r[1]](function(){var e=i&&i.apply(this,arguments);e&&"function"==typeof e.promise?e.promise().progress(t.notify).done(t.resolve).fail(t.reject):t[r[0]+"With"](this,i?[e]:arguments)})}),e=null}).promise()},then:function(t,r,i){var o=0;function a(t,n,r,i){return function(){var s=this,u=arguments,l=function(){var e,l;if(!(t<o)){if((e=r.apply(s,u))===n.promise())throw TypeError("Thenable self-resolution");"function"==typeof(l=e&&("object"==typeof e||"function"==typeof e)&&e.then)?i?l.call(e,a(o,n,e_,i),a(o,n,eU,i)):(o++,l.call(e,a(o,n,e_,i),a(o,n,eU,i),a(o,n,e_,n.notifyWith))):(r!==e_&&(s=void 0,u=[e]),(i||n.resolveWith)(s,u))}},c=i?l:function(){try{l()}catch(e){T.Deferred.exceptionHook&&T.Deferred.exceptionHook(e,c.error),t+1>=o&&(r!==eU&&(s=void 0,u=[e]),n.rejectWith(s,u))}};t?c():(T.Deferred.getErrorHook&&(c.error=T.Deferred.getErrorHook()),e.setTimeout(c))}}return T.Deferred(function(e){n[0][3].add(a(0,e,"function"==typeof i?i:e_,e.notifyWith)),n[1][3].add(a(0,e,"function"==typeof t?t:e_)),n[2][3].add(a(0,e,"function"==typeof r?r:eU))}).promise()},promise:function(e){return null!=e?T.extend(e,i):i}},o={};return T.each(n,function(e,t){var a=t[2],s=t[5];i[t[1]]=a.add,s&&a.add(function(){r=s},n[3-e][2].disable,n[3-e][3].disable,n[0][2].lock,n[0][3].lock),a.add(t[3].fire),o[t[0]]=function(){return o[t[0]+"With"](this===o?void 0:this,arguments),this},o[t[0]+"With"]=a.fireWith}),i.promise(o),t&&t.call(o,o),o},when:function(e){var t=arguments.length,n=t,r=Array(n),o=i.call(arguments),a=T.Deferred(),s=function(e){return function(n){r[e]=this,o[e]=arguments.length>1?i.call(arguments):n,--t||a.resolveWith(r,o)}};if(t<=1&&(eX(e,a.done(s(n)).resolve,a.reject,!t),"pending"===a.state()||"function"==typeof(o[n]&&o[n].then)))return a.then();while(n--)eX(o[n],s(n),a.reject);return a.promise()}});var ez=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;T.Deferred.exceptionHook=function(t,n){t&&ez.test(t.name)&&e.console.warn("jQuery.Deferred exception",t,n)},T.readyException=function(t){e.setTimeout(function(){throw t})};var eY=T.Deferred();function eG(){y.removeEventListener("DOMContentLoaded",eG),e.removeEventListener("load",eG),T.ready()}T.fn.ready=function(e){return eY.then(e).catch(function(e){T.readyException(e)}),this},T.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--T.readyWait:T.isReady)||(T.isReady=!0,!0!==e&&--T.readyWait>0||eY.resolveWith(y,[T]))}}),T.ready.then=eY.then,"loading"!==y.readyState?e.setTimeout(T.ready):(y.addEventListener("DOMContentLoaded",eG),e.addEventListener("load",eG));var eV=/-([a-z])/g;function eQ(e,t){return t.toUpperCase()}function eJ(e){return e.replace(eV,eQ)}function eK(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType}function eZ(){this.expando=T.expando+eZ.uid++}eZ.uid=1,eZ.prototype={cache:function(e){var t=e[this.expando];return!t&&(t=Object.create(null),eK(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[eJ(t)]=n;else for(r in t)i[eJ(r)]=t[r];return n},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][eJ(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(eJ):(t=eJ(t))in r?[t]:t.match(Q)||[]).length;while(n--)delete r[t[n]]}(void 0===t||T.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!T.isEmptyObject(t)}};var e0=new eZ,e1=new eZ,e2=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,e3=/[A-Z]/g;function e4(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(e3,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{i=n,n="true"===i||"false"!==i&&("null"===i?null:i===+i+""?+i:e2.test(i)?JSON.parse(i):i)}catch(e){}e1.set(e,t,n)}else n=void 0;return n}T.extend({hasData:function(e){return e1.hasData(e)||e0.hasData(e)},data:function(e,t,n){return e1.access(e,t,n)},removeData:function(e,t){e1.remove(e,t)},_data:function(e,t,n){return e0.access(e,t,n)},_removeData:function(e,t){e0.remove(e,t)}}),T.fn.extend({data:function(e,t){var n,r,i,o=this[0],a=o&&o.attributes;if(void 0===e){if(this.length&&(i=e1.get(o),1===o.nodeType&&!e0.get(o,"hasDataAttrs"))){n=a.length;while(n--)a[n]&&0===(r=a[n].name).indexOf("data-")&&e4(o,r=eJ(r.slice(5)),i[r]);e0.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof e?this.each(function(){e1.set(this,e)}):V(this,function(t){var n;if(o&&void 0===t)return void 0!==(n=e1.get(o,e))||void 0!==(n=e4(o,e))?n:void 0;this.each(function(){e1.set(this,e,t)})},null,t,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){e1.remove(this,e)})}}),T.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=e0.get(e,t),n&&(!r||Array.isArray(n)?r=e0.set(e,t,T.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=T.queue(e,t),r=n.length,i=n.shift(),o=T._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){T.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return e0.get(e,n)||e0.set(e,n,{empty:T.Callbacks("once memory").add(function(){e0.remove(e,[t+"queue",n])})})}}),T.fn.extend({queue:function(e,t){var n=2;return("string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n)?T.queue(this[0],e):void 0===t?this:this.each(function(){var n=T.queue(this,e,t);T._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&T.dequeue(this,e)})},dequeue:function(e){return this.each(function(){T.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=T.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=e0.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var e5=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,e9=RegExp("^(?:([+-])=|)("+e5+")([a-z%]*)$","i"),e6=["Top","Right","Bottom","Left"];function e8(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&"none"===T.css(e,"display")}var e7=/^[a-z]/,te=/^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;function tt(e){return e7.test(e)&&te.test(e[0].toUpperCase()+e.slice(1))}function tn(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return T.css(e,t,"")},u=s(),l=n&&n[3]||(tt(t)?"px":""),c=e.nodeType&&(!tt(t)||"px"!==l&&+u)&&e9.exec(T.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)T.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,T.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var tr=/^-ms-/;function ti(e){return eJ(e.replace(tr,"ms-"))}var to={};function ta(e,t){for(var n,r,i=[],o=0,a=e.length;o<a;o++)(r=e[o]).style&&(n=r.style.display,t?("none"===n&&(i[o]=e0.get(r,"display")||null,i[o]||(r.style.display="")),""===r.style.display&&e8(r)&&(i[o]=function(e){var t,n=e.ownerDocument,r=e.nodeName,i=to[r];return i||(t=n.body.appendChild(n.createElement(r)),i=T.css(t,"display"),t.parentNode.removeChild(t),"none"===i&&(i="block"),to[r]=i),i}(r))):"none"!==n&&(i[o]="none",e0.set(r,"display",n)));for(o=0;o<a;o++)null!=i[o]&&(e[o].style.display=i[o]);return e}T.fn.extend({show:function(){return ta(this,!0)},hide:function(){return ta(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){e8(this)?T(this).show():T(this).hide()})}});var ts=function(e){return T.contains(e.ownerDocument,e)||e.getRootNode(tu)===e.ownerDocument},tu={composed:!0};L.getRootNode||(ts=function(e){return T.contains(e.ownerDocument,e)});var tl=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,tc={thead:["table"],col:["colgroup","table"],tr:["tbody","table"],td:["tr","tbody","table"]};function tf(e,t){var r;return(r=void 0!==e.getElementsByTagName?n.slice.call(e.getElementsByTagName(t||"*")):void 0!==e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&C(e,t))?T.merge([e],r):r}tc.tbody=tc.tfoot=tc.colgroup=tc.caption=tc.thead,tc.th=tc.td;var tp=/^$|^module$|\/(?:java|ecma)script/i;function td(e,t){for(var n=0,r=e.length;n<r;n++)e0.set(e[n],"globalEval",!t||e0.get(t[n],"globalEval"))}var th=/<|&#?\w+;/;function tg(e,t,r,i,o){for(var a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,g=e.length;d<g;d++)if((a=e[d])||0===a)if("object"===h(a)&&(a.nodeType||v(a)))T.merge(p,a.nodeType?[a]:a);else if(th.test(a)){s=s||f.appendChild(t.createElement("div")),c=(u=tc[(tl.exec(a)||["",""])[1].toLowerCase()]||n).length;while(--c>-1)s=s.appendChild(t.createElement(u[c]));s.innerHTML=T.htmlPrefilter(a),T.merge(p,s.childNodes),(s=f.firstChild).textContent=""}else p.push(t.createTextNode(a));f.textContent="",d=0;while(a=p[d++]){if(i&&T.inArray(a,i)>-1){o&&o.push(a);continue}if(l=ts(a),s=tf(f.appendChild(a),"script"),l&&td(s),r){c=0;while(a=s[c++])tp.test(a.type||"")&&r.push(a)}}return f}function tv(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function ty(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function tm(e,t,n,r){t=o(t);var i,a,s,u,l,c,f=0,p=e.length,d=p-1,h=t[0];if("function"==typeof h)return e.each(function(i){var o=e.eq(i);t[0]=h.call(this,i,o.html()),tm(o,t,n,r)});if(p&&(a=(i=tg(t,e[0].ownerDocument,!1,e,r)).firstChild,1===i.childNodes.length&&(i=a),a||r)){for(u=(s=T.map(tf(i,"script"),tv)).length;f<p;f++)l=i,f!==d&&(l=T.clone(l,!0,!0),u&&T.merge(s,tf(l,"script"))),n.call(e[f],l,f);if(u)for(c=s[s.length-1].ownerDocument,T.map(s,ty),f=0;f<u;f++)l=s[f],tp.test(l.type||"")&&!e0.get(l,"globalEval")&&T.contains(c,l)&&(l.src&&"module"!==(l.type||"").toLowerCase()?T._evalUrl&&!l.noModule&&T._evalUrl(l.src,{nonce:l.nonce,crossOrigin:l.crossOrigin},c):x(l.textContent,l,c))}return e}var tx=/^(?:checkbox|radio)$/i,tb=/^([^.]*)(?:\.(.+)|)/;function tw(){return!0}function tT(){return!1}function tC(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)tC(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=tT;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return T().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=T.guid++)),e.each(function(){T.event.add(this,t,i,r,n)})}function tj(e,t,n){if(!n){void 0===e0.get(e,t)&&T.event.add(e,t,tw);return}e0.set(e,t,!1),T.event.add(e,t,{namespace:!1,handler:function(e){var n,r=e0.get(this,t);if(1&e.isTrigger&&this[t]){if(r.length)(T.event.special[t]||{}).delegateType&&e.stopPropagation();else if(r=i.call(arguments),e0.set(this,t,r),this[t](),n=e0.get(this,t),e0.set(this,t,!1),r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(e0.set(this,t,{value:T.event.trigger(r[0],r.slice(1),this)}),e.stopPropagation(),e.isImmediatePropagationStopped=tw)}})}T.event={add:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=e0.get(e);if(eK(e)){n.handler&&(n=(o=n).handler,i=o.selector),i&&T.find.matchesSelector(L,i),n.guid||(n.guid=T.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(t){return T.event.triggered!==t.type?T.event.dispatch.apply(e,arguments):void 0}),l=(t=(t||"").match(Q)||[""]).length;while(l--){if(d=g=(s=tb.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),!d)continue;f=T.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=T.event.special[d]||{},c=T.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&T.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,(!f.setup||!1===f.setup.call(e,r,h,a))&&e.addEventListener&&e.addEventListener(d,a)),f.add&&(f.add.call(e,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c)}}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=e0.hasData(e)&&e0.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(Q)||[""]).length;while(l--){if(d=g=(s=tb.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),!d){for(d in u)T.event.remove(e,d+t[l],n,r,!0);continue}f=T.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],(i||g===c.origType)&&(!n||n.guid===c.guid)&&(!s||s.test(c.namespace))&&(!r||r===c.selector||"**"===r&&c.selector)&&(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||T.removeEvent(e,d,v.handle),delete u[d])}T.isEmptyObject(u)&&e0.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=Array(arguments.length),u=T.event.fix(e),l=(e0.get(this,"events")||Object.create(null))[u.type]||[],c=T.event.special[u.type]||{};for(t=1,s[0]=u;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=T.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())(!u.rnamespace||!1===o.namespace||u.rnamespace.test(o.namespace))&&(u.handleObj=o,u.data=o.data,void 0!==(r=((T.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&!("click"===e.type&&e.button>=1)){for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(n=0,o=[],a={};n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?T(i,this).index(l)>-1:T.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(e,t){Object.defineProperty(T.Event.prototype,e,{enumerable:!0,configurable:!0,get:"function"==typeof t?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[T.expando]?e:new T.Event(e)},special:T.extend(Object.create(null),{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return tx.test(t.type)&&t.click&&C(t,"input")&&tj(t,"click",!0),!1},trigger:function(e){var t=this||e;return tx.test(t.type)&&t.click&&C(t,"input")&&tj(t,"click"),!0},_default:function(e){var t=e.target;return tx.test(t.type)&&t.click&&C(t,"input")&&e0.get(t,"click")||C(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.preventDefault()}}})},T.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},T.Event=function(e,t){if(!(this instanceof T.Event))return new T.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented?tw:tT,this.target=e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&T.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[T.expando]=!0},T.Event.prototype={constructor:T.Event,isDefaultPrevented:tT,isPropagationStopped:tT,isImmediatePropagationStopped:tT,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=tw,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=tw,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=tw,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},T.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},T.event.addProp),T.each({focus:"focusin",blur:"focusout"},function(e,t){function n(e){var t=T.event.fix(e);t.type="focusin"===e.type?"focus":"blur",t.isSimulated=!0,t.target===t.currentTarget&&e0.get(this,"handle")(t)}T.event.special[e]={setup:function(){if(tj(this,e,!0),!k)return!1;this.addEventListener(t,n)},trigger:function(){return tj(this,e),!0},teardown:function(){if(!k)return!1;this.removeEventListener(t,n)},_default:function(t){return e0.get(t.target,e)},delegateType:t}}),T.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,t){T.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=e.relatedTarget,i=e.handleObj;return r&&(r===this||T.contains(this,r))||(e.type=i.origType,n=i.handler.apply(this,arguments),e.type=t),n}}}),T.fn.extend({on:function(e,t,n,r){return tC(this,e,t,n,r)},one:function(e,t,n,r){return tC(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,T(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return(!1===t||"function"==typeof t)&&(n=t,t=void 0),!1===n&&(n=tT),this.each(function(){T.event.remove(this,e,n,t)})}});var tE=/<script|<style|<link/i;function tk(e,t){return C(e,"table")&&C(11!==t.nodeType?t:t.firstChild,"tr")&&T(e).children("tbody")[0]||e}function tS(e,t){var n,r,i,o=e0.get(e,"events");if(1===t.nodeType){if(o)for(n in e0.remove(t,"handle events"),o)for(r=0,i=o[n].length;r<i;r++)T.event.add(t,n,o[n][r]);e1.hasData(e)&&e1.set(t,T.extend({},e1.get(e)))}}function tD(e,t,n){for(var r,i=t?T.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||T.cleanData(tf(r)),r.parentNode&&(n&&ts(r)&&td(tf(r,"script")),r.parentNode.removeChild(r));return e}T.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s=e.cloneNode(!0),u=ts(e);if(k&&(1===e.nodeType||11===e.nodeType)&&!T.isXMLDoc(e))for(r=0,a=tf(s),i=(o=tf(e)).length;r<i;r++)C(a[r],"textarea")&&(a[r].defaultValue=o[r].defaultValue);if(t)if(n)for(r=0,o=o||tf(e),a=a||tf(s),i=o.length;r<i;r++)tS(o[r],a[r]);else tS(e,s);return(a=tf(s,"script")).length>0&&td(a,!u&&tf(e,"script")),s},cleanData:function(e){for(var t,n,r,i=T.event.special,o=0;void 0!==(n=e[o]);o++)if(eK(n)){if(t=n[e0.expando]){if(t.events)for(r in t.events)i[r]?T.event.remove(n,r):T.removeEvent(n,r,t.handle);n[e0.expando]=void 0}n[e1.expando]&&(n[e1.expando]=void 0)}}}),T.fn.extend({detach:function(e){return tD(this,e,!0)},remove:function(e){return tD(this,e)},text:function(e){return V(this,function(e){return void 0===e?T.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=e)})},null,e,arguments.length)},append:function(){return tm(this,arguments,function(e){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&tk(this,e).appendChild(e)})},prepend:function(){return tm(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=tk(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return tm(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return tm(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(T.cleanData(tf(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return T.clone(this,e,t)})},html:function(e){return V(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!tE.test(e)&&!tc[(tl.exec(e)||["",""])[1].toLowerCase()]){e=T.htmlPrefilter(e);try{for(;n<r;n++)t=this[n]||{},1===t.nodeType&&(T.cleanData(tf(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=[];return tm(this,arguments,function(t){var n=this.parentNode;0>T.inArray(this,e)&&(T.cleanData(tf(this)),n&&n.replaceChild(t,this))},e)}}),T.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){T.fn[e]=function(e){for(var n,r=[],i=T(e),o=i.length-1,s=0;s<=o;s++)n=s===o?this:this.clone(!0),T(i[s])[t](n),a.apply(r,n);return this.pushStack(r)}});var tA=RegExp("^("+e5+")(?!px)[a-z%]+$","i"),tN=/^--/;function tq(t){var n=t.ownerDocument.defaultView;return n||(n=e),n.getComputedStyle(t)}function tO(e,t,n){var r,i=tN.test(t);return(n=n||tq(e))&&(r=n.getPropertyValue(t)||n[t],i&&r&&(r=r.replace(D,"$1")||void 0),""!==r||ts(e)||(r=T.style(e,t))),void 0!==r?r+"":r}var tL=["Webkit","Moz","ms"],tH=y.createElement("div").style;function tP(e){return e in tH?e:function(e){var t=e[0].toUpperCase()+e.slice(1),n=tL.length;while(n--)if((e=tL[n]+t)in tH)return e}(e)||e}var tR,tM,tW=y.createElement("table");function t$(){if(tW&&tW.style){var t,n=y.createElement("col"),r=y.createElement("tr"),i=y.createElement("td");if(tW.style.cssText="position:absolute;left:-11111px;border-collapse:separate;border-spacing:0",r.style.cssText="box-sizing:content-box;border:1px solid;height:1px",i.style.cssText="height:9px;width:9px;padding:0",n.span=2,L.appendChild(tW).appendChild(n).parentNode.appendChild(r).appendChild(i).parentNode.appendChild(i.cloneNode(!0)),0===tW.offsetWidth)return void L.removeChild(tW);t=e.getComputedStyle(r),tM=k||18===Math.round(parseFloat(e.getComputedStyle(n).width)),tR=Math.round(parseFloat(t.height)+parseFloat(t.borderTopWidth)+parseFloat(t.borderBottomWidth))===r.offsetHeight,L.removeChild(tW),tW=null}}T.extend(d,{reliableTrDimensions:function(){return t$(),tR},reliableColDimensions:function(){return t$(),tM}});var tI={position:"absolute",visibility:"hidden",display:"block"},tF={letterSpacing:"0",fontWeight:"400"};function tB(e,t,n){var r=e9.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function t_(e,t,n,r,i,o){var a=+("width"===t),s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=T.css(e,n+e6[a],!0,i)),r?("content"===n&&(u-=T.css(e,"padding"+e6[a],!0,i)),"margin"!==n&&(u-=T.css(e,"border"+e6[a]+"Width",!0,i))):(u+=T.css(e,"padding"+e6[a],!0,i),"padding"!==n?u+=T.css(e,"border"+e6[a]+"Width",!0,i):s+=T.css(e,"border"+e6[a]+"Width",!0,i));return!r&&o>=0&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function tU(e,t,n){var r=tq(e),i=(k||n)&&"border-box"===T.css(e,"boxSizing",!1,r),o=i,a=tO(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(tA.test(a)){if(!n)return a;a="auto"}return("auto"===a||k&&i||!d.reliableColDimensions()&&C(e,"col")||!d.reliableTrDimensions()&&C(e,"tr"))&&e.getClientRects().length&&(i="border-box"===T.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+t_(e,t,n||(i?"border":"content"),o,r,a)+"px"}function tX(e,t,n,r,i){return new tX.prototype.init(e,t,n,r,i)}T.extend({cssHooks:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=ti(t),u=tN.test(t),l=e.style;if(u||(t=tP(s)),a=T.cssHooks[t]||T.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];if("string"==(o=typeof n)&&(i=e9.exec(n))&&i[1]&&(n=tn(e,t,i),o="number"),null!=n&&n==n)"number"===o&&(n+=i&&i[3]||(tt(s)?"px":"")),k&&""===n&&0===t.indexOf("background")&&(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n)}},css:function(e,t,n,r){var i,o,a,s=ti(t);return(tN.test(t)||(t=tP(s)),(a=T.cssHooks[t]||T.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=tO(e,t,r)),"normal"===i&&t in tF&&(i=tF[t]),""===n||n)?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),T.each(["height","width"],function(e,t){T.cssHooks[t]={get:function(e,n,r){if(n)return"none"===T.css(e,"display")?function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r}(e,tI,function(){return tU(e,t,r)}):tU(e,t,r)},set:function(e,n,r){var i,o=tq(e),a=r&&"border-box"===T.css(e,"boxSizing",!1,o),s=r?t_(e,t,r,a,o):0;return s&&(i=e9.exec(n))&&"px"!==(i[3]||"px")&&(e.style[t]=n,n=T.css(e,t)),tB(e,n,s)}}}),T.each({margin:"",padding:"",border:"Width"},function(e,t){T.cssHooks[e+t]={expand:function(n){for(var r=0,i={},o="string"==typeof n?n.split(" "):[n];r<4;r++)i[e+e6[r]+t]=o[r]||o[r-2]||o[0];return i}},"margin"!==e&&(T.cssHooks[e+t].set=tB)}),T.fn.extend({css:function(e,t){return V(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=tq(e),i=t.length;a<i;a++)o[t[a]]=T.css(e,t[a],!1,r);return o}return void 0!==n?T.style(e,t,n):T.css(e,t)},e,t,arguments.length>1)}}),T.Tween=tX,tX.prototype={constructor:tX,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||T.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(tt(n)?"px":"")},cur:function(){var e=tX.propHooks[this.prop];return e&&e.get?e.get(this):tX.propHooks._default.get(this)},run:function(e){var t,n=tX.propHooks[this.prop];return this.options.duration?this.pos=t=T.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):tX.propHooks._default.set(this),this}},tX.prototype.init.prototype=tX.prototype,tX.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=T.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){T.fx.step[e.prop]?T.fx.step[e.prop](e):1===e.elem.nodeType&&(T.cssHooks[e.prop]||null!=e.elem.style[tP(e.prop)])?T.style(e.elem,e.prop,e.now+e.unit):e.elem[e.prop]=e.now}}},T.easing={linear:function(e){return e},swing:function(e){return .5-Math.cos(e*Math.PI)/2},_default:"swing"},T.fx=tX.prototype.init,T.fx.step={};var tz,tY,tG=/^(?:toggle|show|hide)$/,tV=/queueHooks$/;function tQ(){return e.setTimeout(function(){tz=void 0}),tz=Date.now()}function tJ(e,t){var n,r=0,i={height:e};for(t=+!!t;r<4;r+=2-t)i["margin"+(n=e6[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function tK(e,t,n){for(var r,i=(tZ.tweeners[t]||[]).concat(tZ.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function tZ(e,t,n){var r,i,o=0,a=tZ.prefilters.length,s=T.Deferred().always(function(){delete u.elem}),u=function(){if(i)return!1;for(var t=tz||tQ(),n=Math.max(0,l.startTime+l.duration-t),r=1-(n/l.duration||0),o=0,a=l.tweens.length;o<a;o++)l.tweens[o].run(r);return(s.notifyWith(e,[l,r,n]),r<1&&a)?n:(a||s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l]),!1)},l=s.promise({elem:e,props:T.extend({},t),opts:T.extend(!0,{specialEasing:{},easing:T.easing._default},n),originalProperties:t,originalOptions:n,startTime:tz||tQ(),duration:n.duration,tweens:[],createTween:function(t,n){var r=T.Tween(e,l.opts,t,n,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(r),r},stop:function(t){var n=0,r=t?l.tweens.length:0;if(i)return this;for(i=!0;n<r;n++)l.tweens[n].run(1);return t?(s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l,t])):s.rejectWith(e,[l,t]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=ti(n)],Array.isArray(o=e[n])&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=T.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);o<a;o++)if(r=tZ.prefilters[o].call(l,e,c,l.opts))return"function"==typeof r.stop&&(T._queueHooks(l.elem,l.opts.queue).stop=r.stop.bind(r)),r;return T.map(c,tK,l),"function"==typeof l.opts.start&&l.opts.start.call(e,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),T.fx.timer(T.extend(u,{elem:e,anim:l,queue:l.opts.queue})),l}T.Animation=T.extend(tZ,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return tn(n.elem,e,e9.exec(t),n),n}]},tweener:function(e,t){"function"==typeof e?(t=e,e=["*"]):e=e.match(Q);for(var n,r=0,i=e.length;r<i;r++)n=e[r],tZ.tweeners[n]=tZ.tweeners[n]||[],tZ.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&e8(e),v=e0.get(e,"fxshow");for(r in n.queue||(null==(a=T._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,T.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],tG.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show"))if("show"!==i||!v||void 0===v[r])continue;else g=!0;d[r]=v&&v[r]||T.style(e,r)}if(!(!(u=!T.isEmptyObject(t))&&T.isEmptyObject(d)))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=e0.get(e,"display")),"none"===(c=T.css(e,"display"))&&(l?c=l:(ta([e],!0),l=e.style.display||l,c=T.css(e,"display"),ta([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===T.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(l="none"===(c=h.display)?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=e0.set(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&ta([e],!0),p.done(function(){for(r in g||ta([e]),e0.remove(e,"fxshow"),d)T.style(e,r,d[r])})),u=tK(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?tZ.prefilters.unshift(e):tZ.prefilters.push(e)}}),T.speed=function(e,t,n){var r=e&&"object"==typeof e?T.extend({},e):{complete:n||t||"function"==typeof e&&e,duration:e,easing:n&&t||t&&"function"!=typeof t&&t};return T.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in T.fx.speeds?r.duration=T.fx.speeds[r.duration]:r.duration=T.fx.speeds._default),(null==r.queue||!0===r.queue)&&(r.queue="fx"),r.old=r.complete,r.complete=function(){"function"==typeof r.old&&r.old.call(this),r.queue&&T.dequeue(this,r.queue)},r},T.fn.extend({fadeTo:function(e,t,n,r){return this.filter(e8).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=T.isEmptyObject(e),o=T.speed(t,n,r),a=function(){var t=tZ(this,T.extend({},e),o);(i||e0.get(this,"finish"))&&t.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(e,t,n){var r=function(e){var t=e.stop;delete e.stop,t(n)};return"string"!=typeof e&&(n=t,t=e,e=void 0),t&&this.queue(e||"fx",[]),this.each(function(){var t=!0,i=null!=e&&e+"queueHooks",o=T.timers,a=e0.get(this);if(i)a[i]&&a[i].stop&&r(a[i]);else for(i in a)a[i]&&a[i].stop&&tV.test(i)&&r(a[i]);for(i=o.length;i--;)o[i].elem===this&&(null==e||o[i].queue===e)&&(o[i].anim.stop(n),t=!1,o.splice(i,1));(t||!n)&&T.dequeue(this,e)})},finish:function(e){return!1!==e&&(e=e||"fx"),this.each(function(){var t,n=e0.get(this),r=n[e+"queue"],i=n[e+"queueHooks"],o=T.timers,a=r?r.length:0;for(n.finish=!0,T.queue(this,e,[]),i&&i.stop&&i.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;t<a;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}}),T.each(["toggle","show","hide"],function(e,t){var n=T.fn[t];T.fn[t]=function(e,r,i){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(tJ(t,!0),e,r,i)}}),T.each({slideDown:tJ("show"),slideUp:tJ("hide"),slideToggle:tJ("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){T.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),T.timers=[],T.fx.tick=function(){var e,t=0,n=T.timers;for(tz=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||T.fx.stop(),tz=void 0},T.fx.timer=function(e){T.timers.push(e),T.fx.start()},T.fx.start=function(){tY||(tY=!0,function t(){tY&&(!1===y.hidden&&e.requestAnimationFrame?e.requestAnimationFrame(t):e.setTimeout(t,13),T.fx.tick())}())},T.fx.stop=function(){tY=null},T.fx.speeds={slow:600,fast:200,_default:400},T.fn.delay=function(t,n){return t=T.fx&&T.fx.speeds[t]||t,n=n||"fx",this.queue(n,function(n,r){var i=e.setTimeout(n,t);r.stop=function(){e.clearTimeout(i)}})};var t0=/^(?:input|select|textarea|button)$/i,t1=/^(?:a|area)$/i;function t2(e){return(e.match(Q)||[]).join(" ")}function t3(e){return e.getAttribute&&e.getAttribute("class")||""}function t4(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(Q)||[]}T.fn.extend({prop:function(e,t){return V(this,T.prop,e,t,arguments.length>1)},removeProp:function(e){return this.each(function(){delete this[T.propFix[e]||e]})}}),T.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return(1===o&&T.isXMLDoc(e)||(t=T.propFix[t]||t,i=T.propHooks[t]),void 0!==n)?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=e.getAttribute("tabindex");return t?parseInt(t,10):t0.test(e.nodeName)||t1.test(e.nodeName)&&e.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),k&&(T.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),T.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){T.propFix[this.toLowerCase()]=this}),T.fn.extend({addClass:function(e){var t,n,r,i,o,a;return"function"==typeof e?this.each(function(t){T(this).addClass(e.call(this,t,t3(this)))}):(t=t4(e)).length?this.each(function(){if(r=t3(this),n=1===this.nodeType&&" "+t2(r)+" "){for(o=0;o<t.length;o++)i=t[o],0>n.indexOf(" "+i+" ")&&(n+=i+" ");r!==(a=t2(n))&&this.setAttribute("class",a)}}):this},removeClass:function(e){var t,n,r,i,o,a;return"function"==typeof e?this.each(function(t){T(this).removeClass(e.call(this,t,t3(this)))}):arguments.length?(t=t4(e)).length?this.each(function(){if(r=t3(this),n=1===this.nodeType&&" "+t2(r)+" "){for(o=0;o<t.length;o++){i=t[o];while(n.indexOf(" "+i+" ")>-1)n=n.replace(" "+i+" "," ")}r!==(a=t2(n))&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(e,t){var n,r,i,o;return"function"==typeof e?this.each(function(n){T(this).toggleClass(e.call(this,n,t3(this),t),t)}):"boolean"==typeof t?t?this.addClass(e):this.removeClass(e):(n=t4(e)).length?this.each(function(){for(i=0,o=T(this);i<n.length;i++)r=n[i],o.hasClass(r)?o.removeClass(r):o.addClass(r)}):this},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&(" "+t2(t3(n))+" ").indexOf(t)>-1)return!0;return!1}}),T.fn.extend({val:function(e){var t,n,r,i=this[0];if(!arguments.length)return i?(t=T.valHooks[i.type]||T.valHooks[i.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(i,"value"))?n:null==(n=i.value)?"":n:void 0;return r="function"==typeof e,this.each(function(n){var i;1===this.nodeType&&(null==(i=r?e.call(this,n,T(this).val()):e)?i="":"number"==typeof i?i+="":Array.isArray(i)&&(i=T.map(i,function(e){return null==e?"":e+""})),(t=T.valHooks[this.type]||T.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,i,"value")||(this.value=i))})}}),T.extend({valHooks:{select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if((n=i[r]).selected&&!n.disabled&&(!n.parentNode.disabled||!C(n.parentNode,"optgroup"))){if(t=T(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=T.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=T.inArray(T(r).val(),o)>-1)&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),k&&(T.valHooks.option={get:function(e){var t=e.getAttribute("value");return null!=t?t:t2(T.text(e))}}),T.each(["radio","checkbox"],function(){T.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=T.inArray(T(e).val(),t)>-1}}});var t5=/^(?:focusinfocus|focusoutblur)$/,t9=function(e){e.stopPropagation()};T.extend(T.event,{trigger:function(t,n,r,i){var o,a,s,u,l,f,p,d,h=[r||y],v=c.call(t,"type")?t.type:t,m=c.call(t,"namespace")?t.namespace.split("."):[];if((a=d=s=r=r||y,!(3===r.nodeType||8===r.nodeType||t5.test(v+T.event.triggered)))&&(v.indexOf(".")>-1&&(v=(m=v.split(".")).shift(),m.sort()),l=0>v.indexOf(":")&&"on"+v,(t=t[T.expando]?t:new T.Event(v,"object"==typeof t&&t)).isTrigger=i?2:3,t.namespace=m.join("."),t.rnamespace=t.namespace?RegExp("(^|\\.)"+m.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,t.result=void 0,t.target||(t.target=r),n=null==n?[t]:T.makeArray(n,[t]),p=T.event.special[v]||{},i||!p.trigger||!1!==p.trigger.apply(r,n))){if(!i&&!p.noBubble&&!g(r)){for(u=p.delegateType||v,!t5.test(u+v)&&(a=a.parentNode);a;a=a.parentNode)h.push(a),s=a;s===(r.ownerDocument||y)&&h.push(s.defaultView||s.parentWindow||e)}o=0;while((a=h[o++])&&!t.isPropagationStopped())d=a,t.type=o>1?u:p.bindType||v,(f=(e0.get(a,"events")||Object.create(null))[t.type]&&e0.get(a,"handle"))&&f.apply(a,n),(f=l&&a[l])&&f.apply&&eK(a)&&(t.result=f.apply(a,n),!1===t.result&&t.preventDefault());return t.type=v,!i&&!t.isDefaultPrevented()&&(!p._default||!1===p._default.apply(h.pop(),n))&&eK(r)&&l&&"function"==typeof r[v]&&!g(r)&&((s=r[l])&&(r[l]=null),T.event.triggered=v,t.isPropagationStopped()&&d.addEventListener(v,t9),r[v](),t.isPropagationStopped()&&d.removeEventListener(v,t9),T.event.triggered=void 0,s&&(r[l]=s)),t.result}},simulate:function(e,t,n){var r=T.extend(new T.Event,n,{type:e,isSimulated:!0});T.event.trigger(r,null,t)}}),T.fn.extend({trigger:function(e,t){return this.each(function(){T.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return T.event.trigger(e,t,n,!0)}});var t6=e.location,t8={guid:Date.now()},t7=/\?/;T.parseXML=function(t){var n,r;if(!t||"string"!=typeof t)return null;try{n=new e.DOMParser().parseFromString(t,"text/xml")}catch(e){}return r=n&&n.getElementsByTagName("parsererror")[0],(!n||r)&&T.error("Invalid XML: "+(r?T.map(r.childNodes,function(e){return e.textContent}).join("\n"):t)),n};var ne=/\[\]$/,nt=/\r?\n/g,nn=/^(?:submit|button|image|reset|file)$/i,nr=/^(?:input|select|textarea|keygen)/i;T.param=function(e,t){var n,r=[],i=function(e,t){var n="function"==typeof t?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!T.isPlainObject(e))T.each(e,function(){i(this.name,this.value)});else for(n in e)!function e(t,n,r,i){var o;if(Array.isArray(n))T.each(n,function(n,o){r||ne.test(t)?i(t,o):e(t+"["+("object"==typeof o&&null!=o?n:"")+"]",o,r,i)});else if(r||"object"!==h(n))i(t,n);else for(o in n)e(t+"["+o+"]",n[o],r,i)}(n,e[n],t,i);return r.join("&")},T.fn.extend({serialize:function(){return T.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=T.prop(this,"elements");return e?T.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!T(this).is(":disabled")&&nr.test(this.nodeName)&&!nn.test(e)&&(this.checked||!tx.test(e))}).map(function(e,t){var n=T(this).val();return null==n?null:Array.isArray(n)?T.map(n,function(e){return{name:t.name,value:e.replace(nt,"\r\n")}}):{name:t.name,value:n.replace(nt,"\r\n")}}).get()}});var ni=/%20/g,no=/#.*$/,na=/([?&])_=[^&]*/,ns=/^(.*?):[ \t]*([^\r\n]*)$/mg,nu=/^(?:GET|HEAD)$/,nl=/^\/\//,nc={},nf={},np="*/".concat("*"),nd=y.createElement("a");function nh(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,i=0,o=t.toLowerCase().match(Q)||[];if("function"==typeof n)while(r=o[i++])"+"===r[0]?(e[r=r.slice(1)||"*"]=e[r]||[]).unshift(n):(e[r]=e[r]||[]).push(n)}}function ng(e,t,n,r){var i={},o=e===nf;function a(s){var u;return i[s]=!0,T.each(e[s]||[],function(e,s){var l=s(t,n,r);return"string"!=typeof l||o||i[l]?o?!(u=l):void 0:(t.dataTypes.unshift(l),a(l),!1)}),u}return a(t.dataTypes[0])||!i["*"]&&a("*")}function nv(e,t){var n,r,i=T.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&T.extend(!0,e,r),e}nd.href=t6.href,T.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:t6.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(t6.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":np,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":T.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?nv(nv(e,T.ajaxSettings),t):nv(T.ajaxSettings,e)},ajaxPrefilter:nh(nc),ajaxTransport:nh(nf),ajax:function(t,n){"object"==typeof t&&(n=t,t=void 0),n=n||{};var r,i,o,a,s,u,l,c,f,p,d=T.ajaxSetup({},n),h=d.context||d,g=d.context&&(h.nodeType||h.jquery)?T(h):T.event,v=T.Deferred(),m=T.Callbacks("once memory"),x=d.statusCode||{},b={},w={},C="canceled",j={readyState:0,getResponseHeader:function(e){var t;if(l){if(!a){a={};while(t=ns.exec(o))a[t[1].toLowerCase()+" "]=(a[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=a[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return l?o:null},setRequestHeader:function(e,t){return null==l&&(b[e=w[e.toLowerCase()]=w[e.toLowerCase()]||e]=t),this},overrideMimeType:function(e){return null==l&&(d.mimeType=e),this},statusCode:function(e){var t;if(e)if(l)j.always(e[j.status]);else for(t in e)x[t]=[x[t],e[t]];return this},abort:function(e){var t=e||C;return r&&r.abort(t),E(0,t),this}};if(v.promise(j),d.url=((t||d.url||t6.href)+"").replace(nl,t6.protocol+"//"),d.type=n.method||n.type||d.method||d.type,d.dataTypes=(d.dataType||"*").toLowerCase().match(Q)||[""],null==d.crossDomain){u=y.createElement("a");try{u.href=d.url,u.href=u.href,d.crossDomain=nd.protocol+"//"+nd.host!=u.protocol+"//"+u.host}catch(e){d.crossDomain=!0}}if(ng(nc,d,n,j),d.data&&d.processData&&"string"!=typeof d.data&&(d.data=T.param(d.data,d.traditional)),l)return j;for(f in(c=T.event&&d.global)&&0==T.active++&&T.event.trigger("ajaxStart"),d.type=d.type.toUpperCase(),d.hasContent=!nu.test(d.type),i=d.url.replace(no,""),d.hasContent?d.data&&d.processData&&0===(d.contentType||"").indexOf("application/x-www-form-urlencoded")&&(d.data=d.data.replace(ni,"+")):(p=d.url.slice(i.length),d.data&&(d.processData||"string"==typeof d.data)&&(i+=(t7.test(i)?"&":"?")+d.data,delete d.data),!1===d.cache&&(i=i.replace(na,"$1"),p=(t7.test(i)?"&":"?")+"_="+t8.guid+++p),d.url=i+p),d.ifModified&&(T.lastModified[i]&&j.setRequestHeader("If-Modified-Since",T.lastModified[i]),T.etag[i]&&j.setRequestHeader("If-None-Match",T.etag[i])),(d.data&&d.hasContent&&!1!==d.contentType||n.contentType)&&j.setRequestHeader("Content-Type",d.contentType),j.setRequestHeader("Accept",d.dataTypes[0]&&d.accepts[d.dataTypes[0]]?d.accepts[d.dataTypes[0]]+("*"!==d.dataTypes[0]?", "+np+"; q=0.01":""):d.accepts["*"]),d.headers)j.setRequestHeader(f,d.headers[f]);if(d.beforeSend&&(!1===d.beforeSend.call(h,j,d)||l))return j.abort();if(C="abort",m.add(d.complete),j.done(d.success),j.fail(d.error),r=ng(nf,d,n,j)){if(j.readyState=1,c&&g.trigger("ajaxSend",[j,d]),l)return j;d.async&&d.timeout>0&&(s=e.setTimeout(function(){j.abort("timeout")},d.timeout));try{l=!1,r.send(b,E)}catch(e){if(l)throw e;E(-1,e)}}else E(-1,"No Transport");function E(t,n,a,u){var f,p,y,b,w,C=n;!l&&(l=!0,s&&e.clearTimeout(s),r=void 0,o=u||"",j.readyState=4*(t>0),f=t>=200&&t<300||304===t,a&&(b=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r){for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(d,j,a)),!f&&T.inArray("script",d.dataTypes)>-1&&0>T.inArray("json",d.dataTypes)&&(d.converters["text script"]=function(){}),b=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift()){if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o])){for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}}if(!0!==a)if(a&&e.throws)t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}}return{state:"success",data:t}}(d,b,j,f),f?(d.ifModified&&((w=j.getResponseHeader("Last-Modified"))&&(T.lastModified[i]=w),(w=j.getResponseHeader("etag"))&&(T.etag[i]=w)),204===t||"HEAD"===d.type?C="nocontent":304===t?C="notmodified":(C=b.state,p=b.data,f=!(y=b.error))):(y=C,(t||!C)&&(C="error",t<0&&(t=0))),j.status=t,j.statusText=(n||C)+"",f?v.resolveWith(h,[p,C,j]):v.rejectWith(h,[j,C,y]),j.statusCode(x),x=void 0,c&&g.trigger(f?"ajaxSuccess":"ajaxError",[j,d,f?p:y]),m.fireWith(h,[j,C]),c&&(g.trigger("ajaxComplete",[j,d]),--T.active||T.event.trigger("ajaxStop")))}return j},getJSON:function(e,t,n){return T.get(e,t,n,"json")},getScript:function(e,t){return T.get(e,void 0,t,"script")}}),T.each(["get","post"],function(e,t){T[t]=function(e,n,r,i){return("function"==typeof n||null===n)&&(i=i||r,r=n,n=void 0),T.ajax(T.extend({url:e,type:t,dataType:i,data:n,success:r},T.isPlainObject(e)&&e))}}),T.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),T._evalUrl=function(e,t,n){return T.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,scriptAttrs:t.crossOrigin?{crossOrigin:t.crossOrigin}:void 0,converters:{"text script":function(){}},dataFilter:function(e){T.globalEval(e,t,n)}})},T.fn.extend({wrapAll:function(e){var t;return this[0]&&("function"==typeof e&&(e=e.call(this[0])),t=T(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(e){return"function"==typeof e?this.each(function(t){T(this).wrapInner(e.call(this,t))}):this.each(function(){var t=T(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t="function"==typeof e;return this.each(function(n){T(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(e){return this.parent(e).not("body").each(function(){T(this).replaceWith(this.childNodes)}),this}}),T.expr.pseudos.hidden=function(e){return!T.expr.pseudos.visible(e)},T.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},T.ajaxSettings.xhr=function(){return new e.XMLHttpRequest};var ny={0:200};function nm(e){return e.scriptAttrs||!e.headers&&(e.crossDomain||e.async&&0>T.inArray("json",e.dataTypes))}T.ajaxTransport(function(e){var t;return{send:function(n,r){var i,o=e.xhr();if(o.open(e.type,e.url,e.async,e.username,e.password),e.xhrFields)for(i in e.xhrFields)o[i]=e.xhrFields[i];for(i in e.mimeType&&o.overrideMimeType&&o.overrideMimeType(e.mimeType),e.crossDomain||n["X-Requested-With"]||(n["X-Requested-With"]="XMLHttpRequest"),n)o.setRequestHeader(i,n[i]);t=function(e){return function(){t&&(t=o.onload=o.onerror=o.onabort=o.ontimeout=null,"abort"===e?o.abort():"error"===e?r(o.status,o.statusText):r(ny[o.status]||o.status,o.statusText,"text"===(o.responseType||"text")?{text:o.responseText}:{binary:o.response},o.getAllResponseHeaders()))}},o.onload=t(),o.onabort=o.onerror=o.ontimeout=t("error"),t=t("abort");try{o.send(e.hasContent&&e.data||null)}catch(e){if(t)throw e}},abort:function(){t&&t()}}}),T.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},converters:{"text script":function(e){return T.globalEval(e),e}}}),T.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),nm(e)&&(e.type="GET")}),T.ajaxTransport("script",function(e){if(nm(e)){var t,n;return{send:function(r,i){t=T("<script>").attr(e.scriptAttrs||{}).prop({charset:e.scriptCharset,src:e.url}).on("load error",n=function(e){t.remove(),n=null,e&&i("error"===e.type?404:200,e.type)}),y.head.appendChild(t[0])},abort:function(){n&&n()}}}});var nx=[],nb=/(=)\?(?=&|$)|\?\?/;T.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=nx.pop()||T.expando+"_"+t8.guid++;return this[e]=!0,e}}),T.ajaxPrefilter("jsonp",function(t,n,r){var i,o,a,s=!1!==t.jsonp&&(nb.test(t.url)?"url":"string"==typeof t.data&&0===(t.contentType||"").indexOf("application/x-www-form-urlencoded")&&nb.test(t.data)&&"data");return i=t.jsonpCallback="function"==typeof t.jsonpCallback?t.jsonpCallback():t.jsonpCallback,s?t[s]=t[s].replace(nb,"$1"+i):!1!==t.jsonp&&(t.url+=(t7.test(t.url)?"&":"?")+t.jsonp+"="+i),t.converters["script json"]=function(){return a||T.error(i+" was not called"),a[0]},t.dataTypes[0]="json",o=e[i],e[i]=function(){a=arguments},r.always(function(){void 0===o?T(e).removeProp(i):e[i]=o,t[i]&&(t.jsonpCallback=n.jsonpCallback,nx.push(i)),a&&"function"==typeof o&&o(a[0]),a=o=void 0}),"script"}),T.ajaxPrefilter(function(t,n){"string"==typeof t.data||T.isPlainObject(t.data)||Array.isArray(t.data)||"processData"in n||(t.processData=!1),t.data instanceof e.FormData&&(t.contentType=!1)}),T.parseHTML=function(t,n,r){var i,o;return"string"==typeof t||eR(t+"")?("boolean"==typeof n&&(r=n,n=!1),n||(n=new e.DOMParser().parseFromString("","text/html")),i=eP.exec(t),o=!r&&[],i)?[n.createElement(i[1])]:(i=tg([t],n,o),o&&o.length&&T(o).remove(),T.merge([],i.childNodes)):[]},T.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return s>-1&&(r=t2(e.slice(s)),e=e.slice(0,s)),"function"==typeof t?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),a.length>0&&T.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?T("<div>").append(T.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},T.expr.pseudos.animated=function(e){return T.grep(T.timers,function(t){return e===t.elem}).length},T.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=T.css(e,"position"),c=T(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=T.css(e,"top"),u=T.css(e,"left"),("absolute"===l||"fixed"===l)&&(o+u).indexOf("auto")>-1?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),"function"==typeof t&&(t=t.call(e,n,T.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},T.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each(function(t){T.offset.setOffset(this,e,t)});var t,n,r=this[0];if(r)return r.getClientRects().length?(t=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===T.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&e!==n.documentElement&&"static"===T.css(e,"position"))e=e.offsetParent||n.documentElement;e&&e!==r&&1===e.nodeType&&"static"!==T.css(e,"position")&&(i=T(e).offset(),i.top+=T.css(e,"borderTopWidth",!0),i.left+=T.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-T.css(r,"marginTop",!0),left:t.left-i.left-T.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===T.css(e,"position"))e=e.offsetParent;return e||L})}}),T.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,t){var n="pageYOffset"===t;T.fn[e]=function(r){return V(this,function(e,r,i){var o;if(g(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===i)return o?o[t]:e[r];o?o.scrollTo(n?o.pageXOffset:i,n?i:o.pageYOffset):e[r]=i},e,r,arguments.length)}}),T.each({Height:"height",Width:"width"},function(e,t){T.each({padding:"inner"+e,content:t,"":"outer"+e},function(n,r){T.fn[r]=function(i,o){var a=arguments.length&&(n||"boolean"!=typeof i),s=n||(!0===i||!0===o?"margin":"border");return V(this,function(t,n,i){var o;return g(t)?0===r.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body["scroll"+e],o["scroll"+e],t.body["offset"+e],o["offset"+e],o["client"+e])):void 0===i?T.css(t,n,s):T.style(t,n,i,s)},t,a?i:void 0,a)}})}),T.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){T.fn[t]=function(e){return this.on(t,e)}}),T.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1==arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),T.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,t){T.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),T.proxy=function(e,t){var n,r,o;if("string"==typeof t&&(n=e[t],t=e,e=n),"function"==typeof e)return r=i.call(arguments,2),(o=function(){return e.apply(t||this,r.concat(i.call(arguments)))}).guid=e.guid=e.guid||T.guid++,o},T.holdReady=function(e){e?T.readyWait++:T.ready(!0)},T.expr[":"]=T.expr.filters=T.expr.pseudos,"function"==typeof define&&define.amd&&define("jquery",[],function(){return T});var nw=e.jQuery,nT=e.$;return T.noConflict=function(t){return e.$===T&&(e.$=nT),t&&e.jQuery===T&&(e.jQuery=nw),T},void 0===t&&(e.jQuery=e.$=T),T});
APP.Calculator = (function () {
    var exports = {},
        calculatorList = [],
        idSeeker = 0,
        wrapperTemplateString,
        expSupMoveTimer,
        isSymbolMode,
        keyTable = [
            'Space',
            'Backspace',
            'Tab',
            'Enter',
            'AltGraph',
            'End',
            'Home',
            'ArrowLeft',
            'ArrowUp',
            'ArrowRight',
            'ArrowDown',
            'Delete',
            'a',
            'c',
            'x',
            'y',
            'z',
            '/',
            '('
        ],

        formulaChildLengths = {
            'root': 2,
            'per': 2,
            'log': 2,
            'exp': 2,
            'abs': 1,
            'p': 1
        },

        formulaDefaultChildIndexes = {
            'root': 1,
            'root:inverse': 0,
            'per': 0,
            'per:inverse': 1,
            'log': 1,
            'log:inverse': 0,
            'exp': 0,
            'exp:inverse': 1,
            'abs': 0,
            'p': 0
        },

        virtualSelection,
        inited = false;

    function init() {
        if (!inited) {
            inited = true;
            wrapperTemplateString = getTemplate('wrapper');
        }

        isSymbolMode = $body.find('[data-symbol-mode="true"]').length > 0;

        $body.find('[data-calculator]:not([data-calculator-inited])').each(function () {
            requestAnimationFrame(() => {
                new Calculator($(this), getUniqueId());
                APP.Calculator.Keyboard.init();
            });
        });
    }

    function parseFormula(type, child, id) {
        var templateString,
            wrapperString = wrapperTemplateString.replace('{id}', id),
            contentString,
            index = 0;

        switch (type) {
            case 'wrapper':
                if (child.length > 0) {
                    templateString = '';
                    child.forEach(function (children) {
                        templateString += children.toHtml();
                    });
                } else {
                    templateString = getTemplate('placeholder');
                }
                break;

            case 'char':
                templateString = [APP.Locale.replaceMathCharacters(child[0])];

                if (isSymbolMode) {
                    if ('ABCDEF'.indexOf(child[0]) > -1) {
                        templateString = getTemplate('shape').replace(/\{0\}/g, child[0].toLowerCase());
                    }
                }
                break;

            default:
                templateString = getTemplate(type);
                if (type === 'exp' || type === 'log') {
                    templateString = templateString.replace('{ghost-phase}', child[0].parent.ghostPhase);
                }

                while (templateString.indexOf('{' + index + '}') > -1) {
                    contentString = child[index].toHtml();
                    templateString = templateString.replace('{' + index + '}', contentString);
                    index++;
                }
                break;

        }

        wrapperString = wrapperString.replace('{type}', type);
        wrapperString = wrapperString.replace('{content}', templateString);
        return wrapperString;

    }

    function getTemplate(name) {
        return APP.$store.templates['calculator/' + name] || '';
    }

    function getSelection() {
        var html = '',
            parent = null,
            range;

        if (typeof window.getSelection !== 'undefined') {
            var sel = window.getSelection();
            if (sel.rangeCount) {
                var container = document.createElement('div');
                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;

                parent = sel.getRangeAt(0).commonAncestorContainer;
                if (parent.nodeType !== 1) {
                    parent = parent.parentNode;
                }
            }

        } else if (typeof document.selection !== 'undefined') {
            if (document.selection.type === 'Text') {
                range = document.selection.createRange();
                html = range.htmlText;
                parent = range.parentElement();
            }
        }

        return {
            html: html,
            parent: parent
        };

    }

    function getTextSelectionLengthOfElement(element) {
        var selectedText;
        if (typeof document.selection !== 'undefined') {
            element.focus();
            var sel = document.selection.createRange();
            selectedText = sel.text;
        } else if (typeof element.selectionStart !== 'undefined') {
            var startPos = element.selectionStart;
            var endPos = element.selectionEnd;
            selectedText = element.value.substring(startPos, endPos);
        }

        return selectedText.length;
    }

    function getUniqueId() {
        return ++idSeeker;
    }

    // TODO: put it to modules!

    // CALCULATOR OBJECT:
    // -----------------------------------------------------------------------------------------------------------------

    function Calculator($element, id) {
        var _self = this,
            $wrapper,
            $hunter,
            $display,
            $valueHolder,
            hunterFocused = false,
            allFormula = {},
            pointer = null,
            initialized = false,

            history = [],
            historyMoment = 0,
            mouseX = null,
            pasted = false,

            selectionStartX,
            selectionStartY,

            isMouseDown = false,
            isMouseMoved = false,

            wrapperStarter = false;

        function init($el) {
            $wrapper = $el;
            $wrapper.attr('data-calculator-inited', true);
            $hunter = $wrapper.find('[data-calculator-focus-hunter]');
            $display = $wrapper.find('[data-calculator-display]');
            $valueHolder = $wrapper.find('input[type="hidden"]');
            _self.valueObject = newFormula('wrapper');
            _self.valueObject.addChild(getFormulasFromString($el.attr('data-calculator')));
            initAllFormula();
            pointer = _self.valueObject;
            initBinding();
            echoValue();
            initialized = true;
            if ($wrapper.attr('data-calculator-auto-focus') === 'true' && document.location.hash === '#input') {
                setTimeout(addFocus, 8);
            }
            APP.Calculator.Keyboard.add(_self);
        }

        function initAllFormula() {
            var id;

            for (id in allFormula) {
                if (allFormula.hasOwnProperty(id)) {
                    allFormula[id].setExpAndLogGhostP();
                }
            }
        }

        function exitCalculator() {
            hunterFocused = false;
            isMouseDown = false;
        }

        function initBinding() {
            window.onCalculatorFocus = window.onCalculatorFocus || [];
            window.onCalculatorFocus[id] = function (calculator) {
                hunterFocused = true;
                APP.Calculator.Keyboard.show(calculator);
                drawPointerOrSelection();
            };

            $hunter.on({
                'focus': function () {
                    window.onCalculatorFocus[id](_self);
                },
                'blur': blurHunter,
                'keyup': keyUp,
                'keydown': keyDown,
                'paste': function () {
                    keyUp();
                    pasted = true;
                    $hunter.val('');
                }
            });

            $wrapper.on('click', '.calculator--placeholder', function (e) {
                var wrapperId = parseInt($(this).parent().attr('data-calculator-element-id'), 10),
                    pointer = getFormulaById(wrapperId);

                pointer.pointerPosition = 0;
                pointer.length = 0;
                pointFormula(pointer);
            });

            $wrapper.on('dblclick dbltap', '[data-calculator-element-type="wrapper"]', function (event) {
                var formula = getFormulaById($(this).attr('data-calculator-element-id'));

                event.stopPropagation();
                event.preventDefault();
                setTimeout(function () {
                    formula && formula.selectAll();
                }, 1);
            });

            $body.off('.calculatorSelection' + id);

            $body.on('touchstart.calculatorSelection' + id + ' mousedown.calculatorSelection' + id, function (event) {
                var $target = $(event.target),
                    isKeyboardShown = APP.Calculator.Keyboard.isShown(id),
                    notKeyboardAction = $target.parents('[data-keyboard]').length === 0;

                if (isKeyboardShown && notKeyboardAction) {
                    var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                        clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY;

                    selectionStartX = clientX + window.scrollX;
                    selectionStartY = clientY + window.scrollY;
                    isMouseDown = true;
                }
            });

            $body.on('touchmove.calculatorSelection' + id + ' mousemove.calculatorSelection' + id, function (event) {
                if (isMouseDown) {
                    var clientX = event.clientX || event.originalEvent.touches && event.originalEvent.touches[0].clientX,
                        clientY = event.clientY || event.originalEvent.touches && event.originalEvent.touches[0].clientY,
                        selection = rectangleSelect(
                            selectionStartX,
                            selectionStartY,
                            clientX + window.scrollX,
                            clientY + window.scrollY
                        );

                    event.stopPropagation();
                    if (selection) {
                        isMouseMoved = true;
                        pointFormula(selection);
                    } else {
                        pointer.pointerLength = 0;
                        pointFormula(pointer);
                    }
                }
            });

            $body.on('touchend.calculatorSelection' + id + ' mouseup.calculatorSelection' + id, function (event) {
                var $target = $(event.target),
                    isKeyboardShown = APP.Calculator.Keyboard.isShown(id),
                    notKeyboardAction = $target.parents('[data-keyboard]').length === 0,
                    isPlaceholder = $target.attr('class') === 'calculator--placeholder',
                    selection;

                if (!isPlaceholder && (isKeyboardShown || wrapperStarter) && !isMouseMoved && notKeyboardAction && ($target.parents('[data-calculator]').length === 1 || isKeyboardShown)) {
                    selection = pointSelect(selectionStartX, selectionStartY);
                    if (selection) {
                        selection.pointerLength = 0;
                        pointFormula(selection);
                    } else {
                        exitCalculator();
                    }
                }

                isMouseDown = false;
                isMouseMoved = false;
                wrapperStarter = false;

            });

        }

        function rectangleSelect(x1, y1, x2, y2) {
            var left = Math.min(x1, x2),
                top = Math.min(y1, y2),
                right = Math.max(x1, x2),
                bottom = Math.max(y1, y2),
                elements = [],
                $wrappers = $body.find('nope');

            $wrapper.find('[data-calculator-element]:not([data-calculator-element-type="wrapper"])').each(function () {
                var $this = $(this),
                    type = $this.attr('data-calculator-element-type'),
                    offset = $this.offset(),
                    x = offset.left,
                    y = offset.top,
                    w = $this.width(),
                    h = $this.height(),
                    $myWrapper;

                if (type === 'char') {
                    if (x + w >= left
                        && y + h >= top
                        && x <= right
                        && y <= bottom) {
                        elements.push(parseInt($this.attr('data-calculator-element-id'), 10));
                        $myWrapper = $this.parents('[data-calculator-element-type="wrapper"]').first();
                    }
                } else {
                    if (x >= left
                        && y >= top
                        && x + w <= right
                        && y + h <= bottom) {
                        elements.push(parseInt($this.attr('data-calculator-element-id'), 10));
                        $myWrapper = $this.parents('[data-calculator-element-type="wrapper"]').first();
                    }
                }

                if ($myWrapper) {
                    $wrappers = $wrappers.add($myWrapper);
                }

            });

            $wrappers.find('> [data-calculator-element-before], > [data-calculator-element-after]').each(function () {
                var $this = $(this),
                    offset = $this.offset(),
                    x = offset.left,
                    y = offset.top,
                    w = $this.width(),
                    h = $this.height();

                if (x + w >= left
                    && y + h >= top
                    && x <= right
                    && y <= bottom) {
                    var $p = $this.parents('[data-calculator-element]:not([data-calculator-element-type="wrapper"])').first();

                    elements.push(parseInt($p.attr('data-calculator-element-id'), 10));
                }
            });

            return createPointerFromRectangle(elements);
        }

        function pointSelect(x1, y1) {
            var left = x1,
                top = y1,
                right = x1,
                bottom = y1,
                elements = [],
                pointer,
                element;

            $wrapper.find('[data-calculator-element]:not([data-calculator-element-type="wrapper"])').each(function () {
                var $this = $(this),
                    offset = $this.offset(),
                    x = offset.left,
                    y = offset.top,
                    w = $this.width(),
                    h = $this.height();

                if (x + w >= left
                    && y + h >= top
                    && x <= right
                    && y <= bottom) {
                    elements.push(parseInt($this.attr('data-calculator-element-id'), 10));
                }

            });

            element = getInnerElement(elements);
            if (element && element.parent) {
                pointer = element.parent;
                pointer.pointerPosition = pointer.child.indexOf(element);
                if (isCoordinateAfterTheElement(element.id, x1)) {
                    pointer.pointerPosition++;
                }
            } else {
                pointer = getRootElement();
                pointer.pointerPosition = 0;
                if (isCoordinateAfterTheElement(pointer.id, x1)) {
                    pointer.pointerPosition = pointer.child.length;
                }
            }

            return pointer;
        }

        function isCoordinateAfterTheElement(element, x) {
            var $element = $wrapper.find('[data-calculator-element-id="' + element + '"]'),
                midpoint = $element.offset().left + ($element.width() / 2);

            return x > midpoint;
        }

        function getInnerElement(elements) {
            var innerElement = elements[0],
                depth = getParentDepth(innerElement);

            elements.forEach(function (element) {
                var d = getParentDepth(element);

                if (d > depth) {
                    innerElement = element;
                    depth = d;
                }
            });

            return getFormulaById(innerElement);

            function getParentDepth(element, plus) {
                var e = getFormulaById(element);
                plus = plus || 0;

                if (e && e.parent) {
                    return getParentDepth(e.parent.id, ++plus);
                }

                return plus;
            }
        }

        function createPointerFromRectangle(array) {
            var commonParentId,
                pointerFormula,
                pointerPosition = -1,
                pointerLength = 0,
                parents,
                extendedArray;

            if (!array || !array.length) {
                return false;
            }

            parents = getParents(array);
            commonParentId = parents.common;
            pointerFormula = getFormulaById(commonParentId);

            if (pointerFormula) {
                extendedArray = array.concat(parents.extend);
                pointerFormula.child.forEach(function (child, index) {
                    if (extendedArray.indexOf(child.id) > -1) {
                        if (pointerPosition === -1) {
                            pointerPosition = index;
                        }
                        pointerLength = index - pointerPosition + 1;
                    }
                });

                pointerFormula.pointerPosition = pointerPosition;
                pointerFormula.pointerLength = pointerLength;
            }
            return pointerFormula;

            function getParents(idArray) {
                var parentMatrix = [],
                    commonParent,
                    commonParentElement,
                    allParent = [],
                    breakLoop = false,
                    row,
                    actualParent,
                    parentLength = Infinity,
                    i,
                    p;

                idArray.forEach(function (item) {
                    row = getParentRow(item);
                    if (row.length < parentLength) {
                        parentLength = row.length;
                    }
                    parentMatrix.push(row);
                });

                commonParent = parentMatrix[0][0];
                for (p = 0; p < parentLength && !breakLoop; p++) {
                    actualParent = parentMatrix[0][p];
                    for (i = 1; i < idArray.length && !breakLoop; i++) {
                        if (actualParent !== parentMatrix[i][p]) {
                            breakLoop = true;
                        }
                    }
                    if (!breakLoop) {
                        commonParent = actualParent;
                    }
                }

                commonParentElement = getFormulaById(commonParent);
                if (commonParentElement && commonParentElement.type !== 'wrapper' && commonParentElement.parent) {
                    commonParent = commonParentElement.parent.id;
                }

                return {common: commonParent, extend: allParent};

                function getParentRow(id, prefix) {
                    var formula = getFormulaById(id),
                        row = prefix || [],
                        parentId;

                    if (formula && formula.parent) {
                        parentId = formula.parent.id;
                        row.push(parentId);
                        if (allParent.indexOf(parentId) === -1) {
                            allParent.push(parentId);
                        }
                        return getParentRow(formula.parent.id, row);
                    }

                    return row.reverse();
                }
            }

        }

        function getRootElement() {
            return getFormulaById(parseInt($wrapper.find('[data-calculator-element-id]').attr('data-calculator-element-id'), 10));
        }

        function setScrollbar() {
            if ($display.outerWidth() > $element.outerWidth()) {
                $element.addClass('add-scroll');
            } else {
                $element.removeClass('add-scroll');
            }
        }

        function hideCursor() {
            resetSelection();
            resetPointers();
        }

        function mouseDown(event) {
            mouseX = event.clientX;
        }

        function keyUp() {
            var hunterSelected = getTextSelectionLengthOfElement($hunter[0]) === 0;
            if ($hunter.val().length > 0 && hunterSelected && !pasted) {
                addString($hunter.val());
            } else if (pasted) {
                pasted = false;
                onPaste($hunter.val());
                $hunter.val('');
            }
        }

        function onPaste(pastedString) {
            if (pastedString) {
                pointer.addChild(getFormulasFromString(pastedString));
                initAllFormula();
                echoValue();
                drawPointerOrSelection();
                APP.Analytics.trackEvent('calculator', 'paste');
            }
        }

        function blurHunter() {
            exitCalculator();
            setTimeout(function () {
                if (APP.Calculator.Keyboard.shouldRestoreFocus(_self, $hunter[0])) {
                    addFocus();
                }
            }, 20);
        }

        function keyDown(event) {
            var actions = [],
                preventDefault = false;

            if (event.originalEvent && event.originalEvent.repeat) {
                return false;
            }

            let key = event.key;

            if (key === ' ') {
                key = 'Space';
            }

            if (['Space', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', '(', '/'].includes(key)) {
                preventDefault = true;
            }

            // Ctrl+Y, Ctrl+Z
            if (event.ctrlKey && (key.toLowerCase() === 'y' || key.toLowerCase() === 'z')) {
                preventDefault = true;
            }

            if (preventDefault) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (keyTable.indexOf(key) > -1) {
                if (event.ctrlKey) actions.push('ctrl');
                if (event.altKey) actions.push('alt');
                if (event.shiftKey) actions.push('shift');

                actions.push(key.toLowerCase());
                addHotKey(actions.join('+').toLowerCase());
            }
        }

        function getFormulasFromString(string) {
            var formulas = [],
                json;

            try {
                json = JSON.parse(string);
            } catch (error) {
                json = false;
            }

            if (json && validateJson(json)) {
                formulas = getFormulaFromJson(json);
            }

            return formulas;
        }

        function validateJson(json) {
            // TODO VALIDATE JSON STRUCTURE!!
            return !!json; //true;
        }

        function getFormulaFromJson(json, parent) {
            var formula,
                result,
                i,
                j;

            if (json) {
                if (Array.isArray(json)) {
                    formula = [];
                    for (i = 0; i < json.length; i++) {
                        result = getFormulaFromJson(json[i], parent);
                        if (Array.isArray(result)) {
                            for (j = 0; j < result.length; j++) {
                                formula.push(result[j]);
                            }
                        } else {
                            formula.push(result);
                        }
                    }
                } else {
                    if (typeof json === 'string') {
                        formula = createCharFormulasByString(json, parent);
                    } else if (isSymbolMode && json.type === 'shape' &&
                        json.child && json.child.length === 1 && /^[a-f]$/.test(json.child[0])) {
                        // Saved kernel shapes use the same editable operands as the symbol keyboard.
                        formula = createCharFormulasByString(json.child[0].toUpperCase(), parent);
                    } else {
                        formula = newFormula(json.type);
                        if (json.id) {
                            formula.id = json.id;
                            allFormula[json.id] = formula;
                        }
                        formula.child = getFormulaFromJson(json.child, formula);
                    }
                    formula.parent = parent;
                }
                return formula;
            } else {
                return [];
            }

        }

        function newFormula(type, child, parent) {
            var id = getUniqueId(),
                formula = new Formula({
                    id: id,
                    type: type,
                    child: child || []
                }, _self, parent);

            fillFormulaWithWrappers(formula);
            allFormula[id] = formula;

            return formula;

        }

        function fillFormulaWithWrappers(formula) {
            var childLength = formulaChildLengths[formula.type] || 0;
            while (childLength-- > 0) {
                formula.child.push(newFormula('wrapper', [], formula));
            }
        }

        function getFormulaById(id) {
            return allFormula[id];
        }

        function echoValue(disableFromHistory) {
            var val = _self.getContent();

            $wrapper.find('[data-calculator-display]').html(_self.valueObject.toHtml());
            APP.Formula.cosmeticFormulaByWrapper($wrapper);
            $element.attr('data-value', _self.getContent());
            APP.Live.saveClientMeta('input', {
                type: 'formula',
                value: val
            });
            if (!disableFromHistory) {
                addToHistory();
            }
            setScrollbar();
        }

        function addToHistory() {
            var content = deepClone(_self.valueObject.toJson(true));

            history = history.slice(0, ++historyMoment);
            history.push({
                pointer: {
                    id: pointer && pointer.id,
                    pointerPosition: pointer && pointer.pointerPosition,
                    pointerLength: pointer && pointer.pointerLength
                },
                content: content
            });

            if ($valueHolder) {
                $valueHolder.val(getContent());
            }

        }

        function applyHistoryItem(index) {
            var moment = history[index];

            if (!moment) {
                return;
            }

            allFormula = {};
            historyMoment = index;
            _self.valueObject = getFormulaFromJson(moment.content);
            pointer = getFormulaById(moment.pointer.id);
            pointer.pointerPosition = moment.pointer.pointerPosition;
            pointer.pointerLength = moment.pointer.pointerLength;

            initAllFormula();
            echoValue(true);
            drawPointerOrSelection();
        }

        function undo() {
            if (historyMoment > 0) {
                APP.Analytics.trackEvent('calculator', 'undo');
                applyHistoryItem(Math.min(historyMoment - 1, history.length - 2));
            }
        }

        function redro() {
            if (historyMoment < history.length - 1) {
                APP.Analytics.trackEvent('calculator', 'redro');
                applyHistoryItem(historyMoment + 1);
            }
        }

        function getContent() {
            return stringifyJson(_self.valueObject.toJson().child);
        }

        function cleanInput() {
            pointer = _self.valueObject = getFormulaFromJson({type: "wrapper", child: Array(0), id: 0});
            pointer.pointerPosition = 0;
            pointer.pointerLength = 0;
            echoValue(true);
            drawPointerOrSelection();
        }

        function addFocus() {
            if (!hunterFocused) {
                if ($hunter[0]) {
                    $hunter[0].focus({ preventScroll: true });
                }
            }
        }

        function addString(string) {
            $hunter.val('');
            string = string.replace(/[^a-zA-Z0-9\u16A1\u00B1\-\+\*:=≠>≥<≤]*/g, '');
            pointer.addChild(createCharFormulasByString(string));
            echoValue();
            drawPointerOrSelection();
            addFocus();
        }

        function createCharFormulasByString(string, parent) {
            var i, formulas = [];
            for (i = 0; i < string.length; i++) {
                formulas.push(newFormula('char', [string[i]], parent));
            }
            return formulas;
        }

        function addFormula(action) {
            var formula = newFormula(action.split(':')[0]),
                targetChild = pointer.addChild(formula, action);

            if (!targetChild && formulaDefaultChildIndexes.hasOwnProperty(action)) {
                targetChild = formula.child[formulaDefaultChildIndexes[action]];
            }
            echoValue();
            addFocus();
            targetChild.addFocus();
        }

        function addHotKey(method) {
            pointer.hotKey(method);
            addFocus();
        }

        function pointFormula(formula) {
            pointer = formula;
            drawPointerOrSelection();
            clearTimeout(expSupMoveTimer);
        }

        function drawPointerOrSelection() {
            resetSelection();
            resetPointers();
            APP.Calculator.Keyboard.addStatus(pointer.pointerLength);
            if (pointer.pointerLength === 0) {
                putPointer();
            } else {
                putSelection();
            }
        }

        function putPointer() {
            if (pointer.child.length === 0) {
                pointer.pointerPosition = 0;
                pointElementById(pointer.id, 'inner');
            } else if (pointer.pointerPosition < pointer.child.length) {
                if (pointer.pointerPosition === -1) {
                    pointer.pointerPosition = 0;
                }
                pointElementById(pointer.child[pointer.pointerPosition].id, 'before');
            } else {
                pointElementById(pointer.child[pointer.child.length - 1].id, 'after');
            }
            $hunter.val('');
        }

        function pointElementById(id, type) {
            $wrapper.find('[data-calculator-element-id="' + id + '"]').addClass('calculator--element-pointer-' + type);
            addFocusToElement(id);
        }

        function resetPointers() {
            $wrapper.find('.calculator--element')
                .removeClass('calculator--element-pointer-before')
                .removeClass('calculator--element-pointer-after')
                .removeClass('calculator--element-pointer-inner')
                .removeClass('calculator--element-focus')
                .removeClass('calculator--element-focus-inner-ghost');
        }

        function putSelection() {
            getSelection(true);
        }

        function getSelection(put) {
            var length = pointer.pointerLength,
                position = pointer.pointerPosition,
                from = length < 0 ? position + length : position,
                to = length < 0 ? position : position + length,
                selection = [],
                value;

            while (from++ < to) {
                selection.push(pointer.child[from - 1].toJson());
                selectElementById(pointer.child[from - 1].id);
            }
            if (pointer.child[0]) {
                addFocusToElement(pointer.child[0].id);
            }
            value = stringifyJson(selection);

            if (put) {
                $hunter.val(value);

                if (hunterFocused && !APP.Page.hasVirtualKeyboard()) {
                    $hunter[0].setSelectionRange(0, value.length);
                }
            } else {
                return value;
            }
        }

        function addFocusToElement(childId) {
            if (!childId) {
                return;
            }

            var childFormula = getFormulaById(childId),
                parentFormula = childFormula.parent,
                addInnerGhostClass = false;

            if (!!parentFormula && !!parentFormula.parent) {
                if (parentFormula.type === 'wrapper') {
                    parentFormula = parentFormula.parent;
                }
                $wrapper.find('[data-calculator-element-id="' + parentFormula.id + '"]')
                    .addClass('calculator--element-focus');

                if (parentFormula.type === 'exp') {
                    if (childFormula.type === 'wrapper' && childFormula.id === parentFormula.child[0].id) {
                        addInnerGhostClass = true;
                    } else if (childFormula.type !== 'wrapper' && childFormula.parent.id === parentFormula.child[0].id) {
                        addInnerGhostClass = true;
                    }
                } else if (parentFormula.type === 'log') {
                    if (childFormula.type === 'wrapper' && childFormula.id === parentFormula.child[1].id) {
                        addInnerGhostClass = true;
                    } else if (childFormula.type !== 'wrapper' && childFormula.parent.id === parentFormula.child[1].id) {
                        addInnerGhostClass = true;
                    }
                }

                if (addInnerGhostClass) {
                    $wrapper.find('[data-calculator-element-id="' + parentFormula.id + '"]')
                        .addClass('calculator--element-focus-inner-ghost');
                }

            }

        }

        function stringifyJson(json) {
            var string = JSON.stringify(json);
            string = string.replace(/"type"/g, '{!!!type!!!}');
            string = string.replace(/"child"/g, '{!!!child!!!}');
            string = string.replace(/","/g, '');
            string = string.replace(/{!!!type!!!}/g, '"type"');
            string = string.replace(/{!!!child!!!}/g, '"child"');
            return string;
        }

        function selectElementById(id) {
            $wrapper.find('[data-calculator-element-id="' + id + '"]').addClass('calculator--element-select-all');
        }

        function resetSelection() {
            $wrapper.find('.calculator--element-select-all')
                .removeClass('calculator--element-select-all');
        }

        function isSendable() {
            return $element.attr('data-prevent-send') !== 'true';
        }

        function isAttached() {
            return $.contains(document.documentElement, $wrapper[0]);
        }

        _self.valueObject = null;

        _self.addFocus = addFocus;
        _self.addString = addString;
        _self.addFormula = addFormula;
        _self.addHotKey = addHotKey;
        _self.getFormulaById = getFormulaById;
        _self.pointFormula = pointFormula;
        _self.newFormula = newFormula;
        _self.echoValue = echoValue;
        _self.mouseDown = mouseDown;
        _self.onPaste = onPaste;

        _self.undo = undo;
        _self.redro = redro;
        _self.cleanInput = cleanInput;

        _self.getContent = getContent;
        _self.isSendable = isSendable;
        _self.isAttached = isAttached;
        _self.hideCursor = hideCursor;
        _self.getSelection = getSelection;
        _self.exitCalculator = exitCalculator;

        _self.id = id;

        // constructor:
        init($element);

        return _self;
    }

    // FORMULA OBJECT:
    // -----------------------------------------------------------------------------------------------------------------

    function Formula(attributes, calculator, parentFormula) {
        var _self = new FormulaMethodHandler(this, calculator);
        attributes = attributes || {
            type: 'wrapper',
            id: null,
            child: []
        };

        function toHtml() {
            return parseFormula(_self.type, _self.child, _self.id);
        }

        function toJson(saveId) {
            var i,
                json = {
                    type: _self.type,
                    child: []
                };

            if (saveId) {
                json.id = _self.id;
            }

            if (_self.type !== 'char') {
                for (i = 0; i < _self.child.length; i++) {
                    json.child.push(_self.child[i].toJson(saveId));
                }
            } else {
                return _self.child.toString();
            }

            return json;

        }

        function onClick(event) {

            switch (_self.type) {
                case 'wrapper' :
                    _self.pointerPosition = getChildIndexById(event.originalEvent.attribute);
                    _self.pointerLength = 0;
                    calculator.pointFormula(_self);
                    break;

                default:
                    event.originalEvent.attribute = _self.id;
                    break;

            }
        }

        function getWrapperParent() {
            var actualParent = _self.parent;
            while (actualParent && actualParent.type !== 'wrapper') {
                actualParent = actualParent.parent;
            }
            return actualParent || false;
        }

        function getMyIndex() {
            var index = 0;
            if (_self.parent) {
                index = _self.parent.child.indexOf(_self);
            }
            return index;
        }

        function getMySiblingsLength() {
            return _self.parent.child.length;
        }

        function getPointedChild() {
            return _self.child[_self.pointerPosition];
        }

        function getChildIndexById(id) {
            return _self.child.indexOf(calculator.getFormulaById(id));
        }

        function removeSelection(echoValue, preventRemoveOne) {
            var selection = [];
            var formula;
            var vector = 'fromRight';

            if (_self.pointerLength > 0) {
                vector = 'fromLeft';
                if (_self.pointerLength === 1) {
                    formula = _self.child[_self.pointerPosition];
                }
                selection = removeChild(_self.pointerPosition, _self.pointerLength);
            } else if (_self.pointerLength < 0) {
                _self.pointerPosition = _self.pointerPosition + _self.pointerLength;
                if (Math.abs(_self.pointerLength) === 1) {
                    formula = _self.child[_self.pointerPosition];
                }
                selection = removeChild(_self.pointerPosition, Math.abs(_self.pointerLength));
            }

            _self.pointerLength = 0;

            if (formula && !preventRemoveOne) {
                removeOneFormula(formula, vector);
            }

            if (echoValue) {
                calculator.echoValue();
                calculator.pointFormula(_self);
            }
            return selection;
        }

        function removeOneFormula(formula, vector) {
            if (formula.type === 'p') {
                insertChildArray(_self.pointerPosition, 0, formula.child[0].child);
                if (vector === 'fromRight') {
                    _self.pointerPosition += formula.child[0].child.length;
                }
            } else if (formula.type === 'exp' && vector === 'fromRight') {
                if (formula.ghostPhase === 'active') {
                    insertChildArray(_self.pointerPosition, 0, formula.child[0].child);
                    _self.pointerLength = formula.child[0].child.length;
                    calculator.addFormula('p');
                } else {
                    insertChildArray(_self.pointerPosition, 0, formula.child[0].child);
                    _self.pointerPosition += formula.child[0].child.length;
                }
            }
        }

        function removeChild(index, length) {
            var ret = _self.child.splice(index, length || 1);

            setExpAndLogGhostP();
            return ret;
        }

        function insertChild(position, length, child) {
            clearTimeout(expSupMoveTimer);

            child.parent = _self;
            _self.child.splice(position, length, child);

            setExpAndLogGhostP();

            // kitevőről leugrasztás 1 karakter esetén:
            if (_self.parent
                && _self.parent.type === 'exp'
                && _self.child.length > 0
                && _self.parent.child.indexOf(_self) === 1) {
                expSupMoveTimer = setTimeout(_self.moveFocusNext, 5000);
            }

        }

        function insertChildArray(position, length, childArray) {
            var args,
                i;

            for (i = 0; i < childArray.length; i++) {
                childArray[i].parent = _self;
            }

            args = [position, length].concat(childArray);
            _self.child.splice.apply(_self.child, args);
            setExpAndLogGhostP();
        }

        function addChild(formula, formulaName, noStrip) {
            var selection,
                pointFormula = false;

            if (Array.isArray(formula)) {
                for (var i = 0; i < formula.length; i++) {
                    addChild(formula[i], formulaName, noStrip);
                }
            } else {
                formula.parent = _self;
                if (_self.pointerLength !== 0) {
                    selection = removeSelection(false, true);
                    insertChild(_self.pointerPosition, 0, formula);
                } else if ((formula.type === 'exp' || formula.type === 'per') && formula.child[0].child.length === 0 && _self.pointerPosition > 0) {
                    var pointerLength = _self.pointerPosition;
                    _self.setPointerPosition(0);
                    _self.setPointerLength(pointerLength);
                    selection = removeSelection(false, true);
                    formula.child[0].addChild(selection, false, true);
                    insertChild(0, 0, formula);
                    if (formula.type === 'exp') {
                        pointFormula = formula.child[0].setExpBaseByInsert() || formula.child[1];
                    } else {
                        pointFormula = formula.child[0].setPerBaseByInsert() || formula.child[1];
                    }
                    _self.setPointerLength(0);
                    selection = false;
                } else {
                    insertChild(_self.pointerPosition, 0, formula);
                }

                if (_self.pointerPosition < 0) {
                    _self.pointerPosition = 0;
                }

                _self.pointerPosition++;

                if (selection) {
                    formula.addInheritedContent(selection, formulaName);
                    switch (formulaName) {
                        case 'exp':
                            pointFormula = formula.child[1];
                            break;
                        case 'exp:inverse':
                            pointFormula = formula.child[0];
                            break;
                        case 'log':
                            pointFormula = formula.child[0];
                            break;
                        case 'log:inverse':
                            pointFormula = formula.child[1];
                            break;
                        case 'per':
                            pointFormula = formula.child[1];
                            break;
                        case 'per:inverse':
                            pointFormula = formula.child[0];
                            break;
                    }

                }

            }

            return pointFormula;

        }

        function setExpBaseByInsert() {
            var pointFormula = false,
                parent = _self.parent,
                myIndex;

            if (_self.type === 'wrapper' && parent) {
                myIndex = _self.getMyIndex();
                if (parent.type === 'exp' && myIndex === 0) {
                    setBase(isNumberCharChild);
                    if (_self.child.length === 0) {
                        pointFormula = parent.child[0];
                    } else {
                        pointFormula = parent.child[1];
                    }

                }

            }

            return pointFormula;

        }

        function setPerBaseByInsert() {
            var pointFormula = false,
                parent = _self.parent,
                myIndex;

            if (_self.type === 'wrapper' && parent) {
                myIndex = _self.getMyIndex();
                if (parent.type === 'per' && myIndex === 0) {
                    setBase(function (c) {
                        return !isOperation(c);
                    });
                    if (_self.child.length === 0) {
                        pointFormula = parent.child[0];
                    } else {
                        pointFormula = parent.child[1];
                    }

                }

            }

            return pointFormula;

        }

        function setBase(filterFunction) {
            var index,
                foundOneUnit = 0,
                foundNonOneUnit = false;

            index = _self.child.length;

            if (!isOperation(_self.child[index - 1])) {
                while (index-- > 0) {
                    if (filterFunction(_self.child[index])) {
                        foundOneUnit++;
                    } else {
                        foundNonOneUnit = true;
                        if (foundOneUnit === 0) {
                            foundOneUnit++;
                        }
                        break;
                    }
                }

                if (foundNonOneUnit) {
                    _self.setPointerPosition(0);
                    _self.setPointerLength(_self.child.length - foundOneUnit);
                    _self.parent.insertBefore(_self.removeSelection());
                }
            } else {
                _self.setPointerPosition(0);
                _self.setPointerLength(_self.child.length);
                _self.parent.insertBefore(_self.removeSelection());
            }

        }

        function isOperation(formula) {
            if (formula.type === 'char') {
                return !!formula.child[0].match(/(,|-|\+|:|\*|\/|\.|=)/g);
            }
            return false;
        }

        function setExpAndLogGhostP() {
            var parent = _self.parent,
                myIndex;

            if (_self.type === 'wrapper' && parent) {
                myIndex = _self.getMyIndex();
                if (parent.type === 'exp' && myIndex === 0) {
                    if (isGhostPNeeded('exp')) {
                        parent.ghostPhase = 'active';
                    } else {
                        parent.ghostPhase = 'inactive';
                    }
                } else if (parent.type === 'log' && myIndex === 1) {
                    if (isGhostPNeeded('log')) {
                        parent.ghostPhase = 'active';
                    } else {
                        parent.ghostPhase = 'inactive';
                    }

                }

            }

        }

        function isGhostPNeeded(formula) {
            var putP = false,
                index,
                foundOneUnit = 0,
                foundNonOneUnit = false;

            index = _self.child.length;

            while (index-- > 0) {
                if (isNumberCharChild(_self.child[index])) {
                    foundOneUnit++;
                } else if (_self.child[index].type !== 'char' && formula === 'exp') {
                    putP = true;
                } else {
                    foundNonOneUnit = true;
                    foundOneUnit++;
                }
            }

            if (foundNonOneUnit && foundOneUnit > 1) {
                putP = true;
            } else if (_self.child.length === 1 && _self.child[0].type === 'p') {
                putP = false;
            }

            return putP;

        }

        function isNumberCharChild(formula) {
            if (formula.type === 'char') {
                return !isNaN(formula.child[0]);
            }
            return false;
        }

        function addInheritedContent(formula, formulaName) {
            var targetChild;

            if (formulaDefaultChildIndexes.hasOwnProperty(formulaName || _self.type)) {
                targetChild = _self.child[formulaDefaultChildIndexes[formulaName || _self.type]];
                if (targetChild.child.length === 0) {
                    targetChild.addChild(formula, formulaName);
                }

            }

        }

        _self.id = attributes.id;
        _self.type = attributes.type;
        _self.child = attributes.child;
        _self.pointerPosition = 0;
        _self.pointerLength = 0;
        _self.parent = parentFormula;
        _self.ghostPhase = 'inactive';

        _self.toHtml = toHtml;
        _self.toJson = toJson;

        _self.onClick = onClick;

        _self.getMyIndex = getMyIndex;
        _self.getMySiblingsLength = getMySiblingsLength;
        _self.getPointedChild = getPointedChild;
        _self.getWrapperParent = getWrapperParent;

        _self.removeSelection = removeSelection;
        _self.addChild = addChild;
        _self.setExpBaseByInsert = setExpBaseByInsert;
        _self.setPerBaseByInsert = setPerBaseByInsert;
        _self.setExpAndLogGhostP = setExpAndLogGhostP;
        _self.addInheritedContent = addInheritedContent;
        _self.insertChildArray = insertChildArray;

        return _self;

    }

    // METHOD MANAGER OBJECT:
    // -----------------------------------------------------------------------------------------------------------------

    function FormulaMethodHandler(_self, calculator) {
        var methodHotKeyTable = {
            'arrowleft': movePointerLeft,
            'arrowright': movePointerRight,
            'arrowup': moveFocusUp,
            'arrowdown': moveFocusDown,
            'home': movePointerFirst,
            'end': movePointerLast,

            'enter': submitFormula,

            'ctrl+arrowleft': movePointerFirst,
            'ctrl+arrowright': movePointerLast,
            'shift+arrowleft': movePointerLengthLeft,
            'shift+arrowright': movePointerLengthRight,
            'shift+home': movePointerLengthFirst,
            'shift+end': movePointerLengthLast,

            'ctrl+shift+arrowleft': movePointerLengthFirst,
            'ctrl+shift+arrowright': movePointerLengthLast,
            'ctrl+a': selectAll,

            'backspace': removePrevious,
            'delete': removeNext,
            'shift+backspace': removePrevious,
            'shift+delete': removeNext,
            'ctrl+backspace': removePreviousAll,
            'ctrl+delete': removeNextAll,

            'ctrl+x': cut,
            'ctrl+c': copy,
            'ctrl+v': paste,
            'ctrl+z': calculator.undo,
            'ctrl+y': calculator.redro,

            'tab': moveFocusNext,
            'shift+tab': moveFocusPrev,

            'shift+(': () => calculator.addFormula('p'),
            '(': () => calculator.addFormula('p'),

            'shift+/': () => calculator.addFormula('per'),
            '/': () => calculator.addFormula('per'),

            'altgraph': () => calculator.addFormula('exp'),
            'alt+altgraph': () => calculator.addFormula('exp'),
            'ctrl+alt+altgraph': () => calculator.addFormula('exp'),

            'space': () => calculator.addFormula('root'),
            'ctrl+space': () => calculator.addFormula('log')
        };

        function hotKey(methodHotKey) {
            if (methodHotKeyTable[methodHotKey]) {
                methodHotKeyTable[methodHotKey]();
            }
        }

        function setPointerPosition(position) {
            _self.pointerPosition = Math.max(0, position);
            _self.pointerPosition = Math.min(_self.child.length, _self.pointerPosition);
            return _self.pointerPosition;
        }

        function setPointerLength(length) {
            _self.pointerLength = Math.max(-1 * _self.pointerPosition, length);
            _self.pointerLength = Math.min(_self.child.length - _self.pointerPosition, _self.pointerLength);
            return _self.pointerLength;
        }

        function echoPointer() {
            calculator.pointFormula(_self);
        }

        function setPointer(position, length) {
            setPointerPosition(position);
            setPointerLength(length);
            echoPointer();
        }

        function movePointerLeft(keepPointerLength) {
            var pointedChild;

            if (_self.pointerLength === 0) {
                if (_self.pointerPosition === 0) {
                    moveFocusPrev();
                } else {
                    setPointerPosition(_self.pointerPosition - 1);
                    if (!keepPointerLength) {
                        setPointerLength(0);
                    }
                    pointedChild = _self.getPointedChild();
                    if (!pointedChild || pointedChild.type === 'char') {
                        echoPointer();
                    } else {
                        pointedChild.addFocus('right');
                    }
                }
            } else {
                setPointerPosition(Math.min(_self.pointerPosition, _self.pointerPosition + _self.pointerLength));
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();
            }
        }

        function movePointerRight(keepPointerLength) {
            var pointedChild = _self.getPointedChild();
            if (_self.pointerLength === 0) {
                if (_self.pointerPosition === _self.child.length && _self.pointerLength === 0) {
                    moveFocusNext();
                } else {
                    setPointerPosition(_self.pointerPosition + 1);
                    if (!keepPointerLength) {
                        setPointerLength(0);
                    }

                    if (!pointedChild || pointedChild.type === 'char') {
                        echoPointer();
                    } else {
                        pointedChild.addFocus('left');
                    }

                }

            } else {
                setPointerPosition(Math.max(_self.pointerPosition, _self.pointerPosition + _self.pointerLength));
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();

            }

        }

        function movePointerFirst(keepPointerLength) {
            if (_self.pointerPosition === 0) {
                moveFocusPrev();
            } else {
                setPointerPosition(0);
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();
            }
        }

        function movePointerLast(keepPointerLength) {
            if (_self.pointerPosition === _self.child.length) {
                moveFocusNext();
            } else {
                setPointerPosition(_self.child.length);
                if (!keepPointerLength) {
                    setPointerLength(0);
                }
                echoPointer();
            }
        }

        function movePointerLengthLeft() {
            if (_self.pointerLength !== setPointerLength(_self.pointerLength - 1)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('right');
            }
        }

        function movePointerLengthRight() {
            if (_self.pointerLength !== setPointerLength(_self.pointerLength + 1)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('left');
            }
        }

        function movePointerLengthFirst() {
            if (_self.pointerLength !== setPointerLength(-1 * _self.pointerPosition)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('right');
            }
        }

        function movePointerLengthLast() {
            if (_self.pointerLength !== setPointerLength(_self.child.length - _self.pointerPosition)) {
                echoPointer();
            } else {
                _self.selectMeAtParent('left');
            }
        }

        function moveFocusNext() {
            if (_self.parent) {
                var wrapperParent = _self.getWrapperParent(),
                    myIndex = _self.getMyIndex(),
                    mySiblingsLength = _self.getMySiblingsLength();

                switch (_self.parent.type) {
                    case 'wrapper' :
                        _self.parent.setPointer(myIndex + 1, 0);
                        break;
                    case 'per' :
                        if (wrapperParent) {
                            _self.parent.moveFocusNext();
                        }
                        break;
                    default:
                        if (myIndex < mySiblingsLength - 1) {
                            _self.parent.child[myIndex + 1].addFocus('left');
                        } else if (wrapperParent) {
                            _self.parent.moveFocusNext();
                        }
                        break;
                }
            } else {
                setPointer(_self.child.length, 0);
            }

        }

        function moveFocusPrev() {
            if (_self.parent) {
                var wrapperParent = _self.getWrapperParent(),
                    myIndex = _self.getMyIndex();

                switch (_self.parent.type) {
                    case 'wrapper' :
                        _self.parent.setPointer(myIndex, 0);
                        break;
                    case 'per' :
                        if (wrapperParent) {
                            _self.parent.moveFocusPrev();
                        }
                        break;
                    default:
                        if (myIndex > 0) {
                            _self.parent.child[myIndex - 1].addFocus('right');
                        } else if (wrapperParent) {
                            _self.parent.moveFocusPrev();
                        }
                        break;
                }

            } else {
                setPointer(0, 0);
            }

        }

        function moveFocusUp() {
            if (_self.parent && _self.parent.type === 'per' && _self.getMyIndex() === 1) {
                _self.parent.child[0].addFocus('right');
            } else {
                movePointerFirst();
            }
        }

        function moveFocusDown() {
            if (_self.parent && _self.parent.type === 'per' && _self.getMyIndex() === 0) {
                _self.parent.child[1].addFocus('left');
            } else {
                movePointerLast();
            }
        }

        function selectAll() {
            var wrapperParent = _self.getWrapperParent();
            if (_self.pointerPosition !== 0 || _self.pointerLength !== _self.child.length) {
                setPointerPosition(0);
                setPointerLength(_self.child.length);
                echoPointer();
            } else {
                if (wrapperParent) {
                    wrapperParent.selectAll();
                }
            }
        }

        function selectChild(childFormula, pointerSide) {
            var childIndex = _self.child.indexOf(childFormula);
            if (childIndex >= 0) {
                if (pointerSide === 'left') {
                    setPointerPosition(childIndex);
                    setPointerLength(1);
                } else {
                    setPointerPosition(childIndex + 1);
                    setPointerLength(-1);
                }
                echoPointer();
            } else {
                APP.Error.logError(new Error('Calculator unexpected child passed'), {
                    source: 'APP.Calculator.Formula.selectChild',
                    context: {
                        type: _self.type
                    }
                });
            }
        }

        function selectMeAtParent(pointerSide) {
            var parentFormula = _self.parent,
                parentWrapperFormula = false;

            if (parentFormula) {
                parentWrapperFormula = parentFormula.getWrapperParent();
                parentWrapperFormula.selectChild(parentFormula, pointerSide);
            }

            return parentWrapperFormula;
        }

        function addFocus(pointerSide) {
            if (_self.type === 'wrapper') {
                addFocusToWrapper(pointerSide);
            } else if (_self.type !== 'char') {
                addFocusToFormula(pointerSide);
            }

            function addFocusToFormula(pointerSide) {
                if (_self.child.length > 0) {
                    if (pointerSide === 'left') {
                        _self.child[0].addFocus('left');
                    } else {
                        _self.child[_self.child.length - 1].addFocus('right');
                    }
                } else {
                    APP.Error.logError(new Error('Calculator unexpected formula structure'), {
                        source: 'APP.Calculator.Formula.addFocus',
                        context: {
                            type: _self.type
                        }
                    });
                }
            }

            function addFocusToWrapper(pointerSide) {
                setPointerLength(0);
                if (pointerSide === 'left') {
                    setPointerPosition(0);
                } else {
                    setPointerPosition(_self.child.length);
                }
                echoPointer();
            }

        }

        function cut() {
            if (_self.pointerLength !== 0) {
                // asincron because of clipboard
                setTimeout(function () {
                    copy();
                    _self.removeSelection(true);
                }, 8);
            }
        }

        function copy() {
            virtualSelection = calculator.getSelection();
            $body.find('[data-keyboard-method="ctrl+v"]').show();
        }

        function paste() {
            calculator.onPaste(virtualSelection);
        }

        function replaceChild(formula, newFormula) {
            formula.insertBefore(newFormula);
            formula.parent.selectChild(formula);
            formula.parent.removeSelection(true, true);
        }

        function removePrevious() {
            var wrapperParent;
            if (_self.pointerLength === 0) {
                if (_self.pointerPosition !== 0) {
                    setPointerLength(_self.pointerLength - 1);
                    _self.removeSelection(true);
                } else {
                    if (_self.parent && _self.parent.type === 'per') {
                        removePerFromInside();
                    } else if (_self.parent && _self.parent.type === 'exp') {
                        removeExpFromInside();
                    } else {
                        wrapperParent = _self.selectMeAtParent('right');
                        if (wrapperParent) {
                            wrapperParent.removeSelection(true);
                        } else {
                            removeNext();
                        }
                    }
                }
            } else {
                _self.removeSelection(true);
            }
        }

        function removePerFromInside() {
            var otherChild = _self.parent.child[_self.parent.child.indexOf(_self) === 0 ? 1 : 0];

            replaceChild(_self.parent, otherChild.child);
        }

        function removeExpFromInside() {
            var childIndex = _self.parent.child.indexOf(_self) === 0 ? 1 : 0,
                otherChild = _self.parent.child[childIndex];

            if (_self.parent.ghostPhase === 'active') {
                otherChild.selectAll();
                calculator.addFormula('p');
            }
            replaceChild(_self.parent, otherChild.child);
            _self.parent.setExpAndLogGhostP();
        }

        function removeNext() {
            var wrapperParent;
            if (_self.pointerLength === 0) {
                if (_self.pointerPosition !== _self.child.length) {
                    setPointerLength(_self.pointerLength + 1);
                    _self.removeSelection(true);
                } else if (_self.parent) {
                    if (_self.parent.type === 'per') {
                        removePerFromInside();
                    } else if (_self.parent.type === 'exp') {
                        removeExpFromInside();
                    } else {
                        wrapperParent = _self.selectMeAtParent('left');
                        if (wrapperParent) {
                            wrapperParent.removeSelection(true);
                        }
                    }
                }
            } else {
                _self.removeSelection(true);
            }
        }

        function removePreviousAll() {
            var wrapperParent;
            if (_self.pointerPosition === 0) {
                wrapperParent = _self.selectMeAtParent('right');
                if (wrapperParent) {
                    wrapperParent.removeSelection(true);
                }
            } else {
                setPointerLength(-1 * _self.pointerPosition);
                _self.removeSelection(true);
            }
        }

        function removeNextAll() {
            var wrapperParent;
            if (_self.pointerPosition === _self.child.length) {
                wrapperParent = _self.selectMeAtParent('left');
                if (wrapperParent) {
                    wrapperParent.removeSelection(true);
                }
            } else {
                setPointerLength(_self.child.length - _self.pointerPosition);
                _self.removeSelection(true);
            }
        }

        function insertBefore(formulas) {
            var parent = _self.parent;
            parent.setPointerPosition(_self.getMyIndex());
            parent.setPointerLength(0);
            parent.addChild(formulas, false, false);
        }

        function insertAfter(formulas) {
            var parent = _self.parent;
            parent.setPointerPosition(_self.getMyIndex() + 1);
            parent.setPointerLength(0);
            parent.addChild(formulas, false, false);
        }

        function submitFormula() {
            APP.Calculator.Keyboard.submit();
        }

        _self.hotKey = hotKey;
        _self.setPointer = setPointer;
        _self.setPointerPosition = setPointerPosition;
        _self.setPointerLength = setPointerLength;

        _self.selectAll = selectAll;
        _self.selectChild = selectChild;
        _self.selectMeAtParent = selectMeAtParent;

        _self.insertBefore = insertBefore;
        _self.insertAfter = insertAfter;

        _self.addFocus = addFocus;
        _self.moveFocusPrev = moveFocusPrev;
        _self.moveFocusNext = moveFocusNext;
        _self.movePointerLast = movePointerLast;
        _self.movePointerFirst = movePointerFirst;

        return _self;

    }

    //-------------------------------------------------------------------

    exports.init = init;
    return exports;

})();

function OpTbl(width, height, isMultiDigit) {
    var _this = {};
    var pause = 9;

    _this.width = Math.max(1, width | 0);
    _this.height = Math.max(1, height | 0);
    _this._idx = 0;

    _this._cells = [];
    for (var y = 0; y < _this.height; y++) {
        var row = [];

        for (var x = 0; x < _this.width; x++) {
            row.push({num: '', color: '', i: 0, filled: false});
        }
        _this._cells.push(row);
    }

    _this.underline = function (x, y, w) {
        if (_this._cells[y] && _this._cells[y][x]) {
            _this._cells[y][x].underline = {
                index: _this._idx++,
                width: w
            };
            _this._idx += pause;
        }
    };

    _this.markerline = function (x, y) {
        if (_this._cells[y] && _this._cells[y][x]) {
            _this._cells[y][x].markerline = {
                index: _this._idx++
            };
            _this._idx += pause;
        }
    };

    _this.add = function (x1, y1, x2, y2, color, direction, value) {
        color = color || 'black';
        direction = (direction || 'forward').toLowerCase();
        x1 |= 0;
        y1 |= 0;
        x2 |= 0;
        y2 |= 0;

        var left = Math.max(0, Math.min(x1, x2, _this.width - 1));
        var right = Math.min(_this.width - 1, Math.max(x1, x2));
        var top = Math.max(0, Math.min(y1, y2, _this.height - 1));
        var bottom = Math.min(_this.height - 1, Math.max(y1, y2));
        var coords = [];
        for (var y = top; y <= bottom; y++) {
            for (var x = left; x <= right; x++) {
                coords.push([x, y]);
            }
        }

        var n = coords.length;
        var forward = direction !== 'backward';
        var k, xy, cell, a = 0;

        if (forward) {
            for (k = 0; k < n; k++) {
                xy = coords[k];
                cell = this._cells[xy[1]][xy[0]];
                if (value) {
                    if (value[k]) {
                        cell.num = value[k];
                        a++;
                    }
                } else {
                    cell.num = String(k + 1);
                    a++;
                }
                cell.color = color;
                cell.i = _this._idx + k;
                cell.filled = true;
            }
        } else {
            for (k = 0; k < n; k++) {
                xy = coords[k];
                cell = _this._cells[xy[1]][xy[0]];
                if (value) {
                    if (value[k]) {
                        cell.num = value[k];
                        a++;
                    }
                } else {
                    cell.num = String(n - k);
                    a++;
                }

                cell.color = color;
                cell.i = _this._idx + (n - 1 - k);
                cell.filled = true;
            }
        }

        _this._idx += a;
        _this._idx += pause;

        return _this;
    };

    _this.build = function () {
        var html = '<div class="tbl' + (isMultiDigit ? ' tbl--multi' : '') + '">';
        var l;

        for (var y = 0; y < _this.height; y++) {
            html += '<div class="tbl__row">';
            for (var x = 0; x < _this.width; x++) {
                var c = this._cells[y][x];
                l = c.underline ? '<span class="tbl__cell__underline" style="--w:' + c.underline.width + ';--i:' + c.underline.index + ';"></span>' : '';
                if (c.markerline) {
                    l = '<span class="tbl__cell__markerline" style="--i:' + c.markerline.index + ';"></span>';
                }
                if (c.filled) {
                    html += '<div class="tbl__cell"><span class="tbl__num tbl__num--' + c.color +
                        '" style="--i:' + c.i + ';"><span>' + c.num + '</span></span>' + l + '</div>';
                } else {
                    html += '<div class="tbl__cell">' + l + '</div>';
                }
            }
            html += '</div>';
        }
        html += '</div>';

        return html;
    };

    return _this;

}


APP.Operations = (function () {
    var exports = {};

    function init() {
        $body.find('[data-operation]:not(.initialized)').each(function () {
            var $this = $(this);
            var data = $this.data('operation');

            if (data.multidigit) {
                opMultiple(data.operation, data.arguments, $this);
            } else {
                opSingle(data.operation, data.arguments[0], data.arguments[1], $this, data.colors);
            }
            $this.addClass('initialized');
            setTimeout(function () {
                $this.addClass('show');
            }, 120);
        });
    }

    function opSingle(operation, a, b, $target, color) {
        var t;

        if (operation === 'addition') {
            t = OpTbl(a + b, 2);
            t.add(0, 0, a - 1, 0, color[0]);
            t.add(a, 0, a + b, 0, color[1]);
            t.add(0, 1, a + b - 1, 1, color[2]);
        } else if (operation === 'subtraction') {
            t = OpTbl(a, 2);
            t.add(0, 0, a - 1, 0, color[0]);
            t.add(a - 1, 1, a - b, 1, color[1], 'backward');
            t.add(0, 1, a - b - 1, 1, color[2]);
        } else if (operation === 'multiplication') {
            t = OpTbl(b + 1, a + 1);
            t.add(0, 1, 0, a + 1, color[0]);
            t.add(1, 0, b + 1, 0, color[1]);
            t.add(1, 1, b + 1, a + 1, color[2]);
        } else if (operation === 'division') {
            t = OpTbl(b + 1, (a / b) + 1);
            t.add(0, 0, b - 1, 0, color[1]);
            t.add(0, 1, b - 1, a / b, color[0]);
            t.add(b, 1, b, a / b, color[2]);
        } else if (operation === 'reverseAddition') {
            t = OpTbl(a + b, 2);
            t.add(0, 0, a + b - 1, 0, color[2]);
            t.add(0, 1, a - 1, 1, color[0]);
            t.add(a, 1, a + b, 1, color[1]);
        }
        $target.html(t.build());
    }

    function opMultiple(operation, tags, $target) {
        var w, h, t, r;

        if (operation === 'addition') {
            w = Math.max.apply(null, tags.slice(0, tags.length - 1)).toString().length + 1;
            t = OpTbl(w, tags.length, true);
            tags.forEach(function (tag, index) {
                r = tag.toString();
                if (index === tags.length - 1) {
                    t.underline(0, tags.length - 2, w);
                    t.add(w - r.length, index, w, index, 'normal', 'backward', r);
                } else {
                    t.add(w - r.length, index, w, index, 'normal', 'forward', r);
                    if (index === tags.length - 2) {
                        t.add(0, index, 0, index, 'normal', 'forward', '+');
                    }
                }
            });
            $target.html(t.build());
        } else if (operation === 'subtraction') {
            w = Math.max.apply(null, tags).toString().length + 1;
            t = OpTbl(w, tags.length, true);
            tags.forEach(function (tag, index) {
                r = tag.toString();
                if (index === tags.length - 1) {
                    t.underline(0, tags.length - 2, w);
                    t.add(w - r.length, index, w, index, 'normal', 'backward', r);
                } else {
                    t.add(w - r.length, index, w, index, 'normal', 'forward', r);
                    if (index === tags.length - 2) {
                        t.add(0, index, 0, index, 'normal', 'forward', '-');
                    }
                }
            });
            $target.html(t.build());
        } else if (operation === 'multiplication') {
            var a = tags[0],
                b = tags[1],
                list = [], m,
                result;

            b.toString().split('').forEach(function (digit) {
                var res = parseInt(digit, 10) * parseInt(a, 10);

                list.push(res.toString());
            });

            if (list.length > 1) {
                var leftIndent = b.toString().length + 2;
                w = Math.max(list[0].toString().length, a.toString().length) + b.toString().length + 2; // a.toString().length + b.toString().length + 3;
                m = a.toString() + '*' + b.toString();
                t = OpTbl(w, list.length + 2, true);
                t.add(w - m.length, 0, w, 0, 'normal', 'forward', m);
                t.underline(w - m.length, 0, a.toString().length);
                list.forEach(function (item, index) {
                    leftIndent--;
                    t.add(w - leftIndent - item.length, index + 1, w - leftIndent, index + 1, 'normal', 'backward', item);
                });
                result = (a * b).toString();
                t.add(0, list.length, 0, list.length, 'normal', 'forward', '+');
                t.underline(0, list.length, result.length + 1);
                t.add(w - leftIndent, list.length + 2, w - leftIndent - result.length, list.length + 2, 'normal', 'backward', result);
            } else {
                result = (a * b).toString();
                w = (a * b).toString().length + b.toString().length + 1;
                m = a.toString() + '*' + b.toString();
                t = OpTbl(w, 2, true);
                t.add(w - m.length, 0, w, 0, 'normal', 'forward', m);
                t.underline(w - m.length, 0, a.toString().length);
                t.add(w - b.toString().length - 1 - result.length, 1, result.toString().length, 1, 'normal', 'backward', result);
            }
            $target.html(t.build());
        } else if (operation === 'division') {
            var a = parseInt(tags[0], 10),
                b = parseInt(tags[1], 10),
                c = parseInt(a.toString().substr(0, 1), 10),
                d, rows = [], i = 1, l = 1, tmp, re, of = 0, xof = 0, zof, s = false;

            while (true) {
                re = Math.floor(c / b) * b;
                rows.push(re);
                c = parseInt((c - re).toString() + a.toString()[i], 10);
                rows.push(c);
                if (re === 0 && !s) {
                    of += 2;
                    xof += 1;
                } else {
                    s = true;
                }
                i++;
                if (i > a.toString().length) {
                    break;
                }
            }
            w = a.toString().length + b.toString().length + 3 + Math.floor(a / b).toString().length;
            h = rows.length + 2 - of;
            t = OpTbl(w, h, true);
            d = (a + ':' + b + '=' + (a / b)).toString();
            t.add(
                w - d.length,
                1,
                w - d.length + d.length - Math.floor(a / b).toString().length,
                1,
                'normal', 'forward',
                d.substr(0, d.length - Math.floor(a / b).toString().length)
            );

            for (i = of; i < rows.length; i += 2) {
                t.markerline(w - d.length + l - 1 + xof, 0);
                t.add(
                    w - Math.floor(a / b).toString().length - 1 + l,
                    1,
                    w - Math.floor(a / b).toString().length - 1 + l,
                    1,
                    'normal', 'backward', Math.floor(a / b).toString()[l - 1]);
                tmp = w - d.length + l - rows[i].toString().length + xof;

                t.add(
                    tmp,
                    i + 2 - of,
                    tmp + rows[i].toString().length,
                    i + 2 - of,
                    'normal', 'backward',
                    rows[i].toString()
                );
                t.add(
                    w - d.length + l - rows[i].toString().length - 1 + xof,
                    i + 2 - of,
                    w - d.length + l - rows[i].toString().length - 1 + xof,
                    i + 2 - of,
                    'normal', 'forward',
                    '-'
                );

                t.underline(w - d.length + l - rows[i].toString().length - 1 + xof, i + 2 - of, rows[i].toString().length + 1);

                l++;
                zof = 0;
                if (rows[i + 1] === 0) {
                    zof = -1;
                }
                if (rows[i + 1].toString().length === 1) {
                    if (rows[i + 1].toString() !== '0') {
                        t.add(
                            w - d.length + l - 2 + xof + zof,
                            i + 3 - of,
                            w - d.length + l - 2 + xof + zof,
                            i + 3 - of,
                            'normal', 'forward',
                            '0'
                        );
                        t.add(
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            'normal', 'backward',
                            rows[i + 1].toString()
                        );
                    } else if (i + 1 !== rows.length - 1) {
                        t.add(
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            'normal', 'backward',
                            rows[i + 1].toString()
                        );
                        t.add(
                            w - d.length + l + xof + zof,
                            i + 3 - of,
                            w - d.length + l + xof + zof,
                            i + 3 - of,
                            'normal', 'forward',
                            '0'
                        );
                    } else {
                        t.add(
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            w - d.length + l - rows[i + 1].toString().length + xof + zof,
                            i + 3 - of,
                            'normal', 'backward',
                            rows[i + 1].toString()
                        );
                    }
                } else {
                    t.add(
                        w - d.length + l - rows[i + 1].toString().length + xof + zof,
                        i + 3 - of,
                        w - d.length + l - rows[i + 1].toString().length + xof + zof + rows[i + 1].toString().length - 1,
                        i + 3 - of,
                        'normal', 'backward',
                        rows[i + 1].toString().substr(
                            0, rows[i + 1].toString().length - 1
                        )
                    );
                    t.add(
                        w - d.length + l - rows[i + 1].toString().length + xof + zof + rows[i + 1].toString().length - 1,
                        i + 3 - of,
                        w - d.length + l - rows[i + 1].toString().length + xof + zof + rows[i + 1].toString().length,
                        i + 3 - of,
                        'normal', 'backward',
                        rows[i + 1].toString().substr(
                            rows[i + 1].toString().length - 1, 1
                        )
                    );
                }
            }
            $target.html(t.build());
        }
    }

    exports.init = init;

    return exports;

})();

APP.PrimeTable = (function () {

    var exports = {},
        row,
        initialized;

    function init() {
        $body.find('[data-primetable]:not(.inited)').each(function () {
            initPrimeTable($(this));
        });
        initBindings();
    }

    function initBindings() {
        if (!initialized) {
            $body.on('click', '[data-open-prime-table]', showPrimeTable);
            $body.on('click', '[data-submit-prime-table]', submitPrimeTable);
        }
        initialized = true;
    }

    function showPrimeTable() {
        $body.find('[data-prime-box]').show();
        $body.find('[data-dashboard-input]').hide();
        $body.find('[data-comment-box]').hide();
        $body.find('[data-primetable] input').first().focus();
    }

    function submitPrimeTable() {
        var data = collectPrimeTableData();
        APP.Ajax.post('/hu/learn/post-comment', {
            questionId: $body.find('[name="question-id"]').val(),
            historyId: $body.find('[name="lesson-history-id"]').val(),
            data: {
                type: 'prime-table',
                content: data
            }
        }).then(function (result) {
            var $formula = $('<div class="formula-flack" />'),
                $answersWrapper = $body.find('[data-previous-good-answers]');

            if (result.success) {
                $body.find('[data-previous-good-answers-wrapper]').show();
                $formula.html(APP.Tpl.run('prime-table',data));
                $answersWrapper.append($formula);
                $body.find('[data-dashboard-input]').show();
                $body.find('[data-comment-box]').hide();
                $body.find('[data-prime-box]').hide();
                resetPrimeTable();
            }
        }, window.NOOP);
    }

    function collectPrimeTableData() {
        var $rows = $body.find('[data-primetable] [data-prime-row]'),
            data = [];

        $rows.each(function () {
            var $this = $(this);

            data.push([
                parseInt($this.find('[data-inp1]').val(), 10),
                parseInt($this.find('[data-inp2]').val(), 10)
            ]);
        });

        return data;
    }

    function resetPrimeTable() {
        $body.find('[data-primetable]').html(row);
    }

    function initPrimeTable($table) {
        row = $table.find('[data-prime-row]')[0].outerHTML;
        $table.addClass('inited');
        $table.on('input', 'input', cleanTable);

        function cleanTable() {
            var $rows = $table.find('[data-prime-row]'),
                ready = true;

            $('.pin').hide();
            $rows.each(function (index) {
                var $this = $(this),
                    isLast = (index + 1) === $rows.length,
                    val1 = parseInt($this.find('[data-inp1]').val(), 10),
                    val2 = parseInt($this.find('[data-inp2]').val(), 10);

                $this.find('[data-inp1]').val(val1 > 0 ? val1 : '');
                $this.find('[data-inp2]').val(val2 > 0 ? val2 : '');

                if (val1 > 1) {
                    $this.find('[data-inp2]').parent().removeClass('prime-input__hide');
                } else {
                    $this.find('[data-inp2]').parent().addClass('prime-input__hide');
                }

                if(val1 > 0) {
                    $this.find('[data-inp1]').parent().removeClass('empty');
                } else {
                    $this.find('[data-inp1]').parent().addClass('empty');
                }

                if(val2 > 0) {
                    $this.find('[data-inp2]').parent().removeClass('empty');
                } else {
                    $this.find('[data-inp2]').parent().addClass('empty');
                }

                if (isLast) {
                    if ((val1 || val2) && val1 > 1) {
                        $table.append(row);
                    } else if (val1 === 1 && ready) {
                        $('.pin').show();
                        // checkPrimeTableReady();
                    }
                } else {
                    if (!val1) {
                        $this.remove();
                    }
                    if (!val1 || !val2) {
                        ready = false;
                    }
                }

            });

        }
    }

    exports.init = init;

    return exports;

})();

APP.Notification = (function () {

    var exports = {},
        initialized = false,
        $notificationOverlay,
        $notificationContent,
        $notificationNumber,
        $notificationFavicon,
        $noNotification,

        notificationNumber = 0,
        notificationSound,

        notificationPing,

        afterDate = new Date('1987/12/10'),
        beforeDate = new Date(),

        clientId,
        isSubscribed,
        applicationServerPublicKey = 'BDymD2jYRhZIuab6nHvq8BjgGroN-jQWGIDQFQafKO6iSL8Dhey-umxpaJB4iD43Kc_vQFFUzpl0h6oLuHytJzw';

    function init() {
        if (!initialized) {
            initialized = true;
            initDomElements();
            initBindings();
            updateNotificationNumber();
            // notificationPing = setInterval(updateNotificationNumber, 30000);

            if (window.Audio) {
                notificationSound = new Audio(CDN.sound + 'notification.mp3');
            }
        }
    }

    function initDomElements() {
        $notificationContent = $body.find('[data-notification-content]');
        $notificationNumber = $body.find('[data-notification-number]');
        $noNotification = $body.find('[data-no-notification]');
        $notificationFavicon = $(document.getElementById('notification-icon'));
    }

    function initBindings() {
        $body.on('click', '[data-header-tooltip-show="notification"]', renderNewNotifications);

        $body.on('click', '[data-notification-href]', function () {
            var $this = $(this),
                href = $this.attr('data-notification-href');

            $this.addClass('notification__item--seen');
            updateNotificationSeen($this);
            setTimeout(closeNotificationOverlay, 1000);
            if (href) {
                APP.Page.applyPageByUrl(href);
            }
        });

        $body.on('click', '[data-notification-seen-toggle]', function (event) {
            var $this = $(this),
                $notification = $this.parents('[data-notification-href]');

            event.preventDefault();
            event.stopPropagation();
            $notification.toggleClass('notification__item--seen');
            updateNotificationSeen($notification);
        });

        $body.on('click', '[data-load-older-notifications]', function () {
            $(this).hide();
            loadOlderNotifications();
        });

        if (window.USER_ID) {
            APP.Live.subscribeUserEvent(function (data) {
                if (data.key === 'notificationCount') {
                    updateNotificationNumber(data.value);
                } else if (data.key === 'notificationOverlay') {
                    $body.find('[data-notification-alert-content]').html(APP.Tpl.run('notification-overlay', data.value));
                    APP.Layout.openOverlay('show-notification');
                }
            });
        }

        onWorkerMessage(function (data) {
            updateNotificationNumber(data.result);
        });
    }

    function getClientId() {
        if (window.localStorage) {
            clientId = window.localStorage.getItem('clientId');

            if (!clientId) {
                clientId = Math.round(Math.random() * Math.pow(9, 9)).toString(36) + new Date().getTime().toString(36);
                window.localStorage.setItem('clientId', clientId);
            }
        }
        return clientId;
    }

    function onWorkerMessage(callback) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', function (event) {
                callback && callback(JSON.parse(event.data));
            });
            if ('PushManager' in window && window.USER_LOGGED_IN) {
                navigator.serviceWorker.register(document.location.origin + '/hu/sw.js').then(subscribeUser, console.log);
            }
        }
    }

    function subscribeUser(swRegistration) {
        navigator.serviceWorker.ready.then(function () {
            if (window.Notification && window.Notification.permission) {
                var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);

                swRegistration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: applicationServerKey
                }).then(function (subscription) {
                    updateSubscriptionOnServer(subscription);
                    isSubscribed = true;
                }, function () {
                    console.log('no push...');
                });
            }
        });

        function urlB64ToUint8Array(base64String) {
            var padding = '='.repeat((4 - base64String.length % 4) % 4),
                base64 = (base64String + padding)
                    .replace(/\-/g, '+')
                    .replace(/_/g, '/'),
                rawData = window.atob(base64),
                outputArray = new Uint8Array(rawData.length),
                i;

            for (i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }

            return outputArray;
        }

        function updateSubscriptionOnServer(subscription) {
            APP.Ajax.post('/hu/service/save-web-push-subscription', {
                subscription: JSON.stringify(subscription),
                clientId: getClientId()
            }, true).then(window.NOOP, window.NOOP);
        }

    }

    function updateNotificationSeen($element) {
        APP.Ajax.post('/hu/service/update-notification-seen', {
            id: $element.attr('data-notification-id'),
            seen: $element.hasClass('notification__item--seen')
        }, true).then(function (result) {
            updateNotificationNumber(result.result);
        }, window.NOOP);
    }

    function closeNotificationOverlay() {
        $body.find('[data-header-tooltip]').removeClass('show');
    }

    function renderNewNotifications() {
        $body.find('[data-notification-loading]').removeClass('hide');
        return APP.Ajax.post('/hu/service/get-notifications', {
            after: afterDate
        }, true).then(function (response) {
            var notifications = response.result;

            if (notifications.length > 0) {
                afterDate = notifications[0].date;
                $notificationContent[0].insertAdjacentHTML('afterbegin', APP.Tpl.run('notification', notifications));
                APP.Layout.setMoments();
                updateNotificationNumber(0);
                $noNotification.hide();
            }
            $body.find('[data-notification-loading]').addClass('hide');
        }, window.NOOP);
    }

    function loadOlderNotifications() {
        return APP.Ajax.post('/hu/service/get-notifications', {
            before: beforeDate
        }).then(function (response) {
            var notifications = response.result;

            if (notifications.length > 0) {
                beforeDate = notifications[notifications.length - 1].date;
                $notificationContent[0].insertAdjacentHTML('beforeend', APP.Tpl.run('notification', notifications));
                APP.Layout.setMoments();
                $noNotification.hide();
            }
        }, window.NOOP);
    }


    function updateNotificationNumber(number) {
        if (!window.USER_LOGGED_IN) {
            return false;
        } else if (typeof number !== 'undefined') {
            if (notificationNumber < number) {
                playNotificationSound();
                showNotificationFavicon();
            }
            notificationNumber = number;
            $body.find('[data-notification-number]').attr('data-notification-number', notificationNumber);
            if (notificationNumber === 0) {
                hideNotificationFavicon();
            }
        } else {
            APP.Ajax.post('/hu/service/get-notifications-count', {}, true).then(function (result) {
                updateNotificationNumber(result.result);
            }, window.NOOP);
        }
    }

    function playNotificationSound() {
        if (window.USER_SETTINGS && window.USER_SETTINGS.audio && notificationSound) {
            try {
                notificationSound && notificationSound.play().catch(function (error) {
                    /*
                    APP.Error.logError(error, {
                        source: 'APP.Notification.playNotificationSound'
                    });
                    */
                });
            } catch (e) {
                /*
                APP.Error.logError(e, {
                    source: 'APP.Notification.playNotificationSound'
                });
                */
            }
        }
    }

    function showNotificationFavicon() {
        $notificationFavicon.attr('href', $notificationFavicon.attr('data-notification-icon'));
    }

    function hideNotificationFavicon() {
        $notificationFavicon.attr('href', $notificationFavicon.attr('data-default-icon'));
    }

    exports.init = init;
    return exports;

})();

APP.ProblemWorker = (function () {
    var exports,
        $worker,
        initialized = false,
        initPromise,
        workerReady = false,
        requestQueue = [],
        callbacks = {},
        mainRows = [],
        rows = {},

        placeholderCallbacks = {},
        getDomCallbacks = {},
        runCallbacks = {},
        currentCallback,
        domIdSeeker = 0,
        runIdSeeker = 0;

    function init() {
        if (initPromise) {
            return initPromise;
        }

        initPromise = new Promise((function (resolve) {
            if (initialized) {
                resolve();
                return;
            }
            initialized = true;

            if (typeof window.Worker !== 'function') {
                workerFallback(resolve);
            } else {
                $worker = new Worker(document.location.origin + '/static/js/worker.' + window.LANGUAGE + '.js');
                $worker.onerror = function (error) {
                    APP.Error.logError(error, {
                        source: 'APP.ProblemWorker.worker.onerror'
                    });
                };
                $worker.onmessageerror = function (error) {
                    APP.Error.logError(error, {
                        source: 'APP.ProblemWorker.worker.onmessageerror'
                    });
                };
                sendRequest({method: 'addReplaceTable', data: APP.Locale.getReplaceTable()}, true);
                $worker.onmessage = function (e) {
                    var data;

                    try {
                        data = JSON.parse(e.data);
                    } catch (error) {
                        APP.Error.logError(error, {
                            source: 'APP.ProblemWorker.workerMessageParse',
                            context: {
                                raw: e.data || ''
                            }
                        });
                        return;
                    }
                    if (data.method === 'ready') {
                        workerReady = true;
                        flushRequestQueue();
                        resolve();
                    } else {
                        messageHandler(data.method, data.data);
                    }
                };
                sendRequest({method: 'addTemplates', data: APP.$store.templates}, true);
            }
        }));

        return initPromise;
    }

    function workerFallback(resolve) {
        var script = document.createElement('script');
        script.src = document.location.origin + '/static/js/worker.' + window.LANGUAGE + '.js';
        document.body.appendChild(script);

        window.workerReady = (function () {
            $worker = window.$worker;
            workerReady = true;
            sendRequest({method: 'addReplaceTable', data: APP.Locale.getReplaceTable()}, true);
            $worker.onmessage(messageHandler);
            sendRequest({method: 'addTemplates', data: APP.$store.templates}, true);
            flushRequestQueue();
            resolve();
        });
    }

    function messageHandler(method, data) {
        switch (method) {
            case 'addToDom':
                addToDom(data.content, data.placeholder);
                break;
            case 'placeholderContentArrived':
                if (placeholderCallbacks[data.id]) {
                    placeholderCallbacks[data.id](data.content);
                    delete placeholderCallbacks[data.id];
                }
                break;
            case 'addDom':
                if (getDomCallbacks[data.id]) {
                    getDomCallbacks[data.id](data.content);
                    delete getDomCallbacks[data.id];
                }
                break;
            case 'run':
                if (runCallbacks[data.id]) {
                    runCallbacks[data.id](data.content);
                    delete runCallbacks[data.id];
                }
                break;
            case 'setCurrents':
                currentCallback(data);
                break;
            case 'done':
                showDone();
                break;
            case 'error':
                APP.Error.logError(new Error('Problem worker returned error'), {
                    source: 'APP.ProblemWorker.messageHandler',
                    context: {
                        workerError: typeof data === 'string' ? data : JSON.stringify(data || {})
                    }
                });
                showProblemError(data);
                break;
            case 'client-error':
                reportWorkerClientError(data);
                break;
            case 'elementary':
                var $mainRows = $body.find('[data-formulas-root] > [data-row-placeholder]');
                if ($mainRows.length <= 2) {
                    async(function () {
                        $mainRows.first().find('> [data-problem-main-row]').trigger('click');
                    });
                }
                break;
        }

    }

    function sendRequest(message, asap) {
        if (!$worker || (!workerReady && !asap)) {
            requestQueue.push({message: message, asap: asap});
            return;
        }
        if (asap) {
            $worker.postMessage(message);
        } else {
            setTimeout(function () {
                $worker.postMessage(message);
            }, 8);
        }
    }

    function flushRequestQueue() {
        var queued = requestQueue;

        requestQueue = [];
        queued.forEach(function (request) {
            sendRequest(request.message, request.asap);
        });
    }

    function buildResult(id) {
        return new Promise(function (resolve) {
            sendRequest({method: 'buildResult', data: {id: id, source: queryDecode().source}});
            callbacks.onDom = resolve;
        });
    }

    function addToDom(content, id) {
        var $loader = $body.find('[data-placeholder-loader="' + id + '"]:not(.loaded)');
        $loader.html(content);
        $loader.addClass('loaded');
        fillPlaceholderStackByWrapper($loader);
        async(callbacks.onDom);
    }

    function showDone() {
        var $waitbox = $body.find('.waitbox');
        $waitbox.addClass('waitbox--loaded');
    }

    function showProblemError(msg) {
        var $waitbox = $body.find('.waitbox');
        if (typeof msg === 'string') {
            $waitbox.find('[data-problem-error-text]').show().text(msg);
        } else {
            $waitbox.find('[data-problem-error-text]').hide();
        }
        $waitbox.addClass('waitbox--broke');
    }

    function reportWorkerClientError(data) {
        var error = new Error(data && data.message || 'Unknown worker error');

        error.stack = data && data.stack || error.stack;
        APP.Error.logError(error, {
            source: 'APP.ProblemWorker.client-error',
            context: data && data.context || {}
        });
    }

    function fillPlaceholderStackByWrapper($wrapper) {
        $wrapper.find('[data-row-placeholder]:not(.problem-row-placeholder--inited)').each(function () {
            var $this = $(this),
                $parent = $this.parents('[data-row-placeholder]').first(),
                parent = rows[$parent.attr('data-row-placeholder')],
                row = new Row(),
                id;

            row.init($this, parent);
            id = row.getId();

            rows[id] = row;

            if (!parent) {
                mainRows.push(id);
            }
        });
    }

    function getContent(id, callback) {
        sendRequest({method: 'getPlaceholder', data: id});
        placeholderCallbacks[id] = callback;
    }

    function checkMainRows() {
        var i;
        async(function () {
            for (i = 0; i < mainRows.length; i++) {
                rows[mainRows[i]].check();
            }
        });
    }

    function openRow(placeholderId) {
        if (rows.hasOwnProperty(placeholderId)) {
            rows[placeholderId].open();
        }
    }

    function closeRow(placeholderId) {
        if (rows.hasOwnProperty(placeholderId)) {
            rows[placeholderId].close();
        }
    }

    function getDom(formula, mode) {
        return new Promise(function (resolve) {
            sendRequest({
                method: 'getDom', data: {
                    formula: formula,
                    mode: mode,
                    id: ++domIdSeeker
                }
            });
            getDomCallbacks[domIdSeeker] = function (data) {
                resolve(data);
            }
        });
    }

    function run(tpl, context) {
        return new Promise(function (resolve) {
            sendRequest({
                method: 'run', data: {
                    id: ++runIdSeeker,
                    tpl: tpl,
                    context: context
                }
            });
            runCallbacks[runIdSeeker] = resolve;
        });
    }

    exports = {
        sendRequest: sendRequest,
        buildResult: buildResult,
        fillPlaceholderStackByWrapper: fillPlaceholderStackByWrapper,
        getContent: getContent,
        checkMainRows: checkMainRows,
        openRow: openRow,
        closeRow: closeRow,
        getDom: getDom,
        run: run,
        init: init,
    };

    return exports;

})();

APP.BasicCalculator = (function () {
    var initialized = false,
        output = '',
        $screen;

    function init() {
        $body.find('[data-basic-calculator]:not([data-initialized])').each(function () {
            $(this).attr('data-initialized', true).html(APP.Tpl.run('basic-calculator'));
        });
        initDomElements();
        if (!initialized) {
            initBindings();
            initialized = true;
        }
    }

    function initDomElements() {
        $screen = $body.find('[data-basic-calculator-result]');
        output = $screen.html();
    }

    function initBindings() {
        bindClick('[data-basic-calculator-eq]', function () {
            removeErr();
            try {
                $screen.html(eval(output));
                output = $screen.html();
                if (output.length === 0) {
                    write('0');
                }
            } catch (e) {
                $screen.addClass('basic-calculator__result--error');
                $screen.html('¯\\_(ツ)_/¯');
                output = '0';
            }
        });
        bindClick('[data-basic-calculator-delete]', function () {
            removeErr();
            $screen.html(output = '0');
        });
        bindClick('[data-basic-calculator-input]', function () {
            var char = $(this).attr('data-basic-calculator-input'),
                screenHtml = $screen.html();

            removeErr();
            if (isOperator(char)) {
                if (isOperator(output.substr(output.length - 1, 1))) {
                    output = output.substr(0, output.length - 1);
                }
                write(char);
            } else if (char === '0') {
                if (output !== '0') {
                    write(char);
                }
            } else {
                if (output === '0') {
                    output = '';
                }
                write(char);
            }


        });

        function bindClick(selector, callback) {
            $body.on('click', selector, callback);
        }
    }

    function removeErr() {
        $screen.removeClass('basic-calculator__result--error');
    }

    function isOperator(char) {
        return ('.-+*%/').indexOf(char) > -1;
    }

    function write(char) {
        $screen.html(output = output.concat(char));
    }

    return {
        init: init
    };

})();

// Slick hiba javítása: jQuery.type pótlása
if (typeof jQuery !== 'undefined' && !jQuery.type) {
    jQuery.type = function (obj) {
        return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    };
}
!function (i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function (i) {
    "use strict";
    var e = window.Slick || {};
    (e = function () {
        var e = 0;
        return function (t, o) {
            var s, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    return i('<button type="button" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
        }
    }()).prototype.activateADA = function () {
        this.$slideTrack.find(".slick-active").attr({"aria-hidden": "false"}).find("a, input, button, select").attr({tabindex: "0"})
    }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
        var s = this;
        if ("boolean" == typeof t) o = t, t = null; else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e)
        }), s.$slidesCache = s.$slides, s.reinit()
    }, e.prototype.animateHeight = function () {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({height: e}, i.options.speed)
        }
    }, e.prototype.animateSlide = function (e, t) {
        var o = {}, s = this;
        s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({left: e}, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({top: e}, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({animStart: s.currentLeft}).animate({animStart: e}, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function (i) {
                i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o))
            },
            complete: function () {
                t && t.call()
            }
        })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
            s.disableTransition(), t.call()
        }, s.options.speed))
    }, e.prototype.getNavTarget = function () {
        var e = this, t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)), t
    }, e.prototype.asNavFor = function (e) {
        var t = this.getNavTarget();
        null !== t && "object" == typeof t && t.each(function () {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }, e.prototype.applyTransition = function (i) {
        var e = this, t = {};
        !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.autoPlay = function () {
        var i = this;
        i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }, e.prototype.autoPlayClear = function () {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer)
    }, e.prototype.autoPlayIterator = function () {
        var i = this, e = i.currentSlide + i.options.slidesToScroll;
        i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e))
    }, e.prototype.buildArrows = function () {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, e.prototype.buildDots = function () {
        var e, t, o = this;
        if (!0 === o.options.dots) {
            for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active")
        }
    }, e.prototype.buildOut = function () {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
    }, e.prototype.buildRows = function () {
        var i, e, t, o, s, n, r, l = this;
        if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
            for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                var d = document.createElement("div");
                for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                        var c = i * r + (e * l.options.slidesPerRow + t);
                        n.get(c) && a.appendChild(n.get(c))
                    }
                    d.appendChild(a)
                }
                o.appendChild(d)
            }
            l.$slider.empty().append(o), l.$slider.children().children().children().css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, e.prototype.checkResponsive = function (e, t) {
        var o, s, n, r = this, l = !1, d = r.$slider.width(), a = window.innerWidth || i(window).width();
        if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            s = null;
            for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l])
        }
    }, e.prototype.changeSlide = function (e, t) {
        var o, s, n, r = this, l = i(e.currentTarget);
        switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
            case"previous":
                s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
                break;
            case"next":
                s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
                break;
            case"index":
                var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
                r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
                break;
            default:
                return
        }
    }, e.prototype.checkNavigable = function (i) {
        var e, t;
        if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1]; else for (var o in e) {
            if (i < e[o]) {
                i = t;
                break
            }
            t = e[o]
        }
        return i
    }, e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }, e.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.cleanUpRows = function () {
        var i, e = this;
        e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i))
    }, e.prototype.clickHandler = function (i) {
        !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
    }, e.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
            i(this).attr("style", i(this).data("originalStyling"))
        }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
    }, e.prototype.disableTransition = function (i) {
        var e = this, t = {};
        t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.fadeSlide = function (i, e) {
        var t = this;
        !1 === t.cssTransitions ? (t.$slides.eq(i).css({zIndex: t.options.zIndex}), t.$slides.eq(i).animate({opacity: 1}, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
            opacity: 1,
            zIndex: t.options.zIndex
        }), e && setTimeout(function () {
            t.disableTransition(i), e.call()
        }, t.options.speed))
    }, e.prototype.fadeSlideOut = function (i) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(i).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
        var e = this;
        null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
    }, e.prototype.focusHandler = function () {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
            t.stopImmediatePropagation();
            var o = i(this);
            setTimeout(function () {
                e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay())
            }, 0)
        })
    }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
        return this.currentSlide
    }, e.prototype.getDotCount = function () {
        var i = this, e = 0, t = 0, o = 0;
        if (!0 === i.options.infinite) if (i.slideCount <= i.options.slidesToShow) ++o; else for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else if (!0 === i.options.centerMode) o = i.slideCount; else if (i.options.asNavFor) for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow; else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
        return o - 1
    }, e.prototype.getLeft = function (i) {
        var e, t, o, s, n = this, r = 0;
        return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
    }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
        return this.options[i]
    }, e.prototype.getNavigableIndexes = function () {
        var i, e = this, t = 0, o = 0, s = [];
        for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }, e.prototype.getSlick = function () {
        return this
    }, e.prototype.getSlideCount = function () {
        var e, t, o = this;
        return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
            if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1
        }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
        this.changeSlide({data: {message: "index", index: parseInt(i)}}, e)
    }, e.prototype.init = function (e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
    }, e.prototype.initADA = function () {
        var e = this, t = Math.ceil(e.slideCount / e.options.slidesToShow),
            o = e.getNavigableIndexes().filter(function (i) {
                return i >= 0 && i < e.slideCount
            });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({tabindex: "-1"}), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
            var s = o.indexOf(t);
            i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + t,
                tabindex: -1
            }), -1 !== s && i(this).attr({"aria-describedby": "slick-slide-control" + e.instanceUid + s})
        }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
            var n = o[s];
            i(this).attr({role: "presentation"}), i(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + s,
                "aria-controls": "slick-slide" + e.instanceUid + n,
                "aria-label": s + 1 + " of " + t,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({"aria-selected": "true", tabindex: "0"}).end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
        e.activateADA()
    }, e.prototype.initArrowEvents = function () {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {message: "previous"}, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {message: "next"}, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
    }, e.prototype.initDotEvents = function () {
        var e = this;
        !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {message: "index"}, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
    }, e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {action: "start"}, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {action: "move"}, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {action: "end"}, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {action: "end"}, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition)
    }, e.prototype.initUI = function () {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }, e.prototype.keyHandler = function (i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({data: {message: !0 === e.options.rtl ? "next" : "previous"}}) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({data: {message: !0 === e.options.rtl ? "previous" : "next"}}))
    }, e.prototype.lazyLoad = function () {
        function e(e) {
            i("img[data-lazy]", e).each(function () {
                var e = i(this), t = i(this).attr("data-lazy"), o = i(this).attr("data-srcset"),
                    s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"), r = document.createElement("img");
                r.onload = function () {
                    e.animate({opacity: 0}, 100, function () {
                        o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({opacity: 1}, 200, function () {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), n.$slider.trigger("lazyLoaded", [n, e, t])
                    })
                }, r.onerror = function () {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t])
                }, r.src = t
            })
        }

        var t, o, s, n = this;
        if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
        e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
    }, e.prototype.loadSlider = function () {
        var i = this;
        i.setPosition(), i.$slideTrack.css({opacity: 1}), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }, e.prototype.next = e.prototype.slickNext = function () {
        this.changeSlide({data: {message: "next"}})
    }, e.prototype.orientationChange = function () {
        var i = this;
        i.checkResponsive(), i.setPosition()
    }, e.prototype.pause = e.prototype.slickPause = function () {
        var i = this;
        i.autoPlayClear(), i.paused = !0
    }, e.prototype.play = e.prototype.slickPlay = function () {
        var i = this;
        i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
    }, e.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
    }, e.prototype.prev = e.prototype.slickPrev = function () {
        this.changeSlide({data: {message: "previous"}})
    }, e.prototype.preventDefault = function (i) {
        i.preventDefault()
    }, e.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t, o, s, n, r, l = this, d = i("img[data-lazy]", l.$slider);
        d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad()
        }, r.onerror = function () {
            e < 3 ? setTimeout(function () {
                l.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad())
        }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
    }, e.prototype.refresh = function (e) {
        var t, o, s = this;
        o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {currentSlide: t}), s.init(), e || s.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !1)
    }, e.prototype.registerBreakpoints = function () {
        var e, t, o, s = this, n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
            s.respondTo = s.options.respondTo || "window";
            for (e in n) if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
                for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings
            }
            s.breakpoints.sort(function (i, e) {
                return s.options.mobileFirst ? i - e : e - i
            })
        }
    }, e.prototype.reinit = function () {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, e.prototype.resize = function () {
        var e = this;
        i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
            e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
        var o = this;
        if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
        o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit()
    }, e.prototype.setCSS = function (i) {
        var e, t, o = this, s = {};
        !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)))
    }, e.prototype.setDimensions = function () {
        var i = this;
        !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({padding: "0px " + i.options.centerPadding}) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({padding: i.options.centerPadding + " 0px"})), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
    }, e.prototype.setFade = function () {
        var e, t = this;
        t.$slides.each(function (o, s) {
            e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            }) : i(s).css({position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0})
        }), t.$slides.eq(t.currentSlide).css({zIndex: t.options.zIndex - 1, opacity: 1})
    }, e.prototype.setHeight = function () {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
    }, e.prototype.setOption = e.prototype.slickSetOption = function () {
        var e, t, o, s, n, r = this, l = !1;
        if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s; else if ("multiple" === n) i.each(o, function (i, e) {
            r.options[i] = e
        }); else if ("responsive" === n) for (t in s) if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]]; else {
            for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
            r.options.responsive.push(s[t])
        }
        l && (r.unload(), r.reinit())
    }, e.prototype.setPosition = function () {
        var i = this;
        i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
    }, e.prototype.setProps = function () {
        var i = this, e = document.body.style;
        i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
    }, e.prototype.setSlideClasses = function (i) {
        var e, t, o, s, n = this;
        if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
            var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
            e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")
        } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }, e.prototype.setupInfinite = function () {
        var e, t, o, s = this;
        if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
            for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                i(this).attr("id", "")
            })
        }
    }, e.prototype.interrupt = function (i) {
        var e = this;
        i || e.autoPlay(), e.interrupted = i
    }, e.prototype.selectHandler = function (e) {
        var t = this, o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
            s = parseInt(o.attr("data-slick-index"));
        s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s)
    }, e.prototype.slideHandler = function (i, e, t) {
        var o, s, n, r, l, d = null, a = this;
        if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
            a.postSlide(o)
        }) : a.postSlide(o)); else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
            a.postSlide(o)
        }) : a.postSlide(o)); else {
            if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
                a.postSlide(s)
            })) : a.postSlide(s), void a.animateHeight();
            !0 !== t ? a.animateSlide(d, function () {
                a.postSlide(s)
            }) : a.postSlide(s)
        }
    }, e.prototype.startLoad = function () {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
    }, e.prototype.swipeDirection = function () {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
    }, e.prototype.swipeEnd = function (i) {
        var e, t, o = this;
        if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
        if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
        if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {
                case"left":
                case"down":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                    break;
                case"right":
                case"up":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
            }
            "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]))
        } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
    }, e.prototype.swipeHandler = function (i) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
            case"start":
                e.swipeStart(i);
                break;
            case"move":
                e.swipeMove(i);
                break;
            case"end":
                e.swipeEnd(i)
        }
    }, e.prototype.swipeMove = function (i) {
        var e, t, o, s, n, r, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))))
    }, e.prototype.swipeStart = function (i) {
        var e, t = this;
        if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
        void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0
    }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
        var i = this;
        null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
    }, e.prototype.unload = function () {
        var e = this;
        i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, e.prototype.unslick = function (i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]), e.destroy()
    }, e.prototype.updateArrows = function () {
        var i = this;
        Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, e.prototype.updateDots = function () {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
    }, e.prototype.visibility = function () {
        var i = this;
        i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
    }, i.fn.slick = function () {
        var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), r = o.length;
        for (i = 0; i < r; i++) if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
        return o
    }
});

// Ipad fix polyfil
(function () {
    function polyfillReplaceChildren(proto) {
        if (!proto || proto.replaceChildren) return;

        proto.replaceChildren = function () {
            // remove existing children
            while (this.firstChild) this.removeChild(this.firstChild);

            // add new children (strings become text nodes)
            for (var i = 0; i < arguments.length; i++) {
                var node = arguments[i];
                if (typeof node === 'string') {
                    var doc = this.ownerDocument || (this.nodeType === 9 ? this : document);
                    node = doc.createTextNode(node);
                }
                this.appendChild(node);
            }
        };
    }

    polyfillReplaceChildren(Element.prototype);
    polyfillReplaceChildren(Document.prototype);
    polyfillReplaceChildren(DocumentFragment.prototype);
})();
/*! choices.js v11.2.0 | © 2026 Josh Johnson | https://github.com/jshjohnson/Choices#readme */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Choices = factory());
})(this, (function () { 'use strict';

    /******************************************************************************
     Copyright (c) Microsoft Corporation.

     Permission to use, copy, modify, and/or distribute this software for any
     purpose with or without fee is hereby granted.

     THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
     REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
     AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
     INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
     LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
     OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
     PERFORMANCE OF THIS SOFTWARE.
     ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol */

    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function (d, b) {
            d.__proto__ = b;
        } || function (d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function () {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }
    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    var ActionType = {
        ADD_CHOICE: 'ADD_CHOICE',
        REMOVE_CHOICE: 'REMOVE_CHOICE',
        FILTER_CHOICES: 'FILTER_CHOICES',
        ACTIVATE_CHOICES: 'ACTIVATE_CHOICES',
        CLEAR_CHOICES: 'CLEAR_CHOICES',
        ADD_GROUP: 'ADD_GROUP',
        ADD_ITEM: 'ADD_ITEM',
        REMOVE_ITEM: 'REMOVE_ITEM',
        HIGHLIGHT_ITEM: 'HIGHLIGHT_ITEM',
    };

    var EventType = {
        showDropdown: 'showDropdown',
        hideDropdown: 'hideDropdown',
        change: 'change',
        choice: 'choice',
        search: 'search',
        addItem: 'addItem',
        removeItem: 'removeItem',
        highlightItem: 'highlightItem',
        highlightChoice: 'highlightChoice',
        unhighlightItem: 'unhighlightItem',
    };

    var KeyCodeMap = {
        TAB_KEY: 9,
        SHIFT_KEY: 16,
        BACK_KEY: 46,
        DELETE_KEY: 8,
        ENTER_KEY: 13,
        A_KEY: 65,
        ESC_KEY: 27,
        UP_KEY: 38,
        DOWN_KEY: 40,
        PAGE_UP_KEY: 33,
        PAGE_DOWN_KEY: 34,
    };

    var ObjectsInConfig = ['fuseOptions', 'classNames'];

    var PassedElementTypes = {
        Text: 'text',
        SelectOne: 'select-one',
        SelectMultiple: 'select-multiple',
    };

    var addChoice = function (choice) { return ({
        type: ActionType.ADD_CHOICE,
        choice: choice,
    }); };
    var removeChoice = function (choice) { return ({
        type: ActionType.REMOVE_CHOICE,
        choice: choice,
    }); };
    var filterChoices = function (results) { return ({
        type: ActionType.FILTER_CHOICES,
        results: results,
    }); };
    var activateChoices = function (active) {
        return ({
            type: ActionType.ACTIVATE_CHOICES,
            active: active,
        });
    };

    var addGroup = function (group) { return ({
        type: ActionType.ADD_GROUP,
        group: group,
    }); };

    var addItem = function (item) { return ({
        type: ActionType.ADD_ITEM,
        item: item,
    }); };
    var removeItem$1 = function (item) { return ({
        type: ActionType.REMOVE_ITEM,
        item: item,
    }); };
    var highlightItem = function (item, highlighted) { return ({
        type: ActionType.HIGHLIGHT_ITEM,
        item: item,
        highlighted: highlighted,
    }); };

    var getRandomNumber = function (min, max) { return Math.floor(Math.random() * (max - min) + min); };
    var generateChars = function (length) {
        return Array.from({ length: length }, function () { return getRandomNumber(0, 36).toString(36); }).join('');
    };
    var generateId = function (element, prefix) {
        var id = element.id || (element.name && "".concat(element.name, "-").concat(generateChars(2))) || generateChars(4);
        id = id.replace(/(:|\.|\[|\]|,)/g, '');
        id = "".concat(prefix, "-").concat(id);
        return id;
    };
    var getAdjacentEl = function (startEl, selector, direction) {
        if (direction === void 0) { direction = 1; }
        var prop = "".concat(direction > 0 ? 'next' : 'previous', "ElementSibling");
        var sibling = startEl[prop];
        while (sibling) {
            if (sibling.matches(selector)) {
                return sibling;
            }
            sibling = sibling[prop];
        }
        return null;
    };
    var isScrolledIntoView = function (element, parent, direction) {
        if (direction === void 0) { direction = 1; }
        var isVisible;
        if (direction > 0) {
            // In view from bottom
            isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
        }
        else {
            // In view from top
            isVisible = element.offsetTop >= parent.scrollTop;
        }
        return isVisible;
    };
    var sanitise = function (value) {
        if (typeof value !== 'string') {
            if (value === null || value === undefined) {
                return '';
            }
            if (typeof value === 'object') {
                if ('raw' in value) {
                    return sanitise(value.raw);
                }
                if ('trusted' in value) {
                    return value.trusted;
                }
            }
            return value;
        }
        return value
            .replace(/&/g, '&amp;')
            .replace(/>/g, '&gt;')
            .replace(/</g, '&lt;')
            .replace(/'/g, '&#039;')
            .replace(/"/g, '&quot;');
    };
    var strToEl = (function () {
        var tmpEl = document.createElement('div');
        return function (str) {
            tmpEl.innerHTML = str.trim();
            var firstChild = tmpEl.children[0];
            while (tmpEl.firstChild) {
                tmpEl.removeChild(tmpEl.firstChild);
            }
            return firstChild;
        };
    })();
    var resolveStringFunction = function (fn) {
        return typeof fn === 'function' ? fn() : fn;
    };
    var unwrapStringForRaw = function (s) {
        if (typeof s === 'string') {
            return s;
        }
        if (typeof s === 'object') {
            if ('trusted' in s) {
                return s.trusted;
            }
            if ('raw' in s) {
                return s.raw;
            }
        }
        return '';
    };
    var unwrapStringForEscaped = function (s) {
        if (typeof s === 'string') {
            return s;
        }
        if (typeof s === 'object') {
            if ('escaped' in s) {
                return s.escaped;
            }
            if ('trusted' in s) {
                return s.trusted;
            }
        }
        return '';
    };
    var getChoiceForOutput = function (choice, keyCode) {
        return {
            id: choice.id,
            highlighted: choice.highlighted,
            labelClass: choice.labelClass,
            labelDescription: unwrapStringForRaw(choice.labelDescription),
            customProperties: choice.customProperties,
            disabled: choice.disabled,
            active: choice.active,
            label: choice.label,
            placeholder: choice.placeholder,
            value: choice.value,
            groupValue: choice.group ? choice.group.label : undefined,
            element: choice.element,
            keyCode: keyCode,
        };
    };
    var resolveNoticeFunction = function (fn, value, item) {
        return typeof fn === 'function' ? fn(sanitise(value), unwrapStringForRaw(value), item) : fn;
    };
    var escapeForTemplate = function (allowHTML, s) {
        return allowHTML ? unwrapStringForEscaped(s) : sanitise(s);
    };
    var setElementHtml = function (el, allowHtml, html) {
        el.innerHTML = escapeForTemplate(allowHtml, html);
    };
    var sortByAlpha = function (_a, _b) {
        var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
        var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
        return unwrapStringForRaw(label).localeCompare(unwrapStringForRaw(label2), [], {
            sensitivity: 'base',
            ignorePunctuation: true,
            numeric: true,
        });
    };
    var sortByRank = function (a, b) {
        return a.rank - b.rank;
    };
    var dispatchEvent = function (element, type, customArgs) {
        if (customArgs === void 0) { customArgs = null; }
        var event = new CustomEvent(type, {
            detail: customArgs,
            bubbles: true,
            cancelable: true,
        });
        return element.dispatchEvent(event);
    };
    /**
     * Returns an array of keys present on the first but missing on the second object
     */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var diff = function (a, b) {
            var aKeys = Object.keys(a).sort();
            var bKeys = Object.keys(b).sort();
            return aKeys.filter(function (i) { return bKeys.indexOf(i) < 0; });
        };
    var getClassNames = function (ClassNames) {
        return Array.isArray(ClassNames) ? ClassNames : [ClassNames];
    };
    var getClassNamesSelector = function (option) {
        if (option && Array.isArray(option)) {
            return option
                .map(function (item) {
                    return ".".concat(item);
                })
                .join('');
        }
        return ".".concat(option);
    };
    var addClassesToElement = function (element, className) {
        var _a;
        (_a = element.classList).add.apply(_a, getClassNames(className));
    };
    var removeClassesFromElement = function (element, className) {
        var _a;
        (_a = element.classList).remove.apply(_a, getClassNames(className));
    };
    var parseCustomProperties = function (customProperties) {
        if (typeof customProperties !== 'undefined') {
            try {
                return JSON.parse(customProperties);
            }
            catch (e) {
                return customProperties;
            }
        }
        return {};
    };
    var updateClassList = function (item, add, remove) {
        var itemEl = item.itemEl;
        if (itemEl) {
            removeClassesFromElement(itemEl, remove);
            addClassesToElement(itemEl, add);
        }
    };

    var Dropdown = /** @class */ (function () {
        function Dropdown(_a) {
            var element = _a.element, type = _a.type, classNames = _a.classNames;
            this.element = element;
            this.classNames = classNames;
            this.type = type;
            this.isActive = false;
        }
        /**
         * Show dropdown to user by adding active state class
         */
        Dropdown.prototype.show = function () {
            addClassesToElement(this.element, this.classNames.activeState);
            this.element.setAttribute('aria-expanded', 'true');
            this.isActive = true;
            return this;
        };
        /**
         * Hide dropdown from user
         */
        Dropdown.prototype.hide = function () {
            removeClassesFromElement(this.element, this.classNames.activeState);
            this.element.setAttribute('aria-expanded', 'false');
            this.isActive = false;
            return this;
        };
        return Dropdown;
    }());

    var Container = /** @class */ (function () {
        function Container(_a) {
            var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
            this.element = element;
            this.classNames = classNames;
            this.type = type;
            this.position = position;
            this.isOpen = false;
            this.isFlipped = false;
            this.isDisabled = false;
            this.isLoading = false;
        }
        /**
         * Determine whether container should be flipped based on passed
         * dropdown position
         */
        Container.prototype.shouldFlip = function (dropdownPos, dropdownHeight) {
            // If flip is enabled and the dropdown bottom position is
            // greater than the window height flip the dropdown.
            var shouldFlip = false;
            if (this.position === 'auto') {
                shouldFlip =
                    this.element.getBoundingClientRect().top - dropdownHeight >= 0 &&
                    !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
            }
            else if (this.position === 'top') {
                shouldFlip = true;
            }
            return shouldFlip;
        };
        Container.prototype.setActiveDescendant = function (activeDescendantID) {
            this.element.setAttribute('aria-activedescendant', activeDescendantID);
        };
        Container.prototype.removeActiveDescendant = function () {
            this.element.removeAttribute('aria-activedescendant');
        };
        Container.prototype.open = function (dropdownPos, dropdownHeight) {
            addClassesToElement(this.element, this.classNames.openState);
            this.element.setAttribute('aria-expanded', 'true');
            this.isOpen = true;
            if (this.shouldFlip(dropdownPos, dropdownHeight)) {
                addClassesToElement(this.element, this.classNames.flippedState);
                this.isFlipped = true;
            }
        };
        Container.prototype.close = function () {
            removeClassesFromElement(this.element, this.classNames.openState);
            this.element.setAttribute('aria-expanded', 'false');
            this.removeActiveDescendant();
            this.isOpen = false;
            // A dropdown flips if it does not have space within the page
            if (this.isFlipped) {
                removeClassesFromElement(this.element, this.classNames.flippedState);
                this.isFlipped = false;
            }
        };
        Container.prototype.addFocusState = function () {
            addClassesToElement(this.element, this.classNames.focusState);
        };
        Container.prototype.removeFocusState = function () {
            removeClassesFromElement(this.element, this.classNames.focusState);
        };
        Container.prototype.addInvalidState = function () {
            addClassesToElement(this.element, this.classNames.invalidState);
        };
        Container.prototype.removeInvalidState = function () {
            removeClassesFromElement(this.element, this.classNames.invalidState);
        };
        Container.prototype.enable = function () {
            removeClassesFromElement(this.element, this.classNames.disabledState);
            this.element.removeAttribute('aria-disabled');
            if (this.type === PassedElementTypes.SelectOne) {
                this.element.setAttribute('tabindex', '0');
            }
            this.isDisabled = false;
        };
        Container.prototype.disable = function () {
            addClassesToElement(this.element, this.classNames.disabledState);
            this.element.setAttribute('aria-disabled', 'true');
            if (this.type === PassedElementTypes.SelectOne) {
                this.element.setAttribute('tabindex', '-1');
            }
            this.isDisabled = true;
        };
        Container.prototype.wrap = function (element) {
            var el = this.element;
            var parentNode = element.parentNode;
            if (parentNode) {
                if (element.nextSibling) {
                    parentNode.insertBefore(el, element.nextSibling);
                }
                else {
                    parentNode.appendChild(el);
                }
            }
            el.appendChild(element);
        };
        Container.prototype.unwrap = function (element) {
            var el = this.element;
            var parentNode = el.parentNode;
            if (parentNode) {
                // Move passed element outside this element
                parentNode.insertBefore(element, el);
                // Remove this element
                parentNode.removeChild(el);
            }
        };
        Container.prototype.addLoadingState = function () {
            addClassesToElement(this.element, this.classNames.loadingState);
            this.element.setAttribute('aria-busy', 'true');
            this.isLoading = true;
        };
        Container.prototype.removeLoadingState = function () {
            removeClassesFromElement(this.element, this.classNames.loadingState);
            this.element.removeAttribute('aria-busy');
            this.isLoading = false;
        };
        return Container;
    }());

    var Input = /** @class */ (function () {
        function Input(_a) {
            var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
            this.element = element;
            this.type = type;
            this.classNames = classNames;
            this.preventPaste = preventPaste;
            this.isFocussed = this.element.isEqualNode(document.activeElement);
            this.isDisabled = element.disabled;
            this._onPaste = this._onPaste.bind(this);
            this._onInput = this._onInput.bind(this);
            this._onFocus = this._onFocus.bind(this);
            this._onBlur = this._onBlur.bind(this);
        }
        Object.defineProperty(Input.prototype, "placeholder", {
            set: function (placeholder) {
                this.element.placeholder = placeholder;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Input.prototype, "value", {
            get: function () {
                return this.element.value;
            },
            set: function (value) {
                this.element.value = value;
            },
            enumerable: false,
            configurable: true
        });
        Input.prototype.addEventListeners = function () {
            var el = this.element;
            el.addEventListener('paste', this._onPaste);
            el.addEventListener('input', this._onInput, {
                passive: true,
            });
            el.addEventListener('focus', this._onFocus, {
                passive: true,
            });
            el.addEventListener('blur', this._onBlur, {
                passive: true,
            });
        };
        Input.prototype.removeEventListeners = function () {
            var el = this.element;
            el.removeEventListener('input', this._onInput);
            el.removeEventListener('paste', this._onPaste);
            el.removeEventListener('focus', this._onFocus);
            el.removeEventListener('blur', this._onBlur);
        };
        Input.prototype.enable = function () {
            var el = this.element;
            el.removeAttribute('disabled');
            this.isDisabled = false;
        };
        Input.prototype.disable = function () {
            var el = this.element;
            el.setAttribute('disabled', '');
            this.isDisabled = true;
        };
        Input.prototype.focus = function () {
            if (!this.isFocussed) {
                this.element.focus();
            }
        };
        Input.prototype.blur = function () {
            if (this.isFocussed) {
                this.element.blur();
            }
        };
        Input.prototype.clear = function (setWidth) {
            if (setWidth === void 0) { setWidth = true; }
            this.element.value = '';
            if (setWidth) {
                this.setWidth();
            }
            return this;
        };
        /**
         * Set the correct input width based on placeholder
         * value or input value
         */
        Input.prototype.setWidth = function () {
            // Resize input to contents or placeholder
            var element = this.element;
            element.style.minWidth = "".concat(element.placeholder.length + 1, "ch");
            element.style.width = "".concat(element.value.length + 1, "ch");
        };
        Input.prototype.setActiveDescendant = function (activeDescendantID) {
            this.element.setAttribute('aria-activedescendant', activeDescendantID);
        };
        Input.prototype.removeActiveDescendant = function () {
            this.element.removeAttribute('aria-activedescendant');
        };
        Input.prototype._onInput = function () {
            if (this.type !== PassedElementTypes.SelectOne) {
                this.setWidth();
            }
        };
        Input.prototype._onPaste = function (event) {
            if (this.preventPaste) {
                event.preventDefault();
            }
        };
        Input.prototype._onFocus = function () {
            this.isFocussed = true;
        };
        Input.prototype._onBlur = function () {
            this.isFocussed = false;
        };
        return Input;
    }());

    var SCROLLING_SPEED = 4;

    var List = /** @class */ (function () {
        function List(_a) {
            var element = _a.element;
            this.element = element;
            this.scrollPos = this.element.scrollTop;
            this.height = this.element.offsetHeight;
        }
        List.prototype.prepend = function (node) {
            var child = this.element.firstElementChild;
            if (child) {
                this.element.insertBefore(node, child);
            }
            else {
                this.element.append(node);
            }
        };
        List.prototype.scrollToTop = function () {
            this.element.scrollTop = 0;
        };
        List.prototype.scrollToChildElement = function (element, direction) {
            var _this = this;
            if (!element) {
                return;
            }
            var listHeight = this.element.offsetHeight;
            // Scroll position of dropdown
            var listScrollPosition = this.element.scrollTop + listHeight;
            var elementHeight = element.offsetHeight;
            // Distance from bottom of element to top of parent
            var elementPos = element.offsetTop + elementHeight;
            // Difference between the element and scroll position
            var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
            requestAnimationFrame(function () {
                _this._animateScroll(destination, direction);
            });
        };
        List.prototype._scrollDown = function (scrollPos, strength, destination) {
            var easing = (destination - scrollPos) / strength;
            var distance = easing > 1 ? easing : 1;
            this.element.scrollTop = scrollPos + distance;
        };
        List.prototype._scrollUp = function (scrollPos, strength, destination) {
            var easing = (scrollPos - destination) / strength;
            var distance = easing > 1 ? easing : 1;
            this.element.scrollTop = scrollPos - distance;
        };
        List.prototype._animateScroll = function (destination, direction) {
            var _this = this;
            var strength = SCROLLING_SPEED;
            var choiceListScrollTop = this.element.scrollTop;
            var continueAnimation = false;
            if (direction > 0) {
                this._scrollDown(choiceListScrollTop, strength, destination);
                if (choiceListScrollTop < destination) {
                    continueAnimation = true;
                }
            }
            else {
                this._scrollUp(choiceListScrollTop, strength, destination);
                if (choiceListScrollTop > destination) {
                    continueAnimation = true;
                }
            }
            if (continueAnimation) {
                requestAnimationFrame(function () {
                    _this._animateScroll(destination, direction);
                });
            }
        };
        return List;
    }());

    var WrappedElement = /** @class */ (function () {
        function WrappedElement(_a) {
            var element = _a.element, classNames = _a.classNames;
            this.element = element;
            this.classNames = classNames;
            this.isDisabled = false;
        }
        Object.defineProperty(WrappedElement.prototype, "isActive", {
            get: function () {
                return this.element.dataset.choice === 'active';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WrappedElement.prototype, "dir", {
            get: function () {
                return this.element.dir;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WrappedElement.prototype, "value", {
            get: function () {
                return this.element.value;
            },
            set: function (value) {
                this.element.setAttribute('value', value);
                this.element.value = value;
            },
            enumerable: false,
            configurable: true
        });
        WrappedElement.prototype.conceal = function () {
            var el = this.element;
            // Hide passed input
            addClassesToElement(el, this.classNames.input);
            el.hidden = true;
            // Remove element from tab index
            el.tabIndex = -1;
            // Backup original styles if any
            var origStyle = el.getAttribute('style');
            if (origStyle) {
                el.setAttribute('data-choice-orig-style', origStyle);
            }
            el.setAttribute('data-choice', 'active');
        };
        WrappedElement.prototype.reveal = function () {
            var el = this.element;
            // Reinstate passed element
            removeClassesFromElement(el, this.classNames.input);
            el.hidden = false;
            el.removeAttribute('tabindex');
            // Recover original styles if any
            var origStyle = el.getAttribute('data-choice-orig-style');
            if (origStyle) {
                el.removeAttribute('data-choice-orig-style');
                el.setAttribute('style', origStyle);
            }
            else {
                el.removeAttribute('style');
            }
            el.removeAttribute('data-choice');
        };
        WrappedElement.prototype.enable = function () {
            this.element.removeAttribute('disabled');
            this.element.disabled = false;
            this.isDisabled = false;
        };
        WrappedElement.prototype.disable = function () {
            this.element.setAttribute('disabled', '');
            this.element.disabled = true;
            this.isDisabled = true;
        };
        WrappedElement.prototype.triggerEvent = function (eventType, data) {
            dispatchEvent(this.element, eventType, data || {});
        };
        return WrappedElement;
    }());

    var WrappedInput = /** @class */ (function (_super) {
        __extends(WrappedInput, _super);
        function WrappedInput() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return WrappedInput;
    }(WrappedElement));

    var coerceBool = function (arg, defaultValue) {
        if (defaultValue === void 0) { defaultValue = true; }
        return typeof arg === 'undefined' ? defaultValue : !!arg;
    };
    var stringToHtmlClass = function (input) {
        if (typeof input === 'string') {
            // eslint-disable-next-line no-param-reassign
            input = input.split(' ').filter(function (s) { return s.length; });
        }
        if (Array.isArray(input) && input.length) {
            return input;
        }
        return undefined;
    };
    var mapInputToChoice = function (value, allowGroup, allowRawString) {
        if (allowRawString === void 0) { allowRawString = true; }
        if (typeof value === 'string') {
            var sanitisedValue = sanitise(value);
            var userValue = allowRawString || sanitisedValue === value ? value : { escaped: sanitisedValue, raw: value };
            var result_1 = mapInputToChoice({
                value: value,
                label: userValue,
                selected: true,
            }, false);
            return result_1;
        }
        var groupOrChoice = value;
        if ('choices' in groupOrChoice) {
            if (!allowGroup) {
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/optgroup
                throw new TypeError("optGroup is not allowed");
            }
            var group = groupOrChoice;
            var choices = group.choices.map(function (e) { return mapInputToChoice(e, false); });
            var result_2 = {
                id: 0, // actual ID will be assigned during _addGroup
                label: unwrapStringForRaw(group.label) || group.value,
                active: !!choices.length,
                disabled: !!group.disabled,
                choices: choices,
            };
            return result_2;
        }
        var choice = groupOrChoice;
        var result = {
            id: 0, // actual ID will be assigned during _addChoice
            group: null, // actual group will be assigned during _addGroup but before _addChoice
            score: 0, // used in search
            rank: 0, // used in search, stable sort order
            value: choice.value,
            label: choice.label || choice.value,
            active: coerceBool(choice.active),
            selected: coerceBool(choice.selected, false),
            disabled: coerceBool(choice.disabled, false),
            placeholder: coerceBool(choice.placeholder, false),
            highlighted: false,
            labelClass: stringToHtmlClass(choice.labelClass),
            labelDescription: choice.labelDescription,
            customProperties: choice.customProperties,
        };
        return result;
    };

    var isHtmlInputElement = function (e) { return e.tagName === 'INPUT'; };
    var isHtmlSelectElement = function (e) { return e.tagName === 'SELECT'; };
    var isHtmlOption = function (e) { return e.tagName === 'OPTION'; };
    var isHtmlOptgroup = function (e) { return e.tagName === 'OPTGROUP'; };

    var WrappedSelect = /** @class */ (function (_super) {
        __extends(WrappedSelect, _super);
        function WrappedSelect(_a) {
            var element = _a.element, classNames = _a.classNames, template = _a.template, extractPlaceholder = _a.extractPlaceholder;
            var _this = _super.call(this, { element: element, classNames: classNames }) || this;
            _this.template = template;
            _this.extractPlaceholder = extractPlaceholder;
            return _this;
        }
        Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
            get: function () {
                return (this.element.querySelector('option[value=""]') ||
                    // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                    this.element.querySelector('option[placeholder]'));
            },
            enumerable: false,
            configurable: true
        });
        WrappedSelect.prototype.addOptions = function (choices) {
            var _this = this;
            var fragment = document.createDocumentFragment();
            choices.forEach(function (obj) {
                var choice = obj;
                if (choice.element) {
                    return;
                }
                var option = _this.template(choice);
                fragment.appendChild(option);
                choice.element = option;
            });
            this.element.appendChild(fragment);
        };
        WrappedSelect.prototype.optionsAsChoices = function () {
            var _this = this;
            var choices = [];
            this.element.querySelectorAll(':scope > option, :scope > optgroup').forEach(function (e) {
                if (isHtmlOption(e)) {
                    choices.push(_this._optionToChoice(e));
                }
                else if (isHtmlOptgroup(e)) {
                    choices.push(_this._optgroupToChoice(e));
                }
                // todo: hr as empty optgroup, requires displaying empty opt-groups to be useful
            });
            return choices;
        };
        // eslint-disable-next-line class-methods-use-this
        WrappedSelect.prototype._optionToChoice = function (option) {
            // option.value returns the label if there is no value attribute, which can break legacy placeholder attribute support
            if (!option.hasAttribute('value') && option.hasAttribute('placeholder')) {
                option.setAttribute('value', '');
                option.value = '';
            }
            return {
                id: 0,
                group: null,
                score: 0,
                rank: 0,
                value: option.value,
                // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option
                // This attribute is text for the label indicating the meaning of the option. If the `label` attribute isn't defined, its value is that of the element text content (ie `innerText`).
                label: option.label,
                element: option,
                active: true,
                // this returns true if nothing is selected on initial load, which will break placeholder support
                selected: this.extractPlaceholder ? option.selected : option.hasAttribute('selected'),
                disabled: option.disabled,
                highlighted: false,
                placeholder: this.extractPlaceholder && (!option.value || option.hasAttribute('placeholder')),
                labelClass: typeof option.dataset.labelClass !== 'undefined' ? stringToHtmlClass(option.dataset.labelClass) : undefined,
                labelDescription: typeof option.dataset.labelDescription !== 'undefined'
                    ? { trusted: option.dataset.labelDescription }
                    : undefined,
                customProperties: parseCustomProperties(option.dataset.customProperties),
            };
        };
        WrappedSelect.prototype._optgroupToChoice = function (optgroup) {
            var _this = this;
            var options = optgroup.querySelectorAll('option');
            var choices = Array.from(options).map(function (option) { return _this._optionToChoice(option); });
            return {
                id: 0,
                label: optgroup.label || '',
                element: optgroup,
                active: !!choices.length,
                disabled: optgroup.disabled,
                choices: choices,
            };
        };
        return WrappedSelect;
    }(WrappedElement));

    var DEFAULT_CLASSNAMES = {
        containerOuter: ['choices'],
        containerInner: ['choices__inner'],
        input: ['choices__input'],
        inputCloned: ['choices__input--cloned'],
        list: ['choices__list'],
        listItems: ['choices__list--multiple'],
        listSingle: ['choices__list--single'],
        listDropdown: ['choices__list--dropdown'],
        item: ['choices__item'],
        itemSelectable: ['choices__item--selectable'],
        itemDisabled: ['choices__item--disabled'],
        itemChoice: ['choices__item--choice'],
        description: ['choices__description'],
        placeholder: ['choices__placeholder'],
        group: ['choices__group'],
        groupHeading: ['choices__heading'],
        button: ['choices__button'],
        activeState: ['is-active'],
        focusState: ['is-focused'],
        openState: ['is-open'],
        disabledState: ['is-disabled'],
        highlightedState: ['is-highlighted'],
        selectedState: ['is-selected'],
        flippedState: ['is-flipped'],
        loadingState: ['is-loading'],
        invalidState: ['is-invalid'],
        notice: ['choices__notice'],
        addChoice: ['choices__item--selectable', 'add-choice'],
        noResults: ['has-no-results'],
        noChoices: ['has-no-choices'],
    };
    var DEFAULT_CONFIG = {
        items: [],
        choices: [],
        silent: false,
        renderChoiceLimit: -1,
        maxItemCount: -1,
        closeDropdownOnSelect: 'auto',
        singleModeForMultiSelect: false,
        addChoices: false,
        addItems: true,
        addItemFilter: function (value) { return !!value && value !== ''; },
        removeItems: true,
        removeItemButton: false,
        removeItemButtonAlignLeft: false,
        editItems: false,
        allowHTML: false,
        allowHtmlUserInput: false,
        duplicateItemsAllowed: true,
        delimiter: ',',
        paste: true,
        searchEnabled: true,
        searchChoices: true,
        searchDisabledChoices: false,
        searchFloor: 1,
        searchResultLimit: 4,
        searchFields: ['label', 'value'],
        position: 'auto',
        resetScrollPosition: true,
        shouldSort: true,
        shouldSortItems: false,
        sorter: sortByAlpha,
        shadowRoot: null,
        placeholder: true,
        placeholderValue: null,
        searchPlaceholderValue: null,
        prependValue: null,
        appendValue: null,
        renderSelectedChoices: 'auto',
        searchRenderSelectedChoices: true,
        loadingText: 'Loading...',
        noResultsText: 'No results found',
        noChoicesText: 'No choices to choose from',
        itemSelectText: 'Press to select',
        uniqueItemText: 'Only unique values can be added',
        customAddItemText: 'Only values matching specific conditions can be added',
        addItemText: function (value) { return "Press Enter to add <b>\"".concat(value, "\"</b>"); },
        removeItemIconText: function () { return "Remove item"; },
        removeItemLabelText: function (value, _valueRaw, i) {
            return "Remove item: ".concat(i ? sanitise(i.label) : value);
        },
        maxItemText: function (maxItemCount) { return "Only ".concat(maxItemCount, " values can be added"); },
        valueComparer: function (value1, value2) { return value1 === value2; },
        fuseOptions: {
            includeScore: true,
        },
        labelId: '',
        callbackOnInit: null,
        callbackOnCreateTemplates: null,
        classNames: DEFAULT_CLASSNAMES,
        appendGroupInSearch: false,
    };

    var removeItem = function (item) {
        var itemEl = item.itemEl;
        if (itemEl) {
            itemEl.remove();
            item.itemEl = undefined;
        }
    };
    function items(s, action, context) {
        var state = s;
        var update = true;
        switch (action.type) {
            case ActionType.ADD_ITEM: {
                action.item.selected = true;
                var el = action.item.element;
                if (el) {
                    el.selected = true;
                    el.setAttribute('selected', '');
                }
                state.push(action.item);
                break;
            }
            case ActionType.REMOVE_ITEM: {
                action.item.selected = false;
                var el = action.item.element;
                if (el) {
                    el.selected = false;
                    el.removeAttribute('selected');
                    // For a select-one, if all options are deselected, the first item is selected. To set a black value, select.value needs to be set
                    var select = el.parentElement;
                    if (select && isHtmlSelectElement(select) && select.type === PassedElementTypes.SelectOne) {
                        select.value = '';
                    }
                }
                // this is mixing concerns, but this is *so much faster*
                removeItem(action.item);
                state = state.filter(function (choice) { return choice.id !== action.item.id; });
                break;
            }
            case ActionType.REMOVE_CHOICE: {
                removeItem(action.choice);
                state = state.filter(function (item) { return item.id !== action.choice.id; });
                break;
            }
            case ActionType.HIGHLIGHT_ITEM: {
                var highlighted = action.highlighted;
                var item = state.find(function (obj) { return obj.id === action.item.id; });
                if (item && item.highlighted !== highlighted) {
                    item.highlighted = highlighted;
                    if (context) {
                        updateClassList(item, highlighted ? context.classNames.highlightedState : context.classNames.selectedState, highlighted ? context.classNames.selectedState : context.classNames.highlightedState);
                    }
                }
                break;
            }
            default: {
                update = false;
                break;
            }
        }
        return { state: state, update: update };
    }

    function groups(s, action) {
        var state = s;
        var update = true;
        switch (action.type) {
            case ActionType.ADD_GROUP: {
                state.push(action.group);
                break;
            }
            case ActionType.CLEAR_CHOICES: {
                state = [];
                break;
            }
            default: {
                update = false;
                break;
            }
        }
        return { state: state, update: update };
    }

    /* eslint-disable */
    function choices(s, action, context) {
        var state = s;
        var update = true;
        switch (action.type) {
            case ActionType.ADD_CHOICE: {
                state.push(action.choice);
                break;
            }
            case ActionType.REMOVE_CHOICE: {
                action.choice.choiceEl = undefined;
                if (action.choice.group) {
                    action.choice.group.choices = action.choice.group.choices.filter(function (obj) { return obj.id !== action.choice.id; });
                }
                state = state.filter(function (obj) { return obj.id !== action.choice.id; });
                break;
            }
            case ActionType.ADD_ITEM:
            case ActionType.REMOVE_ITEM: {
                action.item.choiceEl = undefined;
                break;
            }
            case ActionType.FILTER_CHOICES: {
                // avoid O(n^2) algorithm complexity when searching/filtering choices
                var scoreLookup_1 = [];
                action.results.forEach(function (result) {
                    scoreLookup_1[result.item.id] = result;
                });
                state.forEach(function (choice) {
                    var result = scoreLookup_1[choice.id];
                    if (result !== undefined) {
                        choice.score = result.score;
                        choice.rank = result.rank;
                        choice.active = true;
                    }
                    else {
                        choice.score = 0;
                        choice.rank = 0;
                        choice.active = false;
                    }
                    if (context && context.appendGroupInSearch) {
                        choice.choiceEl = undefined;
                    }
                });
                break;
            }
            case ActionType.ACTIVATE_CHOICES: {
                state.forEach(function (choice) {
                    choice.active = action.active;
                    if (context && context.appendGroupInSearch) {
                        choice.choiceEl = undefined;
                    }
                });
                break;
            }
            case ActionType.CLEAR_CHOICES: {
                state = [];
                break;
            }
            default: {
                update = false;
                break;
            }
        }
        return { state: state, update: update };
    }

    var reducers = {
        groups: groups,
        items: items,
        choices: choices,
    };
    var Store = /** @class */ (function () {
        function Store(context) {
            this._state = this.defaultState;
            this._listeners = [];
            this._txn = 0;
            this._context = context;
        }
        Object.defineProperty(Store.prototype, "defaultState", {
            // eslint-disable-next-line class-methods-use-this
            get: function () {
                return {
                    groups: [],
                    items: [],
                    choices: [],
                };
            },
            enumerable: false,
            configurable: true
        });
        // eslint-disable-next-line class-methods-use-this
        Store.prototype.changeSet = function (init) {
            return {
                groups: init,
                items: init,
                choices: init,
            };
        };
        Store.prototype.reset = function () {
            this._state = this.defaultState;
            var changes = this.changeSet(true);
            if (this._txn) {
                this._changeSet = changes;
            }
            else {
                this._listeners.forEach(function (l) { return l(changes); });
            }
        };
        Store.prototype.subscribe = function (onChange) {
            this._listeners.push(onChange);
            return this;
        };
        Store.prototype.dispatch = function (action) {
            var _this = this;
            var state = this._state;
            var hasChanges = false;
            var changes = this._changeSet || this.changeSet(false);
            Object.keys(reducers).forEach(function (key) {
                var stateUpdate = reducers[key](state[key], action, _this._context);
                if (stateUpdate.update) {
                    hasChanges = true;
                    changes[key] = true;
                    state[key] = stateUpdate.state;
                }
            });
            if (hasChanges) {
                if (this._txn) {
                    this._changeSet = changes;
                }
                else {
                    this._listeners.forEach(function (l) { return l(changes); });
                }
            }
        };
        Store.prototype.withTxn = function (func) {
            this._txn++;
            try {
                func();
            }
            finally {
                this._txn = Math.max(0, this._txn - 1);
                if (!this._txn) {
                    var changeSet_1 = this._changeSet;
                    if (changeSet_1) {
                        this._changeSet = undefined;
                        this._listeners.forEach(function (l) { return l(changeSet_1); });
                    }
                }
            }
        };
        Object.defineProperty(Store.prototype, "state", {
            /**
             * Get store object
             */
            get: function () {
                return this._state;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "items", {
            /**
             * Get items from store
             */
            get: function () {
                return this.state.items;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "highlightedActiveItems", {
            /**
             * Get highlighted items from store
             */
            get: function () {
                return this.items.filter(function (item) { return item.active && item.highlighted; });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "choices", {
            /**
             * Get choices from store
             */
            get: function () {
                return this.state.choices;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "activeChoices", {
            /**
             * Get active choices from store
             */
            get: function () {
                return this.choices.filter(function (choice) { return choice.active; });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "searchableChoices", {
            /**
             * Get choices that can be searched (excluding placeholders or disabled choices)
             */
            get: function () {
                var context = this._context;
                return this.choices.filter(function (choice) { return !choice.placeholder && (context.searchDisabledChoices || !choice.disabled); });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "groups", {
            /**
             * Get groups from store
             */
            get: function () {
                return this.state.groups;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Store.prototype, "activeGroups", {
            /**
             * Get active groups from store
             */
            get: function () {
                var _this = this;
                return this.state.groups.filter(function (group) {
                    var isActive = group.active && !group.disabled;
                    var hasActiveOptions = _this.state.choices.some(function (choice) { return choice.active && !choice.disabled; });
                    return isActive && hasActiveOptions;
                }, []);
            },
            enumerable: false,
            configurable: true
        });
        Store.prototype.inTxn = function () {
            return this._txn > 0;
        };
        /**
         * Get single choice by it's ID
         */
        Store.prototype.getChoiceById = function (id) {
            return this.activeChoices.find(function (choice) { return choice.id === id; });
        };
        /**
         * Get group by group id
         */
        Store.prototype.getGroupById = function (id) {
            return this.groups.find(function (group) { return group.id === id; });
        };
        return Store;
    }());

    var NoticeTypes = {
        noChoices: 'no-choices',
        noResults: 'no-results',
        addChoice: 'add-choice',
        generic: '',
    };

    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: true,
            configurable: true,
            writable: true
        }) : e[r] = t, e;
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function (r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for (var r = 1; r < arguments.length; r++) {
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }

    /**
     * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
     *
     * Copyright (c) 2023 Kiro Risk (http://kiro.me)
     * All Rights Reserved. Apache Software License 2.0
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     */

    function isArray(value) {
        return !Array.isArray ? getTag(value) === '[object Array]' : Array.isArray(value);
    }
    function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
            return value;
        }
        let result = value + '';
        return result == '0' && 1 / value == -Infinity ? '-0' : result;
    }
    function toString(value) {
        return value == null ? '' : baseToString(value);
    }
    function isString(value) {
        return typeof value === 'string';
    }
    function isNumber(value) {
        return typeof value === 'number';
    }

    // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
    function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && getTag(value) == '[object Boolean]';
    }
    function isObject(value) {
        return typeof value === 'object';
    }

    // Checks if `value` is object-like.
    function isObjectLike(value) {
        return isObject(value) && value !== null;
    }
    function isDefined(value) {
        return value !== undefined && value !== null;
    }
    function isBlank(value) {
        return !value.trim().length;
    }

    // Gets the `toStringTag` of `value`.
    // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
    function getTag(value) {
        return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
    }
    const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
    const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = key => `Invalid value for key ${key}`;
    const PATTERN_LENGTH_TOO_LARGE = max => `Pattern length exceeds max of ${max}.`;
    const MISSING_KEY_PROPERTY = name => `Missing ${name} property in key`;
    const INVALID_KEY_WEIGHT_VALUE = key => `Property 'weight' in key '${key}' must be a positive integer`;
    const hasOwn = Object.prototype.hasOwnProperty;
    class KeyStore {
        constructor(keys) {
            this._keys = [];
            this._keyMap = {};
            let totalWeight = 0;
            keys.forEach(key => {
                let obj = createKey(key);
                this._keys.push(obj);
                this._keyMap[obj.id] = obj;
                totalWeight += obj.weight;
            });

            // Normalize weights so that their sum is equal to 1
            this._keys.forEach(key => {
                key.weight /= totalWeight;
            });
        }
        get(keyId) {
            return this._keyMap[keyId];
        }
        keys() {
            return this._keys;
        }
        toJSON() {
            return JSON.stringify(this._keys);
        }
    }
    function createKey(key) {
        let path = null;
        let id = null;
        let src = null;
        let weight = 1;
        let getFn = null;
        if (isString(key) || isArray(key)) {
            src = key;
            path = createKeyPath(key);
            id = createKeyId(key);
        } else {
            if (!hasOwn.call(key, 'name')) {
                throw new Error(MISSING_KEY_PROPERTY('name'));
            }
            const name = key.name;
            src = name;
            if (hasOwn.call(key, 'weight')) {
                weight = key.weight;
                if (weight <= 0) {
                    throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                }
            }
            path = createKeyPath(name);
            id = createKeyId(name);
            getFn = key.getFn;
        }
        return {
            path,
            id,
            weight,
            src,
            getFn
        };
    }
    function createKeyPath(key) {
        return isArray(key) ? key : key.split('.');
    }
    function createKeyId(key) {
        return isArray(key) ? key.join('.') : key;
    }
    function get(obj, path) {
        let list = [];
        let arr = false;
        const deepGet = (obj, path, index) => {
            if (!isDefined(obj)) {
                return;
            }
            if (!path[index]) {
                // If there's no path left, we've arrived at the object we care about.
                list.push(obj);
            } else {
                let key = path[index];
                const value = obj[key];
                if (!isDefined(value)) {
                    return;
                }

                // If we're at the last value in the path, and if it's a string/number/bool,
                // add it to the list
                if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
                    list.push(toString(value));
                } else if (isArray(value)) {
                    arr = true;
                    // Search each item in the array.
                    for (let i = 0, len = value.length; i < len; i += 1) {
                        deepGet(value[i], path, index + 1);
                    }
                } else if (path.length) {
                    // An object. Recurse further.
                    deepGet(value, path, index + 1);
                }
            }
        };

        // Backwards compatibility (since path used to be a string)
        deepGet(obj, isString(path) ? path.split('.') : path, 0);
        return arr ? list : list[0];
    }
    const MatchOptions = {
        // Whether the matches should be included in the result set. When `true`, each record in the result
        // set will include the indices of the matched characters.
        // These can consequently be used for highlighting purposes.
        includeMatches: false,
        // When `true`, the matching function will continue to the end of a search pattern even if
        // a perfect match has already been located in the string.
        findAllMatches: false,
        // Minimum number of characters that must be matched before a result is considered a match
        minMatchCharLength: 1
    };
    const BasicOptions = {
        // When `true`, the algorithm continues searching to the end of the input even if a perfect
        // match is found before the end of the same input.
        isCaseSensitive: false,
        // When true, the matching function will continue to the end of a search pattern even if
        includeScore: false,
        // List of properties that will be searched. This also supports nested properties.
        keys: [],
        // Whether to sort the result list, by score
        shouldSort: true,
        // Default sort function: sort by ascending score, ascending index
        sortFn: (a, b) => a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
    };
    const FuzzyOptions = {
        // Approximately where in the text is the pattern expected to be found?
        location: 0,
        // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
        // (of both letters and location), a threshold of '1.0' would match anything.
        threshold: 0.6,
        // Determines how close the match must be to the fuzzy location (specified above).
        // An exact letter match which is 'distance' characters away from the fuzzy location
        // would score as a complete mismatch. A distance of '0' requires the match be at
        // the exact location specified, a threshold of '1000' would require a perfect match
        // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
        distance: 100
    };
    const AdvancedOptions = {
        // When `true`, it enables the use of unix-like search commands
        useExtendedSearch: false,
        // The get function to use when fetching an object's properties.
        // The default will search nested paths *ie foo.bar.baz*
        getFn: get,
        // When `true`, search will ignore `location` and `distance`, so it won't matter
        // where in the string the pattern appears.
        // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
        ignoreLocation: false,
        // When `true`, the calculation for the relevance score (used for sorting) will
        // ignore the field-length norm.
        // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
        ignoreFieldNorm: false,
        // The weight to determine how much field length norm effects scoring.
        fieldNormWeight: 1
    };
    var Config = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);
    const SPACE = /[^ ]+/g;

    // Field-length norm: the shorter the field, the higher the weight.
    // Set to 3 decimals to reduce index size.
    function norm(weight = 1, mantissa = 3) {
        const cache = new Map();
        const m = Math.pow(10, mantissa);
        return {
            get(value) {
                const numTokens = value.match(SPACE).length;
                if (cache.has(numTokens)) {
                    return cache.get(numTokens);
                }

                // Default function is 1/sqrt(x), weight makes that variable
                const norm = 1 / Math.pow(numTokens, 0.5 * weight);

                // In place of `toFixed(mantissa)`, for faster computation
                const n = parseFloat(Math.round(norm * m) / m);
                cache.set(numTokens, n);
                return n;
            },
            clear() {
                cache.clear();
            }
        };
    }
    class FuseIndex {
        constructor({
                        getFn = Config.getFn,
                        fieldNormWeight = Config.fieldNormWeight
                    } = {}) {
            this.norm = norm(fieldNormWeight, 3);
            this.getFn = getFn;
            this.isCreated = false;
            this.setIndexRecords();
        }
        setSources(docs = []) {
            this.docs = docs;
        }
        setIndexRecords(records = []) {
            this.records = records;
        }
        setKeys(keys = []) {
            this.keys = keys;
            this._keysMap = {};
            keys.forEach((key, idx) => {
                this._keysMap[key.id] = idx;
            });
        }
        create() {
            if (this.isCreated || !this.docs.length) {
                return;
            }
            this.isCreated = true;

            // List is Array<String>
            if (isString(this.docs[0])) {
                this.docs.forEach((doc, docIndex) => {
                    this._addString(doc, docIndex);
                });
            } else {
                // List is Array<Object>
                this.docs.forEach((doc, docIndex) => {
                    this._addObject(doc, docIndex);
                });
            }
            this.norm.clear();
        }
        // Adds a doc to the end of the index
        add(doc) {
            const idx = this.size();
            if (isString(doc)) {
                this._addString(doc, idx);
            } else {
                this._addObject(doc, idx);
            }
        }
        // Removes the doc at the specified index of the index
        removeAt(idx) {
            this.records.splice(idx, 1);

            // Change ref index of every subsquent doc
            for (let i = idx, len = this.size(); i < len; i += 1) {
                this.records[i].i -= 1;
            }
        }
        getValueForItemAtKeyId(item, keyId) {
            return item[this._keysMap[keyId]];
        }
        size() {
            return this.records.length;
        }
        _addString(doc, docIndex) {
            if (!isDefined(doc) || isBlank(doc)) {
                return;
            }
            let record = {
                v: doc,
                i: docIndex,
                n: this.norm.get(doc)
            };
            this.records.push(record);
        }
        _addObject(doc, docIndex) {
            let record = {
                i: docIndex,
                $: {}
            };

            // Iterate over every key (i.e, path), and fetch the value at that key
            this.keys.forEach((key, keyIndex) => {
                let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                if (!isDefined(value)) {
                    return;
                }
                if (isArray(value)) {
                    let subRecords = [];
                    const stack = [{
                        nestedArrIndex: -1,
                        value
                    }];
                    while (stack.length) {
                        const {
                            nestedArrIndex,
                            value
                        } = stack.pop();
                        if (!isDefined(value)) {
                            continue;
                        }
                        if (isString(value) && !isBlank(value)) {
                            let subRecord = {
                                v: value,
                                i: nestedArrIndex,
                                n: this.norm.get(value)
                            };
                            subRecords.push(subRecord);
                        } else if (isArray(value)) {
                            value.forEach((item, k) => {
                                stack.push({
                                    nestedArrIndex: k,
                                    value: item
                                });
                            });
                        } else ;
                    }
                    record.$[keyIndex] = subRecords;
                } else if (isString(value) && !isBlank(value)) {
                    let subRecord = {
                        v: value,
                        n: this.norm.get(value)
                    };
                    record.$[keyIndex] = subRecord;
                }
            });
            this.records.push(record);
        }
        toJSON() {
            return {
                keys: this.keys,
                records: this.records
            };
        }
    }
    function createIndex(keys, docs, {
        getFn = Config.getFn,
        fieldNormWeight = Config.fieldNormWeight
    } = {}) {
        const myIndex = new FuseIndex({
            getFn,
            fieldNormWeight
        });
        myIndex.setKeys(keys.map(createKey));
        myIndex.setSources(docs);
        myIndex.create();
        return myIndex;
    }
    function parseIndex(data, {
        getFn = Config.getFn,
        fieldNormWeight = Config.fieldNormWeight
    } = {}) {
        const {
            keys,
            records
        } = data;
        const myIndex = new FuseIndex({
            getFn,
            fieldNormWeight
        });
        myIndex.setKeys(keys);
        myIndex.setIndexRecords(records);
        return myIndex;
    }
    function computeScore$1(pattern, {
        errors = 0,
        currentLocation = 0,
        expectedLocation = 0,
        distance = Config.distance,
        ignoreLocation = Config.ignoreLocation
    } = {}) {
        const accuracy = errors / pattern.length;
        if (ignoreLocation) {
            return accuracy;
        }
        const proximity = Math.abs(expectedLocation - currentLocation);
        if (!distance) {
            // Dodge divide by zero error.
            return proximity ? 1.0 : accuracy;
        }
        return accuracy + proximity / distance;
    }
    function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
        let indices = [];
        let start = -1;
        let end = -1;
        let i = 0;
        for (let len = matchmask.length; i < len; i += 1) {
            let match = matchmask[i];
            if (match && start === -1) {
                start = i;
            } else if (!match && start !== -1) {
                end = i - 1;
                if (end - start + 1 >= minMatchCharLength) {
                    indices.push([start, end]);
                }
                start = -1;
            }
        }

        // (i-1 - start) + 1 => i - start
        if (matchmask[i - 1] && i - start >= minMatchCharLength) {
            indices.push([start, i - 1]);
        }
        return indices;
    }

    // Machine word size
    const MAX_BITS = 32;
    function search(text, pattern, patternAlphabet, {
        location = Config.location,
        distance = Config.distance,
        threshold = Config.threshold,
        findAllMatches = Config.findAllMatches,
        minMatchCharLength = Config.minMatchCharLength,
        includeMatches = Config.includeMatches,
        ignoreLocation = Config.ignoreLocation
    } = {}) {
        if (pattern.length > MAX_BITS) {
            throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
        }
        const patternLen = pattern.length;
        // Set starting location at beginning text and initialize the alphabet.
        const textLen = text.length;
        // Handle the case when location > text.length
        const expectedLocation = Math.max(0, Math.min(location, textLen));
        // Highest score beyond which we give up.
        let currentThreshold = threshold;
        // Is there a nearby exact match? (speedup)
        let bestLocation = expectedLocation;

        // Performance: only computer matches when the minMatchCharLength > 1
        // OR if `includeMatches` is true.
        const computeMatches = minMatchCharLength > 1 || includeMatches;
        // A mask of the matches, used for building the indices
        const matchMask = computeMatches ? Array(textLen) : [];
        let index;

        // Get all exact matches, here for speed up
        while ((index = text.indexOf(pattern, bestLocation)) > -1) {
            let score = computeScore$1(pattern, {
                currentLocation: index,
                expectedLocation,
                distance,
                ignoreLocation
            });
            currentThreshold = Math.min(score, currentThreshold);
            bestLocation = index + patternLen;
            if (computeMatches) {
                let i = 0;
                while (i < patternLen) {
                    matchMask[index + i] = 1;
                    i += 1;
                }
            }
        }

        // Reset the best location
        bestLocation = -1;
        let lastBitArr = [];
        let finalScore = 1;
        let binMax = patternLen + textLen;
        const mask = 1 << patternLen - 1;
        for (let i = 0; i < patternLen; i += 1) {
            // Scan for the best match; each iteration allows for one more error.
            // Run a binary search to determine how far from the match location we can stray
            // at this error level.
            let binMin = 0;
            let binMid = binMax;
            while (binMin < binMid) {
                const score = computeScore$1(pattern, {
                    errors: i,
                    currentLocation: expectedLocation + binMid,
                    expectedLocation,
                    distance,
                    ignoreLocation
                });
                if (score <= currentThreshold) {
                    binMin = binMid;
                } else {
                    binMax = binMid;
                }
                binMid = Math.floor((binMax - binMin) / 2 + binMin);
            }

            // Use the result from this iteration as the maximum for the next.
            binMax = binMid;
            let start = Math.max(1, expectedLocation - binMid + 1);
            let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

            // Initialize the bit array
            let bitArr = Array(finish + 2);
            bitArr[finish + 1] = (1 << i) - 1;
            for (let j = finish; j >= start; j -= 1) {
                let currentLocation = j - 1;
                let charMatch = patternAlphabet[text.charAt(currentLocation)];
                if (computeMatches) {
                    // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                    matchMask[currentLocation] = +!!charMatch;
                }

                // First pass: exact match
                bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

                // Subsequent passes: fuzzy match
                if (i) {
                    bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                }
                if (bitArr[j] & mask) {
                    finalScore = computeScore$1(pattern, {
                        errors: i,
                        currentLocation,
                        expectedLocation,
                        distance,
                        ignoreLocation
                    });

                    // This match will almost certainly be better than any existing match.
                    // But check anyway.
                    if (finalScore <= currentThreshold) {
                        // Indeed it is
                        currentThreshold = finalScore;
                        bestLocation = currentLocation;

                        // Already passed `loc`, downhill from here on in.
                        if (bestLocation <= expectedLocation) {
                            break;
                        }

                        // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                        start = Math.max(1, 2 * expectedLocation - bestLocation);
                    }
                }
            }

            // No hope for a (better) match at greater error levels.
            const score = computeScore$1(pattern, {
                errors: i + 1,
                currentLocation: expectedLocation,
                expectedLocation,
                distance,
                ignoreLocation
            });
            if (score > currentThreshold) {
                break;
            }
            lastBitArr = bitArr;
        }
        const result = {
            isMatch: bestLocation >= 0,
            // Count exact matches (those with a score of 0) to be "almost" exact
            score: Math.max(0.001, finalScore)
        };
        if (computeMatches) {
            const indices = convertMaskToIndices(matchMask, minMatchCharLength);
            if (!indices.length) {
                result.isMatch = false;
            } else if (includeMatches) {
                result.indices = indices;
            }
        }
        return result;
    }
    function createPatternAlphabet(pattern) {
        let mask = {};
        for (let i = 0, len = pattern.length; i < len; i += 1) {
            const char = pattern.charAt(i);
            mask[char] = (mask[char] || 0) | 1 << len - i - 1;
        }
        return mask;
    }
    class BitapSearch {
        constructor(pattern, {
            location = Config.location,
            threshold = Config.threshold,
            distance = Config.distance,
            includeMatches = Config.includeMatches,
            findAllMatches = Config.findAllMatches,
            minMatchCharLength = Config.minMatchCharLength,
            isCaseSensitive = Config.isCaseSensitive,
            ignoreLocation = Config.ignoreLocation
        } = {}) {
            this.options = {
                location,
                threshold,
                distance,
                includeMatches,
                findAllMatches,
                minMatchCharLength,
                isCaseSensitive,
                ignoreLocation
            };
            this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
            this.chunks = [];
            if (!this.pattern.length) {
                return;
            }
            const addChunk = (pattern, startIndex) => {
                this.chunks.push({
                    pattern,
                    alphabet: createPatternAlphabet(pattern),
                    startIndex
                });
            };
            const len = this.pattern.length;
            if (len > MAX_BITS) {
                let i = 0;
                const remainder = len % MAX_BITS;
                const end = len - remainder;
                while (i < end) {
                    addChunk(this.pattern.substr(i, MAX_BITS), i);
                    i += MAX_BITS;
                }
                if (remainder) {
                    const startIndex = len - MAX_BITS;
                    addChunk(this.pattern.substr(startIndex), startIndex);
                }
            } else {
                addChunk(this.pattern, 0);
            }
        }
        searchIn(text) {
            const {
                isCaseSensitive,
                includeMatches
            } = this.options;
            if (!isCaseSensitive) {
                text = text.toLowerCase();
            }

            // Exact match
            if (this.pattern === text) {
                let result = {
                    isMatch: true,
                    score: 0
                };
                if (includeMatches) {
                    result.indices = [[0, text.length - 1]];
                }
                return result;
            }

            // Otherwise, use Bitap algorithm
            const {
                location,
                distance,
                threshold,
                findAllMatches,
                minMatchCharLength,
                ignoreLocation
            } = this.options;
            let allIndices = [];
            let totalScore = 0;
            let hasMatches = false;
            this.chunks.forEach(({
                                     pattern,
                                     alphabet,
                                     startIndex
                                 }) => {
                const {
                    isMatch,
                    score,
                    indices
                } = search(text, pattern, alphabet, {
                    location: location + startIndex,
                    distance,
                    threshold,
                    findAllMatches,
                    minMatchCharLength,
                    includeMatches,
                    ignoreLocation
                });
                if (isMatch) {
                    hasMatches = true;
                }
                totalScore += score;
                if (isMatch && indices) {
                    allIndices = [...allIndices, ...indices];
                }
            });
            let result = {
                isMatch: hasMatches,
                score: hasMatches ? totalScore / this.chunks.length : 1
            };
            if (hasMatches && includeMatches) {
                result.indices = allIndices;
            }
            return result;
        }
    }
    class BaseMatch {
        constructor(pattern) {
            this.pattern = pattern;
        }
        static isMultiMatch(pattern) {
            return getMatch(pattern, this.multiRegex);
        }
        static isSingleMatch(pattern) {
            return getMatch(pattern, this.singleRegex);
        }
        search( /*text*/) {}
    }
    function getMatch(pattern, exp) {
        const matches = pattern.match(exp);
        return matches ? matches[1] : null;
    }

    // Token: 'file

    class ExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'exact';
        }
        static get multiRegex() {
            return /^="(.*)"$/;
        }
        static get singleRegex() {
            return /^=(.*)$/;
        }
        search(text) {
            const isMatch = text === this.pattern;
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, this.pattern.length - 1]
            };
        }
    }

    // Token: !fire

    class InverseExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'inverse-exact';
        }
        static get multiRegex() {
            return /^!"(.*)"$/;
        }
        static get singleRegex() {
            return /^!(.*)$/;
        }
        search(text) {
            const index = text.indexOf(this.pattern);
            const isMatch = index === -1;
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, text.length - 1]
            };
        }
    }

    // Token: ^file

    class PrefixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'prefix-exact';
        }
        static get multiRegex() {
            return /^\^"(.*)"$/;
        }
        static get singleRegex() {
            return /^\^(.*)$/;
        }
        search(text) {
            const isMatch = text.startsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, this.pattern.length - 1]
            };
        }
    }

    // Token: !^fire

    class InversePrefixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'inverse-prefix-exact';
        }
        static get multiRegex() {
            return /^!\^"(.*)"$/;
        }
        static get singleRegex() {
            return /^!\^(.*)$/;
        }
        search(text) {
            const isMatch = !text.startsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, text.length - 1]
            };
        }
    }

    // Token: .file$

    class SuffixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'suffix-exact';
        }
        static get multiRegex() {
            return /^"(.*)"\$$/;
        }
        static get singleRegex() {
            return /^(.*)\$$/;
        }
        search(text) {
            const isMatch = text.endsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [text.length - this.pattern.length, text.length - 1]
            };
        }
    }

    // Token: !.file$

    class InverseSuffixExactMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'inverse-suffix-exact';
        }
        static get multiRegex() {
            return /^!"(.*)"\$$/;
        }
        static get singleRegex() {
            return /^!(.*)\$$/;
        }
        search(text) {
            const isMatch = !text.endsWith(this.pattern);
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices: [0, text.length - 1]
            };
        }
    }
    class FuzzyMatch extends BaseMatch {
        constructor(pattern, {
            location = Config.location,
            threshold = Config.threshold,
            distance = Config.distance,
            includeMatches = Config.includeMatches,
            findAllMatches = Config.findAllMatches,
            minMatchCharLength = Config.minMatchCharLength,
            isCaseSensitive = Config.isCaseSensitive,
            ignoreLocation = Config.ignoreLocation
        } = {}) {
            super(pattern);
            this._bitapSearch = new BitapSearch(pattern, {
                location,
                threshold,
                distance,
                includeMatches,
                findAllMatches,
                minMatchCharLength,
                isCaseSensitive,
                ignoreLocation
            });
        }
        static get type() {
            return 'fuzzy';
        }
        static get multiRegex() {
            return /^"(.*)"$/;
        }
        static get singleRegex() {
            return /^(.*)$/;
        }
        search(text) {
            return this._bitapSearch.searchIn(text);
        }
    }

    // Token: 'file

    class IncludeMatch extends BaseMatch {
        constructor(pattern) {
            super(pattern);
        }
        static get type() {
            return 'include';
        }
        static get multiRegex() {
            return /^'"(.*)"$/;
        }
        static get singleRegex() {
            return /^'(.*)$/;
        }
        search(text) {
            let location = 0;
            let index;
            const indices = [];
            const patternLen = this.pattern.length;

            // Get all exact matches
            while ((index = text.indexOf(this.pattern, location)) > -1) {
                location = index + patternLen;
                indices.push([index, location - 1]);
            }
            const isMatch = !!indices.length;
            return {
                isMatch,
                score: isMatch ? 0 : 1,
                indices
            };
        }
    }

    // ❗Order is important. DO NOT CHANGE.
    const searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
    const searchersLen = searchers.length;

    // Regex to split by spaces, but keep anything in quotes together
    const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
    const OR_TOKEN = '|';

    // Return a 2D array representation of the query, for simpler parsing.
    // Example:
    // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
    function parseQuery(pattern, options = {}) {
        return pattern.split(OR_TOKEN).map(item => {
            let query = item.trim().split(SPACE_RE).filter(item => item && !!item.trim());
            let results = [];
            for (let i = 0, len = query.length; i < len; i += 1) {
                const queryItem = query[i];

                // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                let found = false;
                let idx = -1;
                while (!found && ++idx < searchersLen) {
                    const searcher = searchers[idx];
                    let token = searcher.isMultiMatch(queryItem);
                    if (token) {
                        results.push(new searcher(token, options));
                        found = true;
                    }
                }
                if (found) {
                    continue;
                }

                // 2. Handle single query matches (i.e, once that are *not* quoted)
                idx = -1;
                while (++idx < searchersLen) {
                    const searcher = searchers[idx];
                    let token = searcher.isSingleMatch(queryItem);
                    if (token) {
                        results.push(new searcher(token, options));
                        break;
                    }
                }
            }
            return results;
        });
    }

    // These extended matchers can return an array of matches, as opposed
    // to a singl match
    const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

    /**
     * Command-like searching
     * ======================
     *
     * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
     * search in a given text.
     *
     * Search syntax:
     *
     * | Token       | Match type                 | Description                            |
     * | ----------- | -------------------------- | -------------------------------------- |
     * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
     * | `=scheme`   | exact-match                | Items that are `scheme`                |
     * | `'python`   | include-match              | Items that include `python`            |
     * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
     * | `^java`     | prefix-exact-match         | Items that start with `java`           |
     * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
     * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
     * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
     *
     * A single pipe character acts as an OR operator. For example, the following
     * query matches entries that start with `core` and end with either`go`, `rb`,
     * or`py`.
     *
     * ```
     * ^core go$ | rb$ | py$
     * ```
     */
    class ExtendedSearch {
        constructor(pattern, {
            isCaseSensitive = Config.isCaseSensitive,
            includeMatches = Config.includeMatches,
            minMatchCharLength = Config.minMatchCharLength,
            ignoreLocation = Config.ignoreLocation,
            findAllMatches = Config.findAllMatches,
            location = Config.location,
            threshold = Config.threshold,
            distance = Config.distance
        } = {}) {
            this.query = null;
            this.options = {
                isCaseSensitive,
                includeMatches,
                minMatchCharLength,
                findAllMatches,
                ignoreLocation,
                location,
                threshold,
                distance
            };
            this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
            this.query = parseQuery(this.pattern, this.options);
        }
        static condition(_, options) {
            return options.useExtendedSearch;
        }
        searchIn(text) {
            const query = this.query;
            if (!query) {
                return {
                    isMatch: false,
                    score: 1
                };
            }
            const {
                includeMatches,
                isCaseSensitive
            } = this.options;
            text = isCaseSensitive ? text : text.toLowerCase();
            let numMatches = 0;
            let allIndices = [];
            let totalScore = 0;

            // ORs
            for (let i = 0, qLen = query.length; i < qLen; i += 1) {
                const searchers = query[i];

                // Reset indices
                allIndices.length = 0;
                numMatches = 0;

                // ANDs
                for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
                    const searcher = searchers[j];
                    const {
                        isMatch,
                        indices,
                        score
                    } = searcher.search(text);
                    if (isMatch) {
                        numMatches += 1;
                        totalScore += score;
                        if (includeMatches) {
                            const type = searcher.constructor.type;
                            if (MultiMatchSet.has(type)) {
                                allIndices = [...allIndices, ...indices];
                            } else {
                                allIndices.push(indices);
                            }
                        }
                    } else {
                        totalScore = 0;
                        numMatches = 0;
                        allIndices.length = 0;
                        break;
                    }
                }

                // OR condition, so if TRUE, return
                if (numMatches) {
                    let result = {
                        isMatch: true,
                        score: totalScore / numMatches
                    };
                    if (includeMatches) {
                        result.indices = allIndices;
                    }
                    return result;
                }
            }

            // Nothing was matched
            return {
                isMatch: false,
                score: 1
            };
        }
    }
    const registeredSearchers = [];
    function register(...args) {
        registeredSearchers.push(...args);
    }
    function createSearcher(pattern, options) {
        for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
            let searcherClass = registeredSearchers[i];
            if (searcherClass.condition(pattern, options)) {
                return new searcherClass(pattern, options);
            }
        }
        return new BitapSearch(pattern, options);
    }
    const LogicalOperator = {
        AND: '$and',
        OR: '$or'
    };
    const KeyType = {
        PATH: '$path',
        PATTERN: '$val'
    };
    const isExpression = query => !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
    const isPath = query => !!query[KeyType.PATH];
    const isLeaf = query => !isArray(query) && isObject(query) && !isExpression(query);
    const convertToExplicit = query => ({
        [LogicalOperator.AND]: Object.keys(query).map(key => ({
            [key]: query[key]
        }))
    });

    // When `auto` is `true`, the parse function will infer and initialize and add
    // the appropriate `Searcher` instance
    function parse(query, options, {
        auto = true
    } = {}) {
        const next = query => {
            let keys = Object.keys(query);
            const isQueryPath = isPath(query);
            if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
                return next(convertToExplicit(query));
            }
            if (isLeaf(query)) {
                const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                if (!isString(pattern)) {
                    throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                }
                const obj = {
                    keyId: createKeyId(key),
                    pattern
                };
                if (auto) {
                    obj.searcher = createSearcher(pattern, options);
                }
                return obj;
            }
            let node = {
                children: [],
                operator: keys[0]
            };
            keys.forEach(key => {
                const value = query[key];
                if (isArray(value)) {
                    value.forEach(item => {
                        node.children.push(next(item));
                    });
                }
            });
            return node;
        };
        if (!isExpression(query)) {
            query = convertToExplicit(query);
        }
        return next(query);
    }

    // Practical scoring function
    function computeScore(results, {
        ignoreFieldNorm = Config.ignoreFieldNorm
    }) {
        results.forEach(result => {
            let totalScore = 1;
            result.matches.forEach(({
                                        key,
                                        norm,
                                        score
                                    }) => {
                const weight = key ? key.weight : null;
                totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
            });
            result.score = totalScore;
        });
    }
    function transformMatches(result, data) {
        const matches = result.matches;
        data.matches = [];
        if (!isDefined(matches)) {
            return;
        }
        matches.forEach(match => {
            if (!isDefined(match.indices) || !match.indices.length) {
                return;
            }
            const {
                indices,
                value
            } = match;
            let obj = {
                indices,
                value
            };
            if (match.key) {
                obj.key = match.key.src;
            }
            if (match.idx > -1) {
                obj.refIndex = match.idx;
            }
            data.matches.push(obj);
        });
    }
    function transformScore(result, data) {
        data.score = result.score;
    }
    function format(results, docs, {
        includeMatches = Config.includeMatches,
        includeScore = Config.includeScore
    } = {}) {
        const transformers = [];
        if (includeMatches) transformers.push(transformMatches);
        if (includeScore) transformers.push(transformScore);
        return results.map(result => {
            const {
                idx
            } = result;
            const data = {
                item: docs[idx],
                refIndex: idx
            };
            if (transformers.length) {
                transformers.forEach(transformer => {
                    transformer(result, data);
                });
            }
            return data;
        });
    }
    class Fuse {
        constructor(docs, options = {}, index) {
            this.options = _objectSpread2(_objectSpread2({}, Config), options);
            if (this.options.useExtendedSearch && false) ;
            this._keyStore = new KeyStore(this.options.keys);
            this.setCollection(docs, index);
        }
        setCollection(docs, index) {
            this._docs = docs;
            if (index && !(index instanceof FuseIndex)) {
                throw new Error(INCORRECT_INDEX_TYPE);
            }
            this._myIndex = index || createIndex(this.options.keys, this._docs, {
                getFn: this.options.getFn,
                fieldNormWeight: this.options.fieldNormWeight
            });
        }
        add(doc) {
            if (!isDefined(doc)) {
                return;
            }
            this._docs.push(doc);
            this._myIndex.add(doc);
        }
        remove(predicate = ( /* doc, idx */) => false) {
            const results = [];
            for (let i = 0, len = this._docs.length; i < len; i += 1) {
                const doc = this._docs[i];
                if (predicate(doc, i)) {
                    this.removeAt(i);
                    i -= 1;
                    len -= 1;
                    results.push(doc);
                }
            }
            return results;
        }
        removeAt(idx) {
            this._docs.splice(idx, 1);
            this._myIndex.removeAt(idx);
        }
        getIndex() {
            return this._myIndex;
        }
        search(query, {
            limit = -1
        } = {}) {
            const {
                includeMatches,
                includeScore,
                shouldSort,
                sortFn,
                ignoreFieldNorm
            } = this.options;
            let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
            computeScore(results, {
                ignoreFieldNorm
            });
            if (shouldSort) {
                results.sort(sortFn);
            }
            if (isNumber(limit) && limit > -1) {
                results = results.slice(0, limit);
            }
            return format(results, this._docs, {
                includeMatches,
                includeScore
            });
        }
        _searchStringList(query) {
            const searcher = createSearcher(query, this.options);
            const {
                records
            } = this._myIndex;
            const results = [];

            // Iterate over every string in the index
            records.forEach(({
                                 v: text,
                                 i: idx,
                                 n: norm
                             }) => {
                if (!isDefined(text)) {
                    return;
                }
                const {
                    isMatch,
                    score,
                    indices
                } = searcher.searchIn(text);
                if (isMatch) {
                    results.push({
                        item: text,
                        idx,
                        matches: [{
                            score,
                            value: text,
                            norm,
                            indices
                        }]
                    });
                }
            });
            return results;
        }
        _searchLogical(query) {
            const expression = parse(query, this.options);
            const evaluate = (node, item, idx) => {
                if (!node.children) {
                    const {
                        keyId,
                        searcher
                    } = node;
                    const matches = this._findMatches({
                        key: this._keyStore.get(keyId),
                        value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                        searcher
                    });
                    if (matches && matches.length) {
                        return [{
                            idx,
                            item,
                            matches
                        }];
                    }
                    return [];
                }
                const res = [];
                for (let i = 0, len = node.children.length; i < len; i += 1) {
                    const child = node.children[i];
                    const result = evaluate(child, item, idx);
                    if (result.length) {
                        res.push(...result);
                    } else if (node.operator === LogicalOperator.AND) {
                        return [];
                    }
                }
                return res;
            };
            const records = this._myIndex.records;
            const resultMap = {};
            const results = [];
            records.forEach(({
                                 $: item,
                                 i: idx
                             }) => {
                if (isDefined(item)) {
                    let expResults = evaluate(expression, item, idx);
                    if (expResults.length) {
                        // Dedupe when adding
                        if (!resultMap[idx]) {
                            resultMap[idx] = {
                                idx,
                                item,
                                matches: []
                            };
                            results.push(resultMap[idx]);
                        }
                        expResults.forEach(({
                                                matches
                                            }) => {
                            resultMap[idx].matches.push(...matches);
                        });
                    }
                }
            });
            return results;
        }
        _searchObjectList(query) {
            const searcher = createSearcher(query, this.options);
            const {
                keys,
                records
            } = this._myIndex;
            const results = [];

            // List is Array<Object>
            records.forEach(({
                                 $: item,
                                 i: idx
                             }) => {
                if (!isDefined(item)) {
                    return;
                }
                let matches = [];

                // Iterate over every key (i.e, path), and fetch the value at that key
                keys.forEach((key, keyIndex) => {
                    matches.push(...this._findMatches({
                        key,
                        value: item[keyIndex],
                        searcher
                    }));
                });
                if (matches.length) {
                    results.push({
                        idx,
                        item,
                        matches
                    });
                }
            });
            return results;
        }
        _findMatches({
                         key,
                         value,
                         searcher
                     }) {
            if (!isDefined(value)) {
                return [];
            }
            let matches = [];
            if (isArray(value)) {
                value.forEach(({
                                   v: text,
                                   i: idx,
                                   n: norm
                               }) => {
                    if (!isDefined(text)) {
                        return;
                    }
                    const {
                        isMatch,
                        score,
                        indices
                    } = searcher.searchIn(text);
                    if (isMatch) {
                        matches.push({
                            score,
                            key,
                            value: text,
                            idx,
                            norm,
                            indices
                        });
                    }
                });
            } else {
                const {
                    v: text,
                    n: norm
                } = value;
                const {
                    isMatch,
                    score,
                    indices
                } = searcher.searchIn(text);
                if (isMatch) {
                    matches.push({
                        score,
                        key,
                        value: text,
                        norm,
                        indices
                    });
                }
            }
            return matches;
        }
    }
    Fuse.version = '7.0.0';
    Fuse.createIndex = createIndex;
    Fuse.parseIndex = parseIndex;
    Fuse.config = Config;
    {
        Fuse.parseQuery = parse;
    }
    {
        register(ExtendedSearch);
    }

    var SearchByFuse = /** @class */ (function () {
        function SearchByFuse(config) {
            this._haystack = [];
            this._fuseOptions = __assign(__assign({}, config.fuseOptions), { keys: __spreadArray([], config.searchFields, true), includeMatches: true });
        }
        SearchByFuse.prototype.index = function (data) {
            this._haystack = data;
            if (this._fuse) {
                this._fuse.setCollection(data);
            }
        };
        SearchByFuse.prototype.reset = function () {
            this._haystack = [];
            this._fuse = undefined;
        };
        SearchByFuse.prototype.isEmptyIndex = function () {
            return !this._haystack.length;
        };
        SearchByFuse.prototype.search = function (needle) {
            if (!this._fuse) {
                {
                    this._fuse = new Fuse(this._haystack, this._fuseOptions);
                }
            }
            var results = this._fuse.search(needle);
            return results.map(function (value, i) {
                return {
                    item: value.item,
                    score: value.score || 0,
                    rank: i + 1, // If value.score is used for sorting, this can create non-stable sorts!
                };
            });
        };
        return SearchByFuse;
    }());

    function getSearcher(config) {
        {
            return new SearchByFuse(config);
        }
    }

    /**
     * Helpers to create HTML elements used by Choices
     * Can be overridden by providing `callbackOnCreateTemplates` option.
     * `Choices.defaults.templates` allows access to the default template methods from `callbackOnCreateTemplates`
     */
    var isEmptyObject = function (obj) {
        // eslint-disable-next-line no-restricted-syntax
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return false;
            }
        }
        return true;
    };
    var assignCustomProperties = function (el, choice, withCustomProperties) {
        var dataset = el.dataset;
        var customProperties = choice.customProperties, labelClass = choice.labelClass, labelDescription = choice.labelDescription;
        if (labelClass) {
            dataset.labelClass = getClassNames(labelClass).join(' ');
        }
        if (labelDescription) {
            dataset.labelDescription = unwrapStringForRaw(labelDescription);
        }
        if (withCustomProperties && customProperties) {
            if (typeof customProperties === 'string') {
                dataset.customProperties = customProperties;
            }
            else if (typeof customProperties === 'object' && !isEmptyObject(customProperties)) {
                dataset.customProperties = JSON.stringify(customProperties);
            }
        }
    };
    var addAriaLabel = function (docRoot, id, element) {
        var label = id && docRoot.querySelector("label[for='".concat(id, "']"));
        var text = label && label.innerText;
        if (text) {
            element.setAttribute('aria-label', text);
        }
    };
    var templates = {
        containerOuter: function (_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
            var containerOuter = _a.classNames.containerOuter;
            var div = document.createElement('div');
            addClassesToElement(div, containerOuter);
            div.dataset.type = passedElementType;
            if (dir) {
                div.dir = dir;
            }
            if (isSelectOneElement) {
                div.tabIndex = 0;
            }
            if (isSelectElement) {
                div.setAttribute('role', searchEnabled ? 'combobox' : 'listbox');
                if (searchEnabled) {
                    div.setAttribute('aria-autocomplete', 'list');
                }
                else if (!labelId) {
                    addAriaLabel(this._docRoot, this.passedElement.element.id, div);
                }
                div.setAttribute('aria-haspopup', 'true');
                div.setAttribute('aria-expanded', 'false');
            }
            if (labelId) {
                div.setAttribute('aria-labelledby', labelId);
            }
            return div;
        },
        containerInner: function (_a) {
            var containerInner = _a.classNames.containerInner;
            var div = document.createElement('div');
            addClassesToElement(div, containerInner);
            return div;
        },
        itemList: function (_a, isSelectOneElement) {
            var searchEnabled = _a.searchEnabled, _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
            var div = document.createElement('div');
            addClassesToElement(div, list);
            addClassesToElement(div, isSelectOneElement ? listSingle : listItems);
            if (this._isSelectElement && searchEnabled) {
                div.setAttribute('role', 'listbox');
            }
            return div;
        },
        placeholder: function (_a, value) {
            var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
            var div = document.createElement('div');
            addClassesToElement(div, placeholder);
            setElementHtml(div, allowHTML, value);
            return div;
        },
        item: function (_a, choice, removeItemButton) {
            var allowHTML = _a.allowHTML, removeItemButtonAlignLeft = _a.removeItemButtonAlignLeft, removeItemIconText = _a.removeItemIconText, removeItemLabelText = _a.removeItemLabelText, _b = _a.classNames, item = _b.item, button = _b.button, highlightedState = _b.highlightedState, itemSelectable = _b.itemSelectable, placeholder = _b.placeholder;
            var rawValue = unwrapStringForRaw(choice.value);
            var div = document.createElement('div');
            addClassesToElement(div, item);
            if (choice.labelClass) {
                var spanLabel = document.createElement('span');
                setElementHtml(spanLabel, allowHTML, choice.label);
                addClassesToElement(spanLabel, choice.labelClass);
                div.appendChild(spanLabel);
            }
            else {
                setElementHtml(div, allowHTML, choice.label);
            }
            div.dataset.item = '';
            div.dataset.id = choice.id;
            div.dataset.value = rawValue;
            assignCustomProperties(div, choice, true);
            if (choice.disabled || this.containerOuter.isDisabled) {
                div.setAttribute('aria-disabled', 'true');
            }
            if (this._isSelectElement) {
                div.setAttribute('aria-selected', 'true');
                div.setAttribute('role', 'option');
            }
            if (choice.placeholder) {
                addClassesToElement(div, placeholder);
                div.dataset.placeholder = '';
            }
            addClassesToElement(div, choice.highlighted ? highlightedState : itemSelectable);
            if (removeItemButton) {
                if (choice.disabled) {
                    removeClassesFromElement(div, itemSelectable);
                }
                div.dataset.deletable = '';
                var removeButton = document.createElement('button');
                removeButton.type = 'button';
                addClassesToElement(removeButton, button);
                var eventChoice = getChoiceForOutput(choice);
                setElementHtml(removeButton, true, resolveNoticeFunction(removeItemIconText, choice.value, eventChoice));
                var REMOVE_ITEM_LABEL = resolveNoticeFunction(removeItemLabelText, choice.value, eventChoice);
                if (REMOVE_ITEM_LABEL) {
                    removeButton.setAttribute('aria-label', REMOVE_ITEM_LABEL);
                }
                removeButton.dataset.button = '';
                if (removeItemButtonAlignLeft) {
                    div.insertAdjacentElement('afterbegin', removeButton);
                }
                else {
                    div.appendChild(removeButton);
                }
            }
            return div;
        },
        choiceList: function (_a, isSelectOneElement) {
            var list = _a.classNames.list;
            var div = document.createElement('div');
            addClassesToElement(div, list);
            if (!isSelectOneElement) {
                div.setAttribute('aria-multiselectable', 'true');
            }
            div.setAttribute('role', 'listbox');
            return div;
        },
        choiceGroup: function (_a, _b) {
            var allowHTML = _a.allowHTML, _c = _a.classNames, group = _c.group, groupHeading = _c.groupHeading, itemDisabled = _c.itemDisabled;
            var id = _b.id, label = _b.label, disabled = _b.disabled;
            var rawLabel = unwrapStringForRaw(label);
            var div = document.createElement('div');
            addClassesToElement(div, group);
            if (disabled) {
                addClassesToElement(div, itemDisabled);
            }
            div.setAttribute('role', 'group');
            div.dataset.group = '';
            div.dataset.id = id;
            div.dataset.value = rawLabel;
            if (disabled) {
                div.setAttribute('aria-disabled', 'true');
            }
            var heading = document.createElement('div');
            addClassesToElement(heading, groupHeading);
            setElementHtml(heading, allowHTML, label || '');
            div.appendChild(heading);
            return div;
        },
        choice: function (_a, choice, selectText, groupName) {
            var allowHTML = _a.allowHTML, _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, itemSelectable = _b.itemSelectable, selectedState = _b.selectedState, itemDisabled = _b.itemDisabled, description = _b.description, placeholder = _b.placeholder;
            // eslint-disable-next-line prefer-destructuring
            var label = choice.label;
            var rawValue = unwrapStringForRaw(choice.value);
            var div = document.createElement('div');
            div.id = choice.elementId;
            addClassesToElement(div, item);
            addClassesToElement(div, itemChoice);
            if (groupName && typeof label === 'string') {
                label = escapeForTemplate(allowHTML, label);
                label += " (".concat(groupName, ")");
                label = { trusted: label };
            }
            var describedBy = div;
            if (choice.labelClass) {
                var spanLabel = document.createElement('span');
                setElementHtml(spanLabel, allowHTML, label);
                addClassesToElement(spanLabel, choice.labelClass);
                describedBy = spanLabel;
                div.appendChild(spanLabel);
            }
            else {
                setElementHtml(div, allowHTML, label);
            }
            if (choice.labelDescription) {
                var descId = "".concat(choice.elementId, "-description");
                describedBy.setAttribute('aria-describedby', descId);
                var spanDesc = document.createElement('span');
                setElementHtml(spanDesc, allowHTML, choice.labelDescription);
                spanDesc.id = descId;
                addClassesToElement(spanDesc, description);
                div.appendChild(spanDesc);
            }
            if (choice.selected) {
                addClassesToElement(div, selectedState);
            }
            if (choice.placeholder) {
                addClassesToElement(div, placeholder);
            }
            div.setAttribute('role', choice.group ? 'treeitem' : 'option');
            div.dataset.choice = '';
            div.dataset.id = choice.id;
            div.dataset.value = rawValue;
            if (selectText) {
                div.dataset.selectText = selectText;
            }
            if (choice.group) {
                div.dataset.groupId = "".concat(choice.group.id);
            }
            assignCustomProperties(div, choice, false);
            if (choice.disabled) {
                addClassesToElement(div, itemDisabled);
                div.dataset.choiceDisabled = '';
                div.setAttribute('aria-disabled', 'true');
            }
            else {
                addClassesToElement(div, itemSelectable);
                div.dataset.choiceSelectable = '';
                div.setAttribute('aria-selected', choice.selected ? 'true' : 'false');
            }
            return div;
        },
        input: function (_a, placeholderValue) {
            var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned, labelId = _a.labelId;
            var inp = document.createElement('input');
            inp.type = 'search';
            addClassesToElement(inp, input);
            addClassesToElement(inp, inputCloned);
            inp.autocomplete = 'off';
            inp.autocapitalize = 'off';
            inp.spellcheck = false;
            inp.setAttribute('aria-autocomplete', 'list');
            if (placeholderValue) {
                inp.setAttribute('aria-label', placeholderValue);
            }
            else if (!labelId) {
                addAriaLabel(this._docRoot, this.passedElement.element.id, inp);
            }
            return inp;
        },
        dropdown: function (_a) {
            var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
            var div = document.createElement('div');
            addClassesToElement(div, list);
            addClassesToElement(div, listDropdown);
            div.setAttribute('aria-expanded', 'false');
            return div;
        },
        notice: function (_a, innerHTML, type) {
            var _b = _a.classNames, item = _b.item, itemChoice = _b.itemChoice, addChoice = _b.addChoice, noResults = _b.noResults, noChoices = _b.noChoices, noticeItem = _b.notice;
            if (type === void 0) { type = NoticeTypes.generic; }
            var notice = document.createElement('div');
            setElementHtml(notice, true, innerHTML);
            addClassesToElement(notice, item);
            addClassesToElement(notice, itemChoice);
            addClassesToElement(notice, noticeItem);
            // eslint-disable-next-line default-case
            switch (type) {
                case NoticeTypes.addChoice:
                    addClassesToElement(notice, addChoice);
                    break;
                case NoticeTypes.noResults:
                    addClassesToElement(notice, noResults);
                    break;
                case NoticeTypes.noChoices:
                    addClassesToElement(notice, noChoices);
                    break;
            }
            if (type === NoticeTypes.addChoice) {
                notice.dataset.choiceSelectable = '';
                notice.dataset.choice = '';
            }
            return notice;
        },
        option: function (choice) {
            // HtmlOptionElement's label value does not support HTML, so the avoid double escaping unwrap the untrusted string.
            var labelValue = unwrapStringForRaw(choice.label);
            var opt = new Option(labelValue, choice.value, false, choice.selected);
            assignCustomProperties(opt, choice, true);
            opt.disabled = choice.disabled;
            if (choice.selected) {
                opt.setAttribute('selected', '');
            }
            return opt;
        },
    };

    /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */
    var IS_IE11 = '-ms-scroll-limit' in document.documentElement.style &&
        '-ms-ime-align' in document.documentElement.style;
    var USER_DEFAULTS = {};
    var parseDataSetId = function (element) {
        if (!element) {
            return undefined;
        }
        return element.dataset.id ? parseInt(element.dataset.id, 10) : undefined;
    };
    var selectableChoiceIdentifier = '[data-choice-selectable]';
    /**
     * Choices
     * @author Josh Johnson<josh@joshuajohnson.co.uk>
     */
    var Choices = /** @class */ (function () {
        function Choices(element, userConfig) {
            if (element === void 0) { element = '[data-choice]'; }
            if (userConfig === void 0) { userConfig = {}; }
            var _this = this;
            this.initialisedOK = undefined;
            this._hasNonChoicePlaceholder = false;
            this._lastAddedChoiceId = 0;
            this._lastAddedGroupId = 0;
            var defaults = Choices.defaults;
            this.config = __assign(__assign(__assign({}, defaults.allOptions), defaults.options), userConfig);
            ObjectsInConfig.forEach(function (key) {
                _this.config[key] = __assign(__assign(__assign({}, defaults.allOptions[key]), defaults.options[key]), userConfig[key]);
            });
            var config = this.config;
            if (!config.silent) {
                this._validateConfig();
            }
            var docRoot = config.shadowRoot || document.documentElement;
            this._docRoot = docRoot;
            var passedElement = typeof element === 'string' ? docRoot.querySelector(element) : element;
            if (!passedElement ||
                typeof passedElement !== 'object' ||
                !(isHtmlInputElement(passedElement) || isHtmlSelectElement(passedElement))) {
                if (!passedElement && typeof element === 'string') {
                    throw TypeError("Selector ".concat(element, " failed to find an element"));
                }
                throw TypeError("Expected one of the following types text|select-one|select-multiple");
            }
            var elementType = passedElement.type;
            var isText = elementType === PassedElementTypes.Text;
            if (isText || config.maxItemCount !== 1) {
                config.singleModeForMultiSelect = false;
            }
            if (config.singleModeForMultiSelect) {
                elementType = PassedElementTypes.SelectMultiple;
            }
            var isSelectOne = elementType === PassedElementTypes.SelectOne;
            var isSelectMultiple = elementType === PassedElementTypes.SelectMultiple;
            var isSelect = isSelectOne || isSelectMultiple;
            this._elementType = elementType;
            this._isTextElement = isText;
            this._isSelectOneElement = isSelectOne;
            this._isSelectMultipleElement = isSelectMultiple;
            this._isSelectElement = isSelectOne || isSelectMultiple;
            this._canAddUserChoices = (isText && config.addItems) || (isSelect && config.addChoices);
            if (typeof config.renderSelectedChoices !== 'boolean') {
                config.renderSelectedChoices = config.renderSelectedChoices === 'always' || isSelectOne;
            }
            if (config.closeDropdownOnSelect === 'auto') {
                config.closeDropdownOnSelect = isText || isSelectOne || config.singleModeForMultiSelect;
            }
            else {
                config.closeDropdownOnSelect = coerceBool(config.closeDropdownOnSelect);
            }
            if (config.placeholder) {
                if (config.placeholderValue) {
                    this._hasNonChoicePlaceholder = true;
                }
                else if (passedElement.dataset.placeholder) {
                    this._hasNonChoicePlaceholder = true;
                    config.placeholderValue = passedElement.dataset.placeholder;
                }
            }
            if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== 'function') {
                var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                config.addItemFilter = re.test.bind(re);
            }
            if (this._isTextElement) {
                this.passedElement = new WrappedInput({
                    element: passedElement,
                    classNames: config.classNames,
                });
            }
            else {
                var selectEl = passedElement;
                this.passedElement = new WrappedSelect({
                    element: selectEl,
                    classNames: config.classNames,
                    template: function (data) { return _this._templates.option(data); },
                    extractPlaceholder: config.placeholder && !this._hasNonChoicePlaceholder,
                });
            }
            this.initialised = false;
            this._store = new Store(config);
            this._currentValue = '';
            config.searchEnabled = !isText && config.searchEnabled;
            this._canSearch = config.searchEnabled;
            this._isScrollingOnIe = false;
            this._highlightPosition = 0;
            this._wasTap = true;
            this._placeholderValue = this._generatePlaceholderValue();
            this._baseId = generateId(passedElement, 'choices-');
            /**
             * setting direction in cases where it's explicitly set on passedElement
             * or when calculated direction is different from the document
             */
            this._direction = passedElement.dir;
            if (!this._direction) {
                var elementDirection = window.getComputedStyle(passedElement).direction;
                var documentDirection = window.getComputedStyle(document.documentElement).direction;
                if (elementDirection !== documentDirection) {
                    this._direction = elementDirection;
                }
            }
            this._idNames = {
                itemChoice: 'item-choice',
            };
            this._templates = defaults.templates;
            this._render = this._render.bind(this);
            this._onFocus = this._onFocus.bind(this);
            this._onBlur = this._onBlur.bind(this);
            this._onKeyUp = this._onKeyUp.bind(this);
            this._onKeyDown = this._onKeyDown.bind(this);
            this._onInput = this._onInput.bind(this);
            this._onClick = this._onClick.bind(this);
            this._onTouchMove = this._onTouchMove.bind(this);
            this._onTouchEnd = this._onTouchEnd.bind(this);
            this._onMouseDown = this._onMouseDown.bind(this);
            this._onMouseOver = this._onMouseOver.bind(this);
            this._onFormReset = this._onFormReset.bind(this);
            this._onSelectKey = this._onSelectKey.bind(this);
            this._onEnterKey = this._onEnterKey.bind(this);
            this._onEscapeKey = this._onEscapeKey.bind(this);
            this._onDirectionKey = this._onDirectionKey.bind(this);
            this._onDeleteKey = this._onDeleteKey.bind(this);
            this._onChange = this._onChange.bind(this);
            this._onInvalid = this._onInvalid.bind(this);
            // If element has already been initialised with Choices, fail silently
            if (this.passedElement.isActive) {
                if (!config.silent) {
                    console.warn('Trying to initialise Choices on element already initialised', { element: element });
                }
                this.initialised = true;
                this.initialisedOK = false;
                return;
            }
            // Let's go
            this.init();
            // preserve the selected item list after setup for form reset
            this._initialItems = this._store.items.map(function (choice) { return choice.value; });
        }
        Object.defineProperty(Choices, "defaults", {
            get: function () {
                return Object.preventExtensions({
                    get options() {
                        return USER_DEFAULTS;
                    },
                    get allOptions() {
                        return DEFAULT_CONFIG;
                    },
                    get templates() {
                        return templates;
                    },
                });
            },
            enumerable: false,
            configurable: true
        });
        Choices.prototype.init = function () {
            if (this.initialised || this.initialisedOK !== undefined) {
                return;
            }
            this._searcher = getSearcher(this.config);
            this._loadChoices();
            this._createTemplates();
            this._createElements();
            this._createStructure();
            if ((this._isTextElement && !this.config.addItems) ||
                this.passedElement.element.hasAttribute('disabled') ||
                !!this.passedElement.element.closest('fieldset:disabled')) {
                this.disable();
            }
            else {
                this.enable();
                this._addEventListeners();
            }
            // should be triggered **after** disabled state to avoid additional re-draws
            this._initStore();
            this.initialised = true;
            this.initialisedOK = true;
            var callbackOnInit = this.config.callbackOnInit;
            // Run callback if it is a function
            if (typeof callbackOnInit === 'function') {
                callbackOnInit.call(this);
            }
        };
        Choices.prototype.destroy = function () {
            if (!this.initialised) {
                return;
            }
            this._removeEventListeners();
            this.passedElement.reveal();
            this.containerOuter.unwrap(this.passedElement.element);
            this._store._listeners = []; // prevents select/input value being wiped
            this.clearStore(false);
            this._stopSearch();
            this._templates = Choices.defaults.templates;
            this.initialised = false;
            this.initialisedOK = undefined;
        };
        Choices.prototype.enable = function () {
            if (this.passedElement.isDisabled) {
                this.passedElement.enable();
            }
            if (this.containerOuter.isDisabled) {
                this._addEventListeners();
                this.input.enable();
                this.containerOuter.enable();
            }
            return this;
        };
        Choices.prototype.disable = function () {
            if (!this.passedElement.isDisabled) {
                this.passedElement.disable();
            }
            if (!this.containerOuter.isDisabled) {
                this._removeEventListeners();
                this.input.disable();
                this.containerOuter.disable();
            }
            return this;
        };
        Choices.prototype.highlightItem = function (item, runEvent) {
            if (runEvent === void 0) { runEvent = true; }
            if (!item || !item.id) {
                return this;
            }
            var choice = this._store.items.find(function (c) { return c.id === item.id; });
            if (!choice || choice.highlighted) {
                return this;
            }
            this._store.dispatch(highlightItem(choice, true));
            if (runEvent) {
                this.passedElement.triggerEvent(EventType.highlightItem, getChoiceForOutput(choice));
            }
            return this;
        };
        Choices.prototype.unhighlightItem = function (item, runEvent) {
            if (runEvent === void 0) { runEvent = true; }
            if (!item || !item.id) {
                return this;
            }
            var choice = this._store.items.find(function (c) { return c.id === item.id; });
            if (!choice || !choice.highlighted) {
                return this;
            }
            this._store.dispatch(highlightItem(choice, false));
            if (runEvent) {
                this.passedElement.triggerEvent(EventType.unhighlightItem, getChoiceForOutput(choice));
            }
            return this;
        };
        Choices.prototype.highlightAll = function () {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.forEach(function (item) {
                    if (!item.highlighted) {
                        _this._store.dispatch(highlightItem(item, true));
                        _this.passedElement.triggerEvent(EventType.highlightItem, getChoiceForOutput(item));
                    }
                });
            });
            return this;
        };
        Choices.prototype.unhighlightAll = function () {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.forEach(function (item) {
                    if (item.highlighted) {
                        _this._store.dispatch(highlightItem(item, false));
                        _this.passedElement.triggerEvent(EventType.highlightItem, getChoiceForOutput(item));
                    }
                });
            });
            return this;
        };
        Choices.prototype.removeActiveItemsByValue = function (value) {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.filter(function (item) { return item.value === value; }).forEach(function (item) { return _this._removeItem(item); });
            });
            return this;
        };
        Choices.prototype.removeActiveItems = function (excludedId) {
            var _this = this;
            this._store.withTxn(function () {
                _this._store.items.filter(function (_a) {
                    var id = _a.id;
                    return id !== excludedId;
                }).forEach(function (item) { return _this._removeItem(item); });
            });
            return this;
        };
        Choices.prototype.removeHighlightedItems = function (runEvent) {
            var _this = this;
            if (runEvent === void 0) { runEvent = false; }
            this._store.withTxn(function () {
                _this._store.highlightedActiveItems.forEach(function (item) {
                    _this._removeItem(item);
                    // If this action was performed by the user
                    // trigger the event
                    if (runEvent) {
                        _this._triggerChange(item.value);
                    }
                });
            });
            return this;
        };
        Choices.prototype.showDropdown = function (preventInputFocus) {
            var _this = this;
            if (this.dropdown.isActive) {
                return this;
            }
            if (preventInputFocus === undefined) {
                // eslint-disable-next-line no-param-reassign
                preventInputFocus = !this._canSearch;
            }
            requestAnimationFrame(function () {
                _this.dropdown.show();
                var rect = _this.dropdown.element.getBoundingClientRect();
                _this.containerOuter.open(rect.bottom, rect.height);
                if (!preventInputFocus) {
                    _this.input.focus();
                }
                _this.passedElement.triggerEvent(EventType.showDropdown);
                var activeElement = _this.choiceList.element.querySelector(getClassNamesSelector(_this.config.classNames.selectedState));
                if (activeElement !== null && !isScrolledIntoView(activeElement, _this.choiceList.element)) {
                    // We use the native scrollIntoView function instead of choiceList.scrollToChildElement to avoid animated scroll.
                    activeElement.scrollIntoView();
                }
            });
            return this;
        };
        Choices.prototype.hideDropdown = function (preventInputBlur) {
            var _this = this;
            if (!this.dropdown.isActive) {
                return this;
            }
            this._removeHighlightedChoices();
            requestAnimationFrame(function () {
                _this.dropdown.hide();
                _this.containerOuter.close();
                if (!preventInputBlur && _this._canSearch) {
                    _this.input.removeActiveDescendant();
                    _this.input.blur();
                }
                _this.passedElement.triggerEvent(EventType.hideDropdown);
            });
            return this;
        };
        Choices.prototype.getValue = function (valueOnly) {
            var values = this._store.items.map(function (item) {
                return (valueOnly ? item.value : getChoiceForOutput(item));
            });
            return this._isSelectOneElement || this.config.singleModeForMultiSelect ? values[0] : values;
        };
        Choices.prototype.setValue = function (items) {
            var _this = this;
            if (!this.initialisedOK) {
                this._warnChoicesInitFailed('setValue');
                return this;
            }
            this._store.withTxn(function () {
                items.forEach(function (value) {
                    if (value) {
                        _this._addChoice(mapInputToChoice(value, false));
                    }
                });
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        Choices.prototype.setChoiceByValue = function (value) {
            var _this = this;
            if (!this.initialisedOK) {
                this._warnChoicesInitFailed('setChoiceByValue');
                return this;
            }
            if (this._isTextElement) {
                return this;
            }
            this._store.withTxn(function () {
                // If only one value has been passed, convert to array
                var choiceValue = Array.isArray(value) ? value : [value];
                // Loop through each value and
                choiceValue.forEach(function (val) { return _this._findAndSelectChoiceByValue(val); });
                _this.unhighlightAll();
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        /**
         * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
         * a value field name and a label field name.
         * This behaves the same as passing items via the choices option but can be called after initialising Choices.
         * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
         * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
         *
         * **Input types affected:** select-one, select-multiple
         *
         * @example
         * ```js
         * const example = new Choices(element);
         *
         * example.setChoices([
         *   {value: 'One', label: 'Label One', disabled: true},
         *   {value: 'Two', label: 'Label Two', selected: true},
         *   {value: 'Three', label: 'Label Three'},
         * ], 'value', 'label', false);
         * ```
         *
         * @example
         * ```js
         * const example = new Choices(element);
         *
         * example.setChoices(async () => {
         *   try {
         *      const items = await fetch('/items');
         *      return items.json()
         *   } catch(err) {
         *      console.error(err)
         *   }
         * });
         * ```
         *
         * @example
         * ```js
         * const example = new Choices(element);
         *
         * example.setChoices([{
         *   label: 'Group one',
         *   id: 1,
         *   disabled: false,
         *   choices: [
         *     {value: 'Child One', label: 'Child One', selected: true},
         *     {value: 'Child Two', label: 'Child Two',  disabled: true},
         *     {value: 'Child Three', label: 'Child Three'},
         *   ]
         * },
         * {
         *   label: 'Group two',
         *   id: 2,
         *   disabled: false,
         *   choices: [
         *     {value: 'Child Four', label: 'Child Four', disabled: true},
         *     {value: 'Child Five', label: 'Child Five'},
         *     {value: 'Child Six', label: 'Child Six', customProperties: {
         *       description: 'Custom description about child six',
         *       random: 'Another random custom property'
         *     }},
         *   ]
         * }], 'value', 'label', false);
         * ```
         */
        Choices.prototype.setChoices = function (choicesArrayOrFetcher, value, label, replaceChoices, clearSearchFlag, replaceItems) {
            var _this = this;
            if (choicesArrayOrFetcher === void 0) { choicesArrayOrFetcher = []; }
            if (value === void 0) { value = 'value'; }
            if (label === void 0) { label = 'label'; }
            if (replaceChoices === void 0) { replaceChoices = false; }
            if (clearSearchFlag === void 0) { clearSearchFlag = true; }
            if (replaceItems === void 0) { replaceItems = false; }
            if (!this.initialisedOK) {
                this._warnChoicesInitFailed('setChoices');
                return this;
            }
            if (!this._isSelectElement) {
                throw new TypeError("setChoices can't be used with INPUT based Choices");
            }
            if (typeof value !== 'string' || !value) {
                throw new TypeError("value parameter must be a name of 'value' field in passed objects");
            }
            if (typeof choicesArrayOrFetcher === 'function') {
                // it's a choices fetcher function
                var fetcher_1 = choicesArrayOrFetcher(this);
                if (typeof Promise === 'function' && fetcher_1 instanceof Promise) {
                    // that's a promise
                    // eslint-disable-next-line no-promise-executor-return
                    return new Promise(function (resolve) { return requestAnimationFrame(resolve); })
                        .then(function () { return _this._handleLoadingState(true); })
                        .then(function () { return fetcher_1; })
                        .then(function (data) {
                            return _this.setChoices(data, value, label, replaceChoices, clearSearchFlag, replaceItems);
                        })
                        .catch(function (err) {
                            if (!_this.config.silent) {
                                console.error(err);
                            }
                        })
                        .then(function () { return _this._handleLoadingState(false); })
                        .then(function () { return _this; });
                }
                // function returned something else than promise, let's check if it's an array of choices
                if (!Array.isArray(fetcher_1)) {
                    throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                }
                // recursion with results, it's sync and choices were cleared already
                return this.setChoices(fetcher_1, value, label, false);
            }
            if (!Array.isArray(choicesArrayOrFetcher)) {
                throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
            }
            this.containerOuter.removeLoadingState();
            this._store.withTxn(function () {
                if (clearSearchFlag) {
                    _this._isSearching = false;
                }
                // Clear choices if needed
                if (replaceChoices) {
                    _this.clearChoices(true, replaceItems);
                }
                var isDefaultValue = value === 'value';
                var isDefaultLabel = label === 'label';
                choicesArrayOrFetcher.forEach(function (groupOrChoice) {
                    if ('choices' in groupOrChoice) {
                        var group = groupOrChoice;
                        if (!isDefaultLabel) {
                            group = __assign(__assign({}, group), { label: group[label] });
                        }
                        _this._addGroup(mapInputToChoice(group, true));
                    }
                    else {
                        var choice = groupOrChoice;
                        if (!isDefaultLabel || !isDefaultValue) {
                            choice = __assign(__assign({}, choice), { value: choice[value], label: choice[label] });
                        }
                        var choiceFull = mapInputToChoice(choice, false);
                        _this._addChoice(choiceFull);
                        if (choiceFull.placeholder && !_this._hasNonChoicePlaceholder) {
                            _this._placeholderValue = unwrapStringForEscaped(choiceFull.label);
                        }
                    }
                });
                _this.unhighlightAll();
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        Choices.prototype.refresh = function (withEvents, selectFirstOption, deselectAll) {
            var _this = this;
            if (withEvents === void 0) { withEvents = false; }
            if (selectFirstOption === void 0) { selectFirstOption = false; }
            if (deselectAll === void 0) { deselectAll = false; }
            if (!this._isSelectElement) {
                if (!this.config.silent) {
                    console.warn('refresh method can only be used on choices backed by a <select> element');
                }
                return this;
            }
            this._store.withTxn(function () {
                var choicesFromOptions = _this.passedElement.optionsAsChoices();
                // Build the list of items which require preserving
                var existingItems = {};
                if (!deselectAll) {
                    _this._store.items.forEach(function (choice) {
                        if (choice.id && choice.active && choice.selected) {
                            existingItems[choice.value] = true;
                        }
                    });
                }
                _this.clearStore(false);
                var updateChoice = function (choice) {
                    if (deselectAll) {
                        _this._store.dispatch(removeItem$1(choice));
                    }
                    else if (existingItems[choice.value]) {
                        choice.selected = true;
                    }
                };
                choicesFromOptions.forEach(function (groupOrChoice) {
                    if ('choices' in groupOrChoice) {
                        groupOrChoice.choices.forEach(updateChoice);
                        return;
                    }
                    updateChoice(groupOrChoice);
                });
                /* @todo only generate add events for the added options instead of all
                if (withEvents) {
                  items.forEach((choice) => {
                    if (existingItems[choice.value]) {
                      this.passedElement.triggerEvent(
                        EventType.removeItem,
                        this._getChoiceForEvent(choice),
                      );
                    }
                  });
                }
                */
                // load new choices & items
                _this._addPredefinedChoices(choicesFromOptions, selectFirstOption, withEvents);
                // re-do search if required
                if (_this._isSearching) {
                    _this._searchChoices(_this.input.value);
                }
            });
            return this;
        };
        Choices.prototype.removeChoice = function (value) {
            var choice = this._store.choices.find(function (c) { return c.value === value; });
            if (!choice) {
                return this;
            }
            this._clearNotice();
            this._store.dispatch(removeChoice(choice));
            // @todo integrate with Store
            this._searcher.reset();
            if (choice.selected) {
                this.passedElement.triggerEvent(EventType.removeItem, getChoiceForOutput(choice));
            }
            return this;
        };
        Choices.prototype.clearChoices = function (clearOptions, clearItems) {
            var _this = this;
            if (clearOptions === void 0) { clearOptions = true; }
            if (clearItems === void 0) { clearItems = false; }
            if (clearOptions) {
                if (clearItems) {
                    this.passedElement.element.replaceChildren('');
                }
                else {
                    this.passedElement.element.querySelectorAll(':not([selected])').forEach(function (el) {
                        el.remove();
                    });
                }
            }
            this.itemList.element.replaceChildren('');
            this.choiceList.element.replaceChildren('');
            this._clearNotice();
            this._store.withTxn(function () {
                var items = clearItems ? [] : _this._store.items;
                _this._store.reset();
                items.forEach(function (item) {
                    _this._store.dispatch(addChoice(item));
                    _this._store.dispatch(addItem(item));
                });
            });
            // @todo integrate with Store
            this._searcher.reset();
            return this;
        };
        Choices.prototype.clearStore = function (clearOptions) {
            if (clearOptions === void 0) { clearOptions = true; }
            this.clearChoices(clearOptions, true);
            this._stopSearch();
            this._lastAddedChoiceId = 0;
            this._lastAddedGroupId = 0;
            return this;
        };
        Choices.prototype.clearInput = function () {
            var shouldSetInputWidth = !this._isSelectOneElement;
            this.input.clear(shouldSetInputWidth);
            this._stopSearch();
            return this;
        };
        Choices.prototype._validateConfig = function () {
            var config = this.config;
            var invalidConfigOptions = diff(config, DEFAULT_CONFIG);
            if (invalidConfigOptions.length) {
                console.warn('Unknown config option(s) passed', invalidConfigOptions.join(', '));
            }
            if (config.allowHTML && config.allowHtmlUserInput) {
                if (config.addItems) {
                    console.warn('Warning: allowHTML/allowHtmlUserInput/addItems all being true is strongly not recommended and may lead to XSS attacks');
                }
                if (config.addChoices) {
                    console.warn('Warning: allowHTML/allowHtmlUserInput/addChoices all being true is strongly not recommended and may lead to XSS attacks');
                }
            }
        };
        Choices.prototype._render = function (changes) {
            if (changes === void 0) { changes = { choices: true, groups: true, items: true }; }
            if (this._store.inTxn()) {
                return;
            }
            if (this._isSelectElement) {
                if (changes.choices || changes.groups) {
                    this._renderChoices();
                }
            }
            if (changes.items) {
                this._renderItems();
            }
        };
        Choices.prototype._renderChoices = function () {
            var _this = this;
            if (!this._canAddItems()) {
                return; // block rendering choices if the input limit is reached.
            }
            var _a = this, config = _a.config, isSearching = _a._isSearching;
            var _b = this._store, activeGroups = _b.activeGroups, activeChoices = _b.activeChoices;
            var renderLimit = isSearching ? config.searchResultLimit : config.renderChoiceLimit;
            if (this._isSelectElement) {
                var backingOptions = activeChoices.filter(function (choice) { return !choice.element; });
                if (backingOptions.length) {
                    this.passedElement.addOptions(backingOptions);
                }
            }
            var fragment = document.createDocumentFragment();
            var renderableChoices = function (choices) {
                return choices.filter(function (choice) {
                    return !choice.placeholder &&
                        (isSearching
                            ? (config.searchRenderSelectedChoices || !choice.selected) && !!choice.rank
                            : config.renderSelectedChoices || !choice.selected);
                });
            };
            var showLabel = config.appendGroupInSearch && isSearching;
            var selectableChoices = false;
            var highlightedEl = null;
            var renderChoices = function (choices, withinGroup) {
                if (isSearching) {
                    // sortByRank is used to ensure stable sorting, as scores are non-unique
                    // this additionally ensures fuseOptions.sortFn is not ignored
                    choices.sort(sortByRank);
                }
                else if (config.shouldSort) {
                    choices.sort(config.sorter);
                }
                var choiceLimit = choices.length;
                choiceLimit = !withinGroup && renderLimit > 0 && choiceLimit > renderLimit ? renderLimit : choiceLimit;
                choiceLimit--;
                choices.every(function (choice, index) {
                    // choiceEl being empty signals the contents has probably significantly changed
                    var dropdownItem = choice.choiceEl ||
                        _this._templates.choice(config, choice, config.itemSelectText, showLabel && choice.group ? choice.group.label : undefined);
                    choice.choiceEl = dropdownItem;
                    fragment.appendChild(dropdownItem);
                    if (isSearching || !choice.selected) {
                        selectableChoices = true;
                    }
                    else if (!highlightedEl) {
                        highlightedEl = dropdownItem;
                    }
                    return index < choiceLimit;
                });
            };
            if (activeChoices.length) {
                if (config.resetScrollPosition) {
                    requestAnimationFrame(function () { return _this.choiceList.scrollToTop(); });
                }
                if (!this._hasNonChoicePlaceholder && !isSearching && this._isSelectOneElement) {
                    // If we have a placeholder choice along with groups
                    renderChoices(activeChoices.filter(function (choice) { return choice.placeholder && !choice.group; }), false);
                }
                // If we have grouped options
                if (activeGroups.length && !isSearching) {
                    if (config.shouldSort) {
                        activeGroups.sort(config.sorter);
                    }
                    // render Choices without group first, regardless of sort, otherwise they won't be distinguishable
                    // from the last group
                    renderChoices(activeChoices.filter(function (choice) { return !choice.placeholder && !choice.group; }), false);
                    activeGroups.forEach(function (group) {
                        var groupChoices = renderableChoices(group.choices);
                        if (groupChoices.length) {
                            if (group.label) {
                                var dropdownGroup = group.groupEl || _this._templates.choiceGroup(_this.config, group);
                                group.groupEl = dropdownGroup;
                                dropdownGroup.remove();
                                fragment.appendChild(dropdownGroup);
                            }
                            renderChoices(groupChoices, true);
                        }
                    });
                }
                else {
                    renderChoices(renderableChoices(activeChoices), false);
                }
            }
            if (!selectableChoices && (isSearching || !fragment.children.length || !config.renderSelectedChoices)) {
                if (!this._notice) {
                    this._notice = {
                        text: resolveStringFunction(isSearching ? config.noResultsText : config.noChoicesText),
                        type: isSearching ? NoticeTypes.noResults : NoticeTypes.noChoices,
                    };
                }
                fragment.replaceChildren('');
            }
            this._renderNotice(fragment);
            this.choiceList.element.replaceChildren(fragment);
            this._highlightChoice(highlightedEl);
        };
        Choices.prototype._renderItems = function () {
            var _this = this;
            var items = this._store.items || [];
            var itemList = this.itemList.element;
            var config = this.config;
            var fragment = document.createDocumentFragment();
            var itemFromList = function (item) {
                return itemList.querySelector("[data-item][data-id=\"".concat(item.id, "\"]"));
            };
            var addItemToFragment = function (item) {
                var el = item.itemEl;
                if (el && el.parentElement) {
                    return;
                }
                el = itemFromList(item) || _this._templates.item(config, item, config.removeItemButton);
                item.itemEl = el;
                fragment.appendChild(el);
            };
            // new items
            items.forEach(addItemToFragment);
            var addedItems = !!fragment.childNodes.length;
            if (this._isSelectOneElement) {
                var existingItems = itemList.children.length;
                if (addedItems || existingItems > 1) {
                    var placeholder = itemList.querySelector(getClassNamesSelector(config.classNames.placeholder));
                    if (placeholder) {
                        placeholder.remove();
                    }
                }
                else if (!addedItems && !existingItems && this._placeholderValue) {
                    addedItems = true;
                    addItemToFragment(mapInputToChoice({
                        selected: true,
                        value: '',
                        label: this._placeholderValue,
                        placeholder: true,
                    }, false));
                }
            }
            if (addedItems) {
                itemList.append(fragment);
                if (config.shouldSortItems && !this._isSelectOneElement) {
                    items.sort(config.sorter);
                    // push sorting into the DOM
                    items.forEach(function (item) {
                        var el = itemFromList(item);
                        if (el) {
                            el.remove();
                            fragment.append(el);
                        }
                    });
                    itemList.append(fragment);
                }
            }
            if (this._isTextElement) {
                // Update the value of the hidden input
                this.passedElement.value = items.map(function (_a) {
                    var value = _a.value;
                    return value;
                }).join(config.delimiter);
            }
        };
        Choices.prototype._displayNotice = function (text, type, openDropdown) {
            if (openDropdown === void 0) { openDropdown = true; }
            var oldNotice = this._notice;
            if (oldNotice &&
                ((oldNotice.type === type && oldNotice.text === text) ||
                    (oldNotice.type === NoticeTypes.addChoice &&
                        (type === NoticeTypes.noResults || type === NoticeTypes.noChoices)))) {
                if (openDropdown) {
                    this.showDropdown(true);
                }
                return;
            }
            this._clearNotice();
            this._notice = text
                ? {
                    text: text,
                    type: type,
                }
                : undefined;
            this._renderNotice();
            if (openDropdown && text) {
                this.showDropdown(true);
            }
        };
        Choices.prototype._clearNotice = function () {
            if (!this._notice) {
                return;
            }
            var noticeElement = this.choiceList.element.querySelector(getClassNamesSelector(this.config.classNames.notice));
            if (noticeElement) {
                noticeElement.remove();
            }
            this._notice = undefined;
        };
        Choices.prototype._renderNotice = function (fragment) {
            var noticeConf = this._notice;
            if (noticeConf) {
                var notice = this._templates.notice(this.config, noticeConf.text, noticeConf.type);
                if (fragment) {
                    fragment.append(notice);
                }
                else {
                    this.choiceList.prepend(notice);
                }
            }
        };
        /**
         * @deprecated Use utils.getChoiceForOutput
         */
        // eslint-disable-next-line class-methods-use-this
        Choices.prototype._getChoiceForOutput = function (choice, keyCode) {
            return getChoiceForOutput(choice, keyCode);
        };
        Choices.prototype._triggerChange = function (value) {
            if (value === undefined || value === null) {
                return;
            }
            this.passedElement.triggerEvent(EventType.change, {
                value: value,
            });
        };
        Choices.prototype._handleButtonAction = function (element) {
            var _this = this;
            var items = this._store.items;
            if (!items.length || !this.config.removeItems || !this.config.removeItemButton) {
                return;
            }
            var id = element && parseDataSetId(element.closest('[data-id]'));
            var itemToRemove = id && items.find(function (item) { return item.id === id; });
            if (!itemToRemove) {
                return;
            }
            this._store.withTxn(function () {
                // Remove item associated with button
                _this._removeItem(itemToRemove);
                _this._triggerChange(itemToRemove.value);
                if (_this._isSelectOneElement && !_this._hasNonChoicePlaceholder) {
                    var placeholderChoice = (_this.config.shouldSort ? _this._store.choices.reverse() : _this._store.choices).find(function (choice) { return choice.placeholder; });
                    if (placeholderChoice) {
                        _this._addItem(placeholderChoice);
                        _this.unhighlightAll();
                        if (placeholderChoice.value) {
                            _this._triggerChange(placeholderChoice.value);
                        }
                    }
                }
            });
        };
        Choices.prototype._handleItemAction = function (element, hasShiftKey) {
            var _this = this;
            if (hasShiftKey === void 0) { hasShiftKey = false; }
            var items = this._store.items;
            if (!items.length || !this.config.removeItems || this._isSelectOneElement) {
                return;
            }
            var id = parseDataSetId(element);
            if (!id) {
                return;
            }
            // We only want to select one item with a click
            // so we deselect any items that aren't the target
            // unless shift is being pressed
            items.forEach(function (item) {
                if (item.id === id && !item.highlighted) {
                    _this.highlightItem(item);
                }
                else if (!hasShiftKey && item.highlighted) {
                    _this.unhighlightItem(item);
                }
            });
            // Focus input as without focus, a user cannot do anything with a
            // highlighted item
            this.input.focus();
        };
        Choices.prototype._handleChoiceAction = function (element) {
            var _this = this;
            // If we are clicking on an option
            var id = parseDataSetId(element);
            var choice = id && this._store.getChoiceById(id);
            if (!choice || choice.disabled) {
                return false;
            }
            var hasActiveDropdown = this.dropdown.isActive;
            if (!choice.selected) {
                if (!this._canAddItems()) {
                    return true; // causes _onEnterKey to early out
                }
                this._store.withTxn(function () {
                    _this._addItem(choice, true, true);
                    _this.clearInput();
                    _this.unhighlightAll();
                });
                this._triggerChange(choice.value);
            }
            // We want to close the dropdown if we are dealing with a single select box
            if (hasActiveDropdown && this.config.closeDropdownOnSelect) {
                this.hideDropdown(true);
                this.containerOuter.element.focus();
            }
            return true;
        };
        Choices.prototype._handleBackspace = function (items) {
            var config = this.config;
            if (!config.removeItems || !items.length) {
                return;
            }
            var lastItem = items[items.length - 1];
            var hasHighlightedItems = items.some(function (item) { return item.highlighted; });
            // If editing the last item is allowed and there are not other selected items,
            // we can edit the item value. Otherwise if we can remove items, remove all selected items
            if (config.editItems && !hasHighlightedItems && lastItem) {
                this.input.value = lastItem.value;
                this.input.setWidth();
                this._removeItem(lastItem);
                this._triggerChange(lastItem.value);
            }
            else {
                if (!hasHighlightedItems) {
                    // Highlight last item if none already highlighted
                    this.highlightItem(lastItem, false);
                }
                this.removeHighlightedItems(true);
            }
        };
        Choices.prototype._loadChoices = function () {
            var _a;
            var _this = this;
            var config = this.config;
            if (this._isTextElement) {
                // Assign preset items from passed object first
                this._presetChoices = config.items.map(function (e) { return mapInputToChoice(e, false); });
                // Add any values passed from attribute
                if (this.passedElement.value) {
                    var elementItems = this.passedElement.value
                        .split(config.delimiter)
                        .map(function (e) { return mapInputToChoice(e, false, _this.config.allowHtmlUserInput); });
                    this._presetChoices = this._presetChoices.concat(elementItems);
                }
                this._presetChoices.forEach(function (choice) {
                    choice.selected = true;
                });
            }
            else if (this._isSelectElement) {
                // Assign preset choices from passed object
                this._presetChoices = config.choices.map(function (e) { return mapInputToChoice(e, true); });
                // Create array of choices from option elements
                var choicesFromOptions = this.passedElement.optionsAsChoices();
                if (choicesFromOptions) {
                    (_a = this._presetChoices).push.apply(_a, choicesFromOptions);
                }
            }
        };
        Choices.prototype._handleLoadingState = function (setLoading) {
            if (setLoading === void 0) { setLoading = true; }
            var el = this.itemList.element;
            if (setLoading) {
                this.disable();
                this.containerOuter.addLoadingState();
                if (this._isSelectOneElement) {
                    el.replaceChildren(this._templates.placeholder(this.config, this.config.loadingText));
                }
                else {
                    this.input.placeholder = this.config.loadingText;
                }
            }
            else {
                this.enable();
                this.containerOuter.removeLoadingState();
                if (this._isSelectOneElement) {
                    el.replaceChildren('');
                    this._render();
                }
                else {
                    this.input.placeholder = this._placeholderValue || '';
                }
            }
        };
        Choices.prototype._handleSearch = function (value) {
            if (!this.input.isFocussed) {
                return;
            }
            // Check that we have a value to search and the input was an alphanumeric character
            if (value !== null && typeof value !== 'undefined' && value.length >= this.config.searchFloor) {
                var resultCount = this.config.searchChoices ? this._searchChoices(value) : 0;
                if (resultCount !== null) {
                    // Trigger search event
                    this.passedElement.triggerEvent(EventType.search, {
                        value: value,
                        resultCount: resultCount,
                    });
                }
            }
            else if (this._store.choices.some(function (option) { return !option.active; })) {
                this._stopSearch();
            }
        };
        Choices.prototype._canAddItems = function () {
            var config = this.config;
            var maxItemCount = config.maxItemCount, maxItemText = config.maxItemText;
            if (!config.singleModeForMultiSelect && maxItemCount > 0 && maxItemCount <= this._store.items.length) {
                this.choiceList.element.replaceChildren('');
                this._notice = undefined;
                this._displayNotice(typeof maxItemText === 'function' ? maxItemText(maxItemCount) : maxItemText, NoticeTypes.addChoice);
                return false;
            }
            if (this._notice && this._notice.type === NoticeTypes.addChoice) {
                this._clearNotice();
            }
            return true;
        };
        Choices.prototype._canCreateItem = function (value) {
            var config = this.config;
            var canAddItem = true;
            var notice = '';
            if (canAddItem && typeof config.addItemFilter === 'function' && !config.addItemFilter(value)) {
                canAddItem = false;
                notice = resolveNoticeFunction(config.customAddItemText, value, undefined);
            }
            if (canAddItem) {
                var foundChoice = this._store.choices.find(function (choice) { return config.valueComparer(choice.value, value); });
                if (foundChoice) {
                    if (this._isSelectElement) {
                        // for exact matches, do not prompt to add it as a custom choice
                        this._displayNotice('', NoticeTypes.addChoice);
                        return false;
                    }
                    if (!config.duplicateItemsAllowed) {
                        canAddItem = false;
                        notice = resolveNoticeFunction(config.uniqueItemText, value, undefined);
                    }
                }
            }
            if (canAddItem) {
                notice = resolveNoticeFunction(config.addItemText, value, undefined);
            }
            if (notice) {
                this._displayNotice(notice, NoticeTypes.addChoice);
            }
            return canAddItem;
        };
        Choices.prototype._searchChoices = function (value) {
            var newValue = value.trim().replace(/\s{2,}/, ' ');
            // signal input didn't change search
            if (!newValue.length || newValue === this._currentValue) {
                return null;
            }
            var searcher = this._searcher;
            if (searcher.isEmptyIndex()) {
                searcher.index(this._store.searchableChoices);
            }
            // If new value matches the desired length and is not the same as the current value with a space
            var results = searcher.search(newValue);
            this._currentValue = newValue;
            this._highlightPosition = 0;
            this._isSearching = true;
            var notice = this._notice;
            var noticeType = notice && notice.type;
            if (noticeType !== NoticeTypes.addChoice) {
                if (!results.length) {
                    this._displayNotice(resolveStringFunction(this.config.noResultsText), NoticeTypes.noResults);
                }
                else {
                    this._clearNotice();
                }
            }
            this._store.dispatch(filterChoices(results));
            return results.length;
        };
        Choices.prototype._stopSearch = function () {
            if (this._isSearching) {
                this._currentValue = '';
                this._isSearching = false;
                this._clearNotice();
                this._store.dispatch(activateChoices(true));
                this.passedElement.triggerEvent(EventType.search, {
                    value: '',
                    resultCount: 0,
                });
            }
        };
        Choices.prototype._addEventListeners = function () {
            var documentElement = this._docRoot;
            var outerElement = this.containerOuter.element;
            var inputElement = this.input.element;
            var passedElement = this.passedElement.element;
            // capture events - can cancel event processing or propagation
            documentElement.addEventListener('touchend', this._onTouchEnd, true);
            outerElement.addEventListener('keydown', this._onKeyDown, true);
            outerElement.addEventListener('mousedown', this._onMouseDown, true);
            // passive events - doesn't call `preventDefault` or `stopPropagation`
            documentElement.addEventListener('click', this._onClick, { passive: true });
            documentElement.addEventListener('touchmove', this._onTouchMove, {
                passive: true,
            });
            this.dropdown.element.addEventListener('mouseover', this._onMouseOver, {
                passive: true,
            });
            if (this._isSelectOneElement) {
                outerElement.addEventListener('focus', this._onFocus, {
                    passive: true,
                });
                outerElement.addEventListener('blur', this._onBlur, {
                    passive: true,
                });
            }
            inputElement.addEventListener('keyup', this._onKeyUp, {
                passive: true,
            });
            inputElement.addEventListener('input', this._onInput, {
                passive: true,
            });
            inputElement.addEventListener('focus', this._onFocus, {
                passive: true,
            });
            inputElement.addEventListener('blur', this._onBlur, {
                passive: true,
            });
            if (inputElement.form) {
                inputElement.form.addEventListener('reset', this._onFormReset, {
                    passive: true,
                });
            }
            if (passedElement.hasAttribute('required')) {
                passedElement.addEventListener('change', this._onChange, {
                    passive: true,
                });
                passedElement.addEventListener('invalid', this._onInvalid, {
                    passive: true,
                });
            }
            this.input.addEventListeners();
        };
        Choices.prototype._removeEventListeners = function () {
            var documentElement = this._docRoot;
            var outerElement = this.containerOuter.element;
            var inputElement = this.input.element;
            var passedElement = this.passedElement.element;
            documentElement.removeEventListener('touchend', this._onTouchEnd, true);
            outerElement.removeEventListener('keydown', this._onKeyDown, true);
            outerElement.removeEventListener('mousedown', this._onMouseDown, true);
            documentElement.removeEventListener('click', this._onClick);
            documentElement.removeEventListener('touchmove', this._onTouchMove);
            this.dropdown.element.removeEventListener('mouseover', this._onMouseOver);
            if (this._isSelectOneElement) {
                outerElement.removeEventListener('focus', this._onFocus);
                outerElement.removeEventListener('blur', this._onBlur);
            }
            inputElement.removeEventListener('keyup', this._onKeyUp);
            inputElement.removeEventListener('input', this._onInput);
            inputElement.removeEventListener('focus', this._onFocus);
            inputElement.removeEventListener('blur', this._onBlur);
            if (inputElement.form) {
                inputElement.form.removeEventListener('reset', this._onFormReset);
            }
            if (passedElement.hasAttribute('required')) {
                passedElement.removeEventListener('change', this._onChange);
                passedElement.removeEventListener('invalid', this._onInvalid);
            }
            this.input.removeEventListeners();
        };
        Choices.prototype._onKeyDown = function (event) {
            var keyCode = event.keyCode;
            var hasActiveDropdown = this.dropdown.isActive;
            /*
            See:
            https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
            https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
            https://en.wikipedia.org/wiki/UTF-16#Code_points_from_U+010000_to_U+10FFFF - UTF-16 surrogate pairs
            https://stackoverflow.com/a/70866532 - "Unidentified" for mobile
            http://www.unicode.org/versions/Unicode5.2.0/ch16.pdf#G19635 - U+FFFF is reserved (Section 16.7)

            Logic: when a key event is sent, `event.key` represents its printable value _or_ one
            of a large list of special values indicating meta keys/functionality. In addition,
            key events for compose functionality contain a value of `Dead` when mid-composition.

            I can't quite verify it, but non-English IMEs may also be able to generate key codes
            for code points in the surrogate-pair range, which could potentially be seen as having
            key.length > 1. Since `Fn` is one of the special keys, we can't distinguish by that
            alone.

            Here, key.length === 1 means we know for sure the input was printable and not a special
            `key` value. When the length is greater than 1, it could be either a printable surrogate
            pair or a special `key` value. We can tell the difference by checking if the _character
            code_ value (not code point!) is in the "surrogate pair" range or not.

            We don't use .codePointAt because an invalid code point would return 65535, which wouldn't
            pass the >= 0x10000 check we would otherwise use.

            > ...The Unicode Standard sets aside 66 noncharacter code points. The last two code points
            > of each plane are noncharacters: U+FFFE and U+FFFF on the BMP...
            */
            var wasPrintableChar = event.key.length === 1 ||
                (event.key.length === 2 && event.key.charCodeAt(0) >= 0xd800) ||
                event.key === 'Unidentified';
            /*
              We do not show the dropdown if focusing out with esc or navigating through input fields.
              An activated search can still be opened with any other key.
             */
            if (!this._isTextElement &&
                !hasActiveDropdown &&
                keyCode !== KeyCodeMap.ESC_KEY &&
                keyCode !== KeyCodeMap.TAB_KEY &&
                keyCode !== KeyCodeMap.SHIFT_KEY) {
                this.showDropdown();
                if (!this.input.isFocussed && wasPrintableChar) {
                    /*
                      We update the input value with the pressed key as
                      the input was not focussed at the time of key press
                      therefore does not have the value of the key.
                    */
                    this.input.value += event.key;
                    // browsers interpret a space as pagedown
                    if (event.key === ' ') {
                        event.preventDefault();
                    }
                }
            }
            switch (keyCode) {
                case KeyCodeMap.A_KEY:
                    return this._onSelectKey(event, this.itemList.element.hasChildNodes());
                case KeyCodeMap.ENTER_KEY:
                    return this._onEnterKey(event, hasActiveDropdown);
                case KeyCodeMap.ESC_KEY:
                    return this._onEscapeKey(event, hasActiveDropdown);
                case KeyCodeMap.UP_KEY:
                case KeyCodeMap.PAGE_UP_KEY:
                case KeyCodeMap.DOWN_KEY:
                case KeyCodeMap.PAGE_DOWN_KEY:
                    return this._onDirectionKey(event, hasActiveDropdown);
                case KeyCodeMap.DELETE_KEY:
                case KeyCodeMap.BACK_KEY:
                    return this._onDeleteKey(event, this._store.items, this.input.isFocussed);
            }
        };
        Choices.prototype._onKeyUp = function ( /* event: KeyboardEvent */) {
            this._canSearch = this.config.searchEnabled;
        };
        Choices.prototype._onInput = function ( /* event: InputEvent */) {
            var value = this.input.value;
            if (!value) {
                if (this._isTextElement) {
                    this.hideDropdown(true);
                }
                else {
                    this._stopSearch();
                }
                return;
            }
            if (!this._canAddItems()) {
                return;
            }
            if (this._canSearch) {
                // do the search even if the entered text can not be added
                this._handleSearch(value);
            }
            if (!this._canAddUserChoices) {
                return;
            }
            // determine if a notice needs to be displayed for why a search result can't be added
            this._canCreateItem(value);
            if (this._isSelectElement) {
                this._highlightPosition = 0; // reset to select the notice and/or exact match
                this._highlightChoice();
            }
        };
        Choices.prototype._onSelectKey = function (event, hasItems) {
            // If CTRL + A or CMD + A have been pressed and there are items to select
            if ((event.ctrlKey || event.metaKey) && hasItems) {
                this._canSearch = false;
                var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                if (shouldHightlightAll) {
                    this.highlightAll();
                }
            }
        };
        Choices.prototype._onEnterKey = function (event, hasActiveDropdown) {
            var _this = this;
            var value = this.input.value;
            var target = event.target;
            event.preventDefault();
            if (target && target.hasAttribute('data-button')) {
                this._handleButtonAction(target);
                return;
            }
            if (!hasActiveDropdown) {
                if (this._isSelectElement || this._notice) {
                    this.showDropdown();
                }
                return;
            }
            var highlightedChoice = this.dropdown.element.querySelector(getClassNamesSelector(this.config.classNames.highlightedState));
            if (highlightedChoice && this._handleChoiceAction(highlightedChoice)) {
                return;
            }
            if (!target || !value) {
                this.hideDropdown(true);
                return;
            }
            if (!this._canAddItems()) {
                return;
            }
            var addedItem = false;
            this._store.withTxn(function () {
                addedItem = _this._findAndSelectChoiceByValue(value, true);
                if (!addedItem) {
                    if (!_this._canAddUserChoices) {
                        return;
                    }
                    if (!_this._canCreateItem(value)) {
                        return;
                    }
                    _this._addChoice(mapInputToChoice(value, false, _this.config.allowHtmlUserInput), true, true);
                    addedItem = true;
                }
                _this.clearInput();
                _this.unhighlightAll();
            });
            if (!addedItem) {
                return;
            }
            this._triggerChange(value);
            if (this.config.closeDropdownOnSelect) {
                this.hideDropdown(true);
            }
        };
        Choices.prototype._onEscapeKey = function (event, hasActiveDropdown) {
            if (hasActiveDropdown) {
                event.stopPropagation();
                this.hideDropdown(true);
                this._stopSearch();
                this.containerOuter.element.focus();
            }
        };
        Choices.prototype._onDirectionKey = function (event, hasActiveDropdown) {
            var keyCode = event.keyCode;
            // If up or down key is pressed, traverse through options
            if (hasActiveDropdown || this._isSelectOneElement) {
                this.showDropdown();
                this._canSearch = false;
                var directionInt = keyCode === KeyCodeMap.DOWN_KEY || keyCode === KeyCodeMap.PAGE_DOWN_KEY ? 1 : -1;
                var skipKey = event.metaKey || keyCode === KeyCodeMap.PAGE_DOWN_KEY || keyCode === KeyCodeMap.PAGE_UP_KEY;
                var nextEl = void 0;
                if (skipKey) {
                    if (directionInt > 0) {
                        nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                    }
                    else {
                        nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                    }
                }
                else {
                    var currentEl = this.dropdown.element.querySelector(getClassNamesSelector(this.config.classNames.highlightedState));
                    if (currentEl) {
                        nextEl = getAdjacentEl(currentEl, selectableChoiceIdentifier, directionInt);
                    }
                    else {
                        nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                    }
                }
                if (nextEl) {
                    // We prevent default to stop the cursor moving
                    // when pressing the arrow
                    if (!isScrolledIntoView(nextEl, this.choiceList.element, directionInt)) {
                        this.choiceList.scrollToChildElement(nextEl, directionInt);
                    }
                    this._highlightChoice(nextEl);
                }
                // Prevent default to maintain cursor position whilst
                // traversing dropdown options
                event.preventDefault();
            }
        };
        Choices.prototype._onDeleteKey = function (event, items, hasFocusedInput) {
            // If backspace or delete key is pressed and the input has no value
            if (!this._isSelectOneElement && !event.target.value && hasFocusedInput) {
                this._handleBackspace(items);
                event.preventDefault();
            }
        };
        Choices.prototype._onTouchMove = function () {
            if (this._wasTap) {
                this._wasTap = false;
            }
        };
        Choices.prototype._onTouchEnd = function (event) {
            var target = (event || event.touches[0]).target;
            var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
            if (touchWasWithinContainer) {
                var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                if (containerWasExactTarget) {
                    if (this._isTextElement) {
                        this.input.focus();
                    }
                    else if (this._isSelectMultipleElement) {
                        this.showDropdown();
                    }
                }
                // Prevents focus event firing
                event.stopPropagation();
            }
            this._wasTap = true;
        };
        /**
         * Handles mousedown event in capture mode for containetOuter.element
         */
        Choices.prototype._onMouseDown = function (event) {
            var target = event.target;
            if (!(target instanceof Element)) {
                return;
            }
            // If we have our mouse down on the scrollbar and are on IE11...
            if (IS_IE11 && this.choiceList.element.contains(target)) {
                // check if click was on a scrollbar area
                var firstChoice = this.choiceList.element.firstElementChild;
                this._isScrollingOnIe =
                    this._direction === 'ltr' ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
            }
            if (target === this.input.element) {
                return;
            }
            var item = target.closest('[data-button],[data-item],[data-choice]');
            if (item instanceof HTMLElement) {
                if ('button' in item.dataset) {
                    this._handleButtonAction(item);
                }
                else if ('item' in item.dataset) {
                    this._handleItemAction(item, event.shiftKey);
                }
                else if ('choice' in item.dataset) {
                    this._handleChoiceAction(item);
                }
            }
            event.preventDefault();
        };
        /**
         * Handles mouseover event over this.dropdown
         * @param {MouseEvent} event
         */
        Choices.prototype._onMouseOver = function (_a) {
            var target = _a.target;
            if (target instanceof HTMLElement && 'choice' in target.dataset) {
                this._highlightChoice(target);
            }
        };
        Choices.prototype._onClick = function (_a) {
            var target = _a.target;
            var containerOuter = this.containerOuter;
            var clickWasWithinContainer = containerOuter.element.contains(target);
            if (clickWasWithinContainer) {
                if (!this.dropdown.isActive && !containerOuter.isDisabled) {
                    if (this._isTextElement) {
                        if (document.activeElement !== this.input.element) {
                            this.input.focus();
                        }
                    }
                    else {
                        this.showDropdown();
                        containerOuter.element.focus();
                    }
                }
                else if (this._isSelectOneElement &&
                    target !== this.input.element &&
                    !this.dropdown.element.contains(target)) {
                    this.hideDropdown();
                }
            }
            else {
                containerOuter.removeFocusState();
                this.hideDropdown(true);
                this.unhighlightAll();
            }
        };
        Choices.prototype._onFocus = function (_a) {
            var target = _a.target;
            var containerOuter = this.containerOuter;
            var focusWasWithinContainer = target && containerOuter.element.contains(target);
            if (!focusWasWithinContainer) {
                return;
            }
            var targetIsInput = target === this.input.element;
            if (this._isTextElement) {
                if (targetIsInput) {
                    containerOuter.addFocusState();
                }
            }
            else if (this._isSelectMultipleElement) {
                if (targetIsInput) {
                    this.showDropdown(true);
                    // If element is a select box, the focused element is the container and the dropdown
                    // isn't already open, focus and show dropdown
                    containerOuter.addFocusState();
                }
            }
            else {
                containerOuter.addFocusState();
                if (targetIsInput) {
                    this.showDropdown(true);
                }
            }
        };
        Choices.prototype._onBlur = function (_a) {
            var target = _a.target;
            var containerOuter = this.containerOuter;
            var blurWasWithinContainer = target && containerOuter.element.contains(target);
            if (blurWasWithinContainer && !this._isScrollingOnIe) {
                if (target === this.input.element) {
                    containerOuter.removeFocusState();
                    this.hideDropdown(true);
                    if (this._isTextElement || this._isSelectMultipleElement) {
                        this.unhighlightAll();
                    }
                }
                else if (target === this.containerOuter.element) {
                    // Remove the focus state when the past outerContainer was the target
                    containerOuter.removeFocusState();
                    // Also close the dropdown if search is disabled
                    if (!this.config.searchEnabled) {
                        this.hideDropdown(true);
                    }
                }
            }
            else {
                // On IE11, clicking the scollbar blurs our input and thus
                // closes the dropdown. To stop this, we refocus our input
                // if we know we are on IE *and* are scrolling.
                this._isScrollingOnIe = false;
                this.input.element.focus();
            }
        };
        Choices.prototype._onFormReset = function () {
            var _this = this;
            this._store.withTxn(function () {
                _this.clearInput();
                _this.hideDropdown();
                _this.refresh(false, false, true);
                if (_this._initialItems.length) {
                    _this.setChoiceByValue(_this._initialItems);
                }
            });
        };
        Choices.prototype._onChange = function (event) {
            if (!event.target.checkValidity()) {
                return;
            }
            this.containerOuter.removeInvalidState();
        };
        Choices.prototype._onInvalid = function () {
            this.containerOuter.addInvalidState();
        };
        /**
         * Removes any highlighted choice options
         */
        Choices.prototype._removeHighlightedChoices = function () {
            var highlightedState = this.config.classNames.highlightedState;
            var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(getClassNamesSelector(highlightedState)));
            // Remove any highlighted choices
            highlightedChoices.forEach(function (choice) {
                removeClassesFromElement(choice, highlightedState);
                choice.setAttribute('aria-selected', 'false');
            });
        };
        Choices.prototype._highlightChoice = function (el) {
            if (el === void 0) { el = null; }
            var choices = Array.from(this.dropdown.element.querySelectorAll(selectableChoiceIdentifier));
            if (!choices.length) {
                return;
            }
            var passedEl = el;
            var highlightedState = this.config.classNames.highlightedState;
            this._removeHighlightedChoices();
            if (passedEl) {
                this._highlightPosition = choices.indexOf(passedEl);
            }
            else {
                // Highlight choice based on last known highlight location
                if (choices.length > this._highlightPosition) {
                    // If we have an option to highlight
                    passedEl = choices[this._highlightPosition];
                }
                else {
                    // Otherwise highlight the option before
                    passedEl = choices[choices.length - 1];
                }
                if (!passedEl) {
                    passedEl = choices[0];
                }
            }
            addClassesToElement(passedEl, highlightedState);
            passedEl.setAttribute('aria-selected', 'true');
            this.passedElement.triggerEvent(EventType.highlightChoice, {
                el: passedEl,
            });
            if (this.dropdown.isActive) {
                // IE11 ignores aria-label and blocks virtual keyboard
                // if aria-activedescendant is set without a dropdown
                this.input.setActiveDescendant(passedEl.id);
                this.containerOuter.setActiveDescendant(passedEl.id);
            }
        };
        Choices.prototype._addItem = function (item, withEvents, userTriggered) {
            if (withEvents === void 0) { withEvents = true; }
            if (userTriggered === void 0) { userTriggered = false; }
            if (!item.id) {
                throw new TypeError('item.id must be set before _addItem is called for a choice/item');
            }
            if (this.config.singleModeForMultiSelect || this._isSelectOneElement) {
                this.removeActiveItems(item.id);
            }
            this._store.dispatch(addItem(item));
            if (withEvents) {
                var eventChoice = getChoiceForOutput(item);
                this.passedElement.triggerEvent(EventType.addItem, eventChoice);
                if (userTriggered) {
                    this.passedElement.triggerEvent(EventType.choice, eventChoice);
                }
            }
        };
        Choices.prototype._removeItem = function (item) {
            if (!item.id) {
                return;
            }
            this._store.dispatch(removeItem$1(item));
            var notice = this._notice;
            if (notice && notice.type === NoticeTypes.noChoices) {
                this._clearNotice();
            }
            this.passedElement.triggerEvent(EventType.removeItem, getChoiceForOutput(item));
        };
        Choices.prototype._addChoice = function (choice, withEvents, userTriggered) {
            if (withEvents === void 0) { withEvents = true; }
            if (userTriggered === void 0) { userTriggered = false; }
            if (choice.id) {
                throw new TypeError('Can not re-add a choice which has already been added');
            }
            var config = this.config;
            if (!config.duplicateItemsAllowed && this._store.choices.find(function (c) { return config.valueComparer(c.value, choice.value); })) {
                return;
            }
            // Generate unique id, in-place update is required so chaining _addItem works as expected
            this._lastAddedChoiceId++;
            choice.id = this._lastAddedChoiceId;
            choice.elementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choice.id);
            var prependValue = config.prependValue, appendValue = config.appendValue;
            if (prependValue) {
                choice.value = prependValue + choice.value;
            }
            if (appendValue) {
                choice.value += appendValue.toString();
            }
            if ((prependValue || appendValue) && choice.element) {
                choice.element.value = choice.value;
            }
            this._clearNotice();
            this._store.dispatch(addChoice(choice));
            if (choice.selected) {
                this._addItem(choice, withEvents, userTriggered);
            }
        };
        Choices.prototype._addGroup = function (group, withEvents) {
            var _this = this;
            if (withEvents === void 0) { withEvents = true; }
            if (group.id) {
                throw new TypeError('Can not re-add a group which has already been added');
            }
            this._store.dispatch(addGroup(group));
            if (!group.choices) {
                return;
            }
            // add unique id for the group(s), and do not store the full list of choices in this group
            this._lastAddedGroupId++;
            group.id = this._lastAddedGroupId;
            group.choices.forEach(function (item) {
                item.group = group;
                if (group.disabled) {
                    item.disabled = true;
                }
                _this._addChoice(item, withEvents);
            });
        };
        Choices.prototype._createTemplates = function () {
            var _this = this;
            var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
            var userTemplates = {};
            if (typeof callbackOnCreateTemplates === 'function') {
                userTemplates = callbackOnCreateTemplates.call(this, strToEl, escapeForTemplate, getClassNames);
            }
            var templating = {};
            Object.keys(this._templates).forEach(function (name) {
                if (name in userTemplates) {
                    templating[name] = userTemplates[name].bind(_this);
                }
                else {
                    templating[name] = _this._templates[name].bind(_this);
                }
            });
            this._templates = templating;
        };
        Choices.prototype._createElements = function () {
            var templating = this._templates;
            var _a = this, config = _a.config, isSelectOneElement = _a._isSelectOneElement;
            var position = config.position, classNames = config.classNames;
            var elementType = this._elementType;
            this.containerOuter = new Container({
                element: templating.containerOuter(config, this._direction, this._isSelectElement, isSelectOneElement, config.searchEnabled, elementType, config.labelId),
                classNames: classNames,
                type: elementType,
                position: position,
            });
            this.containerInner = new Container({
                element: templating.containerInner(config),
                classNames: classNames,
                type: elementType,
                position: position,
            });
            this.input = new Input({
                element: templating.input(config, this._placeholderValue),
                classNames: classNames,
                type: elementType,
                preventPaste: !config.paste,
            });
            this.choiceList = new List({
                element: templating.choiceList(config, isSelectOneElement),
            });
            this.itemList = new List({
                element: templating.itemList(config, isSelectOneElement),
            });
            this.dropdown = new Dropdown({
                element: templating.dropdown(config),
                classNames: classNames,
                type: elementType,
            });
        };
        Choices.prototype._createStructure = function () {
            var _a = this, containerInner = _a.containerInner, containerOuter = _a.containerOuter, passedElement = _a.passedElement;
            var dropdownElement = this.dropdown.element;
            // Hide original element
            passedElement.conceal();
            // Wrap input in container preserving DOM ordering
            containerInner.wrap(passedElement.element);
            // Wrapper inner container with outer container
            containerOuter.wrap(containerInner.element);
            containerOuter.element.appendChild(containerInner.element);
            containerOuter.element.appendChild(dropdownElement);
            containerInner.element.appendChild(this.itemList.element);
            dropdownElement.appendChild(this.choiceList.element);
            if (this._isSelectOneElement) {
                this.input.placeholder = this.config.searchPlaceholderValue || '';
                if (this.config.searchEnabled) {
                    dropdownElement.insertBefore(this.input.element, dropdownElement.firstChild);
                }
            }
            else {
                if (!this._isSelectMultipleElement || this.config.searchEnabled) {
                    containerInner.element.appendChild(this.input.element);
                }
                if (this._placeholderValue) {
                    this.input.placeholder = this._placeholderValue;
                }
                this.input.setWidth();
            }
            this._highlightPosition = 0;
            this._isSearching = false;
        };
        Choices.prototype._initStore = function () {
            var _this = this;
            this._store.subscribe(this._render).withTxn(function () {
                _this._addPredefinedChoices(_this._presetChoices, _this._isSelectOneElement && !_this._hasNonChoicePlaceholder, false);
            });
            if (!this._store.choices.length || (this._isSelectOneElement && this._hasNonChoicePlaceholder)) {
                this._render();
            }
        };
        Choices.prototype._addPredefinedChoices = function (choices, selectFirstOption, withEvents) {
            var _this = this;
            if (selectFirstOption === void 0) { selectFirstOption = false; }
            if (withEvents === void 0) { withEvents = true; }
            if (selectFirstOption) {
                /**
                 * If there is a selected choice already or the choice is not the first in
                 * the array, add each choice normally.
                 *
                 * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
                 */
                var noSelectedChoices = choices.findIndex(function (choice) { return choice.selected; }) === -1;
                if (noSelectedChoices) {
                    choices.some(function (choice) {
                        if (choice.disabled || 'choices' in choice) {
                            return false;
                        }
                        choice.selected = true;
                        return true;
                    });
                }
            }
            choices.forEach(function (item) {
                if ('choices' in item) {
                    if (_this._isSelectElement) {
                        _this._addGroup(item, withEvents);
                    }
                }
                else {
                    _this._addChoice(item, withEvents);
                }
            });
        };
        Choices.prototype._findAndSelectChoiceByValue = function (value, userTriggered) {
            var _this = this;
            if (userTriggered === void 0) { userTriggered = false; }
            // Check 'value' property exists and the choice isn't already selected
            var foundChoice = this._store.choices.find(function (choice) { return _this.config.valueComparer(choice.value, value); });
            if (foundChoice && !foundChoice.disabled && !foundChoice.selected) {
                this._addItem(foundChoice, true, userTriggered);
                return true;
            }
            return false;
        };
        Choices.prototype._generatePlaceholderValue = function () {
            var config = this.config;
            if (!config.placeholder) {
                return null;
            }
            if (this._hasNonChoicePlaceholder) {
                return config.placeholderValue;
            }
            if (this._isSelectElement) {
                var placeholderOption = this.passedElement.placeholderOption;
                return placeholderOption ? placeholderOption.text : null;
            }
            return null;
        };
        Choices.prototype._warnChoicesInitFailed = function (caller) {
            if (this.config.silent) {
                return;
            }
            if (!this.initialised) {
                throw new TypeError("".concat(caller, " called on a non-initialised instance of Choices"));
            }
            else if (!this.initialisedOK) {
                throw new TypeError("".concat(caller, " called for an element which has multiple instances of Choices initialised on it"));
            }
        };
        Choices.version = '11.2.0';
        return Choices;
    }());

    return Choices;

}));

!function(e,a){"object"==typeof exports&&"undefined"!=typeof module?module.exports=a():"function"==typeof define&&define.amd?define(a):e.moment=a()}(this,function(){"use strict";var E;function c(){return E.apply(null,arguments)}function F(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function z(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function l(e,a){return Object.prototype.hasOwnProperty.call(e,a)}function N(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;for(var a in e)if(l(e,a))return;return 1}function L(e){return void 0===e}function J(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function R(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function C(e,a){for(var t=[],s=e.length,n=0;n<s;++n)t.push(a(e[n],n));return t}function I(e,a){for(var t in a)l(a,t)&&(e[t]=a[t]);return l(a,"toString")&&(e.toString=a.toString),l(a,"valueOf")&&(e.valueOf=a.valueOf),e}function U(e,a,t,s){return Na(e,a,t,s,!0).utc()}function Y(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function G(e){var a,t,s=e._d&&!isNaN(e._d.getTime());return s&&(a=Y(e),t=q.call(a.parsedDateParts,function(e){return null!=e}),s=a.overflow<0&&!a.empty&&!a.invalidEra&&!a.invalidMonth&&!a.invalidWeekday&&!a.weekdayMismatch&&!a.nullInput&&!a.invalidFormat&&!a.userInvalidated&&(!a.meridiem||a.meridiem&&t),e._strict)&&(s=s&&0===a.charsLeftOver&&0===a.unusedTokens.length&&void 0===a.bigHour),null!=Object.isFrozen&&Object.isFrozen(e)?s:(e._isValid=s,e._isValid)}function V(e){var a=U(NaN);return null!=e?I(Y(a),e):Y(a).userInvalidated=!0,a}var q=Array.prototype.some||function(e){for(var a=Object(this),t=a.length>>>0,s=0;s<t;s++)if(s in a&&e.call(this,a[s],s,a))return!0;return!1},B=c.momentProperties=[],K=!1;function Z(e,a){var t,s,n,r=B.length;if(L(a._isAMomentObject)||(e._isAMomentObject=a._isAMomentObject),L(a._i)||(e._i=a._i),L(a._f)||(e._f=a._f),L(a._l)||(e._l=a._l),L(a._strict)||(e._strict=a._strict),L(a._tzm)||(e._tzm=a._tzm),L(a._isUTC)||(e._isUTC=a._isUTC),L(a._offset)||(e._offset=a._offset),L(a._pf)||(e._pf=Y(a)),L(a._locale)||(e._locale=a._locale),0<r)for(t=0;t<r;t++)L(n=a[s=B[t]])||(e[s]=n);return e}function $(e){Z(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===K&&(K=!0,c.updateOffset(this),K=!1)}function Q(e){return e instanceof $||null!=e&&null!=e._isAMomentObject}function X(e){!1===c.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function e(r,d){var _=!0;return I(function(){if(null!=c.deprecationHandler&&c.deprecationHandler(null,r),_){for(var e,a,t=[],s=arguments.length,n=0;n<s;n++){if(e="","object"==typeof arguments[n]){for(a in e+="\n["+n+"] ",arguments[0])l(arguments[0],a)&&(e+=a+": "+arguments[0][a]+", ");e=e.slice(0,-2)}else e=arguments[n];t.push(e)}X(r+"\nArguments: "+Array.prototype.slice.call(t).join("")+"\n"+(new Error).stack),_=!1}return d.apply(this,arguments)},d)}var ee={};function ae(e,a){null!=c.deprecationHandler&&c.deprecationHandler(e,a),ee[e]||(X(a),ee[e]=!0)}function te(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function se(e,a){var t,s=I({},e);for(t in a)l(a,t)&&(z(e[t])&&z(a[t])?(s[t]={},I(s[t],e[t]),I(s[t],a[t])):null!=a[t]?s[t]=a[t]:delete s[t]);for(t in e)l(e,t)&&!l(a,t)&&z(e[t])&&(s[t]=I({},s[t]));return s}function ne(e){null!=e&&this.set(e)}c.suppressDeprecationWarnings=!1,c.deprecationHandler=null;var re=Object.keys||function(e){var a,t=[];for(a in e)l(e,a)&&t.push(a);return t};function de(e,a,t){var s=""+Math.abs(e);return(0<=e?t?"+":"":"-")+Math.pow(10,Math.max(0,a-s.length)).toString().substr(1)+s}var _e=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,ie=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,oe={},me={};function s(e,a,t,s){var n="string"==typeof s?function(){return this[s]()}:s;e&&(me[e]=n),a&&(me[a[0]]=function(){return de(n.apply(this,arguments),a[1],a[2])}),t&&(me[t]=function(){return this.localeData().ordinal(n.apply(this,arguments),e)})}function ue(e,a){return e.isValid()?(a=le(a,e.localeData()),oe[a]=oe[a]||function(s){for(var e,n=s.match(_e),a=0,r=n.length;a<r;a++)me[n[a]]?n[a]=me[n[a]]:n[a]=(e=n[a]).match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"");return function(e){for(var a="",t=0;t<r;t++)a+=te(n[t])?n[t].call(e,s):n[t];return a}}(a),oe[a](e)):e.localeData().invalidDate()}function le(e,a){var t=5;function s(e){return a.longDateFormat(e)||e}for(ie.lastIndex=0;0<=t&&ie.test(e);)e=e.replace(ie,s),ie.lastIndex=0,--t;return e}var Me={D:"date",dates:"date",date:"date",d:"day",days:"day",day:"day",e:"weekday",weekdays:"weekday",weekday:"weekday",E:"isoWeekday",isoweekdays:"isoWeekday",isoweekday:"isoWeekday",DDD:"dayOfYear",dayofyears:"dayOfYear",dayofyear:"dayOfYear",h:"hour",hours:"hour",hour:"hour",ms:"millisecond",milliseconds:"millisecond",millisecond:"millisecond",m:"minute",minutes:"minute",minute:"minute",M:"month",months:"month",month:"month",Q:"quarter",quarters:"quarter",quarter:"quarter",s:"second",seconds:"second",second:"second",gg:"weekYear",weekyears:"weekYear",weekyear:"weekYear",GG:"isoWeekYear",isoweekyears:"isoWeekYear",isoweekyear:"isoWeekYear",w:"week",weeks:"week",week:"week",W:"isoWeek",isoweeks:"isoWeek",isoweek:"isoWeek",y:"year",years:"year",year:"year"};function d(e){return"string"==typeof e?Me[e]||Me[e.toLowerCase()]:void 0}function he(e){var a,t,s={};for(t in e)l(e,t)&&(a=d(t))&&(s[a]=e[t]);return s}var ce={date:9,day:11,weekday:11,isoWeekday:11,dayOfYear:4,hour:13,millisecond:16,minute:14,month:8,quarter:7,second:15,weekYear:1,isoWeekYear:1,week:5,isoWeek:5,year:1};var Le=/\d/,a=/\d\d/,Ye=/\d{3}/,t=/\d{4}/,n=/[+-]?\d{6}/,r=/\d\d?/,ye=/\d\d\d\d?/,_=/\d\d\d\d\d\d?/,fe=/\d{1,3}/,i=/\d{1,4}/,o=/[+-]?\d{1,6}/,ke=/\d+/,pe=/[+-]?\d+/,De=/Z|[+-]\d\d:?\d\d/gi,Te=/Z|[+-]\d\d(?::?\d\d)?/gi,m=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,u=/^[1-9]\d?/,M=/^([1-9]\d|\d)/;function h(e,t,s){be[e]=te(t)?t:function(e,a){return e&&s?s:t}}function ge(e,a){return l(be,e)?be[e](a._strict,a._locale):new RegExp(we(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,a,t,s,n){return a||t||s||n})))}function we(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function y(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function f(e){var e=+e,a=0;return a=0!=e&&isFinite(e)?y(e):a}var be={},He={};function k(e,t){var a,s,n=t;for("string"==typeof e&&(e=[e]),J(t)&&(n=function(e,a){a[t]=f(e)}),s=e.length,a=0;a<s;a++)He[e[a]]=n}function Se(e,n){k(e,function(e,a,t,s){t._w=t._w||{},n(e,t._w,t,s)})}function ve(e){return e%4==0&&e%100!=0||e%400==0}var p=0,je=1,xe=2,D=3,Pe=4,Oe=5,We=6,Ae=7,Ee=8;function Fe(e){return ve(e)?366:365}s("Y",0,0,function(){var e=this.year();return e<=9999?de(e,4):"+"+e}),s(0,["YY",2],0,function(){return this.year()%100}),s(0,["YYYY",4],0,"year"),s(0,["YYYYY",5],0,"year"),s(0,["YYYYYY",6,!0],0,"year"),h("Y",pe),h("YY",r,a),h("YYYY",i,t),h("YYYYY",o,n),h("YYYYYY",o,n),k(["YYYYY","YYYYYY"],p),k("YYYY",function(e,a){a[p]=2===e.length?c.parseTwoDigitYear(e):f(e)}),k("YY",function(e,a){a[p]=c.parseTwoDigitYear(e)}),k("Y",function(e,a){a[p]=parseInt(e,10)}),c.parseTwoDigitYear=function(e){return f(e)+(68<f(e)?1900:2e3)};var T,ze=Ne("FullYear",!0);function Ne(a,t){return function(e){return null!=e?(Re(this,a,e),c.updateOffset(this,t),this):Je(this,a)}}function Je(e,a){if(!e.isValid())return NaN;var t=e._d,s=e._isUTC;switch(a){case"Milliseconds":return s?t.getUTCMilliseconds():t.getMilliseconds();case"Seconds":return s?t.getUTCSeconds():t.getSeconds();case"Minutes":return s?t.getUTCMinutes():t.getMinutes();case"Hours":return s?t.getUTCHours():t.getHours();case"Date":return s?t.getUTCDate():t.getDate();case"Day":return s?t.getUTCDay():t.getDay();case"Month":return s?t.getUTCMonth():t.getMonth();case"FullYear":return s?t.getUTCFullYear():t.getFullYear();default:return NaN}}function Re(e,a,t){var s,n,r;if(e.isValid()&&!isNaN(t)){switch(s=e._d,n=e._isUTC,a){case"Milliseconds":return n?s.setUTCMilliseconds(t):s.setMilliseconds(t);case"Seconds":return n?s.setUTCSeconds(t):s.setSeconds(t);case"Minutes":return n?s.setUTCMinutes(t):s.setMinutes(t);case"Hours":return n?s.setUTCHours(t):s.setHours(t);case"Date":return n?s.setUTCDate(t):s.setDate(t);case"FullYear":break;default:return}a=t,r=e.month(),e=29!==(e=e.date())||1!==r||ve(a)?e:28,n?s.setUTCFullYear(a,r,e):s.setFullYear(a,r,e)}}function Ce(e,a){var t;return isNaN(e)||isNaN(a)?NaN:(t=(a%(t=12)+t)%t,e+=(a-t)/12,1==t?ve(e)?29:28:31-t%7%2)}T=Array.prototype.indexOf||function(e){for(var a=0;a<this.length;++a)if(this[a]===e)return a;return-1},s("M",["MM",2],"Mo",function(){return this.month()+1}),s("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),s("MMMM",0,0,function(e){return this.localeData().months(this,e)}),h("M",r,u),h("MM",r,a),h("MMM",function(e,a){return a.monthsShortRegex(e)}),h("MMMM",function(e,a){return a.monthsRegex(e)}),k(["M","MM"],function(e,a){a[je]=f(e)-1}),k(["MMM","MMMM"],function(e,a,t,s){s=t._locale.monthsParse(e,s,t._strict);null!=s?a[je]=s:Y(t).invalidMonth=e});var Ie="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Ue="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Ge=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Ve=m,qe=m;function Be(e,a){if(e.isValid()){if("string"==typeof a)if(/^\d+$/.test(a))a=f(a);else if(!J(a=e.localeData().monthsParse(a)))return;var t=(t=e.date())<29?t:Math.min(t,Ce(e.year(),a));e._isUTC?e._d.setUTCMonth(a,t):e._d.setMonth(a,t)}}function Ke(e){return null!=e?(Be(this,e),c.updateOffset(this,!0),this):Je(this,"Month")}function Ze(){function e(e,a){return a.length-e.length}for(var a,t,s=[],n=[],r=[],d=0;d<12;d++)t=U([2e3,d]),a=we(this.monthsShort(t,"")),t=we(this.months(t,"")),s.push(a),n.push(t),r.push(t),r.push(a);s.sort(e),n.sort(e),r.sort(e),this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+n.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function $e(e,a,t,s,n,r,d){var _;return e<100&&0<=e?(_=new Date(e+400,a,t,s,n,r,d),isFinite(_.getFullYear())&&_.setFullYear(e)):_=new Date(e,a,t,s,n,r,d),_}function Qe(e){var a;return e<100&&0<=e?((a=Array.prototype.slice.call(arguments))[0]=e+400,a=new Date(Date.UTC.apply(null,a)),isFinite(a.getUTCFullYear())&&a.setUTCFullYear(e)):a=new Date(Date.UTC.apply(null,arguments)),a}function Xe(e,a,t){t=7+a-t;return t-(7+Qe(e,0,t).getUTCDay()-a)%7-1}function ea(e,a,t,s,n){var r,a=1+7*(a-1)+(7+t-s)%7+Xe(e,s,n),t=a<=0?Fe(r=e-1)+a:a>Fe(e)?(r=e+1,a-Fe(e)):(r=e,a);return{year:r,dayOfYear:t}}function aa(e,a,t){var s,n,r=Xe(e.year(),a,t),r=Math.floor((e.dayOfYear()-r-1)/7)+1;return r<1?s=r+ta(n=e.year()-1,a,t):r>ta(e.year(),a,t)?(s=r-ta(e.year(),a,t),n=e.year()+1):(n=e.year(),s=r),{week:s,year:n}}function ta(e,a,t){var s=Xe(e,a,t),a=Xe(e+1,a,t);return(Fe(e)-s+a)/7}s("w",["ww",2],"wo","week"),s("W",["WW",2],"Wo","isoWeek"),h("w",r,u),h("ww",r,a),h("W",r,u),h("WW",r,a),Se(["w","ww","W","WW"],function(e,a,t,s){a[s.substr(0,1)]=f(e)});function sa(e,a){return e.slice(a,7).concat(e.slice(0,a))}s("d",0,"do","day"),s("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),s("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),s("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),s("e",0,0,"weekday"),s("E",0,0,"isoWeekday"),h("d",r),h("e",r),h("E",r),h("dd",function(e,a){return a.weekdaysMinRegex(e)}),h("ddd",function(e,a){return a.weekdaysShortRegex(e)}),h("dddd",function(e,a){return a.weekdaysRegex(e)}),Se(["dd","ddd","dddd"],function(e,a,t,s){s=t._locale.weekdaysParse(e,s,t._strict);null!=s?a.d=s:Y(t).invalidWeekday=e}),Se(["d","e","E"],function(e,a,t,s){a[s]=f(e)});var na="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),ra="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),da="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),_a=m,ia=m,oa=m;function ma(){function e(e,a){return a.length-e.length}for(var a,t,s,n=[],r=[],d=[],_=[],i=0;i<7;i++)s=U([2e3,1]).day(i),a=we(this.weekdaysMin(s,"")),t=we(this.weekdaysShort(s,"")),s=we(this.weekdays(s,"")),n.push(a),r.push(t),d.push(s),_.push(a),_.push(t),_.push(s);n.sort(e),r.sort(e),d.sort(e),_.sort(e),this._weekdaysRegex=new RegExp("^("+_.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+d.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+r.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+n.join("|")+")","i")}function ua(){return this.hours()%12||12}function la(e,a){s(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),a)})}function Ma(e,a){return a._meridiemParse}s("H",["HH",2],0,"hour"),s("h",["hh",2],0,ua),s("k",["kk",2],0,function(){return this.hours()||24}),s("hmm",0,0,function(){return""+ua.apply(this)+de(this.minutes(),2)}),s("hmmss",0,0,function(){return""+ua.apply(this)+de(this.minutes(),2)+de(this.seconds(),2)}),s("Hmm",0,0,function(){return""+this.hours()+de(this.minutes(),2)}),s("Hmmss",0,0,function(){return""+this.hours()+de(this.minutes(),2)+de(this.seconds(),2)}),la("a",!0),la("A",!1),h("a",Ma),h("A",Ma),h("H",r,M),h("h",r,u),h("k",r,u),h("HH",r,a),h("hh",r,a),h("kk",r,a),h("hmm",ye),h("hmmss",_),h("Hmm",ye),h("Hmmss",_),k(["H","HH"],D),k(["k","kk"],function(e,a,t){e=f(e);a[D]=24===e?0:e}),k(["a","A"],function(e,a,t){t._isPm=t._locale.isPM(e),t._meridiem=e}),k(["h","hh"],function(e,a,t){a[D]=f(e),Y(t).bigHour=!0}),k("hmm",function(e,a,t){var s=e.length-2;a[D]=f(e.substr(0,s)),a[Pe]=f(e.substr(s)),Y(t).bigHour=!0}),k("hmmss",function(e,a,t){var s=e.length-4,n=e.length-2;a[D]=f(e.substr(0,s)),a[Pe]=f(e.substr(s,2)),a[Oe]=f(e.substr(n)),Y(t).bigHour=!0}),k("Hmm",function(e,a,t){var s=e.length-2;a[D]=f(e.substr(0,s)),a[Pe]=f(e.substr(s))}),k("Hmmss",function(e,a,t){var s=e.length-4,n=e.length-2;a[D]=f(e.substr(0,s)),a[Pe]=f(e.substr(s,2)),a[Oe]=f(e.substr(n))});m=Ne("Hours",!0);var ha,ca={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Ie,monthsShort:Ue,week:{dow:0,doy:6},weekdays:na,weekdaysMin:da,weekdaysShort:ra,meridiemParse:/[ap]\.?m?\.?/i},g={},La={};function Ya(e){return e&&e.toLowerCase().replace("_","-")}function ya(e){for(var a,t,s,n,r=0;r<e.length;){for(a=(n=Ya(e[r]).split("-")).length,t=(t=Ya(e[r+1]))?t.split("-"):null;0<a;){if(s=fa(n.slice(0,a).join("-")))return s;if(t&&t.length>=a&&function(e,a){for(var t=Math.min(e.length,a.length),s=0;s<t;s+=1)if(e[s]!==a[s])return s;return t}(n,t)>=a-1)break;a--}r++}return ha}function fa(a){var e,t;if(void 0===g[a]&&"undefined"!=typeof module&&module&&module.exports&&(t=a)&&t.match("^[^/\\\\]*$"))try{e=ha._abbr,require("./locale/"+a),ka(e)}catch(e){g[a]=null}return g[a]}function ka(e,a){return e&&((a=L(a)?Da(e):pa(e,a))?ha=a:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),ha._abbr}function pa(e,a){if(null===a)return delete g[e],null;var t,s=ca;if(a.abbr=e,null!=g[e])ae("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=g[e]._config;else if(null!=a.parentLocale)if(null!=g[a.parentLocale])s=g[a.parentLocale]._config;else{if(null==(t=fa(a.parentLocale)))return La[a.parentLocale]||(La[a.parentLocale]=[]),La[a.parentLocale].push({name:e,config:a}),null;s=t._config}return g[e]=new ne(se(s,a)),La[e]&&La[e].forEach(function(e){pa(e.name,e.config)}),ka(e),g[e]}function Da(e){var a;if(!(e=e&&e._locale&&e._locale._abbr?e._locale._abbr:e))return ha;if(!F(e)){if(a=fa(e))return a;e=[e]}return ya(e)}function Ta(e){var a=e._a;return a&&-2===Y(e).overflow&&(a=a[je]<0||11<a[je]?je:a[xe]<1||a[xe]>Ce(a[p],a[je])?xe:a[D]<0||24<a[D]||24===a[D]&&(0!==a[Pe]||0!==a[Oe]||0!==a[We])?D:a[Pe]<0||59<a[Pe]?Pe:a[Oe]<0||59<a[Oe]?Oe:a[We]<0||999<a[We]?We:-1,Y(e)._overflowDayOfYear&&(a<p||xe<a)&&(a=xe),Y(e)._overflowWeeks&&-1===a&&(a=Ae),Y(e)._overflowWeekday&&-1===a&&(a=Ee),Y(e).overflow=a),e}var ga=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,wa=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,ba=/Z|[+-]\d\d(?::?\d\d)?/,Ha=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],Sa=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],va=/^\/?Date\((-?\d+)/i,ja=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,xa={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Pa(e){var a,t,s,n,r,d,_=e._i,i=ga.exec(_)||wa.exec(_),_=Ha.length,o=Sa.length;if(i){for(Y(e).iso=!0,a=0,t=_;a<t;a++)if(Ha[a][1].exec(i[1])){n=Ha[a][0],s=!1!==Ha[a][2];break}if(null==n)e._isValid=!1;else{if(i[3]){for(a=0,t=o;a<t;a++)if(Sa[a][1].exec(i[3])){r=(i[2]||" ")+Sa[a][0];break}if(null==r)return void(e._isValid=!1)}if(s||null==r){if(i[4]){if(!ba.exec(i[4]))return void(e._isValid=!1);d="Z"}e._f=n+(r||"")+(d||""),Fa(e)}else e._isValid=!1}}else e._isValid=!1}function Oa(e,a,t,s,n,r){e=[function(e){e=parseInt(e,10);{if(e<=49)return 2e3+e;if(e<=999)return 1900+e}return e}(e),Ue.indexOf(a),parseInt(t,10),parseInt(s,10),parseInt(n,10)];return r&&e.push(parseInt(r,10)),e}function Wa(e){var a,t,s=ja.exec(e._i.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));s?(a=Oa(s[4],s[3],s[2],s[5],s[6],s[7]),function(e,a,t){if(!e||ra.indexOf(e)===new Date(a[0],a[1],a[2]).getDay())return 1;Y(t).weekdayMismatch=!0,t._isValid=!1}(s[1],a,e)&&(e._a=a,e._tzm=(a=s[8],t=s[9],s=s[10],a?xa[a]:t?0:60*(((a=parseInt(s,10))-(t=a%100))/100)+t),e._d=Qe.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),Y(e).rfc2822=!0)):e._isValid=!1}function Aa(e,a,t){return null!=e?e:null!=a?a:t}function Ea(e){var a,t,s,n,r,d,_,i,o,m,u,l=[];if(!e._d){for(s=e,n=new Date(c.now()),t=s._useUTC?[n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()]:[n.getFullYear(),n.getMonth(),n.getDate()],e._w&&null==e._a[xe]&&null==e._a[je]&&(null!=(n=(s=e)._w).GG||null!=n.W||null!=n.E?(i=1,o=4,r=Aa(n.GG,s._a[p],aa(w(),1,4).year),d=Aa(n.W,1),((_=Aa(n.E,1))<1||7<_)&&(m=!0)):(i=s._locale._week.dow,o=s._locale._week.doy,u=aa(w(),i,o),r=Aa(n.gg,s._a[p],u.year),d=Aa(n.w,u.week),null!=n.d?((_=n.d)<0||6<_)&&(m=!0):null!=n.e?(_=n.e+i,(n.e<0||6<n.e)&&(m=!0)):_=i),d<1||d>ta(r,i,o)?Y(s)._overflowWeeks=!0:null!=m?Y(s)._overflowWeekday=!0:(u=ea(r,d,_,i,o),s._a[p]=u.year,s._dayOfYear=u.dayOfYear)),null!=e._dayOfYear&&(n=Aa(e._a[p],t[p]),(e._dayOfYear>Fe(n)||0===e._dayOfYear)&&(Y(e)._overflowDayOfYear=!0),m=Qe(n,0,e._dayOfYear),e._a[je]=m.getUTCMonth(),e._a[xe]=m.getUTCDate()),a=0;a<3&&null==e._a[a];++a)e._a[a]=l[a]=t[a];for(;a<7;a++)e._a[a]=l[a]=null==e._a[a]?2===a?1:0:e._a[a];24===e._a[D]&&0===e._a[Pe]&&0===e._a[Oe]&&0===e._a[We]&&(e._nextDay=!0,e._a[D]=0),e._d=(e._useUTC?Qe:$e).apply(null,l),r=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[D]=24),e._w&&void 0!==e._w.d&&e._w.d!==r&&(Y(e).weekdayMismatch=!0)}}function Fa(e){if(e._f===c.ISO_8601)Pa(e);else if(e._f===c.RFC_2822)Wa(e);else{e._a=[],Y(e).empty=!0;for(var a,t,s,n,r,d=""+e._i,_=d.length,i=0,o=le(e._f,e._locale).match(_e)||[],m=o.length,u=0;u<m;u++)t=o[u],(a=(d.match(ge(t,e))||[])[0])&&(0<(s=d.substr(0,d.indexOf(a))).length&&Y(e).unusedInput.push(s),d=d.slice(d.indexOf(a)+a.length),i+=a.length),me[t]?(a?Y(e).empty=!1:Y(e).unusedTokens.push(t),s=t,r=e,null!=(n=a)&&l(He,s)&&He[s](n,r._a,r,s)):e._strict&&!a&&Y(e).unusedTokens.push(t);Y(e).charsLeftOver=_-i,0<d.length&&Y(e).unusedInput.push(d),e._a[D]<=12&&!0===Y(e).bigHour&&0<e._a[D]&&(Y(e).bigHour=void 0),Y(e).parsedDateParts=e._a.slice(0),Y(e).meridiem=e._meridiem,e._a[D]=function(e,a,t){if(null==t)return a;return null!=e.meridiemHour?e.meridiemHour(a,t):null!=e.isPM?((e=e.isPM(t))&&a<12&&(a+=12),a=e||12!==a?a:0):a}(e._locale,e._a[D],e._meridiem),null!==(_=Y(e).era)&&(e._a[p]=e._locale.erasConvertYear(_,e._a[p])),Ea(e),Ta(e)}}function za(e){var a,t,s,n=e._i,r=e._f;if(e._locale=e._locale||Da(e._l),null===n||void 0===r&&""===n)return V({nullInput:!0});if("string"==typeof n&&(e._i=n=e._locale.preparse(n)),Q(n))return new $(Ta(n));if(R(n))e._d=n;else if(F(r)){var d,_,i,o,m,u,l=e,M=!1,h=l._f.length;if(0===h)Y(l).invalidFormat=!0,l._d=new Date(NaN);else{for(o=0;o<h;o++)m=0,u=!1,d=Z({},l),null!=l._useUTC&&(d._useUTC=l._useUTC),d._f=l._f[o],Fa(d),G(d)&&(u=!0),m=(m+=Y(d).charsLeftOver)+10*Y(d).unusedTokens.length,Y(d).score=m,M?m<i&&(i=m,_=d):(null==i||m<i||u)&&(i=m,_=d,u)&&(M=!0);I(l,_||d)}}else if(r)Fa(e);else if(L(r=(n=e)._i))n._d=new Date(c.now());else R(r)?n._d=new Date(r.valueOf()):"string"==typeof r?(t=n,null!==(a=va.exec(t._i))?t._d=new Date(+a[1]):(Pa(t),!1===t._isValid&&(delete t._isValid,Wa(t),!1===t._isValid)&&(delete t._isValid,t._strict?t._isValid=!1:c.createFromInputFallback(t)))):F(r)?(n._a=C(r.slice(0),function(e){return parseInt(e,10)}),Ea(n)):z(r)?(a=n)._d||(s=void 0===(t=he(a._i)).day?t.date:t.day,a._a=C([t.year,t.month,s,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),Ea(a)):J(r)?n._d=new Date(r):c.createFromInputFallback(n);return G(e)||(e._d=null),e}function Na(e,a,t,s,n){var r={};return!0!==a&&!1!==a||(s=a,a=void 0),!0!==t&&!1!==t||(s=t,t=void 0),(z(e)&&N(e)||F(e)&&0===e.length)&&(e=void 0),r._isAMomentObject=!0,r._useUTC=r._isUTC=n,r._l=t,r._i=e,r._f=a,r._strict=s,(n=new $(Ta(za(n=r))))._nextDay&&(n.add(1,"d"),n._nextDay=void 0),n}function w(e,a,t,s){return Na(e,a,t,s,!1)}c.createFromInputFallback=e("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),c.ISO_8601=function(){},c.RFC_2822=function(){};ye=e("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=w.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:V()}),_=e("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=w.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:V()});function Ja(e,a){var t,s;if(!(a=1===a.length&&F(a[0])?a[0]:a).length)return w();for(t=a[0],s=1;s<a.length;++s)a[s].isValid()&&!a[s][e](t)||(t=a[s]);return t}var Ra=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ca(e){var e=he(e),a=e.year||0,t=e.quarter||0,s=e.month||0,n=e.week||e.isoWeek||0,r=e.day||0,d=e.hour||0,_=e.minute||0,i=e.second||0,o=e.millisecond||0;this._isValid=function(e){var a,t,s=!1,n=Ra.length;for(a in e)if(l(e,a)&&(-1===T.call(Ra,a)||null!=e[a]&&isNaN(e[a])))return!1;for(t=0;t<n;++t)if(e[Ra[t]]){if(s)return!1;parseFloat(e[Ra[t]])!==f(e[Ra[t]])&&(s=!0)}return!0}(e),this._milliseconds=+o+1e3*i+6e4*_+1e3*d*60*60,this._days=+r+7*n,this._months=+s+3*t+12*a,this._data={},this._locale=Da(),this._bubble()}function Ia(e){return e instanceof Ca}function Ua(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ga(e,t){s(e,0,0,function(){var e=this.utcOffset(),a="+";return e<0&&(e=-e,a="-"),a+de(~~(e/60),2)+t+de(~~e%60,2)})}Ga("Z",":"),Ga("ZZ",""),h("Z",Te),h("ZZ",Te),k(["Z","ZZ"],function(e,a,t){t._useUTC=!0,t._tzm=qa(Te,e)});var Va=/([\+\-]|\d\d)/gi;function qa(e,a){var a=(a||"").match(e);return null===a?null:0===(a=60*(e=((a[a.length-1]||[])+"").match(Va)||["-",0,0])[1]+f(e[2]))?0:"+"===e[0]?a:-a}function Ba(e,a){var t;return a._isUTC?(a=a.clone(),t=(Q(e)||R(e)?e:w(e)).valueOf()-a.valueOf(),a._d.setTime(a._d.valueOf()+t),c.updateOffset(a,!1),a):w(e).local()}function Ka(e){return-Math.round(e._d.getTimezoneOffset())}function Za(){return!!this.isValid()&&this._isUTC&&0===this._offset}c.updateOffset=function(){};var $a=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,Qa=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function Xa(e,a){var t,s=e;return Ia(e)?s={ms:e._milliseconds,d:e._days,M:e._months}:J(e)||!isNaN(+e)?(s={},a?s[a]=+e:s.milliseconds=+e):(a=$a.exec(e))?(t="-"===a[1]?-1:1,s={y:0,d:f(a[xe])*t,h:f(a[D])*t,m:f(a[Pe])*t,s:f(a[Oe])*t,ms:f(Ua(1e3*a[We]))*t}):(a=Qa.exec(e))?(t="-"===a[1]?-1:1,s={y:et(a[2],t),M:et(a[3],t),w:et(a[4],t),d:et(a[5],t),h:et(a[6],t),m:et(a[7],t),s:et(a[8],t)}):null==s?s={}:"object"==typeof s&&("from"in s||"to"in s)&&(a=function(e,a){var t;if(!e.isValid()||!a.isValid())return{milliseconds:0,months:0};a=Ba(a,e),e.isBefore(a)?t=at(e,a):((t=at(a,e)).milliseconds=-t.milliseconds,t.months=-t.months);return t}(w(s.from),w(s.to)),(s={}).ms=a.milliseconds,s.M=a.months),t=new Ca(s),Ia(e)&&l(e,"_locale")&&(t._locale=e._locale),Ia(e)&&l(e,"_isValid")&&(t._isValid=e._isValid),t}function et(e,a){e=e&&parseFloat(e.replace(",","."));return(isNaN(e)?0:e)*a}function at(e,a){var t={};return t.months=a.month()-e.month()+12*(a.year()-e.year()),e.clone().add(t.months,"M").isAfter(a)&&--t.months,t.milliseconds=+a-+e.clone().add(t.months,"M"),t}function tt(s,n){return function(e,a){var t;return null===a||isNaN(+a)||(ae(n,"moment()."+n+"(period, number) is deprecated. Please use moment()."+n+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),t=e,e=a,a=t),st(this,Xa(e,a),s),this}}function st(e,a,t,s){var n=a._milliseconds,r=Ua(a._days),a=Ua(a._months);e.isValid()&&(s=null==s||s,a&&Be(e,Je(e,"Month")+a*t),r&&Re(e,"Date",Je(e,"Date")+r*t),n&&e._d.setTime(e._d.valueOf()+n*t),s)&&c.updateOffset(e,r||a)}Xa.fn=Ca.prototype,Xa.invalid=function(){return Xa(NaN)};Ie=tt(1,"add"),na=tt(-1,"subtract");function nt(e){return"string"==typeof e||e instanceof String}function rt(e){return Q(e)||R(e)||nt(e)||J(e)||function(a){var e=F(a),t=!1;e&&(t=0===a.filter(function(e){return!J(e)&&nt(a)}).length);return e&&t}(e)||function(e){var a,t,s=z(e)&&!N(e),n=!1,r=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],d=r.length;for(a=0;a<d;a+=1)t=r[a],n=n||l(e,t);return s&&n}(e)||null==e}function dt(e,a){var t,s;return e.date()<a.date()?-dt(a,e):-((t=12*(a.year()-e.year())+(a.month()-e.month()))+(a-(s=e.clone().add(t,"months"))<0?(a-s)/(s-e.clone().add(t-1,"months")):(a-s)/(e.clone().add(1+t,"months")-s)))||0}function _t(e){return void 0===e?this._locale._abbr:(null!=(e=Da(e))&&(this._locale=e),this)}c.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",c.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";da=e("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function it(){return this._locale}var ot=126227808e5;function mt(e,a){return(e%a+a)%a}function ut(e,a,t){return e<100&&0<=e?new Date(e+400,a,t)-ot:new Date(e,a,t).valueOf()}function lt(e,a,t){return e<100&&0<=e?Date.UTC(e+400,a,t)-ot:Date.UTC(e,a,t)}function Mt(e,a){return a.erasAbbrRegex(e)}function ht(){for(var e,a,t,s=[],n=[],r=[],d=[],_=this.eras(),i=0,o=_.length;i<o;++i)e=we(_[i].name),a=we(_[i].abbr),t=we(_[i].narrow),n.push(e),s.push(a),r.push(t),d.push(e),d.push(a),d.push(t);this._erasRegex=new RegExp("^("+d.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+n.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+s.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+r.join("|")+")","i")}function ct(e,a){s(0,[e,e.length],0,a)}function Lt(e,a,t,s,n){var r;return null==e?aa(this,s,n).year:(r=ta(e,s,n),function(e,a,t,s,n){e=ea(e,a,t,s,n),a=Qe(e.year,0,e.dayOfYear);return this.year(a.getUTCFullYear()),this.month(a.getUTCMonth()),this.date(a.getUTCDate()),this}.call(this,e,a=r<a?r:a,t,s,n))}s("N",0,0,"eraAbbr"),s("NN",0,0,"eraAbbr"),s("NNN",0,0,"eraAbbr"),s("NNNN",0,0,"eraName"),s("NNNNN",0,0,"eraNarrow"),s("y",["y",1],"yo","eraYear"),s("y",["yy",2],0,"eraYear"),s("y",["yyy",3],0,"eraYear"),s("y",["yyyy",4],0,"eraYear"),h("N",Mt),h("NN",Mt),h("NNN",Mt),h("NNNN",function(e,a){return a.erasNameRegex(e)}),h("NNNNN",function(e,a){return a.erasNarrowRegex(e)}),k(["N","NN","NNN","NNNN","NNNNN"],function(e,a,t,s){s=t._locale.erasParse(e,s,t._strict);s?Y(t).era=s:Y(t).invalidEra=e}),h("y",ke),h("yy",ke),h("yyy",ke),h("yyyy",ke),h("yo",function(e,a){return a._eraYearOrdinalRegex||ke}),k(["y","yy","yyy","yyyy"],p),k(["yo"],function(e,a,t,s){var n;t._locale._eraYearOrdinalRegex&&(n=e.match(t._locale._eraYearOrdinalRegex)),t._locale.eraYearOrdinalParse?a[p]=t._locale.eraYearOrdinalParse(e,n):a[p]=parseInt(e,10)}),s(0,["gg",2],0,function(){return this.weekYear()%100}),s(0,["GG",2],0,function(){return this.isoWeekYear()%100}),ct("gggg","weekYear"),ct("ggggg","weekYear"),ct("GGGG","isoWeekYear"),ct("GGGGG","isoWeekYear"),h("G",pe),h("g",pe),h("GG",r,a),h("gg",r,a),h("GGGG",i,t),h("gggg",i,t),h("GGGGG",o,n),h("ggggg",o,n),Se(["gggg","ggggg","GGGG","GGGGG"],function(e,a,t,s){a[s.substr(0,2)]=f(e)}),Se(["gg","GG"],function(e,a,t,s){a[s]=c.parseTwoDigitYear(e)}),s("Q",0,"Qo","quarter"),h("Q",Le),k("Q",function(e,a){a[je]=3*(f(e)-1)}),s("D",["DD",2],"Do","date"),h("D",r,u),h("DD",r,a),h("Do",function(e,a){return e?a._dayOfMonthOrdinalParse||a._ordinalParse:a._dayOfMonthOrdinalParseLenient}),k(["D","DD"],xe),k("Do",function(e,a){a[xe]=f(e.match(r)[0])});i=Ne("Date",!0);s("DDD",["DDDD",3],"DDDo","dayOfYear"),h("DDD",fe),h("DDDD",Ye),k(["DDD","DDDD"],function(e,a,t){t._dayOfYear=f(e)}),s("m",["mm",2],0,"minute"),h("m",r,M),h("mm",r,a),k(["m","mm"],Pe);var Yt,t=Ne("Minutes",!1),o=(s("s",["ss",2],0,"second"),h("s",r,M),h("ss",r,a),k(["s","ss"],Oe),Ne("Seconds",!1));for(s("S",0,0,function(){return~~(this.millisecond()/100)}),s(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),s(0,["SSS",3],0,"millisecond"),s(0,["SSSS",4],0,function(){return 10*this.millisecond()}),s(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),s(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),s(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),s(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),s(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),h("S",fe,Le),h("SS",fe,a),h("SSS",fe,Ye),Yt="SSSS";Yt.length<=9;Yt+="S")h(Yt,ke);function yt(e,a){a[We]=f(1e3*("0."+e))}for(Yt="S";Yt.length<=9;Yt+="S")k(Yt,yt);n=Ne("Milliseconds",!1),s("z",0,0,"zoneAbbr"),s("zz",0,0,"zoneName");u=$.prototype;function ft(e){return e}u.add=Ie,u.calendar=function(e,a){1===arguments.length&&(arguments[0]?rt(arguments[0])?(e=arguments[0],a=void 0):function(e){for(var a=z(e)&&!N(e),t=!1,s=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"],n=0;n<s.length;n+=1)t=t||l(e,s[n]);return a&&t}(arguments[0])&&(a=arguments[0],e=void 0):a=e=void 0);var e=e||w(),t=Ba(e,this).startOf("day"),t=c.calendarFormat(this,t)||"sameElse",a=a&&(te(a[t])?a[t].call(this,e):a[t]);return this.format(a||this.localeData().calendar(t,this,w(e)))},u.clone=function(){return new $(this)},u.diff=function(e,a,t){var s,n,r;if(!this.isValid())return NaN;if(!(s=Ba(e,this)).isValid())return NaN;switch(n=6e4*(s.utcOffset()-this.utcOffset()),a=d(a)){case"year":r=dt(this,s)/12;break;case"month":r=dt(this,s);break;case"quarter":r=dt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-n)/864e5;break;case"week":r=(this-s-n)/6048e5;break;default:r=this-s}return t?r:y(r)},u.endOf=function(e){var a,t;if(void 0!==(e=d(e))&&"millisecond"!==e&&this.isValid()){switch(t=this._isUTC?lt:ut,e){case"year":a=t(this.year()+1,0,1)-1;break;case"quarter":a=t(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":a=t(this.year(),this.month()+1,1)-1;break;case"week":a=t(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":a=t(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":a=t(this.year(),this.month(),this.date()+1)-1;break;case"hour":a=this._d.valueOf(),a+=36e5-mt(a+(this._isUTC?0:6e4*this.utcOffset()),36e5)-1;break;case"minute":a=this._d.valueOf(),a+=6e4-mt(a,6e4)-1;break;case"second":a=this._d.valueOf(),a+=1e3-mt(a,1e3)-1;break}this._d.setTime(a),c.updateOffset(this,!0)}return this},u.format=function(e){return e=e||(this.isUtc()?c.defaultFormatUtc:c.defaultFormat),e=ue(this,e),this.localeData().postformat(e)},u.from=function(e,a){return this.isValid()&&(Q(e)&&e.isValid()||w(e).isValid())?Xa({to:this,from:e}).locale(this.locale()).humanize(!a):this.localeData().invalidDate()},u.fromNow=function(e){return this.from(w(),e)},u.to=function(e,a){return this.isValid()&&(Q(e)&&e.isValid()||w(e).isValid())?Xa({from:this,to:e}).locale(this.locale()).humanize(!a):this.localeData().invalidDate()},u.toNow=function(e){return this.to(w(),e)},u.get=function(e){return te(this[e=d(e)])?this[e]():this},u.invalidAt=function(){return Y(this).overflow},u.isAfter=function(e,a){return e=Q(e)?e:w(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(a=d(a)||"millisecond")?this.valueOf()>e.valueOf():e.valueOf()<this.clone().startOf(a).valueOf())},u.isBefore=function(e,a){return e=Q(e)?e:w(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(a=d(a)||"millisecond")?this.valueOf()<e.valueOf():this.clone().endOf(a).valueOf()<e.valueOf())},u.isBetween=function(e,a,t,s){return e=Q(e)?e:w(e),a=Q(a)?a:w(a),!!(this.isValid()&&e.isValid()&&a.isValid())&&("("===(s=s||"()")[0]?this.isAfter(e,t):!this.isBefore(e,t))&&(")"===s[1]?this.isBefore(a,t):!this.isAfter(a,t))},u.isSame=function(e,a){var e=Q(e)?e:w(e);return!(!this.isValid()||!e.isValid())&&("millisecond"===(a=d(a)||"millisecond")?this.valueOf()===e.valueOf():(e=e.valueOf(),this.clone().startOf(a).valueOf()<=e&&e<=this.clone().endOf(a).valueOf()))},u.isSameOrAfter=function(e,a){return this.isSame(e,a)||this.isAfter(e,a)},u.isSameOrBefore=function(e,a){return this.isSame(e,a)||this.isBefore(e,a)},u.isValid=function(){return G(this)},u.lang=da,u.locale=_t,u.localeData=it,u.max=_,u.min=ye,u.parsingFlags=function(){return I({},Y(this))},u.set=function(e,a){if("object"==typeof e)for(var t=function(e){var a,t=[];for(a in e)l(e,a)&&t.push({unit:a,priority:ce[a]});return t.sort(function(e,a){return e.priority-a.priority}),t}(e=he(e)),s=t.length,n=0;n<s;n++)this[t[n].unit](e[t[n].unit]);else if(te(this[e=d(e)]))return this[e](a);return this},u.startOf=function(e){var a,t;if(void 0!==(e=d(e))&&"millisecond"!==e&&this.isValid()){switch(t=this._isUTC?lt:ut,e){case"year":a=t(this.year(),0,1);break;case"quarter":a=t(this.year(),this.month()-this.month()%3,1);break;case"month":a=t(this.year(),this.month(),1);break;case"week":a=t(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":a=t(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":a=t(this.year(),this.month(),this.date());break;case"hour":a=this._d.valueOf(),a-=mt(a+(this._isUTC?0:6e4*this.utcOffset()),36e5);break;case"minute":a=this._d.valueOf(),a-=mt(a,6e4);break;case"second":a=this._d.valueOf(),a-=mt(a,1e3);break}this._d.setTime(a),c.updateOffset(this,!0)}return this},u.subtract=na,u.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},u.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},u.toDate=function(){return new Date(this.valueOf())},u.toISOString=function(e){var a;return this.isValid()?(a=(e=!0!==e)?this.clone().utc():this).year()<0||9999<a.year()?ue(a,e?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):te(Date.prototype.toISOString)?e?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",ue(a,"Z")):ue(a,e?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ"):null},u.inspect=function(){var e,a,t;return this.isValid()?(a="moment",e="",this.isLocal()||(a=0===this.utcOffset()?"moment.utc":"moment.parseZone",e="Z"),a="["+a+'("]',t=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",this.format(a+t+"-MM-DD[T]HH:mm:ss.SSS"+(e+'[")]'))):"moment.invalid(/* "+this._i+" */)"},"undefined"!=typeof Symbol&&null!=Symbol.for&&(u[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),u.toJSON=function(){return this.isValid()?this.toISOString():null},u.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},u.unix=function(){return Math.floor(this.valueOf()/1e3)},u.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},u.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},u.eraName=function(){for(var e,a=this.localeData().eras(),t=0,s=a.length;t<s;++t){if(e=this.clone().startOf("day").valueOf(),a[t].since<=e&&e<=a[t].until)return a[t].name;if(a[t].until<=e&&e<=a[t].since)return a[t].name}return""},u.eraNarrow=function(){for(var e,a=this.localeData().eras(),t=0,s=a.length;t<s;++t){if(e=this.clone().startOf("day").valueOf(),a[t].since<=e&&e<=a[t].until)return a[t].narrow;if(a[t].until<=e&&e<=a[t].since)return a[t].narrow}return""},u.eraAbbr=function(){for(var e,a=this.localeData().eras(),t=0,s=a.length;t<s;++t){if(e=this.clone().startOf("day").valueOf(),a[t].since<=e&&e<=a[t].until)return a[t].abbr;if(a[t].until<=e&&e<=a[t].since)return a[t].abbr}return""},u.eraYear=function(){for(var e,a,t=this.localeData().eras(),s=0,n=t.length;s<n;++s)if(e=t[s].since<=t[s].until?1:-1,a=this.clone().startOf("day").valueOf(),t[s].since<=a&&a<=t[s].until||t[s].until<=a&&a<=t[s].since)return(this.year()-c(t[s].since).year())*e+t[s].offset;return this.year()},u.year=ze,u.isLeapYear=function(){return ve(this.year())},u.weekYear=function(e){return Lt.call(this,e,this.week(),this.weekday()+this.localeData()._week.dow,this.localeData()._week.dow,this.localeData()._week.doy)},u.isoWeekYear=function(e){return Lt.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},u.quarter=u.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},u.month=Ke,u.daysInMonth=function(){return Ce(this.year(),this.month())},u.week=u.weeks=function(e){var a=this.localeData().week(this);return null==e?a:this.add(7*(e-a),"d")},u.isoWeek=u.isoWeeks=function(e){var a=aa(this,1,4).week;return null==e?a:this.add(7*(e-a),"d")},u.weeksInYear=function(){var e=this.localeData()._week;return ta(this.year(),e.dow,e.doy)},u.weeksInWeekYear=function(){var e=this.localeData()._week;return ta(this.weekYear(),e.dow,e.doy)},u.isoWeeksInYear=function(){return ta(this.year(),1,4)},u.isoWeeksInISOWeekYear=function(){return ta(this.isoWeekYear(),1,4)},u.date=i,u.day=u.days=function(e){var a,t,s;return this.isValid()?(a=Je(this,"Day"),null!=e?(t=e,s=this.localeData(),e="string"!=typeof t?t:isNaN(t)?"number"==typeof(t=s.weekdaysParse(t))?t:null:parseInt(t,10),this.add(e-a,"d")):a):null!=e?this:NaN},u.weekday=function(e){var a;return this.isValid()?(a=(this.day()+7-this.localeData()._week.dow)%7,null==e?a:this.add(e-a,"d")):null!=e?this:NaN},u.isoWeekday=function(e){var a,t;return this.isValid()?null!=e?(a=e,t=this.localeData(),t="string"==typeof a?t.weekdaysParse(a)%7||7:isNaN(a)?null:a,this.day(this.day()%7?t:t-7)):this.day()||7:null!=e?this:NaN},u.dayOfYear=function(e){var a=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?a:this.add(e-a,"d")},u.hour=u.hours=m,u.minute=u.minutes=t,u.second=u.seconds=o,u.millisecond=u.milliseconds=n,u.utcOffset=function(e,a,t){var s,n=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null==e)return this._isUTC?n:Ka(this);if("string"==typeof e){if(null===(e=qa(Te,e)))return this}else Math.abs(e)<16&&!t&&(e*=60);return!this._isUTC&&a&&(s=Ka(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),n!==e&&(!a||this._changeInProgress?st(this,Xa(e-n,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,c.updateOffset(this,!0),this._changeInProgress=null)),this},u.utc=function(e){return this.utcOffset(0,e)},u.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e)&&this.subtract(Ka(this),"m"),this},u.parseZone=function(){var e;return null!=this._tzm?this.utcOffset(this._tzm,!1,!0):"string"==typeof this._i&&(null!=(e=qa(De,this._i))?this.utcOffset(e):this.utcOffset(0,!0)),this},u.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?w(e).utcOffset():0,(this.utcOffset()-e)%60==0)},u.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},u.isLocal=function(){return!!this.isValid()&&!this._isUTC},u.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},u.isUtc=Za,u.isUTC=Za,u.zoneAbbr=function(){return this._isUTC?"UTC":""},u.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},u.dates=e("dates accessor is deprecated. Use date instead.",i),u.months=e("months accessor is deprecated. Use month instead",Ke),u.years=e("years accessor is deprecated. Use year instead",ze),u.zone=e("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,a){return null!=e?(this.utcOffset(e="string"!=typeof e?-e:e,a),this):-this.utcOffset()}),u.isDSTShifted=e("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){var e,a;return L(this._isDSTShifted)&&(Z(e={},this),(e=za(e))._a?(a=(e._isUTC?U:w)(e._a),this._isDSTShifted=this.isValid()&&0<function(e,a,t){for(var s=Math.min(e.length,a.length),n=Math.abs(e.length-a.length),r=0,d=0;d<s;d++)(t&&e[d]!==a[d]||!t&&f(e[d])!==f(a[d]))&&r++;return r+n}(e._a,a.toArray())):this._isDSTShifted=!1),this._isDSTShifted});M=ne.prototype;function kt(e,a,t,s){var n=Da(),s=U().set(s,a);return n[t](s,e)}function pt(e,a,t){if(J(e)&&(a=e,e=void 0),e=e||"",null!=a)return kt(e,a,t,"month");for(var s=[],n=0;n<12;n++)s[n]=kt(e,n,t,"month");return s}function Dt(e,a,t,s){a=("boolean"==typeof e?J(a)&&(t=a,a=void 0):(a=e,e=!1,J(t=a)&&(t=a,a=void 0)),a||"");var n,r=Da(),d=e?r._week.dow:0,_=[];if(null!=t)return kt(a,(t+d)%7,s,"day");for(n=0;n<7;n++)_[n]=kt(a,(n+d)%7,s,"day");return _}M.calendar=function(e,a,t){return te(e=this._calendar[e]||this._calendar.sameElse)?e.call(a,t):e},M.longDateFormat=function(e){var a=this._longDateFormat[e],t=this._longDateFormat[e.toUpperCase()];return a||!t?a:(this._longDateFormat[e]=t.match(_e).map(function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e}).join(""),this._longDateFormat[e])},M.invalidDate=function(){return this._invalidDate},M.ordinal=function(e){return this._ordinal.replace("%d",e)},M.preparse=ft,M.postformat=ft,M.relativeTime=function(e,a,t,s){var n=this._relativeTime[t];return te(n)?n(e,a,t,s):n.replace(/%d/i,e)},M.pastFuture=function(e,a){return te(e=this._relativeTime[0<e?"future":"past"])?e(a):e.replace(/%s/i,a)},M.set=function(e){var a,t;for(t in e)l(e,t)&&(te(a=e[t])?this[t]=a:this["_"+t]=a);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},M.eras=function(e,a){for(var t,s=this._eras||Da("en")._eras,n=0,r=s.length;n<r;++n){switch(typeof s[n].since){case"string":t=c(s[n].since).startOf("day"),s[n].since=t.valueOf();break}switch(typeof s[n].until){case"undefined":s[n].until=1/0;break;case"string":t=c(s[n].until).startOf("day").valueOf(),s[n].until=t.valueOf();break}}return s},M.erasParse=function(e,a,t){var s,n,r,d,_,i=this.eras();for(e=e.toUpperCase(),s=0,n=i.length;s<n;++s)if(r=i[s].name.toUpperCase(),d=i[s].abbr.toUpperCase(),_=i[s].narrow.toUpperCase(),t)switch(a){case"N":case"NN":case"NNN":if(d===e)return i[s];break;case"NNNN":if(r===e)return i[s];break;case"NNNNN":if(_===e)return i[s];break}else if(0<=[r,d,_].indexOf(e))return i[s]},M.erasConvertYear=function(e,a){var t=e.since<=e.until?1:-1;return void 0===a?c(e.since).year():c(e.since).year()+(a-e.offset)*t},M.erasAbbrRegex=function(e){return l(this,"_erasAbbrRegex")||ht.call(this),e?this._erasAbbrRegex:this._erasRegex},M.erasNameRegex=function(e){return l(this,"_erasNameRegex")||ht.call(this),e?this._erasNameRegex:this._erasRegex},M.erasNarrowRegex=function(e){return l(this,"_erasNarrowRegex")||ht.call(this),e?this._erasNarrowRegex:this._erasRegex},M.months=function(e,a){return e?(F(this._months)?this._months:this._months[(this._months.isFormat||Ge).test(a)?"format":"standalone"])[e.month()]:F(this._months)?this._months:this._months.standalone},M.monthsShort=function(e,a){return e?(F(this._monthsShort)?this._monthsShort:this._monthsShort[Ge.test(a)?"format":"standalone"])[e.month()]:F(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},M.monthsParse=function(e,a,t){var s,n;if(this._monthsParseExact)return function(e,a,t){var s,n,r,e=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=U([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return t?"MMM"===a?-1!==(n=T.call(this._shortMonthsParse,e))?n:null:-1!==(n=T.call(this._longMonthsParse,e))?n:null:"MMM"===a?-1!==(n=T.call(this._shortMonthsParse,e))||-1!==(n=T.call(this._longMonthsParse,e))?n:null:-1!==(n=T.call(this._longMonthsParse,e))||-1!==(n=T.call(this._shortMonthsParse,e))?n:null}.call(this,e,a,t);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(n=U([2e3,s]),t&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(n,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(n,"").replace(".","")+"$","i")),t||this._monthsParse[s]||(n="^"+this.months(n,"")+"|^"+this.monthsShort(n,""),this._monthsParse[s]=new RegExp(n.replace(".",""),"i")),t&&"MMMM"===a&&this._longMonthsParse[s].test(e))return s;if(t&&"MMM"===a&&this._shortMonthsParse[s].test(e))return s;if(!t&&this._monthsParse[s].test(e))return s}},M.monthsRegex=function(e){return this._monthsParseExact?(l(this,"_monthsRegex")||Ze.call(this),e?this._monthsStrictRegex:this._monthsRegex):(l(this,"_monthsRegex")||(this._monthsRegex=qe),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},M.monthsShortRegex=function(e){return this._monthsParseExact?(l(this,"_monthsRegex")||Ze.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(l(this,"_monthsShortRegex")||(this._monthsShortRegex=Ve),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},M.week=function(e){return aa(e,this._week.dow,this._week.doy).week},M.firstDayOfYear=function(){return this._week.doy},M.firstDayOfWeek=function(){return this._week.dow},M.weekdays=function(e,a){return a=F(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(a)?"format":"standalone"],!0===e?sa(a,this._week.dow):e?a[e.day()]:a},M.weekdaysMin=function(e){return!0===e?sa(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},M.weekdaysShort=function(e){return!0===e?sa(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},M.weekdaysParse=function(e,a,t){var s,n;if(this._weekdaysParseExact)return function(e,a,t){var s,n,r,e=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=U([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return t?"dddd"===a?-1!==(n=T.call(this._weekdaysParse,e))?n:null:"ddd"===a?-1!==(n=T.call(this._shortWeekdaysParse,e))?n:null:-1!==(n=T.call(this._minWeekdaysParse,e))?n:null:"dddd"===a?-1!==(n=T.call(this._weekdaysParse,e))||-1!==(n=T.call(this._shortWeekdaysParse,e))||-1!==(n=T.call(this._minWeekdaysParse,e))?n:null:"ddd"===a?-1!==(n=T.call(this._shortWeekdaysParse,e))||-1!==(n=T.call(this._weekdaysParse,e))||-1!==(n=T.call(this._minWeekdaysParse,e))?n:null:-1!==(n=T.call(this._minWeekdaysParse,e))||-1!==(n=T.call(this._weekdaysParse,e))||-1!==(n=T.call(this._shortWeekdaysParse,e))?n:null}.call(this,e,a,t);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(n=U([2e3,1]).day(s),t&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(n,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(n,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(n,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(n="^"+this.weekdays(n,"")+"|^"+this.weekdaysShort(n,"")+"|^"+this.weekdaysMin(n,""),this._weekdaysParse[s]=new RegExp(n.replace(".",""),"i")),t&&"dddd"===a&&this._fullWeekdaysParse[s].test(e))return s;if(t&&"ddd"===a&&this._shortWeekdaysParse[s].test(e))return s;if(t&&"dd"===a&&this._minWeekdaysParse[s].test(e))return s;if(!t&&this._weekdaysParse[s].test(e))return s}},M.weekdaysRegex=function(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||ma.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(l(this,"_weekdaysRegex")||(this._weekdaysRegex=_a),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},M.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||ma.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(l(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=ia),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},M.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||ma.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(l(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=oa),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},M.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},M.meridiem=function(e,a,t){return 11<e?t?"pm":"PM":t?"am":"AM"},ka("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1===f(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")}}),c.lang=e("moment.lang is deprecated. Use moment.locale instead.",ka),c.langData=e("moment.langData is deprecated. Use moment.localeData instead.",Da);var Tt=Math.abs;function gt(e,a,t,s){a=Xa(a,t);return e._milliseconds+=s*a._milliseconds,e._days+=s*a._days,e._months+=s*a._months,e._bubble()}function wt(e){return e<0?Math.floor(e):Math.ceil(e)}function bt(e){return 4800*e/146097}function Ht(e){return 146097*e/4800}function St(e){return function(){return this.as(e)}}Le=St("ms"),a=St("s"),fe=St("m"),Ye=St("h"),Ie=St("d"),_=St("w"),ye=St("M"),na=St("Q"),m=St("y"),t=Le;function vt(e){return function(){return this.isValid()?this._data[e]:NaN}}var o=vt("milliseconds"),n=vt("seconds"),i=vt("minutes"),ze=vt("hours"),M=vt("days"),jt=vt("months"),xt=vt("years");var Pt=Math.round,Ot={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function Wt(e,a,t,s){var n=Xa(e).abs(),r=Pt(n.as("s")),d=Pt(n.as("m")),_=Pt(n.as("h")),i=Pt(n.as("d")),o=Pt(n.as("M")),m=Pt(n.as("w")),n=Pt(n.as("y")),r=(r<=t.ss?["s",r]:r<t.s&&["ss",r])||(d<=1?["m"]:d<t.m&&["mm",d])||(_<=1?["h"]:_<t.h&&["hh",_])||(i<=1?["d"]:i<t.d&&["dd",i]);return(r=(r=null!=t.w?r||(m<=1?["w"]:m<t.w&&["ww",m]):r)||(o<=1?["M"]:o<t.M&&["MM",o])||(n<=1?["y"]:["yy",n]))[2]=a,r[3]=0<+e,r[4]=s,function(e,a,t,s,n){return n.relativeTime(a||1,!!t,e,s)}.apply(null,r)}var At=Math.abs;function Et(e){return(0<e)-(e<0)||+e}function Ft(){var e,a,t,s,n,r,d,_,i,o,m;return this.isValid()?(e=At(this._milliseconds)/1e3,a=At(this._days),t=At(this._months),(_=this.asSeconds())?(s=y(e/60),n=y(s/60),e%=60,s%=60,r=y(t/12),t%=12,d=e?e.toFixed(3).replace(/\.?0+$/,""):"",i=Et(this._months)!==Et(_)?"-":"",o=Et(this._days)!==Et(_)?"-":"",m=Et(this._milliseconds)!==Et(_)?"-":"",(_<0?"-":"")+"P"+(r?i+r+"Y":"")+(t?i+t+"M":"")+(a?o+a+"D":"")+(n||s||e?"T":"")+(n?m+n+"H":"")+(s?m+s+"M":"")+(e?m+d+"S":"")):"P0D"):this.localeData().invalidDate()}function zt(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5}function b(d){return function(e,a,t,s){var n=zt(e),r=Rt[d][zt(e)];return(r=2===n?r[a?0:1]:r).replace(/%d/i,e)}}function Nt(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5}function H(d){return function(e,a,t,s){var n=Nt(e),r=It[d][Nt(e)];return(r=2===n?r[a?0:1]:r).replace(/%d/i,e)}}function Jt(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5}function S(d){return function(e,a,t,s){var n=Jt(e),r=Zt[d][Jt(e)];return(r=2===n?r[a?0:1]:r).replace(/%d/i,e)}}var v=Ca.prototype,Rt=(v.isValid=function(){return this._isValid},v.abs=function(){var e=this._data;return this._milliseconds=Tt(this._milliseconds),this._days=Tt(this._days),this._months=Tt(this._months),e.milliseconds=Tt(e.milliseconds),e.seconds=Tt(e.seconds),e.minutes=Tt(e.minutes),e.hours=Tt(e.hours),e.months=Tt(e.months),e.years=Tt(e.years),this},v.add=function(e,a){return gt(this,e,a,1)},v.subtract=function(e,a){return gt(this,e,a,-1)},v.as=function(e){if(!this.isValid())return NaN;var a,t,s=this._milliseconds;if("month"===(e=d(e))||"quarter"===e||"year"===e)switch(a=this._days+s/864e5,t=this._months+bt(a),e){case"month":return t;case"quarter":return t/3;case"year":return t/12}else switch(a=this._days+Math.round(Ht(this._months)),e){case"week":return a/7+s/6048e5;case"day":return a+s/864e5;case"hour":return 24*a+s/36e5;case"minute":return 1440*a+s/6e4;case"second":return 86400*a+s/1e3;case"millisecond":return Math.floor(864e5*a)+s;default:throw new Error("Unknown unit "+e)}},v.asMilliseconds=Le,v.asSeconds=a,v.asMinutes=fe,v.asHours=Ye,v.asDays=Ie,v.asWeeks=_,v.asMonths=ye,v.asQuarters=na,v.asYears=m,v.valueOf=t,v._bubble=function(){var e=this._milliseconds,a=this._days,t=this._months,s=this._data;return 0<=e&&0<=a&&0<=t||e<=0&&a<=0&&t<=0||(e+=864e5*wt(Ht(t)+a),t=a=0),s.milliseconds=e%1e3,e=y(e/1e3),s.seconds=e%60,e=y(e/60),s.minutes=e%60,e=y(e/60),s.hours=e%24,a+=y(e/24),t+=e=y(bt(a)),a-=wt(Ht(e)),e=y(t/12),t%=12,s.days=a,s.months=t,s.years=e,this},v.clone=function(){return Xa(this)},v.get=function(e){return e=d(e),this.isValid()?this[e+"s"]():NaN},v.milliseconds=o,v.seconds=n,v.minutes=i,v.hours=ze,v.days=M,v.weeks=function(){return y(this.days()/7)},v.months=jt,v.years=xt,v.humanize=function(e,a){var t,s;return this.isValid()?(t=!1,s=Ot,"object"==typeof e&&(a=e,e=!1),"boolean"==typeof e&&(t=e),"object"==typeof a&&(s=Object.assign({},Ot,a),null!=a.s)&&null==a.ss&&(s.ss=a.s-1),e=this.localeData(),a=Wt(this,!t,s,e),t&&(a=e.pastFuture(+this,a)),e.postformat(a)):this.localeData().invalidDate()},v.toISOString=Ft,v.toString=Ft,v.toJSON=Ft,v.locale=_t,v.localeData=it,v.toIsoString=e("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",Ft),v.lang=da,s("X",0,0,"unix"),s("x",0,0,"valueOf"),h("x",pe),h("X",/[+-]?\d+(\.\d{1,3})?/),k("X",function(e,a,t){t._d=new Date(1e3*parseFloat(e))}),k("x",function(e,a,t){t._d=new Date(f(e))}),c.version="2.30.1",E=w,c.fn=u,c.min=function(){return Ja("isBefore",[].slice.call(arguments,0))},c.max=function(){return Ja("isAfter",[].slice.call(arguments,0))},c.now=function(){return Date.now?Date.now():+new Date},c.utc=U,c.unix=function(e){return w(1e3*e)},c.months=function(e,a){return pt(e,a,"months")},c.isDate=R,c.locale=ka,c.invalid=V,c.duration=Xa,c.isMoment=Q,c.weekdays=function(e,a,t){return Dt(e,a,t,"weekdays")},c.parseZone=function(){return w.apply(null,arguments).parseZone()},c.localeData=Da,c.isDuration=Ia,c.monthsShort=function(e,a){return pt(e,a,"monthsShort")},c.weekdaysMin=function(e,a,t){return Dt(e,a,t,"weekdaysMin")},c.defineLocale=pa,c.updateLocale=function(e,a){var t,s;return null!=a?(s=ca,null!=g[e]&&null!=g[e].parentLocale?g[e].set(se(g[e]._config,a)):(a=se(s=null!=(t=fa(e))?t._config:s,a),null==t&&(a.abbr=e),(s=new ne(a)).parentLocale=g[e],g[e]=s),ka(e)):null!=g[e]&&(null!=g[e].parentLocale?(g[e]=g[e].parentLocale,e===ka()&&ka(e)):null!=g[e]&&delete g[e]),g[e]},c.locales=function(){return re(g)},c.weekdaysShort=function(e,a,t){return Dt(e,a,t,"weekdaysShort")},c.normalizeUnits=d,c.relativeTimeRounding=function(e){return void 0===e?Pt:"function"==typeof e&&(Pt=e,!0)},c.relativeTimeThreshold=function(e,a){return void 0!==Ot[e]&&(void 0===a?Ot[e]:(Ot[e]=a,"s"===e&&(Ot.ss=a-1),!0))},c.calendarFormat=function(e,a){return(e=e.diff(a,"days",!0))<-6?"sameElse":e<-1?"lastWeek":e<0?"lastDay":e<1?"sameDay":e<2?"nextDay":e<7?"nextWeek":"sameElse"},c.prototype=u,c.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},c.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"vm":"VM":t?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[M\xf4re om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),{s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]}),Le=["\u062c\u0627\u0646\u0641\u064a","\u0641\u064a\u0641\u0631\u064a","\u0645\u0627\u0631\u0633","\u0623\u0641\u0631\u064a\u0644","\u0645\u0627\u064a","\u062c\u0648\u0627\u0646","\u062c\u0648\u064a\u0644\u064a\u0629","\u0623\u0648\u062a","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"],Ct=(c.defineLocale("ar-dz",{months:Le,monthsShort:Le,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:b("s"),ss:b("s"),m:b("m"),mm:b("m"),h:b("h"),hh:b("h"),d:b("d"),dd:b("d"),M:b("M"),MM:b("M"),y:b("y"),yy:b("y")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:0,doy:4}}),c.defineLocale("ar-kw",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:0,doy:12}}),{1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"}),It={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},a=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"],Ut=(c.defineLocale("ar-ly",{months:a,monthsShort:a,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:H("s"),ss:H("s"),m:H("m"),mm:H("m"),h:H("h"),hh:H("h"),d:H("d"),dd:H("d"),M:H("M"),MM:H("M"),y:H("y"),yy:H("y")},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Ct[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),c.defineLocale("ar-ma",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:1,doy:4}}),{1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"}),Gt={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},Vt=(c.defineLocale("ar-ps",{months:"\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u062b\u0627\u0646\u064a_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064a\u0633\u0627\u0646_\u0623\u064a\u0651\u0627\u0631_\u062d\u0632\u064a\u0631\u0627\u0646_\u062a\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064a\u0644\u0648\u0644_\u062a\u0634\u0631\u064a \u0627\u0644\u0623\u0648\u0651\u0644_\u062a\u0634\u0631\u064a\u0646 \u0627\u0644\u062b\u0627\u0646\u064a_\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0648\u0651\u0644".split("_"),monthsShort:"\u0643\u0662_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064a\u0633\u0627\u0646_\u0623\u064a\u0651\u0627\u0631_\u062d\u0632\u064a\u0631\u0627\u0646_\u062a\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064a\u0644\u0648\u0644_\u062a\u0661_\u062a\u0662_\u0643\u0661".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},preparse:function(e){return e.replace(/[\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return Gt[e]}).split("").reverse().join("").replace(/[\u0661\u0662](?![\u062a\u0643])/g,function(e){return Gt[e]}).split("").reverse().join("").replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Ut[e]}).replace(/,/g,"\u060c")},week:{dow:0,doy:6}}),{1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"}),qt={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},Bt=(c.defineLocale("ar-sa",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return qt[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Vt[e]}).replace(/,/g,"\u060c")},week:{dow:0,doy:6}}),c.defineLocale("ar-tn",{months:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:1,doy:4}}),{1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"}),Kt={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},Zt={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},fe=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"],$t=(c.defineLocale("ar",{months:fe,monthsShort:fe,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:S("s"),ss:S("s"),m:S("m"),mm:S("m"),h:S("h"),hh:S("h"),d:S("d"),dd:S("d"),M:S("M"),MM:S("M"),y:S("y"),yy:S("y")},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return Kt[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Bt[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),{1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-\xfcnc\xfc",4:"-\xfcnc\xfc",100:"-\xfcnc\xfc",6:"-nc\u0131",9:"-uncu",10:"-uncu",30:"-uncu",60:"-\u0131nc\u0131",90:"-\u0131nc\u0131"});function Qt(e,a,t){return"m"===t?a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443":"h"===t?a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443":e+" "+(e=+e,a=(a={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",hh:a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",dd:"\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",yy:"\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e"}[t]).split("_"),e%10==1&&e%100!=11?a[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?a[1]:a[2])}c.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split("_"),weekdaysShort:"Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),weekdaysMin:"Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",lastDay:"[d\xfcn\u0259n] LT",lastWeek:"[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \u0259vv\u0259l",s:"bir ne\xe7\u0259 saniy\u0259",ss:"%d saniy\u0259",m:"bir d\u0259qiq\u0259",mm:"%d d\u0259qiq\u0259",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,isPM:function(e){return/^(g\xfcnd\xfcz|ax\u015fam)$/.test(e)},meridiem:function(e,a,t){return e<4?"gec\u0259":e<12?"s\u0259h\u0259r":e<17?"g\xfcnd\xfcz":"ax\u015fam"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,ordinal:function(e){var a;return 0===e?e+"-\u0131nc\u0131":e+($t[a=e%10]||$t[e%100-a]||$t[100<=e?100:null])},week:{dow:1,doy:7}}),c.defineLocale("be",{months:{format:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split("_"),standalone:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split("_")},monthsShort:"\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split("_"),weekdays:{format:"\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),standalone:"\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),isFormat:/\[ ?[\u0423\u0443\u045e] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., HH:mm",LLLL:"dddd, D MMMM YYYY \u0433., HH:mm"},calendar:{sameDay:"[\u0421\u0451\u043d\u043d\u044f \u045e] LT",nextDay:"[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",lastDay:"[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",nextWeek:function(){return"[\u0423] dddd [\u045e] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";case 1:case 2:case 4:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT"}},sameElse:"L"},relativeTime:{future:"\u043f\u0440\u0430\u0437 %s",past:"%s \u0442\u0430\u043c\u0443",s:"\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",m:Qt,mm:Qt,h:Qt,hh:Qt,d:"\u0434\u0437\u0435\u043d\u044c",dd:Qt,M:"\u043c\u0435\u0441\u044f\u0446",MM:Qt,y:"\u0433\u043e\u0434",yy:Qt},meridiemParse:/\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(e)},meridiem:function(e,a,t){return e<4?"\u043d\u043e\u0447\u044b":e<12?"\u0440\u0430\u043d\u0456\u0446\u044b":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0430\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e%10!=2&&e%10!=3||e%100==12||e%100==13?e+"-\u044b":e+"-\u0456";case"D":return e+"-\u0433\u0430";default:return e}},week:{dow:1,doy:7}}),c.defineLocale("bg",{months:"\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u044f\u043d\u0443_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u043d\u0435\u0441 \u0432] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432] LT",nextWeek:"dddd [\u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u041c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";case 1:case 2:case 4:case 5:return"[\u041c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0441\u043b\u0435\u0434 %s",past:"\u043f\u0440\u0435\u0434\u0438 %s",s:"\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0434\u0435\u043d",dd:"%d \u0434\u0435\u043d\u0430",w:"\u0441\u0435\u0434\u043c\u0438\u0446\u0430",ww:"%d \u0441\u0435\u0434\u043c\u0438\u0446\u0438",M:"\u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0430",y:"\u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-\u0435\u0432":0==t?e+"-\u0435\u043d":10<t&&t<20?e+"-\u0442\u0438":1==a?e+"-\u0432\u0438":2==a?e+"-\u0440\u0438":7==a||8==a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),c.defineLocale("bm",{months:"Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split("_"),monthsShort:"Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split("_"),weekdays:"Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),weekdaysShort:"Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),weekdaysMin:"Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"MMMM [tile] D [san] YYYY",LLL:"MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",LLLL:"dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm"},calendar:{sameDay:"[Bi l\u025br\u025b] LT",nextDay:"[Sini l\u025br\u025b] LT",nextWeek:"dddd [don l\u025br\u025b] LT",lastDay:"[Kunu l\u025br\u025b] LT",lastWeek:"dddd [t\u025bm\u025bnen l\u025br\u025b] LT",sameElse:"L"},relativeTime:{future:"%s k\u0254n\u0254",past:"a b\u025b %s b\u0254",s:"sanga dama dama",ss:"sekondi %d",m:"miniti kelen",mm:"miniti %d",h:"l\u025br\u025b kelen",hh:"l\u025br\u025b %d",d:"tile kelen",dd:"tile %d",M:"kalo kelen",MM:"kalo %d",y:"san kelen",yy:"san %d"},week:{dow:1,doy:4}});var Xt={1:"\u09e7",2:"\u09e8",3:"\u09e9",4:"\u09ea",5:"\u09eb",6:"\u09ec",7:"\u09ed",8:"\u09ee",9:"\u09ef",0:"\u09e6"},es={"\u09e7":"1","\u09e8":"2","\u09e9":"3","\u09ea":"4","\u09eb":"5","\u09ec":"6","\u09ed":"7","\u09ee":"8","\u09ef":"9","\u09e6":"0"},as=(c.defineLocale("bn-bd",{months:"\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),monthsShort:"\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),weekdays:"\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),weekdaysShort:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),weekdaysMin:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),longDateFormat:{LT:"A h:mm \u09b8\u09ae\u09df",LTS:"A h:mm:ss \u09b8\u09ae\u09df",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",LLLL:"dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"},calendar:{sameDay:"[\u0986\u099c] LT",nextDay:"[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",nextWeek:"dddd, LT",lastDay:"[\u0997\u09a4\u0995\u09be\u09b2] LT",lastWeek:"[\u0997\u09a4] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u09aa\u09b0\u09c7",past:"%s \u0986\u0997\u09c7",s:"\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",ss:"%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",m:"\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",mm:"%d \u09ae\u09bf\u09a8\u09bf\u099f",h:"\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",hh:"%d \u0998\u09a8\u09cd\u099f\u09be",d:"\u098f\u0995 \u09a6\u09bf\u09a8",dd:"%d \u09a6\u09bf\u09a8",M:"\u098f\u0995 \u09ae\u09be\u09b8",MM:"%d \u09ae\u09be\u09b8",y:"\u098f\u0995 \u09ac\u099b\u09b0",yy:"%d \u09ac\u099b\u09b0"},preparse:function(e){return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,function(e){return es[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Xt[e]})},meridiemParse:/\u09b0\u09be\u09a4|\u09ad\u09cb\u09b0|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be|\u09b0\u09be\u09a4/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u09b0\u09be\u09a4"===a?e<4?e:e+12:"\u09ad\u09cb\u09b0"===a||"\u09b8\u0995\u09be\u09b2"===a?e:"\u09a6\u09c1\u09aa\u09c1\u09b0"===a?3<=e?e:e+12:"\u09ac\u09bf\u0995\u09be\u09b2"===a||"\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u09b0\u09be\u09a4":e<6?"\u09ad\u09cb\u09b0":e<12?"\u09b8\u0995\u09be\u09b2":e<15?"\u09a6\u09c1\u09aa\u09c1\u09b0":e<18?"\u09ac\u09bf\u0995\u09be\u09b2":e<20?"\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be":"\u09b0\u09be\u09a4"},week:{dow:0,doy:6}}),{1:"\u09e7",2:"\u09e8",3:"\u09e9",4:"\u09ea",5:"\u09eb",6:"\u09ec",7:"\u09ed",8:"\u09ee",9:"\u09ef",0:"\u09e6"}),ts={"\u09e7":"1","\u09e8":"2","\u09e9":"3","\u09ea":"4","\u09eb":"5","\u09ec":"6","\u09ed":"7","\u09ee":"8","\u09ef":"9","\u09e6":"0"},ss=(c.defineLocale("bn",{months:"\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),monthsShort:"\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),weekdays:"\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),weekdaysShort:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),weekdaysMin:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),longDateFormat:{LT:"A h:mm \u09b8\u09ae\u09df",LTS:"A h:mm:ss \u09b8\u09ae\u09df",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",LLLL:"dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"},calendar:{sameDay:"[\u0986\u099c] LT",nextDay:"[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",nextWeek:"dddd, LT",lastDay:"[\u0997\u09a4\u0995\u09be\u09b2] LT",lastWeek:"[\u0997\u09a4] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u09aa\u09b0\u09c7",past:"%s \u0986\u0997\u09c7",s:"\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",ss:"%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",m:"\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",mm:"%d \u09ae\u09bf\u09a8\u09bf\u099f",h:"\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",hh:"%d \u0998\u09a8\u09cd\u099f\u09be",d:"\u098f\u0995 \u09a6\u09bf\u09a8",dd:"%d \u09a6\u09bf\u09a8",M:"\u098f\u0995 \u09ae\u09be\u09b8",MM:"%d \u09ae\u09be\u09b8",y:"\u098f\u0995 \u09ac\u099b\u09b0",yy:"%d \u09ac\u099b\u09b0"},preparse:function(e){return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,function(e){return ts[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return as[e]})},meridiemParse:/\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u09b0\u09be\u09a4"===a&&4<=e||"\u09a6\u09c1\u09aa\u09c1\u09b0"===a&&e<5||"\u09ac\u09bf\u0995\u09be\u09b2"===a?e+12:e},meridiem:function(e,a,t){return e<4?"\u09b0\u09be\u09a4":e<10?"\u09b8\u0995\u09be\u09b2":e<17?"\u09a6\u09c1\u09aa\u09c1\u09b0":e<20?"\u09ac\u09bf\u0995\u09be\u09b2":"\u09b0\u09be\u09a4"},week:{dow:0,doy:6}}),{1:"\u0f21",2:"\u0f22",3:"\u0f23",4:"\u0f24",5:"\u0f25",6:"\u0f26",7:"\u0f27",8:"\u0f28",9:"\u0f29",0:"\u0f20"}),ns={"\u0f21":"1","\u0f22":"2","\u0f23":"3","\u0f24":"4","\u0f25":"5","\u0f26":"6","\u0f27":"7","\u0f28":"8","\u0f29":"9","\u0f20":"0"};function rs(e,a,t){return e+" "+(t={mm:"munutenn",MM:"miz",dd:"devezh"}[t],2!==(e=e)?t:void 0!==(e={m:"v",b:"v",d:"z"})[(t=t).charAt(0)]?e[t.charAt(0)]+t.substring(1):t)}c.defineLocale("bo",{months:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),monthsShort:"\u0f5f\u0fb3\u0f0b1_\u0f5f\u0fb3\u0f0b2_\u0f5f\u0fb3\u0f0b3_\u0f5f\u0fb3\u0f0b4_\u0f5f\u0fb3\u0f0b5_\u0f5f\u0fb3\u0f0b6_\u0f5f\u0fb3\u0f0b7_\u0f5f\u0fb3\u0f0b8_\u0f5f\u0fb3\u0f0b9_\u0f5f\u0fb3\u0f0b10_\u0f5f\u0fb3\u0f0b11_\u0f5f\u0fb3\u0f0b12".split("_"),monthsShortRegex:/^(\u0f5f\u0fb3\u0f0b\d{1,2})/,monthsParseExact:!0,weekdays:"\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysShort:"\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysMin:"\u0f49\u0f72_\u0f5f\u0fb3_\u0f58\u0f72\u0f42_\u0f63\u0fb7\u0f42_\u0f55\u0f74\u0f62_\u0f66\u0f44\u0f66_\u0f66\u0fa4\u0f7a\u0f53".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",nextDay:"[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",nextWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",lastDay:"[\u0f41\u0f0b\u0f66\u0f44] LT",lastWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0f63\u0f0b",past:"%s \u0f66\u0f94\u0f53\u0f0b\u0f63",s:"\u0f63\u0f58\u0f0b\u0f66\u0f44",ss:"%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",m:"\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",mm:"%d \u0f66\u0f90\u0f62\u0f0b\u0f58",h:"\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",hh:"%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",d:"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",dd:"%d \u0f49\u0f72\u0f53\u0f0b",M:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",MM:"%d \u0f5f\u0fb3\u0f0b\u0f56",y:"\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",yy:"%d \u0f63\u0f7c"},preparse:function(e){return e.replace(/[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g,function(e){return ns[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return ss[e]})},meridiemParse:/\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"===a&&4<=e||"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44"===a&&e<5||"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42"===a?e+12:e},meridiem:function(e,a,t){return e<4?"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c":e<10?"\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66":e<17?"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44":e<20?"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42":"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"},week:{dow:0,doy:6}});Ye=[/^gen/i,/^c[\u02bc\']hwe/i,/^meu/i,/^ebr/i,/^mae/i,/^(mez|eve)/i,/^gou/i,/^eos/i,/^gwe/i,/^her/i,/^du/i,/^ker/i],Ie=/^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,_=[/^Su/i,/^Lu/i,/^Me([^r]|$)/i,/^Mer/i,/^Ya/i,/^Gw/i,/^Sa/i];function ds(e,a,t){var s=e+" ";switch(t){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"mm":return s+=1!==e&&(2===e||3===e||4===e)?"minute":"minuta";case"h":return"jedan sat";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1!==e&&(2===e||3===e||4===e)?"godine":"godina"}}c.defineLocale("br",{months:"Genver_C\u02bchwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_C\u02bchwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Merc\u02bcher_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParse:_,fullWeekdaysParse:[/^sul/i,/^lun/i,/^meurzh/i,/^merc[\u02bc\']her/i,/^yaou/i,/^gwener/i,/^sadorn/i],shortWeekdaysParse:[/^Sul/i,/^Lun/i,/^Meu/i,/^Mer/i,/^Yao/i,/^Gwe/i,/^Sad/i],minWeekdaysParse:_,monthsRegex:Ie,monthsShortRegex:Ie,monthsStrictRegex:/^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,monthsShortStrictRegex:/^(gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,monthsParse:Ye,longMonthsParse:Ye,shortMonthsParse:Ye,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY HH:mm",LLLL:"dddd, D [a viz] MMMM YYYY HH:mm"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warc\u02bchoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Dec\u02bch da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s \u02bczo",s:"un nebeud segondenno\xf9",ss:"%d eilenn",m:"ur vunutenn",mm:rs,h:"un eur",hh:"%d eur",d:"un devezh",dd:rs,M:"ur miz",MM:rs,y:"ur bloaz",yy:function(e){switch(function e(a){if(9<a)return e(a%10);return a}(e)){case 1:case 3:case 4:case 5:case 9:return e+" bloaz";default:return e+" vloaz"}}},dayOfMonthOrdinalParse:/\d{1,2}(a\xf1|vet)/,ordinal:function(e){return e+(1===e?"a\xf1":"vet")},week:{dow:1,doy:4},meridiemParse:/a.m.|g.m./,isPM:function(e){return"g.m."===e},meridiem:function(e,a,t){return e<12?"a.m.":"g.m."}}),c.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[pro\u0161lu] dddd [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:ds,m:function(e,a,t,s){switch(t){case"m":return a?"jedna minuta":s?"jednu minutu":"jedne minute"}},mm:ds,h:ds,hh:ds,d:"dan",dd:ds,M:"mjesec",MM:ds,y:"godinu",yy:ds},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),c.defineLocale("ca",{months:{standalone:"gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[dem\xe0 a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aqu\xed %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|\xe8|a)/,ordinal:function(e,a){return e+("w"!==a&&"W"!==a?1===e?"r":2===e?"n":3===e?"r":4===e?"t":"\xe8":"a")},week:{dow:1,doy:4}});ye={standalone:"leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split("_"),format:"ledna_\xfanora_b\u0159ezna_dubna_kv\u011btna_\u010dervna_\u010dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split("_"),isFormat:/DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/},na="led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_"),m=[/^led/i,/^\xfano/i,/^b\u0159e/i,/^dub/i,/^kv\u011b/i,/^(\u010dvn|\u010derven$|\u010dervna)/i,/^(\u010dvc|\u010dervenec|\u010dervence)/i,/^srp/i,/^z\xe1\u0159/i,/^\u0159\xedj/i,/^lis/i,/^pro/i],t=/^(leden|\xfanor|b\u0159ezen|duben|kv\u011bten|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|z\xe1\u0159\xed|\u0159\xedjen|listopad|prosinec|led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i;function _s(e){return 1<e&&e<5&&1!=~~(e/10)}function j(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"p\xe1r sekund":"p\xe1r sekundami";case"ss":return a||s?n+(_s(e)?"sekundy":"sekund"):n+"sekundami";case"m":return a?"minuta":s?"minutu":"minutou";case"mm":return a||s?n+(_s(e)?"minuty":"minut"):n+"minutami";case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?n+(_s(e)?"hodiny":"hodin"):n+"hodinami";case"d":return a||s?"den":"dnem";case"dd":return a||s?n+(_s(e)?"dny":"dn\xed"):n+"dny";case"M":return a||s?"m\u011bs\xedc":"m\u011bs\xedcem";case"MM":return a||s?n+(_s(e)?"m\u011bs\xedce":"m\u011bs\xedc\u016f"):n+"m\u011bs\xedci";case"y":return a||s?"rok":"rokem";case"yy":return a||s?n+(_s(e)?"roky":"let"):n+"lety"}}function is(e,a,t,s){e={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?e[t][0]:e[t][1]}function os(e,a,t,s){e={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?e[t][0]:e[t][1]}function ms(e,a,t,s){e={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?e[t][0]:e[t][1]}c.defineLocale("cs",{months:ye,monthsShort:na,monthsRegex:t,monthsShortRegex:t,monthsStrictRegex:/^(leden|ledna|\xfanora|\xfanor|b\u0159ezen|b\u0159ezna|duben|dubna|kv\u011bten|kv\u011btna|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|srpna|z\xe1\u0159\xed|\u0159\xedjen|\u0159\xedjna|listopadu|listopad|prosinec|prosince)/i,monthsShortStrictRegex:/^(led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i,monthsParse:m,longMonthsParse:m,shortMonthsParse:m,weekdays:"ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split("_"),weekdaysShort:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),weekdaysMin:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[z\xedtra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v ned\u011bli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve st\u0159edu v] LT";case 4:return"[ve \u010dtvrtek v] LT";case 5:return"[v p\xe1tek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[v\u010dera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou ned\u011bli v] LT";case 1:case 2:return"[minul\xe9] dddd [v] LT";case 3:return"[minulou st\u0159edu v] LT";case 4:case 5:return"[minul\xfd] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"p\u0159ed %s",s:j,ss:j,m:j,mm:j,h:j,hh:j,d:j,dd:j,M:j,MM:j,y:j,yy:j},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("cv",{months:"\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split("_"),monthsShort:"\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split("_"),weekdays:"\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split("_"),weekdaysShort:"\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split("_"),weekdaysMin:"\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",LLL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",LLLL:"dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm"},calendar:{sameDay:"[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextDay:"[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastDay:"[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextWeek:"[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastWeek:"[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",sameElse:"L"},relativeTime:{future:function(e){return e+(/\u0441\u0435\u0445\u0435\u0442$/i.exec(e)?"\u0440\u0435\u043d":/\u04ab\u0443\u043b$/i.exec(e)?"\u0442\u0430\u043d":"\u0440\u0430\u043d")},past:"%s \u043a\u0430\u044f\u043b\u043b\u0430",s:"\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",ss:"%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",m:"\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",hh:"%d \u0441\u0435\u0445\u0435\u0442",d:"\u043f\u04d7\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",MM:"%d \u0443\u0439\u04d1\u0445",y:"\u043f\u04d7\u0440 \u04ab\u0443\u043b",yy:"%d \u04ab\u0443\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-\u043c\u04d7\u0448/,ordinal:"%d-\u043c\u04d7\u0448",week:{dow:1,doy:7}}),c.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn \xf4l",s:"ychydig eiliadau",ss:"%d eiliad",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},dayOfMonthOrdinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var a="";return 20<e?a=40===e||50===e||60===e||80===e||100===e?"fed":"ain":0<e&&(a=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"][e]),e+a},week:{dow:1,doy:4}}),c.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"p\xe5 dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"f\xe5 sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"et \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("de-at",{months:"J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:is,mm:"%d Minuten",h:is,hh:"%d Stunden",d:is,dd:is,w:is,ww:"%d Wochen",M:is,MM:is,y:is,yy:is},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("de-ch",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:os,mm:"%d Minuten",h:os,hh:"%d Stunden",d:os,dd:os,w:os,ww:"%d Wochen",M:os,MM:os,y:os,yy:os},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("de",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:ms,mm:"%d Minuten",h:ms,hh:"%d Stunden",d:ms,dd:ms,w:ms,ww:"%d Wochen",M:ms,MM:ms,y:ms,yy:ms},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});o=["\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9","\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9","\u0789\u07a7\u0783\u07a8\u0797\u07aa","\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa","\u0789\u07ad","\u0796\u07ab\u0782\u07b0","\u0796\u07aa\u078d\u07a6\u0787\u07a8","\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa","\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa","\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa"],n=["\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6","\u0780\u07af\u0789\u07a6","\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6","\u0784\u07aa\u078b\u07a6","\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8","\u0780\u07aa\u0786\u07aa\u0783\u07aa","\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa"];c.defineLocale("dv",{months:o,monthsShort:o,weekdays:n,weekdaysShort:n,weekdaysMin:"\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0789\u0786|\u0789\u078a/,isPM:function(e){return"\u0789\u078a"===e},meridiem:function(e,a,t){return e<12?"\u0789\u0786":"\u0789\u078a"},calendar:{sameDay:"[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",nextDay:"[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",nextWeek:"dddd LT",lastDay:"[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",lastWeek:"[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",sameElse:"L"},relativeTime:{future:"\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",past:"\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",s:"\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",ss:"d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",m:"\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",mm:"\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",h:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",hh:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",d:"\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",dd:"\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",M:"\u0789\u07a6\u0780\u07ac\u0787\u07b0",MM:"\u0789\u07a6\u0790\u07b0 %d",y:"\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",yy:"\u0787\u07a6\u0780\u07a6\u0783\u07aa %d"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:7,doy:12}}),c.defineLocale("el",{monthsNominativeEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split("_"),monthsGenitiveEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split("_"),months:function(e,a){return e?("string"==typeof a&&/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl:this._monthsNominativeEl)[e.month()]:this._monthsNominativeEl},monthsShort:"\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split("_"),weekdays:"\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split("_"),weekdaysShort:"\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split("_"),weekdaysMin:"\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split("_"),meridiem:function(e,a,t){return 11<e?t?"\u03bc\u03bc":"\u039c\u039c":t?"\u03c0\u03bc":"\u03a0\u039c"},isPM:function(e){return"\u03bc"===(e+"").toLowerCase()[0]},meridiemParse:/[\u03a0\u039c]\.?\u039c?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",nextDay:"[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[\u03a7\u03b8\u03b5\u03c2 {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";default:return"[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,a){var t,e=this._calendarEl[e],s=a&&a.hours();return t=e,(e="undefined"!=typeof Function&&t instanceof Function||"[object Function]"===Object.prototype.toString.call(t)?e.apply(a):e).replace("{}",s%12==1?"\u03c3\u03c4\u03b7":"\u03c3\u03c4\u03b9\u03c2")},relativeTime:{future:"\u03c3\u03b5 %s",past:"%s \u03c0\u03c1\u03b9\u03bd",s:"\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",ss:"%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",m:"\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",mm:"%d \u03bb\u03b5\u03c0\u03c4\u03ac",h:"\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",hh:"%d \u03ce\u03c1\u03b5\u03c2",d:"\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",dd:"%d \u03bc\u03ad\u03c1\u03b5\u03c2",M:"\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",MM:"%d \u03bc\u03ae\u03bd\u03b5\u03c2",y:"\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",yy:"%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1"},dayOfMonthOrdinalParse:/\d{1,2}\u03b7/,ordinal:"%d\u03b7",week:{dow:1,doy:4}}),c.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:0,doy:4}}),c.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")}}),c.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),c.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),c.defineLocale("en-il",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")}}),c.defineLocale("en-in",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:0,doy:6}}),c.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),c.defineLocale("en-sg",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),c.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mart_apr_maj_jun_jul_a\u016dg_sept_okt_nov_dec".split("_"),weekdays:"diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split("_"),weekdaysShort:"dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),weekdaysMin:"di_lu_ma_me_\u0135a_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"[la] D[-an de] MMMM, YYYY",LLL:"[la] D[-an de] MMMM, YYYY HH:mm",LLLL:"dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",llll:"ddd, [la] D[-an de] MMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(e){return"p"===e.charAt(0).toLowerCase()},meridiem:function(e,a,t){return 11<e?t?"p.t.m.":"P.T.M.":t?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodia\u016d je] LT",nextDay:"[Morga\u016d je] LT",nextWeek:"dddd[n je] LT",lastDay:"[Hiera\u016d je] LT",lastWeek:"[pasintan] dddd[n je] LT",sameElse:"L"},relativeTime:{future:"post %s",past:"anta\u016d %s",s:"kelkaj sekundoj",ss:"%d sekundoj",m:"unu minuto",mm:"%d minutoj",h:"unu horo",hh:"%d horoj",d:"unu tago",dd:"%d tagoj",M:"unu monato",MM:"%d monatoj",y:"unu jaro",yy:"%d jaroj"},dayOfMonthOrdinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}});var us="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),ls="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),i=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],ze=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,Ms=(c.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?ls:us)[e.month()]:us},monthsRegex:ze,monthsShortRegex:ze,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")),hs="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),M=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],jt=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,cs=(c.defineLocale("es-mx",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?hs:Ms)[e.month()]:Ms},monthsRegex:jt,monthsShortRegex:jt,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:M,longMonthsParse:M,shortMonthsParse:M,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:0,doy:4},invalidDate:"Fecha inv\xe1lida"}),"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")),Ls="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),xt=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],v=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,Ys=(c.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?Ls:cs)[e.month()]:cs},monthsRegex:v,monthsShortRegex:v,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:xt,longMonthsParse:xt,shortMonthsParse:xt,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:0,doy:6}}),"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")),ys="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),da=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],pe=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;function fs(e,a,t,s){e={s:["m\xf5ne sekundi","m\xf5ni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["\xfche minuti","\xfcks minut"],mm:[e+" minuti",e+" minutit"],h:["\xfche tunni","tund aega","\xfcks tund"],hh:[e+" tunni",e+" tundi"],d:["\xfche p\xe4eva","\xfcks p\xe4ev"],M:["kuu aja","kuu aega","\xfcks kuu"],MM:[e+" kuu",e+" kuud"],y:["\xfche aasta","aasta","\xfcks aasta"],yy:[e+" aasta",e+" aastat"]};return a?e[t][2]||e[t][1]:s?e[t][0]:e[t][1]}c.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?ys:Ys)[e.month()]:Ys},monthsRegex:pe,monthsShortRegex:pe,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:da,longMonthsParse:da,shortMonthsParse:da,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4},invalidDate:"Fecha inv\xe1lida"}),c.defineLocale("et",{months:"jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[T\xe4na,] LT",nextDay:"[Homme,] LT",nextWeek:"[J\xe4rgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s p\xe4rast",past:"%s tagasi",s:fs,ss:fs,m:fs,mm:fs,h:fs,hh:fs,d:fs,dd:"%d p\xe4eva",M:fs,MM:fs,y:fs,yy:fs},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var ks={1:"\u06f1",2:"\u06f2",3:"\u06f3",4:"\u06f4",5:"\u06f5",6:"\u06f6",7:"\u06f7",8:"\u06f8",9:"\u06f9",0:"\u06f0"},ps={"\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9","\u06f0":"0"},Ds=(c.defineLocale("fa",{months:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),monthsShort:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),weekdays:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysShort:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,isPM:function(e){return/\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(e)},meridiem:function(e,a,t){return e<12?"\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631":"\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631"},calendar:{sameDay:"[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",nextDay:"[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",nextWeek:"dddd [\u0633\u0627\u0639\u062a] LT",lastDay:"[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",lastWeek:"dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",sameElse:"L"},relativeTime:{future:"\u062f\u0631 %s",past:"%s \u067e\u06cc\u0634",s:"\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",ss:"%d \u062b\u0627\u0646\u06cc\u0647",m:"\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",mm:"%d \u062f\u0642\u06cc\u0642\u0647",h:"\u06cc\u06a9 \u0633\u0627\u0639\u062a",hh:"%d \u0633\u0627\u0639\u062a",d:"\u06cc\u06a9 \u0631\u0648\u0632",dd:"%d \u0631\u0648\u0632",M:"\u06cc\u06a9 \u0645\u0627\u0647",MM:"%d \u0645\u0627\u0647",y:"\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/[\u06f0-\u06f9]/g,function(e){return ps[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return ks[e]}).replace(/,/g,"\u060c")},dayOfMonthOrdinalParse:/\d{1,2}\u0645/,ordinal:"%d\u0645",week:{dow:6,doy:12}}),"nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" ")),Ts=["nolla","yhden","kahden","kolmen","nelj\xe4n","viiden","kuuden",Ds[7],Ds[8],Ds[9]];function x(e,a,t,s){var n="";switch(t){case"s":return s?"muutaman sekunnin":"muutama sekunti";case"ss":n=s?"sekunnin":"sekuntia";break;case"m":return s?"minuutin":"minuutti";case"mm":n=s?"minuutin":"minuuttia";break;case"h":return s?"tunnin":"tunti";case"hh":n=s?"tunnin":"tuntia";break;case"d":return s?"p\xe4iv\xe4n":"p\xe4iv\xe4";case"dd":n=s?"p\xe4iv\xe4n":"p\xe4iv\xe4\xe4";break;case"M":return s?"kuukauden":"kuukausi";case"MM":n=s?"kuukauden":"kuukautta";break;case"y":return s?"vuoden":"vuosi";case"yy":n=s?"vuoden":"vuotta";break}return t=s,n=((e=e)<10?(t?Ts:Ds)[e]:e)+" "+n}c.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[t\xe4n\xe4\xe4n] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s p\xe4\xe4st\xe4",past:"%s sitten",s:x,ss:x,m:x,mm:x,h:x,hh:x,d:x,dd:x,M:x,MM:x,y:x,yy:x},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("fil",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),c.defineLocale("fo",{months:"januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),weekdaysShort:"sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),weekdaysMin:"su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[\xcd dag kl.] LT",nextDay:"[\xcd morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xcd gj\xe1r kl.] LT",lastWeek:"[s\xed\xf0stu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s s\xed\xf0ani",s:"f\xe1 sekund",ss:"%d sekundir",m:"ein minuttur",mm:"%d minuttir",h:"ein t\xedmi",hh:"%d t\xedmar",d:"ein dagur",dd:"%d dagar",M:"ein m\xe1na\xf0ur",MM:"%d m\xe1na\xf0ir",y:"eitt \xe1r",yy:"%d \xe1r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("fr-ca",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}}),c.defineLocale("fr-ch",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}});var u=/(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?|janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,Le=[/^janv/i,/^f\xe9vr/i,/^mars/i,/^avr/i,/^mai/i,/^juin/i,/^juil/i,/^ao\xfbt/i,/^sept/i,/^oct/i,/^nov/i,/^d\xe9c/i],gs=(c.defineLocale("fr",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsRegex:u,monthsShortRegex:u,monthsStrictRegex:/^(janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,monthsShortStrictRegex:/(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?)/i,monthsParse:Le,longMonthsParse:Le,shortMonthsParse:Le,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",w:"une semaine",ww:"%d semaines",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}}),"jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_")),ws="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");c.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?ws:gs)[e.month()]:gs},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[\xf4fr\xfbne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",ss:"%d sekonden",m:"ien min\xfat",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),c.defineLocale("ga",{months:["Ean\xe1ir","Feabhra","M\xe1rta","Aibre\xe1n","Bealtaine","Meitheamh","I\xfail","L\xfanasa","Me\xe1n F\xf3mhair","Deireadh F\xf3mhair","Samhain","Nollaig"],monthsShort:["Ean","Feabh","M\xe1rt","Aib","Beal","Meith","I\xfail","L\xfan","M.F.","D.F.","Samh","Noll"],monthsParseExact:!0,weekdays:["D\xe9 Domhnaigh","D\xe9 Luain","D\xe9 M\xe1irt","D\xe9 C\xe9adaoin","D\xe9ardaoin","D\xe9 hAoine","D\xe9 Sathairn"],weekdaysShort:["Domh","Luan","M\xe1irt","C\xe9ad","D\xe9ar","Aoine","Sath"],weekdaysMin:["Do","Lu","M\xe1","C\xe9","D\xe9","A","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Inniu ag] LT",nextDay:"[Am\xe1rach ag] LT",nextWeek:"dddd [ag] LT",lastDay:"[Inn\xe9 ag] LT",lastWeek:"dddd [seo caite] [ag] LT",sameElse:"L"},relativeTime:{future:"i %s",past:"%s \xf3 shin",s:"c\xfapla soicind",ss:"%d soicind",m:"n\xf3im\xe9ad",mm:"%d n\xf3im\xe9ad",h:"uair an chloig",hh:"%d uair an chloig",d:"l\xe1",dd:"%d l\xe1",M:"m\xed",MM:"%d m\xedonna",y:"bliain",yy:"%d bliain"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}});function P(e,a,t,s){e={s:["\u0925\u094b\u0921\u092f\u093e \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940","\u0925\u094b\u0921\u0947 \u0938\u0945\u0915\u0902\u0921"],ss:[e+" \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",e+" \u0938\u0945\u0915\u0902\u0921"],m:["\u090f\u0915\u093e \u092e\u093f\u0923\u091f\u093e\u0928","\u090f\u0915 \u092e\u093f\u0928\u0942\u091f"],mm:[e+" \u092e\u093f\u0923\u091f\u093e\u0902\u0928\u0940",e+" \u092e\u093f\u0923\u091f\u093e\u0902"],h:["\u090f\u0915\u093e \u0935\u0930\u093e\u0928","\u090f\u0915 \u0935\u0930"],hh:[e+" \u0935\u0930\u093e\u0902\u0928\u0940",e+" \u0935\u0930\u093e\u0902"],d:["\u090f\u0915\u093e \u0926\u093f\u0938\u093e\u0928","\u090f\u0915 \u0926\u0940\u0938"],dd:[e+" \u0926\u093f\u0938\u093e\u0902\u0928\u0940",e+" \u0926\u0940\u0938"],M:["\u090f\u0915\u093e \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928","\u090f\u0915 \u092e\u094d\u0939\u092f\u0928\u094b"],MM:[e+" \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928\u0940",e+" \u092e\u094d\u0939\u092f\u0928\u0947"],y:["\u090f\u0915\u093e \u0935\u0930\u094d\u0938\u093e\u0928","\u090f\u0915 \u0935\u0930\u094d\u0938"],yy:[e+" \u0935\u0930\u094d\u0938\u093e\u0902\u0928\u0940",e+" \u0935\u0930\u094d\u0938\u093e\u0902"]};return s?e[t][0]:e[t][1]}function bs(e,a,t,s){e={s:["thoddea sekondamni","thodde sekond"],ss:[e+" sekondamni",e+" sekond"],m:["eka mintan","ek minut"],mm:[e+" mintamni",e+" mintam"],h:["eka voran","ek vor"],hh:[e+" voramni",e+" voram"],d:["eka disan","ek dis"],dd:[e+" disamni",e+" dis"],M:["eka mhoinean","ek mhoino"],MM:[e+" mhoineamni",e+" mhoine"],y:["eka vorsan","ek voros"],yy:[e+" vorsamni",e+" vorsam"]};return s?e[t][0]:e[t][1]}c.defineLocale("gd",{months:["Am Faoilleach","An Gearran","Am M\xe0rt","An Giblean","An C\xe8itean","An t-\xd2gmhios","An t-Iuchar","An L\xf9nastal","An t-Sultain","An D\xe0mhair","An t-Samhain","An D\xf9bhlachd"],monthsShort:["Faoi","Gear","M\xe0rt","Gibl","C\xe8it","\xd2gmh","Iuch","L\xf9n","Sult","D\xe0mh","Samh","D\xf9bh"],monthsParseExact:!0,weekdays:["Did\xf2mhnaich","Diluain","Dim\xe0irt","Diciadain","Diardaoin","Dihaoine","Disathairne"],weekdaysShort:["Did","Dil","Dim","Dic","Dia","Dih","Dis"],weekdaysMin:["D\xf2","Lu","M\xe0","Ci","Ar","Ha","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-m\xe0ireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-d\xe8 aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",ss:"%d diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"m\xecos",MM:"%d m\xecosan",y:"bliadhna",yy:"%d bliadhna"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}}),c.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextDay:function(){return"[ma\xf1\xe1 "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"\xe1s":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"\xe1":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"\xe1s":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),c.defineLocale("gom-deva",{months:{standalone:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u092f_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),format:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092e\u093e\u0930\u094d\u091a\u093e\u091a\u094d\u092f\u093e_\u090f\u092a\u094d\u0930\u0940\u0932\u093e\u091a\u094d\u092f\u093e_\u092e\u0947\u092f\u093e\u091a\u094d\u092f\u093e_\u091c\u0942\u0928\u093e\u091a\u094d\u092f\u093e_\u091c\u0941\u0932\u092f\u093e\u091a\u094d\u092f\u093e_\u0911\u0917\u0938\u094d\u091f\u093e\u091a\u094d\u092f\u093e_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0911\u0915\u094d\u091f\u094b\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0921\u093f\u0938\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940._\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),monthsParseExact:!0,weekdays:"\u0906\u092f\u0924\u093e\u0930_\u0938\u094b\u092e\u093e\u0930_\u092e\u0902\u0917\u0933\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u092c\u093f\u0930\u0947\u0938\u094d\u0924\u093e\u0930_\u0938\u0941\u0915\u094d\u0930\u093e\u0930_\u0936\u0947\u0928\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0906\u092f\u0924._\u0938\u094b\u092e._\u092e\u0902\u0917\u0933._\u092c\u0941\u0927._\u092c\u094d\u0930\u0947\u0938\u094d\u0924._\u0938\u0941\u0915\u094d\u0930._\u0936\u0947\u0928.".split("_"),weekdaysMin:"\u0906_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u092c\u094d\u0930\u0947_\u0938\u0941_\u0936\u0947".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",LTS:"A h:mm:ss [\u0935\u093e\u091c\u0924\u093e\u0902]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",llll:"ddd, D MMM YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]"},calendar:{sameDay:"[\u0906\u092f\u091c] LT",nextDay:"[\u092b\u093e\u0932\u094d\u092f\u093e\u0902] LT",nextWeek:"[\u092b\u0941\u0921\u0932\u094b] dddd[,] LT",lastDay:"[\u0915\u093e\u0932] LT",lastWeek:"[\u092b\u093e\u091f\u0932\u094b] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s \u0906\u0926\u0940\u0902",s:P,ss:P,m:P,mm:P,h:P,hh:P,d:P,dd:P,M:P,MM:P,y:P,yy:P},dayOfMonthOrdinalParse:/\d{1,2}(\u0935\u0947\u0930)/,ordinal:function(e,a){switch(a){case"D":return e+"\u0935\u0947\u0930";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return e}},week:{dow:0,doy:3},meridiemParse:/\u0930\u093e\u0924\u0940|\u0938\u0915\u093e\u0933\u0940\u0902|\u0926\u0928\u092a\u093e\u0930\u093e\u0902|\u0938\u093e\u0902\u091c\u0947/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u0940"===a?e<4?e:e+12:"\u0938\u0915\u093e\u0933\u0940\u0902"===a?e:"\u0926\u0928\u092a\u093e\u0930\u093e\u0902"===a?12<e?e:e+12:"\u0938\u093e\u0902\u091c\u0947"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0930\u093e\u0924\u0940":e<12?"\u0938\u0915\u093e\u0933\u0940\u0902":e<16?"\u0926\u0928\u092a\u093e\u0930\u093e\u0902":e<20?"\u0938\u093e\u0902\u091c\u0947":"\u0930\u093e\u0924\u0940"}}),c.defineLocale("gom-latn",{months:{standalone:"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),format:"Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),weekdaysShort:"Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),weekdaysMin:"Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [vazta]",LTS:"A h:mm:ss [vazta]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [vazta]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [vazta]",llll:"ddd, D MMM YYYY, A h:mm [vazta]"},calendar:{sameDay:"[Aiz] LT",nextDay:"[Faleam] LT",nextWeek:"[Fuddlo] dddd[,] LT",lastDay:"[Kal] LT",lastWeek:"[Fattlo] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s adim",s:bs,ss:bs,m:bs,mm:bs,h:bs,hh:bs,d:bs,dd:bs,M:bs,MM:bs,y:bs,yy:bs},dayOfMonthOrdinalParse:/\d{1,2}(er)/,ordinal:function(e,a){switch(a){case"D":return e+"er";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return e}},week:{dow:0,doy:3},meridiemParse:/rati|sokallim|donparam|sanje/,meridiemHour:function(e,a){return 12===e&&(e=0),"rati"===a?e<4?e:e+12:"sokallim"===a?e:"donparam"===a?12<e?e:e+12:"sanje"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"rati":e<12?"sokallim":e<16?"donparam":e<20?"sanje":"rati"}});var Hs={1:"\u0ae7",2:"\u0ae8",3:"\u0ae9",4:"\u0aea",5:"\u0aeb",6:"\u0aec",7:"\u0aed",8:"\u0aee",9:"\u0aef",0:"\u0ae6"},Ss={"\u0ae7":"1","\u0ae8":"2","\u0ae9":"3","\u0aea":"4","\u0aeb":"5","\u0aec":"6","\u0aed":"7","\u0aee":"8","\u0aef":"9","\u0ae6":"0"},vs=(c.defineLocale("gu",{months:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split("_"),monthsShort:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split("_"),monthsParseExact:!0,weekdays:"\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split("_"),weekdaysShort:"\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split("_"),weekdaysMin:"\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split("_"),longDateFormat:{LT:"A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LTS:"A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LLLL:"dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7"},calendar:{sameDay:"[\u0a86\u0a9c] LT",nextDay:"[\u0a95\u0abe\u0ab2\u0ac7] LT",nextWeek:"dddd, LT",lastDay:"[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",lastWeek:"[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0aae\u0abe",past:"%s \u0aaa\u0ab9\u0ac7\u0ab2\u0abe",s:"\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",ss:"%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",m:"\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",mm:"%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",h:"\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",hh:"%d \u0a95\u0ab2\u0abe\u0a95",d:"\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",dd:"%d \u0aa6\u0abf\u0ab5\u0ab8",M:"\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",MM:"%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",y:"\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",yy:"%d \u0ab5\u0ab0\u0acd\u0ab7"},preparse:function(e){return e.replace(/[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g,function(e){return Ss[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Hs[e]})},meridiemParse:/\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0ab0\u0abe\u0aa4"===a?e<4?e:e+12:"\u0ab8\u0ab5\u0abe\u0ab0"===a?e:"\u0aac\u0aaa\u0acb\u0ab0"===a?10<=e?e:e+12:"\u0ab8\u0abe\u0a82\u0a9c"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0ab0\u0abe\u0aa4":e<10?"\u0ab8\u0ab5\u0abe\u0ab0":e<17?"\u0aac\u0aaa\u0acb\u0ab0":e<20?"\u0ab8\u0abe\u0a82\u0a9c":"\u0ab0\u0abe\u0aa4"},week:{dow:0,doy:6}}),c.defineLocale("he",{months:"\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split("_"),monthsShort:"\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split("_"),weekdays:"\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split("_"),weekdaysShort:"\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split("_"),weekdaysMin:"\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [\u05d1]MMMM YYYY",LLL:"D [\u05d1]MMMM YYYY HH:mm",LLLL:"dddd, D [\u05d1]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",nextDay:"[\u05de\u05d7\u05e8 \u05d1\u05be]LT",nextWeek:"dddd [\u05d1\u05e9\u05e2\u05d4] LT",lastDay:"[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",lastWeek:"[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",sameElse:"L"},relativeTime:{future:"\u05d1\u05e2\u05d5\u05d3 %s",past:"\u05dc\u05e4\u05e0\u05d9 %s",s:"\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",ss:"%d \u05e9\u05e0\u05d9\u05d5\u05ea",m:"\u05d3\u05e7\u05d4",mm:"%d \u05d3\u05e7\u05d5\u05ea",h:"\u05e9\u05e2\u05d4",hh:function(e){return 2===e?"\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd":e+" \u05e9\u05e2\u05d5\u05ea"},d:"\u05d9\u05d5\u05dd",dd:function(e){return 2===e?"\u05d9\u05d5\u05de\u05d9\u05d9\u05dd":e+" \u05d9\u05de\u05d9\u05dd"},M:"\u05d7\u05d5\u05d3\u05e9",MM:function(e){return 2===e?"\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd":e+" \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd"},y:"\u05e9\u05e0\u05d4",yy:function(e){return 2===e?"\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd":e%10==0&&10!==e?e+" \u05e9\u05e0\u05d4":e+" \u05e9\u05e0\u05d9\u05dd"}},meridiemParse:/\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,isPM:function(e){return/^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(e)},meridiem:function(e,a,t){return e<5?"\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8":e<10?"\u05d1\u05d1\u05d5\u05e7\u05e8":e<12?t?'\u05dc\u05e4\u05e0\u05d4"\u05e6':"\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":e<18?t?'\u05d0\u05d7\u05d4"\u05e6':"\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":"\u05d1\u05e2\u05e8\u05d1"}}),{1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"}),js={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"},a=[/^\u091c\u0928/i,/^\u092b\u093c\u0930|\u092b\u0930/i,/^\u092e\u093e\u0930\u094d\u091a/i,/^\u0905\u092a\u094d\u0930\u0948/i,/^\u092e\u0908/i,/^\u091c\u0942\u0928/i,/^\u091c\u0941\u0932/i,/^\u0905\u0917/i,/^\u0938\u093f\u0924\u0902|\u0938\u093f\u0924/i,/^\u0905\u0915\u094d\u091f\u0942/i,/^\u0928\u0935|\u0928\u0935\u0902/i,/^\u0926\u093f\u0938\u0902|\u0926\u093f\u0938/i];function xs(e,a,t){var s=e+" ";switch(t){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1!==e&&(2===e||3===e||4===e)?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1!==e&&(2===e||3===e||4===e)?"godine":"godina"}}c.defineLocale("hi",{months:{format:"\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split("_"),standalone:"\u091c\u0928\u0935\u0930\u0940_\u092b\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u0902\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u0902\u092c\u0930_\u0926\u093f\u0938\u0902\u092c\u0930".split("_")},monthsShort:"\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split("_"),weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u092c\u091c\u0947",LTS:"A h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947"},monthsParse:a,longMonthsParse:a,shortMonthsParse:[/^\u091c\u0928/i,/^\u092b\u093c\u0930/i,/^\u092e\u093e\u0930\u094d\u091a/i,/^\u0905\u092a\u094d\u0930\u0948/i,/^\u092e\u0908/i,/^\u091c\u0942\u0928/i,/^\u091c\u0941\u0932/i,/^\u0905\u0917/i,/^\u0938\u093f\u0924/i,/^\u0905\u0915\u094d\u091f\u0942/i,/^\u0928\u0935/i,/^\u0926\u093f\u0938/i],monthsRegex:/^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,monthsShortRegex:/^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,monthsStrictRegex:/^(\u091c\u0928\u0935\u0930\u0940?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908?|\u0905\u0917\u0938\u094d\u0924?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924?\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930?)/i,monthsShortStrictRegex:/^(\u091c\u0928\.?|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\.?|\u0905\u0917\.?|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\.?|\u0926\u093f\u0938\.?)/i,calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0915\u0932] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u0932] LT",lastWeek:"[\u092a\u093f\u091b\u0932\u0947] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u092e\u0947\u0902",past:"%s \u092a\u0939\u0932\u0947",s:"\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0902\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u091f",mm:"%d \u092e\u093f\u0928\u091f",h:"\u090f\u0915 \u0918\u0902\u091f\u093e",hh:"%d \u0918\u0902\u091f\u0947",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",MM:"%d \u092e\u0939\u0940\u0928\u0947",y:"\u090f\u0915 \u0935\u0930\u094d\u0937",yy:"%d \u0935\u0930\u094d\u0937"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return js[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return vs[e]})},meridiemParse:/\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924"===a?e<4?e:e+12:"\u0938\u0941\u092c\u0939"===a?e:"\u0926\u094b\u092a\u0939\u0930"===a?10<=e?e:e+12:"\u0936\u093e\u092e"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0930\u093e\u0924":e<10?"\u0938\u0941\u092c\u0939":e<17?"\u0926\u094b\u092a\u0939\u0930":e<20?"\u0936\u093e\u092e":"\u0930\u093e\u0924"},week:{dow:0,doy:6}}),c.defineLocale("hr",{months:{format:"sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"Do MMMM YYYY",LLL:"Do MMMM YYYY H:mm",LLLL:"dddd, Do MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:return"[pro\u0161lu] [nedjelju] [u] LT";case 3:return"[pro\u0161lu] [srijedu] [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:xs,m:xs,mm:xs,h:xs,hh:xs,d:"dan",dd:xs,M:"mjesec",MM:xs,y:"godinu",yy:xs},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var Ps="vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");function Os(e,a,t,s){var n=e;switch(t){case"s":return s||a?"n\xe9h\xe1ny m\xe1sodperc":"n\xe9h\xe1ny m\xe1sodperce";case"ss":return n+(s||a)?" m\xe1sodperc":" m\xe1sodperce";case"m":return"egy"+(s||a?" perc":" perce");case"mm":return n+(s||a?" perc":" perce");case"h":return"egy"+(s||a?" \xf3ra":" \xf3r\xe1ja");case"hh":return n+(s||a?" \xf3ra":" \xf3r\xe1ja");case"d":return"egy"+(s||a?" nap":" napja");case"dd":return n+(s||a?" nap":" napja");case"M":return"egy"+(s||a?" h\xf3nap":" h\xf3napja");case"MM":return n+(s||a?" h\xf3nap":" h\xf3napja");case"y":return"egy"+(s||a?" \xe9v":" \xe9ve");case"yy":return n+(s||a?" \xe9v":" \xe9ve")}return""}function Ws(e){return(e?"":"[m\xfalt] ")+"["+Ps[this.day()]+"] LT[-kor]"}function As(e){return e%100==11||e%10!=1}function Es(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"nokkrar sek\xfandur":"nokkrum sek\xfandum";case"ss":return As(e)?n+(a||s?"sek\xfandur":"sek\xfandum"):n+"sek\xfanda";case"m":return a?"m\xedn\xfata":"m\xedn\xfatu";case"mm":return As(e)?n+(a||s?"m\xedn\xfatur":"m\xedn\xfatum"):a?n+"m\xedn\xfata":n+"m\xedn\xfatu";case"hh":return As(e)?n+(a||s?"klukkustundir":"klukkustundum"):n+"klukkustund";case"d":return a?"dagur":s?"dag":"degi";case"dd":return As(e)?a?n+"dagar":n+(s?"daga":"d\xf6gum"):a?n+"dagur":n+(s?"dag":"degi");case"M":return a?"m\xe1nu\xf0ur":s?"m\xe1nu\xf0":"m\xe1nu\xf0i";case"MM":return As(e)?a?n+"m\xe1nu\xf0ir":n+(s?"m\xe1nu\xf0i":"m\xe1nu\xf0um"):a?n+"m\xe1nu\xf0ur":n+(s?"m\xe1nu\xf0":"m\xe1nu\xf0i");case"y":return a||s?"\xe1r":"\xe1ri";case"yy":return As(e)?n+(a||s?"\xe1r":"\xe1rum"):n+(a||s?"\xe1r":"\xe1ri")}}c.defineLocale("hu",{months:"janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),monthsShort:"jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),weekdaysShort:"vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,t){return e<12?!0===t?"de":"DE":!0===t?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return Ws.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return Ws.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s m\xfalva",past:"%s",s:Os,ss:Os,m:Os,mm:Os,h:Os,hh:Os,d:Os,dd:Os,M:Os,MM:Os,y:Os,yy:Os},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("hy-am",{months:{format:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split("_"),standalone:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split("_")},monthsShort:"\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split("_"),weekdays:"\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split("_"),weekdaysShort:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),weekdaysMin:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0569.",LLL:"D MMMM YYYY \u0569., HH:mm",LLLL:"dddd, D MMMM YYYY \u0569., HH:mm"},calendar:{sameDay:"[\u0561\u0575\u057d\u0585\u0580] LT",nextDay:"[\u057e\u0561\u0572\u0568] LT",lastDay:"[\u0565\u0580\u0565\u056f] LT",nextWeek:function(){return"dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},lastWeek:function(){return"[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},sameElse:"L"},relativeTime:{future:"%s \u0570\u0565\u057f\u0578",past:"%s \u0561\u057c\u0561\u057b",s:"\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",ss:"%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",m:"\u0580\u0578\u057a\u0565",mm:"%d \u0580\u0578\u057a\u0565",h:"\u056a\u0561\u0574",hh:"%d \u056a\u0561\u0574",d:"\u0585\u0580",dd:"%d \u0585\u0580",M:"\u0561\u0574\u056b\u057d",MM:"%d \u0561\u0574\u056b\u057d",y:"\u057f\u0561\u0580\u056b",yy:"%d \u057f\u0561\u0580\u056b"},meridiemParse:/\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,isPM:function(e){return/^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(e)},meridiem:function(e){return e<4?"\u0563\u056b\u0577\u0565\u0580\u057e\u0561":e<12?"\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561":e<17?"\u0581\u0565\u0580\u0565\u056f\u057e\u0561":"\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576"},dayOfMonthOrdinalParse:/\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,ordinal:function(e,a){switch(a){case"DDD":case"w":case"W":case"DDDo":return 1===e?e+"-\u056b\u0576":e+"-\u0580\u0564";default:return e}},week:{dow:1,doy:7}}),c.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?11<=e?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:0,doy:6}}),c.defineLocale("is",{months:"jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split("_"),monthsShort:"jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),weekdays:"sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split("_"),weekdaysShort:"sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),weekdaysMin:"Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[\xed dag kl.] LT",nextDay:"[\xe1 morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xed g\xe6r kl.] LT",lastWeek:"[s\xed\xf0asta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s s\xed\xf0an",s:Es,ss:Es,m:Es,mm:Es,h:"klukkustund",hh:Es,d:Es,dd:Es,M:Es,MM:Es,y:Es,yy:Es},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("it-ch",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),c.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:function(){return"[Oggi a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextDay:function(){return"[Domani a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextWeek:function(){return"dddd [a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastDay:function(){return"[Ieri a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastWeek:function(){switch(this.day()){case 0:return"[La scorsa] dddd [a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT";default:return"[Lo scorso] dddd [a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"}},sameElse:"L"},relativeTime:{future:"tra %s",past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",w:"una settimana",ww:"%d settimane",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),c.defineLocale("ja",{eras:[{since:"2019-05-01",offset:1,name:"\u4ee4\u548c",narrow:"\u32ff",abbr:"R"},{since:"1989-01-08",until:"2019-04-30",offset:1,name:"\u5e73\u6210",narrow:"\u337b",abbr:"H"},{since:"1926-12-25",until:"1989-01-07",offset:1,name:"\u662d\u548c",narrow:"\u337c",abbr:"S"},{since:"1912-07-30",until:"1926-12-24",offset:1,name:"\u5927\u6b63",narrow:"\u337d",abbr:"T"},{since:"1873-01-01",until:"1912-07-29",offset:6,name:"\u660e\u6cbb",narrow:"\u337e",abbr:"M"},{since:"0001-01-01",until:"1873-12-31",offset:1,name:"\u897f\u66a6",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"\u7d00\u5143\u524d",narrow:"BC",abbr:"BC"}],eraYearOrdinalRegex:/(\u5143|\d+)\u5e74/,eraYearOrdinalParse:function(e,a){return"\u5143"===a[1]?1:parseInt(a[1]||e,10)},months:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split("_"),weekdaysShort:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),weekdaysMin:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5(ddd) HH:mm"},meridiemParse:/\u5348\u524d|\u5348\u5f8c/i,isPM:function(e){return"\u5348\u5f8c"===e},meridiem:function(e,a,t){return e<12?"\u5348\u524d":"\u5348\u5f8c"},calendar:{sameDay:"[\u4eca\u65e5] LT",nextDay:"[\u660e\u65e5] LT",nextWeek:function(e){return e.week()!==this.week()?"[\u6765\u9031]dddd LT":"dddd LT"},lastDay:"[\u6628\u65e5] LT",lastWeek:function(e){return this.week()!==e.week()?"[\u5148\u9031]dddd LT":"dddd LT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}\u65e5/,ordinal:function(e,a){switch(a){case"y":return 1===e?"\u5143\u5e74":e+"\u5e74";case"d":case"D":case"DDD":return e+"\u65e5";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u6570\u79d2",ss:"%d\u79d2",m:"1\u5206",mm:"%d\u5206",h:"1\u6642\u9593",hh:"%d\u6642\u9593",d:"1\u65e5",dd:"%d\u65e5",M:"1\u30f6\u6708",MM:"%d\u30f6\u6708",y:"1\u5e74",yy:"%d\u5e74"}}),c.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,a){return 12===e&&(e=0),"enjing"===a?e:"siyang"===a?11<=e?e:e+12:"sonten"===a||"ndalu"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"enjing":e<15?"siyang":e<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",ss:"%d detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}}),c.defineLocale("ka",{months:"\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split("_"),monthsShort:"\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split("_"),weekdays:{standalone:"\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split("_"),format:"\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split("_"),isFormat:/(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/},weekdaysShort:"\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split("_"),weekdaysMin:"\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",nextDay:"[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",lastDay:"[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",nextWeek:"[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",lastWeek:"[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",sameElse:"L"},relativeTime:{future:function(e){return e.replace(/(\u10ec\u10d0\u10db|\u10ec\u10e3\u10d7|\u10e1\u10d0\u10d0\u10d7|\u10ec\u10d4\u10da|\u10d3\u10e6|\u10d7\u10d5)(\u10d8|\u10d4)/,function(e,a,t){return"\u10d8"===t?a+"\u10e8\u10d8":a+t+"\u10e8\u10d8"})},past:function(e){return/(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(e)?e.replace(/(\u10d8|\u10d4)$/,"\u10d8\u10e1 \u10ec\u10d8\u10dc"):/\u10ec\u10d4\u10da\u10d8/.test(e)?e.replace(/\u10ec\u10d4\u10da\u10d8$/,"\u10ec\u10da\u10d8\u10e1 \u10ec\u10d8\u10dc"):e},s:"\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",ss:"%d \u10ec\u10d0\u10db\u10d8",m:"\u10ec\u10e3\u10d7\u10d8",mm:"%d \u10ec\u10e3\u10d7\u10d8",h:"\u10e1\u10d0\u10d0\u10d7\u10d8",hh:"%d \u10e1\u10d0\u10d0\u10d7\u10d8",d:"\u10d3\u10e6\u10d4",dd:"%d \u10d3\u10e6\u10d4",M:"\u10d7\u10d5\u10d4",MM:"%d \u10d7\u10d5\u10d4",y:"\u10ec\u10d4\u10da\u10d8",yy:"%d \u10ec\u10d4\u10da\u10d8"},dayOfMonthOrdinalParse:/0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,ordinal:function(e){return 0===e?e:1===e?e+"-\u10da\u10d8":e<20||e<=100&&e%20==0||e%100==0?"\u10db\u10d4-"+e:e+"-\u10d4"},week:{dow:1,doy:7}});var Fs={0:"-\u0448\u0456",1:"-\u0448\u0456",2:"-\u0448\u0456",3:"-\u0448\u0456",4:"-\u0448\u0456",5:"-\u0448\u0456",6:"-\u0448\u044b",7:"-\u0448\u0456",8:"-\u0448\u0456",9:"-\u0448\u044b",10:"-\u0448\u044b",20:"-\u0448\u044b",30:"-\u0448\u044b",40:"-\u0448\u044b",50:"-\u0448\u0456",60:"-\u0448\u044b",70:"-\u0448\u0456",80:"-\u0448\u0456",90:"-\u0448\u044b",100:"-\u0448\u0456"},zs=(c.defineLocale("kk",{months:"\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split("_"),monthsShort:"\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split("_"),weekdays:"\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split("_"),weekdaysShort:"\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split("_"),weekdaysMin:"\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",nextDay:"[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0493\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0456\u0448\u0456\u043d\u0434\u0435",past:"%s \u0431\u04b1\u0440\u044b\u043d",s:"\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",hh:"%d \u0441\u0430\u0493\u0430\u0442",d:"\u0431\u0456\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0456\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0456\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0448\u0456|\u0448\u044b)/,ordinal:function(e){return e+(Fs[e]||Fs[e%10]||Fs[100<=e?100:null])},week:{dow:1,doy:7}}),{1:"\u17e1",2:"\u17e2",3:"\u17e3",4:"\u17e4",5:"\u17e5",6:"\u17e6",7:"\u17e7",8:"\u17e8",9:"\u17e9",0:"\u17e0"}),Ns={"\u17e1":"1","\u17e2":"2","\u17e3":"3","\u17e4":"4","\u17e5":"5","\u17e6":"6","\u17e7":"7","\u17e8":"8","\u17e9":"9","\u17e0":"0"},Js=(c.defineLocale("km",{months:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),monthsShort:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),weekdays:"\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),weekdaysShort:"\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),weekdaysMin:"\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u1796\u17d2\u179a\u17b9\u1780|\u179b\u17d2\u1784\u17b6\u1785/,isPM:function(e){return"\u179b\u17d2\u1784\u17b6\u1785"===e},meridiem:function(e,a,t){return e<12?"\u1796\u17d2\u179a\u17b9\u1780":"\u179b\u17d2\u1784\u17b6\u1785"},calendar:{sameDay:"[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",nextDay:"[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",nextWeek:"dddd [\u1798\u17c9\u17c4\u1784] LT",lastDay:"[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",lastWeek:"dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",sameElse:"L"},relativeTime:{future:"%s\u1791\u17c0\u178f",past:"%s\u1798\u17bb\u1793",s:"\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",ss:"%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",m:"\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",mm:"%d \u1793\u17b6\u1791\u17b8",h:"\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",hh:"%d \u1798\u17c9\u17c4\u1784",d:"\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",dd:"%d \u1790\u17d2\u1784\u17c3",M:"\u1798\u17bd\u1799\u1781\u17c2",MM:"%d \u1781\u17c2",y:"\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",yy:"%d \u1786\u17d2\u1793\u17b6\u17c6"},dayOfMonthOrdinalParse:/\u1791\u17b8\d{1,2}/,ordinal:"\u1791\u17b8%d",preparse:function(e){return e.replace(/[\u17e1\u17e2\u17e3\u17e4\u17e5\u17e6\u17e7\u17e8\u17e9\u17e0]/g,function(e){return Ns[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return zs[e]})},week:{dow:1,doy:4}}),{1:"\u0ce7",2:"\u0ce8",3:"\u0ce9",4:"\u0cea",5:"\u0ceb",6:"\u0cec",7:"\u0ced",8:"\u0cee",9:"\u0cef",0:"\u0ce6"}),Rs={"\u0ce7":"1","\u0ce8":"2","\u0ce9":"3","\u0cea":"4","\u0ceb":"5","\u0cec":"6","\u0ced":"7","\u0cee":"8","\u0cef":"9","\u0ce6":"0"};function O(e,a,t,s){e={s:["\xe7end san\xeeye","\xe7end san\xeeyeyan"],ss:[e+" san\xeeye",e+" san\xeeyeyan"],m:["deq\xeeqeyek","deq\xeeqeyek\xea"],mm:[e+" deq\xeeqe",e+" deq\xeeqeyan"],h:["saetek","saetek\xea"],hh:[e+" saet",e+" saetan"],d:["rojek","rojek\xea"],dd:[e+" roj",e+" rojan"],w:["hefteyek","hefteyek\xea"],ww:[e+" hefte",e+" hefteyan"],M:["mehek","mehek\xea"],MM:[e+" meh",e+" mehan"],y:["salek","salek\xea"],yy:[e+" sal",e+" salan"]};return a?e[t][0]:e[t][1]}c.defineLocale("kn",{months:"\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split("_"),monthsShort:"\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5_\u0ca8\u0cb5\u0cc6\u0c82_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82".split("_"),monthsParseExact:!0,weekdays:"\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split("_"),weekdaysShort:"\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split("_"),weekdaysMin:"\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c87\u0c82\u0ca6\u0cc1] LT",nextDay:"[\u0ca8\u0cbe\u0cb3\u0cc6] LT",nextWeek:"dddd, LT",lastDay:"[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",lastWeek:"[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0ca8\u0c82\u0ca4\u0cb0",past:"%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",s:"\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",ss:"%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",m:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",mm:"%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",h:"\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",hh:"%d \u0c97\u0c82\u0c9f\u0cc6",d:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",dd:"%d \u0ca6\u0cbf\u0ca8",M:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",MM:"%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",y:"\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",yy:"%d \u0cb5\u0cb0\u0ccd\u0cb7"},preparse:function(e){return e.replace(/[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g,function(e){return Rs[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Js[e]})},meridiemParse:/\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"===a?e<4?e:e+12:"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6"===a?e:"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8"===a?10<=e?e:e+12:"\u0cb8\u0c82\u0c9c\u0cc6"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf":e<10?"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6":e<17?"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8":e<20?"\u0cb8\u0c82\u0c9c\u0cc6":"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"},dayOfMonthOrdinalParse:/\d{1,2}(\u0ca8\u0cc6\u0cd5)/,ordinal:function(e){return e+"\u0ca8\u0cc6\u0cd5"},week:{dow:0,doy:6}}),c.defineLocale("ko",{months:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),monthsShort:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),weekdays:"\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split("_"),weekdaysShort:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),weekdaysMin:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY\ub144 MMMM D\uc77c",LLL:"YYYY\ub144 MMMM D\uc77c A h:mm",LLLL:"YYYY\ub144 MMMM D\uc77c dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY\ub144 MMMM D\uc77c",lll:"YYYY\ub144 MMMM D\uc77c A h:mm",llll:"YYYY\ub144 MMMM D\uc77c dddd A h:mm"},calendar:{sameDay:"\uc624\ub298 LT",nextDay:"\ub0b4\uc77c LT",nextWeek:"dddd LT",lastDay:"\uc5b4\uc81c LT",lastWeek:"\uc9c0\ub09c\uc8fc dddd LT",sameElse:"L"},relativeTime:{future:"%s \ud6c4",past:"%s \uc804",s:"\uba87 \ucd08",ss:"%d\ucd08",m:"1\ubd84",mm:"%d\ubd84",h:"\ud55c \uc2dc\uac04",hh:"%d\uc2dc\uac04",d:"\ud558\ub8e8",dd:"%d\uc77c",M:"\ud55c \ub2ec",MM:"%d\ub2ec",y:"\uc77c \ub144",yy:"%d\ub144"},dayOfMonthOrdinalParse:/\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\uc77c";case"M":return e+"\uc6d4";case"w":case"W":return e+"\uc8fc";default:return e}},meridiemParse:/\uc624\uc804|\uc624\ud6c4/,isPM:function(e){return"\uc624\ud6c4"===e},meridiem:function(e,a,t){return e<12?"\uc624\uc804":"\uc624\ud6c4"}}),c.defineLocale("ku-kmr",{months:"R\xeabendan_Sibat_Adar_N\xeesan_Gulan_Hez\xeeran_T\xeermeh_Tebax_\xcelon_Cotmeh_Mijdar_Berfanbar".split("_"),monthsShort:"R\xeab_Sib_Ada_N\xees_Gul_Hez_T\xeer_Teb_\xcelo_Cot_Mij_Ber".split("_"),monthsParseExact:!0,weekdays:"Yek\u015fem_Du\u015fem_S\xea\u015fem_\xc7ar\u015fem_P\xeanc\u015fem_\xcen_\u015eem\xee".split("_"),weekdaysShort:"Yek_Du_S\xea_\xc7ar_P\xean_\xcen_\u015eem".split("_"),weekdaysMin:"Ye_Du_S\xea_\xc7a_P\xea_\xcen_\u015ee".split("_"),meridiem:function(e,a,t){return e<12?t?"bn":"BN":t?"pn":"PN"},meridiemParse:/bn|BN|pn|PN/,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"Do MMMM[a] YYYY[an]",LLL:"Do MMMM[a] YYYY[an] HH:mm",LLLL:"dddd, Do MMMM[a] YYYY[an] HH:mm",ll:"Do MMM[.] YYYY[an]",lll:"Do MMM[.] YYYY[an] HH:mm",llll:"ddd[.], Do MMM[.] YYYY[an] HH:mm"},calendar:{sameDay:"[\xcero di saet] LT [de]",nextDay:"[Sib\xea di saet] LT [de]",nextWeek:"dddd [di saet] LT [de]",lastDay:"[Duh di saet] LT [de]",lastWeek:"dddd[a bor\xee di saet] LT [de]",sameElse:"L"},relativeTime:{future:"di %s de",past:"ber\xee %s",s:O,ss:O,m:O,mm:O,h:O,hh:O,d:O,dd:O,w:O,ww:O,M:O,MM:O,y:O,yy:O},dayOfMonthOrdinalParse:/\d{1,2}(?:y\xea|\xea|\.)/,ordinal:function(e,a){var a=a.toLowerCase();return a.includes("w")||a.includes("m")?e+".":e+(e=(a=""+(a=e)).substring(a.length-1),12==(a=1<a.length?a.substring(a.length-2):"")||13==a||"2"!=e&&"3"!=e&&"50"!=a&&"70"!=e&&"80"!=e?"\xea":"y\xea")},week:{dow:1,doy:4}});var Cs={1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"},Is={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},fe=["\u06a9\u0627\u0646\u0648\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645","\u0634\u0648\u0628\u0627\u062a","\u0626\u0627\u0632\u0627\u0631","\u0646\u06cc\u0633\u0627\u0646","\u0626\u0627\u06cc\u0627\u0631","\u062d\u0648\u0632\u06d5\u06cc\u0631\u0627\u0646","\u062a\u06d5\u0645\u0645\u0648\u0632","\u0626\u0627\u0628","\u0626\u06d5\u06cc\u0644\u0648\u0648\u0644","\u062a\u0634\u0631\u06cc\u0646\u06cc \u06cc\u06d5\u0643\u06d5\u0645","\u062a\u0634\u0631\u06cc\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645","\u0643\u0627\u0646\u0648\u0646\u06cc \u06cc\u06d5\u06a9\u06d5\u0645"],Us=(c.defineLocale("ku",{months:fe,monthsShort:fe,weekdays:"\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u062f\u0648\u0648\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0633\u06ce\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),weekdaysShort:"\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645_\u062f\u0648\u0648\u0634\u0647\u200c\u0645_\u0633\u06ce\u0634\u0647\u200c\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u0647_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0626\u06ce\u0648\u0627\u0631\u0647\u200c|\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc/,isPM:function(e){return/\u0626\u06ce\u0648\u0627\u0631\u0647\u200c/.test(e)},meridiem:function(e,a,t){return e<12?"\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc":"\u0626\u06ce\u0648\u0627\u0631\u0647\u200c"},calendar:{sameDay:"[\u0626\u0647\u200c\u0645\u0631\u06c6 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",nextDay:"[\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",nextWeek:"dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",lastDay:"[\u062f\u0648\u06ce\u0646\u06ce \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",lastWeek:"dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",sameElse:"L"},relativeTime:{future:"\u0644\u0647\u200c %s",past:"%s",s:"\u0686\u0647\u200c\u0646\u062f \u0686\u0631\u0643\u0647\u200c\u06cc\u0647\u200c\u0643",ss:"\u0686\u0631\u0643\u0647\u200c %d",m:"\u06cc\u0647\u200c\u0643 \u062e\u0648\u0644\u0647\u200c\u0643",mm:"%d \u062e\u0648\u0644\u0647\u200c\u0643",h:"\u06cc\u0647\u200c\u0643 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",hh:"%d \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",d:"\u06cc\u0647\u200c\u0643 \u0695\u06c6\u0698",dd:"%d \u0695\u06c6\u0698",M:"\u06cc\u0647\u200c\u0643 \u0645\u0627\u0646\u06af",MM:"%d \u0645\u0627\u0646\u06af",y:"\u06cc\u0647\u200c\u0643 \u0633\u0627\u06b5",yy:"%d \u0633\u0627\u06b5"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return Is[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return Cs[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),{0:"-\u0447\u04af",1:"-\u0447\u0438",2:"-\u0447\u0438",3:"-\u0447\u04af",4:"-\u0447\u04af",5:"-\u0447\u0438",6:"-\u0447\u044b",7:"-\u0447\u0438",8:"-\u0447\u0438",9:"-\u0447\u0443",10:"-\u0447\u0443",20:"-\u0447\u044b",30:"-\u0447\u0443",40:"-\u0447\u044b",50:"-\u0447\u04af",60:"-\u0447\u044b",70:"-\u0447\u0438",80:"-\u0447\u0438",90:"-\u0447\u0443",100:"-\u0447\u04af"});function Gs(e,a,t,s){var n={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?n[t][0]:n[t][1]}function Vs(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;var a;if(e<100)return Vs(0==(a=e%10)?e/10:a);if(e<1e4){for(;10<=e;)e/=10;return Vs(e)}return Vs(e/=1e3)}c.defineLocale("ky",{months:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split("_"),weekdaysShort:"\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split("_"),weekdaysMin:"\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",nextDay:"[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0447\u044d\u044d \u0441\u0430\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u04e9\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0438\u0447\u0438\u043d\u0434\u0435",past:"%s \u043c\u0443\u0440\u0443\u043d",s:"\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",mm:"%d \u043c\u04af\u043d\u04e9\u0442",h:"\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",hh:"%d \u0441\u0430\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0438\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0438\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,ordinal:function(e){return e+(Us[e]||Us[e%10]||Us[100<=e?100:null])},week:{dow:1,doy:7}}),c.defineLocale("lb",{months:"Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),weekdaysMin:"So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[G\xebschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:function(e){return Vs(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e},past:function(e){return Vs(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e},s:"e puer Sekonnen",ss:"%d Sekonnen",m:Gs,mm:"%d Minutten",h:Gs,hh:"%d Stonnen",d:Gs,dd:"%d Deeg",M:Gs,MM:"%d M\xe9int",y:Gs,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("lo",{months:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),monthsShort:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),weekdays:"\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysShort:"\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysMin:"\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,isPM:function(e){return"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"===e},meridiem:function(e,a,t){return e<12?"\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2":"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"},calendar:{sameDay:"[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextDay:"[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastDay:"[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",sameElse:"L"},relativeTime:{future:"\u0ead\u0eb5\u0e81 %s",past:"%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",s:"\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",ss:"%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",m:"1 \u0e99\u0eb2\u0e97\u0eb5",mm:"%d \u0e99\u0eb2\u0e97\u0eb5",h:"1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",hh:"%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",d:"1 \u0ea1\u0eb7\u0ec9",dd:"%d \u0ea1\u0eb7\u0ec9",M:"1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",MM:"%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",y:"1 \u0e9b\u0eb5",yy:"%d \u0e9b\u0eb5"},dayOfMonthOrdinalParse:/(\u0e97\u0eb5\u0ec8)\d{1,2}/,ordinal:function(e){return"\u0e97\u0eb5\u0ec8"+e}});var qs={ss:"sekund\u0117_sekund\u017ei\u0173_sekundes",m:"minut\u0117_minut\u0117s_minut\u0119",mm:"minut\u0117s_minu\u010di\u0173_minutes",h:"valanda_valandos_valand\u0105",hh:"valandos_valand\u0173_valandas",d:"diena_dienos_dien\u0105",dd:"dienos_dien\u0173_dienas",M:"m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",MM:"m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",y:"metai_met\u0173_metus",yy:"metai_met\u0173_metus"};function Bs(e,a,t,s){return a?Zs(t)[0]:s?Zs(t)[1]:Zs(t)[2]}function Ks(e){return e%10==0||10<e&&e<20}function Zs(e){return qs[e].split("_")}function $s(e,a,t,s){var n=e+" ";return 1===e?n+Bs(0,a,t[0],s):a?n+(Ks(e)?Zs(t)[1]:Zs(t)[0]):s?n+Zs(t)[1]:n+(Ks(e)?Zs(t)[1]:Zs(t)[2])}c.defineLocale("lt",{months:{format:"sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),weekdaysMin:"S_P_A_T_K_Pn_\u0160".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[\u0160iandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Pra\u0117jus\u012f] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prie\u0161 %s",s:function(e,a,t,s){return a?"kelios sekund\u0117s":s?"keli\u0173 sekund\u017ei\u0173":"kelias sekundes"},ss:$s,m:Bs,mm:$s,h:Bs,hh:$s,d:Bs,dd:$s,M:Bs,MM:$s,y:Bs,yy:$s},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}});var Qs={ss:"sekundes_sekund\u0113m_sekunde_sekundes".split("_"),m:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),mm:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),h:"stundas_stund\u0101m_stunda_stundas".split("_"),hh:"stundas_stund\u0101m_stunda_stundas".split("_"),d:"dienas_dien\u0101m_diena_dienas".split("_"),dd:"dienas_dien\u0101m_diena_dienas".split("_"),M:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),MM:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};function Xs(e,a,t){return t?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function en(e,a,t){return e+" "+Xs(Qs[t],e,a)}function an(e,a,t){return Xs(Qs[t],e,a)}c.defineLocale("lv",{months:"janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split("_"),weekdays:"sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[\u0160odien pulksten] LT",nextDay:"[R\u012bt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"p\u0113c %s",past:"pirms %s",s:function(e,a){return a?"da\u017eas sekundes":"da\u017e\u0101m sekund\u0113m"},ss:en,m:an,mm:en,h:an,hh:en,d:an,dd:en,M:an,MM:en,y:an,yy:en},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var tn={words:{ss:["sekund","sekunda","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:2<=e&&e<=4?a[1]:a[2]},translate:function(e,a,t){var s=tn.words[t];return 1===t.length?a?s[0]:s[1]:e+" "+tn.correctGrammaticalCase(e,s)}};function sn(e,a,t,s){switch(t){case"s":return a?"\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434":"\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d";case"ss":return e+(a?" \u0441\u0435\u043a\u0443\u043d\u0434":" \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d");case"m":case"mm":return e+(a?" \u043c\u0438\u043d\u0443\u0442":" \u043c\u0438\u043d\u0443\u0442\u044b\u043d");case"h":case"hh":return e+(a?" \u0446\u0430\u0433":" \u0446\u0430\u0433\u0438\u0439\u043d");case"d":case"dd":return e+(a?" \u04e9\u0434\u04e9\u0440":" \u04e9\u0434\u0440\u0438\u0439\u043d");case"M":case"MM":return e+(a?" \u0441\u0430\u0440":" \u0441\u0430\u0440\u044b\u043d");case"y":case"yy":return e+(a?" \u0436\u0438\u043b":" \u0436\u0438\u043b\u0438\u0439\u043d");default:return e}}c.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedjelje] [u] LT","[pro\u0161log] [ponedjeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srijede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",ss:tn.translate,m:tn.translate,mm:tn.translate,h:tn.translate,hh:tn.translate,d:"dan",dd:tn.translate,M:"mjesec",MM:tn.translate,y:"godinu",yy:tn.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),c.defineLocale("mi",{months:"Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),weekdaysShort:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),weekdaysMin:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te h\u0113kona ruarua",ss:"%d h\u0113kona",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),c.defineLocale("mk",{months:"\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split("_"),weekdaysMin:"\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",nextWeek:"[\u0412\u043e] dddd [\u0432\u043e] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";case 1:case 2:case 4:case 5:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT"}},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"\u043f\u0440\u0435\u0434 %s",s:"\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u0435\u0434\u043d\u0430 \u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0435\u0434\u0435\u043d \u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0435\u0434\u0435\u043d \u0434\u0435\u043d",dd:"%d \u0434\u0435\u043d\u0430",M:"\u0435\u0434\u0435\u043d \u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0438",y:"\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,t=e%100;return 0===e?e+"-\u0435\u0432":0==t?e+"-\u0435\u043d":10<t&&t<20?e+"-\u0442\u0438":1==a?e+"-\u0432\u0438":2==a?e+"-\u0440\u0438":7==a||8==a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),c.defineLocale("ml",{months:"\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split("_"),monthsShort:"\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split("_"),monthsParseExact:!0,weekdays:"\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split("_"),weekdaysShort:"\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split("_"),weekdaysMin:"\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split("_"),longDateFormat:{LT:"A h:mm -\u0d28\u0d41",LTS:"A h:mm:ss -\u0d28\u0d41",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -\u0d28\u0d41",LLLL:"dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41"},calendar:{sameDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",nextDay:"[\u0d28\u0d3e\u0d33\u0d46] LT",nextWeek:"dddd, LT",lastDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",lastWeek:"[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",past:"%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",s:"\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",ss:"%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",m:"\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",mm:"%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",h:"\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",hh:"%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",d:"\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",dd:"%d \u0d26\u0d3f\u0d35\u0d38\u0d02",M:"\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",MM:"%d \u0d2e\u0d3e\u0d38\u0d02",y:"\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",yy:"%d \u0d35\u0d7c\u0d37\u0d02"},meridiemParse:/\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"===a&&4<=e||"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d"===a||"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02"===a?e+12:e},meridiem:function(e,a,t){return e<4?"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f":e<12?"\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46":e<17?"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d":e<20?"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02":"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"}}),c.defineLocale("mn",{months:"\u041d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0425\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04e9\u0440\u04e9\u0432\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043e\u043b\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041d\u0430\u0439\u043c\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u043d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u0445\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split("_"),monthsShort:"1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split("_"),monthsParseExact:!0,weekdays:"\u041d\u044f\u043c_\u0414\u0430\u0432\u0430\u0430_\u041c\u044f\u0433\u043c\u0430\u0440_\u041b\u0445\u0430\u0433\u0432\u0430_\u041f\u04af\u0440\u044d\u0432_\u0411\u0430\u0430\u0441\u0430\u043d_\u0411\u044f\u043c\u0431\u0430".split("_"),weekdaysShort:"\u041d\u044f\u043c_\u0414\u0430\u0432_\u041c\u044f\u0433_\u041b\u0445\u0430_\u041f\u04af\u0440_\u0411\u0430\u0430_\u0411\u044f\u043c".split("_"),weekdaysMin:"\u041d\u044f_\u0414\u0430_\u041c\u044f_\u041b\u0445_\u041f\u04af_\u0411\u0430_\u0411\u044f".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY \u043e\u043d\u044b MMMM\u044b\u043d D",LLL:"YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",LLLL:"dddd, YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm"},meridiemParse:/\u04ae\u04e8|\u04ae\u0425/i,isPM:function(e){return"\u04ae\u0425"===e},meridiem:function(e,a,t){return e<12?"\u04ae\u04e8":"\u04ae\u0425"},calendar:{sameDay:"[\u04e8\u043d\u04e9\u04e9\u0434\u04e9\u0440] LT",nextDay:"[\u041c\u0430\u0440\u0433\u0430\u0430\u0448] LT",nextWeek:"[\u0418\u0440\u044d\u0445] dddd LT",lastDay:"[\u04e8\u0447\u0438\u0433\u0434\u04e9\u0440] LT",lastWeek:"[\u04e8\u043d\u0433\u04e9\u0440\u0441\u04e9\u043d] dddd LT",sameElse:"L"},relativeTime:{future:"%s \u0434\u0430\u0440\u0430\u0430",past:"%s \u04e9\u043c\u043d\u04e9",s:sn,ss:sn,m:sn,mm:sn,h:sn,hh:sn,d:sn,dd:sn,M:sn,MM:sn,y:sn,yy:sn},dayOfMonthOrdinalParse:/\d{1,2} \u04e9\u0434\u04e9\u0440/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+" \u04e9\u0434\u04e9\u0440";default:return e}}});var nn={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},rn={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};function dn(e,a,t,s){var n="";if(a)switch(t){case"s":n="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";break;case"ss":n="%d \u0938\u0947\u0915\u0902\u0926";break;case"m":n="\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";break;case"mm":n="%d \u092e\u093f\u0928\u093f\u091f\u0947";break;case"h":n="\u090f\u0915 \u0924\u093e\u0938";break;case"hh":n="%d \u0924\u093e\u0938";break;case"d":n="\u090f\u0915 \u0926\u093f\u0935\u0938";break;case"dd":n="%d \u0926\u093f\u0935\u0938";break;case"M":n="\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";break;case"MM":n="%d \u092e\u0939\u093f\u0928\u0947";break;case"y":n="\u090f\u0915 \u0935\u0930\u094d\u0937";break;case"yy":n="%d \u0935\u0930\u094d\u0937\u0947";break}else switch(t){case"s":n="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"ss":n="%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"m":n="\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";break;case"mm":n="%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";break;case"h":n="\u090f\u0915\u093e \u0924\u093e\u0938\u093e";break;case"hh":n="%d \u0924\u093e\u0938\u093e\u0902";break;case"d":n="\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";break;case"dd":n="%d \u0926\u093f\u0935\u0938\u093e\u0902";break;case"M":n="\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";break;case"MM":n="%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";break;case"y":n="\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";break;case"yy":n="%d \u0935\u0930\u094d\u0937\u093e\u0902";break}return n.replace(/%d/i,e)}c.defineLocale("mr",{months:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),monthsShort:"\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),monthsParseExact:!0,weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u0935\u093e\u091c\u0924\u093e",LTS:"A h:mm:ss \u0935\u093e\u091c\u0924\u093e",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",LLLL:"dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0909\u0926\u094d\u092f\u093e] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u093e\u0932] LT",lastWeek:"[\u092e\u093e\u0917\u0940\u0932] dddd, LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u0927\u094d\u092f\u0947",past:"%s\u092a\u0942\u0930\u094d\u0935\u0940",s:dn,ss:dn,m:dn,mm:dn,h:dn,hh:dn,d:dn,dd:dn,M:dn,MM:dn,y:dn,yy:dn},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return rn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return nn[e]})},meridiemParse:/\u092a\u0939\u093e\u091f\u0947|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940|\u0930\u093e\u0924\u094d\u0930\u0940/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u092a\u0939\u093e\u091f\u0947"===a||"\u0938\u0915\u093e\u0933\u0940"===a?e:"\u0926\u0941\u092a\u093e\u0930\u0940"===a||"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940"===a||"\u0930\u093e\u0924\u094d\u0930\u0940"===a?12<=e?e:e+12:void 0},meridiem:function(e,a,t){return 0<=e&&e<6?"\u092a\u0939\u093e\u091f\u0947":e<12?"\u0938\u0915\u093e\u0933\u0940":e<17?"\u0926\u0941\u092a\u093e\u0930\u0940":e<20?"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940":"\u0930\u093e\u0924\u094d\u0930\u0940"},week:{dow:0,doy:6}}),c.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?11<=e?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),c.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?11<=e?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,t){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),c.defineLocale("mt",{months:"Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split("_"),monthsShort:"Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split("_"),weekdays:"Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split("_"),weekdaysShort:"\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),weekdaysMin:"\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Illum fil-]LT",nextDay:"[G\u0127ada fil-]LT",nextWeek:"dddd [fil-]LT",lastDay:"[Il-biera\u0127 fil-]LT",lastWeek:"dddd [li g\u0127adda] [fil-]LT",sameElse:"L"},relativeTime:{future:"f\u2019 %s",past:"%s ilu",s:"ftit sekondi",ss:"%d sekondi",m:"minuta",mm:"%d minuti",h:"sieg\u0127a",hh:"%d sieg\u0127at",d:"\u0121urnata",dd:"%d \u0121ranet",M:"xahar",MM:"%d xhur",y:"sena",yy:"%d sni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}});var _n={1:"\u1041",2:"\u1042",3:"\u1043",4:"\u1044",5:"\u1045",6:"\u1046",7:"\u1047",8:"\u1048",9:"\u1049",0:"\u1040"},on={"\u1041":"1","\u1042":"2","\u1043":"3","\u1044":"4","\u1045":"5","\u1046":"6","\u1047":"7","\u1048":"8","\u1049":"9","\u1040":"0"},mn=(c.defineLocale("my",{months:"\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split("_"),monthsShort:"\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split("_"),weekdays:"\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split("_"),weekdaysShort:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),weekdaysMin:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",nextDay:"[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",nextWeek:"dddd LT [\u1019\u103e\u102c]",lastDay:"[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",lastWeek:"[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",sameElse:"L"},relativeTime:{future:"\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",past:"\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",s:"\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",ss:"%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",m:"\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",mm:"%d \u1019\u102d\u1014\u1005\u103a",h:"\u1010\u1005\u103a\u1014\u102c\u101b\u102e",hh:"%d \u1014\u102c\u101b\u102e",d:"\u1010\u1005\u103a\u101b\u1000\u103a",dd:"%d \u101b\u1000\u103a",M:"\u1010\u1005\u103a\u101c",MM:"%d \u101c",y:"\u1010\u1005\u103a\u1014\u103e\u1005\u103a",yy:"%d \u1014\u103e\u1005\u103a"},preparse:function(e){return e.replace(/[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g,function(e){return on[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return _n[e]})},week:{dow:1,doy:4}}),c.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"\xe9n time",hh:"%d timer",d:"\xe9n dag",dd:"%d dager",w:"\xe9n uke",ww:"%d uker",M:"\xe9n m\xe5ned",MM:"%d m\xe5neder",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),{1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"}),un={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"},ln=(c.defineLocale("ne",{months:"\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split("_"),monthsShort:"\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split("_"),monthsParseExact:!0,weekdays:"\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split("_"),weekdaysShort:"\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split("_"),weekdaysMin:"\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A\u0915\u094b h:mm \u092c\u091c\u0947",LTS:"A\u0915\u094b h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return un[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return mn[e]})},meridiemParse:/\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u093f"===a?e<4?e:e+12:"\u092c\u093f\u0939\u093e\u0928"===a?e:"\u0926\u093f\u0909\u0901\u0938\u094b"===a?10<=e?e:e+12:"\u0938\u093e\u0901\u091d"===a?e+12:void 0},meridiem:function(e,a,t){return e<3?"\u0930\u093e\u0924\u093f":e<12?"\u092c\u093f\u0939\u093e\u0928":e<16?"\u0926\u093f\u0909\u0901\u0938\u094b":e<20?"\u0938\u093e\u0901\u091d":"\u0930\u093e\u0924\u093f"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u092d\u094b\u0932\u093f] LT",nextWeek:"[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",lastDay:"[\u0939\u093f\u091c\u094b] LT",lastWeek:"[\u0917\u090f\u0915\u094b] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u093e",past:"%s \u0905\u0917\u093e\u0921\u093f",s:"\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",mm:"%d \u092e\u093f\u0928\u0947\u091f",h:"\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",hh:"%d \u0918\u0923\u094d\u091f\u093e",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",MM:"%d \u092e\u0939\u093f\u0928\u093e",y:"\u090f\u0915 \u092c\u0930\u094d\u0937",yy:"%d \u092c\u0930\u094d\u0937"},week:{dow:0,doy:6}}),"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_")),Mn="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),_=[/^jan/i,/^feb/i,/^(maart|mrt\.?)$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],Ie=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,hn=(c.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?Mn:ln)[e.month()]:ln},monthsRegex:Ie,monthsShortRegex:Ie,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:_,longMonthsParse:_,shortMonthsParse:_,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_")),cn="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),Ye=[/^jan/i,/^feb/i,/^(maart|mrt\.?)$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],ye=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,Ln=(c.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?cn:hn)[e.month()]:hn},monthsRegex:ye,monthsShortRegex:ye,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:Ye,longMonthsParse:Ye,shortMonthsParse:Ye,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",w:"\xe9\xe9n week",ww:"%d weken",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),c.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"su._m\xe5._ty._on._to._fr._lau.".split("_"),weekdaysMin:"su_m\xe5_ty_on_to_fr_la".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I g\xe5r klokka] LT",lastWeek:"[F\xf8reg\xe5ande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",w:"ei veke",ww:"%d veker",M:"ein m\xe5nad",MM:"%d m\xe5nader",y:"eit \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("oc-lnc",{months:{standalone:"geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split("_"),format:"de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dm._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dm_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:"[u\xe8i a] LT",nextDay:"[deman a] LT",nextWeek:"dddd [a] LT",lastDay:"[i\xe8r a] LT",lastWeek:"dddd [passat a] LT",sameElse:"L"},relativeTime:{future:"d'aqu\xed %s",past:"fa %s",s:"unas segondas",ss:"%d segondas",m:"una minuta",mm:"%d minutas",h:"una ora",hh:"%d oras",d:"un jorn",dd:"%d jorns",M:"un mes",MM:"%d meses",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|\xe8|a)/,ordinal:function(e,a){return e+("w"!==a&&"W"!==a?1===e?"r":2===e?"n":3===e?"r":4===e?"t":"\xe8":"a")},week:{dow:1,doy:4}}),{1:"\u0a67",2:"\u0a68",3:"\u0a69",4:"\u0a6a",5:"\u0a6b",6:"\u0a6c",7:"\u0a6d",8:"\u0a6e",9:"\u0a6f",0:"\u0a66"}),Yn={"\u0a67":"1","\u0a68":"2","\u0a69":"3","\u0a6a":"4","\u0a6b":"5","\u0a6c":"6","\u0a6d":"7","\u0a6e":"8","\u0a6f":"9","\u0a66":"0"},yn=(c.defineLocale("pa-in",{months:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),monthsShort:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),weekdays:"\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split("_"),weekdaysShort:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),weekdaysMin:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),longDateFormat:{LT:"A h:mm \u0a35\u0a1c\u0a47",LTS:"A h:mm:ss \u0a35\u0a1c\u0a47",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",LLLL:"dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47"},calendar:{sameDay:"[\u0a05\u0a1c] LT",nextDay:"[\u0a15\u0a32] LT",nextWeek:"[\u0a05\u0a17\u0a32\u0a3e] dddd, LT",lastDay:"[\u0a15\u0a32] LT",lastWeek:"[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0a35\u0a3f\u0a71\u0a1a",past:"%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",s:"\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",ss:"%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",m:"\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",mm:"%d \u0a2e\u0a3f\u0a70\u0a1f",h:"\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",hh:"%d \u0a18\u0a70\u0a1f\u0a47",d:"\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",dd:"%d \u0a26\u0a3f\u0a28",M:"\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",MM:"%d \u0a2e\u0a39\u0a40\u0a28\u0a47",y:"\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",yy:"%d \u0a38\u0a3e\u0a32"},preparse:function(e){return e.replace(/[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g,function(e){return Yn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Ln[e]})},meridiemParse:/\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0a30\u0a3e\u0a24"===a?e<4?e:e+12:"\u0a38\u0a35\u0a47\u0a30"===a?e:"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30"===a?10<=e?e:e+12:"\u0a38\u0a3c\u0a3e\u0a2e"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0a30\u0a3e\u0a24":e<10?"\u0a38\u0a35\u0a47\u0a30":e<17?"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30":e<20?"\u0a38\u0a3c\u0a3e\u0a2e":"\u0a30\u0a3e\u0a24"},week:{dow:0,doy:6}}),"stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split("_")),fn="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split("_"),na=[/^sty/i,/^lut/i,/^mar/i,/^kwi/i,/^maj/i,/^cze/i,/^lip/i,/^sie/i,/^wrz/i,/^pa\u017a/i,/^lis/i,/^gru/i];function kn(e){return e%10<5&&1<e%10&&~~(e/10)%10!=1}function pn(e,a,t){var s=e+" ";switch(t){case"ss":return s+(kn(e)?"sekundy":"sekund");case"m":return a?"minuta":"minut\u0119";case"mm":return s+(kn(e)?"minuty":"minut");case"h":return a?"godzina":"godzin\u0119";case"hh":return s+(kn(e)?"godziny":"godzin");case"ww":return s+(kn(e)?"tygodnie":"tygodni");case"MM":return s+(kn(e)?"miesi\u0105ce":"miesi\u0119cy");case"yy":return s+(kn(e)?"lata":"lat")}}function Dn(e,a,t){return e+(20<=e%100||100<=e&&e%100==0?" de ":" ")+{ss:"secunde",mm:"minute",hh:"ore",dd:"zile",ww:"s\u0103pt\u0103m\xe2ni",MM:"luni",yy:"ani"}[t]}function Tn(e,a,t){return"m"===t?a?"\u043c\u0438\u043d\u0443\u0442\u0430":"\u043c\u0438\u043d\u0443\u0442\u0443":e+" "+(e=+e,a=(a={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442":"\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",hh:"\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",ww:"\u043d\u0435\u0434\u0435\u043b\u044f_\u043d\u0435\u0434\u0435\u043b\u0438_\u043d\u0435\u0434\u0435\u043b\u044c",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",yy:"\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442"}[t]).split("_"),e%10==1&&e%100!=11?a[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?a[1]:a[2])}c.defineLocale("pl",{months:function(e,a){return e?(/D MMMM/.test(a)?fn:yn)[e.month()]:yn},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),monthsParse:na,longMonthsParse:na,shortMonthsParse:na,weekdays:"niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_\u015br_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dzi\u015b o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedziel\u0119 o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W \u015brod\u0119 o] LT";case 6:return"[W sobot\u0119 o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zesz\u0142\u0105 niedziel\u0119 o] LT";case 3:return"[W zesz\u0142\u0105 \u015brod\u0119 o] LT";case 6:return"[W zesz\u0142\u0105 sobot\u0119 o] LT";default:return"[W zesz\u0142y] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:pn,m:pn,mm:pn,h:pn,hh:pn,d:"1 dzie\u0144",dd:"%d dni",w:"tydzie\u0144",ww:pn,M:"miesi\u0105c",MM:pn,y:"rok",yy:pn},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("pt-br",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),weekdaysMin:"do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [\xe0s] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",invalidDate:"Data inv\xe1lida"}),c.defineLocale("pt",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),weekdaysMin:"Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",w:"uma semana",ww:"%d semanas",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),c.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[m\xe2ine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s \xeen urm\u0103",s:"c\xe2teva secunde",ss:Dn,m:"un minut",mm:Dn,h:"o or\u0103",hh:Dn,d:"o zi",dd:Dn,w:"o s\u0103pt\u0103m\xe2n\u0103",ww:Dn,M:"o lun\u0103",MM:Dn,y:"un an",yy:Dn},week:{dow:1,doy:7}});t=[/^\u044f\u043d\u0432/i,/^\u0444\u0435\u0432/i,/^\u043c\u0430\u0440/i,/^\u0430\u043f\u0440/i,/^\u043c\u0430[\u0439\u044f]/i,/^\u0438\u044e\u043d/i,/^\u0438\u044e\u043b/i,/^\u0430\u0432\u0433/i,/^\u0441\u0435\u043d/i,/^\u043e\u043a\u0442/i,/^\u043d\u043e\u044f/i,/^\u0434\u0435\u043a/i],c.defineLocale("ru",{months:{format:"\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split("_"),standalone:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_")},monthsShort:{format:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_"),standalone:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_")},weekdays:{standalone:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split("_"),format:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split("_"),isFormat:/\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?] ?dddd/},weekdaysShort:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),monthsParse:t,longMonthsParse:t,shortMonthsParse:t,monthsRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsShortRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsStrictRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,monthsShortStrictRegex:/^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., H:mm",LLLL:"dddd, D MMMM YYYY \u0433., H:mm"},calendar:{sameDay:"[\u0421\u0435\u0433\u043e\u0434\u043d\u044f, \u0432] LT",nextDay:"[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd, [\u0432] LT":"[\u0412] dddd, [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd, [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd, [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd, [\u0432] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd, [\u0432] LT":"[\u0412] dddd, [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd, [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd, [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd, [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0447\u0435\u0440\u0435\u0437 %s",past:"%s \u043d\u0430\u0437\u0430\u0434",s:"\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",ss:Tn,m:Tn,mm:Tn,h:"\u0447\u0430\u0441",hh:Tn,d:"\u0434\u0435\u043d\u044c",dd:Tn,w:"\u043d\u0435\u0434\u0435\u043b\u044f",ww:Tn,M:"\u043c\u0435\u0441\u044f\u0446",MM:Tn,y:"\u0433\u043e\u0434",yy:Tn},meridiemParse:/\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(e)},meridiem:function(e,a,t){return e<4?"\u043d\u043e\u0447\u0438":e<12?"\u0443\u0442\u0440\u0430":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0435\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-\u0439";case"D":return e+"-\u0433\u043e";case"w":case"W":return e+"-\u044f";default:return e}},week:{dow:1,doy:4}}),m=["\u062c\u0646\u0648\u0631\u064a","\u0641\u064a\u0628\u0631\u0648\u0631\u064a","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u064a\u0644","\u0645\u0626\u064a","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0621\u0650","\u0622\u06af\u0633\u067d","\u0633\u064a\u067e\u067d\u0645\u0628\u0631","\u0622\u06aa\u067d\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u068a\u0633\u0645\u0628\u0631"],o=["\u0622\u0686\u0631","\u0633\u0648\u0645\u0631","\u0627\u06b1\u0627\u0631\u0648","\u0627\u0631\u0628\u0639","\u062e\u0645\u064a\u0633","\u062c\u0645\u0639","\u0687\u0646\u0687\u0631"],c.defineLocale("sd",{months:m,monthsShort:m,weekdays:o,weekdaysShort:o,weekdaysMin:o,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0627\u0684] LT",nextDay:"[\u0633\u0680\u0627\u06bb\u064a] LT",nextWeek:"dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",lastDay:"[\u06aa\u0627\u0644\u0647\u0647] LT",lastWeek:"[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",sameElse:"L"},relativeTime:{future:"%s \u067e\u0648\u0621",past:"%s \u0627\u06b3",s:"\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",ss:"%d \u0633\u064a\u06aa\u0646\u068a",m:"\u0647\u06aa \u0645\u0646\u067d",mm:"%d \u0645\u0646\u067d",h:"\u0647\u06aa \u06aa\u0644\u0627\u06aa",hh:"%d \u06aa\u0644\u0627\u06aa",d:"\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",dd:"%d \u068f\u064a\u0646\u0647\u0646",M:"\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",MM:"%d \u0645\u0647\u064a\u0646\u0627",y:"\u0647\u06aa \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),c.defineLocale("se",{months:"o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split("_"),monthsShort:"o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split("_"),weekdays:"sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),weekdaysShort:"sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s gea\u017ees",past:"ma\u014bit %s",s:"moadde sekunddat",ss:"%d sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta m\xe1nnu",MM:"%d m\xe1nut",y:"okta jahki",yy:"%d jagit"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("si",{months:"\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split("_"),monthsShort:"\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split("_"),weekdays:"\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split("_"),weekdaysShort:"\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split("_"),weekdaysMin:"\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss"},calendar:{sameDay:"[\u0d85\u0daf] LT[\u0da7]",nextDay:"[\u0dc4\u0dd9\u0da7] LT[\u0da7]",nextWeek:"dddd LT[\u0da7]",lastDay:"[\u0d8a\u0dba\u0dda] LT[\u0da7]",lastWeek:"[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",sameElse:"L"},relativeTime:{future:"%s\u0d9a\u0dd2\u0db1\u0dca",past:"%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",s:"\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",ss:"\u0dad\u0dad\u0dca\u0db4\u0dbb %d",m:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",mm:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",h:"\u0db4\u0dd0\u0dba",hh:"\u0db4\u0dd0\u0dba %d",d:"\u0daf\u0dd2\u0db1\u0dba",dd:"\u0daf\u0dd2\u0db1 %d",M:"\u0db8\u0dcf\u0dc3\u0dba",MM:"\u0db8\u0dcf\u0dc3 %d",y:"\u0dc0\u0dc3\u0dbb",yy:"\u0dc0\u0dc3\u0dbb %d"},dayOfMonthOrdinalParse:/\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,ordinal:function(e){return e+" \u0dc0\u0dd0\u0db1\u0dd2"},meridiemParse:/\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,isPM:function(e){return"\u0db4.\u0dc0."===e||"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4"===e},meridiem:function(e,a,t){return 11<e?t?"\u0db4.\u0dc0.":"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4":t?"\u0db4\u0dd9.\u0dc0.":"\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4"}}),n="janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split("_"),ze="jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");function gn(e){return 1<e&&e<5}function wn(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"p\xe1r sek\xfand":"p\xe1r sekundami";case"ss":return a||s?n+(gn(e)?"sekundy":"sek\xfand"):n+"sekundami";case"m":return a?"min\xfata":s?"min\xfatu":"min\xfatou";case"mm":return a||s?n+(gn(e)?"min\xfaty":"min\xfat"):n+"min\xfatami";case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?n+(gn(e)?"hodiny":"hod\xedn"):n+"hodinami";case"d":return a||s?"de\u0148":"d\u0148om";case"dd":return a||s?n+(gn(e)?"dni":"dn\xed"):n+"d\u0148ami";case"M":return a||s?"mesiac":"mesiacom";case"MM":return a||s?n+(gn(e)?"mesiace":"mesiacov"):n+"mesiacmi";case"y":return a||s?"rok":"rokom";case"yy":return a||s?n+(gn(e)?"roky":"rokov"):n+"rokmi"}}function bn(e,a,t,s){var n=e+" ";switch(t){case"s":return a||s?"nekaj sekund":"nekaj sekundami";case"ss":return n+=1===e?a?"sekundo":"sekundi":2===e?a||s?"sekundi":"sekundah":e<5?a||s?"sekunde":"sekundah":"sekund";case"m":return a?"ena minuta":"eno minuto";case"mm":return n+=1===e?a?"minuta":"minuto":2===e?a||s?"minuti":"minutama":e<5?a||s?"minute":"minutami":a||s?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return n+=1===e?a?"ura":"uro":2===e?a||s?"uri":"urama":e<5?a||s?"ure":"urami":a||s?"ur":"urami";case"d":return a||s?"en dan":"enim dnem";case"dd":return n+=1===e?a||s?"dan":"dnem":2===e?a||s?"dni":"dnevoma":a||s?"dni":"dnevi";case"M":return a||s?"en mesec":"enim mesecem";case"MM":return n+=1===e?a||s?"mesec":"mesecem":2===e?a||s?"meseca":"mesecema":e<5?a||s?"mesece":"meseci":a||s?"mesecev":"meseci";case"y":return a||s?"eno leto":"enim letom";case"yy":return n+=1===e?a||s?"leto":"letom":2===e?a||s?"leti":"letoma":e<5?a||s?"leta":"leti":a||s?"let":"leti"}}c.defineLocale("sk",{months:n,monthsShort:ze,weekdays:"nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_\u0161t_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_\u0161t_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nede\u013eu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo \u0161tvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[v\u010dera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minul\xfa nede\u013eu o] LT";case 1:case 2:return"[minul\xfd] dddd [o] LT";case 3:return"[minul\xfa stredu o] LT";case 4:case 5:return"[minul\xfd] dddd [o] LT";case 6:return"[minul\xfa sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:wn,ss:wn,m:wn,mm:wn,h:wn,hh:wn,d:wn,dd:wn,M:wn,MM:wn,y:wn,yy:wn},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._\u010det._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_\u010de_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[v\u010deraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prej\u0161njo] [nedeljo] [ob] LT";case 3:return"[prej\u0161njo] [sredo] [ob] LT";case 6:return"[prej\u0161njo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prej\u0161nji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"\u010dez %s",past:"pred %s",s:bn,ss:bn,m:bn,mm:bn,h:bn,hh:bn,d:bn,dd:bn,M:bn,MM:bn,y:bn,yy:bn},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),c.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),weekdays:"E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),weekdaysShort:"Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_M\xeb_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,a,t){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot n\xeb] LT",nextDay:"[Nes\xebr n\xeb] LT",nextWeek:"dddd [n\xeb] LT",lastDay:"[Dje n\xeb] LT",lastWeek:"dddd [e kaluar n\xeb] LT",sameElse:"L"},relativeTime:{future:"n\xeb %s",past:"%s m\xeb par\xeb",s:"disa sekonda",ss:"%d sekonda",m:"nj\xeb minut\xeb",mm:"%d minuta",h:"nj\xeb or\xeb",hh:"%d or\xeb",d:"nj\xeb dit\xeb",dd:"%d dit\xeb",M:"nj\xeb muaj",MM:"%d muaj",y:"nj\xeb vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var W={words:{ss:["\u0441\u0435\u043a\u0443\u043d\u0434\u0430","\u0441\u0435\u043a\u0443\u043d\u0434\u0435","\u0441\u0435\u043a\u0443\u043d\u0434\u0438"],m:["\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442","\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0438\u043d\u0443\u0442\u0430"],mm:["\u043c\u0438\u043d\u0443\u0442","\u043c\u0438\u043d\u0443\u0442\u0430","\u043c\u0438\u043d\u0443\u0442\u0430"],h:["\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442","\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430"],hh:["\u0441\u0430\u0442","\u0441\u0430\u0442\u0430","\u0441\u0430\u0442\u0438"],d:["\u0458\u0435\u0434\u0430\u043d \u0434\u0430\u043d","\u0458\u0435\u0434\u043d\u043e\u0433 \u0434\u0430\u043d\u0430"],dd:["\u0434\u0430\u043d","\u0434\u0430\u043d\u0430","\u0434\u0430\u043d\u0430"],M:["\u0458\u0435\u0434\u0430\u043d \u043c\u0435\u0441\u0435\u0446","\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0435\u0441\u0435\u0446\u0430"],MM:["\u043c\u0435\u0441\u0435\u0446","\u043c\u0435\u0441\u0435\u0446\u0430","\u043c\u0435\u0441\u0435\u0446\u0438"],y:["\u0458\u0435\u0434\u043d\u0443 \u0433\u043e\u0434\u0438\u043d\u0443","\u0458\u0435\u0434\u043d\u0435 \u0433\u043e\u0434\u0438\u043d\u0435"],yy:["\u0433\u043e\u0434\u0438\u043d\u0443","\u0433\u043e\u0434\u0438\u043d\u0435","\u0433\u043e\u0434\u0438\u043d\u0430"]},correctGrammaticalCase:function(e,a){return 1<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?e%10==1?a[0]:a[1]:a[2]},translate:function(e,a,t,s){var n=W.words[t];return 1===t.length?"y"===t&&a?"\u0458\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430":s||a?n[0]:n[1]:(s=W.correctGrammaticalCase(e,n),"yy"===t&&a&&"\u0433\u043e\u0434\u0438\u043d\u0443"===s?e+" \u0433\u043e\u0434\u0438\u043d\u0430":e+" "+s)}},A=(c.defineLocale("sr-cyrl",{months:"\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split("_"),monthsShort:"\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split("_"),monthsParseExact:!0,weekdays:"\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split("_"),weekdaysMin:"\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",nextDay:"[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",nextWeek:function(){switch(this.day()){case 0:return"[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";case 3:return"[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";case 6:return"[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";case 1:case 2:case 4:case 5:return"[\u0443] dddd [\u0443] LT"}},lastDay:"[\u0458\u0443\u0447\u0435 \u0443] LT",lastWeek:function(){return["[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"\u043f\u0440\u0435 %s",s:"\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:W.translate,m:W.translate,mm:W.translate,h:W.translate,hh:W.translate,d:W.translate,dd:W.translate,M:W.translate,MM:W.translate,y:W.translate,yy:W.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),{words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],d:["jedan dan","jednog dana"],dd:["dan","dana","dana"],M:["jedan mesec","jednog meseca"],MM:["mesec","meseca","meseci"],y:["jednu godinu","jedne godine"],yy:["godinu","godine","godina"]},correctGrammaticalCase:function(e,a){return 1<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?e%10==1?a[0]:a[1]:a[2]},translate:function(e,a,t,s){var n=A.words[t];return 1===t.length?"y"===t&&a?"jedna godina":s||a?n[0]:n[1]:(s=A.correctGrammaticalCase(e,n),"yy"===t&&a&&"godinu"===s?e+" godina":e+" "+s)}}),Hn=(c.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedelje] [u] LT","[pro\u0161log] [ponedeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:A.translate,m:A.translate,mm:A.translate,h:A.translate,hh:A.translate,d:A.translate,dd:A.translate,M:A.translate,MM:A.translate,y:A.translate,yy:A.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),c.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",ss:"%d mzuzwana",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,a,t){return e<11?"ekuseni":e<15?"emini":e<19?"entsambama":"ebusuku"},meridiemHour:function(e,a){return 12===e&&(e=0),"ekuseni"===a?e:"emini"===a?11<=e?e:e+12:"entsambama"===a||"ebusuku"===a?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}}),c.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),weekdaysShort:"s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),weekdaysMin:"s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Ig\xe5r] LT",nextWeek:"[P\xe5] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"f\xf6r %s sedan",s:"n\xe5gra sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en m\xe5nad",MM:"%d m\xe5nader",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}(\:e|\:a)/,ordinal:function(e){var a=e%10;return e+(1!=~~(e%100/10)&&(1==a||2==a)?":a":":e")},week:{dow:1,doy:4}}),c.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"hh:mm A",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",ss:"sekunde %d",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"siku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}}),{1:"\u0be7",2:"\u0be8",3:"\u0be9",4:"\u0bea",5:"\u0beb",6:"\u0bec",7:"\u0bed",8:"\u0bee",9:"\u0bef",0:"\u0be6"}),Sn={"\u0be7":"1","\u0be8":"2","\u0be9":"3","\u0bea":"4","\u0beb":"5","\u0bec":"6","\u0bed":"7","\u0bee":"8","\u0bef":"9","\u0be6":"0"},vn=(c.defineLocale("ta",{months:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),monthsShort:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),weekdays:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split("_"),weekdaysShort:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split("_"),weekdaysMin:"\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",nextDay:"[\u0ba8\u0bbe\u0bb3\u0bc8] LT",nextWeek:"dddd, LT",lastDay:"[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",lastWeek:"[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0b87\u0bb2\u0bcd",past:"%s \u0bae\u0bc1\u0ba9\u0bcd",s:"\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",ss:"%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",m:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",mm:"%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",h:"\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",hh:"%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",d:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",dd:"%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",M:"\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",MM:"%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",y:"\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",yy:"%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd"},dayOfMonthOrdinalParse:/\d{1,2}\u0bb5\u0ba4\u0bc1/,ordinal:function(e){return e+"\u0bb5\u0ba4\u0bc1"},preparse:function(e){return e.replace(/[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g,function(e){return Sn[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Hn[e]})},meridiemParse:/\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,meridiem:function(e,a,t){return e<2?" \u0baf\u0bbe\u0bae\u0bae\u0bcd":e<6?" \u0bb5\u0bc8\u0b95\u0bb1\u0bc8":e<10?" \u0b95\u0bbe\u0bb2\u0bc8":e<14?" \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd":e<18?" \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1":e<22?" \u0bae\u0bbe\u0bb2\u0bc8":" \u0baf\u0bbe\u0bae\u0bae\u0bcd"},meridiemHour:function(e,a){return 12===e&&(e=0),"\u0baf\u0bbe\u0bae\u0bae\u0bcd"===a?e<2?e:e+12:"\u0bb5\u0bc8\u0b95\u0bb1\u0bc8"===a||"\u0b95\u0bbe\u0bb2\u0bc8"===a||"\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd"===a&&10<=e?e:e+12},week:{dow:0,doy:6}}),c.defineLocale("te",{months:"\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split("_"),monthsShort:"\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split("_"),monthsParseExact:!0,weekdays:"\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split("_"),weekdaysShort:"\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split("_"),weekdaysMin:"\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c28\u0c47\u0c21\u0c41] LT",nextDay:"[\u0c30\u0c47\u0c2a\u0c41] LT",nextWeek:"dddd, LT",lastDay:"[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",lastWeek:"[\u0c17\u0c24] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0c32\u0c4b",past:"%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",s:"\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",ss:"%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",m:"\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",mm:"%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",h:"\u0c12\u0c15 \u0c17\u0c02\u0c1f",hh:"%d \u0c17\u0c02\u0c1f\u0c32\u0c41",d:"\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",dd:"%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",M:"\u0c12\u0c15 \u0c28\u0c46\u0c32",MM:"%d \u0c28\u0c46\u0c32\u0c32\u0c41",y:"\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",yy:"%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41"},dayOfMonthOrdinalParse:/\d{1,2}\u0c35/,ordinal:"%d\u0c35",meridiemParse:/\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"===a?e<4?e:e+12:"\u0c09\u0c26\u0c2f\u0c02"===a?e:"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02"===a?10<=e?e:e+12:"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f":e<10?"\u0c09\u0c26\u0c2f\u0c02":e<17?"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02":e<20?"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02":"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"},week:{dow:0,doy:6}}),c.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"segundu balun",ss:"segundu %d",m:"minutu ida",mm:"minutu %d",h:"oras ida",hh:"oras %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),{0:"-\u0443\u043c",1:"-\u0443\u043c",2:"-\u044e\u043c",3:"-\u044e\u043c",4:"-\u0443\u043c",5:"-\u0443\u043c",6:"-\u0443\u043c",7:"-\u0443\u043c",8:"-\u0443\u043c",9:"-\u0443\u043c",10:"-\u0443\u043c",12:"-\u0443\u043c",13:"-\u0443\u043c",20:"-\u0443\u043c",30:"-\u044e\u043c",40:"-\u0443\u043c",50:"-\u0443\u043c",60:"-\u0443\u043c",70:"-\u0443\u043c",80:"-\u0443\u043c",90:"-\u0443\u043c",100:"-\u0443\u043c"}),jn=(c.defineLocale("tg",{months:{format:"\u044f\u043d\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043b\u0438_\u043c\u0430\u0440\u0442\u0438_\u0430\u043f\u0440\u0435\u043b\u0438_\u043c\u0430\u0439\u0438_\u0438\u044e\u043d\u0438_\u0438\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u0438_\u043e\u043a\u0442\u044f\u0431\u0440\u0438_\u043d\u043e\u044f\u0431\u0440\u0438_\u0434\u0435\u043a\u0430\u0431\u0440\u0438".split("_"),standalone:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_")},monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u044f\u043a\u0448\u0430\u043d\u0431\u0435_\u0434\u0443\u0448\u0430\u043d\u0431\u0435_\u0441\u0435\u0448\u0430\u043d\u0431\u0435_\u0447\u043e\u0440\u0448\u0430\u043d\u0431\u0435_\u043f\u0430\u043d\u04b7\u0448\u0430\u043d\u0431\u0435_\u04b7\u0443\u043c\u044a\u0430_\u0448\u0430\u043d\u0431\u0435".split("_"),weekdaysShort:"\u044f\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043f\u0448\u0431_\u04b7\u0443\u043c_\u0448\u043d\u0431".split("_"),weekdaysMin:"\u044f\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043f\u0448_\u04b7\u043c_\u0448\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0418\u043c\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",nextDay:"[\u0424\u0430\u0440\u0434\u043e \u0441\u043e\u0430\u0442\u0438] LT",lastDay:"[\u0414\u0438\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",nextWeek:"dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u043e\u044f\u043d\u0434\u0430 \u0441\u043e\u0430\u0442\u0438] LT",lastWeek:"dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043e\u0430\u0442\u0438] LT",sameElse:"L"},relativeTime:{future:"\u0431\u0430\u044a\u0434\u0438 %s",past:"%s \u043f\u0435\u0448",s:"\u044f\u043a\u0447\u0430\u043d\u0434 \u0441\u043e\u043d\u0438\u044f",m:"\u044f\u043a \u0434\u0430\u049b\u0438\u049b\u0430",mm:"%d \u0434\u0430\u049b\u0438\u049b\u0430",h:"\u044f\u043a \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u044f\u043a \u0440\u04ef\u0437",dd:"%d \u0440\u04ef\u0437",M:"\u044f\u043a \u043c\u043e\u04b3",MM:"%d \u043c\u043e\u04b3",y:"\u044f\u043a \u0441\u043e\u043b",yy:"%d \u0441\u043e\u043b"},meridiemParse:/\u0448\u0430\u0431|\u0441\u0443\u0431\u04b3|\u0440\u04ef\u0437|\u0431\u0435\u0433\u043e\u04b3/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0448\u0430\u0431"===a?e<4?e:e+12:"\u0441\u0443\u0431\u04b3"===a?e:"\u0440\u04ef\u0437"===a?11<=e?e:e+12:"\u0431\u0435\u0433\u043e\u04b3"===a?e+12:void 0},meridiem:function(e,a,t){return e<4?"\u0448\u0430\u0431":e<11?"\u0441\u0443\u0431\u04b3":e<16?"\u0440\u04ef\u0437":e<19?"\u0431\u0435\u0433\u043e\u04b3":"\u0448\u0430\u0431"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0443\u043c|\u044e\u043c)/,ordinal:function(e){return e+(vn[e]||vn[e%10]||vn[100<=e?100:null])},week:{dow:1,doy:7}}),c.defineLocale("th",{months:"\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split("_"),monthsShort:"\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split("_"),monthsParseExact:!0,weekdays:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysShort:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysMin:"\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",LLLL:"\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm"},meridiemParse:/\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,isPM:function(e){return"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"===e},meridiem:function(e,a,t){return e<12?"\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07":"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"},calendar:{sameDay:"[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextDay:"[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextWeek:"dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",lastDay:"[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",lastWeek:"[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",sameElse:"L"},relativeTime:{future:"\u0e2d\u0e35\u0e01 %s",past:"%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",s:"\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",ss:"%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",m:"1 \u0e19\u0e32\u0e17\u0e35",mm:"%d \u0e19\u0e32\u0e17\u0e35",h:"1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",hh:"%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",d:"1 \u0e27\u0e31\u0e19",dd:"%d \u0e27\u0e31\u0e19",w:"1 \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",ww:"%d \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",M:"1 \u0e40\u0e14\u0e37\u0e2d\u0e19",MM:"%d \u0e40\u0e14\u0e37\u0e2d\u0e19",y:"1 \u0e1b\u0e35",yy:"%d \u0e1b\u0e35"}}),{1:"'inji",5:"'inji",8:"'inji",70:"'inji",80:"'inji",2:"'nji",7:"'nji",20:"'nji",50:"'nji",3:"'\xfcnji",4:"'\xfcnji",100:"'\xfcnji",6:"'njy",9:"'unjy",10:"'unjy",30:"'unjy",60:"'ynjy",90:"'ynjy"}),xn=(c.defineLocale("tk",{months:"\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split("_"),monthsShort:"\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split("_"),weekdays:"\xddek\u015fenbe_Du\u015fenbe_Si\u015fenbe_\xc7ar\u015fenbe_Pen\u015fenbe_Anna_\u015eenbe".split("_"),weekdaysShort:"\xddek_Du\u015f_Si\u015f_\xc7ar_Pen_Ann_\u015een".split("_"),weekdaysMin:"\xddk_D\u015f_S\u015f_\xc7r_Pn_An_\u015en".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn sagat] LT",nextDay:"[ertir sagat] LT",nextWeek:"[indiki] dddd [sagat] LT",lastDay:"[d\xfc\xfdn] LT",lastWeek:"[ge\xe7en] dddd [sagat] LT",sameElse:"L"},relativeTime:{future:"%s so\u0148",past:"%s \xf6\u0148",s:"birn\xe4\xe7e sekunt",m:"bir minut",mm:"%d minut",h:"bir sagat",hh:"%d sagat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir a\xfd",MM:"%d a\xfd",y:"bir \xfdyl",yy:"%d \xfdyl"},ordinal:function(e,a){switch(a){case"d":case"D":case"Do":case"DD":return e;default:var t;return 0===e?e+"'unjy":e+(jn[t=e%10]||jn[e%100-t]||jn[100<=e?100:null])}},week:{dow:1,doy:7}}),c.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),"pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_"));function Pn(e,a,t,s){var n=function(e){var a=Math.floor(e%1e3/100),t=Math.floor(e%100/10),e=e%10,s="";0<a&&(s+=xn[a]+"vatlh");0<t&&(s+=(""!==s?" ":"")+xn[t]+"maH");0<e&&(s+=(""!==s?" ":"")+xn[e]);return""===s?"pagh":s}(e);switch(t){case"ss":return n+" lup";case"mm":return n+" tup";case"hh":return n+" rep";case"dd":return n+" jaj";case"MM":return n+" jar";case"yy":return n+" DIS"}}c.defineLocale("tlh",{months:"tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split("_"),monthsShort:"jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa\u2019leS] LT",nextWeek:"LLL",lastDay:"[wa\u2019Hu\u2019] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"leS":-1!==e.indexOf("jar")?a.slice(0,-3)+"waQ":-1!==e.indexOf("DIS")?a.slice(0,-3)+"nem":a+" pIq"},past:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"Hu\u2019":-1!==e.indexOf("jar")?a.slice(0,-3)+"wen":-1!==e.indexOf("DIS")?a.slice(0,-3)+"ben":a+" ret"},s:"puS lup",ss:Pn,m:"wa\u2019 tup",mm:Pn,h:"wa\u2019 rep",hh:Pn,d:"wa\u2019 jaj",dd:Pn,M:"wa\u2019 jar",MM:Pn,y:"wa\u2019 DIS",yy:Pn},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var On={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'\xfcnc\xfc",4:"'\xfcnc\xfc",100:"'\xfcnc\xfc",6:"'nc\u0131",9:"'uncu",10:"'uncu",30:"'uncu",60:"'\u0131nc\u0131",90:"'\u0131nc\u0131"};function Wn(e,a,t,s){e={s:["viensas secunds","'iensas secunds"],ss:[e+" secunds",e+" secunds"],m:["'n m\xedut","'iens m\xedut"],mm:[e+" m\xeduts",e+" m\xeduts"],h:["'n \xfeora","'iensa \xfeora"],hh:[e+" \xfeoras",e+" \xfeoras"],d:["'n ziua","'iensa ziua"],dd:[e+" ziuas",e+" ziuas"],M:["'n mes","'iens mes"],MM:[e+" mesen",e+" mesen"],y:["'n ar","'iens ar"],yy:[e+" ars",e+" ars"]};return s||a?e[t][0]:e[t][1]}function An(e,a,t){return"m"===t?a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443":"h"===t?a?"\u0433\u043e\u0434\u0438\u043d\u0430":"\u0433\u043e\u0434\u0438\u043d\u0443":e+" "+(e=+e,a=(a={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",hh:a?"\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d":"\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",MM:"\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",yy:"\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432"}[t]).split("_"),e%10==1&&e%100!=11?a[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?a[1]:a[2])}function En(e){return function(){return e+"\u043e"+(11===this.hours()?"\u0431":"")+"] LT"}}c.defineLocale("tr",{months:"Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),monthsShort:"Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split("_"),weekdaysMin:"Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),meridiem:function(e,a,t){return e<12?t?"\xf6\xf6":"\xd6\xd6":t?"\xf6s":"\xd6S"},meridiemParse:/\xf6\xf6|\xd6\xd6|\xf6s|\xd6S/,isPM:function(e){return"\xf6s"===e||"\xd6S"===e},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[yar\u0131n saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[d\xfcn] LT",lastWeek:"[ge\xe7en] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \xf6nce",s:"birka\xe7 saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",w:"bir hafta",ww:"%d hafta",M:"bir ay",MM:"%d ay",y:"bir y\u0131l",yy:"%d y\u0131l"},ordinal:function(e,a){switch(a){case"d":case"D":case"Do":case"DD":return e;default:var t;return 0===e?e+"'\u0131nc\u0131":e+(On[t=e%10]||On[e%100-t]||On[100<=e?100:null])}},week:{dow:1,doy:7}}),c.defineLocale("tzl",{months:"Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),weekdaysShort:"S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),weekdaysMin:"S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(e){return"d'o"===e.toLowerCase()},meridiem:function(e,a,t){return 11<e?t?"d'o":"D'O":t?"d'a":"D'A"},calendar:{sameDay:"[oxhi \xe0] LT",nextDay:"[dem\xe0 \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[ieiri \xe0] LT",lastWeek:"[s\xfcr el] dddd [lasteu \xe0] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:Wn,ss:Wn,m:Wn,mm:Wn,h:Wn,hh:Wn,d:Wn,dd:Wn,M:Wn,MM:Wn,y:Wn,yy:Wn},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),c.defineLocale("tzm-latn",{months:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",ss:"%d imik",m:"minu\u1e0d",mm:"%d minu\u1e0d",h:"sa\u025ba",hh:"%d tassa\u025bin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}}),c.defineLocale("tzm",{months:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),monthsShort:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),weekdays:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysShort:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysMin:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",nextDay:"[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",nextWeek:"dddd [\u2d34] LT",lastDay:"[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",lastWeek:"dddd [\u2d34] LT",sameElse:"L"},relativeTime:{future:"\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",past:"\u2d62\u2d30\u2d4f %s",s:"\u2d49\u2d4e\u2d49\u2d3d",ss:"%d \u2d49\u2d4e\u2d49\u2d3d",m:"\u2d4e\u2d49\u2d4f\u2d53\u2d3a",mm:"%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",h:"\u2d59\u2d30\u2d44\u2d30",hh:"%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",d:"\u2d30\u2d59\u2d59",dd:"%d o\u2d59\u2d59\u2d30\u2d4f",M:"\u2d30\u2d62o\u2d53\u2d54",MM:"%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",y:"\u2d30\u2d59\u2d33\u2d30\u2d59",yy:"%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f"},week:{dow:6,doy:12}}),c.defineLocale("ug-cn",{months:"\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),monthsShort:"\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),weekdays:"\u064a\u06d5\u0643\u0634\u06d5\u0646\u0628\u06d5_\u062f\u06c8\u0634\u06d5\u0646\u0628\u06d5_\u0633\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u0686\u0627\u0631\u0634\u06d5\u0646\u0628\u06d5_\u067e\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u062c\u06c8\u0645\u06d5_\u0634\u06d5\u0646\u0628\u06d5".split("_"),weekdaysShort:"\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),weekdaysMin:"\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649",LLL:"YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",LLLL:"dddd\u060c YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm"},meridiemParse:/\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5|\u0633\u06d5\u06be\u06d5\u0631|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646|\u0686\u06c8\u0634|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646|\u0643\u06d5\u0686/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5"===a||"\u0633\u06d5\u06be\u06d5\u0631"===a||"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646"===a||"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646"!==a&&"\u0643\u06d5\u0686"!==a&&11<=e?e:e+12},meridiem:function(e,a,t){e=100*e+a;return e<600?"\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5":e<900?"\u0633\u06d5\u06be\u06d5\u0631":e<1130?"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646":e<1230?"\u0686\u06c8\u0634":e<1800?"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646":"\u0643\u06d5\u0686"},calendar:{sameDay:"[\u0628\u06c8\u06af\u06c8\u0646 \u0633\u0627\u0626\u06d5\u062a] LT",nextDay:"[\u0626\u06d5\u062a\u06d5 \u0633\u0627\u0626\u06d5\u062a] LT",nextWeek:"[\u0643\u06d0\u0644\u06d5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",lastDay:"[\u062a\u06c6\u0646\u06c8\u06af\u06c8\u0646] LT",lastWeek:"[\u0626\u0627\u0644\u062f\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0643\u06d0\u064a\u0649\u0646",past:"%s \u0628\u06c7\u0631\u06c7\u0646",s:"\u0646\u06d5\u0686\u0686\u06d5 \u0633\u06d0\u0643\u0648\u0646\u062a",ss:"%d \u0633\u06d0\u0643\u0648\u0646\u062a",m:"\u0628\u0649\u0631 \u0645\u0649\u0646\u06c7\u062a",mm:"%d \u0645\u0649\u0646\u06c7\u062a",h:"\u0628\u0649\u0631 \u0633\u0627\u0626\u06d5\u062a",hh:"%d \u0633\u0627\u0626\u06d5\u062a",d:"\u0628\u0649\u0631 \u0643\u06c8\u0646",dd:"%d \u0643\u06c8\u0646",M:"\u0628\u0649\u0631 \u0626\u0627\u064a",MM:"%d \u0626\u0627\u064a",y:"\u0628\u0649\u0631 \u064a\u0649\u0644",yy:"%d \u064a\u0649\u0644"},dayOfMonthOrdinalParse:/\d{1,2}(-\u0643\u06c8\u0646\u0649|-\u0626\u0627\u064a|-\u06be\u06d5\u067e\u062a\u06d5)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"-\u0643\u06c8\u0646\u0649";case"w":case"W":return e+"-\u06be\u06d5\u067e\u062a\u06d5";default:return e}},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:7}}),c.defineLocale("uk",{months:{format:"\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split("_"),standalone:"\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split("_")},monthsShort:"\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),weekdays:function(e,a){var t={nominative:"\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),accusative:"\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),genitive:"\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split("_")};return!0===e?t.nominative.slice(1,7).concat(t.nominative.slice(0,1)):e?t[/(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(a)?"accusative":/\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(a)?"genitive":"nominative"][e.day()]:t.nominative},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0440.",LLL:"D MMMM YYYY \u0440., HH:mm",LLLL:"dddd, D MMMM YYYY \u0440., HH:mm"},calendar:{sameDay:En("[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "),nextDay:En("[\u0417\u0430\u0432\u0442\u0440\u0430 "),lastDay:En("[\u0412\u0447\u043e\u0440\u0430 "),nextWeek:En("[\u0423] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return En("[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd [").call(this);case 1:case 2:case 4:return En("[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"%s \u0442\u043e\u043c\u0443",s:"\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",ss:An,m:An,mm:An,h:"\u0433\u043e\u0434\u0438\u043d\u0443",hh:An,d:"\u0434\u0435\u043d\u044c",dd:An,M:"\u043c\u0456\u0441\u044f\u0446\u044c",MM:An,y:"\u0440\u0456\u043a",yy:An},meridiemParse:/\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(e)},meridiem:function(e,a,t){return e<4?"\u043d\u043e\u0447\u0456":e<12?"\u0440\u0430\u043d\u043a\u0443":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u043e\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-\u0439";case"D":return e+"-\u0433\u043e";default:return e}},week:{dow:1,doy:7}});i=["\u062c\u0646\u0648\u0631\u06cc","\u0641\u0631\u0648\u0631\u06cc","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u06cc\u0644","\u0645\u0626\u06cc","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0626\u06cc","\u0627\u06af\u0633\u062a","\u0633\u062a\u0645\u0628\u0631","\u0627\u06a9\u062a\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u062f\u0633\u0645\u0628\u0631"],jt=["\u0627\u062a\u0648\u0627\u0631","\u067e\u06cc\u0631","\u0645\u0646\u06af\u0644","\u0628\u062f\u06be","\u062c\u0645\u0639\u0631\u0627\u062a","\u062c\u0645\u0639\u06c1","\u06c1\u0641\u062a\u06c1"];return c.defineLocale("ur",{months:i,monthsShort:i,weekdays:jt,weekdaysShort:jt,weekdaysMin:jt,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,t){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0622\u062c \u0628\u0648\u0642\u062a] LT",nextDay:"[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",nextWeek:"dddd [\u0628\u0648\u0642\u062a] LT",lastDay:"[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",lastWeek:"[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0628\u0639\u062f",past:"%s \u0642\u0628\u0644",s:"\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",ss:"%d \u0633\u06cc\u06a9\u0646\u0688",m:"\u0627\u06cc\u06a9 \u0645\u0646\u0679",mm:"%d \u0645\u0646\u0679",h:"\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",hh:"%d \u06af\u06be\u0646\u0679\u06d2",d:"\u0627\u06cc\u06a9 \u062f\u0646",dd:"%d \u062f\u0646",M:"\u0627\u06cc\u06a9 \u0645\u0627\u06c1",MM:"%d \u0645\u0627\u06c1",y:"\u0627\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),c.defineLocale("uz-latn",{months:"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),monthsShort:"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),weekdays:"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),weekdaysShort:"Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),weekdaysMin:"Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Bugun soat] LT [da]",nextDay:"[Ertaga] LT [da]",nextWeek:"dddd [kuni soat] LT [da]",lastDay:"[Kecha soat] LT [da]",lastWeek:"[O'tgan] dddd [kuni soat] LT [da]",sameElse:"L"},relativeTime:{future:"Yaqin %s ichida",past:"Bir necha %s oldin",s:"soniya",ss:"%d soniya",m:"bir daqiqa",mm:"%d daqiqa",h:"bir soat",hh:"%d soat",d:"bir kun",dd:"%d kun",M:"bir oy",MM:"%d oy",y:"bir yil",yy:"%d yil"},week:{dow:1,doy:7}}),c.defineLocale("uz",{months:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split("_"),weekdaysShort:"\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split("_"),weekdaysMin:"\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",nextDay:"[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",nextWeek:"dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastDay:"[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastWeek:"[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",sameElse:"L"},relativeTime:{future:"\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",past:"\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",s:"\u0444\u0443\u0440\u0441\u0430\u0442",ss:"%d \u0444\u0443\u0440\u0441\u0430\u0442",m:"\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",mm:"%d \u0434\u0430\u043a\u0438\u043a\u0430",h:"\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u0431\u0438\u0440 \u043e\u0439",MM:"%d \u043e\u0439",y:"\u0431\u0438\u0440 \u0439\u0438\u043b",yy:"%d \u0439\u0438\u043b"},week:{dow:1,doy:7}}),c.defineLocale("vi",{months:"th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split("_"),monthsShort:"Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),monthsParseExact:!0,weekdays:"ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,t){return e<12?t?"sa":"SA":t?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [n\u0103m] YYYY",LLL:"D MMMM [n\u0103m] YYYY HH:mm",LLLL:"dddd, D MMMM [n\u0103m] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[H\xf4m nay l\xfac] LT",nextDay:"[Ng\xe0y mai l\xfac] LT",nextWeek:"dddd [tu\u1ea7n t\u1edbi l\xfac] LT",lastDay:"[H\xf4m qua l\xfac] LT",lastWeek:"dddd [tu\u1ea7n tr\u01b0\u1edbc l\xfac] LT",sameElse:"L"},relativeTime:{future:"%s t\u1edbi",past:"%s tr\u01b0\u1edbc",s:"v\xe0i gi\xe2y",ss:"%d gi\xe2y",m:"m\u1ed9t ph\xfat",mm:"%d ph\xfat",h:"m\u1ed9t gi\u1edd",hh:"%d gi\u1edd",d:"m\u1ed9t ng\xe0y",dd:"%d ng\xe0y",w:"m\u1ed9t tu\u1ea7n",ww:"%d tu\u1ea7n",M:"m\u1ed9t th\xe1ng",MM:"%d th\xe1ng",y:"m\u1ed9t n\u0103m",yy:"%d n\u0103m"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),c.defineLocale("x-pseudo",{months:"J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split("_"),monthsShort:"J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split("_"),monthsParseExact:!0,weekdays:"S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split("_"),weekdaysShort:"S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),weekdaysMin:"S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~\xf3d\xe1~\xfd \xe1t] LT",nextDay:"[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",nextWeek:"dddd [\xe1t] LT",lastDay:"[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",lastWeek:"[L~\xe1st] dddd [\xe1t] LT",sameElse:"L"},relativeTime:{future:"\xed~\xf1 %s",past:"%s \xe1~g\xf3",s:"\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",ss:"%d s~\xe9c\xf3\xf1~ds",m:"\xe1 ~m\xed\xf1~\xfat\xe9",mm:"%d m~\xed\xf1\xfa~t\xe9s",h:"\xe1~\xf1 h\xf3~\xfar",hh:"%d h~\xf3\xfars",d:"\xe1 ~d\xe1\xfd",dd:"%d d~\xe1\xfds",M:"\xe1 ~m\xf3\xf1~th",MM:"%d m~\xf3\xf1t~hs",y:"\xe1 ~\xfd\xe9\xe1r",yy:"%d \xfd~\xe9\xe1rs"},dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),c.defineLocale("yo",{months:"S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),monthsShort:"S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),weekdays:"A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split("_"),weekdaysShort:"A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split("_"),weekdaysMin:"A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[O\u0300ni\u0300 ni] LT",nextDay:"[\u1ecc\u0300la ni] LT",nextWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",lastDay:"[A\u0300na ni] LT",lastWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",sameElse:"L"},relativeTime:{future:"ni\u0301 %s",past:"%s k\u1ecdja\u0301",s:"i\u0300s\u1eb9ju\u0301 aaya\u0301 die",ss:"aaya\u0301 %d",m:"i\u0300s\u1eb9ju\u0301 kan",mm:"i\u0300s\u1eb9ju\u0301 %d",h:"wa\u0301kati kan",hh:"wa\u0301kati %d",d:"\u1ecdj\u1ecd\u0301 kan",dd:"\u1ecdj\u1ecd\u0301 %d",M:"osu\u0300 kan",MM:"osu\u0300 %d",y:"\u1ecddu\u0301n kan",yy:"\u1ecddu\u0301n %d"},dayOfMonthOrdinalParse:/\u1ecdj\u1ecd\u0301\s\d{1,2}/,ordinal:"\u1ecdj\u1ecd\u0301 %d",week:{dow:1,doy:4}}),c.defineLocale("zh-cn",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",LLLL:"YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a||"\u4e0b\u5348"!==a&&"\u665a\u4e0a"!==a&&11<=e?e:e+12},meridiem:function(e,a,t){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1130?"\u4e0a\u5348":e<1230?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:function(e){return e.week()!==this.week()?"[\u4e0b]dddLT":"[\u672c]dddLT"},lastDay:"[\u6628\u5929]LT",lastWeek:function(e){return this.week()!==e.week()?"[\u4e0a]dddLT":"[\u672c]dddLT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u5468)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u5468";default:return e}},relativeTime:{future:"%s\u540e",past:"%s\u524d",s:"\u51e0\u79d2",ss:"%d \u79d2",m:"1 \u5206\u949f",mm:"%d \u5206\u949f",h:"1 \u5c0f\u65f6",hh:"%d \u5c0f\u65f6",d:"1 \u5929",dd:"%d \u5929",w:"1 \u5468",ww:"%d \u5468",M:"1 \u4e2a\u6708",MM:"%d \u4e2a\u6708",y:"1 \u5e74",yy:"%d \u5e74"},week:{dow:1,doy:4}}),c.defineLocale("zh-hk",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,t){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1200?"\u4e0a\u5348":1200===e?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),c.defineLocale("zh-mo",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"D/M/YYYY",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,t){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1130?"\u4e0a\u5348":e<1230?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929] LT",nextDay:"[\u660e\u5929] LT",nextWeek:"[\u4e0b]dddd LT",lastDay:"[\u6628\u5929] LT",lastWeek:"[\u4e0a]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5167",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),c.defineLocale("zh-tw",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,t){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1130?"\u4e0a\u5348":e<1230?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929] LT",nextDay:"[\u660e\u5929] LT",nextWeek:"[\u4e0b]dddd LT",lastDay:"[\u6628\u5929] LT",lastWeek:"[\u4e0a]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),c.locale("en"),c});
//# sourceMappingURL=moment-with-locales.min.js.map
/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 * Open source under the BSD License.
 *
 * Copyright ÂŠ 2008 George McGinley Smith
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
	{
		easeOutExpo: function (x, t, b, c, d) {
			return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
		},
		easeInElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		},
		easeOutElastic: function (x, t, b, c, d) {
			var s=1.70158;var p=0;var a=c;
			if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
			if (a < Math.abs(c)) { a=c; var s=p/4; }
			else var s = p/(2*Math.PI) * Math.asin (c/a);
			return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
		}
	});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 *
 * Open source under the BSD License.
 *
 * Copyright ÂŠ 2001 Robert Penner
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice, this list of
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list
 * of conditions and the following disclaimer in the documentation and/or other materials
 * provided with the distribution.
 *
 * Neither the name of the author nor the names of contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */
/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
 */

(function () { 'use strict';

// to suit your point format, run search/replace for '.x' and '.y';
// for 3D version, see 3d branch (configurability would draw significant performance overhead)

// square distance between 2 points
    function getSqDist(p1, p2) {

        var dx = p1.x - p2.x,
            dy = p1.y - p2.y;

        return dx * dx + dy * dy;
    }

// square distance from a point to a segment
    function getSqSegDist(p, p1, p2) {

        var x = p1.x,
            y = p1.y,
            dx = p2.x - x,
            dy = p2.y - y;

        if (dx !== 0 || dy !== 0) {

            var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

            if (t > 1) {
                x = p2.x;
                y = p2.y;

            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }

        dx = p.x - x;
        dy = p.y - y;

        return dx * dx + dy * dy;
    }
// rest of the code doesn't care about point format

// basic distance-based simplification
    function simplifyRadialDist(points, sqTolerance) {

        var prevPoint = points[0],
            newPoints = [prevPoint],
            point;

        for (var i = 1, len = points.length; i < len; i++) {
            point = points[i];

            if (getSqDist(point, prevPoint) > sqTolerance) {
                newPoints.push(point);
                prevPoint = point;
            }
        }

        if (prevPoint !== point) newPoints.push(point);

        return newPoints;
    }

    function simplifyDPStep(points, first, last, sqTolerance, simplified) {
        var maxSqDist = sqTolerance,
            index;

        for (var i = first + 1; i < last; i++) {
            var sqDist = getSqSegDist(points[i], points[first], points[last]);

            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }

        if (maxSqDist > sqTolerance) {
            if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
            simplified.push(points[index]);
            if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
        }
    }

// simplification using Ramer-Douglas-Peucker algorithm
    function simplifyDouglasPeucker(points, sqTolerance) {
        var last = points.length - 1;

        var simplified = [points[0]];
        simplifyDPStep(points, 0, last, sqTolerance, simplified);
        simplified.push(points[last]);

        return simplified;
    }

// both algorithms combined for awesome performance
    function simplify(points, tolerance, highestQuality) {

        if (points.length <= 2) return points;

        var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

        points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
        points = simplifyDouglasPeucker(points, sqTolerance);

        return points;
    }

    window.simplify = simplify;

})();
(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *		 the user visible viewport of a web browser.
     *		 only accounts for vertical position, not horizontal.
     */
    $.fn.visible = function(partial){

        var $t				= $(this),
            $w				= $(window),
            viewTop			= $w.scrollTop(),
            viewBottom		= viewTop + $w.height(),
            _top			= $t.offset().top,
            _bottom			= _top + $t.height(),
            compareTop		= partial === true ? _bottom : _top,
            compareBottom	= partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

})(jQuery);
APP.Calculator.Keyboard = (function () {
    var exports = {},

        CALCULATE_SERVICE = '/hu/service/calculate',

        previousCalculator = false,
        $keyBoard = null,
        $editCta,
        initialized = false,
        activeCalculator,
        calculators = [],
        keyboardHideTimer = null,
        keyboardHideDuration = 70,

        preventHideKeyboard = false,
        preventFocusRestore = false,
        lastUsedCalc,

        isMouseDown = false;

    function init() {
        preventHideKeyboard = false;
        $editCta = $body.find('[data-input-edit-cta]');
        if (!initialized) {
            initialized = true;
            $keyBoard = $body.find('[data-keyboard]');
            $body.find('[data-keyboard="desktop"]').html(
                APP.Tpl.run('keyboard/desktop') +
                APP.Tpl.run('keyboard/5th') +
                APP.Tpl.run('keyboard/symbol')
            );
            $body.find('[data-keyboard="device"]').html(
                APP.Tpl.run('keyboard/device') +
                APP.Tpl.run('keyboard/5th-device') +
                APP.Tpl.run('keyboard/symbol-device')
            );
            $body.find('[data-keyboard="qwerty"]').html(APP.Tpl.run('keyboard/qwerty'));
            $body.find('[data-keyboard="qwerty-uppercase"]').html(APP.Tpl.run('keyboard/qwerty-uppercase'));
            initBindings();
        }
        setUpKeyboardDisables();
        setUpExtraButtons();
    }

    function setUpKeyboardDisables() {
        var mode = $body.find('[data-keyboard-mode]').val();

        $body.find('[data-keyboard-var]').hide();

        if (mode) {
            $body.find('[data-keyboard-var="' + mode + '"]').show();
        } else {
            $body.find('[data-keyboard-var="default"]').show();
        }

        if ([
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            || navigator.userAgent.includes('Android')
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) {
            $body.find('[data-calculator-focus-hunter]').attr('readonly', 'readonly');
        }
    }

    function setUpExtraButtons() {
        var extraButtons = [],
            extraButtonSource = $body.find('[data-extra-buttons]').attr('data-extra-buttons');

        try {
            extraButtons = extraButtonSource ? JSON.parse(extraButtonSource) : [];
        } catch (e) {
            APP.Error.logError(e, {
                source: 'APP.Calculator.Keyboard.extraButtons',
                context: {
                    raw: $body.find('[data-extra-buttons]').attr('data-extra-buttons') || ''
                }
            });
        }

        var extraButtonsKey = JSON.stringify(extraButtons);
        $body.find('[data-keyboard="extra-buttons"]').each(function () {
            var $container = $(this);
            // Focus recovery can run between mousedown and click; keep the pressed node attached.
            if ($container.data('keyboard-extra-buttons') !== extraButtonsKey) {
                $container.html(APP.Tpl.run('keyboard/extra-buttons', extraButtons));
                $container.data('keyboard-extra-buttons', extraButtonsKey);
            }
        });
    }

    function initBindings() {
        $document.on('mouseup', function () {
            isMouseDown = false;
            setTimeout(function () {
                if (activeCalculator && $body.find('.overlay--show').length === 0) {
                    activeCalculator.addFocus();
                }
            }, 20);
        });

        $document.on('mousedown', function () {
            isMouseDown = true;
            previousCalculator = activeCalculator;
            activeCalculator = false;
        });

        $keyBoard.on('mouseup', function () {
            isMouseDown = false;
            activeCalculator = previousCalculator;
        });

        $body.on('mouseup mousedown click select', '[data-calculator]', function (e) {
            activeCalculator = activeCalculator || previousCalculator;
            e.preventDefault();
        });

        $body.on('click', '[data-calculator]', function (e) {
            var $this = $(this);

            $this.find('[data-calculator-focus-hunter]').focus();
        });

        $body.on('click', '[data-keyboard-character]', function (e) {
            e.stopPropagation();
            if (lastUsedCalc) {
                var character = $(this).attr('data-keyboard-character');

                lastUsedCalc.addString(character);
                APP.Analytics.trackEvent('keyboard', 'press', 'character', {character: character});
            }
        });

        $keyBoard.find('[data-keyboard-action]').on('click', function (e) {
            var $this = $(this);

            e.stopPropagation();
            if (lastUsedCalc && !$this.attr('data-keyboard-alert')) {
                var action = $this.attr('data-keyboard-action');
                lastUsedCalc.addFormula(action);
                APP.Analytics.trackEvent('keyboard', 'press', 'action', {action: action});
            }
        });

        $body.on('click', '[data-keyboard-alert]', function (e) {
            APP.Layout.alert($(this).attr('data-keyboard-alert'), false, function () {
                if (lastUsedCalc) {
                    lastUsedCalc.addFocus();
                }
            });
            if (activeCalculator) {
                activeCalculator.addFocus();
            }
        });

        $keyBoard.find('[data-keyboard-method]').on('click', function () {
            if (lastUsedCalc) {
                var method = $(this).attr('data-keyboard-method');
                lastUsedCalc.addHotKey(method);
                APP.Analytics.trackEvent('keyboard', 'press', 'method', {method: method});
            }
        });

        $keyBoard.find('[data-keyboard-calculate]').on('click', submit);

        $body.find('[data-scroll-to-input]').on('click', scrollToDashboardInput);

        $body.on('click', '[data-input-edit-cta]', function () {
            $body.find('[data-calculator-focus-hunter]').focus();
        });

        $body.on('click', '[data-keyboard-qwerty]', function () {
            if (lastUsedCalc) {
                $body.addClass('qwerty');
                $body.removeClass('qwerty-uppercase');
                lastUsedCalc.addFocus();
            }
        });

        $body.on('click', '[data-keyboard-qwerty-uppercase]', function () {
            if (lastUsedCalc) {
                $body.addClass('qwerty-uppercase');
                $body.removeClass('qwerty');
                lastUsedCalc.addFocus();
            }
        });

        $body.on('click', '[data-keyboard-normal]', function () {
            if (lastUsedCalc) {
                $body.removeClass('qwerty-uppercase');
                $body.removeClass('qwerty');
                lastUsedCalc.addFocus();
            }
        });

        $body.on('click', '[data-close-input]', function () {
            hideKeyboard(true);
        });

        $document.on('keydown', function (e) {
            if (e.key === 'Escape' && $keyBoard.hasClass('keyboard--show')) {
                hideKeyboard(true);
            }
        });

        virtualKeyboardDetector.on('virtualKeyboardVisible', function () {
            var $hunter = $body.find('[data-calculator-focus-hunter]');
            $hunter.attr('readonly', 'readonly');
            $hunter.blur();
            scrollToDashboardInput(1);
        });

        $body.on('focus', '[data-calculator-focus-hunter]', function () {
            $body.find('[data-calculator-focus-hunter]').attr('autocomplete', 'off');
        });
    }

    function sendCalculatorContent(content) {
        APP.Ajax.post(CALCULATE_SERVICE, {input: content}).then(outputArrived, function (error) {
            APP.Error.logError(error || new Error('Calculator submit request failed'), {
                source: 'APP.Calculator.Keyboard.sendCalculatorContent',
                context: {
                    service: CALCULATE_SERVICE
                }
            });
            APP.Analytics.trackEvent('keyboard', 'submit', 'fail general');
        });
    }

    function outputArrived(result) {
        if (result.success) {
            APP.Analytics.trackEvent('keyboard', 'submit', 'success', JSON.stringify(activeCalculator && activeCalculator.getContent && activeCalculator.getContent()));
            APP.Page.applyPageByUrl('/hu/problem/' + result.id);
        } else {
            APP.Analytics.trackEvent('keyboard', 'submit', 'fail', {error: result.error});
            APP.Error.logError(new Error('Calculator service returned unsuccessful result'), {
                source: 'APP.Calculator.Keyboard.outputArrived',
                context: {
                    error: result.error || '',
                    service: CALCULATE_SERVICE
                }
            });
        }
    }

    function displayError(error) {
        APP.Analytics.trackEvent('keyboard', 'displayError', error);
        APP.Layout.alert(error);
        APP.Layout.onOverlayClose(function () {
            $body.find('[data-calculator]').trigger('click');
        });
    }

    function showKeyboard(calculator) {
        init();
        clearTimeout(keyboardHideTimer);
        preventFocusRestore = false;
        activateCalculator(calculator);
        if (!$keyBoard.hasClass('keyboard--show')) {
            APP.Analytics.trackEvent('keyboard', 'show');
            $keyBoard.addClass('keyboard--show');
            $body.addClass('application--show-keyboard');
            $body.find('[data-dashboard-input]').addClass('dashboard__card--active');
            $body.find('[data-dashboard-learn]').hide();
            $body.find('[data-keyboard-calculate] .text').text($body.find('[data-calculator-cta]').attr('data-calculator-cta'));
        }
    }

    function autoFocus() {
        if (lastUsedCalc) {
            showKeyboard(lastUsedCalc);
            lastUsedCalc.addFocus();
        }
    }

    function setActiveCalculator(calculator) {
        activateCalculator(calculator);
    }

    function activateCalculator(calculator) {
        if (!calculator) {
            return;
        }

        hideInactiveCalculators(calculator);
        activeCalculator = lastUsedCalc = previousCalculator = calculator;
    }

    function hideInactiveCalculators(active) {
        calculators.forEach(function (calculator) {
            if (calculator !== active) {
                calculator.hideCursor();
                calculator.exitCalculator();
            }
        });
    }

    function addCalculator(calc) {
        cleanDetachedCalculators();
        if (calculators.indexOf(calc) === -1) {
            calculators.push(calc);
        }

        lastUsedCalc = lastUsedCalc || calc;
    }

    function cleanDetachedCalculators() {
        calculators = calculators.filter(function (calculator) {
            return calculator && calculator.isAttached && calculator.isAttached();
        });

        if (lastUsedCalc && calculators.indexOf(lastUsedCalc) === -1) {
            lastUsedCalc = false;
        }
        if (activeCalculator && calculators.indexOf(activeCalculator) === -1) {
            activeCalculator = false;
        }
        if (previousCalculator && calculators.indexOf(previousCalculator) === -1) {
            previousCalculator = false;
        }
    }

    function scrollToDashboardInput(time) {
        var $inputBox = $body.find('[data-dashboard-input]'),
            offset,
            top;

        if (!$keyBoard.hasClass('keyboard--show')) {
            setTimeout(function () {
                offset = $inputBox.offset();
                top = ((offset && offset.top) ? offset.top - 60 : 0) - 90;
                APP.Layout.scrollTo(top);
            }, parseInt(time, 10) || 300);
        }
    }

    function hideKeyboard(force) {
        if (force) {
            preventFocusRestore = true;
            previousCalculator = activeCalculator || previousCalculator || lastUsedCalc;
            activeCalculator = false;
            lastUsedCalc && lastUsedCalc.hideCursor();
        }
        if (!force && (isMouseDown || preventHideKeyboard)) {
            return;
        }
        init();
        keyboardHideTimer = setTimeout(function () {
            if (!activeCalculator) {
                if ($keyBoard.hasClass('keyboard--show')) {
                    $keyBoard.removeClass('keyboard--show');
                    $body.removeClass('application--show-keyboard');
                    if (!$body.find('[data-calculator]').attr('data-sent') || $body.find('[name="question-id"]')) {
                        $body.find('[data-dashboard-input]').removeClass('dashboard__card--active');
                        $body.find('[data-dashboard-learn]').show();
                    }
                    APP.Analytics.trackEvent('keyboard', 'hide');
                    $body.find('[data-calculator-focus-hunter]').trigger('blur');
                    lastUsedCalc && lastUsedCalc.hideCursor();
                }
            }
        }, keyboardHideDuration);
    }

    function addStatus(selectionLength) {
        init();
        if (selectionLength === 0) {
            $keyBoard.addClass('keyboard--pointer-phase');
            $keyBoard.removeClass('keyboard--selection-phase');
            $body.find('[data-keyboard-method="ctrl+c"], [data-keyboard-method="ctrl+x"]').hide();
        } else {
            $keyBoard.addClass('keyboard--selection-phase');
            $keyBoard.removeClass('keyboard--pointer-phase');
            $body.find('[data-keyboard-method="ctrl+c"], [data-keyboard-method="ctrl+x"]').show();
        }

    }

    function submit() {
        activeCalculator = activeCalculator || previousCalculator;

        if (activeCalculator) {
            var content = activeCalculator.getContent();

            preventHideKeyboard = true;
            if (activeCalculator && activeCalculator.isSendable()) {
                if (content.length > 2) {
                    sendCalculatorContent(content);
                } else {
                    APP.Layout.openOverlay('keyboard-empty');
                    APP.Layout.onOverlayClose(function () {
                        $body.find('[data-calculator]').trigger('click');
                    });
                }
            } else {
                getVisibleSubmit().trigger('click');
            }
            $body.find('[data-calculator]').attr('data-sent', true);
        }
    }

    function getVisibleSubmit() {
        return $body.find('[data-formula-default-ctas] button:first()');
    }

    exports.init = init;
    exports.show = showKeyboard;
    exports.hide = hideKeyboard;
    exports.focus = autoFocus;
    exports.setActiveCalculator = setActiveCalculator;
    exports.addStatus = addStatus;
    exports.submit = submit;
    exports.isShown = function (id) {
        if (typeof id === 'undefined') {
            return !!activeCalculator;
        } else {
            if (activeCalculator && activeCalculator.id === id) {
                return true;
            }
        }
        return false;
    };
    exports.shouldRestoreFocus = function (calculator, focusHunter) {
        return !!(
            initialized
            && $keyBoard.hasClass('keyboard--show')
            && !preventFocusRestore
            && lastUsedCalc === calculator
            && focusHunter
            && !$(focusHunter).is('[readonly]')
            && $body.find('.overlay--show').length === 0
        );
    };
    exports.paste = function (pastedString) {
        lastUsedCalc.onPaste(pastedString);
        APP.Calculator.Keyboard.show(lastUsedCalc);
    };
    exports.clean = function () {
        if (lastUsedCalc) {
            lastUsedCalc.cleanInput();
            APP.Calculator.Keyboard.show(lastUsedCalc);
            lastUsedCalc.addFocus();
        }
    };
    exports.add = addCalculator;
    return exports;

})();

var DictionaryHelper = function (text, html) {
    var regexp = /\$(\S*)\{([^}]+)\}/g,
        htmlMarks = {};

    html.replace(regexp, function (match, key, value) {
        htmlMarks[key] = value;
        return match;
    });

    return text.replace(regexp, function (match, key, value) {
        return htmlMarks[key].replace(/@@@/g, value);
    });

};

var MarkupParser = function(html){
    var regexp = /\{\{\#\$markup(.+)\}\}(((?!\{\{\/\$markup\}\})[\s|\S])+)\{\{\/\$markup\}\}/g;

    html.replace(regexp, function (match, argument, value) {
        return match;
    });
};

/*


 // declaration:
 dictionary.key = 'You can\'t connect the dots $0{looking forward}; you can only connect them $1{looking backwards}.'

 // usage:
 dictionary.key

 // result:
 You can't connect the dots <b>looking forward<b>; you can only connect them <strong>looking backwards</strong>

 */
jQuery.event.special.dbltap = {
    setup: function(data, namespaces) {
        var elem = this,
            $elem = jQuery(elem);
        $elem.bind('touchend.dbltap', jQuery.event.special.dbltap.handler);
    },

    teardown: function(namespaces) {
        var elem = this,
            $elem = jQuery(elem);
        $elem.unbind('touchend.dbltap');
    },

    handler: function(event) {
        var elem = event.target,
            $elem = jQuery(elem),
            lastTouch = $elem.data('lastTouch') || 0,
            now = new Date().getTime();

        var delta = now - lastTouch;
        if(delta > 20 && delta<500){
            $elem.data('lastTouch', 0);
            $elem.trigger('dbltap');
        }else
            $elem.data('lastTouch', now);
    }
};
/**
 * Minified by jsDelivr using Terser v5.37.0.
 * Original file: /npm/daterangepicker@3.1.0/daterangepicker.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
/**
 * @version: 3.1
 * @author: Dan Grossman http://www.dangrossman.info/
 * @copyright: Copyright (c) 2012-2019 Dan Grossman. All rights reserved.
 * @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
 * @website: http://www.daterangepicker.com/
 */
!function(t,e){if("function"==typeof define&&define.amd)define(["moment","jquery"],(function(t,a){return a.fn||(a.fn={}),"function"!=typeof t&&t.hasOwnProperty("default")&&(t=t.default),e(t,a)}));else if("object"==typeof module&&module.exports){var a="undefined"!=typeof window?window.jQuery:void 0;a||(a=require("jquery")).fn||(a.fn={});var i="undefined"!=typeof window&&void 0!==window.moment?window.moment:require("moment");module.exports=e(i,a)}else t.daterangepicker=e(t.moment,t.jQuery)}(this,(function(t,e){var a=function(a,i,s){if(this.parentEl="body",this.element=e(a),this.startDate=t().startOf("day"),this.endDate=t().endOf("day"),this.minDate=!1,this.maxDate=!1,this.maxSpan=!1,this.autoApply=!1,this.singleDatePicker=!1,this.showDropdowns=!1,this.minYear=t().subtract(100,"year").format("YYYY"),this.maxYear=t().add(100,"year").format("YYYY"),this.showWeekNumbers=!1,this.showISOWeekNumbers=!1,this.showCustomRangeLabel=!0,this.timePicker=!1,this.timePicker24Hour=!1,this.timePickerIncrement=1,this.timePickerSeconds=!1,this.linkedCalendars=!0,this.autoUpdateInput=!0,this.alwaysShowCalendars=!1,this.ranges={},this.opens="right",this.element.hasClass("pull-right")&&(this.opens="left"),this.drops="down",this.element.hasClass("dropup")&&(this.drops="up"),this.buttonClasses="btn btn-sm",this.applyButtonClasses="btn-primary",this.cancelButtonClasses="btn-default",this.locale={direction:"ltr",format:t.localeData().longDateFormat("L"),separator:" - ",applyLabel:"Apply",cancelLabel:"Cancel",weekLabel:"W",customRangeLabel:"Custom Range",daysOfWeek:t.weekdaysMin(),monthNames:t.monthsShort(),firstDay:t.localeData().firstDayOfWeek()},this.callback=function(){},this.isShowing=!1,this.leftCalendar={},this.rightCalendar={},"object"==typeof i&&null!==i||(i={}),"string"==typeof(i=e.extend(this.element.data(),i)).template||i.template instanceof e||(i.template='<div class="daterangepicker"><div class="ranges"></div><div class="drp-calendar left"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-calendar right"><div class="calendar-table"></div><div class="calendar-time"></div></div><div class="drp-buttons"><span class="drp-selected"></span><button class="cancelBtn" type="button"></button><button class="applyBtn" disabled="disabled" type="button"></button> </div></div>'),this.parentEl=i.parentEl&&e(i.parentEl).length?e(i.parentEl):e(this.parentEl),this.container=e(i.template).appendTo(this.parentEl),"object"==typeof i.locale&&("string"==typeof i.locale.direction&&(this.locale.direction=i.locale.direction),"string"==typeof i.locale.format&&(this.locale.format=i.locale.format),"string"==typeof i.locale.separator&&(this.locale.separator=i.locale.separator),"object"==typeof i.locale.daysOfWeek&&(this.locale.daysOfWeek=i.locale.daysOfWeek.slice()),"object"==typeof i.locale.monthNames&&(this.locale.monthNames=i.locale.monthNames.slice()),"number"==typeof i.locale.firstDay&&(this.locale.firstDay=i.locale.firstDay),"string"==typeof i.locale.applyLabel&&(this.locale.applyLabel=i.locale.applyLabel),"string"==typeof i.locale.cancelLabel&&(this.locale.cancelLabel=i.locale.cancelLabel),"string"==typeof i.locale.weekLabel&&(this.locale.weekLabel=i.locale.weekLabel),"string"==typeof i.locale.customRangeLabel)){(p=document.createElement("textarea")).innerHTML=i.locale.customRangeLabel;var n=p.value;this.locale.customRangeLabel=n}if(this.container.addClass(this.locale.direction),"string"==typeof i.startDate&&(this.startDate=t(i.startDate,this.locale.format)),"string"==typeof i.endDate&&(this.endDate=t(i.endDate,this.locale.format)),"string"==typeof i.minDate&&(this.minDate=t(i.minDate,this.locale.format)),"string"==typeof i.maxDate&&(this.maxDate=t(i.maxDate,this.locale.format)),"object"==typeof i.startDate&&(this.startDate=t(i.startDate)),"object"==typeof i.endDate&&(this.endDate=t(i.endDate)),"object"==typeof i.minDate&&(this.minDate=t(i.minDate)),"object"==typeof i.maxDate&&(this.maxDate=t(i.maxDate)),this.minDate&&this.startDate.isBefore(this.minDate)&&(this.startDate=this.minDate.clone()),this.maxDate&&this.endDate.isAfter(this.maxDate)&&(this.endDate=this.maxDate.clone()),"string"==typeof i.applyButtonClasses&&(this.applyButtonClasses=i.applyButtonClasses),"string"==typeof i.applyClass&&(this.applyButtonClasses=i.applyClass),"string"==typeof i.cancelButtonClasses&&(this.cancelButtonClasses=i.cancelButtonClasses),"string"==typeof i.cancelClass&&(this.cancelButtonClasses=i.cancelClass),"object"==typeof i.maxSpan&&(this.maxSpan=i.maxSpan),"object"==typeof i.dateLimit&&(this.maxSpan=i.dateLimit),"string"==typeof i.opens&&(this.opens=i.opens),"string"==typeof i.drops&&(this.drops=i.drops),"boolean"==typeof i.showWeekNumbers&&(this.showWeekNumbers=i.showWeekNumbers),"boolean"==typeof i.showISOWeekNumbers&&(this.showISOWeekNumbers=i.showISOWeekNumbers),"string"==typeof i.buttonClasses&&(this.buttonClasses=i.buttonClasses),"object"==typeof i.buttonClasses&&(this.buttonClasses=i.buttonClasses.join(" ")),"boolean"==typeof i.showDropdowns&&(this.showDropdowns=i.showDropdowns),"number"==typeof i.minYear&&(this.minYear=i.minYear),"number"==typeof i.maxYear&&(this.maxYear=i.maxYear),"boolean"==typeof i.showCustomRangeLabel&&(this.showCustomRangeLabel=i.showCustomRangeLabel),"boolean"==typeof i.singleDatePicker&&(this.singleDatePicker=i.singleDatePicker,this.singleDatePicker&&(this.endDate=this.startDate.clone())),"boolean"==typeof i.timePicker&&(this.timePicker=i.timePicker),"boolean"==typeof i.timePickerSeconds&&(this.timePickerSeconds=i.timePickerSeconds),"number"==typeof i.timePickerIncrement&&(this.timePickerIncrement=i.timePickerIncrement),"boolean"==typeof i.timePicker24Hour&&(this.timePicker24Hour=i.timePicker24Hour),"boolean"==typeof i.autoApply&&(this.autoApply=i.autoApply),"boolean"==typeof i.autoUpdateInput&&(this.autoUpdateInput=i.autoUpdateInput),"boolean"==typeof i.linkedCalendars&&(this.linkedCalendars=i.linkedCalendars),"function"==typeof i.isInvalidDate&&(this.isInvalidDate=i.isInvalidDate),"function"==typeof i.isCustomDate&&(this.isCustomDate=i.isCustomDate),"boolean"==typeof i.alwaysShowCalendars&&(this.alwaysShowCalendars=i.alwaysShowCalendars),0!=this.locale.firstDay)for(var r=this.locale.firstDay;r>0;)this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift()),r--;var o,h,l;if(void 0===i.startDate&&void 0===i.endDate&&e(this.element).is(":text")){var c=e(this.element).val(),d=c.split(this.locale.separator);o=h=null,2==d.length?(o=t(d[0],this.locale.format),h=t(d[1],this.locale.format)):this.singleDatePicker&&""!==c&&(o=t(c,this.locale.format),h=t(c,this.locale.format)),null!==o&&null!==h&&(this.setStartDate(o),this.setEndDate(h))}if("object"==typeof i.ranges){for(l in i.ranges){o="string"==typeof i.ranges[l][0]?t(i.ranges[l][0],this.locale.format):t(i.ranges[l][0]),h="string"==typeof i.ranges[l][1]?t(i.ranges[l][1],this.locale.format):t(i.ranges[l][1]),this.minDate&&o.isBefore(this.minDate)&&(o=this.minDate.clone());var m=this.maxDate;if(this.maxSpan&&m&&o.clone().add(this.maxSpan).isAfter(m)&&(m=o.clone().add(this.maxSpan)),m&&h.isAfter(m)&&(h=m.clone()),!(this.minDate&&h.isBefore(this.minDate,this.timepicker?"minute":"day")||m&&o.isAfter(m,this.timepicker?"minute":"day"))){var p;(p=document.createElement("textarea")).innerHTML=l;n=p.value;this.ranges[n]=[o,h]}}var f="<ul>";for(l in this.ranges)f+='<li data-range-key="'+l+'">'+l+"</li>";this.showCustomRangeLabel&&(f+='<li data-range-key="'+this.locale.customRangeLabel+'">'+this.locale.customRangeLabel+"</li>"),f+="</ul>",this.container.find(".ranges").prepend(f)}"function"==typeof s&&(this.callback=s),this.timePicker||(this.startDate=this.startDate.startOf("day"),this.endDate=this.endDate.endOf("day"),this.container.find(".calendar-time").hide()),this.timePicker&&this.autoApply&&(this.autoApply=!1),this.autoApply&&this.container.addClass("auto-apply"),"object"==typeof i.ranges&&this.container.addClass("show-ranges"),this.singleDatePicker&&(this.container.addClass("single"),this.container.find(".drp-calendar.left").addClass("single"),this.container.find(".drp-calendar.left").show(),this.container.find(".drp-calendar.right").hide(),!this.timePicker&&this.autoApply&&this.container.addClass("auto-apply")),(void 0===i.ranges&&!this.singleDatePicker||this.alwaysShowCalendars)&&this.container.addClass("show-calendar"),this.container.addClass("opens"+this.opens),this.container.find(".applyBtn, .cancelBtn").addClass(this.buttonClasses),this.applyButtonClasses.length&&this.container.find(".applyBtn").addClass(this.applyButtonClasses),this.cancelButtonClasses.length&&this.container.find(".cancelBtn").addClass(this.cancelButtonClasses),this.container.find(".applyBtn").html(this.locale.applyLabel),this.container.find(".cancelBtn").html(this.locale.cancelLabel),this.container.find(".drp-calendar").on("click.daterangepicker",".prev",e.proxy(this.clickPrev,this)).on("click.daterangepicker",".next",e.proxy(this.clickNext,this)).on("mousedown.daterangepicker","td.available",e.proxy(this.clickDate,this)).on("mouseenter.daterangepicker","td.available",e.proxy(this.hoverDate,this)).on("change.daterangepicker","select.yearselect",e.proxy(this.monthOrYearChanged,this)).on("change.daterangepicker","select.monthselect",e.proxy(this.monthOrYearChanged,this)).on("change.daterangepicker","select.hourselect,select.minuteselect,select.secondselect,select.ampmselect",e.proxy(this.timeChanged,this)),this.container.find(".ranges").on("click.daterangepicker","li",e.proxy(this.clickRange,this)),this.container.find(".drp-buttons").on("click.daterangepicker","button.applyBtn",e.proxy(this.clickApply,this)).on("click.daterangepicker","button.cancelBtn",e.proxy(this.clickCancel,this)),this.element.is("input")||this.element.is("button")?this.element.on({"click.daterangepicker":e.proxy(this.show,this),"focus.daterangepicker":e.proxy(this.show,this),"keyup.daterangepicker":e.proxy(this.elementChanged,this),"keydown.daterangepicker":e.proxy(this.keydown,this)}):(this.element.on("click.daterangepicker",e.proxy(this.toggle,this)),this.element.on("keydown.daterangepicker",e.proxy(this.toggle,this))),this.updateElement()};return a.prototype={constructor:a,setStartDate:function(e){"string"==typeof e&&(this.startDate=t(e,this.locale.format)),"object"==typeof e&&(this.startDate=t(e)),this.timePicker||(this.startDate=this.startDate.startOf("day")),this.timePicker&&this.timePickerIncrement&&this.startDate.minute(Math.round(this.startDate.minute()/this.timePickerIncrement)*this.timePickerIncrement),this.minDate&&this.startDate.isBefore(this.minDate)&&(this.startDate=this.minDate.clone(),this.timePicker&&this.timePickerIncrement&&this.startDate.minute(Math.round(this.startDate.minute()/this.timePickerIncrement)*this.timePickerIncrement)),this.maxDate&&this.startDate.isAfter(this.maxDate)&&(this.startDate=this.maxDate.clone(),this.timePicker&&this.timePickerIncrement&&this.startDate.minute(Math.floor(this.startDate.minute()/this.timePickerIncrement)*this.timePickerIncrement)),this.isShowing||this.updateElement(),this.updateMonthsInView()},setEndDate:function(e){"string"==typeof e&&(this.endDate=t(e,this.locale.format)),"object"==typeof e&&(this.endDate=t(e)),this.timePicker||(this.endDate=this.endDate.endOf("day")),this.timePicker&&this.timePickerIncrement&&this.endDate.minute(Math.round(this.endDate.minute()/this.timePickerIncrement)*this.timePickerIncrement),this.endDate.isBefore(this.startDate)&&(this.endDate=this.startDate.clone()),this.maxDate&&this.endDate.isAfter(this.maxDate)&&(this.endDate=this.maxDate.clone()),this.maxSpan&&this.startDate.clone().add(this.maxSpan).isBefore(this.endDate)&&(this.endDate=this.startDate.clone().add(this.maxSpan)),this.previousRightTime=this.endDate.clone(),this.container.find(".drp-selected").html(this.startDate.format(this.locale.format)+this.locale.separator+this.endDate.format(this.locale.format)),this.isShowing||this.updateElement(),this.updateMonthsInView()},isInvalidDate:function(){return!1},isCustomDate:function(){return!1},updateView:function(){this.timePicker&&(this.renderTimePicker("left"),this.renderTimePicker("right"),this.endDate?this.container.find(".right .calendar-time select").prop("disabled",!1).removeClass("disabled"):this.container.find(".right .calendar-time select").prop("disabled",!0).addClass("disabled")),this.endDate&&this.container.find(".drp-selected").html(this.startDate.format(this.locale.format)+this.locale.separator+this.endDate.format(this.locale.format)),this.updateMonthsInView(),this.updateCalendars(),this.updateFormInputs()},updateMonthsInView:function(){if(this.endDate){if(!this.singleDatePicker&&this.leftCalendar.month&&this.rightCalendar.month&&(this.startDate.format("YYYY-MM")==this.leftCalendar.month.format("YYYY-MM")||this.startDate.format("YYYY-MM")==this.rightCalendar.month.format("YYYY-MM"))&&(this.endDate.format("YYYY-MM")==this.leftCalendar.month.format("YYYY-MM")||this.endDate.format("YYYY-MM")==this.rightCalendar.month.format("YYYY-MM")))return;this.leftCalendar.month=this.startDate.clone().date(2),this.linkedCalendars||this.endDate.month()==this.startDate.month()&&this.endDate.year()==this.startDate.year()?this.rightCalendar.month=this.startDate.clone().date(2).add(1,"month"):this.rightCalendar.month=this.endDate.clone().date(2)}else this.leftCalendar.month.format("YYYY-MM")!=this.startDate.format("YYYY-MM")&&this.rightCalendar.month.format("YYYY-MM")!=this.startDate.format("YYYY-MM")&&(this.leftCalendar.month=this.startDate.clone().date(2),this.rightCalendar.month=this.startDate.clone().date(2).add(1,"month"));this.maxDate&&this.linkedCalendars&&!this.singleDatePicker&&this.rightCalendar.month>this.maxDate&&(this.rightCalendar.month=this.maxDate.clone().date(2),this.leftCalendar.month=this.maxDate.clone().date(2).subtract(1,"month"))},updateCalendars:function(){if(this.timePicker){var t,e,a,i;if(this.endDate){if(t=parseInt(this.container.find(".left .hourselect").val(),10),e=parseInt(this.container.find(".left .minuteselect").val(),10),isNaN(e)&&(e=parseInt(this.container.find(".left .minuteselect option:last").val(),10)),a=this.timePickerSeconds?parseInt(this.container.find(".left .secondselect").val(),10):0,!this.timePicker24Hour)"PM"===(i=this.container.find(".left .ampmselect").val())&&t<12&&(t+=12),"AM"===i&&12===t&&(t=0)}else if(t=parseInt(this.container.find(".right .hourselect").val(),10),e=parseInt(this.container.find(".right .minuteselect").val(),10),isNaN(e)&&(e=parseInt(this.container.find(".right .minuteselect option:last").val(),10)),a=this.timePickerSeconds?parseInt(this.container.find(".right .secondselect").val(),10):0,!this.timePicker24Hour)"PM"===(i=this.container.find(".right .ampmselect").val())&&t<12&&(t+=12),"AM"===i&&12===t&&(t=0);this.leftCalendar.month.hour(t).minute(e).second(a),this.rightCalendar.month.hour(t).minute(e).second(a)}this.renderCalendar("left"),this.renderCalendar("right"),this.container.find(".ranges li").removeClass("active"),null!=this.endDate&&this.calculateChosenLabel()},renderCalendar:function(a){var i,s=(i="left"==a?this.leftCalendar:this.rightCalendar).month.month(),n=i.month.year(),r=i.month.hour(),o=i.month.minute(),h=i.month.second(),l=t([n,s]).daysInMonth(),c=t([n,s,1]),d=t([n,s,l]),m=t(c).subtract(1,"month").month(),p=t(c).subtract(1,"month").year(),f=t([p,m]).daysInMonth(),u=c.day();(i=[]).firstDay=c,i.lastDay=d;for(var D=0;D<6;D++)i[D]=[];var g=f-u+this.locale.firstDay+1;g>f&&(g-=7),u==this.locale.firstDay&&(g=f-6);for(var y=t([p,m,g,12,o,h]),k=(D=0,0),b=0;D<42;D++,k++,y=t(y).add(24,"hour"))D>0&&k%7==0&&(k=0,b++),i[b][k]=y.clone().hour(r).minute(o).second(h),y.hour(12),this.minDate&&i[b][k].format("YYYY-MM-DD")==this.minDate.format("YYYY-MM-DD")&&i[b][k].isBefore(this.minDate)&&"left"==a&&(i[b][k]=this.minDate.clone()),this.maxDate&&i[b][k].format("YYYY-MM-DD")==this.maxDate.format("YYYY-MM-DD")&&i[b][k].isAfter(this.maxDate)&&"right"==a&&(i[b][k]=this.maxDate.clone());"left"==a?this.leftCalendar.calendar=i:this.rightCalendar.calendar=i;var v="left"==a?this.minDate:this.startDate,C=this.maxDate,Y=("left"==a?this.startDate:this.endDate,this.locale.direction,'<table class="table-condensed">');Y+="<thead>",Y+="<tr>",(this.showWeekNumbers||this.showISOWeekNumbers)&&(Y+="<th></th>"),v&&!v.isBefore(i.firstDay)||this.linkedCalendars&&"left"!=a?Y+="<th></th>":Y+='<th class="prev available"><span></span></th>';var w=this.locale.monthNames[i[1][1].month()]+i[1][1].format(" YYYY");if(this.showDropdowns){for(var P=i[1][1].month(),x=i[1][1].year(),M=C&&C.year()||this.maxYear,I=v&&v.year()||this.minYear,S=x==I,B=x==M,A='<select class="monthselect">',L=0;L<12;L++)(!S||v&&L>=v.month())&&(!B||C&&L<=C.month())?A+="<option value='"+L+"'"+(L===P?" selected='selected'":"")+">"+this.locale.monthNames[L]+"</option>":A+="<option value='"+L+"'"+(L===P?" selected='selected'":"")+" disabled='disabled'>"+this.locale.monthNames[L]+"</option>";A+="</select>";for(var N='<select class="yearselect">',E=I;E<=M;E++)N+='<option value="'+E+'"'+(E===x?' selected="selected"':"")+">"+E+"</option>";w=A+(N+="</select>")}if(Y+='<th colspan="5" class="month">'+w+"</th>",C&&!C.isAfter(i.lastDay)||this.linkedCalendars&&"right"!=a&&!this.singleDatePicker?Y+="<th></th>":Y+='<th class="next available"><span></span></th>',Y+="</tr>",Y+="<tr>",(this.showWeekNumbers||this.showISOWeekNumbers)&&(Y+='<th class="week">'+this.locale.weekLabel+"</th>"),e.each(this.locale.daysOfWeek,(function(t,e){Y+="<th>"+e+"</th>"})),Y+="</tr>",Y+="</thead>",Y+="<tbody>",null==this.endDate&&this.maxSpan){var O=this.startDate.clone().add(this.maxSpan).endOf("day");C&&!O.isBefore(C)||(C=O)}for(b=0;b<6;b++){Y+="<tr>",this.showWeekNumbers?Y+='<td class="week">'+i[b][0].week()+"</td>":this.showISOWeekNumbers&&(Y+='<td class="week">'+i[b][0].isoWeek()+"</td>");for(k=0;k<7;k++){var W=[];i[b][k].isSame(new Date,"day")&&W.push("today"),i[b][k].isoWeekday()>5&&W.push("weekend"),i[b][k].month()!=i[1][1].month()&&W.push("off","ends"),this.minDate&&i[b][k].isBefore(this.minDate,"day")&&W.push("off","disabled"),C&&i[b][k].isAfter(C,"day")&&W.push("off","disabled"),this.isInvalidDate(i[b][k])&&W.push("off","disabled"),i[b][k].format("YYYY-MM-DD")==this.startDate.format("YYYY-MM-DD")&&W.push("active","start-date"),null!=this.endDate&&i[b][k].format("YYYY-MM-DD")==this.endDate.format("YYYY-MM-DD")&&W.push("active","end-date"),null!=this.endDate&&i[b][k]>this.startDate&&i[b][k]<this.endDate&&W.push("in-range");var H=this.isCustomDate(i[b][k]);!1!==H&&("string"==typeof H?W.push(H):Array.prototype.push.apply(W,H));var j="",R=!1;for(D=0;D<W.length;D++)j+=W[D]+" ","disabled"==W[D]&&(R=!0);R||(j+="available"),Y+='<td class="'+j.replace(/^\s+|\s+$/g,"")+'" data-title="r'+b+"c"+k+'">'+i[b][k].date()+"</td>"}Y+="</tr>"}Y+="</tbody>",Y+="</table>",this.container.find(".drp-calendar."+a+" .calendar-table").html(Y)},renderTimePicker:function(t){if("right"!=t||this.endDate){var e,a,i,s=this.maxDate;if(!this.maxSpan||this.maxDate&&!this.startDate.clone().add(this.maxSpan).isBefore(this.maxDate)||(s=this.startDate.clone().add(this.maxSpan)),"left"==t)a=this.startDate.clone(),i=this.minDate;else if("right"==t){a=this.endDate.clone(),i=this.startDate;var n=this.container.find(".drp-calendar.right .calendar-time");if(""!=n.html()&&(a.hour(isNaN(a.hour())?n.find(".hourselect option:selected").val():a.hour()),a.minute(isNaN(a.minute())?n.find(".minuteselect option:selected").val():a.minute()),a.second(isNaN(a.second())?n.find(".secondselect option:selected").val():a.second()),!this.timePicker24Hour)){var r=n.find(".ampmselect option:selected").val();"PM"===r&&a.hour()<12&&a.hour(a.hour()+12),"AM"===r&&12===a.hour()&&a.hour(0)}a.isBefore(this.startDate)&&(a=this.startDate.clone()),s&&a.isAfter(s)&&(a=s.clone())}e='<select class="hourselect">';for(var o=this.timePicker24Hour?0:1,h=this.timePicker24Hour?23:12,l=o;l<=h;l++){var c=l;this.timePicker24Hour||(c=a.hour()>=12?12==l?12:l+12:12==l?0:l);var d=a.clone().hour(c),m=!1;i&&d.minute(59).isBefore(i)&&(m=!0),s&&d.minute(0).isAfter(s)&&(m=!0),c!=a.hour()||m?e+=m?'<option value="'+l+'" disabled="disabled" class="disabled">'+l+"</option>":'<option value="'+l+'">'+l+"</option>":e+='<option value="'+l+'" selected="selected">'+l+"</option>"}e+="</select> ",e+=': <select class="minuteselect">';for(l=0;l<60;l+=this.timePickerIncrement){var p=l<10?"0"+l:l;d=a.clone().minute(l),m=!1;i&&d.second(59).isBefore(i)&&(m=!0),s&&d.second(0).isAfter(s)&&(m=!0),a.minute()!=l||m?e+=m?'<option value="'+l+'" disabled="disabled" class="disabled">'+p+"</option>":'<option value="'+l+'">'+p+"</option>":e+='<option value="'+l+'" selected="selected">'+p+"</option>"}if(e+="</select> ",this.timePickerSeconds){e+=': <select class="secondselect">';for(l=0;l<60;l++){p=l<10?"0"+l:l,d=a.clone().second(l),m=!1;i&&d.isBefore(i)&&(m=!0),s&&d.isAfter(s)&&(m=!0),a.second()!=l||m?e+=m?'<option value="'+l+'" disabled="disabled" class="disabled">'+p+"</option>":'<option value="'+l+'">'+p+"</option>":e+='<option value="'+l+'" selected="selected">'+p+"</option>"}e+="</select> "}if(!this.timePicker24Hour){e+='<select class="ampmselect">';var f="",u="";i&&a.clone().hour(12).minute(0).second(0).isBefore(i)&&(f=' disabled="disabled" class="disabled"'),s&&a.clone().hour(0).minute(0).second(0).isAfter(s)&&(u=' disabled="disabled" class="disabled"'),a.hour()>=12?e+='<option value="AM"'+f+'>AM</option><option value="PM" selected="selected"'+u+">PM</option>":e+='<option value="AM" selected="selected"'+f+'>AM</option><option value="PM"'+u+">PM</option>",e+="</select>"}this.container.find(".drp-calendar."+t+" .calendar-time").html(e)}},updateFormInputs:function(){this.singleDatePicker||this.endDate&&(this.startDate.isBefore(this.endDate)||this.startDate.isSame(this.endDate))?this.container.find("button.applyBtn").prop("disabled",!1):this.container.find("button.applyBtn").prop("disabled",!0)},move:function(){var t,a={top:0,left:0},i=this.drops,s=e(window).width();switch(this.parentEl.is("body")||(a={top:this.parentEl.offset().top-this.parentEl.scrollTop(),left:this.parentEl.offset().left-this.parentEl.scrollLeft()},s=this.parentEl[0].clientWidth+this.parentEl.offset().left),i){case"auto":(t=this.element.offset().top+this.element.outerHeight()-a.top)+this.container.outerHeight()>=this.parentEl[0].scrollHeight&&(t=this.element.offset().top-this.container.outerHeight()-a.top,i="up");break;case"up":t=this.element.offset().top-this.container.outerHeight()-a.top;break;default:t=this.element.offset().top+this.element.outerHeight()-a.top}this.container.css({top:0,left:0,right:"auto"});var n=this.container.outerWidth();if(this.container.toggleClass("drop-up","up"==i),"left"==this.opens){var r=s-this.element.offset().left-this.element.outerWidth();n+r>e(window).width()?this.container.css({top:t,right:"auto",left:9}):this.container.css({top:t,right:r,left:"auto"})}else if("center"==this.opens){(o=this.element.offset().left-a.left+this.element.outerWidth()/2-n/2)<0?this.container.css({top:t,right:"auto",left:9}):o+n>e(window).width()?this.container.css({top:t,left:"auto",right:0}):this.container.css({top:t,left:o,right:"auto"})}else{var o;(o=this.element.offset().left-a.left)+n>e(window).width()?this.container.css({top:t,left:"auto",right:0}):this.container.css({top:t,left:o,right:"auto"})}},show:function(t){this.isShowing||(this._outsideClickProxy=e.proxy((function(t){this.outsideClick(t)}),this),e(document).on("mousedown.daterangepicker",this._outsideClickProxy).on("touchend.daterangepicker",this._outsideClickProxy).on("click.daterangepicker","[data-toggle=dropdown]",this._outsideClickProxy).on("focusin.daterangepicker",this._outsideClickProxy),e(window).on("resize.daterangepicker",e.proxy((function(t){this.move(t)}),this)),this.oldStartDate=this.startDate.clone(),this.oldEndDate=this.endDate.clone(),this.previousRightTime=this.endDate.clone(),this.updateView(),this.container.show(),this.move(),this.element.trigger("show.daterangepicker",this),this.isShowing=!0)},hide:function(t){this.isShowing&&(this.endDate||(this.startDate=this.oldStartDate.clone(),this.endDate=this.oldEndDate.clone()),this.startDate.isSame(this.oldStartDate)&&this.endDate.isSame(this.oldEndDate)||this.callback(this.startDate.clone(),this.endDate.clone(),this.chosenLabel),this.updateElement(),e(document).off(".daterangepicker"),e(window).off(".daterangepicker"),this.container.hide(),this.element.trigger("hide.daterangepicker",this),this.isShowing=!1)},toggle:function(t){this.isShowing?this.hide():this.show()},outsideClick:function(t){var a=e(t.target);"focusin"==t.type||a.closest(this.element).length||a.closest(this.container).length||a.closest(".calendar-table").length||(this.hide(),this.element.trigger("outsideClick.daterangepicker",this))},showCalendars:function(){this.container.addClass("show-calendar"),this.move(),this.element.trigger("showCalendar.daterangepicker",this)},hideCalendars:function(){this.container.removeClass("show-calendar"),this.element.trigger("hideCalendar.daterangepicker",this)},clickRange:function(t){var e=t.target.getAttribute("data-range-key");if(this.chosenLabel=e,e==this.locale.customRangeLabel)this.showCalendars();else{var a=this.ranges[e];this.startDate=a[0],this.endDate=a[1],this.timePicker||(this.startDate.startOf("day"),this.endDate.endOf("day")),this.alwaysShowCalendars||this.hideCalendars(),this.clickApply()}},clickPrev:function(t){e(t.target).parents(".drp-calendar").hasClass("left")?(this.leftCalendar.month.subtract(1,"month"),this.linkedCalendars&&this.rightCalendar.month.subtract(1,"month")):this.rightCalendar.month.subtract(1,"month"),this.updateCalendars()},clickNext:function(t){e(t.target).parents(".drp-calendar").hasClass("left")?this.leftCalendar.month.add(1,"month"):(this.rightCalendar.month.add(1,"month"),this.linkedCalendars&&this.leftCalendar.month.add(1,"month")),this.updateCalendars()},hoverDate:function(t){if(e(t.target).hasClass("available")){var a=e(t.target).attr("data-title"),i=a.substr(1,1),s=a.substr(3,1),n=e(t.target).parents(".drp-calendar").hasClass("left")?this.leftCalendar.calendar[i][s]:this.rightCalendar.calendar[i][s],r=this.leftCalendar,o=this.rightCalendar,h=this.startDate;this.endDate||this.container.find(".drp-calendar tbody td").each((function(t,a){if(!e(a).hasClass("week")){var i=e(a).attr("data-title"),s=i.substr(1,1),l=i.substr(3,1),c=e(a).parents(".drp-calendar").hasClass("left")?r.calendar[s][l]:o.calendar[s][l];c.isAfter(h)&&c.isBefore(n)||c.isSame(n,"day")?e(a).addClass("in-range"):e(a).removeClass("in-range")}}))}},clickDate:function(t){if(e(t.target).hasClass("available")){var a=e(t.target).attr("data-title"),i=a.substr(1,1),s=a.substr(3,1),n=e(t.target).parents(".drp-calendar").hasClass("left")?this.leftCalendar.calendar[i][s]:this.rightCalendar.calendar[i][s];if(this.endDate||n.isBefore(this.startDate,"day")){if(this.timePicker){var r=parseInt(this.container.find(".left .hourselect").val(),10);if(!this.timePicker24Hour)"PM"===(l=this.container.find(".left .ampmselect").val())&&r<12&&(r+=12),"AM"===l&&12===r&&(r=0);var o=parseInt(this.container.find(".left .minuteselect").val(),10);isNaN(o)&&(o=parseInt(this.container.find(".left .minuteselect option:last").val(),10));var h=this.timePickerSeconds?parseInt(this.container.find(".left .secondselect").val(),10):0;n=n.clone().hour(r).minute(o).second(h)}this.endDate=null,this.setStartDate(n.clone())}else if(!this.endDate&&n.isBefore(this.startDate))this.setEndDate(this.startDate.clone());else{if(this.timePicker){var l;r=parseInt(this.container.find(".right .hourselect").val(),10);if(!this.timePicker24Hour)"PM"===(l=this.container.find(".right .ampmselect").val())&&r<12&&(r+=12),"AM"===l&&12===r&&(r=0);o=parseInt(this.container.find(".right .minuteselect").val(),10);isNaN(o)&&(o=parseInt(this.container.find(".right .minuteselect option:last").val(),10));h=this.timePickerSeconds?parseInt(this.container.find(".right .secondselect").val(),10):0;n=n.clone().hour(r).minute(o).second(h)}this.setEndDate(n.clone()),this.autoApply&&(this.calculateChosenLabel(),this.clickApply())}this.singleDatePicker&&(this.setEndDate(this.startDate),!this.timePicker&&this.autoApply&&this.clickApply()),this.updateView(),t.stopPropagation()}},calculateChosenLabel:function(){var t=!0,e=0;for(var a in this.ranges){if(this.timePicker){var i=this.timePickerSeconds?"YYYY-MM-DD HH:mm:ss":"YYYY-MM-DD HH:mm";if(this.startDate.format(i)==this.ranges[a][0].format(i)&&this.endDate.format(i)==this.ranges[a][1].format(i)){t=!1,this.chosenLabel=this.container.find(".ranges li:eq("+e+")").addClass("active").attr("data-range-key");break}}else if(this.startDate.format("YYYY-MM-DD")==this.ranges[a][0].format("YYYY-MM-DD")&&this.endDate.format("YYYY-MM-DD")==this.ranges[a][1].format("YYYY-MM-DD")){t=!1,this.chosenLabel=this.container.find(".ranges li:eq("+e+")").addClass("active").attr("data-range-key");break}e++}t&&(this.showCustomRangeLabel?this.chosenLabel=this.container.find(".ranges li:last").addClass("active").attr("data-range-key"):this.chosenLabel=null,this.showCalendars())},clickApply:function(t){this.hide(),this.element.trigger("apply.daterangepicker",this)},clickCancel:function(t){this.startDate=this.oldStartDate,this.endDate=this.oldEndDate,this.hide(),this.element.trigger("cancel.daterangepicker",this)},monthOrYearChanged:function(t){var a=e(t.target).closest(".drp-calendar").hasClass("left"),i=a?"left":"right",s=this.container.find(".drp-calendar."+i),n=parseInt(s.find(".monthselect").val(),10),r=s.find(".yearselect").val();a||(r<this.startDate.year()||r==this.startDate.year()&&n<this.startDate.month())&&(n=this.startDate.month(),r=this.startDate.year()),this.minDate&&(r<this.minDate.year()||r==this.minDate.year()&&n<this.minDate.month())&&(n=this.minDate.month(),r=this.minDate.year()),this.maxDate&&(r>this.maxDate.year()||r==this.maxDate.year()&&n>this.maxDate.month())&&(n=this.maxDate.month(),r=this.maxDate.year()),a?(this.leftCalendar.month.month(n).year(r),this.linkedCalendars&&(this.rightCalendar.month=this.leftCalendar.month.clone().add(1,"month"))):(this.rightCalendar.month.month(n).year(r),this.linkedCalendars&&(this.leftCalendar.month=this.rightCalendar.month.clone().subtract(1,"month"))),this.updateCalendars()},timeChanged:function(t){var a=e(t.target).closest(".drp-calendar"),i=a.hasClass("left"),s=parseInt(a.find(".hourselect").val(),10),n=parseInt(a.find(".minuteselect").val(),10);isNaN(n)&&(n=parseInt(a.find(".minuteselect option:last").val(),10));var r=this.timePickerSeconds?parseInt(a.find(".secondselect").val(),10):0;if(!this.timePicker24Hour){var o=a.find(".ampmselect").val();"PM"===o&&s<12&&(s+=12),"AM"===o&&12===s&&(s=0)}if(i){var h=this.startDate.clone();h.hour(s),h.minute(n),h.second(r),this.setStartDate(h),this.singleDatePicker?this.endDate=this.startDate.clone():this.endDate&&this.endDate.format("YYYY-MM-DD")==h.format("YYYY-MM-DD")&&this.endDate.isBefore(h)&&this.setEndDate(h.clone())}else if(this.endDate){var l=this.endDate.clone();l.hour(s),l.minute(n),l.second(r),this.setEndDate(l)}this.updateCalendars(),this.updateFormInputs(),this.renderTimePicker("left"),this.renderTimePicker("right")},elementChanged:function(){if(this.element.is("input")&&this.element.val().length){var e=this.element.val().split(this.locale.separator),a=null,i=null;2===e.length&&(a=t(e[0],this.locale.format),i=t(e[1],this.locale.format)),(this.singleDatePicker||null===a||null===i)&&(i=a=t(this.element.val(),this.locale.format)),a.isValid()&&i.isValid()&&(this.setStartDate(a),this.setEndDate(i),this.updateView())}},keydown:function(t){9!==t.keyCode&&13!==t.keyCode||this.hide(),27===t.keyCode&&(t.preventDefault(),t.stopPropagation(),this.hide())},updateElement:function(){if(this.element.is("input")&&this.autoUpdateInput){var t=this.startDate.format(this.locale.format);this.singleDatePicker||(t+=this.locale.separator+this.endDate.format(this.locale.format)),t!==this.element.val()&&this.element.val(t).trigger("change")}},remove:function(){this.container.remove(),this.element.off(".daterangepicker"),this.element.removeData()}},e.fn.daterangepicker=function(t,i){var s=e.extend(!0,{},e.fn.daterangepicker.defaultOptions,t);return this.each((function(){var t=e(this);t.data("daterangepicker")&&t.data("daterangepicker").remove(),t.data("daterangepicker",new a(t,s,i))})),this},a}));
//# sourceMappingURL=/sm/88e48650a36caa41dd1aa0f1a5ee66247818a496500de85dec44b4e2e87cd438.map
/**
 *  The Virtual Keyboard Detector
 */

var virtualKeyboardDetector = ( function( window ) {

    var recentlyFocusedTimeoutDuration = 3000;

    var currentViewportWidth = previousViewportWidth = viewportWidthWithoutVirtualKeyboard = window.innerWidth;
    var currentViewportHeight = previousViewportHeight = viewportHeightWithoutVirtualKeyboard = window.innerHeight;

    var virtualKeyboardVisible = false;
    var recentlyFocused = false;
    var recentlyFocusedTimeout = null;
    var validFocusableElements = [ 'INPUT', 'TEXTAREA' ];

    var subscriptions = {};


    /**
     * Public functions
     */

    function init ( options ) {
        if ( typeof options !== 'undefined' ) {
            if ( typeof options.recentlyFocusedTimeoutDuration !== 'undefined' ) recentlyFocusedTimeoutDuration = options.recentlyFocusedTimeoutDuration;
        }

        resetViewportSizes();
        initFocusListener();
        initResizeListener();
    }

    function isVirtualKeyboardVisible () {
        return virtualKeyboardVisible;
    }

    function getVirtualKeyboardSize () {
        if ( !virtualKeyboardVisible ) return false;

        return {
            width: currentViewportWidth,
            height: viewportHeightWithoutVirtualKeyboard - currentViewportHeight
        };
    }

    // Subscribe
    function on ( eventName, fn ) {
        if ( typeof subscriptions[eventName] === 'undefined' ) subscriptions[eventName] = [];

        subscriptions[eventName].push(fn);
    }

    // Unsubscribe
    function off ( eventName, fn ) {
        if (typeof subscriptions[eventName] === 'undefined' ) return;

        if (typeof fn === 'undefined') {
            subscriptions[eventName] = [];
        } else {
            var i = subscriptions[eventName].length;
            while ( i-- ) {
                if ( subscriptions[eventName][i] === fn ) subscriptions[eventName].splice(i, 1);
            }
        }
    }

    // Publish
    function trigger ( eventName, args ) {
        for ( i in subscriptions[eventName] ) {
            if ( typeof subscriptions[eventName][i] === 'function' ) subscriptions[eventName][i]( args );
        }
    }


    /**
     * Private functions
     */

    // Reset all sizes. We presume the virtual keyboard is not visible at this stage.
    // We call this function on initialisation, so make sure you initialise the virtualKeyBoardListener at a moment when the virtual keyboard is likely to be invisible.
    function resetViewportSizes () {
        currentViewportWidth = previousViewportWidth = viewportWidthWithoutVirtualKeyboard = window.innerWidth;
        currentViewportHeight = previousViewportHeight = viewportHeightWithoutVirtualKeyboard = window.innerHeight;
    }

    // Initialise the listener that checks for focus events in the whole document. This way we can also handle dynamically added focusable elements.
    function initFocusListener () {
        document.addEventListener( 'focus', documentFocusHandler, true );
    }

    // Handle the document focus event. We check if the target was a valid focusable element.
    function documentFocusHandler (e) {
        if (typeof e.target !== 'undefined' && typeof e.target.nodeName !== 'undefined') {
            if (validFocusableElements.indexOf(e.target.nodeName) !== -1) elementFocusHandler(e);
        }
    }

    // Handle the case when a valid focusable element is focused. We flag that a valid element was recently focused. This flag expires after recentlyFocusedTimeoutDuration.
    function elementFocusHandler (e) {
        if ( recentlyFocusedTimeout != null ) {
            window.clearTimeout( recentlyFocusedTimeout );
            recentlyFocusedTimeout = null;
        }

        recentlyFocused = true;

        recentlyFocusedTimeout = window.setTimeout( expireRecentlyFocused, recentlyFocusedTimeoutDuration );
    }

    function expireRecentlyFocused () {
        recentlyFocused = false;
    }

    function initResizeListener () {
        window.addEventListener( 'resize', resizeHandler );
    }

    function resizeHandler () {
        currentViewportWidth = window.innerWidth;
        currentViewportHeight = window.innerHeight;

        // If the virtual keyboard is tought to be visible, but the viewport height returns to the value before keyboard was visible, we presume the keyboard was hidden.
        if ( virtualKeyboardVisible && currentViewportWidth === previousViewportWidth && currentViewportHeight >= viewportHeightWithoutVirtualKeyboard ) {
            virtualKeyboardHiddenHandler();
        }

        // If the width of the viewport is changed, it's hard to tell wether virtual keyboard is still visible, so we make sure it's not.
        if ( currentViewportWidth !== previousViewportWidth ) {
            document.activeElement && document.activeElement.blur();
            virtualKeyboardHiddenHandler();
        }

        // If recently focused and viewport height is smaller then previous height, we presume that the virtual keyboard has appeared.
        if ( !virtualKeyboardVisible && recentlyFocused && currentViewportWidth === previousViewportWidth && currentViewportHeight < previousViewportHeight ) {
            virtualKeyboardVisibleHandler();
        }

        // If the keyboard is presumed not visible, we save the current measurements as values before keyboard was shown.
        if ( virtualKeyboardVisible === false ) {
            viewportWidthWithoutVirtualKeyboard = currentViewportWidth;
            viewportHeightWithoutVirtualKeyboard = currentViewportHeight;
        }

        previousViewportWidth = currentViewportWidth;
        previousViewportHeight = currentViewportHeight;
    }

    function virtualKeyboardVisibleHandler () {
        virtualKeyboardVisible = true;

        var eventData = {
            virtualKeyboardVisible: virtualKeyboardVisible,
            sizes: getSizesData()
        };

        trigger( 'virtualKeyboardVisible', eventData );
    }

    function virtualKeyboardHiddenHandler () {
        virtualKeyboardVisible = false;

        var eventData = {
            virtualKeyboardVisible: virtualKeyboardVisible,
            sizes: getSizesData()
        };

        trigger( 'virtualKeyboardHidden', eventData );
    }

    function getSizesData () {
        return {
            viewportWithoutVirtualKeyboard: {
                width: viewportWidthWithoutVirtualKeyboard,
                height: viewportHeightWithoutVirtualKeyboard
            },
            currentViewport: {
                width: currentViewportWidth,
                height: currentViewportHeight
            },
            virtualKeyboard: {
                width: currentViewportWidth,
                height: viewportHeightWithoutVirtualKeyboard - currentViewportHeight
            }
        };
    }

    // Make public functions available
    return {
        init: init,
        isVirtualKeyboardVisible: isVirtualKeyboardVisible,
        getVirtualKeyboardSize: getVirtualKeyboardSize,
        on: on,
        addEventListener: on,
        subscribe: on,
        off: off,
        removeEventListener: off,
        unsubscribe: off,
        trigger: trigger,
        publish: trigger,
        dispatchEvent: trigger
    };

} )( window );
APP.Initializer = (function (win, doq) {
    var exports = {},
        initialized,
        actualVersion;

    function _construct() {
        actualVersion = getVersion();
        setGlobalDomVariables();
        requestAnimationFrame(init);
    }

    function getVersion(context) {
        var v = (context || document.body).querySelector('[data-version]');
        return v && v.getAttribute('data-version');
    }

    function init() {
        var problemWorkerReady;

        setUpGlobals();
        APP.Error.init();
        problemWorkerReady = APP.ProblemWorker.init();
        problemWorkerReady.catch(function (error) {
            APP.Error.logError(error, {
                source: 'APP.Initializer.problemWorkerReady'
            });
        });
        APP.Assets.init();
        APP.Live.init();
        APP.Analytics.init();
        showAddToHomeScreen();
        $.ajaxSetup({cache: false});
        if (window.ADMIN) {
            ADMIN.Initializer.init();
        }
        ready();
    }

    function setUpGlobals() {
        // for inline scripts:
        window.AKRIEL_ajaxPost = APP.Ajax.post;
        window.AKRIEL_applyUrl = APP.Page.applyPageByUrl;
    }

    function showAddToHomeScreen() {
        if (navigator.serviceWorker) {
            try {
                navigator.serviceWorker.register(document.location.origin + '/hu/sw.js').catch(function (error) {
                    reportServiceWorkerRegistrationFailure(error);
                });
            } catch (error) {
                reportServiceWorkerRegistrationFailure(error);
            }
            window.addEventListener('beforeinstallprompt', function (e) {
                e.userChoice.then(function (outcome) {
                    APP.Analytics.trackEvent('install', outcome, e.platforms.join(','));
                });
            });
        }
    }

    function reportServiceWorkerRegistrationFailure(error) {
        if (APP.Analytics && APP.Analytics.capture) {
            APP.Analytics.capture('service-worker-registration-failed', {
                code: 'service_worker_registration_rejected',
                source: 'APP.Initializer.serviceWorkerRegister',
                page: document.location.pathname,
                serviceWorkerSupported: !!navigator.serviceWorker,
                hasController: !!(navigator.serviceWorker && navigator.serviceWorker.controller),
                hasReadyPromise: !!(navigator.serviceWorker && navigator.serviceWorker.ready),
                protocol: document.location.protocol,
                script: document.location.origin + '/hu/sw.js',
                reason: {
                    name: error && error.name || 'Error',
                    message: error && error.message || String(error || 'Unknown service worker registration failure'),
                    code: error && error.code || ''
                }
            });
        }
    }

    function ready() {
        initialized = true;
        APP.Tpl.init();
        APP.Error.init();
        APP.Form.init();
        APP.Locale.init();
        APP.Page.init();
        APP.User.init();
        APP.Notification.init();
        $body.addClass('application--ready')
            .removeClass('application--starts')
            .removeClass('application--loading');
        win.domReady();
        requestAnimationFrame(pageLoadedInit);
    }

    function pageLoadedInit() {
        APP.Live.init();
        APP.Layout.scrollTo(0);
        APP.Tpl.init();
        APP.Calculator.Keyboard.hide(true);
        APP.Calculator.init();
        APP.Locale.init();
        APP.Layout.init();
        APP.User.init();
        APP.Problem.init();
        APP.Decor.init();
        APP.Formula.cosmeticFormulaByWrapper($body.find('[data-cosmetic-formulas]'));
        APP.Pro.init();
        APP.Formula.init();
        APP.Race.init();
        APP.NewsFeed.init();
        APP.BasicCalculator.init();
        APP.Cd.init();
        APP.Analytics.pageView();
        APP.PrimeTable.init();
        APP.Exam.init();
        APP.Akri.init();
        APP.Doodle.init();
        APP.Video.init();
        APP.Learn.init();
        if (window.ADMIN) {
            ADMIN.Initializer.pageLoaded();
        }
    }

    function needUpdate(context) {
        return (actualVersion !== getVersion(context));
    }

    function setGlobalDomVariables() {
        win.$document = $(doq);
        win.$window = $(win);
        win.$body = $(doq.body);
    }

    // constructor:
    _construct();

    exports.init = pageLoadedInit;
    exports.getVersion = getVersion;
    exports.needUpdate = needUpdate;
    return exports;

}(window, document));
;APP.$store={};APP.$store.svg = '<svg xmlns="http://www.w3.org/2000/svg"><symbol id="icon-akriel-symbol-p1" viewBox="0 0 256 256"><path d="M139.3 237.9h-20.9c-2.9 0-3.6 1.7-1.5 3.7l8.3 8.3c2.0 2.0 5.4 2.0 7.4 0l8.3-8.3c2.0-2.0 1.3-3.7-1.5-3.7zM149.3 192.1h-43.0c-2.9 0-5.2 2.3-5.2 5.2v2.0c0 2.9 2.4 5.2 5.2 5.2h43.0c2.9 0 5.2-2.4 5.2-5.2v-2.0c0-2.9-2.4-5.2-5.2-5.2zM148.0 214.9h-40.4c-2.9 0-5.2 2.4-5.2 5.2v2.0c0 2.9 2.4 5.2 5.2 5.2h40.4c2.9 0 5.2-2.4 5.2-5.2v-2.0c0-2.9-2.4-5.2-5.2-5.2zM191.6 102.9l-58.4-39.6c-2.5-1.7-6.6-1.7-9.0 0l-58.4 39.6c-2.5 1.7-3.6 5.4-2.6 8.2l24.6 63.8c1.1 2.8 4.4 5.1 7.4 5.1h66.9c3.0 0 6.4-2.3 7.4-5.1l19.4-50.5c1.1-2.8-.493-5.1-3.5-5.1h-18.8c-3.0 0-7.0 2.0-8.8 4.3l-17.6 22.9c-1.8 2.4-4.8 6.3-6.7 8.7l-1.6 2.0c-1.8 2.4-5.0 2.5-7.0.336l-19.8-21.3c-2.0-2.2-2.0-5.8.058-8.0l1.7-1.7c2.1-2.2 5.5-2.2 7.5.054l9.7 10.5c2.0 2.2 5.2 2.1 7.1-.332l20.4-26.5c1.8-2.4 5.8-4.3 8.8-4.3h30.3c3.0 0 3.4-1.4.948-3.1z"/></symbol><symbol id="icon-akriel-symbol-p2" viewBox="0 0 256 256"><path d="M47.2 190.0L26.2 205.4c-1.7 1.3-1.9 4.0-1.4 4.6.492.6 3.8 2.2 5.5.853l20.8-15.6c2.7-2.3.312-6.3-.04-6.7-.35-.472-2.1.184-3.8 1.5zM44.2 35.2c-1.4-1.6-5.6-.27-6.7.79-1.1 1.1-.783 3.2.736 4.7L56.6 59.2c1.5 1.5 3.4 2.2 4.2 1.4.81-.767 1.8-4.1.43-5.7L44.2 35.2zM213.9 33.8c-1.1-1.0-3.2-.48-4.6 1.2L192.4 54.9c-1.4 1.6-.3 4.9.525 5.7.83.8 2.7.138 4.2-1.4l18.1-18.8c1.5-1.6-.214-5.6-1.4-6.6zM33.1 146.0c-.155-1.1-2.0-1.8-4.2-1.5l-25.8 3.4c-2.1.287-3.3 4.5-3.0 6.0.278 1.5 2.2 2.4 4.3 2.0l25.5-5.1c2.1-.424 3.3-3.7 3.1-4.8zM252.9 146.6l-25.8-3.2c-2.1-.262-4.3 2.5-4.5 3.6-.193 1.1 1.4 2.4 3.5 2.8l25.6 4.8c2.1.398 4.1-.507 4.3-2.0.26-1.5-.94-5.7-3.1-6.0zM223.1 100.8l24.8-7.9c2.0-.657 2.5-5.0 1.9-6.4-.535-1.4-2.6-2.0-4.6-1.2l-24.2 9.5c-2.0.788-2.6 4.2-2.2 5.3.357 1.1 2.3 1.4 4.4.754zM151.5 38.1c1.1.282 2.5-1.2 3.0-3.3L161.5 9.7c.574-2.1-2.8-4.8-4.3-5.1-1.5-.34-3.1 1.1-3.5 3.2l-5.3 25.5c-.45 2.1 2.1 4.5 3.2 4.8zM99.0 35.0c.574 2.1 1.9 3.6 3.0 3.3 1.1-.288 3.6-2.7 3.2-4.8L99.9 8.0c-.447-2.1-4.7-3.0-6.2-2.6-1.5.384-2.2 2.4-1.6 4.5l6.9 25.1zM7.0 94.3l25.1 7.0c2.1.586 4.0.17 4.4-.922.3-1.1-.41-4.5-2.4-5.2L9.4 86.7C7.4 86.0 4.4 89.1 4 90.6c-.44 1.5.896 3.1 3.0 3.7zM230.2 204.5L209.1 189.3c-1.8-1.3-4.1-1.0-4.4-.574-.355.5-.847 3.8.865 5.1l21.2 15.9c1.7 1.3 4.5.02 5.0-.617.5-.634.3-3.3-1.5-4.6z"/></symbol><symbol id="icon-akriel-symbol" viewBox="0 0 256 256"><path d="M139.3,237.9h-20.9c-2.9,0-3.6,1.7-1.5,3.7l8.3,8.3c2.0,2.0,5.4,2.0,7.4,0l8.3-8.3c2.0-2.0,1.3-3.7-1.5-3.7L139.3,237.9zM149.3,192.1h-43.0c-2.9,0-5.2,2.3-5.2,5.2v2.0c0,2.9,2.4,5.2,5.2,5.2h43.0c2.9,0,5.2-2.4,5.2-5.2v-2.0C154.5,194.5,152.2,192.1,149.3,192.1L149.3,192.1zM148.0,214.9h-40.4c-2.9,0-5.2,2.4-5.2,5.2v2.0c0,2.9,2.4,5.2,5.2,5.2h40.4c2.9,0,5.2-2.4,5.2-5.2v-2.0C153.2,217.3,150.9,214.9,148.0,214.9zM47.2,190.0L26.2,205.4c-1.7,1.3-1.9,4.0-1.4,4.6c0.5,0.6,3.8,2.2,5.5,0.9l20.8-15.6c2.7-2.3,0.3-6.3-0.0-6.7c-0.3-0.5-2.1,0.2-3.8,1.5H47.2zM44.2,35.2c-1.4-1.6-5.6-0.3-6.7,0.8c-1.1,1.1-0.8,3.2,0.7,4.7L56.6,59.2c1.5,1.5,3.4,2.2,4.2,1.4c0.8-0.8,1.8-4.1,0.4-5.7L44.2,35.2zM213.9,33.8c-1.1-1.0-3.2-0.5-4.6,1.2L192.4,54.9c-1.4,1.6-0.3,4.9,0.5,5.7c0.8,0.8,2.7,0.1,4.2-1.4l18.1-18.8c1.5-1.6-0.2-5.6-1.4-6.6H213.9zM33.1,146.0c-0.2-1.1-2.0-1.8-4.2-1.5l-25.8,3.4c-2.1,0.3-3.3,4.5-3.0,6.0c0.3,1.5,2.2,2.4,4.3,2.0l25.5-5.1C32.0,150.4,33.2,147.1,33.1,146.0L33.1,146.0zM252.9,146.6l-25.8-3.2c-2.1-0.3-4.3,2.5-4.5,3.6c-0.2,1.1,1.4,2.4,3.5,2.8l25.6,4.8c2.1,0.4,4.1-0.5,4.3-2.0c0.3-1.5-0.9-5.7-3.1-5.9V146.6zM223.1,100.8l24.8-7.9c2.0-0.7,2.5-5.0,1.9-6.4c-0.5-1.4-2.6-2.0-4.6-1.2l-24.2,9.5c-2.0,0.8-2.6,4.2-2.2,5.3C219.1,101.1,221.1,101.4,223.1,100.8L223.1,100.8zM151.5,38.1c1.1,0.3,2.5-1.2,3.0-3.3L161.5,9.7c0.6-2.1-2.8-4.8-4.3-5.1c-1.5-0.3-3.1,1.1-3.5,3.2l-5.3,25.5C147.9,35.4,150.4,37.8,151.5,38.1L151.5,38.1zM99.0,35.0c0.6,2.1,1.9,3.6,3.0,3.3c1.1-0.3,3.6-2.7,3.2-4.8L99.9,8.0c-0.4-2.1-4.7-3.0-6.2-2.6c-1.5,0.4-2.2,2.4-1.6,4.5L99.0,35.0L99.0,35.0zM7.0,94.3l25.1,7.0c2.1,0.6,4.0,0.2,4.4-0.9c0.3-1.1-0.4-4.5-2.4-5.2L9.4,86.7C7.4,86.0,4.4,89.1,4,90.6C3.6,92.1,4.9,93.7,7.0,94.3zM230.2,204.5L209.1,189.3c-1.8-1.3-4.1-1.0-4.4-0.6c-0.4,0.5-0.8,3.8,0.9,5.1l21.2,15.9c1.7,1.3,4.5,0.0,5.0-0.6c0.5-0.6,0.3-3.3-1.5-4.6L230.2,204.5zM191.6,102.9l-58.4-39.6c-2.5-1.7-6.6-1.7-9.0,0l-58.4,39.6c-2.5,1.7-3.6,5.4-2.6,8.2l24.6,63.8c1.1,2.8,4.4,5.1,7.4,5.1h66.9c3.0,0,6.4-2.3,7.4-5.1l19.4-50.5c1.1-2.8-0.5-5.1-3.5-5.1h-18.8c-3.0,0-7.0,2.0-8.8,4.3l-17.6,22.9c-1.8,2.4-4.8,6.3-6.7,8.7l-1.6,2.0c-1.8,2.4-5,2.5-7.0,0.3l-19.8-21.3c-2.0-2.2-2.0-5.8,0.1-8.0l1.7-1.7c2.1-2.2,5.5-2.2,7.5,0.1l9.7,10.5c2.0,2.2,5.2,2.1,7.0-0.3l20.4-26.5c1.8-2.4,5.8-4.3,8.8-4.3h30.3C193.6,106.0,194.1,104.6,191.6,102.9L191.6,102.9z"/></symbol><symbol id="icon-arrow-doodle-right-down" viewBox="0 0 256 256"><path d="M255.2 247.5c.036-.8.1-.3.1-.42.1-.18.1-.36.2-.63.0-.16.1-.25.1-.44.0-.25.1-.6.1-.88.0-.36.1-.72.1-.115.0-.24.1-.46.1-.73.0-.38.0-.8.1-.12.0-.53.0-.105.1-.16.0-.27.0-.48.0-.75.0-.007 0-.13.0-.2.0-.44.0-.9.0-.136.0-.35.0-.66.0-.103 0-.025-.013-.05-.015-.074-.003-.38.0-.076-.006-.114 0-.006 0-.012 0-.018-.007-.036-.03-.063-.04-.1-.02-.058-.035-.11-.063-.164-.017-.033-.028-.066-.05-.1-.02-.035-.054-.062-.08-.094-.037-.046-.073-.087-.117-.125-.026-.022-.05-.05-.08-.07-.033-.022-.072-.036-.11-.057-.054-.03-.108-.055-.166-.074-.024-.01-.045-.027-.07-.035l-33.9-8.5c-.567-.143-1.1.202-1.3.77-.23.1-.32.2-.32.3 0 .474.3.904.8 1.0l24.7 6.2C112.7 240.3 2.1 130.5 2.1 1.1 2.1.474 1.6 0 1.1 0S0 .476 0 1.1c0 62.1 26.7 124.5 73.3 171.1 46.3 46.3 107.1 72.8 171.9 75.2l-32.8 6.6c-.504.1-.852.5-.852 1.0 0 .68.0.14.0.21.1.57.7.943 1.2.828l42.3-8.5z"/></symbol><symbol id="icon-arrow-doodle-right-up" viewBox="0 0 256 256"><path d="M247.5.85c-.008-.036-.03-.063-.042-.098-.018-.06-.036-.114-.063-.168-.016-.03-.025-.063-.044-.09-.025-.04-.06-.07-.088-.105-.036-.044-.072-.084-.115-.122-.024-.022-.046-.047-.073-.066-.038-.027-.08-.043-.122-.064-.05-.028-.104-.05-.16-.07-.025-.01-.046-.03-.073-.035-.007 0-.013 0-.02 0-.044-.01-.09-.006-.136-.01-.037-.006-.067-.023-.104-.023-.026 0-.5.0-.75.0-.38.0-.076-.002-.114.0-.5.0-.01 0-.017 0-.36.0-.63.0-.1.0-.58.0-.11.0-.164.1-.34.0-.67.0-.1.1-.36.0-.63.1-.95.1-.46.0-.87.1-.125.1-.23.0-.5.0-.7.1-.23.0-.37.1-.58.1-.3.1-.55.1-.74.2-.1.0-.26.0-.34.1l-8.5 33.9c-.142.6.203 1.1.772 1.3.86.0.172.0.257.0.473 0 .903-.32 1.0-.8l6.2-24.7C240.3 143.3 130.5 253.9 1.1 253.9c-.585 0-1.1.473-1.1 1.1S.476 256 1.1 256c62.1 0 124.5-26.7 171.1-73.3 46.3-46.3 72.8-107.1 75.2-172.0l6.6 32.8c.1.5.543.9 1.0.85.1 0 .14-.6.2-.2.6-.115.9-.673.8-1.2L247.5.85z"/></symbol><symbol id="icon-arrow-down" viewBox="0 0 256 256"><path d="M23.6 159.2l91.4 91.4c7.1 7.1 18.7 7.1 25.9 0l91.4-91.4c7.1-7.1 7.1-18.7 0-25.9-7.1-7.1-18.7-7.1-25.9 0l-60.2 60.2V18.3C146.3 8.2 138.1 0 128 0c-10.1 0-18.3 8.2-18.3 18.3V193.6L49.5 133.4c-3.6-3.6-8.3-5.4-12.9-5.4s-9.4 1.8-12.9 5.4c-7.1 7.1-7.1 18.7 0 25.9z"/></symbol><symbol id="icon-arrow-key-down" viewBox="0 0 256 256"><path d="M98.7 29.3V161.0h-65.8L128 256l95.1-95.0h-65.8V28.6C157.3 12.8 144.2 0 128 0S98.7 13.5 98.7 29.3z"/></symbol><symbol id="icon-arrow-key-left" viewBox="0 0 256 256"><path d="M226.7 98.7H95.0v-65.8L0 128.0l95.0 95.1v-65.8h132.4c15.8 0 28.6-13.1 28.6-29.3 0-16.2-13.5-29.3-29.3-29.3z"/></symbol><symbol id="icon-arrow-key-right" viewBox="0 0 256 256"><path d="M29.3 157.3H161.0l-.002 65.9L256.0 128l-95.0-95.1v65.8H28.6c-15.8 0-28.6 13.1-28.6 29.3s13.5 29.3 29.3 29.3z"/></symbol><symbol id="icon-arrow-key-up" viewBox="0 0 256 256"><path d="M157.3 226.7V95.0h65.8L128 0 32.9 95.0h65.8v132.4c0 15.8 13.1 28.6 29.3 28.6s29.3-13.5 29.3-29.3z"/></symbol><symbol id="icon-arrow-left" viewBox="0 0 256 256"><path d="M96.8,23.6L5.4,115.1c-7.1,7.1-7.1,18.7,0,25.9l91.4,91.4c7.1,7.1,18.7,7.1,25.9,0c7.1-7.1,7.1-18.7,0-25.9l-60.2-60.2h175.3c10.1,0,18.3-8.2,18.3-18.3s-8.2-18.3-18.3-18.3H62.4l60.2-60.2c3.6-3.6,5.4-8.3,5.4-12.9s-1.8-9.4-5.4-12.9C115.5,16.5,103.9,16.5,96.8,23.6L96.8,23.6z"/></symbol><symbol id="icon-arrow-right" viewBox="0 0 256 256"><path d="M159.2 232.4l91.4-91.4c7.1-7.1 7.1-18.7 0-25.9l-91.4-91.4c-7.1-7.1-18.7-7.1-25.9 0-7.1 7.1-7.1 18.7 0 25.9l60.2 60.2H18.3C8.2 109.7 0 117.9 0 128c0 10.1 8.2 18.3 18.3 18.3H193.6L133.4 206.5c-3.6 3.6-5.4 8.3-5.4 12.9s1.8 9.4 5.4 12.9c7.1 7.1 18.7 7.1 25.9 0z"/></symbol><symbol id="icon-arrow-small-down" viewBox="0 0 256 256"><path d="M249.0 96.3c-9.0 9.2-103.6 99.4-103.6 99.4-4.8 4.9-11.1 7.4-17.4 7.4-6.3 0-12.6-2.5-17.4-7.4 0 0-94.6-90.2-103.6-99.4-9.0-9.2-9.6-25.8 0-35.7 9.6-9.8 23.0-10.6 34.8 0L128 143.3l86.2-82.7c11.8-10.6 25.2-9.8 34.8 0 9.6 9.8 9.0 26.4 0 35.6z"/></symbol><symbol id="icon-arrow-up" viewBox="0 0 256 256"><path d="M232.4,96.8l-91.4-91.4c-7.1-7.1-18.7-7.1-25.9,0l-91.4,91.4c-7.1,7.1-7.1,18.7,0,25.9c7.1,7.1,18.7,7.1,25.9,0l60.2-60.2l0,175.3c0,10.1,8.2,18.3,18.3,18.3c10.1,0,18.3-8.2,18.3-18.3V62.4l60.2,60.2c3.6,3.6,8.3,5.4,12.9,5.4s9.4-1.8,12.9-5.4C239.5,115.5,239.5,103.9,232.4,96.8L232.4,96.8z"/></symbol><symbol id="icon-doodle-fullscreen" viewBox="0 0 256 256"><g id="Layer_2"><polygon points="12,57.2 0,57.2 0,0 57.2,0 57.2,12 12,12 "/><polygon points="256,57.2 244,57.2 244,12 198.8,12 198.8,0 256,0 "/><polygon points="256,256 198.8,256 198.8,244 244,244 244,198.8 256,198.8 "/><polygon points="57.2,256 0,256 0,198.8 12,198.8 12,244 57.2,244 "/></g></symbol><symbol id="icon-doodle-pan" viewBox="0 0 256 256"><polygon points="160,48.9 128,17 96,48.9 87.6,40.4 128,0 168.4,40.4 "/><polygon points="215.6,168.4 207.1,160 239,128 207.1,96 215.6,87.6 256,128 "/><polygon points="128,256 87.6,215.6 96,207.1 128,239 160,207.1 168.4,215.6 "/><polygon points="40.4,168.4 0,128 40.4,87.6 48.9,96 17,128 48.9,160 "/></symbol><symbol id="icon-doodle-pen" viewBox="0 0 256 256"><path d="M235.2,20.6C222,7.5,204.7,0,187.6,0c-14.4,0-27.7,5.3-37.4,15l-38.9,39.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.1,0.2-0.2,0.2l0,0L28.1,138c-3.8,3.8-6.6,8.5-8.1,13.6L1.2,219.8c0,0.2-1.2,5.5-1.2,8.2c0,15.5,12.6,28,28,28c3.1,0,9-1.5,9.3-1.5l67.8-17.8c5.2-1.5,9.8-4.3,13.6-8.1l122.1-123.1C263.1,83.2,260.6,46,235.2,20.6zM128.1,190.4c-0.7-7.2-2.7-14.3-5.8-21L198,93.7c4.6,14.6,2.2,29.9-7.9,40c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1l-61.8,62.3C128.2,194.3,128.3,192.4,128.1,190.4L128.1,190.4zM118.3,162c-3-4.9-6.4-9.6-10.6-13.8c-4.9-4.9-10.5-8.7-16.4-11.9L167.7,60c6,2.7,11.7,6.4,16.8,11.5c4.3,4.3,7.7,9.1,10.2,14.2C194.7,85.7,118.3,162,118.3,162zM83.9,132.5c-7.4-3-15.2-4.7-22.9-4.8l61.6-62.1c9.4-9.2,23.2-11.8,36.7-8.5C159.3,57.1,83.9,132.5,83.9,132.5zM33.3,239c-0.9,0.2-3.6,0.9-5.4,1c-6.6-0.1-11.9-5.4-11.9-12c0.1-1.3,0.6-3.7,0.8-4.5l8.4-30.5c9.1-0.2,19,3.3,26.7,11.1c7.9,7.8,11.6,17.9,11.2,27.1L33.3,239L33.3,239zM71,229.1c-0.2-10.7-4.6-21.9-13.4-30.7c-8.3-8.3-19.2-13.2-30.1-13.6l8-28.9c0.6-1.9,1.7-3.8,3.1-5.5c16-11.5,40.7-8.1,57.9,9.1c18.1,18.1,20.9,44.7,7,60.5c-0.9,0.5-1.9,1-2.9,1.2C100.6,221.3,71,229.1,71,229.1zM229.5,94.2l-13.5,13.6c0-1.8,0.2-3.5,0-5.4c-1.4-15.5-8.6-30.4-20.3-42.2c-13-13-30.3-20.5-47.4-20.6l13.2-13.4c6.6-6.6,15.9-10.3,26-10.3c12.9,0,26.1,5.8,36.3,16c9.5,9.5,15.2,21.4,16,33.3C240.7,76.5,237,86.7,229.5,94.2z"/></symbol><symbol id="icon-doodle-rubber" viewBox="0 0 256 256"><path d="M100,234.5L232.6,102h0c7.3-7.3,7.3-19.3,0-26.6l-60.9-60.9c-3.6-3.6-8.3-5.5-13.3-5.5c-5,0-9.7,2-13.3,5.5L5.5,154c-7.3,7.3-7.3,19.3,0,26.6l60.9,60.9c3.5,3.5,8.2,5.4,12.8,5.5v0.1H256v-12.5H100zM153.9,23.3c1.2-1.2,2.8-1.8,4.4-1.8c1.7,0,3.2,0.7,4.4,1.8l60.9,60.9c2.4,2.4,2.4,6.4,0,8.9l-65.4,65.4L88.6,88.7L153.9,23.3zM14.4,171.7c-2.4-2.4-2.4-6.4,0-8.9l65.4-65.3l69.8,69.8l-65.4,65.4c-2.4,2.4-6.4,2.4-8.9,0L14.4,171.7z"/></symbol><symbol id="icon-formula-abs-placeholder" viewBox="0 0 256 256"><path d="M149.1 96.3h-47.5c-5.1 0-9.2 4.1-9.2 9.2v47.5c0 5.1 4.1 9.2 9.2 9.2h47.5c5.1 0 9.2-4.1 9.2-9.2v-47.5c0-5.1-4.1-9.2-9.2-9.2z"/></symbol><symbol id="icon-formula-abs" viewBox="0 0 256 256"><path d="M9.2 232.2c-5.1 0-9.2-4.1-9.2-9.2V33.0c0-5.1 4.1-9.2 9.2-9.2 5.1 0 9.2 4.1 9.2 9.2v190.0c0 5.1-4.1 9.2-9.2 9.2zM246.8 232.2c-5.1 0-9.2-4.1-9.2-9.2V33.0c0-5.1 4.1-9.2 9.2-9.2 5.1 0 9.2 4.1 9.2 9.2v190.0c0 5.1-4.1 9.2-9.2 9.2z"/></symbol><symbol id="icon-formula-exp-placeholder-1" viewBox="0 0 256 256"><g><rect x="4.5" y="114.5" width="137" height="137"/></g></symbol><symbol id="icon-formula-exp-placeholder-2" viewBox="0 0 256 256"><g><polygon points="159.9,85.5 204,9 248.2,85.5 "/></g></symbol><symbol id="icon-formula-log-placeholder-1" viewBox="0 0 256 256"><g><polygon points="116.6,229 152.1,167.5 187.6,229 "/></g></symbol><symbol id="icon-formula-log-placeholder-2" viewBox="0 0 256 256"><g><rect x="175.5" y="90" width="76" height="76"/></g></symbol><symbol id="icon-formula-log" viewBox="0 0 256 256"><path d="M29.7 150.7c-1.5 0-2.6-.046-3.6-.148-.276-.028-.344-.09-.35-.104 0 0 .203-.243.0-1.1-.146-.728.1-2.1.095-4.8v-68.8c0-2.0-2.4-4.8-4.4-4.8h-2.5c-.463 0-.93.7-1.4.847L2.2 78.6c-.905.4-1.6 1.2-2.0 2.2-.354.9-.336 2 .074 2.9l.932 2.1c.82 1.8 2.9 2.6 4.7 1.8 1.1-.463 1.8-.582 2.1-.61.1.527.5 1.4.604 2.7.138 1.9.482 4.6.482 8.0v47.0c0 1.8-.354 3.3-.5 4.4-.132.9-.493 1.3-.537 1.4 0 0-.143.1-.365.1-.494.1-.95.3-2.7.276-2.0 0-3.1 1.6-3.1 3.6v2.0c0 2.0.55 3.4 2.5 3.4h25.4c2.0 0 3.2-1.4 3.2-3.4v-2.0c-.025-2.0-1.4-3.6-3.4-3.6zM122.0 145.8c-1.2-.113-3.1-.26-5.6-.437-2.5-.164-5.8-.313-9.8-.426-2.7-.052-4.9-.16-6.5-.323-1.0-.107-1.7-.22-2.2-.318.1-.103.1-.225.2-.35.1-.202.4-.68 1.2-1.5.827.2 1.6.333 2.5.436 5.1.65 10.0.174 14.1-1.3 3.0-1.1 5.5-2.6 7.6-4.5 2.1-1.9 3.8-4.2 5.0-6.8 1.2-2.6 1.8-5.8 1.8-8.7 0-2.5-.335-5.0-.984-7.4h.94c2.6 0 3.9.322 4.8-.205.9-.49 2.5-1.5 2.5-4.4 0-.705-.02-1.2-.052-1.7-.057-.914-.28-1.7-.648-2.4-.506-1.3-1.7-2.2-3.2-2.4-.252-.036-.664-.434-1.3-.47-.502-.032-1.2-.407-2.2-.407h-9.9c-4.0-2.4-8.7-3.3-13.9-3.3-3.4 0-6.6.76-9.6 1.9-3.0 1.1-5.5 2.8-7.7 4.9-2.2 2.0-3.9 4.5-5.1 7.2-.596 1.3-1.1 2.7-1.4 4.1-1.4-3.3-3.2-6.2-5.6-8.7-2.5-2.7-5.6-4.9-9.0-6.5-3.5-1.6-7.4-2.4-11.5-2.4-4.1 0-8.0.896-11.5 2.7-3.4 1.7-6.5 4.1-9.0 7.0-2.5 2.9-4.5 6.2-6.0 10.0-1.4 3.7-2.2 7.8-2.2 11.9 0 4.0.685 7.9 2.0 11.6 1.4 3.7 3.3 6.9 5.7 9.7 2.5 2.8 5.5 5.1 8.9 6.8 3.5 1.7 7.3 2.6 11.4 2.6 3.9 0 7.6-.8 11.2-2.4 3.5-1.6 6.7-3.8 9.3-6.6 2.7-2.8 4.8-6.2 6.3-10.1 1.2-3.0 1.9-6.3 2.2-9.8.52.1.94.2.152.3 1.2 1.9 2.7 3.6 4.4 5.0-.498.5-.952.9-1.4 1.3-1.4 1.4-2.4 2.6-3.2 3.8-.845 1.3-1.4 2.4-1.7 3.6-.276 1.0-.42 2.1-.42 3.0 0 2.0.706 3.9 2.0 5.5.386.5.85.9 1.4 1.4-1.0 1.1-1.9 2.1-2.7 2.9-1.5 1.6-2.6 3.0-3.4 4.1-.948 1.4-1.6 2.6-1.9 3.7-.28 1.0-.427 2.1-.427 3.3 0 1.7.55 4.3 3.2 6.9 1.7 1.6 3.8 3.0 6.4 4.1 2.4 1.1 5.1 1.9 8.0 2.5 2.9.613 5.8.923 8.7.923 4.0 0 8.0-.595 11.9-1.8 3.8-1.2 7.3-2.8 10.2-4.8 3.1-2.1 5.6-4.6 7.5-7.4 2.0-3.0 3.0-6.4 3.0-9.9 0-4.0-1.4-7.5-4.1-10.3-2.6-2.7-6.2-4.3-10.6-4.9zm-60.2 3.7c-1.1.49-2.2.73-3.5.73-1.7 0-3.2-.51-4.6-1.6-1.6-1.2-3.0-2.9-4.2-4.9-1.2-2.2-2.2-4.9-2.9-7.9-.697-3.1-1.0-6.3-1.0-9.7 0-3.2.32-5.9.948-8.0.602-2.0 1.4-3.7 2.3-4.9.83-1.1 1.7-1.8 2.7-2.3 1.1-.487 2.1-.724 3.2-.724 1.8 0 3.4.48 4.8 1.5 1.6 1.1 2.9 2.7 4.0 4.7 1.2 2.1 2.1 4.7 2.8 7.6.67 3.0 1.0 6.3 1.0 9.7 0 3.4-.288 6.3-.856 8.5-.54 2.1-1.2 3.8-2.1 5-.772 1.1-1.6 1.8-2.6 2.2zm60.4 18.4c-1.3.875-3.0 1.6-5.1 2.2-2.2.59-4.8.89-7.9.89-2.5 0-4.8-.183-7.0-.548-2.1-.35-3.9-.838-5.5-1.4-1.3-.53-2.3-1.1-3.0-1.8-.47-.455-.47-.727-.47-.886 0-.903.5-2.8 3.2-6.2 4.6.553 10.6.895 18.0 1.1 2.8.106 5.1.266 6.9.48 1.9.234 3.0.548 3.5.772.3.14.5.24.5.24.0.83.1.257.1.57 0 .697-.22 1.4-.667 2.2-.527.9-1.4 1.7-2.6 2.5zm-9.8-50.7c.445 1.9.66 4.0.66 6.2 0 3.7-.655 6.4-1.9 7.9-1.2 1.3-2.6 2.0-4.4 2.0-1.1 0-2.0-.248-2.9-.753-.926-.586-1.7-1.4-2.4-2.5-.77-1.2-1.4-2.7-1.8-4.5-.447-1.9-.667-4.0-.667-6.2 0-3.7.693-6.4 2.0-7.9 1.2-1.4 2.6-2.1 4.3-2.1 1.1 0 2.1.256 2.9.782.9.606 1.7 1.4 2.4 2.6.765 1.3 1.4 2.9 1.8 4.6z"/></symbol><symbol id="icon-formula-p-placeholder" viewBox="0 0 256 256"><rect x="60" y="60" width="136" height="136"/></symbol><symbol id="icon-formula-p" viewBox="0 0 256 256"><path d="M24.4 232c-8.0-18.1-14.1-35.7-18.2-52.9C2.1 161.9 0 144.9 0 128.0c0-16.9 2.1-33.9 6.2-51.1C10.3 59.8 16.4 42.1 24.4 24h21.9c-8.6 18.5-15.2 36.3-19.6 53.2-4.4 17.0-6.6 33.9-6.6 50.8 0 16.9 2.2 33.8 6.6 50.8C31.1 195.7 37.6 213.5 46.3 232H24.4zM209.7 232c8.6-18.5 15.2-36.3 19.6-53.2 4.4-17.0 6.6-33.9 6.6-50.8 0-16.9-2.2-33.8-6.6-50.8-4.4-17.0-11.0-34.7-19.6-53.2h21.9c8.0 18.1 14.1 35.8 18.2 52.9 4.1 17.2 6.2 34.2 6.2 51.1 0 16.9-2.1 33.9-6.2 51.1-4.1 17.2-10.2 34.8-18.2 52.9H209.7z"/></symbol><symbol id="icon-formula-per-placeholder-1" viewBox="0 0 256 256"><g><rect x="83.7" y="5.5" width="88.7" height="88.7"/></g></symbol><symbol id="icon-formula-per-placeholder-2" viewBox="0 0 256 256"><g><polygon points="76,251.5 128,161.5 180,251.5"/></g></symbol><symbol id="icon-formula-per" viewBox="0 0 256 256"><path d="M195.8,138.4H60.2c-5,0-9.1-4.1-9.1-9.1c0-5.1,4.1-9.1,9.1-9.1h135.7c5.1,0,9.1,4.1,9.1,9.1C205,134.4,200.9,138.4,195.8,138.4L195.8,138.4z"/></symbol><symbol id="icon-formula-root-placeholder-1" viewBox="0 0 256 256"><polygon points="36.1,98.8 0,98.8 18.1,67.5 36.1,36.2 54.2,67.5 72.3,98.8 "/></symbol><symbol id="icon-formula-root-placeholder-2" viewBox="0 0 256 256"><g><rect x="135.9" y="86.5" width="87" height="87"/></g></symbol><symbol id="icon-formula-root" viewBox="0 0 256 256"><path d="M87.0 227.7c-3.3 0-6.3-1.8-7.8-4.8l-41.9-81.7h-17.2c-4.8 0-8.8-3.9-8.8-8.8 0-4.9 3.9-8.8 8.8-8.8h22.6c3.3 0 6.3 1.8 7.8 4.8l31.2 60.9 18.5-153.3c.532-4.4 4.3-7.7 8.7-7.7h138.3c4.9 0 8.8 3.9 8.8 8.8V60.9c0 4.9-3.9 8.8-8.8 8.8-4.9 0-8.8-3.9-8.8-8.8V45.9h-121.8L95.7 220.0c-.462 3.8-3.4 6.9-7.2 7.6-.52.1-1.0.14-1.6.14z"/></symbol><symbol id="icon-learn-cup-basic" viewBox="0 0 256 256"><g><path d="M132,14.2v227.6H71.1c0-15.7,12.7-28.5,28.5-28.5h14.2v-29.8c-23-4.7-42-20.4-51.3-41.4c-2.9-6.6-4.9-13.8-5.6-21.3c-0.3-2.4-0.4-4.9-0.4-7.5s0.1-5,0.4-7.5V28.4c0-7.8,6.4-14.2,14.2-14.2H132z"/><path style="fill:#FF9F28 !important" d="M199.5,113.5c0,2.5-0.1,5-0.4,7.5c-0.8,7.5-2.7,14.6-5.6,21.3c-9.2,21-28.2,36.7-51.3,41.4v29.8h14.2c15.7,0,28.4,12.7,28.4,28.5H128V14.2h56.9c7.8,0,14.2,6.4,14.2,14.2V106C199.4,108.5,199.5,111,199.5,113.5z"/></g></symbol><symbol id="icon-learn-cup-default-detailed" viewBox="0 0 256 256"><g><path style="fill:#FFD700 !important;" d="M212.7,64.1c0,1.6,0,3.1-0.1,4.7c0,1.5-0.1,2.9-0.1,4.3c0,0.4,0,0.7-0.1,1.1c0,1-0.1,2.1-0.2,3.1c0,0.3,0,0.6-0.1,1c-0.1,1.3-0.2,2.7-0.3,4c-0.4,4.2-0.9,8.2-1.6,12c-0.1,0.4-0.2,0.9-0.3,1.3c-0.2,1-0.4,2.1-0.6,3.1c-0.2,1.1-0.5,2.2-0.7,3.2c-0.2,0.9-0.4,1.7-0.6,2.5c0,0.2-0.1,0.3-0.1,0.4c-0.2,0.8-0.4,1.6-0.6,2.3c-0.3,1.1-0.6,2.1-0.9,3.2c-0.3,1-0.6,2-0.9,3c-0.2,0.7-0.5,1.4-0.7,2.1c-0.2,0.5-0.3,1-0.6,1.6c-0.3,1-0.7,1.9-1.1,2.9c-2.9,7.6-8.9,19.2-17.5,29.2c-8.1,9.4-17.9,16-28.1,20.3c-1.1,0.5-1.8,1.5-1.8,2.7V191c0,1.2,0.8,2.3,2,2.8c11.2,3.9,16.2,9.1,16.6,9.4c0.5,0.5,0.8,1.2,0.8,2v12.3c0,1.3,0.8,2.4,2,2.8c10.8,3.5,15.8,7.1,16.2,7.4c0.7,0.5,1.1,1.4,1.1,2.3v14.4c0,2.6-1.6,4.7-3.9,5.5c-0.6,0.2-1.2,0.3-1.9,0.3h-122c-0.5,0-0.9-0.1-1.3-0.3c-0.9-0.4-1.6-1.4-1.6-2.6l-0.1-17.5c0-0.9,0.4-1.8,1.2-2.3c0.4-0.3,5.3-3.8,15.9-7.2c1.2-0.4,2-1.5,2-2.8l-0.1-11.7c0-0.7,0.3-1.4,0.8-2c0.3-0.4,5.7-6.1,17.8-10.3c1.2-0.4,2-1.5,2-2.8v-17.4c0-1.2-0.8-2.3-1.9-2.7c-11.6-4.3-24.5-14.1-31.6-22.1c-2.9-3.2-12.1-15.7-17.3-29.4c-0.4-0.9-0.7-1.9-1.1-2.9c-0.4-1.1-0.8-2.3-1.2-3.4c-0.4-1.2-0.7-2.3-1-3.5c-0.3-1.1-0.6-2.2-0.9-3.3c-0.1-0.4-0.2-0.9-0.3-1.4c-0.1-0.4-0.2-0.9-0.3-1.4c-0.2-0.7-0.3-1.4-0.5-2.2c0-0.1,0-0.1,0-0.2c-0.2-0.9-0.3-1.7-0.5-2.6c0-0.1-0.1-0.3-0.1-0.4c-0.2-1-0.4-2.1-0.6-3.2c-0.1-0.2-0.1-0.4-0.1-0.7c-0.2-1-0.4-2-0.5-3c-0.1-0.2-0.1-0.4-0.1-0.7c-0.1-0.6-0.2-1.2-0.2-1.8c-0.1-0.6-0.2-1.2-0.3-1.8c-0.1-0.5-0.1-1.1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c-0.1-0.8-0.1-1.6-0.2-2.3c0-0.7-0.1-1.3-0.1-2l-0.1-1.4c-0.1-1.1-0.1-2.2-0.2-3.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-1.4-0.1-2.7-0.1-4.1c0-1.6-0.1-3.1-0.1-4.7v-52c0-3.2,2.6-5.8,5.8-5.8h160.6c1.6,0,2.9,1.3,2.9,2.9l0,17.4l0,23.2v0.1L212.7,64.1z"/><path style="fill:#ff9f28 !important;" d="M212.7,49.5L212.7,49.5l0-23.3l0-17.4c0-1.6-1.3-2.9-2.9-2.9H128V7c0.4,0.5,0.6,1.1,0.6,1.7c0,1.6,1.3,2.9,2.9,2.9H181v46.2L141.5,58l-13.4-38.2L128,20v88.5l0.1,0l40.4,19.2l-13.3-44.6L181,58.8v5.4c0,5.4-0.1,10.6-0.4,15.8c-0.2,3-0.4,5.9-0.7,8.8c-0.5,5.7-1.3,11.2-2.3,16.4c-0.1,0.6-0.2,1.2-0.3,1.7c-0.2,0.9-0.4,1.9-0.6,2.8c-0.3,1.6-0.7,3.3-1.1,4.9c-0.2,0.8-0.4,1.6-0.6,2.4c-0.6,2.3-1.3,4.5-2,6.7c-0.3,0.8-0.5,1.6-0.8,2.4c-0.3,0.8-0.5,1.6-0.9,2.4c-0.3,0.9-0.7,1.8-1,2.6c-0.4,0.9-0.8,1.8-1.1,2.7c-0.3,0.6-0.5,1.1-0.8,1.7c-0.2,0.4-0.3,0.8-0.5,1.1c-0.3,0.6-0.6,1.2-0.9,1.8c-0.2,0.5-0.5,1-0.8,1.5c-0.3,0.6-0.7,1.2-1,1.8c-0.2,0.3-0.4,0.7-0.6,1c-1.3,2.2-2.7,4.2-4.1,6.1c-0.5,0.6-0.9,1.2-1.4,1.8c-2,2.4-4.1,4.7-6.4,6.6c-0.7,0.6-1.4,1.2-2.2,1.8c-0.4,0.3-0.8,0.7-1.3,1c-0.6,0.5-1.3,0.9-2,1.4c-0.2,0.1-0.3,0.2-0.4,0.3c-0.6,0.4-1.2,0.8-1.8,1.1c-0.7,0.4-1.5,0.8-2.2,1.2c-0.3,0.2-0.6,0.3-0.9,0.4c0,0-0.1,0-0.2,0.1c-0.7,0.3-1.4,0.7-2.2,1c-0.6,0.3-1.2,0.5-1.9,0.8c-0.3,0.1-0.7,0.3-1.1,0.4c-0.8,0.3-1.7,0.6-2.5,0.8c-0.9,0.3-1.9,0.5-2.9,0.8c0,0,0,0,0,0c-0.7,0.2-1.5,0.3-2.2,0.5c-0.8-0.1-1.5-0.3-2.2-0.4c1.3,0.3,2.2,1.5,2.2,2.8v3.6c0.1,0,0.2,0,0.3-0.1c1.9-0.2,6.1-0.6,10.4-1c0.5-0.1,1.1-0.1,1.7-0.2c1.1-0.1,2.1-0.2,3.1-0.3c0.9-0.1,1.8-0.2,2.5-0.3c1.8-0.2,3.3,1.1,3.3,2.9v12.6c0,1.6-1.3,2.9-2.9,2.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9-0.1c-0.5,0-1-0.1-1.5-0.1c-0.1,0-0.1,0-0.2,0c-0.4,0-0.9-0.1-1.3-0.1c-0.6,0-1.2-0.1-1.8-0.1c-0.8-0.1-1.6-0.1-2.4-0.1c-2.5-0.1-5-0.3-7-0.4h-0.2c-1.6,0-2.9,1.3-2.9,2.9v0.2c0,0,0,0,0,0c0,1.5-1,2.7-2.5,2.9c-0.2,0-0.4,0.1-0.6,0.1c1-0.2,2-0.3,3-0.4c0.8,0.1,1.7,0.2,2.5,0.3h0c0.8,0.1,1.6,0.2,2.5,0.3c2.2,0.4,4.5,0.8,6.7,1.2c1.6,0.3,3.1,0.6,4.6,1c0.9,0.2,1.9,0.4,2.8,0.6c0.8,0.2,1.6,0.4,2.3,0.6c0.1,0,0.2,0.1,0.3,0.1c0.9,0.2,1.7,0.4,2.5,0.7c0.1,0,0.2,0,0.3,0.1c2,0.5,3.8,1,5.5,1.6h0c0.7,0.2,1.4,0.4,2,0.6c1,0.3,1.9,0.6,2.8,0.9c0.5,0.2,1,0.3,1.4,0.5c0.7,0.3,1.4,0.5,2,0.8c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.4,0.2c0.8,0.5,1.3,1.5,1.3,2.4v6.4c0,1.8-1.6,3.2-3.4,2.8c-2.7-0.4-6-0.9-9.7-1.2c-1.9-0.2-3.9-0.4-6-0.6c-0.4,0-0.8-0.1-1.3-0.1c-2.4-0.2-4.8-0.4-7.2-0.6c-0.2,0-0.4,0-0.5,0c-0.6,0-1.2-0.1-1.8-0.1l-1-0.1c-1.1-0.1-2.2-0.2-3.3-0.2c-2.3-0.1-4.6-0.3-6.5-0.4v0c-0.9,0.1-2,0.1-3.1,0.2c1.7-0.1,3.1,1.2,3.1,2.9c0,1.5,1.1,2.7,2.6,2.9c0,0,0,0,0,0c0,0,0.1,0,0.1,0c1.7,0.1,3.4,0.3,5.1,0.4c2.6,0.2,5.2,0.5,7.8,0.8c1.5,0.2,3,0.4,4.5,0.6c1.6,0.2,3.1,0.4,4.7,0.7c2.3,0.4,4.5,0.8,6.6,1.2c0.7,0.1,1.4,0.3,2.1,0.4c2.8,0.5,5.4,1.1,7.9,1.7c0.6,0.1,1.2,0.3,1.8,0.4c1.2,0.3,2.3,0.6,3.4,0.8c0.9,0.2,1.8,0.5,2.6,0.7c3.1,0.9,5.8,1.7,7.7,2.4c0.5,0.2,1,0.4,1.5,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.2,0.8,0.3,1.1,0.5c0.2,0.1,0.3,0.2,0.4,0.3v9.9c0,1.6-1.3,2.9-2.9,2.9h-54.6c-1.6,0-2.8,1.2-2.9,2.8l0,0.2c0,1.1-0.7,2-1.6,2.5c-0.4,0.2-0.8,0.3-1.2,0.3h63.3c0.7,0,1.3-0.1,1.9-0.3c2.3-0.8,3.9-2.9,3.9-5.5v-14.4c0-0.9-0.4-1.8-1.1-2.3c-0.4-0.3-5.4-3.9-16.2-7.4c-1.2-0.4-2-1.5-2-2.8v-12.3c0-0.8-0.3-1.5-0.8-2c-0.3-0.3-5.4-5.5-16.6-9.4c-1.2-0.4-2-1.5-2-2.8v-18.8c0-1.2,0.7-2.2,1.8-2.7c10.3-4.3,20-11,28.1-20.3c8.7-9.9,14.7-21.6,17.5-29.2c0.4-0.9,0.7-1.9,1.1-2.9c0.2-0.5,0.4-1,0.6-1.6c0.3-0.7,0.5-1.4,0.7-2.1c0.3-1,0.6-2,0.9-3c0.3-1,0.6-2.1,0.9-3.2c0.2-0.8,0.4-1.6,0.6-2.3c0-0.1,0.1-0.3,0.1-0.4c0.2-0.8,0.4-1.7,0.6-2.5c0.2-1.1,0.5-2.2,0.7-3.2c0.2-1,0.4-2,0.6-3.1c0.1-0.4,0.2-0.8,0.3-1.3c0.7-3.9,1.2-7.9,1.6-12c0.1-1.3,0.3-2.6,0.3-4c0.1-0.3,0.1-0.6,0.1-1c0.1-1,0.1-2,0.2-3.1c0.1-0.3,0.1-0.7,0.1-1.1c0.1-1.4,0.1-2.9,0.1-4.3c0-1.6,0.1-3.1,0.1-4.7L212.7,49.5z"/><path style="fill:#FFFB00 !important;" d="M128.2,247.3l0-0.2c0.1-1.6,1.4-2.8,2.9-2.8H72.5c-1.6,0-2.8-1.3-2.9-2.8v-0.1l0-8.2v-0.1c0-1.2,0.8-2.2,1.9-2.6c0.3-0.1,0.5-0.2,0.8-0.3c0.5-0.2,1.1-0.4,1.7-0.6c1-0.3,2.1-0.7,3.3-1c0.4-0.1,0.8-0.3,1.3-0.4c0.4-0.1,0.9-0.3,1.4-0.4c0.5-0.2,1-0.3,1.6-0.4c0.4-0.1,0.9-0.2,1.3-0.3c0.2-0.1,0.4-0.1,0.5-0.2c0.8-0.2,1.7-0.4,2.6-0.6c1.1-0.3,2.2-0.5,3.4-0.8c0.1,0,0.3-0.1,0.4-0.1c0.7-0.2,1.3-0.3,2-0.4c1-0.2,2.1-0.4,3.2-0.7c0.3-0.1,0.7-0.1,1.1-0.2c0.9-0.2,1.9-0.4,2.9-0.5c5.4-1,11.4-1.9,17.6-2.6c0.8-0.1,1.6-0.2,2.4-0.3c1.4-0.2,2.8-0.3,4.2-0.4c0.9-0.1,1.8-0.2,2.7-0.2c0.9-0.1,1.8-0.1,2.7-0.2v-0.1c0.1,0,0.2,0,0.2,0c0.9,0,1.7,0.1,2.6,0.2c-1.5-0.2-2.6-1.4-2.6-2.9c0-1.7-1.4-3-3.1-2.9c-0.9,0.1-1.9,0.1-2.9,0.2c-0.9,0.1-1.8,0.1-2.7,0.2c-0.5,0-0.9,0.1-1.4,0.1c-0.6,0-1.2,0.1-1.7,0.1c-3.2,0.2-6.5,0.5-9.7,0.8c-1.9,0.2-3.8,0.3-5.6,0.5c-0.9,0.1-1.8,0.2-2.6,0.3c-3,0.3-5.8,0.7-7.9,1.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.6,0.1-1.1,0.2-1.6,0.3l-0.1-9.4v-0.1c0-1.1,0.7-2.1,1.6-2.5c0.2-0.1,0.4-0.2,0.6-0.3c1.9-0.9,4.7-1.9,8.3-3.1c3.8-1.2,8.3-2.5,13.1-3.7c0.1,0,0.2,0,0.3-0.1c0.9-0.2,1.8-0.4,2.7-0.6c3.4-0.8,6.9-1.5,10.4-2c0.2,0,0.4-0.1,0.6-0.1c1.4-0.2,2.5-1.4,2.5-2.9c0,0,0,0,0,0v-0.2c0-1.6,1.3-2.9,2.9-2.9c-1.2-0.1-2.2-0.2-2.9-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.7,0.1c-0.4,0-0.9,0.1-1.4,0.1c-0.3,0-0.5,0-0.8,0c-0.3,0-0.6,0-0.9,0.1c-0.6,0-1.2,0.1-1.9,0.1c-0.3,0-0.7,0-1,0.1c-0.3,0-0.7,0-1.1,0.1h0c-0.6,0-1.2,0.1-1.8,0.1c-2.1,0.1-4.2,0.2-5.9,0.3c-0.4,0-0.8,0.1-1.2,0.1c-0.2,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.7,0.1-1.3,0.1-1.6,0.2v-15c0-1.7,1.4-3,3.1-2.9h0.1c0.4,0,0.8,0.1,1.3,0.1c0.7,0,1.4,0.1,2.2,0.2c0.4,0,0.9,0.1,1.4,0.1c0.1,0,0.2,0,0.3,0c0.5,0,0.9,0,1.4,0.1c0.6,0,1.2,0.1,1.8,0.1c0.6,0,1.2,0.1,1.7,0.1c0.1,0,0.2,0,0.3,0c1,0.1,1.9,0.1,2.7,0.2c0,0,0,0,0.1,0c1.4,0.1,2.5,0.2,3.1,0.3V171c0-1.3-1-2.5-2.2-2.8c-0.3,0-0.5-0.1-0.7-0.2c-0.8-0.2-1.7-0.4-2.5-0.6c-0.2-0.1-0.4-0.1-0.7-0.2c-0.9-0.3-1.7-0.5-2.5-0.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.6-0.6-2.3-0.9c-0.9-0.4-1.8-0.8-2.7-1.2c-2.5-1.2-4.8-2.5-7-4.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.8-0.5-1.5-1.1-2.3-1.7c-0.8-0.6-1.5-1.2-2.2-1.9c-0.7-0.6-1.5-1.3-2.2-2c-2.1-2.1-4.1-4.3-5.9-6.7c-0.6-0.8-1.2-1.6-1.8-2.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.5-0.7-1-1.5-1.5-2.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.7-0.9-1.4-1.3-2.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.5-0.8-0.9-1.6-1.3-2.4c-0.2-0.4-0.4-0.7-0.6-1.1c-0.4-0.7-0.7-1.4-1.1-2.1c-0.5-1-1-2-1.4-3.1c-1-2.3-1.9-4.6-2.8-7.1c-0.4-1-0.7-2.1-1-3.1c-0.3-1-0.7-2.1-1-3.2c-0.7-2.4-1.3-4.8-1.9-7.3c-0.3-1.2-0.6-2.4-0.8-3.6c-0.3-1.4-0.6-2.8-0.8-4.2c-0.1-0.8-0.3-1.5-0.4-2.2c-0.1-0.8-0.3-1.5-0.4-2.3c-0.2-1.1-0.3-2.3-0.5-3.5c-0.1-0.9-0.2-1.9-0.3-2.9c-0.1-0.7-0.2-1.4-0.2-2c-0.1-1.3-0.3-2.5-0.4-3.8c-0.1-0.9-0.1-1.8-0.2-2.8c-0.1-1-0.2-2.1-0.2-3.2c0-0.1,0-0.1,0-0.1c-0.1-1.7-0.2-3.4-0.3-5.2c0-0.1,0-0.3,0-0.4c0-1.6-0.1-3.3-0.1-4.9c0-1.8-0.1-3.6-0.1-5.4v-49c0-1.6,1.3-2.9,2.9-2.9H128h3.5c-1.6,0-2.9-1.3-2.9-2.9c0-0.7-0.2-1.3-0.6-1.7V5.9H49.1c-3.2,0-5.8,2.6-5.8,5.8v52c0,1.6,0,3.1,0.1,4.7c0,1.4,0.1,2.8,0.1,4.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0,0.4c0.1,1.1,0.1,2.2,0.2,3.2l0.1,1.4c0,0.7,0.1,1.4,0.1,2c0.1,0.8,0.1,1.6,0.2,2.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.2,0.1,0.4,0.1,0.6c0,0.6,0.1,1.1,0.2,1.6c0.1,0.5,0.1,1.1,0.2,1.6c0.1,0.6,0.2,1.2,0.3,1.8c0.1,0.6,0.1,1.2,0.2,1.8c0,0.2,0.1,0.4,0.1,0.7c0.1,1,0.3,2.1,0.5,3c0,0.2,0.1,0.4,0.1,0.7c0.2,1.1,0.4,2.1,0.6,3.2c0,0.1,0,0.3,0.1,0.4c0.2,0.9,0.3,1.7,0.5,2.6c0,0.1,0,0.1,0,0.2c0.2,0.7,0.3,1.4,0.5,2.2c0.1,0.5,0.2,0.9,0.3,1.4c0.1,0.5,0.2,0.9,0.3,1.4c0.3,1.1,0.6,2.2,0.9,3.3c0.3,1.2,0.7,2.3,1,3.5c0.4,1.2,0.8,2.3,1.2,3.4c0.4,1,0.7,2,1.1,2.9c5.3,13.7,14.4,26.2,17.3,29.4c7.1,8,20,17.8,31.6,22.1c1.1,0.4,1.9,1.5,1.9,2.7v17.4c0,1.3-0.8,2.4-2,2.8c-12.1,4.1-17.5,9.9-17.8,10.3c-0.5,0.5-0.8,1.2-0.8,2l0.1,11.7c0,1.3-0.8,2.4-2,2.8c-10.6,3.4-15.5,6.9-15.9,7.2c-0.7,0.5-1.2,1.4-1.2,2.3l0.1,17.5c0,1.1,0.6,2.1,1.6,2.6c0.4,0.2,0.9,0.3,1.3,0.3h58.7c0.4,0,0.9-0.1,1.2-0.3C127.6,249.4,128.2,248.4,128.2,247.3z"/><polygon style="fill:#FFFB00 !important;" points="74.1,57.8 101.1,83.3 87.4,127.7 128,108.5 128,20 114.2,57.8 "/></g></symbol><symbol id="icon-learn-cup-detailed" viewBox="0 0 256 256"><g><path style="fill:#FFD700 !important;" d="M212.1,64.1c0,1.6,0,3.1-0.1,4.7c0,1.5-0.1,2.9-0.1,4.3c0,0.4,0,0.7-0.1,1.1c0,1-0.1,2.1-0.2,3.1c0,0.3,0,0.6-0.1,1c-0.1,1.3-0.2,2.7-0.3,4c-0.4,4.2-0.9,8.2-1.6,12c-0.1,0.4-0.2,0.9-0.3,1.3c-0.2,1-0.4,2.1-0.6,3.1c-0.2,1.1-0.5,2.2-0.7,3.2c-0.2,0.9-0.4,1.7-0.6,2.5c0,0.2-0.1,0.3-0.1,0.4c-0.2,0.8-0.4,1.6-0.6,2.3c-0.3,1.1-0.6,2.1-0.9,3.2c-0.3,1-0.6,2-0.9,3c-0.2,0.7-0.5,1.4-0.7,2.1c-0.2,0.5-0.3,1-0.6,1.6c-0.3,1-0.7,1.9-1.1,2.9c-2.9,7.6-8.9,19.2-17.5,29.2c-8.1,9.4-17.9,16-28.1,20.3c-1.1,0.5-1.8,1.5-1.8,2.7v18.8c0,1.2,0.8,2.3,2,2.8c11.2,3.9,16.2,9.1,16.6,9.4c0.5,0.5,0.8,1.2,0.8,2v12.3c0,1.3,0.8,2.4,2,2.8c10.8,3.5,15.8,7.1,16.2,7.4c0.7,0.5,1.1,1.4,1.1,2.3v14.4c0,2.6-1.6,4.7-3.9,5.5c-0.6,0.2-1.2,0.3-1.9,0.3H66.1c-0.5,0-0.9-0.1-1.3-0.3c-0.9-0.4-1.6-1.4-1.6-2.6l-0.1-17.5c0-0.9,0.4-1.8,1.2-2.3c0.4-0.3,5.3-3.8,15.9-7.2c1.2-0.4,2-1.5,2-2.8l-0.1-11.7c0-0.7,0.3-1.4,0.8-2c0.3-0.4,5.7-6.1,17.8-10.3c1.2-0.4,2-1.5,2-2.8v-17.4c0-1.2-0.8-2.3-1.9-2.7c-11.6-4.3-24.5-14.1-31.6-22.1c-2.9-3.2-12.1-15.7-17.3-29.4c-0.4-0.9-0.7-1.9-1.1-2.9c-0.4-1.1-0.8-2.3-1.2-3.4c-0.4-1.2-0.7-2.3-1-3.5c-0.3-1.1-0.6-2.2-0.9-3.3c-0.1-0.4-0.2-0.9-0.3-1.4c-0.1-0.4-0.2-0.9-0.3-1.4c-0.2-0.7-0.3-1.4-0.5-2.2c0-0.1,0-0.1,0-0.2c-0.2-0.9-0.3-1.7-0.5-2.6c0-0.1-0.1-0.3-0.1-0.4c-0.2-1-0.4-2.1-0.6-3.2c-0.1-0.2-0.1-0.4-0.1-0.7c-0.2-1-0.4-2-0.5-3c-0.1-0.2-0.1-0.4-0.1-0.7c-0.1-0.6-0.2-1.2-0.2-1.8c-0.1-0.6-0.2-1.2-0.3-1.8c-0.1-0.5-0.1-1.1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c-0.1-0.8-0.1-1.6-0.2-2.3c0-0.7-0.1-1.3-0.1-2l-0.1-1.4c-0.1-1.1-0.1-2.2-0.2-3.2c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3s0-0.2,0-0.3c0-1.4-0.1-2.7-0.1-4.1c0-1.6-0.1-3.1-0.1-4.7V11.7c0-3.2,2.6-5.8,5.8-5.8h160.6c1.6,0,2.9,1.3,2.9,2.9l0,17.4l0,23.2v0.1L212.1,64.1z"/><path style="fill:#FFFB00 !important;" d="M127.6,247.3l0-0.2c0.1-1.6,1.3-2.8,2.9-2.8H71.8c-1.6,0-2.8-1.3-2.9-2.8v-0.1l0-8.2v-0.1c0-1.2,0.8-2.2,1.9-2.6c0.3-0.1,0.5-0.2,0.8-0.3c0.5-0.2,1.1-0.4,1.7-0.6c1-0.3,2.1-0.7,3.3-1c0.4-0.1,0.8-0.3,1.3-0.4c0.4-0.1,0.9-0.3,1.4-0.4c0.5-0.2,1-0.3,1.6-0.4c0.4-0.1,0.9-0.2,1.3-0.3c0.2-0.1,0.4-0.1,0.6-0.2c0.8-0.2,1.7-0.4,2.6-0.6c1.1-0.3,2.2-0.5,3.4-0.8c0.1,0,0.3-0.1,0.4-0.1c0.7-0.2,1.3-0.3,2-0.4c1-0.2,2.1-0.4,3.2-0.7c0.3-0.1,0.7-0.1,1.1-0.2c0.9-0.2,1.9-0.4,2.9-0.5c5.4-1,11.4-1.9,17.6-2.6c0.8-0.1,1.6-0.2,2.3-0.3c1.4-0.2,2.8-0.3,4.2-0.4c0.9-0.1,1.8-0.2,2.7-0.2c0.9-0.1,1.8-0.1,2.7-0.2v-0.1c0.1,0,0.2,0,0.2,0c0.9,0,1.7,0.1,2.6,0.2c-1.5-0.2-2.6-1.4-2.6-2.9c0-1.7-1.4-3-3.1-2.9c-0.9,0.1-1.9,0.1-2.9,0.2c-0.9,0.1-1.8,0.1-2.7,0.2c-0.4,0-0.9,0.1-1.4,0.1c-0.6,0-1.2,0.1-1.7,0.1c-3.2,0.2-6.5,0.5-9.7,0.8c-1.9,0.2-3.8,0.3-5.6,0.5c-0.9,0.1-1.8,0.2-2.6,0.3c-3,0.3-5.8,0.7-7.9,1.1c-0.3,0.1-0.5,0.1-0.8,0.2c-0.6,0.1-1.1,0.2-1.6,0.3l0-9.4v-0.1c0-1.1,0.7-2.1,1.6-2.5c0.2-0.1,0.4-0.2,0.6-0.3c1.9-0.9,4.8-1.9,8.3-3.1c3.8-1.2,8.3-2.5,13.1-3.7c0.1,0,0.2,0,0.3-0.1c0.9-0.2,1.8-0.4,2.7-0.6c3.4-0.8,7-1.5,10.4-2c0.2,0,0.4-0.1,0.5-0.1c1.4-0.2,2.5-1.4,2.5-2.9v-0.2c0-1.6,1.3-2.9,2.9-2.9c-1.2-0.1-2.2-0.2-2.9-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.7,0.1c-0.4,0-0.9,0.1-1.4,0.1c-0.3,0-0.5,0-0.8,0c-0.3,0-0.6,0-0.9,0.1c-0.6,0-1.2,0.1-1.9,0.1c-0.3,0-0.7,0-1,0.1c-0.3,0-0.7,0-1.1,0.1h0c-0.6,0-1.2,0.1-1.8,0.1c-2.1,0.1-4.2,0.2-5.9,0.3c-0.4,0-0.8,0.1-1.2,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.7,0.1-1.3,0.1-1.6,0.2v-15c0-1.7,1.4-3,3.1-2.9h0.1c0.4,0,0.8,0.1,1.2,0.1c0.7,0,1.4,0.1,2.2,0.2c0.4,0,0.9,0.1,1.4,0.1c0.1,0,0.2,0,0.3,0c0.5,0,0.9,0,1.4,0.1c0.6,0,1.2,0.1,1.8,0.1c0.6,0,1.1,0.1,1.7,0.1c0.1,0,0.2,0,0.3,0c1,0.1,1.9,0.1,2.7,0.2c0,0,0,0,0,0c1.4,0.1,2.5,0.2,3.1,0.3V171c0-1.3-1-2.5-2.3-2.8c-0.3,0-0.5-0.1-0.7-0.2c-0.8-0.2-1.6-0.4-2.5-0.6c-0.2-0.1-0.5-0.1-0.7-0.2c-0.9-0.3-1.7-0.5-2.5-0.8c-0.1-0.1-0.3-0.1-0.4-0.2c-0.8-0.3-1.6-0.6-2.3-0.9c-0.9-0.4-1.8-0.8-2.7-1.2c-2.5-1.2-4.8-2.5-7.1-4.1c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2l21.9-10.4V95.2l-8.4,23.1l-24.5,0l16.5,15.5l-7.5,24.3c-0.7-0.6-1.5-1.2-2.2-1.8c-0.7-0.6-1.5-1.3-2.2-2c-2.1-2.1-4.1-4.3-5.9-6.7c-0.6-0.8-1.2-1.6-1.8-2.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.5-0.7-1-1.5-1.5-2.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.4-0.7-0.9-1.4-1.3-2.2c-0.1-0.1-0.1-0.1-0.1-0.2c-0.4-0.8-0.9-1.6-1.3-2.4c-0.2-0.4-0.4-0.7-0.6-1.1c-0.4-0.7-0.7-1.4-1.1-2.1c-0.5-1-1-2-1.4-3.1c-1-2.3-1.9-4.6-2.8-7.1c-0.4-1-0.7-2.1-1-3.1c-0.3-1-0.7-2.1-1-3.2c-0.7-2.4-1.3-4.8-1.9-7.3c-0.3-1.2-0.6-2.4-0.8-3.6c-0.3-1.4-0.6-2.8-0.8-4.2c-0.1-0.8-0.3-1.5-0.4-2.2c-0.1-0.8-0.3-1.5-0.4-2.3c-0.2-1.1-0.3-2.3-0.5-3.5c-0.1-0.9-0.3-1.9-0.3-2.9c-0.1-0.7-0.2-1.4-0.2-2c-0.1-1.3-0.3-2.5-0.4-3.8c-0.1-0.9-0.2-1.8-0.2-2.8c-0.1-1-0.2-2.1-0.2-3.2c0-0.1,0-0.1,0-0.1c-0.1-1.7-0.2-3.4-0.3-5.2c0-0.1,0-0.3,0-0.4c-0.1-1.6-0.1-3.3-0.1-4.9c0-1.8-0.1-3.6-0.1-5.4v-49c0-1.6,1.3-2.9,2.9-2.9H112v67.5l15.5,15.5h0.4V8.8c0-1.6-1.3-2.9-2.9-2.9H48.5c-3.2,0-5.8,2.6-5.8,5.8v14.5c0,1.6-1.3,2.9-2.9,2.9H11.6C5.2,29.2,0,34.4,0,40.8v22.9C0,117,28.5,139,67.7,147.6c0.6,0.1,1.1,0.4,1.6,0.9c9.1,10.5,20,17.8,31.6,22.1c1.1,0.4,1.9,1.5,1.9,2.7v17.4c0,1.3-0.8,2.4-2,2.8c-12.1,4.1-17.5,9.9-17.8,10.3c-0.5,0.5-0.8,1.2-0.8,2l0,11.7c0,1.3-0.8,2.4-2,2.8c-10.6,3.4-15.5,6.9-15.9,7.2c-0.7,0.5-1.2,1.4-1.2,2.3l0.1,17.5c0,1.1,0.7,2.1,1.6,2.6c0.4,0.2,0.8,0.3,1.3,0.3h58.7c0.4,0,0.9-0.1,1.2-0.3C126.9,249.4,127.5,248.4,127.6,247.3zM48.2,122.8c-0.1-0.1-0.2-0.1-0.3-0.2c-1.3-0.7-2.6-1.4-3.8-2.2c-1.2-0.8-2.4-1.5-3.5-2.4c-0.6-0.4-1.1-0.8-1.6-1.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.4-0.3-0.8-0.6-1.2-0.9c-0.2-0.2-0.3-0.3-0.5-0.5c-0.4-0.3-0.7-0.6-1.1-0.9c-0.6-0.5-1.2-1.1-1.7-1.6c-0.2-0.2-0.5-0.5-0.7-0.7c-0.3-0.3-0.6-0.7-0.9-1c-0.5-0.5-1-1.1-1.4-1.6c-0.4-0.5-0.9-1.1-1.3-1.6c-0.2-0.3-0.4-0.5-0.6-0.8c-0.2-0.3-0.4-0.6-0.6-0.9c-0.4-0.6-0.8-1.2-1.2-1.7c-0.4-0.6-0.8-1.2-1.1-1.8c-0.3-0.5-0.6-1-0.9-1.6c-0.3-0.6-0.6-1.2-0.9-1.8c-0.3-0.5-0.5-1-0.8-1.6v0c-0.3-0.5-0.5-1.1-0.7-1.6c-0.2-0.5-0.4-1-0.6-1.6c-0.3-0.9-0.6-1.7-0.9-2.6c-0.3-0.9-0.6-1.8-0.8-2.7c-0.2-0.8-0.4-1.6-0.6-2.5c-0.2-0.7-0.3-1.3-0.4-2c-0.1-0.5-0.2-1-0.3-1.5c-0.1-0.6-0.2-1.2-0.3-1.8c-0.1-0.7-0.3-1.5-0.3-2.3c-0.1-0.6-0.2-1.2-0.3-1.9c0-0.1,0-0.2,0-0.2c-0.1-0.7-0.2-1.5-0.2-2.2c-0.1-0.6-0.1-1.1-0.2-1.7c-0.1-1-0.1-2-0.2-3c0-0.6-0.1-1.3-0.1-1.9v-0.3c0-0.5,0-1.1-0.1-1.7c0-0.8,0-1.6,0-2.3V49.5c0-1.6,1.3-2.9,2.9-2.9h19.4c1.6,0,2.9,1.3,2.9,2.9v14.1c0,1.6,0,3.1,0.1,4.7c0,1.4,0.1,2.8,0.1,4.1c0,0.1,0,0.2,0,0.3s0,0.2,0,0.3c0,0.1,0,0.3,0,0.4c0,1.1,0.1,2.2,0.2,3.2l0.1,1.4c0,0.7,0.1,1.4,0.2,2c0.1,0.8,0.1,1.6,0.2,2.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.1,1.1,0.2,1.6c0.1,0.5,0.1,1.1,0.2,1.6c0.1,0.6,0.2,1.2,0.2,1.8c0.1,0.6,0.2,1.2,0.3,1.8c0,0.2,0.1,0.4,0.1,0.7c0.2,1,0.3,2.1,0.5,3c0,0.2,0.1,0.4,0.1,0.7c0.2,1.1,0.4,2.1,0.6,3.2c0,0.1,0,0.3,0.1,0.4c0.2,0.9,0.3,1.7,0.5,2.6c0,0.1,0,0.1,0,0.2c0.2,0.7,0.3,1.4,0.5,2.2c0.1,0.5,0.2,0.9,0.3,1.4c0.1,0.5,0.2,0.9,0.3,1.4c0.3,1.1,0.6,2.2,0.9,3.3c0.3,1.2,0.7,2.3,1.1,3.5c0.4,1.2,0.8,2.3,1.2,3.4c0.3,1,0.7,2,1.1,2.9C52.8,121.4,50.4,123.7,48.2,122.8z"/><path style="fill:#ff9f28 !important;" d="M255.9,37.9c0-4.8-3.9-8.7-8.7-8.7h-32.3c-1.6,0-2.9-1.3-2.9-2.9l0-17.4c0-1.6-1.3-2.9-2.9-2.9h-81.1v2.9v85.8h0.4l15.5-15.5V11.7h36.5v52.4c0,5.3-0.1,10.6-0.4,15.8c-0.2,3-0.4,5.9-0.7,8.8c-0.5,5.7-1.3,11.2-2.3,16.4c-0.1,0.6-0.2,1.2-0.3,1.7c-0.2,0.9-0.4,1.9-0.6,2.8c-0.3,1.6-0.7,3.3-1.1,4.9c-0.2,0.8-0.4,1.6-0.6,2.4c-0.6,2.3-1.3,4.5-2,6.7c-0.3,0.8-0.5,1.6-0.8,2.4c-0.3,0.8-0.6,1.6-0.9,2.4c-0.3,0.9-0.7,1.8-1,2.6c-0.4,0.9-0.8,1.8-1.2,2.7c-0.2,0.6-0.5,1.1-0.8,1.7c-0.2,0.4-0.3,0.8-0.5,1.1c-0.3,0.6-0.6,1.2-0.9,1.8c-0.2,0.5-0.5,1-0.8,1.5c-0.3,0.6-0.7,1.2-1,1.8c-0.2,0.3-0.4,0.7-0.6,1c-1.3,2.2-2.7,4.2-4.2,6.1c-0.4,0.6-0.9,1.2-1.4,1.8c-2,2.4-4.1,4.7-6.4,6.6c0,0-0.1,0.1-0.1,0.1l-7-23.5l16.3-15.4l-24.7,0L128,95.1l0,0.1v54.1l0,0l21.1,10c-0.3,0.2-0.5,0.4-0.8,0.6c-0.6,0.5-1.3,0.9-2,1.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.6,0.4-1.2,0.8-1.9,1.1c-0.7,0.4-1.5,0.8-2.2,1.2c-0.3,0.2-0.6,0.3-0.9,0.4c0,0-0.1,0-0.2,0.1c-0.7,0.3-1.4,0.7-2.2,1c-0.6,0.3-1.2,0.5-1.9,0.8c-0.3,0.1-0.7,0.3-1,0.4c-0.8,0.3-1.7,0.6-2.5,0.8c-0.9,0.3-1.9,0.5-2.9,0.8c0,0,0,0,0,0c-0.7,0.2-1.5,0.3-2.2,0.5v2.3v3.6c0.1,0,0.2,0,0.3-0.1c1.9-0.2,6.1-0.6,10.4-1c0.6-0.1,1.1-0.1,1.7-0.2c1.1-0.1,2.1-0.2,3.1-0.3c0.9-0.1,1.8-0.2,2.5-0.3c1.7-0.2,3.3,1.1,3.3,2.9v12.6c0,1.6-1.3,2.9-2.9,2.9c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9-0.1c-0.5,0-0.9-0.1-1.5-0.1c-0.1,0-0.1,0-0.2,0c-0.4,0-0.9-0.1-1.4-0.1c-0.6,0-1.2-0.1-1.8-0.1c-0.8-0.1-1.6-0.1-2.4-0.1c-2.5-0.1-5-0.3-7-0.4h-0.2c-1.6,0-2.9,1.3-2.9,2.9v0.2v2.5c0.8,0.1,1.7,0.2,2.5,0.3h0c0.8,0.1,1.6,0.2,2.4,0.3c2.2,0.4,4.5,0.8,6.7,1.2c1.6,0.3,3.1,0.6,4.6,1c0.9,0.2,1.9,0.4,2.8,0.6c0.8,0.2,1.6,0.4,2.3,0.6c0.1,0,0.2,0.1,0.3,0.1c0.9,0.2,1.7,0.4,2.5,0.7c0.1,0,0.2,0,0.3,0.1c2,0.5,3.8,1,5.5,1.6h0c0.7,0.2,1.4,0.4,2,0.6c1,0.3,1.9,0.6,2.8,0.9c0.5,0.2,1,0.3,1.4,0.5c0.8,0.3,1.4,0.5,2,0.8c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.1,0.4,0.2c0.8,0.5,1.3,1.5,1.3,2.4v6.4c0,1.8-1.6,3.2-3.4,2.8c-2.7-0.4-6-0.9-9.7-1.2c-1.9-0.2-3.9-0.4-6-0.6c-0.4,0-0.8-0.1-1.3-0.1c-2.4-0.2-4.8-0.4-7.2-0.6c-0.2,0-0.3,0-0.5,0c-0.6,0-1.2-0.1-1.8-0.1l-1-0.1c-1.1-0.1-2.2-0.2-3.3-0.2c-2.3-0.1-4.6-0.3-6.5-0.4v0v3.1c0,1.5,1.1,2.7,2.6,2.9c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c1.7,0.1,3.4,0.3,5.1,0.4c2.6,0.2,5.3,0.5,7.8,0.8c1.5,0.2,3,0.4,4.5,0.6c1.6,0.2,3.1,0.4,4.7,0.7c2.3,0.4,4.5,0.8,6.6,1.2c0.7,0.1,1.4,0.3,2.1,0.4c2.8,0.5,5.4,1.1,7.9,1.7c0.6,0.1,1.2,0.3,1.8,0.4c1.2,0.3,2.3,0.6,3.4,0.8c0.9,0.2,1.8,0.5,2.6,0.7c3.1,0.9,5.7,1.7,7.7,2.4c0.5,0.2,1,0.4,1.5,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.2,0.8,0.3,1.1,0.5c0.2,0.1,0.3,0.2,0.4,0.3v9.9c0,1.6-1.3,2.9-2.9,2.9h-54.6c-1.6,0-2.8,1.2-2.9,2.8l0,0.2c0,1.1-0.7,2-1.6,2.5c-0.4,0.2-0.8,0.3-1.2,0.3H188c0.7,0,1.3-0.1,1.9-0.3c2.3-0.8,3.9-2.9,3.9-5.5v-14.4c0-0.9-0.4-1.8-1.2-2.3c-0.4-0.3-5.4-3.9-16.2-7.4c-1.2-0.4-2-1.5-2-2.8v-12.3c0-0.8-0.3-1.5-0.8-2c-0.3-0.3-5.3-5.5-16.6-9.4c-1.2-0.4-2-1.5-2-2.8v-18.8c0-1.2,0.7-2.2,1.8-2.7c10.3-4.3,19.9-11,28.1-20.3c0.4-0.5,1-0.8,1.6-0.9c10.7-2.1,20.8-5.3,29.7-9.8c26.8-13.7,39.8-37.9,39.8-74c0,0,0,0,0,0L255.9,37.9zM238.4,70.1c0,0.7-0.1,1.5-0.1,2.2l-0.1,0.8c0,0.6-0.1,1.2-0.2,1.8c-0.1,1.3-0.3,2.5-0.4,3.7c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.6-0.2,1.3-0.3,1.9c-0.1,0.7-0.2,1.3-0.4,1.9c-0.1,0.5-0.2,1.1-0.4,1.6c-0.3,1.2-0.6,2.4-0.9,3.5c-0.5,1.6-1,3.2-1.6,4.7c-0.2,0.5-0.3,0.9-0.6,1.4c-0.5,1.2-1,2.4-1.5,3.5c-0.3,0.6-0.6,1.2-0.9,1.8c-0.3,0.5-0.5,1-0.8,1.5c-0.2,0.3-0.4,0.7-0.6,1c-0.7,1.2-1.5,2.3-2.2,3.4c-0.3,0.4-0.6,0.9-1,1.3c-0.7,0.9-1.4,1.8-2.2,2.7c-0.6,0.7-1.2,1.4-1.9,2c-0.9,0.9-1.8,1.7-2.7,2.5c-0.3,0.3-0.7,0.6-1.1,0.9c-0.4,0.3-0.8,0.7-1.3,1c-0.5,0.4-1,0.8-1.5,1.1c-0.5,0.4-1.1,0.8-1.7,1.1c-2.3,1.5-4.8,2.9-7.4,4.2c0,0-0.1,0-0.1,0c-2.3,1-4.8-1.3-3.9-3.7c0.4-0.9,0.7-1.9,1.1-2.9c0.2-0.5,0.4-1,0.5-1.6c0.3-0.7,0.5-1.4,0.7-2.1c0.3-1,0.6-2,0.9-3c0.3-1,0.6-2.1,0.9-3.2c0.2-0.8,0.4-1.6,0.6-2.3c0-0.1,0.1-0.3,0.1-0.4c0.2-0.8,0.4-1.7,0.6-2.5c0.2-1.1,0.5-2.2,0.7-3.2c0.2-1,0.4-2,0.6-3.1c0.1-0.4,0.2-0.8,0.3-1.3c0.7-3.9,1.2-7.9,1.6-12c0.1-1.3,0.3-2.6,0.3-4c0-0.3,0.1-0.6,0.1-1c0.1-1,0.1-2,0.2-3.1c0-0.3,0.1-0.7,0.1-1.1c0.1-1.4,0.1-2.9,0.2-4.3c0-1.6,0.1-3.1,0.1-4.7l0-14.6v-0.1c0-1.6,1.3-2.8,2.9-2.8h20.7c1.6,0,2.8,1.3,2.9,2.8v0.1l0.1,14.9C238.6,66.3,238.5,68.2,238.4,70.1z"/></g></symbol><symbol id="icon-learn-cup-empty-default" viewBox="0 0 256 256"><g><path class="st0" d="M142.4,183.4c22.9-4.7,41.8-20.3,50.9-41.2h0.3c3.1-7,5-14.6,5.7-22.6l0-12.1l0-15.1l-0.1-49.7V28.4c0-7.9-6.4-14.2-14.2-14.2H71.1c-7.9,0-14.2,6.4-14.2,14.2v92.8c0.8,7.4,2.7,14.4,5.5,21h0.5c9.1,20.9,28,36.6,50.9,41.2v0.4v29.5H99.6c-15.7,0-28.4,12.7-28.4,28.4H185c0-15.7-12.7-28.4-28.4-28.4h-14.2v-29.6V183.4zM128,156.5c-17,0-32.3-10.1-39.1-25.6l-3.6-8.2v-80h34h17.5h33.8l0,13.5l0.1,66.5l-3.6,8.2C160.3,146.5,145,156.5,128,156.5z"/></g></symbol><symbol id="icon-learn-cup-empty" viewBox="0 0 256 256"><path d="M241.8,42.7h-42.7V28.4c0-7.9-6.4-14.2-14.2-14.2H71.1c-7.9,0-14.2,6.4-14.2,14.2v14.2H14.2C6.4,42.7,0,49,0,56.9v28.4c0,22.9,15.2,56.9,56.9,56.9h6c9.1,20.9,28,36.6,50.9,41.2v29.9H99.6c-15.7,0-28.4,12.7-28.4,28.4h113.8c0-15.7-12.7-28.4-28.4-28.4h-14.2v-29.9c22.9-4.7,41.8-20.3,50.9-41.2h6c41.7,0,56.9-34,56.9-56.9V56.9C256,49,249.6,42.7,241.8,42.7zM56.9,113.8c-26,0-28.3-21.8-28.4-28.4V71.1h28.4V113.8zM170.7,122.7l-3.6,8.2c-6.8,15.6-22.1,25.6-39.1,25.6s-32.3-10.1-39.1-25.6l-3.6-8.2v-80h85.3L170.7,122.7L170.7,122.7zM227.6,85.3c0,4.8-1.4,28.4-28.4,28.4V71.1h28.4V85.3z"/></symbol><symbol id="icon-learn-cup" viewBox="0 0 256 256"><path d="M71.1,14.2c-7.8,0-14.2,6.4-14.2,14.2v14.2H14.2C6.4,42.7,0,49,0,56.9v28.4c0,22.9,15.2,56.9,56.9,56.9h6c9.1,20.9,28,36.6,50.9,41.2v29.9H99.6c-15.7,0-28.5,12.7-28.5,28.5H135V14.2H71.1zM56.9,113.8c-26,0-28.3-21.9-28.5-28.5V71.1h28.5V113.8z"/><path class="st0" style="fill:#FF9F28 !important" d="M241.8,42.7h-42.7V28.4c0-7.8-6.4-14.2-14.2-14.2H128v227.6h56.9c0-15.7-12.7-28.5-28.4-28.5h-14.2v-29.9c22.9-4.7,41.8-20.3,50.9-41.2h6c41.7,0,56.9-34,56.9-56.9V56.9C256,49,249.6,42.7,241.8,42.7zM227.6,85.3c0,4.8-1.4,28.5-28.5,28.5V71.1h28.5V85.3z"/></symbol><symbol id="icon-learn-medal" viewBox="0 0 256 256"><polygon points="184.5,182.9 142.1,183.0 128.1,143 113.6,182.8 71.5,182.8 99.8,209.5 85.5,256 128.1,235.8 170.4,256 156.5,209.3 "/><polygon points="128.7,142.3 139.4,131.6 139.4,0 116.9,0 116.9,131.9 127.3,142.3 "/><polygon points="113.8,0 100.8,0 100.8,115.7 113.8,128.8 "/><polygon points="155.3,0 142.2,0 142.2,128.8 155.3,115.7 "/></symbol><symbol id="icon-logo-android" viewBox="0 0 256 256"><path d="M224 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zM32 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm24 104c0 13.3 10.7 24 24 24h8v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h8c13.3 0 24-10.7 24-24V96H56v88zM157.7 22.4l10.1-19.5c.508-.975.1-2.2-.85-2.7s-2.2-.125-2.7.85l-10.3 19.7C145.9 17.7 137.2 16 128 16c-9.2 0-17.9 1.7-25.9 4.8L91.8 1.1c-.508-.976-1.7-1.4-2.7-.85s-1.4 1.7-.85 2.7l10.1 19.5C75.7 32.6 59.3 54.3 56.4 80h143.1c-2.8-25.7-19.2-47.4-41.9-57.6zM96 67.6c-6.4 0-11.6-5.2-11.6-11.6 0-6.4 5.2-11.6 11.6-11.6 6.4 0 11.6 5.2 11.6 11.6 0 6.4-5.2 11.6-11.6 11.6zm64 0c-6.4 0-11.6-5.2-11.6-11.6 0-6.4 5.2-11.6 11.6-11.6 6.4 0 11.6 5.2 11.6 11.6 0 6.4-5.2 11.6-11.6 11.6z"/></symbol><symbol id="icon-logo-apple" viewBox="0 0 256 256"><path d="M197.9 136.0c-.324-32.4 26.4-48.0 27.6-48.7-15.0-22.0-38.5-25.0-46.8-25.4-19.9-2.0-38.9 11.7-49.0 11.7-10.1 0-25.7-11.4-42.2-11.1-21.7.323-41.8 12.6-53.0 32.1-22.6 39.2-5.8 97.2 16.2 129.0 10.8 15.6 23.6 33.0 40.4 32.4 16.2-.647 22.3-10.5 41.9-10.5 19.6 0 25.1 10.5 42.3 10.2 17.4-.324 28.5-15.8 39.2-31.4 12.3-18.0 17.4-35.5 17.7-36.4-.387-.178-34.0-13.1-34.4-51.8zM165.6 40.9c8.9-10.8 15.0-25.9 13.3-40.9-12.9.524-28.5 8.6-37.7 19.4-8.3 9.6-15.5 24.9-13.6 39.6 14.4 1.1 29.0-7.3 38.0-18.1z"/></symbol><symbol id="icon-logo-cc" viewBox="0 0 256 256"><path d="M129.7 162.7c-8.6 0-15.2-3.2-19.6-9.5-4.5-6.3-6.7-14.7-6.7-25.2 0-23.1 8.8-34.7 26.3-34.7 3.5 0 7.3 1.2 11.4 3.5 4.1 2.3 7.5 6.4 10.3 12.3L177.6 95.4c-10.5-18.9-27.9-28.4-52.2-28.4-16.6 0-30.3 5.5-41.1 16.5C73.4 94.5 68 109.3 68 128.0c0 19.1 5.4 34.1 16.1 44.9 10.7 10.7 24.9 16.1 42.4 16.1 11.0 0 21.0-2.8 30.1-8.3 9.1-5.5 16.2-13.0 21.4-22.6l-24.2-12.3c-4.7 11.2-12.7 16.8-24.2 16.8zM256.0 126.3C255.0 55.6 196.9-.928 126.3.02 55.6.964-.936 59.0.01 129.7.96 200.4 59.0 256.9 129.7 256.0c70.7-.932 127.2-59.0 126.3-129.7zM129.3 229.0c-55.8.76-101.7-43.9-102.4-99.7-.747-55.8 43.9-101.7 99.7-102.4 55.8-.746 101.6 43.9 102.4 99.7s-43.9 101.6-99.7 102.4z"/></symbol><symbol id="icon-logo-facebook" viewBox="0 0 256 256"><path d="M148.1 256H100.2V128h-32V83.9l32-.015-.052-26.0c0-36.0 9.8-57.9 52.1-57.9h35.3v44.1h-22.1c-16.5 0-17.3 6.2-17.3 17.7l-.066 22.1h39.7l-4.7 44.1-35.0.015-.032 128z"/></symbol><symbol id="icon-logo-github" viewBox="0 0 256 256"><path d="M128 0C57.3 0 0 57.3 0 128s57.3 128 128 128 128-57.3 128-128S198.7 0 128 0zm76.0 204.0c-9.9 9.9-21.4 17.6-34.2 23.0-3.3 1.4-6.6 2.6-9.9 3.6V211.5c0-10.1-3.5-17.5-10.4-22.3 4.3-.416 8.3-1 11.9-1.8s7.5-1.8 11.5-3.3c4.0-1.4 7.7-3.1 10.9-5.1 3.2-2.0 6.3-4.5 9.3-7.6 3.0-3.1 5.4-6.7 7.4-10.6s3.6-8.7 4.8-14.3c1.2-5.5 1.8-11.6 1.8-18.3 0-12.9-4.2-23.9-12.6-33 3.8-10 3.4-20.9-1.3-32.6l-3.1-.376c-2.2-.25-6.1.667-11.7 2.8s-11.9 5.5-18.9 10.3c-9.9-2.8-20.2-4.1-30.9-4.1-10.8 0-21 1.4-30.8 4.1-4.4-3-8.6-5.5-12.6-7.4s-7.1-3.3-9.5-4-4.6-1.1-6.6-1.3-3.4-.208-3.9-.125-1 .167-1.3.25c-4.7 11.8-5.1 22.7-1.3 32.6-8.4 9.1-12.6 20.1-12.6 33 0 6.7.583 12.8 1.8 18.3s2.8 10.3 4.8 14.3 4.5 7.5 7.4 10.6 6.0 5.7 9.3 7.6 6.8 3.6 10.9 5.1 7.9 2.5 11.5 3.3 7.6 1.3 11.9 1.8c-6.8 4.7-10.3 12.1-10.3 22.3v19.6c-3.8-1.1-7.5-2.5-11.2-4.0-12.8-5.4-24.3-13.2-34.2-23.0-9.9-9.9-17.6-21.4-23.0-34.2-5.6-13.2-8.4-27.3-8.4-41.8s2.8-28.6 8.4-41.8c5.4-12.8 13.2-24.3 23.0-34.2 9.9-9.9 21.4-17.6 34.2-23.0 13.2-5.6 27.3-8.4 41.8-8.4s28.6 2.8 41.8 8.4c12.8 5.4 24.3 13.2 34.2 23.0 9.9 9.9 17.6 21.4 23.0 34.2 5.6 13.2 8.4 27.3 8.4 41.8s-2.8 28.6-8.4 41.8c-5.4 12.8-13.2 24.3-23.0 34.2z"/></symbol><symbol id="icon-logo-instagram" viewBox="0 0 256 256"><path d="M128.0 23.1c34.2 0 38.2.152 51.7.762 12.5.56 19.3 2.6 23.8 4.4 6.0 2.3 10.3 5.1 14.7 9.5 4.5 4.5 7.3 8.7 9.6 14.7 1.7 4.5 3.9 11.3 4.4 23.8.608 13.5.76 17.5.76 51.7 0 34.2-.15 38.2-.76 51.7-.56 12.5-2.6 19.3-4.4 23.8-2.3 6.0-5.1 10.3-9.6 14.7-4.5 4.5-8.7 7.3-14.7 9.6-4.5 1.7-11.3 3.9-23.8 4.4-13.5.608-17.5.76-51.7.76-34.2 0-38.2-.15-51.7-.76-12.5-.56-19.3-2.6-23.8-4.4-6.0-2.3-10.3-5.1-14.7-9.6-4.5-4.5-7.3-8.7-9.6-14.7-1.7-4.5-3.9-11.3-4.4-23.8-.61-13.5-.762-17.5-.762-51.7s.152-38.2.762-51.7c.56-12.5 2.6-19.3 4.4-23.8 2.3-6.0 5.1-10.3 9.5-14.7s8.7-7.3 14.7-9.6c4.5-1.7 11.3-3.9 23.8-4.4 13.5-.66 17.5-.76 51.7-.76m0-23.1c-34.7 0-39.1.152-52.8.762-13.6.61-22.9 2.8-31.0 5.9-8.4 3.3-15.5 7.7-22.7 14.8-7.1 7.1-11.5 14.3-14.8 22.7C3.6 52.3 1.4 61.6.76 75.3.152 88.9 0 93.2 0 128.0c0 34.7.152 39.1.762 52.8.61 13.6 2.8 22.9 5.9 31.1 3.3 8.4 7.7 15.5 14.8 22.7 7.1 7.1 14.3 11.5 22.7 14.8 8.1 3.1 17.4 5.3 31.1 5.9 13.7.61 18.0.762 52.8.762 34.8 0 39.1-.152 52.8-.762 13.6-.61 22.9-2.8 31.1-5.9 8.4-3.3 15.5-7.7 22.7-14.8 7.1-7.1 11.5-14.3 14.8-22.7 3.1-8.1 5.3-17.4 5.9-31.1s.763-18.0.763-52.8-.152-39.1-.762-52.8c-.61-13.6-2.8-22.9-5.9-31.1-3.3-8.4-7.7-15.5-14.8-22.7-7.1-7.1-14.3-11.5-22.7-14.8-8.1-3.1-17.4-5.3-31.1-5.9C167.1.177 162.7.025 128.0.025zM128.0 62.2c-36.3 0-65.7 29.4-65.7 65.7s29.5 65.7 65.7 65.7 65.7-29.5 65.7-65.7-29.5-65.7-65.7-65.7zm0 108.4c-23.6 0-42.7-19.1-42.7-42.7s19.1-42.7 42.7-42.7 42.7 19.1 42.7 42.7-19.1 42.7-42.7 42.7z"/><circle cx="196.3" cy="59.7" r="15.3"/></symbol><symbol id="icon-logo-windows" viewBox="0 0 256 256"><path d="M.093 119.5L0 36.2l102.4-13.9v97.1H.093zm119.4-99.6L256.0 0v119.5h-136.5V19.9zM256 136.5L256.0 256l-136.5-19.2V136.5H256zm-153.6 98.1L.083 220.6l-.005-84.1H102.4v98.1z"/></symbol><symbol id="icon-logo-x" viewBox="0 0 256 256"><path d="M151.8,108.4L245.1,0H223l-81,94.1L77.3,0H2.8l97.8,142.3L2.8,256h22.1l85.5-99.4l68.3,99.4h74.6L151.8,108.4L151.8,108.4zM121.6,143.6l-9.9-14.2L32.8,16.6h33.9l63.6,91l9.9,14.2L223,240.1h-33.9L121.6,143.6L121.6,143.6z"/></symbol><symbol id="icon-logo-youtube" viewBox="0 0 256 256"><path d="M208 32H48C21.6 32 0 53.6 0 80v96c0 26.4 21.6 48 48 48h160c26.4 0 48-21.6 48-48V80c0-26.4-21.6-48-48-48zM96 192V64l80 64-80 64z"/></symbol><symbol id="icon-logout" viewBox="0 0 256 256"><path d="M247.3,132.5c0,65.8-53.5,119.3-119.3,119.3S8.8,198.3,8.8,132.5C8.8,71.9,54.3,21.6,113,14.2V29.4C62.6,36.6,23.8,80.1,23.8,132.5c0,57.5,46.8,104.3,104.3,104.3c57.5,0,104.3-46.8,104.3-104.3c0-52.4-38.9-95.9-89.3-103.2V14.2C201.7,21.6,247.3,71.9,247.3,132.5z"/><path d="M128,142.5c-5.5,0-10-4.5-10-10V14.2c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10V132.5C138,138.1,133.5,142.5,128,142.5z"/></symbol><symbol id="icon-menu-academy" viewBox="0 0 256 256"><g><g><path d="M24,208v5c0,8.9,6,16.8,14.6,19.1l73.5,23.1c1.7,0.5,3.5,0.7,5.2,0.7c4.3,0,8.5-1.4,12-4.1c4.9-3.8,7.8-12.7,7.8-19v-2.2h75c10.9,0,19.8-8.9,19.8-19.8V44.7c0-11-8.9-19.9-19.8-19.9h-74.8v-2.2c0-6.2-2.8-14.7-7.7-18.5c-4.9-3.8-11.1-5-17.1-3.5L38.8,22.7C30.1,25,24,32.9,24,42v5.6M24.2,179.5V190M24.2,151v10.5M24.2,122.5V133M24.2,94v10.5M24.2,65.6V76M119.3,232.9c0,0.7-0.4,1.2-0.7,1.4c-0.3,0.3-0.9,0.5-1.6,0.3l-14.6-3.9l-58.9-15.8c-0.8-0.2-1.3-0.9-1.3-1.8V42c0-0.8,0.6-1.5,1.3-1.8L102,24.9l15-3.9c0.2,0,0.3-0.1,0.5-0.1c0.5,0,0.8,0.2,1.1,0.4c0.3,0.3,0.7,0.7,0.7,1.4V232.9zM137.3,190v-10.4h31.4c5,0,9-4,9-9s-4-9-9-9h-31.4v-10.5h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4v-10.4h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4V94.1h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4V65.6M137.3,47.6V43h74.9c1,0,1.8,0.8,1.8,1.8V211c0,1-0.8,1.8-1.8,1.8h-74.8v-4.6"/></g><path d="M59.1,103c-4.3,0-8.1-3.1-8.9-7.5c-0.8-4.9,2.4-9.6,7.3-10.4l40.5-7c4.9-0.8,9.6,2.4,10.4,7.3c0.8,4.9-2.4,9.6-7.3,10.4l-40.5,7C60.2,103,59.6,103,59.1,103z"/><path d="M59.1,127c-4.5,0-8.4-3.4-8.9-7.9c-0.6-4.9,3-9.4,7.9-10l25.5-3c4.9-0.6,9.4,3,10,7.9c0.6,4.9-3,9.4-7.9,10l-25.5,3C59.8,127,59.5,127,59.1,127z"/></g></symbol><symbol id="icon-menu-collection" viewBox="0 0 256 256"><path d="M229.7 38.5h-19.0l-1.9-9.4c-1.7-8.4-9.1-14.4-17.3-14.5-.12-.01-.234-.085-.355-.085-1.2 0-2.4.083-3.6.335l-22.4 4.6-4.0-8.8c-3.0-6.7-9.6-10.7-16.5-10.7-2.5 0-5.0.504-7.3 1.6L19.5 54.3c-9.1 4.1-13.2 14.8-9.1 23.9l72.5 162.4c1.3 8.7 8.8 15.9 17.9 15.9h128.9c10.0 0 17.8-9.2 17.8-19.1V56.0c0-10.0-7.8-17.4-17.8-17.4zM25.8 71.3c-.243-.553.0-1.3.6-1.6l20.4-9.1c.57.6.15 1.2.272 1.8L68.8 167.3 25.8 71.3zM82.5 56.0v95.4L63.5 58.9c-.065-.3.1-.59.3-.88.2-.282.5-.45.8-.517l18.3-3.8c-.94.7-.25 1.5-.25 2.2zm108.6-24.6c.084-.2.4-.27.4-.027s.873.6.994 1.2l1.2 5.9h-20.3l-1.2-2.9 18.9-4.2zm-46.9-14.4c.14-.67.3-.96.4-.96.3 0 .88.1 1.1.685l2.4 5.4-32.4 6.7 28.4-12.7zM230.5 237.4c0 .646-.138 2.1-.795 2.1H100.8c-.656 0-1.3-1.5-1.3-2.1V56.0c0-.646.6-.45 1.3-.45h129.0c.647 0 .673-.196.7.45v181.4zM215.5 82c0 4.1-3.4 7.5-7.5 7.5h-86c-4.1 0-7.5-3.4-7.5-7.5v-2c0-4.1 3.4-7.5 7.5-7.5h86c4.1 0 7.5 3.4 7.5 7.5v2zM215.5 113c0 4.1-3.4 7.5-7.5 7.5h-86c-4.1 0-7.5-3.4-7.5-7.5v-2c0-4.1 3.4-7.5 7.5-7.5h86c4.1 0 7.5 3.4 7.5 7.5v2zM215.5 145c0 4.1-3.4 7.5-7.5 7.5h-86c-4.1 0-7.5-3.4-7.5-7.5v-2c0-4.1 3.4-7.5 7.5-7.5h86c4.1 0 7.5 3.4 7.5 7.5v2zM187.5 177c0 4.1-3.4 7.5-7.5 7.5h-58c-4.1 0-7.5-3.4-7.5-7.5v-2c0-4.1 3.4-7.5 7.5-7.5h58c4.1 0 7.5 3.4 7.5 7.5v2z"/></symbol><symbol id="icon-menu-exam" viewBox="0 0 256 256"><g><path class="st0" d="M202.7,256H53.3c-12.9,0-23.5-10.5-23.5-23.5V23.5C29.8,10.5,40.3,0,53.3,0h149.5c12.9,0,23.5,10.5,23.5,23.5v209.1C226.2,245.5,215.7,256,202.7,256zM53.3,17.6c-3.2,0-5.9,2.6-5.9,5.9v209.1c0,3.2,2.6,5.9,5.9,5.9h149.5c3.2,0,5.9-2.6,5.9-5.9V23.5c0-3.2-2.6-5.9-5.9-5.9H53.3z"/><g><path class="st0" d="M192.5,46.4H63.5c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8S197.3,46.4,192.5,46.4z"/><path class="st0" d="M192.5,74.2H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8C201.3,70.3,197.3,74.2,192.5,74.2z"/><path class="st0" d="M192.5,102H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8C201.3,98.1,197.3,102,192.5,102z"/><path class="st0" d="M192.5,129.8H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8C201.3,125.9,197.3,129.8,192.5,129.8z"/><path class="st0" d="M192.5,157.7H63.5c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8h128.9c4.9,0,8.8,3.9,8.8,8.8S197.3,157.7,192.5,157.7z"/><path class="st0" d="M108.5,185.5H63.5c-4.9,0-8.8-3.9-8.8-8.8c0-4.9,3.9-8.8,8.8-8.8h44.9c4.9,0,8.8,3.9,8.8,8.8C117.2,181.5,113.3,185.5,108.5,185.5z"/></g><path class="st0" d="M163.2,228.1c-2.6,0-5-1.1-6.7-3.1L143,209.1c-3.1-3.7-2.7-9.2,1-12.4c3.7-3.1,9.2-2.7,12.4,1l6.6,7.8l21.2-26.3c3-3.8,8.6-4.4,12.4-1.3c3.8,3,4.4,8.6,1.3,12.4l-27.8,34.5c-1.6,2-4.1,3.2-6.7,3.3C163.3,228.1,163.3,228.1,163.2,228.1z"/></g></symbol><symbol id="icon-menu-exercisebook" viewBox="0 0 256 256"><g><path class="st0" d="M218.5,0.3H56c-12.3,0-22.3,10-22.3,22.3v3.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v5.3h-9.5c-5,0-9,4-9,9s4,9,9,9h9.5v3.3c0,12.3,10,22.3,22.3,22.3h162.5c12.3,0,22.3-10,22.3-22.3v-211C240.7,10.3,230.8,0.3,218.5,0.3zM222.7,233.4c0,2.3-1.9,4.3-4.3,4.3H56c-2.3,0-4.3-1.9-4.3-4.3v-3.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5V137h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-5.3h8.5c5,0,9-4,9-9s-4-9-9-9h-8.5v-3.3c0-2.3,1.9-4.3,4.3-4.3h162.5c2.3,0,4.3,1.9,4.3,4.3v210.9H222.7z"/><path class="st0" d="M197.5,62.1H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,62.1,197.5,62.1z"/><path class="st0" d="M197.5,119H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,119,197.5,119z"/><path class="st0" d="M197.5,175.9H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,175.9,197.5,175.9z"/><path class="st0" d="M197.5,33.7H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,33.7,197.5,33.7z"/><path class="st0" d="M197.5,90.6H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,90.6,197.5,90.6z"/><path class="st0" d="M197.5,147.4H85c-5,0-9,4-9,9s4,9,9,9h112.5c5,0,9-4,9-9S202.5,147.4,197.5,147.4z"/><path class="st0" d="M158.3,204.3H85c-5,0-9,4-9,9s4,9,9,9h73.3c5,0,9-4,9-9S163.2,204.3,158.3,204.3z"/></g></symbol><symbol id="icon-menu-group" viewBox="0 0 256 256"><g><path class="st0" d="M216.1,165.9c-4.9,0-9.6,0.9-13.9,2.5l-28.8-39.7c13.8-12.4,22.6-30.5,22.6-50.5c0-37.5-30.5-67.9-67.9-67.9S60.1,40.8,60.1,78.2c0,19.3,8.1,36.8,21.2,49.2L53,168.2c-4.1-1.4-8.5-2.2-13.1-2.2c-22,0-39.9,17.9-39.9,39.9s17.9,39.9,39.9,39.9c22,0,39.9-17.9,39.9-39.9c0-10.8-4.3-20.6-11.3-27.8l27.7-39.9c7,3.7,14.6,6.3,22.8,7.4V167c-17.6,4.2-30.7,20-30.7,38.8c0,22,17.9,39.9,39.9,39.9c22,0,39.9-17.9,39.9-39.9c0-18.8-13.1-34.7-30.7-38.8v-21.5c7.5-1,14.6-3.2,21.1-6.5l28.8,39.6c-6.7,7.1-10.7,16.7-10.7,27.2c0,22,17.9,39.9,39.9,39.9c22,0,39.9-17.9,39.9-39.9S238.1,165.9,216.1,165.9zM39.9,227.4c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6c11.9,0,21.6,9.7,21.6,21.6C61.4,217.7,51.8,227.4,39.9,227.4zM78.4,78.2c0-27.4,22.3-49.6,49.6-49.6c27.4,0,49.6,22.3,49.6,49.6c0,27.4-22.3,49.6-49.6,49.6C100.6,127.8,78.4,105.6,78.4,78.2zM149.6,205.8c0,11.9-9.7,21.6-21.6,21.6s-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6S149.6,193.9,149.6,205.8zM216.1,227.4c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6c11.9,0,21.6,9.7,21.6,21.6C237.7,217.7,228,227.4,216.1,227.4z"/></g></symbol><symbol id="icon-menu-how-to" viewBox="0 0 256 256"><path d="M126.1 17.5c9.6 0 18.5 1.4 26.2 4.0 7.4 2.6 13.8 6.2 19.1 10.8 5.1 4.5 9 9.7 11.9 16.0 2.9 6.3 4.2 13.2 4.2 21.3 0 10.2-3.1 18.9-9.6 26.5-7.0 8.3-18.9 15.4-35.2 21.0-7.1 2.4-12.0 9.0-12.2 16.5l-.056 1.9h-24.3V113.9c5.8-1.7 10.8-3.1 15.1-4.3 7.0-2.0 12.8-4.1 17.7-6.7 6.5-3.4 11.6-7.8 15.2-13.1 3.8-5.8 5.8-12.8 5.8-21.0 0-9.2-3.8-17.7-10.7-23.8-6.7-5.9-16.2-8.7-30.1-8.7-11.1 0-21.7 2.1-31.5 6.3-3.5 1.5-6.9 2.9-10.0 4.1l-6.3-17.4c2.3-1.1 4.9-2.2 8.0-3.1 6.1-2.0 12.3-3.6 18.5-4.9 6.4-1.3 12.3-2.3 17.7-2.9 7.0-.826 9.7-.916 10.5-.916m-6.6 176.6c3.0 0 5.7.52 8.1 1.6 2.7 1.2 5 2.8 7.1 4.9 2.1 2.1 3.7 4.4 4.9 7.1 1.1 2.4 1.6 5.1 1.6 8.1 0 3.0-.52 5.7-1.6 8.1-1.2 2.7-2.8 5.0-4.9 7.1-2.1 2.1-4.4 3.7-7.1 4.9-2.4 1.1-5.1 1.6-8.1 1.6-3.1 0-5.8-.54-8.4-1.6-2.6-1.1-4.8-2.6-6.8-4.6-2.2-2.2-3.9-4.7-5.2-7.6-1.1-2.3-1.6-4.9-1.6-7.8 0-2.9.525-5.5 1.6-7.8 1.3-2.9 3.0-5.4 5.2-7.6 1.9-2.0 4.1-3.5 6.8-4.6 2.6-1.1 5.4-1.6 8.4-1.6M126.1-.543c-2.5 0-6.7.352-12.6 1.0-5.9.696-12.2 1.7-19.1 3.1S80.6 6.8 73.8 9.0c-6.8 2.2-12.4 4.8-16.7 7.8-2.5 1.9-4.4 3.3-5.5 4.3-1.2 1.0-1.2 3.1 0 6.1l13.8 38.5c.984 2.4 2.1 3.5 3.5 3.5.223 0 .45-.34.7-.1 1.6-.46 3.5-1.1 5.5-2.1 5.5-2.1 12.1-4.7 19.7-7.9 7.6-3.2 15.8-4.8 24.5-4.8 9.0 0 15.0 1.4 18.1 4.1s4.7 6.2 4.7 10.4c0 4.6-.922 8.3-2.8 11.0-1.8 2.8-4.7 5.1-8.5 7.1-3.8 2.0-8.6 3.7-14.3 5.3-5.8 1.6-12.5 3.6-20.4 5.9-3.2 1.2-5.3 2.1-6.4 2.9-1.0.81-1.6 2.5-1.6 5.0v39.7c0 3.2.397 5.3 1.2 6.2.803.9 2.8 1.4 6.0 1.4h45.5c3.0 0 4.9-.46 5.7-1.4.802-.917 1.3-3.0 1.6-6.2l.345-11.7c19.5-6.7 33.9-15.5 43.1-26.4 9.2-10.9 13.8-23.6 13.8-38.1 0-10.6-2.0-20.2-5.9-28.7-3.9-8.6-9.4-15.9-16.4-22.0-7.0-6.1-15.4-10.9-25.0-14.2C148.5 1.1 137.8-.543 126.1-.543zm-6.6 176.6c-5.5 0-10.7 1.0-15.5 3.1-4.8 2.1-9.0 5.0-12.6 8.6-3.6 3.7-6.4 7.9-8.6 12.6-2.2 4.7-3.3 9.8-3.3 15.4s1.1 10.6 3.3 15.4c2.2 4.7 5.1 8.9 8.6 12.6 3.6 3.7 7.8 6.6 12.6 8.6 4.8 2.1 10.0 3.1 15.5 3.1s10.6-1.0 15.4-3.1c4.7-2.1 8.9-5.0 12.6-8.6 3.7-3.7 6.6-7.9 8.6-12.6 2.1-4.7 3.1-9.8 3.1-15.4s-1.0-10.6-3.1-15.4c-2.1-4.7-5.0-8.9-8.6-12.6-3.7-3.7-7.9-6.6-12.6-8.6-4.7-2.1-9.8-3.1-15.4-3.1z"/></symbol><symbol id="icon-menu-invitation" viewBox="-871 873 256 256"><path d="M-625.4 975.4l-26.5-23.3v-29.5c0-12.1-9.8-21.9-21.9-21.9h-36.5l-30.5-26.8c-1.3-1.1-3.2-1.1-4.5 0l-30.5 26.8h-36.5c-12.1 0-21.9 9.8-21.9 21.9V952l-26.5 23.3c-.7.7-1.2 1.6-1.2 2.6v129.2c0 12 9.8 21.8 21.9 21.8h193.7c12.1 0 21.9-9.8 21.9-21.8V977.9c.2-1-.3-1.9-1-2.5zm-126.3-74.7l8.7-7.7 8.7 7.7h-17.4zm111.4 94v112.4c0 .5-.1 1-.2 1.5l-65-56.7 65.2-57.2zm-11.6-12.1v-9.3l5.2 4.6-5.2 4.7zM-683 1009c.1 0 .1 0 .2 0l-13 11.6h-95.1l-13.4-11.9c.4.2.9.3 1.3.3h120zm15-13.2l-11.6 10.4c0-.2 0-.4 0-.6v-9.2c0-1.9-1.5-3.4-3.4-3.4h-120c-1.9 0-3.4 1.5-3.4 3.4v9.2c0 .6.2 1.2.5 1.7l-12.1-10.6v-74.1c0-3.3 2.5-5.8 5.8-5.8h138.4c3.2 0 5.8 2.6 5.8 5.9v73.1zm-45.8 40.9l-13 11.6h-12.6c-.2-.1-.5-.1-.7-.1l-19.6-.1-12.9-11.4h58.8zm-55.6 27.7h52.8l56.6 48.5h-166l56.6-48.5zm-11.1-12.5l-65 56.7c-.1-.5-.2-1-.2-1.5V994.7l65.2 57.2zm-58.8-74l5.2-4.6v9.3l-5.2-4.7zM-683 965.3h-120c-1.9 0-3.4 1.5-3.4 3.4v9.2c0 1.9 1.5 3.4 3.4 3.4h120c1.9 0 3.4-1.5 3.4-3.4v-9.2c0-1.9-1.5-3.4-3.4-3.4zM-683 937.6h-120c-1.9 0-3.4 1.5-3.4 3.4v9.2c0 1.9 1.5 3.4 3.4 3.4h120c1.9 0 3.4-1.5 3.4-3.4V941c0-1.9-1.5-3.4-3.4-3.4z"/></symbol><symbol id="icon-menu-new-problem" viewBox="0 0 256 256"><g><path class="st0" d="M111.7,129.1h-11v-11c0-5-4-9-9-9s-9,4-9,9v11h-11c-5,0-9,4-9,9s4,9,9,9h11v11c0,5,4,9,9,9s9-4,9-9v-11h11c5,0,9-4,9-9S116.6,129.1,111.7,129.1z"/><path class="st0" d="M112.9,181.1c-3.5-3.5-9.2-3.5-12.7,0l-0.3,0.3c0,0,0,0,0,0l-8.2,8.2l-8.5-8.5c-3.5-3.5-9.2-3.5-12.7,0c0,0-0.1,0.1-0.1,0.2c-0.1,0-0.1,0.1-0.2,0.1c-3.5,3.5-3.5,9.2,0,12.7l8.5,8.5l-8.5,8.5c-3.5,3.5-3.5,9.2,0,12.7c1.8,1.8,4.1,2.6,6.4,2.6s4.6-0.9,6.4-2.6l8.5-8.5l8.5,8.5c1.8,1.8,4.1,2.6,6.4,2.6c2.3,0,4.6-0.9,6.4-2.6c0,0,0.1-0.1,0.1-0.2c0.1,0,0.1-0.1,0.2-0.1c3.5-3.5,3.5-9.2,0-12.7l-8.5-8.5l8.5-8.5C116.5,190.3,116.5,184.6,112.9,181.1z"/><path class="st0" d="M183.3,129.1h-40c-5,0-9,4-9,9s4,9,9,9h40c5,0,9-4,9-9S188.3,129.1,183.3,129.1z"/><path class="st0" d="M209.2,0.3H46.8c-12.3,0-22.3,10-22.3,22.3v210.8c0,12.3,10,22.3,22.3,22.3h162.5c12.3,0,22.3-10,22.3-22.3V22.6C231.5,10.3,221.5,0.3,209.2,0.3zM213.5,233.4c0,2.3-1.9,4.3-4.3,4.3H46.8c-2.3,0-4.3-1.9-4.3-4.3V22.6c0-2.3,1.9-4.3,4.3-4.3h162.5c2.3,0,4.3,1.9,4.3,4.3V233.4z"/><path class="st0" d="M182.3,30.1H73.8c-12.3,0-22.3,10-22.3,22.3v27.5c0,12.3,10,22.3,22.3,22.3h108.5c12.3,0,22.3-10,22.3-22.3V52.3C204.5,40.1,194.5,30.1,182.3,30.1zM186.5,79.8c0,2.3-1.9,4.3-4.3,4.3H73.8c-2.3,0-4.3-1.9-4.3-4.3V52.3c0-2.3,1.9-4.3,4.3-4.3h108.5c2.3,0,4.3,1.9,4.3,4.3V79.8z"/><path class="st0" d="M183.3,182h-40c-5,0-9,4-9,9s4,9,9,9h40c5,0,9-4,9-9S188.3,182,183.3,182z"/><path class="st0" d="M183.3,204.2h-40c-5,0-9,4-9,9s4,9,9,9h40c5,0,9-4,9-9S188.3,204.2,183.3,204.2z"/></g></symbol><symbol id="icon-menu-notification-full" viewBox="0 0 256 256"><path d="M157.5,236.3v2.9c0,9.3-7.6,16.9-16.9,16.9h-25.4c-9.3,0-16.9-7.6-16.9-16.9v-2.9c0-9.3,7.6-16.9,16.9-16.9h25.4C150.0,219.4,157.5,227.0,157.5,236.3z"/><path d="M244.6,208.4c0,4.1-3.3,7.5-7.5,7.5H18.9c-4.1,0-7.5-3.4-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5c15.6,0,28.2-12.7,28.2-28.2V102.9c0-34.8,22.1-64.6,53.0-75.9c-1.1-2.2-1.6-4.6-1.6-7.2v-2.9C98.5,7.6,106.0,0,115.3,0h25.4c9.3,0,16.9,7.6,16.9,16.9v2.9c0,2.6-0.6,5.0-1.6,7.2c30.9,11.4,53.0,41.1,53.0,75.9v69.9c0,15.6,12.6,28.2,28.2,28.2C241.2,201.0,244.6,204.3,244.6,208.4z"/></symbol><symbol id="icon-menu-notification" viewBox="0 0 256 256"><path d="M140.7,219.4h-25.4c-9.3,0-16.9,7.6-16.9,16.9v2.9c0,9.3,7.6,16.9,16.9,16.9h25.4c9.3,0,16.9-7.6,16.9-16.9v-2.9C157.5,227.0,150.0,219.4,140.7,219.4zM142.6,239.1c0,1.1-0.9,1.9-1.9,1.9h-25.4c-1.1,0-1.9-0.9-1.9-1.9v-2.9c0-1.1,0.9-1.9,1.9-1.9h25.4c1.1,0,1.9,0.9,1.9,1.9V239.1z"/><path d="M237.1,201.0c-15.6,0-28.2-12.7-28.2-28.2v-69.9c0-34.8-22.1-64.6-53.0-75.9c1.0-2.2,1.6-4.6,1.6-7.2v-2.9C157.5,7.6,150.0,0,140.7,0h-25.4c-9.3,0-16.9,7.6-16.9,16.9v2.9c0,2.6,0.6,5.0,1.6,7.2c-30.9,11.4-53.0,41.1-53.0,75.9v69.9c0,15.6-12.7,28.2-28.2,28.2c-4.1,0-7.5,3.3-7.5,7.5s3.3,7.5,7.5,7.5h218.2c4.1,0,7.5-3.3,7.5-7.5S241.2,201.0,237.1,201.0zM113.4,16.9c0-1.1,0.9-1.9,1.9-1.9h25.4c1.1,0,1.9,0.9,1.9,1.9v2.9c0,1.1-0.9,1.9-1.9,1.9h-25.4c-1.1,0-1.9-0.9-1.9-1.9V16.9zM51.5,201.0c6.6-7.6,10.5-17.4,10.5-28.2v-69.9c0-36.4,29.6-66.0,66.0-66.0s66.0,29.6,66.0,66.0v69.9c0,10.8,4.0,20.6,10.5,28.2H51.5z"/></symbol><symbol id="icon-menu-premium" viewBox="-15 17 256 256"><path d="M234.5 86.7l-43.3-41.1c-3.6-3.4-8.3-5.3-13.3-5.3H48c-4.9 0-9.7 1.9-13.3 5.3L-8.5 86.7c-7.4 7-8 18.5-1.5 26.3L98.2 242.8c3.7 4.4 9.1 6.9 14.8 6.9s11.1-2.5 14.8-6.9L236 112.9c6.5-7.8 5.9-19.3-1.5-26.2zm-15.8 11.5h-39.8L159.8 80l19.8-18.8-1.7-1.7 40.8 38.7zm-121.3 0L113 83.4l15.6 14.8H97.4zm34.4 4.8L113 215.9 94.2 103h37.6zm-15.3-23l18.2-17.3L152.8 80l-18.2 17.3L116.5 80zm21.6-20.5h36.3l-18.2 17.3-18.1-17.3zM113 76.7L94.8 59.5h36.3L113 76.7zM91.3 62.8L109.5 80 91.3 97.3 73.2 80l18.1-17.2zM69.7 76.7L51.5 59.5h36.3L69.7 76.7zm15.6 21.5H54.1l15.6-14.8 15.6 14.8zm4 4.8L108 215.1 51.9 103h37.4zm47.4 0h37.4L118 215.1 136.7 103zm4-4.8l15.6-14.8 15.6 14.8h-31.2zM48 59.5l-1.7 1.7L66.2 80 47.1 98.2H7.3L48 59.5zM6.8 103h39.8l59.7 119.4L6.8 103zm112.9 119.5L179.4 103h39.8l-99.5 119.5z"/></symbol><symbol id="icon-menu-tv" viewBox="0 0 256 256"><g><path class="st0" d="M215.2,56.8H136L157.6,22c0.2,0,0.3,0,0.5,0c6,0,10.9-4.9,10.9-10.9s-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9c0,1.8,0.5,3.5,1.2,5l-25.3,40.6h-2.4L104.9,38c-0.2-0.2-0.4-0.4-0.7-0.6c0.4-1.2,0.7-2.5,0.7-3.8c0-6-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9S88,44.6,94,44.6c0.7,0,1.4-0.1,2.1-0.2c0.2,0.3,0.3,0.5,0.5,0.8l9.9,11.6H40.8C18.3,56.8,0,75,0,97.5v117.4c0,22.5,18.3,40.8,40.8,40.8h174.4c22.5,0,40.8-18.3,40.8-40.8V97.5C256,75,237.7,56.8,215.2,56.8zM237,216.4c0,10.7-8.7,19.5-19.5,19.5h-179c-10.7,0-19.5-8.7-19.5-19.5V96c0-10.7,8.7-19.5,19.5-19.5h179c10.7,0,19.5,8.7,19.5,19.5V216.4z"/><g><path d="M149,200.9h-9.4v-61.8c0-12.3-5.1-14.5-15.2-14.5H107c-11.9,0-14.4,6.1-14.4,11.3c0,4.2,1.9,11.3,14.4,11.3h10.1v53.8H107c-11.9,0-14.4,6.1-14.4,11.3c0,4.2,1.9,11.3,14.4,11.3h42c12.5,0,14.4-7.1,14.4-11.3C163.4,207.1,160.9,200.9,149,200.9z"/><path d="M118.6,117.9h9.5c6.8,0,10.8-3.9,10.8-10.8v-7.9c0-6.8-3.9-10.8-10.8-10.8h-9.5c-6.8,0-10.8,3.9-10.8,10.8v7.9C107.8,114,111.8,117.9,118.6,117.9z"/></g></g></symbol><symbol id="icon-player-backward" viewBox="0 0 256 256"><g><path class="st0" d="M242.7,12.8c-2.5-1.4-5.6-1.4-8.1,0.1L67.9,114V19.7c0-4.4-3.6-8-8-8H17.1c-4.4,0-8,3.6-8,8v216.5c0,4.4,3.6,8,8,8h42.8c4.4,0,8-3.6,8-8V142L234.7,243c1.3,0.8,2.7,1.2,4.1,1.2c1.4,0,2.7-0.3,3.9-1c2.5-1.4,4.1-4.1,4.1-7V19.8C246.8,16.9,245.2,14.2,242.7,12.8zM51.9,228.2H25.1V27.7h26.8V228.2zM230.8,222L75.7,128l155.1-94V222z"/></g></symbol><symbol id="icon-player-forward" viewBox="0 0 256 256"><g><path class="st0" d="M238.9,11.8h-42.8c-4.4,0-8,3.6-8,8V114L21.3,13c-2.5-1.5-5.6-1.5-8.1-0.1c-2.5,1.4-4.1,4.1-4.1,7v216.4c0,2.9,1.6,5.6,4.1,7c1.2,0.7,2.6,1,3.9,1c1.4,0,2.9-0.4,4.1-1.2L188.1,142v94.3c0,4.4,3.6,8,8,8h42.8c4.4,0,8-3.6,8-8V19.8C246.9,15.4,243.3,11.8,238.9,11.8zM25.2,222V34l155.1,94L25.2,222zM230.9,228.3h-26.8V27.8h26.8V228.3z"/></g></symbol><symbol id="icon-player-pause" viewBox="0 0 256 256"><path class="st0" d="M217.9,244.2h-42.8c-4.4,0-8-3.6-8-8V19.7c0-4.4,3.6-8,8-8h42.8c4.4,0,8,3.6,8,8v216.5C225.9,240.6,222.3,244.2,217.9,244.2zM183.1,228.2h26.8V27.7h-26.8V228.2z"/><path class="st0" d="M80.9,244.2H38.1c-4.4,0-8-3.6-8-8V19.7c0-4.4,3.6-8,8-8h42.8c4.4,0,8,3.6,8,8v216.5C88.9,240.6,85.3,244.2,80.9,244.2zM46.1,228.2h26.8V27.7H46.1V228.2z"/></symbol><symbol id="icon-player-play" viewBox="0 0 256 256"><path class="st0" d="M38.8,244.2c-1.4,0-2.7-0.3-3.9-1c-2.5-1.4-4.1-4.1-4.1-7V19.8c0-2.9,1.6-5.6,4.1-7c2.5-1.4,5.6-1.4,8.1,0.1l178.5,108.2c2.4,1.5,3.9,4,3.9,6.8c0,2.8-1.5,5.4-3.9,6.8L42.9,243C41.7,243.8,40.2,244.2,38.8,244.2zM46.8,34v188l155.1-94L46.8,34z"/></symbol><symbol id="icon-player-stop" viewBox="0 0 256 256"><path class="st0" d="M238.8,11.8H17.2c-4.4,0-8,3.6-8,8v216.5c0,4.4,3.6,8,8,8h221.7c4.4,0,8-3.6,8-8V19.8C246.8,15.3,243.3,11.8,238.8,11.8zM230.8,228.2H25.2V27.8h205.7V228.2z"/></symbol><symbol id="icon-pro" viewBox="0 0 256 256"><path d="M244,35H12C5.4,35,0,40.4,0,47v162c0,6.6,5.4,12,12,12h232c6.6,0,12-5.4,12-12V47C256,40.4,250.6,35,244,35zM85.0,133.2c0,7.3-3.6,11-10.8,11H45.6v42.7H28V69.1h46.2c7.2,0,10.8,3.6,10.8,10.8V133.2zM139.4,186.9l-19.4-54.8v-10.6h17.3V84.2h-22.2v102.7H97.5V69.1h46.8c7.1,0,10.6,3.6,10.6,10.8v42.9c0,5.0-1.7,8.2-5.1,9.6c-1.8,0.8-5.6,1.1-11.4,1.1l19.4,53.4H139.4zM228,176.2c0,7.2-3.6,10.8-10.7,10.8h-38.3c-7.0,0-10.5-3.6-10.5-10.8V79.9c0-7.2,3.5-10.8,10.5-10.8h38.3c7.1,0,10.7,3.6,10.7,10.8V176.2z"/><rect x="45.6" y="84.2" width="21.5" height="44.9"/><rect x="186.2" y="84.2" width="24.2" height="87.6"/></symbol><symbol id="icon-shape-a-x" viewBox="0 0 1000 1000"><path d="M0 0v1000h1000V0H0zm575.6 812.5c0 6.1-4.9 11.0-11.0 11.0h-125.8c-6.1 0-11.0-4.9-11.0-11.0V686.6c0-6.1 4.9-11.0 11.0-11.0h125.8c6.1 0 11.0 4.9 11.0 11.0V812.5zm107.2-369.1c-22.7 27.0-58.2 48.7-106.4 65.1l-.852 101.3c-.57 8.0-1.9 13.1-3.8 15.3-2.0 2.3-6.7 3.4-14.0 3.4H445.3c-8.0 0-12.9-1.1-14.9-3.4-2.0-2.3-3.0-7.4-3.0-15.3V439.6c0-6.2 1.3-10.3 3.8-12.3 2.6-2.0 7.8-4.4 15.8-7.2 19.3-5.7 36.0-10.5 50.2-14.5 14.2-4.0 26.0-8.4 35.3-13.2 9.4-4.8 16.3-10.6 20.9-17.4 4.5-6.8 6.8-15.9 6.8-27.2 0-10.2-3.8-18.7-11.5-25.5-7.7-6.8-22.6-10.2-44.7-10.2-21.6 0-41.7 4.0-60.4 11.9-18.7 8.0-34.9 14.5-48.5 19.6-5.1 2.3-9.7 4.0-13.6 5.1-4.0 1.1-7.4-1.7-10.2-8.5l-34.1-94.9c-2.8-7.4-2.8-12.4 0-15.0 2.8-2.6 7.4-6.1 13.6-10.7 10.8-7.4 24.5-13.8 41.3-19.3 16.7-5.4 33.6-9.8 50.7-13.3 17.0-3.4 32.8-6 47.3-7.7 14.5-1.7 24.8-2.6 31.1-2.6 28.9 0 55.3 4.2 79.2 12.4 23.8 8.3 44.4 20.0 61.7 35.1 17.3 15.1 30.8 33.3 40.4 54.4 9.6 21.1 14.5 44.8 14.5 70.9 0 35.8-11.4 67.1-34.1 94.1z"/></symbol><symbol id="icon-shape-a" viewBox="0 0 256 256"><path d="M0 0h256v256H0z"/></symbol><symbol id="icon-shape-a2" viewBox="-871 873 256 256"><path d="M-665 923v156h-156V923h156m50-50h-256v256h256V873z"/></symbol><symbol id="icon-shape-arrow" viewBox="0 0 256 256"><path d="M159.2 232.4l91.4-91.4c7.1-7.1 7.1-18.7 0-25.9l-91.4-91.4c-7.1-7.1-18.7-7.1-25.9 0-7.1 7.1-7.1 18.7 0 25.9l60.2 60.2H18.3C8.2 109.7 0 117.9 0 128c0 10.1 8.2 18.3 18.3 18.3H193.6L133.4 206.5c-3.6 3.6-5.4 8.3-5.4 12.9s1.8 9.4 5.4 12.9c7.1 7.1 18.7 7.1 25.9 0z"/></symbol><symbol id="icon-shape-b-x" viewBox="0 0 1000 1000"><path d="M500 67.0L0 933.0h1000L500 67.0zm52.5 774.8c0 4.7-3.8 8.6-8.6 8.6H446.2c-4.7 0-8.6-3.8-8.6-8.6v-97.7c0-4.7 3.8-8.6 8.6-8.6H543.9c4.7 0 8.6 3.8 8.6 8.6v97.7zm.64-236.1l-.66 78.6c-.443 6.2-1.4 10.1-3.0 11.9-1.5 1.8-5.2 2.6-10.9 2.6H451.3c-6.2 0-10.0-.88-11.6-2.6-1.6-1.8-2.3-5.7-2.3-11.9V552.2c0-4.8.992-8.0 3.0-9.6 2.0-1.5 6.1-3.4 12.2-5.6 15.0-4.4 28.0-8.2 39.0-11.2 11.0-3.1 20.2-6.5 27.4-10.3 7.3-3.7 12.7-8.3 16.2-13.6 3.5-5.3 5.3-12.3 5.3-21.2 0-7.9-3.0-14.5-8.9-19.8-6.0-5.3-17.5-7.9-34.7-7.9-16.8 0-32.4 3.1-46.9 9.3-14.5 6.2-27.1 11.2-37.7 15.2-4.0 1.8-7.5 3.1-10.6 4.0-3.1.89-5.7-1.3-7.9-6.6l-26.4-73.7c-2.2-5.8-2.2-9.6 0-11.6 2.2-2.0 5.7-4.8 10.6-8.3 8.4-5.8 19.1-10.8 32.1-15.0 13.0-4.2 26.1-7.6 39.3-10.3 13.2-2.7 25.5-4.7 36.7-6.0 11.2-1.3 19.3-2.0 24.1-2.0 22.5 0 43.0 3.2 61.5 9.6 18.5 6.4 34.5 15.5 47.9 27.3 13.4 11.8 23.9 25.8 31.4 42.2 7.5 16.4 11.2 34.8 11.2 55.0 0 27.8-8.8 52.1-26.4 73.1-17.6 20.9-45.2 37.8-82.6 50.6z"/></symbol><symbol id="icon-shape-b" viewBox="0 0 256 256"><path d="M0 238.9L128 17.1l128 221.7z"/></symbol><symbol id="icon-shape-b2" viewBox="-871 873 256 256"><path d="M-743 990.1l41.4 71.7h-82.8l41.4-71.7m0-99.9l-128 221.7h256l-128-221.7z"/></symbol><symbol id="icon-shape-c-x" viewBox="0 0 1000 1000"><path d="M500 0C223.8 0 0 223.8 0 500s223.8 500 500 500 500-223.8 500-500S776.2 0 500 0zm75.6 812.5c0 6.1-4.9 11.0-11.0 11.0h-125.8c-6.1 0-11.0-4.9-11.0-11.0V686.6c0-6.1 4.9-11.0 11.0-11.0h125.8c6.1 0 11.0 4.9 11.0 11.0V812.5zm107.2-369.1c-22.7 27.0-58.2 48.7-106.4 65.1l-.852 101.3c-.57 8.0-1.9 13.1-3.8 15.3-2.0 2.3-6.7 3.4-14.0 3.4H445.3c-8.0 0-12.9-1.1-14.9-3.4-2.0-2.3-3.0-7.4-3.0-15.3V439.6c0-6.2 1.3-10.3 3.8-12.3 2.6-2.0 7.8-4.4 15.8-7.2 19.3-5.7 36.0-10.5 50.2-14.5 14.2-4.0 26.0-8.4 35.3-13.2 9.4-4.8 16.3-10.6 20.9-17.4 4.5-6.8 6.8-15.9 6.8-27.2 0-10.2-3.8-18.7-11.5-25.5-7.7-6.8-22.6-10.2-44.7-10.2-21.6 0-41.7 4.0-60.4 11.9-18.7 8.0-34.9 14.5-48.5 19.6-5.1 2.3-9.7 4.0-13.6 5.1-4.0 1.1-7.4-1.7-10.2-8.5l-34.1-94.9c-2.8-7.4-2.8-12.4 0-15.0 2.8-2.6 7.4-6.1 13.6-10.7 10.8-7.4 24.5-13.8 41.3-19.3 16.7-5.4 33.6-9.8 50.7-13.3 17.0-3.4 32.8-6 47.3-7.7 14.5-1.7 24.8-2.6 31.1-2.6 28.9 0 55.3 4.2 79.2 12.4 23.8 8.3 44.4 20.0 61.7 35.1 17.3 15.1 30.8 33.3 40.4 54.4 9.6 21.1 14.5 44.8 14.5 70.9 0 35.8-11.4 67.1-34.1 94.1z"/></symbol><symbol id="icon-shape-c" viewBox="0 0 256 256"><circle cx="128" cy="128" r="128"/></symbol><symbol id="icon-shape-c2" viewBox="-871 873 256 256"><path d="M-743 923c43 0 78 35 78 78s-35 78-78 78-78-35-78-78 35-78 78-78m0-50c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128z"/></symbol><symbol id="icon-shape-d" viewBox="0 0 256 256"><path d="M128 256L0 128.0l128-128 128 128z"/></symbol><symbol id="icon-shape-d2" viewBox="-871 873 256 256"><path d="M-743 943.7l57.3 57.3-57.3 57.3-57.3-57.3 57.3-57.3m0-70.7l-128 128 128 128 128-128-128-128z"/></symbol><symbol id="icon-shape-e" viewBox="0 0 256 256"><path d="M256 17.1L128 238.9 0 17.1z"/></symbol><symbol id="icon-shape-e2" viewBox="-871 873 256 256"><path d="M-701.6 940.2l-41.4 71.7-41.4-71.7h82.8m86.6-50h-256l128 221.7 128-221.7z"/></symbol><symbol id="icon-shape-f" viewBox="0 0 256 256"><path d="M48.9 249.7L0 99.3 128 6.3l128 93.0-48.9 150.5z"/></symbol><symbol id="icon-shape-f2" viewBox="-871 873 256 256"><path d="M-743 941.1l69.2 50.3-26.4 81.4h-85.6l-26.4-81.4 69.2-50.3m0-61.8l-128 93 48.9 150.5h158.2l48.9-150.5-128-93z"/></symbol><symbol id="icon-shape-placeholder" viewBox="0 0 256 256"><path d="M126.6,157.8h-5.1c0-7.5,0.4-13.4,1.2-17.8c0.8-4.3,1.8-7.8,3.1-10.3c1.2-2.5,4.4-7.1,9.5-13.8c4-5.2,6.8-10.1,8.5-14.8c1.6-4.6,2.4-9.7,2.4-15.2c0-7.5-2.1-13.6-6.3-18.1c-4.2-4.6-9.4-6.9-15.5-6.9c-5.3,0-9.7,1.3-13.2,3.9c-3.5,2.6-5.3,5.3-5.3,8c0,1.5,1.2,3.2,3.7,5.2c3.8,2.9,5.6,6.1,5.6,9.5c0,3.1-1,5.6-3,7.6c-2,2-4.5,3.1-7.5,3.1c-3.6,0-6.6-1.4-9.1-4.3c-2.5-2.9-3.7-6.6-3.7-11.3c0-7.3,3.4-13.9,10.1-19.7c6.8-5.8,15.3-8.7,25.5-8.7c10.5,0,19.2,3.3,26.1,9.8c6.9,6.5,10.3,14.4,10.3,23.8c0,6-1.2,11.4-3.5,16.3c-1.8,3.6-6.3,8.7-13.5,15.3c-9.4,8.4-15.1,14.6-17.1,18.6C127.9,142,126.8,148.6,126.6,157.8zM124.3,178.5c3.2,0,5.9,1.1,8.1,3.3c2.2,2.2,3.3,4.9,3.3,8c0,3.3-1.1,6.1-3.3,8.5c-2.2,2.3-4.9,3.5-8.1,3.5c-3.2,0-5.9-1.1-8.1-3.4c-2.2-2.3-3.3-5.1-3.3-8.5c0-3.2,1.1-5.9,3.3-8.1C118.4,179.6,121.1,178.5,124.3,178.5z"/><path style="opacity:0.2" d="M209.5,228h-163c-10.2,0-18.5-8.3-18.5-18.5v-163C28,36.3,36.3,28,46.5,28h163c10.2,0,18.5,8.3,18.5,18.5v163C228,219.7,219.7,228,209.5,228z"/></symbol><symbol id="icon-shape-x" viewBox="0 0 1000 1000"><path d="M576.6 788.1v194.3c0 9.4-7.6 17.0-17.0 17.0H365.3c-9.4 0-17.0-7.6-17.0-17.0V788.1c0-9.4 7.6-17.0 17.0-17.0H559.6c9.4 0 17.0 7.6 17.0 17.0zM794.8 267.3c-.016 55.2-17.6 103.6-52.6 145.3-35.1 41.6-89.8 75.1-164.3 100.6l-1.3 156.4c-.88 12.3-2.9 20.2-5.9 23.7-3.1 3.5-10.3 5.3-21.7 5.3h-173.5c-12.3 0-19.9-1.7-23.0-5.3-3.1-3.5-4.6-11.4-4.6-23.7v-262.8c0-9.6 2.0-16.0 5.9-19.1 4.0-3.1 12.0-6.8 24.3-11.2 29.8-8.8 55.6-16.2 77.6-22.3 21.9-6.1 40.1-12.9 54.5-20.4 14.5-7.4 25.2-16.4 32.2-26.9 7.0-10.5 10.5-24.5 10.5-42.1 0-15.8-5.9-28.9-17.7-39.4-11.8-10.5-34.8-15.8-69.0-15.8-33.3 0-64.4 6.1-93.3 18.4-28.9 12.3-53.9 22.3-74.9 30.2-7.9 3.5-14.9 6.1-21.0 7.9-6.1 1.8-11.4-2.6-15.8-13.1l-52.6-146.6c-4.4-11.5-4.4-19.2 0-23.1 4.4-4.0 11.4-9.5 21.0-16.5 16.6-11.5 37.9-21.4 63.8-29.8 25.8-8.4 51.9-15.2 78.2-20.5 26.3-5.3 50.6-9.3 73.0-11.9C466.8 1.8 482.8.5 492.4.5c44.7 0 85.4 6.4 122.2 19.2 36.8 12.8 68.6 30.9 95.3 54.2 26.7 23.4 47.5 51.4 62.4 84.0 14.9 32.6 22.4 69.1 22.4 109.4z"/></symbol><symbol id="icon-star" viewBox="0 0 256 256"><path d="M64.2,150.6L0.0,90.2l95.3-0.1L128.1,0l31.9,90.5l96.0-0.2l-63.4,59.8L224.0,256l-95.9-45.6L31.7,256L64.2,150.6z"/></symbol><symbol id="icon-symbol-az" viewBox="0 0 256 256"><g><path d="M124.7,168c-2.5-2.2-5.7-3.3-9.6-3.4L79.7,70.9c-1.4-3.7-4.9-6.2-8.9-6.2H31.9c-4.2,0-7.7,1.2-10.3,3.4c-2.8,2.5-4.4,6-4.4,9.9c0,3.9,1.6,7.4,4.4,9.9c2.6,2.3,6,3.5,10.3,3.5h9.1L14,164.5c-3.9,0.1-7.2,1.3-9.6,3.4c-2.8,2.5-4.4,6-4.4,9.9c0,3.8,1.5,7.2,4.3,9.8c2.6,2.4,6.1,3.6,10.4,3.6h28.9c4.3,0,7.8-1.2,10.4-3.6c2.7-2.5,4.2-6,4.2-9.7c0-3.9-1.6-7.4-4.4-9.9c-2.6-2.3-6-3.4-10.3-3.4h-1.2l3.4-9.2h37.5l3.4,9.2h-1c-4.3,0-7.8,1.2-10.4,3.4c-2.8,2.5-4.4,6-4.4,9.9c0,3.8,1.5,7.2,4.2,9.7c2.6,2.4,6.1,3.6,10.5,3.6h28.8c4.3,0,7.8-1.2,10.4-3.6c2.7-2.5,4.2-6,4.2-9.7C129.2,174,127.6,170.5,124.7,168zM64.3,105.3l8.8,23.3H55.7L64.3,105.3z"/><path d="M153.1,113.5h-32.4c-5.3,0-9.5,4.3-9.5,9.5v11c0,5.3,4.3,9.5,9.5,9.5h32.4c5.3,0,9.5-4.3,9.5-9.5v-11C162.6,117.8,158.4,113.5,153.1,113.5z"/><path d="M252.4,153c-2.5-2.7-6-4.2-9.8-4.2c-3.9,0-7.4,1.6-9.9,4.4c-2.3,2.6-3.4,6-3.4,10.3v1.1h-21.5l43.7-49.1c1.6-1.7,2.4-4,2.4-6.3v-6.9c0-5.3-4.3-9.5-9.5-9.5h-66.7c-5.3,0-9.5,4.3-9.5,9.5v18.3c0,4.3,1.2,7.8,3.6,10.4c2.5,2.7,6,4.3,9.8,4.3c3.8,0,7.2-1.5,9.7-4.2c2.4-2.6,3.6-6.1,3.6-10.4v-1h17.3l-43.5,49.1c-1.5,1.7-2.4,4-2.4,6.3v6.9c0,5.3,4.3,9.5,9.5,9.5h70.6c5.2,0,9.5-4.2,9.5-9.5l0.1-18.4C256,159.1,254.8,155.6,252.4,153z"/></g></symbol><symbol id="icon-symbol-back" viewBox="0 0 256 256"><path d="M216 0c4.4 0 8.2 1.6 11.3 4.7S232 11.6 232 16c0 4.5-1.5 8.3-4.6 11.4L126.6 128l100.8 100.8c3.1 3.1 4.6 6.9 4.6 11.4 0 4.4-1.6 8.2-4.7 11.3S220.4 256 216 256c-4.5 0-8.3-1.5-11.4-4.6l-112-112C89.5 136.1 88 132.3 88 128c0-4.3 1.5-8 4.6-11.3l112-112C207.8 1.6 211.6 0 216 0zM40 0c4.4 0 8.2 1.6 11.3 4.7S56 11.6 56 16v224c0 4.4-1.6 8.2-4.7 11.3S44.4 256 40 256s-8.2-1.6-11.3-4.7S24 244.4 24 240V16c0-4.4 1.6-8.2 4.7-11.3S35.6 0 40 0z"/></symbol><symbol id="icon-symbol-backspace" viewBox="0 0 256 256"><path d="M85.3 32H224c8.8 0 16.4 3.1 22.6 9.4S256 55.2 256 64v128c0 8.8-3.1 16.4-9.4 22.6S232.8 224 224 224H85.3L0 128l85.3-96zM224 53.3H94.9L28.6 128l66.3 74.7H224c2.9 0 5.5-1.0 7.5-3.1 2.1-2.1 3.1-4.6 3.1-7.5V64c0-2.9-1.0-5.5-3.1-7.5-2.1-2.1-4.6-3.1-7.5-3.1zM202.7 96c0 3-1.0 5.5-3.1 7.6L175.1 128l24.5 24.4c2.1 2.1 3.1 4.6 3.1 7.6 0 3.1-1.0 5.6-3.0 7.6s-4.6 3.0-7.6 3.0c-3 0-5.5-1.0-7.6-3.1L160 143.1l-24.4 24.5c-2.1 2.1-4.6 3.1-7.6 3.1-2.9 0-5.5-1.0-7.5-3.1-2.1-2.1-3.1-4.6-3.1-7.5 0-2.9 1.0-5.4 3.1-7.6l24.5-24.4-24.5-24.4c-2.1-2.2-3.1-4.7-3.1-7.6 0-2.9 1.0-5.5 3.1-7.5 2.1-2.1 4.6-3.1 7.5-3.1 3 0 5.5 1.0 7.6 3.1l24.4 24.5 24.4-24.5c2.1-2.1 4.6-3.1 7.6-3.1 3.1 0 5.6 1.0 7.6 3.0s3.0 4.6 3.0 7.6z"/></symbol><symbol id="icon-symbol-bug" viewBox="0 0 256 256"><path d="M210,172v-34.4h35.5c5.2,0,9.5-4.3,9.5-9.5s-4.3-9.5-9.5-9.5H210v-31c25.4-4.5,44.8-26.8,44.8-53.5c0-5.2-4.3-9.5-9.5-9.5s-9.5,4.3-9.5,9.5c0,17.3-12.5,31.7-28.9,34.7c-4.4-10.1-13.2-18-23.9-21.1C179.4,21.4,156.7,1,129.3,1c-27.1,0-49.7,20-53.7,46c-11.8,2.4-21.5,10.4-26.3,21.1c-16.5-2.9-29.2-17.4-29.2-34.8c0-5.2-4.3-9.5-9.5-9.5s-9.5,4.3-9.5,9.5c0,26.7,19.4,49,44.8,53.5l0,31.7H10.5c-5.2,0-9.5,4.3-9.5,9.5s4.3,9.5,9.5,9.5h35.4l0,34.4c-25.4,4.5-44.8,26.8-44.8,53.5c0,5.2,4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5c0-16.9,11.9-31.1,27.8-34.5c8.2,36.6,41,64,80,64c39,0,71.8-27.4,80-64c15.9,3.4,27.9,17.6,27.9,34.5c0,5.2,4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5C254.9,198.7,235.5,176.5,210,172zM129.3,20c16.3,0,30.1,11.1,34.1,26.2H95.2C99.2,31.2,113,20,129.3,20zM64.9,172.9l0-64.8h59l0,127.8C91.1,233.7,64.9,206.3,64.9,172.9zM191,172.9c0,33.4-26.1,60.8-59,62.9l0-127.8H191V172.9zM191,100.1H65l0-16.6c0-10,8.2-18.2,18.2-18.2h89.7c10,0,18.2,8.2,18.2,18.2V100.1z"/></symbol><symbol id="icon-symbol-calculator" viewBox="0 0 256 256"><path d="M204.5,256h-153c-12.1,0-22-9.9-22-22V22c0-12.1,9.9-22,22-22h153c12.1,0,22,9.9,22,22v212C226.5,246.1,216.6,256,204.5,256zM51.5,20c-1.1,0-2,0.9-2,2v212c0,1.1,0.9,2,2,2h153c1.1,0,2-0.9,2-2V22c0-1.1-0.9-2-2-2H51.5z"/><g><path d="M190.1,76.7H65.9c-5.1,0-9.3-4.2-9.3-9.3V37.3c0-5.1,4.2-9.3,9.3-9.3h124.2c5.1,0,9.3,4.2,9.3,9.3v30.1C199.4,72.6,195.2,76.7,190.1,76.7zM65.9,33.0c-2.4,0-4.3,1.9-4.3,4.3v30.1c0,2.4,1.9,4.3,4.3,4.3h124.2c2.4,0,4.3-1.9,4.3-4.3V37.3c0-2.4-1.9-4.3-4.3-4.3H65.9z"/><path d="M90.8,127.3H65.9c-5.1,0-9.3-4.2-9.3-9.3V92.3c0-5.1,4.2-9.3,9.3-9.3H90.8c5.1,0,9.3,4.2,9.3,9.3V118C100.1,123.1,95.9,127.3,90.8,127.3zM65.9,88.0c-2.4,0-4.3,1.9-4.3,4.3V118c0,2.4,1.9,4.3,4.3,4.3H90.8c2.4,0,4.3-1.9,4.3-4.3V92.3c0-2.4-1.9-4.3-4.3-4.3H65.9z"/><path d="M140.4,127.3h-24.9c-5.1,0-9.3-4.2-9.3-9.3V92.3c0-5.1,4.2-9.3,9.3-9.3h24.9c5.1,0,9.3,4.2,9.3,9.3V118C149.7,123.1,145.6,127.3,140.4,127.3zM115.6,88.0c-2.4,0-4.3,1.9-4.3,4.3V118c0,2.4,1.9,4.3,4.3,4.3h24.9c2.4,0,4.3-1.9,4.3-4.3V92.3c0-2.4-1.9-4.3-4.3-4.3H115.6z"/><path d="M190.1,127.3h-24.9c-5.1,0-9.3-4.2-9.3-9.3V92.3c0-5.1,4.2-9.3,9.3-9.3h24.9c5.1,0,9.3,4.2,9.3,9.3V118C199.4,123.1,195.2,127.3,190.1,127.3zM165.2,88.0c-2.4,0-4.3,1.9-4.3,4.3V118c0,2.4,1.9,4.3,4.3,4.3h24.9c2.4,0,4.3-1.9,4.3-4.3V92.3c0-2.4-1.9-4.3-4.3-4.3H165.2z"/><path d="M90.8,177.6H65.9c-5.1,0-9.3-4.2-9.3-9.3v-25.7c0-5.1,4.2-9.3,9.3-9.3H90.8c5.1,0,9.3,4.2,9.3,9.3v25.7C100.1,173.5,95.9,177.6,90.8,177.6zM65.9,138.3c-2.4,0-4.3,1.9-4.3,4.3v25.7c0,2.4,1.9,4.3,4.3,4.3H90.8c2.4,0,4.3-1.9,4.3-4.3v-25.7c0-2.4-1.9-4.3-4.3-4.3H65.9z"/><path d="M140.4,177.6h-24.9c-5.1,0-9.3-4.2-9.3-9.3v-25.7c0-5.1,4.2-9.3,9.3-9.3h24.9c5.1,0,9.3,4.2,9.3,9.3v25.7C149.7,173.5,145.6,177.6,140.4,177.6zM115.6,138.3c-2.4,0-4.3,1.9-4.3,4.3v25.7c0,2.4,1.9,4.3,4.3,4.3h24.9c2.4,0,4.3-1.9,4.3-4.3v-25.7c0-2.4-1.9-4.3-4.3-4.3H115.6z"/><path d="M90.8,228.0H65.9c-5.1,0-9.3-4.2-9.3-9.3v-25.7c0-5.1,4.2-9.3,9.3-9.3H90.8c5.1,0,9.3,4.2,9.3,9.3V218.7C100.1,223.8,95.9,228.0,90.8,228.0zM65.9,188.7c-2.4,0-4.3,1.9-4.3,4.3V218.7c0,2.4,1.9,4.3,4.3,4.3H90.8c2.4,0,4.3-1.9,4.3-4.3v-25.7c0-2.4-1.9-4.3-4.3-4.3H65.9z"/><path d="M140.4,228.0h-24.9c-5.1,0-9.3-4.2-9.3-9.3v-25.7c0-5.1,4.2-9.3,9.3-9.3h24.9c5.1,0,9.3,4.2,9.3,9.3V218.7C149.7,223.8,145.6,228.0,140.4,228.0zM115.6,188.7c-2.4,0-4.3,1.9-4.3,4.3V218.7c0,2.4,1.9,4.3,4.3,4.3h24.9c2.4,0,4.3-1.9,4.3-4.3v-25.7c0-2.4-1.9-4.3-4.3-4.3H115.6z"/><path d="M190.1,228.0h-24.9c-5.1,0-9.3-4.2-9.3-9.3v-76.1c0-5.1,4.2-9.3,9.3-9.3h24.9c4.3,0,8.1,2.9,9.0,7.1c0.2,0.7,0.2,1.4,0.2,2.1V218.7C199.4,223.8,195.2,228.0,190.1,228.0zM165.2,138.3c-2.4,0-4.3,1.9-4.3,4.3V218.7c0,2.4,1.9,4.3,4.3,4.3h24.9c2.4,0,4.3-1.9,4.3-4.3v-76.1c0-0.3-0.0-0.7-0.1-1.0c-0.5-1.9-2.2-3.3-4.2-3.3H165.2z"/></g></symbol><symbol id="icon-symbol-calendar" viewBox="0 0 256 256"><g><path class="st0" d="M256,53.1v179.4c0,12.9-10.5,23.5-23.5,23.5h-209C10.5,256,0,245.5,0,232.5V53c0-12.9,10.5-23.5,23.5-23.5h209.1C245.5,29.6,256,40.1,256,53.1zM17.6,232.5c0,3.2,2.6,5.9,5.9,5.9h209.1c3.2,0,5.9-2.6,5.9-5.9V53c0-3.2-2.6-5.9-5.9-5.9H23.5c-3.2,0-5.9,2.6-5.9,5.9V232.5z"/></g><g><path class="st0" d="M67.3,8.7v54c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8V8.8c0-4.9,3.9-8.8,8.8-8.8C63.3,0,67.3,3.9,67.3,8.7z"/><path class="st0" d="M95.1,8.7v54c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8V8.8c0-4.9,3.9-8.8,8.8-8.8C91.1,0,95.1,3.9,95.1,8.7z"/><path class="st0" d="M122.9,8.7v54c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8V8.8c0-4.9,3.9-8.8,8.8-8.8C118.9,0,122.9,3.9,122.9,8.7z"/><path class="st0" d="M150.8,8.7v54c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8V8.8c0-4.9,3.9-8.8,8.8-8.8C146.8,0,150.8,3.9,150.8,8.7z"/><path class="st0" d="M178.6,8.7v54c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8V8.8c0-4.9,3.9-8.8,8.8-8.8C174.6,0,178.6,3.9,178.6,8.7z"/><path class="st0" d="M206.3,8.7v54c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8V8.8c0-4.9,3.9-8.8,8.8-8.8C202.3,0,206.3,3.9,206.3,8.7z"/></g><path class="st0" d="M154,108.3c1.6,2.1,2.2,4.8,1.7,7.3L139,196.4c-1,4.8-5.7,7.9-10.4,6.9c-4.8-1-7.9-5.7-6.9-10.4l14.5-70.5l-27.5-0.2c-4.9-0.1-8.7-4.1-8.6-9c0.1-4.9,4.1-8.7,9-8.6l38.1,0.4c2.6,0,5,1.2,6.6,3.2C153.9,108.3,153.9,108.3,154,108.3z"/></symbol><symbol id="icon-symbol-camera" viewBox="0 0 256 256"><path d="M85.3 21.3h85.3l21.3 32h32c8.8 0 16.4 3.2 22.6 9.5S256 76.8 256 85.7v117.2c0 8.8-3.1 16.3-9.4 22.5s-13.8 9.3-22.6 9.3H32c-8.8 0-16.4-3.1-22.6-9.4S0 211.5 0 202.7V85.5c0-8.8 3.1-16.4 9.4-22.7 6.3-6.3 13.8-9.5 22.6-9.5h32l21.3-32zm42.7 64c7.2 0 14.1 1.4 20.7 4.3 6.6 2.8 12.3 6.6 17 11.4s8.5 10.4 11.4 17c2.8 6.6 4.3 13.5 4.3 20.7 0 7.2-1.4 14.1-4.3 20.7-2.8 6.6-6.6 12.3-11.4 17s-10.4 8.5-17 11.4C142.1 190.6 135.2 192 128 192c-7.2 0-14.1-1.4-20.7-4.3-6.6-2.8-12.3-6.6-17-11.4s-8.5-10.4-11.4-17-4.3-13.5-4.3-20.7c0-7.2 1.4-14.1 4.3-20.7 2.8-6.6 6.6-12.3 11.4-17s10.4-8.5 17-11.4c6.6-2.8 13.5-4.3 20.7-4.3zm0 21.3c-8.8 0-16.4 3.1-22.6 9.4S96 129.8 96 138.7c0 8.8 3.1 16.4 9.4 22.6s13.8 9.4 22.6 9.4 16.4-3.1 22.6-9.4S160 147.5 160 138.7c0-8.8-3.1-16.4-9.4-22.6s-13.8-9.4-22.6-9.4zm52.6-32l-20.9-32H96.8l-21.3 32H32c-2.9 0-5.5 1.1-7.5 3.2-2.1 2.1-3.1 4.7-3.1 7.7v117.2c0 2.9 1.0 5.5 3.1 7.5 2.1 2.1 4.6 3.1 7.5 3.1h192c3 0 5.5-1.0 7.6-3.0 2.1-2.0 3.1-4.5 3.1-7.5V85.7c0-3-1.1-5.6-3.2-7.8-2.1-2.2-4.6-3.3-7.5-3.3h-43.4z"/></symbol><symbol id="icon-symbol-chart" viewBox="0 0 256 256"><g><path d="M50.5,248h-41c-5.2,0-9.5-4.3-9.5-9.5v-41c0-5.2,4.3-9.5,9.5-9.5h41c5.2,0,9.5,4.3,9.5,9.5v41C60,243.7,55.7,248,50.5,248z"/><path d="M148.5,248h-41c-5.2,0-9.5-4.3-9.5-9.5v-101c0-5.2,4.3-9.5,9.5-9.5h41c5.2,0,9.5,4.3,9.5,9.5v101C158,243.7,153.7,248,148.5,248z"/><path d="M246.5,248h-41c-5.2,0-9.5-4.3-9.5-9.5v-221c0-5.2,4.3-9.5,9.5-9.5h41c5.2,0,9.5,4.3,9.5,9.5v221C256,243.7,251.7,248,246.5,248z"/></g></symbol><symbol id="icon-symbol-clipboard-copy" viewBox="0 0 256 256"><path d="M76.8,76.8V25.6C76.8,11.5,88.3,0,102.4,0h128C244.5,0,256,11.5,256,25.6l0,0v128c0,14.1-11.5,25.6-25.6,25.6l0,0h-51.2v51.2c0,14.1-11.5,25.6-25.6,25.6l0,0h-128C11.5,256,0,244.5,0,230.4l0,0v-128c0-14.1,11.5-25.6,25.6-25.6C25.6,76.8,76.8,76.8,76.8,76.8zM102.4,76.8h51.2c14.1,0,25.6,11.5,25.6,25.6l0,0v51.2h51.2v-128h-128C102.4,25.6,102.4,76.8,102.4,76.8zM25.6,102.4v128h128v-128C153.6,102.4,25.6,102.4,25.6,102.4z"/></symbol><symbol id="icon-symbol-clipboard-cut" viewBox="0 0 256 256"><path d="M125.1,147.2l68.3,50c5.6,4.2,15.9,7.5,22.9,7.5H256L88.3,81.7c0.9-3.4,1.5-7.3,1.5-11.3c0-24.7-20-44.8-44.8-44.8S0.2,45.7,0.2,70.4s20,44.8,44.8,44.8c9.6,0,18.4-3,25.7-8.1l-0.1,0.1L99,128.1l-28.5,20.9c-7.2-5.1-16.1-8.1-25.7-8.1C20,140.8,0,160.9,0,185.6s20,44.8,44.8,44.8s44.8-20,44.8-44.8c0-4-0.5-7.8-1.5-11.5l0.1,0.3l37.1-27.1L125.1,147.2zM44.9,89.7c-10.6,0-19.2-8.6-19.2-19.2s8.6-19.2,19.2-19.2l0,0c10.6,0,19.2,8.6,19.2,19.2S55.5,89.7,44.9,89.7C44.9,89.7,44.9,89.7,44.9,89.7zM44.9,204.8c-10.6,0-19.2-8.6-19.2-19.2s8.6-19.2,19.2-19.2l0,0c10.6,0,19.2,8.6,19.2,19.2S55.5,204.8,44.9,204.8L44.9,204.8zM193.3,58.8c6.5-4.4,14.4-7.1,22.9-7.5l0.1,0H256l-96,70.4l-26.2-19.2C133.8,102.5,193.3,58.8,193.3,58.8z"/></symbol><symbol id="icon-symbol-clipboard-paste" viewBox="0 0 256 256"><g transform="scale(0.0 0.0)"><path d="M6881.4,13099.8H1310.7C586.8,13099.8,0,12512.9,0,11789l0,0V3924.6c0-720.9,589.8-1310.7,1310.7-1310.7h655.4v-655.4l1330.4-262.1C3437.2,736.4,4254.9,7.6,5242.9,7.6s1805.8,728.8,1945.2,1678.1l1.3,10.7l1330.4,262.1v655.4h655.4c723.9,0,1310.7,586.8,1310.7,1310.7l0,0V4580H9175.2v-655.4h-655.4V4580H1966.1v-655.4h-655.4V11789h3276.8v1310.7C4587.6,13099.8,6881.4,13099.8,6881.4,13099.8zM5242.9,2613.9c362,0,655.4-293.4,655.4-655.4s-293.4-655.4-655.4-655.4l0,0c-362,0-655.4,293.4-655.4,655.4S4881,2613.9,5242.9,2613.9L5242.9,2613.9zM6553.7,5235.3h5242.9c723.9,0,1310.7,586.8,1310.7,1310.7l0,0V11789c0,723.9-586.8,1310.7-1310.7,1310.7l0,0H6553.7c-723.9,0-1310.7-586.8-1310.7-1310.7l0,0V6546.1C5242.9,5825.2,5832.8,5235.3,6553.7,5235.3zM6553.7,6546.1V11789h5242.9V6546.1C11796.6,6546.1,6553.7,6546.1,6553.7,6546.1z"/></g></symbol><symbol id="icon-symbol-clock" viewBox="0 0 256 256"><g><path fill="none" d="M128,44.5c-53.0,0-96.1,43.1-96.1,96.1S75.0,236.6,128,236.6s96.1-43.1,96.1-96.1S181.0,44.5,128,44.5zM131.5,143.9c-0.0,0.0-0.0,0.1-0.1,0.1c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.0-0.3,0.1-0.4,0.1c-0.2,0.0-0.3,0.1-0.5,0.1c-0.1,0.0-0.2,0.0-0.3,0.0c-0.1,0.0-0.2,0.0-0.3,0.0c0,0-0.0,0-0.0,0s0,0-0.0,0c-0.0,0-0.0,0-0.0,0c-0.1,0-0.2-0.0-0.3-0.0c-0.2-0.0-0.4-0.0-0.6-0.1c-0.3-0.1-0.6-0.1-0.9-0.3c-0.0-0.0-0.1-0.0-0.1-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.4-0.3-0.5-0.4c-0.0-0.0-0.0-0.0-0.1-0.0L82.1,101.5c-1.9-1.9-1.9-5.0,0-6.8c1.9-1.9,5.0-1.9,6.8,0l33.6,33.6l-1.7-31.7c-0.1-2.7,1.9-4.9,4.6-5.1c2.7-0.1,5.0,1.9,5.1,4.6l2.4,44.3c0.0,0.0-0.0,0.1-0.0,0.1c0.0,0.2-0.0,0.3-0.0,0.5c-0.0,0.1-0.0,0.3-0.0,0.4c-0.0,0.2-0.1,0.3-0.1,0.5c-0.0,0.2-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3C131.7,143.6,131.6,143.8,131.5,143.9zM128,62.5c-43.2,0-78.4,35.2-78.4,78.4c0,2.7-2.2,4.8-4.8,4.8s-4.8-2.2-4.8-4.8c0-48.6,39.5-88.1,88.1-88.1c2.7,0,4.8,2.2,4.8,4.8C132.8,60.3,130.7,62.5,128,62.5z"/><path d="M213.8,63.4l15.7-15.7c3.8-3.8,3.8-9.9,0-13.7c-3.8-3.8-9.9-3.8-13.7,0L199.7,50.2c-19.7-15.6-44.6-25.0-71.7-25.0c-63.6,0-115.4,51.8-115.4,115.4C12.6,204.2,64.4,256,128,256c63.6,0,115.4-51.8,115.4-115.4C243.4,110.9,232.2,83.9,213.8,63.4zM128,236.6c-53.0,0-96.1-43.1-96.1-96.1S75.0,44.5,128,44.5s96.1,43.1,96.1,96.1S181.0,236.6,128,236.6z"/><path d="M132.3,142.7c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.1-0.3,0.1-0.4c0.0-0.2,0.1-0.3,0.1-0.5c0.0-0.1,0.0-0.3,0.0-0.4c0.0-0.2,0.0-0.3,0.0-0.5c-0.0-0.0,0.0-0.1,0.0-0.1l-2.4-44.3c-0.1-2.7-2.4-4.7-5.1-4.6c-2.7,0.1-4.7,2.4-4.6,5.1l1.7,31.7L88.9,94.7c-1.9-1.9-5.0-1.9-6.8,0c-1.9,1.9-1.9,5.0,0,6.8l42.5,42.5c0.0,0.0,0.0,0.0,0.1,0.0c0.2,0.2,0.3,0.3,0.5,0.4c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.1,0.5,0.3,0.7,0.4c0.0,0.0,0.1,0.0,0.1,0.1c0.3,0.1,0.6,0.2,0.9,0.3c0.2,0.0,0.4,0.0,0.6,0.1c0.1,0.0,0.2,0.0,0.3,0.0c0.0,0,0.0,0,0.0,0c0,0,0,0,0.0,0s0.0,0,0.0,0c0.1,0,0.2-0.0,0.3-0.0c0.1-0.0,0.2-0.0,0.3-0.0c0.2-0.0,0.3-0.0,0.5-0.1c0.2-0.0,0.3-0.1,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.0-0.0,0.0-0.1,0.1-0.1c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.3C132.2,143.0,132.2,142.9,132.3,142.7z"/><path d="M104.5,19.4h46.9c5.3,0,9.7-4.3,9.7-9.7S156.8,0,151.5,0h-46.9c-5.3,0-9.7,4.3-9.7,9.7S99.2,19.4,104.5,19.4z"/><path d="M128,52.8c-48.6,0-88.1,39.5-88.1,88.1c0,2.7,2.2,4.8,4.8,4.8s4.8-2.2,4.8-4.8c0-43.2,35.2-78.4,78.4-78.4c2.7,0,4.8-2.2,4.8-4.8C132.8,55.0,130.7,52.8,128,52.8z"/></g></symbol><symbol id="icon-symbol-code" viewBox="0 0 256 256"><path d="M32 128l64-64H64L0 128l64 64h32l-64-64zm160-64h-32l64 64-64 64h32l64-64-64-64zm-56-32L96 224h24l40-192h-24z"/></symbol><symbol id="icon-symbol-cookie" viewBox="0 0 256 256"><path d="M256.0,93.9l-0.1-3.4l-3.4-0.3c-8.6-0.7-15.7-7.2-17.2-15.8l-0.7-4.1l-4.1,1.1c-2.1,0.6-4.3,0.9-6.5,0.9c-13.3,0-24.1-10.8-24.1-24.1c0-1.6,0.2-3.2,0.5-4.8l0.7-3.6l-3.6-0.8c-8.7-1.9-14.9-9.8-14.9-18.7c0-1.6,0.2-3.2,0.6-4.8l1.1-4.3l-4.4-0.5c-3.1-0.3-6.3-0.5-9.4-0.5c-40.0,0-73.6,27.6-82.9,64.7c-0.8-0.0-1.5-0.0-2.3-0.0C38.3,74.9,0,113.2,0,160.3c0,47.1,38.3,85.4,85.4,85.4c40.0,0,73.6-27.6,82.9-64.7c0.8,0.0,1.5,0.0,2.3,0.0c47.1,0,85.4-38.3,85.4-85.4C256,95.1,256.0,94.5,256.0,93.9zM85.4,238.2c-42.9,0-77.8-34.9-77.8-77.8c0-42.9,34.9-77.8,77.8-77.8s77.8,34.9,77.8,77.8C163.3,203.3,128.3,238.2,85.4,238.2zM170.6,173.5c-0.2,0-0.5-0.0-0.7-0.0c0.7-4.3,1.0-8.7,1.0-13.1c0-43.7-33.0-79.9-75.5-84.8c8.9-33.2,39.2-57.7,75.2-57.7c1.5,0,3.0,0.0,4.5,0.1c-0.1,0.8-0.1,1.5-0.1,2.3c0,11.2,7.2,21.3,17.5,25.1c-0.1,0.9-0.1,1.9-0.1,2.8c0,17.5,14.2,31.7,31.7,31.7c1.6,0,3.2-0.1,4.7-0.4c2.9,8.9,10.4,15.7,19.6,17.7C247.5,139.4,213.0,173.5,170.6,173.5z"/><path d="M171.7,50.0c0-6.3-5.2-11.5-11.5-11.5c-6.3,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5S171.7,56.3,171.7,50.0zM156.4,50.0c0-2.1,1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9c0,2.1-1.7,3.9-3.9,3.9C158.1,53.9,156.4,52.1,156.4,50.0z"/><path d="M111.2,59.6l6.5,4.0c1.0-1.7,2.2-3.3,3.3-4.9l-6.1-4.6C113.6,55.9,112.3,57.8,111.2,59.6z"/><path d="M119.5,48.7l5.6,5.1c6.5-7.1,14.7-12.8,23.7-16.3l-2.8-7.1C136.0,34.4,126.8,40.7,119.5,48.7z"/><path d="M220.9,132.1l6.1,4.5c3.6-4.8,6.5-10.1,8.8-15.7l-7.0-2.9C226.7,123.1,224.1,127.8,220.9,132.1z"/><path d="M194.1,122.9c-6.3,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5C205.5,128.1,200.4,122.9,194.1,122.9zM194.1,138.3c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9C197.9,136.6,196.2,138.3,194.1,138.3z"/><path d="M170.6,73.7c-6.3,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5c6.3,0,11.5-5.2,11.5-11.5C182.1,78.8,176.9,73.7,170.6,73.7zM170.6,89.0c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9S172.7,89.0,170.6,89.0z"/><path d="M227.1,103.9c0-7.8-6.4-14.2-14.2-14.2s-14.2,6.4-14.2,14.2c0,7.8,6.4,14.2,14.2,14.2C220.7,118.1,227.1,111.7,227.1,103.9zM212.8,110.5c-3.7,0-6.6-3.0-6.6-6.6s3.0-6.6,6.6-6.6s6.6,3.0,6.6,6.6S216.5,110.5,212.8,110.5z"/><path d="M90.4,116.1c6.3,0,11.5-5.2,11.5-11.5S96.8,93.1,90.4,93.1s-11.5,5.2-11.5,11.5S84.1,116.1,90.4,116.1zM90.4,100.7c2.1,0,3.9,1.7,3.9,3.9s-1.7,3.9-3.9,3.9c-2.1,0-3.9-1.7-3.9-3.9S88.3,100.7,90.4,100.7z"/><path d="M34.4,123.1l-6.1-4.6c-1.3,1.8-2.6,3.6-3.7,5.5l6.5,4.0C32.1,126.3,33.2,124.7,34.4,123.1z"/><path d="M62.2,101.9l-2.8-7.1c-10.0,3.9-19.2,10.2-26.5,18.2l5.6,5.1C45.0,111.1,53.2,105.5,62.2,101.9z"/><path d="M136.0,197.4l6.1,4.5c3.6-4.8,6.5-10.1,8.8-15.7l-7.0-2.9C141.8,188.3,139.2,193.0,136.0,197.4z"/><path d="M25.0,193.7c3.4,6.1,7.6,11.6,12.5,16.5l5.3-5.4c-4.4-4.3-8.2-9.3-11.2-14.7L25.0,193.7z"/><path d="M26.3,177.0l-7.3,2.0c0.8,2.8,1.7,5.5,2.8,8.1l7.0-2.9C27.8,181.9,27.0,179.5,26.3,177.0z"/><path d="M108.9,187.6c-6.3,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5c6.3,0,11.5-5.2,11.5-11.5S115.2,187.6,108.9,187.6zM108.9,203.0c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9s3.9,1.7,3.9,3.9S111.0,203.0,108.9,203.0z"/><path d="M32.9,141.2c-6.3,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5s11.5-5.2,11.5-11.5C44.4,146.3,39.3,141.2,32.9,141.2zM32.9,156.5c-2.1,0-3.9-1.7-3.9-3.9c0-2.1,1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9S35.1,156.5,32.9,156.5z"/><path d="M85.4,138.4c-6.3,0-11.5,5.2-11.5,11.5c0,6.3,5.2,11.5,11.5,11.5c6.3,0,11.5-5.2,11.5-11.5S91.8,138.4,85.4,138.4zM85.4,153.7c-2.1,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9c2.1,0,3.9,1.7,3.9,3.9S87.6,153.7,85.4,153.7z"/><path d="M123.9,158.1c0,7.8,6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2s-6.4-14.2-14.2-14.2S123.9,150.3,123.9,158.1zM144.8,158.1c0,3.7-3.0,6.6-6.6,6.6c-3.7,0-6.6-3.0-6.6-6.6s3.0-6.6,6.6-6.6C141.8,151.5,144.8,154.5,144.8,158.1z"/><path d="M64.7,198.6c-7.8,0-14.2,6.4-14.2,14.2s6.4,14.2,14.2,14.2s14.2-6.4,14.2-14.2C78.9,204.9,72.5,198.6,64.7,198.6zM64.7,219.4c-3.7,0-6.6-3.0-6.6-6.6c0-3.7,3.0-6.6,6.6-6.6c3.7,0,6.6,3.0,6.6,6.6C71.3,216.4,68.3,219.4,64.7,219.4z"/></symbol><symbol id="icon-symbol-copy" viewBox="0 0 256 256"><g><path d="M128.2,214.4c-50.4,0-91.5-41-91.5-91.5s41-91.5,91.5-91.5s91.5,41,91.5,91.5c0,14.8-3.5,28.8-9.8,41.2c2.3,5,4.1,10.3,5.3,15.8c10.7-16.4,17-35.9,17-57C232.1,65.5,185.6,19,128.2,19C70.7,19,24.2,65.5,24.2,122.9s46.5,103.9,103.9,103.9c6.4,0,12.6-0.6,18.7-1.7l-11-11.1C133.3,214.3,130.7,214.4,128.2,214.4z"/><g><path d="M214.3,180L164,231l-50.3-51h15.1h18l-0.5-18c-0.5-21.9-3.4-45.5-15.8-67.5c11.5,5.3,21.8,13,30.1,22.9c1.7,2,3.3,4.1,4.8,6.2c1.5,2.1,2.9,4.4,4.2,6.6c6.1,10.5,9.9,22,11.2,34.1l1.7,15.6h15.7H214.3M240,174.1c0-3-1.1-6-3.4-8.3c-2.3-2.3-5.3-3.4-8.3-3.4h-29.9c-1.6-14.8-6.3-28.7-13.5-41c-1.6-2.7-3.3-5.4-5.1-8c-1.8-2.6-3.7-5.1-5.8-7.4C154.8,83.3,126,68.9,93.8,68.9H82.1c40,26.3,45.8,61.4,46.6,93.6H99.7c-0.4,0-0.7,0-1.1,0.1c-1.1,0.1-2.2,0.4-3.3,0.8c-1.4,0.6-2.7,1.4-3.9,2.6c-2.3,2.3-3.4,5.3-3.4,8.3c0,0.7,0.1,1.5,0.2,2.2c0.3,1.5,0.9,2.9,1.7,4.2c0.4,0.6,0.9,1.3,1.5,1.8L164,256l72.6-73.6c0.6-0.6,1.1-1.2,1.5-1.8c0.9-1.3,1.4-2.7,1.7-4.2C239.9,175.6,240,174.9,240,174.1L240,174.1z"/></g></g></symbol><symbol id="icon-symbol-eye" viewBox="0 0 256 256"><path d="M255.7 126.2c-.08-.336-.032-.697-.16-1.0-.05-.136-.17-.208-.217-.336-.08-.192-.064-.41-.168-.593-23.2-44.5-73.8-76.3-127.2-76.3-53.4 0-103.9 31.8-127.2 76.3-.104.2-.88.4-.168.6-.56.1-.168.2-.216.3-.127.3-.8.7-.16 1.0-.144.6-.28 1.2-.28 1.8s.144 1.2.28 1.8c.8.3.32.7.16 1.0.48.1.168.2.216.3.8.2.64.4.168.6 23.2 44.5 73.8 76.3 127.2 76.3 53.4 0 103.9-31.8 127.2-76.3.112-.184.1-.4.2-.592.0-.13.2-.2.2-.338.1-.328.1-.69.2-1.0.135-.61.3-1.2.28-1.8 0-.61-.145-1.2-.28-1.8zM128 192.0c-45.0 0-89.0-25.6-111.0-64.0C39.1 89.4 83.1 64.0 128 64.0c45.0 0 89.0 25.6 111.0 64.1-22.1 38.5-66.0 64.0-111.0 64.0zm0-96.0c2.2 0 4.0 1.8 4.0 4.0 0 2.2-1.8 4.0-4.0 4.0v.008c-13.3 0-24.0 10.8-24.0 24.0 0 2.2-1.8 4.0-4.0 4.0-2.2 0-4.0-1.8-4.0-4.0 0-17.7 14.3-32.0 32.0-32.0.018 0 .034-.1.1-.01zm-.185-24.0c-31.0 0-56.1 25.1-56.1 56.1s25.1 56.1 56.1 56.1c31.0 0 56.1-25.1 56.1-56.1 0-31.0-25.1-56.1-56.1-56.1zm0 104.2c-26.5 0-48.1-21.6-48.1-48.1s21.6-48.1 48.1-48.1 48.1 21.6 48.1 48.1c0 26.5-21.6 48.1-48.1 48.1z"/></symbol><symbol id="icon-symbol-feed" viewBox="0 0 256 256"><path d="M128 0C57.3 0 0 57.3 0 128s57.3 128 128 128 128-57.3 128-128S198.7 0 128 0zM80 192c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm44 0c0-33.1-26.9-60-60-60v-24c46.3 0 84 37.7 84 84h-24zm48 0c0-28.8-11.2-56.0-31.6-76.4C120.0 95.2 92.8 84 64 84V60c35.3 0 68.4 13.7 93.3 38.7S196 156.7 196 192h-24z"/></symbol><symbol id="icon-symbol-fire" viewBox="0 0 256 256"><path d="M176.0 72c-.496 21.4-16.6 39.5-16.6 39.5C159.4 71.7 128.0 40 128.0 40s-.424 23.7-16.3 47.6C95.7 31.8 47.9 0 47.9 0c23.9 87.6-8.0 119.4-8.0 183.1 0 37.4 31.6 72.9 80 72.9 71.7 0 85.5-26.3 92.9-55.9 10.2-40.8-5.1-88.2-36.9-128.1zm21.4 124.2C192.2 216.7 186.4 240 120.0 240c-40.1 0-64-28.9-64-56.9 0-21.4 3.9-39.0 8.0-57.6 5.2-23.6 10.6-47.7 8.3-79.7 24.7 34.2 33.5 79.4 33.5 79.4s23.0-32.2 29.1-47.2C139.6 87.7 144.0 120 144.0 152c0 0 21.2-17.5 37.2-43.8 16.8 30.1 22.8 61.6 16.2 88.0zm-18.0-61.8l1.5 8.3c3.3 18.5 1.5 40.5-4.7 55.9-.624 1.6-2.1 2.5-3.7 2.5-.504 0-1.0-.097-1.5-.29-2.0-.823-3.0-3.1-2.2-5.2 4.7-11.6 6.6-27.9 5.4-42.8-8.0 9.0-18.2 18.3-39.8 28.6l-4.0 1.9-1.5-4.2c-2.9-8.4-5.8-16.9-7.1-28.7-4.3 6.8-8.3 12.9-14.9 21.9l-4.1 5.5-2.8-6.3c-6.9-15.4-12.1-27.4-16.3-38-3.8 12.4-6.7 26.7-6.7 55.5 0 2.2-1.8 4-4 4-2.2 0-4-1.8-4-4 0-37.7 5-52.2 10.3-67.5l4.2-12.1 3.8 10.8c4.1 11.6 9.5 24.4 17.2 41.7 5.1-7.1 8.4-12.5 12.5-19.0l12.1-19.0v13.7c0 15.4 2.8 25.4 5.8 34.6 21.3-10.7 29.2-20.0 37.7-29.8l6.8-7.9z"/></symbol><symbol id="icon-symbol-folder" viewBox="0 0 256 256"><path d="M238.8 141.3c0-3.1-2.4-4.7-7.1-4.7H85.8c-3.6 0-7.4.96-11.5 2.9s-7.3 4.3-9.6 7.0l-39.4 48.7c-1.6 2.1-2.4 3.9-2.4 5.4 0 3.1 2.4 4.7 7.1 4.7H175.9c3.6 0 7.4-.983 11.5-3.0 4.1-2.0 7.3-4.3 9.5-7.1l39.4-48.7c1.6-2.0 2.4-3.7 2.4-5.2zm-153.0-21.9h103.0V98.0c0-3.6-1.3-6.6-3.8-9.1-2.5-2.5-5.5-3.8-9.1-3.8H98.7c-3.6 0-6.6-1.3-9.1-3.8-2.5-2.5-3.8-5.5-3.8-9.1v-8.6c0-3.6-1.3-6.6-3.8-9.1-2.5-2.5-5.5-3.8-9.1-3.8H30.0c-3.6 0-6.6 1.3-9.1 3.8-2.5 2.5-3.8 5.5-3.8 9.1v114.4l34.3-42.2c3.9-4.7 9.1-8.7 15.6-11.7 6.4-3.1 12.7-4.6 18.8-4.6zM256 141.3c0 5.5-2.1 10.9-6.2 16.1l-39.6 48.7c-3.8 4.7-9.0 8.7-15.6 11.7-6.5 3.1-12.8 4.6-18.8 4.6H30.0c-8.2 0-15.3-3.0-21.2-8.8S0 200.6 0 192.4V63.6c0-8.2 3.0-15.3 8.8-21.2s13.0-8.8 21.2-8.8H73.0c8.2 0 15.3 3.0 21.2 8.8 5.9 5.9 8.8 13.0 8.8 21.2v4.3h73.0c8.2 0 15.3 3.0 21.2 8.8s8.9 13.0 8.9 21.2v21.5h25.7c4.8 0 9.3 1.1 13.3 3.3 4.0 2.2 7.0 5.3 9.0 9.5 1.3 2.9 2.0 5.9 2.0 9.1z"/></symbol><symbol id="icon-symbol-forward" viewBox="0 0 256 256"><path d="M40 0c4.4 0 8.2 1.6 11.4 4.8l112 112C166.5 119.8 168 123.6 168 128c0 4.5-1.5 8.3-4.6 11.4l-112 112C48.3 254.5 44.5 256 40 256c-4.4 0-8.2-1.5-11.3-4.6S24 244.5 24 240.1c0-4.3 1.5-8.1 4.6-11.4L129.4 128 28.6 27.4C25.5 24.1 24 20.3 24 16c0-4.4 1.6-8.2 4.7-11.3S35.6 0 40 0zm176 0c4.4 0 8.2 1.6 11.3 4.7S232 11.6 232 16v224c0 4.4-1.6 8.2-4.7 11.3S220.4 256 216 256s-8.2-1.6-11.3-4.7S200 244.4 200 240V16c0-4.4 1.6-8.2 4.7-11.3S211.6 0 216 0z"/></symbol><symbol id="icon-symbol-heart-full" viewBox="0 0 256 256"><path d="M233.5,38.1C204.5,9.3,158.1,8.7,128,35.8C97.9,8.7,51.5,9.3,22.4,38.1c-29.9,29.6-29.9,77.7,0,107.3c8.6,8.5,88.4,87.5,88.4,87.5c9.5,9.4,24.8,9.4,34.2,0c0,0,87.5-86.6,88.4-87.5C263.5,115.8,263.5,67.7,233.5,38.1zM74.0,56c0.0,0,0.0-0.0,0.0-0.0c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4h-0.0c-14.3,0-26.0,11.6-26.0,26c0,1.1-0.5,2.1-1.2,2.8c-0.7,0.7-1.7,1.2-2.8,1.2c-2.2,0-4-1.8-4-4C40,71.2,55.2,56.0,74.0,56z"/></symbol><symbol id="icon-symbol-heart" viewBox="0 0 256 256"><path d="M233.5 38.1c-29.0-28.8-75.5-29.4-105.5-2.3C97.9 8.7 51.5 9.3 22.4 38.1c-29.9 29.6-29.9 77.7 0 107.3 8.6 8.5 88.4 87.5 88.4 87.5 9.5 9.4 24.8 9.4 34.2 0 0 0 87.5-86.6 88.4-87.5 29.9-29.7 29.9-77.7-.01-107.3zm-11.4 96.0l-88.4 87.5c-3.1 3.1-8.3 3.1-11.4 0l-88.4-87.5c-23.6-23.4-23.6-61.4 0-84.7 22.8-22.5 59.3-23.3 83.3-1.8l10.8 9.8 10.8-9.8c24.0-21.5 60.5-20.8 83.3 1.8 23.6 23.4 23.6 61.4.01 84.7zM74.0 56.0c2.2 0 4 1.8 4 4 0 2.2-1.8 4-4 4h-.007c-14.4 0-26.0 11.6-26.0 26.0v.008c0 2.2-1.8 4-4 4-2.2 0-4-1.8-4-4 0-18.8 15.2-34.0 34.0-34.0.017 0 .017-.7.0-.007z"/></symbol><symbol id="icon-symbol-hidepass" viewBox="0 0 256 256"><path d="M255.7,126.2c-0.1-0.3,0-0.7-0.2-1c0-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.1-0.4-0.2-0.6C243,101,223.4,81.2,199.7,67.6l41.4-41.4c1.6-1.6,2.3-3.6,2.3-5.6c0-2.1-0.8-4.1-2.3-5.7c-3.1-3.1-8.2-3.1-11.3,0L184.7,60c-17.7-7.7-37-12-56.7-12c-53.4,0-103.9,31.8-127.2,76.3c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.3-0.1,0.7-0.2,1C0.1,126.8,0,127.3,0,128c0,0.6,0.1,1.2,0.3,1.8c0.1,0.3,0,0.7,0.2,1c0,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.2,0.6C13,155,32.7,174.8,56.3,188.4l-41.4,41.4c-1.6,1.6-2.3,3.6-2.3,5.6c0,2.1,0.8,4.1,2.3,5.7c3.1,3.1,8.2,3.1,11.3,0L71.3,196c17.7,7.7,37,12,56.7,12c53.3,0,103.9-31.8,127.2-76.3c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.2-0.2,0.2-0.3c0.1-0.3,0.1-0.7,0.2-1c0.1-0.6,0.3-1.2,0.3-1.8C256,127.4,255.8,126.8,255.7,126.2zM68,176.7c-21.1-11.2-39.2-28.1-51-48.7c22.1-38.5,66-64,111-64c15.2,0,30.3,2.9,44.5,8.3l-11,11c-9.4-7.1-21-11.2-33.7-11.2C96.8,72,71.7,97,71.7,128c0,12.6,4.2,24.3,11.2,33.7L68,176.7zM128,192c-15.2,0-30.3-2.9-44.4-8.3L94.3,173c9.3,7,21,11.1,33.5,11.1c31,0,56.1-25.1,56.1-56.1c0-12.6-4.1-24.2-11.1-33.5L188,79.3c21.1,11.3,39.2,28.1,50.9,48.7C216.9,166.5,172.9,192,128,192z"/></symbol><symbol id="icon-symbol-idea" viewBox="0 0 256 256"><path d="M128 0C79.4 0 40 39.4 40 88c0 32.2 29.5 66.4 40.2 96.4C96.3 229.2 94.5 256 128 256c34 0 31.7-26.7 47.8-71.4C186.5 154.5 216 120 216 88c0-48.6-39.4-88-88-88zm20.7 217.4l-39.7 5.0c-1.4-4.1-2.9-8.9-4.8-15.1-.024-.08-.056-.168-.072-.25l49.5-6.2c-.704 2.4-1.5 4.8-2.1 7.1-1.0 3.6-2.0 6.7-2.9 9.6zm-46.8-18.1c-1.5-4.8-3.1-9.9-4.9-15.3h62.1c-.983 2.9-2.0 5.8-2.8 8.5l-54.4 6.8zM128 240c-8.1 0-11.8-.936-16.0-10l33.9-4.2C141.0 239.0 137.4 240 128 240zm37.4-72H90.7c-4.0-8.6-8.8-17.3-13.5-25.7C66.8 123.6 56 104.3 56 88c0-39.7 32.3-72 72-72s72 32.3 72 72c0 16.1-10.8 35.6-21.2 54.4-4.7 8.4-9.4 17.0-13.4 25.6zM128 40c2.2 0 4 1.8 4 4s-1.8 4-4 4c-22.1 0-40 17.9-40 40 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-26.5 21.5-48 48-48z"/></symbol><symbol id="icon-symbol-info" viewBox="0 0 256 256"><path d="M128 256C57.4 256 0 198.6 0 128S57.4 0 128 0s128 57.4 128 128-57.4 128-128 128zm0-237.4C67.7 18.6 18.6 67.7 18.6 128S67.7 237.4 128 237.4 237.4 188.3 237.4 128 188.3 18.6 128 18.6zM151.7 219.8c0 1.8-.17 2.8-.497 3.0-.336.2-1.4.25-3.2.25h-37.7c-1.5 0-2.5-.123-3.0-.372-.494-.25-.744-1.2-.744-2.9v-84.2H93.1c-1.5 0-2.4-.204-2.9-.62-.416-.41-.623-1.3-.623-2.6v-28.3c0-1.6.207-2.7.623-3.1.413-.41 1.4-.62 2.9-.62h55.1c1.6 0 2.6.21 3.0.62.3.417.5 1.5.497 3.1v115.7zm2.7-160.4c0 3.5-.662 6.8-2.0 10.1-1.3 3.2-3.2 6.1-5.6 8.6-2.4 2.5-5.3 4.5-8.6 6.0-3.3 1.5-6.9 2.2-10.7 2.2-3.8 0-7.4-.747-10.7-2.2-3.3-1.5-6.1-3.5-8.4-6.0-2.3-2.5-4.1-5.3-5.5-8.6-1.3-3.2-2.0-6.6-2.0-10.1 0-3.5.663-6.8 2.0-10.1 1.3-3.2 3.2-6.0 5.6-8.4 2.4-2.4 5.3-4.3 8.6-5.7 3.3-1.4 6.9-2.1 10.7-2.1 3.8 0 7.3.707 10.6 2.1 3.2 1.4 6.0 3.4 8.4 5.8 2.4 2.5 4.3 5.3 5.6 8.4 1.3 3.1 2.0 6.5 2.0 9.9z"/></symbol><symbol id="icon-symbol-key" viewBox="0 0 256 256"><path d="M610.5 521.8c-6.4-4.3-123.1-80.8-296.7-118.4 63.7-80.7 104.6-189.2 122.0-261.4 24.1-100.1 14.8-295.9-81.4-418.0C298.2-347.3 219.5-385 127-385s-171.2 37.7-227.3 109.0C-196.5-154.0-205.8 41.8-181.7 141.9c17.4 72.2 58.2 180.7 122.0 261.4-173.6 37.6-290.3 114.1-296.7 118.4-23.5 15.6-34.0 44.8-25.8 71.7C-374.1 620.5-349.2 639-321 639h896c28.2 0 53.1-18.5 61.2-45.5 8.2-26.9-2.3-56.1-25.7-71.7zM263.5 363.7l-10.4 13.2c-76.3 87.7-175.8 87.7-252.1 0L-9.5 363.7c-89.1-112.9-133.3-262.3-114.3-404.8C-106.3-178.0-27.9-321 127-321S360.4-178.0 377.8-41.0c19.0 142.6-25.1 291.8-114.3 404.8zM-321 575c4.4-2.9 112.8-74.0 274.8-109.1L33.2 448.8C61.6 467.4 92.8 479 127 479c34.3 0 65.4-11.6 93.8-30.2l79.5 17.2C460.9 500.7 568.9 571 575 575h-896z"/></symbol><symbol id="icon-symbol-lab" viewBox="0 0 256 256"><path d="M165.5 29.9c-3.8-3.8-8.8-5.9-14.1-5.9s-10.4 2.1-14.2 5.9l-11.3 11.3c-3.8 3.8-5.9 8.8-5.9 14.2 0 3.8 1.0 7.4 3.0 10.5L14.4 109.3C7.1 112.5 1.9 119.1.42 126.8c-1.5 7.8 1 15.8 6.7 21.5l101.8 100.6c4.4 4.4 10.2 6.9 16.4 7.0.144.0.48.0.624.0 1.6 0 3.3-.17 4.9-.497 8.0-1.6 14.5-7.1 17.4-14.6l42.7-107.0c3.2 2.1 7 3.3 10.9 3.3 5.4 0 10.4-2.1 14.1-5.9L227.2 120c3.8-3.8 5.9-8.8 5.9-14.2s-2.1-10.4-5.9-14.1l-61.8-61.8zm-32.2 205.1c-.99 2.5-3.2 4.4-5.8 4.9-.608.1-1.2.177-1.8.17-2.0-.05-4.0-.865-5.5-2.3L18.3 137.0c-1.9-1.9-2.7-4.5-2.2-7.1.488-2.6 2.2-4.8 4.7-5.8l49.7-19.9c33.5 11.1 67.0.408 100.6 36.2l-37.8 94.7zm82.7-126.3l-11.3 11.3c-1.6 1.6-4.1 1.6-5.7 0l-14.1-14.1-11.5 28.7.95-2.4c-24.1-24.0-48.5-27.1-70.6-29.8-7.1-.872-14.0-1.8-20.7-3.2l67.9-27.2-13.7-13.7c-1.6-1.6-1.6-4.1 0-5.7l11.3-11.3c1.6-1.6 4.1-1.6 5.7 0l61.8 61.8c1.6 1.6 1.6 4.1.01 5.7zM132.0 168c11.0 0 20-9.0 20-20 0-11.0-9.0-20-20-20-11.0 0-20 9.0-20 20 0 11.0 9.0 20 20 20zm0-32c6.6 0 12 5.4 12 12s-5.4 12-12 12c-6.6 0-12-5.4-12-12s5.4-12 12-12zM236 .002c-11.0 0-20 9.0-20 20s9.0 20 20 20c11.0 0 20-9.0 20-20s-9.0-20-20-20zm0 32c-6.6 0-12-5.4-12-12 0-6.6 5.4-12 12-12s12 5.4 12 12c0 6.6-5.4 12-12 12zM64.0 136c0 8.8 7.2 16 16 16s16-7.2 16-16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16-8c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm16 56c0-4.4 3.6-8 8-8 4.4 0 8 3.6 8 8s-3.6 8-8 8c-4.4 0-8-3.6-8-8zM224 64c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8z"/></symbol><symbol id="icon-symbol-lock" viewBox="0 0 256 256"><path d="M200 104V72c0-39.8-32.2-72-72-72S56 32.2 56 72v32c-13.3 0-24 10.7-24 24v56c0 39.8 32.2 72 72 72h48c39.8 0 72-32.2 72-72v-56c0-13.3-10.8-24-24-24zM72 72c0-30.9 25.1-56 56-56s56 25.1 56 56v32h-16V72.0c0-22.1-17.9-40-40-40s-40 17.9-40 40V104H72V72zm88 0v32H96V72c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 80v32c0 30.9-25.1 56-56 56h-48c-30.9 0-56-25.1-56-56v-56c0-4.4 3.6-8 8-8 5.3 0 10.7 0 16 0h112c5.3 0 10.7 0 16 0 4.4 0 8 3.6 8 8v24zm-80 0c8.8 0 16 7.2 16 16 0 4.9-2.6 14.1-5.3 21.5-2.2 5.9-4.4 10.5-10.7 10.5-5.8 0-8.5-4.7-10.7-10.6C114.7 182.1 112 172.9 112 168c0-8.8 7.2-16 16-16z"/></symbol><symbol id="icon-symbol-lowercase" viewBox="0 0 256 256"><path d="M255.0,124.1L130.4,2.4c-1.3-1.3-3.4-1.3-4.8,0L1.0,124.1c-1.0,1.0-1.3,2.4-0.8,3.7c0.5,1.3,1.8,2.1,3.2,2.1H62.3v121.2c0,1.9,1.5,3.4,3.4,3.4h124.6c1.9,0,3.4-1.5,3.4-3.4V129.9h58.9c1.4,0,2.6-0.8,3.2-2.1C256.3,126.5,256.0,125.1,255.0,124.1z"/></symbol><symbol id="icon-symbol-money" viewBox="0 0 256 256"><path d="M251.3 84.7l-80-80.0C167.3.72 161.6-.873 156.2.47c-2.9.705-5.4 2.2-7.5 4.2-1.8 1.8-3.2 4.1-4.0 6.6-3.6 11.8-9.9 22.0-19.2 31.2-12.4 12.4-28.5 21.8-45.6 31.7-18.1 10.5-36.8 21.4-52.2 36.7C14.8 123.9 5.9 138.4.714 155.3c-1.8 5.7-.224 11.8 4.0 16.0l80.0 80.0c4.0 4.0 9.7 5.6 15.2 4.2 2.9-.72 5.4-2.2 7.5-4.2 1.8-1.8 3.2-4.1 4.0-6.6 3.6-11.8 9.9-22.0 19.2-31.2 12.4-12.4 28.5-21.7 45.6-31.6 18.1-10.5 36.8-21.4 52.1-36.7 13.0-13.0 21.9-27.6 27.1-44.4 1.7-5.7.21-11.9-4.0-16.0zM96 240.0c-26.5-26.5-53.5-53.5-80.0-80C38.7 86.4 137.3 89.6 160.0 16c26.5 26.5 53.5 53.5 80.0 80.0C217.3 169.6 118.7 166.4 96 240.0zm60.5-120.8c-2.6-2.2-5.2-3.7-7.9-4.4-2.6-.736-5.2-1.0-7.9-.84-2.6.2-5.3.8-8 1.8-2.7 1.0-5.4 2.2-8.1 3.5-4.3-4.9-8.6-9.8-12.9-14.3 1.9-1.8 3.8-2.6 5.6-2.7 1.8-.08 3.6.112 5.2.528 1.7.424 3.2.784 4.7 1.1 1.4.28 2.7-.032 3.8-.952 1.2-1 1.8-2.3 1.9-3.9.08-1.6-.512-3.1-1.8-4.6-1.7-1.9-3.7-3.1-6.2-3.5-2.4-.424-4.9-.392-7.4.168-2.5.576-4.9 1.5-7.2 2.9-2.3 1.3-4.1 2.7-5.5 4.1-.52-.496-1.0-.984-1.6-1.5-.577-.528-1.3-.816-2.2-.8-.873 0-1.6.376-2.2 1.1-.576.7-.84 1.5-.736 2.3.8.9.423 1.5 1.0 2.0.52.4 1.0.872 1.6 1.3-2.0 2.5-3.7 5.2-5.1 8.1-1.3 2.9-2.1 5.8-2.4 8.5-.31 2.8-.015 5.4.84 7.7.857 2.4 2.4 4.4 4.8 6.3 3.8 3.1 8.2 4.5 13.3 4.2 5.1-.313 10.7-1.8 16.6-5.0 4.7 5.5 9.5 10.9 14.2 15.9-2 1.7-3.8 2.7-5.3 3.0-1.5.328-2.9.296-4.2-.08-1.2-.393-2.4-.952-3.5-1.7-1.1-.736-2.1-1.4-3.2-1.9-1.0-.512-2.1-.8-3.2-.816-1.1-.016-2.2.513-3.5 1.6-1.3 1.1-2.0 2.5-2.0 4.0 0 1.5.688 3 2.0 4.5 1.4 1.5 3.1 2.8 5.3 3.8 2.1 1.0 4.6 1.7 7.2 1.8 2.7.185 5.5-.216 8.4-1.3 3.0-1.1 5.9-3.0 8.8-5.9 1.4 1.4 2.8 2.7 4.2 3.9.592.5 1.3.77 2.2.704.8-.032 1.6-.424 2.2-1.1.593-.72.8-1.5.753-2.3-.08-.84-.425-1.5-1-2.0-1.4-1.1-2.8-2.3-4.2-3.6 2.4-2.9 4.3-6.0 5.7-9.1 1.4-3.1 2.3-6.0 2.5-8.8.28-2.8-.048-5.3-.952-7.5-.898-2.3-2.5-4.3-4.8-6.2zm-44.7 5.4c-2.3.096-4.2-.656-6.0-2.3-.736-.704-1.2-1.6-1.6-2.6-.328-1.0-.44-2.1-.312-3.3.112-1.2.472-2.5 1.1-3.7.592-1.3 1.5-2.5 2.6-3.8 4.1 4.0 8.1 8.5 12.2 13.0-3.1 1.7-5.7 2.6-8.0 2.7zm37.7 16.0c-.72 1.3-1.5 2.5-2.5 3.5-4.5-4.5-9.0-9.5-13.4-14.6 1.1-.512 2.3-1.0 3.6-1.6 1.3-.543 2.6-.903 3.9-1.1 1.3-.2 2.6-.144 4.0.168 1.3.33 2.5 1.0 3.7 2.1 1.1 1.1 1.8 2.3 2.1 3.6.314 1.3.33 2.6.113 3.9-.233 1.3-.705 2.7-1.4 4.0zm-31.8 36.8c1.6-1.3 3.9-1.2 5.3.264 1.6 1.6 1.6 4.1 0 5.7-.13.1-.265.2-.41.3l.17.0c-5.1 3.9-9.2 7.3-13.7 11.8-4.1 4.0-7.7 8.3-10.9 12.6l-5.1 7c-.16.3-.352.6-.592.8-1.6 1.6-4.1 1.6-5.7 0-1.4-1.4-1.5-3.5-.528-5.0l-.016-.016 5.5-7.5c3.4-4.7 7.3-9.2 11.7-13.6 4.5-4.5 9.4-8.6 14.4-12.4h.017zm29.3-115.7c4.0-4.0 7.7-8.3 10.9-12.6l5.3-7.3c.192-.344.4-.688.7-.984 1.6-1.6 4.1-1.6 5.7 0 1.5 1.5 1.6 3.9.2 5.5l.16.0-5.5 7.5c-3.4 4.7-7.3 9.2-11.7 13.6-4.5 4.5-9.4 8.6-14.4 12.4l-.03-.016c-1.6 1.5-4.1 1.4-5.6-.11-1.6-1.6-1.6-4.1 0-5.7.28-.297.6-.505.9-.69 4.7-3.6 9.2-7.4 13.4-11.5z"/></symbol><symbol id="icon-symbol-more" viewBox="0 0 256 256"><circle cx="128" cy="128" r="27.5"/><circle cx="228.5" cy="128" r="27.5"/><circle cx="27.5" cy="128" r="27.5"/></symbol><symbol id="icon-symbol-new-tab" viewBox="0 0 256 256"><path d="M36.6 0v219.4H256V0H36.6zm201.1 201.1H54.9V18.3h182.9v182.9zM18.3 237.7v-192L0 27.4V256h228.6l-18.3-18.3h-192zM82.3 54.9L128 100.6 73.1 155.4l27.4 27.4L155.4 128l45.7 45.7V54.9H82.3z"/></symbol><symbol id="icon-symbol-paperplane" viewBox="0 0 256 256"><path d="M252.3 1.3C251.0.424 249.5 0 248.0 0c-1.5 0-3.1.44-4.4 1.3L3.6 161.3c-2.5 1.6-3.8 4.5-3.5 7.5.304 3.0 2.2 5.5 5.0 6.6l62.6 25.0 29.4 51.5c1.4 2.5 4.0 4 6.9 4.0.032 0 .056 0 .088 0 2.8 0 5.4-1.5 6.9-3.9l16.6-27.7 77.6 31.0c.952.4 2.0.567 3.0.567 1.4 0 2.7-.344 3.9-1.0 2.1-1.2 3.6-3.3 4.0-5.7l40-240.0c.52-3.1-.873-6.3-3.5-8.0zM25.1 166.2L210.5 42.6 75.7 186.9c-.71-.423-1.3-.982-2.1-1.3l-48.5-19.4zm56.4 26.3c-.016-.032-.04-.048-.056-.08L233 30.2l-129.2 201.3-22.3-39.0zm120.2 44.3l-68.3-27.3c-1.6-.64-3.3-.856-5.0-.952l105.2-163.1-31.9 191.4z"/></symbol><symbol id="icon-symbol-parent-folder" viewBox="0 0 256 256"><path d="M254.0 132.2c-2.0-4.1-5.0-7.3-9.0-9.5-4.0-2.2-8.4-3.3-13.3-3.3H206.0V98.0c0-8.2-3.0-15.3-8.9-21.2s-13.0-8.8-21.2-8.8h-73.0V63.6c0-8.2-3.0-15.3-8.9-21.2-5.9-5.9-13.0-8.8-21.2-8.8H30.0c-8.2 0-15.3 3.0-21.2 8.8S0 55.4 0 63.6v128.7c0 8.2 3.0 15.3 8.8 21.2s13.0 8.8 21.2 8.8h145.9c6.0 0 12.3-1.5 18.8-4.6 6.5-3.1 11.7-7.0 15.6-11.7l39.6-48.7c4.1-5.2 6.2-10.5 6.2-16.1 0-3.2-.67-6.3-2.0-9.1zM17.2 63.6c0-3.6 1.3-6.6 3.8-9.1 2.5-2.5 5.5-3.8 9.1-3.8h42.9c3.6 0 6.6 1.3 9.1 3.8 2.5 2.5 3.8 5.5 3.8 9.1v8.6c0 3.6 1.3 6.6 3.8 9.1 2.5 2.5 5.5 3.8 9.1 3.8h77.2c3.6 0 6.6 1.3 9.1 3.8 2.5 2.5 3.8 5.5 3.8 9.1v21.5H85.8c-6.1 0-12.3 1.5-18.8 4.6-1.5.718-2.9 1.5-4.3 2.3V102.3h20.6L53.6 72.6 23.9 102.3h20.6v41.4c0 .234.0.464.0.694l-27.3 33.6V63.6zm219.3 82.9l-39.4 48.7c-2.2 2.8-5.4 5.1-9.5 7.1-4.1 2.0-8.0 3.0-11.5 3.0H30.0c-4.7 0-7.1-1.6-7.1-4.7 0-1.4.805-3.2 2.4-5.4l39.4-48.7c2.3-2.8 5.5-5.1 9.6-7.0s7.9-2.9 11.5-2.9h145.9c4.7 0 7.1 1.6 7.1 4.7 0 1.5-.805 3.3-2.4 5.2z"/></symbol><symbol id="icon-symbol-pen" viewBox="0 0 256 256"><path d="M235.2 20.6C222.0 7.5 204.7 0 187.6 0c-14.4 0-27.7 5.3-37.4 15.0L111.3 54.2c-.12.1-.256.2-.376.3-.64.1-.104.2-.168.2l.16.0-82.6 83.3c-3.8 3.8-6.6 8.5-8.1 13.6L1.2 219.8c-.16.2-1.2 5.5-1.2 8.2 0 15.5 12.6 28 28.0 28 3.1 0 9.0-1.5 9.3-1.5l67.8-17.8c5.2-1.5 9.8-4.3 13.6-8.1L240.9 105.5C263.1 83.2 260.6 46 235.2 20.6zM128.1 190.4c-.656-7.2-2.7-14.3-5.8-21.0l75.6-75.6c4.6 14.6 2.2 29.9-7.9 40.0-.62.1-.143.1-.198.2l.11.1-61.8 62.3c0-2.0.096-3.9-.087-6.0zm-9.8-28.3c-3.0-4.9-6.4-9.6-10.6-13.8-4.9-4.9-10.5-8.7-16.4-11.9l76.3-76.3c6.0 2.7 11.7 6.4 16.8 11.5 4.3 4.3 7.7 9.1 10.2 14.2l-76.4 76.4zm-34.5-29.6c-7.4-3.0-15.2-4.7-22.9-4.8l61.6-62.1c9.4-9.2 23.2-11.8 36.7-8.5l-75.4 75.4zM33.3 239.0c-.873.2-3.6.888-5.4 1.0-6.6-.08-11.9-5.4-11.9-12 .096-1.3.632-3.7.816-4.5l8.4-30.5c9.1-.248 19.0 3.3 26.7 11.1 7.9 7.8 11.6 17.9 11.2 27.1l-29.8 7.8zm37.7-9.9c-.192-10.7-4.6-21.9-13.4-30.7-8.3-8.3-19.2-13.2-30.1-13.6l8.0-28.9c.576-1.9 1.7-3.8 3.1-5.5 16.0-11.5 40.7-8.1 57.9 9.1 18.1 18.1 20.9 44.7 7.0 60.5-.928.5-1.9.952-2.9 1.2l-29.6 7.8zM229.5 94.2l-13.5 13.6c0-1.8.215-3.5.047-5.4-1.4-15.5-8.6-30.4-20.3-42.2-13.0-13.0-30.3-20.5-47.4-20.6l13.2-13.4c6.6-6.6 15.9-10.3 26.0-10.3 12.9 0 26.1 5.8 36.3 16.0 9.5 9.5 15.2 21.4 16.0 33.3.75 11.2-2.9 21.4-10.4 28.9z"/></symbol><symbol id="icon-symbol-pipe" viewBox="0 0 256 256"><path d="M93.1,239.8c-7.8,0-15.3-3.5-20.3-9.6L6.0,149.0c-9.2-11.2-7.6-27.8,3.6-37.0c11.2-9.2,27.8-7.6,37.0,3.6l46.3,56.2L209.2,26.1c9.1-11.3,25.6-13.2,36.9-4.1c11.3,9.1,13.2,25.6,4.1,36.9L113.7,229.9c-4.9,6.2-12.4,9.8-20.3,9.9C93.3,239.8,93.2,239.8,93.1,239.8z"/></symbol><symbol id="icon-symbol-planet" viewBox="0 0 256 256"><path d="M128 0C57.3 0 0 57.3 0 128s57.3 128 128 128 128-57.3 128-128S198.7 0 128 0zm111.3 123.9H189.8c-.453-18.3-3.7-35.8-9.5-51.8 11.1-4.7 21.5-10.8 30.9-18.1 16.7 18.8 27.2 43.1 28.1 69.9zM123.4 239.3c-13.7-11.4-25.2-26.3-33.7-43.5 10.8-3.4 22.3-5.2 34.1-5.6v49.1c-.148 0-.288-.01-.437-.017zm9.1-222.5c15.6 13.0 28.3 30.3 36.9 50.6-11.8 4.0-24.3 6.4-37.3 6.8V16.7c.157.0.29.0.43.0zm13.8 1.4c22.8 3.8 43.2 14.4 59.2 29.8-8.6 6.6-18.1 12.2-28.3 16.5-7.5-17.8-18.1-33.6-30.9-46.3zm-22.4-1.4v57.4c-13.0-.42-25.5-2.8-37.3-6.8 8.6-20.3 21.3-37.6 36.9-50.6.15-.1.3-.17.4-.025zm-45.0 47.8c-10.2-4.3-19.7-9.9-28.3-16.5C66.4 32.6 86.9 21.9 109.7 18.2c-12.8 12.8-23.3 28.5-30.9 46.3zm4.6 10.4c12.7 4.4 26.3 7.0 40.4 7.4v41.5H74.5c.446-17.3 3.5-33.8 9.0-48.9zm40.4 57.2v49.8c-13.0.396-25.6 2.5-37.5 6.3-7.2-17.0-11.4-36.0-11.9-56.1h49.4zm-14.2 105.7c-20.4-3.4-39.0-12.3-54.0-25.2 8.1-5.6 16.9-10.4 26.3-14.0 7.2 14.9 16.6 28.2 27.7 39.2zm22.4 1.4V190.2c11.8.38 23.3 2.2 34.1 5.6-8.4 17.2-19.9 32.1-33.7 43.5-.14 0-.29.0-.438.0zm41.9-40.7c9.4 3.6 18.2 8.4 26.3 14.0-15.1 12.9-33.6 21.8-54.0 25.2 11.1-11.1 20.5-24.3 27.7-39.2zm-4.4-10.4c-11.9-3.8-24.5-6.0-37.5-6.3v-49.8h49.4c-.52 20.1-4.7 39.1-11.9 56.1zM132.1 123.9V82.4c14.1-.43 27.7-3.0 40.4-7.4 5.4 15.1 8.5 31.6 9.0 48.9H132.1v-.007zM44.9 54.0C54.3 61.3 64.6 67.5 75.7 72.1c-5.8 16.0-9.0 33.5-9.5 51.8H16.7c.99-26.8 11.4-51.1 28.2-69.9zM16.7 132.1h49.5c.512 21.1 4.9 41.0 12.4 58.9-10.5 4.1-20.2 9.5-29.2 15.9-19.4-19.3-31.6-45.7-32.7-74.9zm189.8 74.9c-9-6.4-18.8-11.9-29.2-15.9 7.5-17.9 11.9-37.8 12.4-58.9h49.5c-1.1 29.2-13.3 55.6-32.7 74.9z"/></symbol><symbol id="icon-symbol-play" viewBox="0 0 256 256"><path d="M128,0C57.4,0,0,57.4,0,128c0,70.6,57.4,128,128,128c70.6,0,128-57.4,128-128C256,57.4,198.6,0,128,0zM128,242.9c-63.3,0-114.9-51.5-114.9-114.9C13.1,64.7,64.7,13.1,128,13.1c63.3,0,114.9,51.5,114.9,114.9C242.9,191.3,191.3,242.9,128,242.9z"/><path d="M189,122.9L98.2,74.6c-1.8-0.9-3.9-0.9-5.6,0.1c-1.7,1-2.8,2.9-2.8,4.9v96.7c0,2,1,3.8,2.8,4.9c0.9,0.5,1.9,0.8,2.9,0.8c0.9,0,1.8-0.2,2.7-0.7l90.8-48.3c1.9-1,3-2.9,3-5C192,125.8,190.9,123.9,189,122.9z"/></symbol><symbol id="icon-symbol-prim-table" viewBox="0 0 256 256"><g><g><g><circle cx="62.4" cy="61.5" r="17.3"/><circle cx="62.4" cy="124.8" r="17.3"/><circle cx="62.4" cy="188.1" r="17.3"/></g><g><circle cx="193.6" cy="61.5" r="17.3"/><circle cx="193.6" cy="124.8" r="17.3"/></g></g><path d="M128,221c-4.7,0-8.4-3.8-8.4-8.4V43.4c0-4.7,3.8-8.4,8.4-8.4c4.7,0,8.4,3.8,8.4,8.4v169.1C136.4,217.2,132.7,221,128,221z"/></g></symbol><symbol id="icon-symbol-question-mark" viewBox="0 0 256 256"><path d="M186.2 17.6C169.9 5.8 149.6 0 125.1 0c-18.7 0-34.4 4.1-47.2 12.3C57.6 25.2 46.8 47.1 45.5 78.0H92.5c0-9.0 2.6-17.6 7.9-26.0 5.2-8.3 14.2-12.5 26.7-12.5 12.8 0 21.6 3.4 26.4 10.1 4.8 6.8 7.2 14.3 7.2 22.5 0 7.2-3.6 13.7-7.9 19.7-2.4 3.5-5.5 6.7-9.4 9.6 0 0-25.5 16.4-36.7 29.5-6.5 7.6-7.1 19.0-7.7 35.4-.042 1.2.398 3.6 4.5 3.6 4.1 0 33.0 0 36.6 0s4.4-2.7 4.4-3.9c.257-6.0.925-9.0 2.0-12.4 2.1-6.5 7.6-12.2 13.9-17.1l12.9-8.9c11.7-9.1 21.0-16.6 25.1-22.4 7.0-9.6 12.0-21.5 12.0-35.6-.002-23.0-8.1-40.3-24.3-52.0zM124.3 198.0c-16.2-.484-29.6 10.7-30.1 28.3-.512 17.6 12.2 29.2 28.4 29.7 16.9.497 29.9-10.4 30.4-27.9.498-17.6-11.8-29.5-28.8-30.0z"/></symbol><symbol id="icon-symbol-quote" viewBox="0 0 256 256"><g><path d="M86.7,128.2h-3.1c-8.8,0-16.8-3.4-24-10.3c-7.2-6.8-10.7-15.4-10.7-25.6c0-9.9,3.6-18.3,10.7-25c7.2-6.8,16-10.1,26.6-10.1c11.6,0,21.2,4.7,28.8,14.2c7.6,9.4,11.3,22.6,11.3,39.4c0,12.1-2,23.5-5.9,34.2c-3.9,10.7-9,20-15.2,28c-6.2,7.9-12.9,14.2-20.1,18.9c-7.2,4.6-13.6,7-19.2,7c-5.2,0-9.2-1.5-11.9-4.4c-2.8-2.9-4.1-6.8-4.1-11.7c0-7.1,3.1-12.2,9.2-15.3c8.7-4.9,15.2-10.3,19.6-16.2C83,145.3,85.7,137.7,86.7,128.2z"/><path d="M167.9,127.8h-3.3c-9,0-17-3.4-24.2-10.3c-7.2-6.8-10.7-15.4-10.7-25.6c0-10.1,3.6-18.4,10.7-24.9c7.2-6.5,16-9.8,26.6-9.8c11.5,0,21,4.6,28.7,13.8c7.6,9.2,11.4,22.3,11.4,39.3c0,15.6-3.3,30.2-10,43.8c-6.7,13.6-14.9,24.4-24.5,32.3c-9.7,7.9-18.3,11.9-25.8,11.9c-5,0-9-1.5-11.8-4.5c-2.8-3-4.2-6.8-4.2-11.6c0-6.9,3.1-12,9.2-15.3c8.3-4.6,15-9.9,19.8-16.1C164.5,144.8,167.3,137,167.9,127.8z"/></g></symbol><symbol id="icon-symbol-redo" viewBox="0 0 256 256"><path d="M144 20c-4.1 0-8.2 1.6-11.3 4.7C129.6 27.8 128 31.9 128 36v40.9C56 84.9 0 145.9 0 220v16c35.9-54.8 84-62.7 128-63.8V212c0 4.1 1.6 8.2 4.7 11.3 3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7L256 124 155.3 24.7C152.2 21.6 148.1 20 144 20z"/></symbol><symbol id="icon-symbol-refresh" viewBox="0 0 256 256"><path d="M218.7,217.4c23.0-23.1,36.3-53.5,37.3-86.2c0.2-6.0-4.5-11.1-10.6-11.3c-6.1-0.2-11.1,4.5-11.3,10.6c-1.3,38.3-22.8,71.3-53.9,88.9c-0.3,0.1-0.5,0.3-0.8,0.4c-1.1,0.6-2.2,1.2-3.3,1.8c-1.0,0.5-2.0,1.0-3.0,1.5c-0.4,0.2-0.7,0.3-1.1,0.5c-1.4,0.6-2.7,1.2-4.1,1.8c-0.0,0.0-0.0,0.0-0.0,0.0c-27.1,11.0-57.8,10.3-84.4-1.9c-0.3-0.2-0.7-0.3-1.0-0.5c-0.9-0.5-1.9-0.9-2.8-1.4c-0.9-0.5-1.7-0.9-2.6-1.4c-0.4-0.2-0.8-0.4-1.2-0.6c-18.3-10.3-33.3-26.0-42.8-44.8c-0.2-0.4-0.4-0.8-0.6-1.3c-0.5-0.9-0.9-1.9-1.3-2.8c-0.5-1.2-1.0-2.3-1.5-3.5c-0.1-0.2-0.2-0.4-0.3-0.7c-10.8-26.9-10.1-57.4,2.0-83.8c0.2-0.4,0.4-0.9,0.6-1.3c0.4-0.8,0.8-1.6,1.2-2.4c0.5-1.0,1.0-2.0,1.6-3.0c0.1-0.2,0.3-0.5,0.4-0.7c10.4-18.5,26.1-33.5,45.0-43.0c0.4-0.2,0.7-0.4,1.1-0.5c1.0-0.5,2.0-0.9,3.0-1.4c1.1-0.5,2.3-1.0,3.4-1.5c0.2-0.1,0.4-0.2,0.7-0.3c38.2-15.3,83.6-7.5,114.5,23.3l-38.0,37.9h90.8V-1.0l-37.4,37.4c-23.6-23.5-54.1-35.9-85.0-37.2c-0.4-0.1-0.8-0.1-1.2-0.1C130.8-1.0,129.4-1,128.0-1c-15.9,0-31.1,2.9-45.2,8.3c-0.0,0.0-0.0,0.0-0.0,0.0c-0.6,0.2-1.2,0.5-1.8,0.7c-0.5,0.2-1.0,0.4-1.6,0.6c-0.0,0.0-0.1,0.0-0.1,0.1c-15.2,6.2-29.4,15.5-41.7,27.8c-11.2,11.2-19.9,23.9-26.0,37.6c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.6-0.5,1.1-0.7,1.7c-0.3,0.7-0.6,1.4-0.9,2.1c-0.0,0.1-0.1,0.3-0.2,0.4c-5.5,13.6-8.8,28.4-9.3,43.9c-0.6,17.3,2.4,34.0,8.2,49.3c0.0,0.1,0.1,0.2,0.1,0.3c0.2,0.5,0.4,1.1,0.6,1.6c0.2,0.6,0.5,1.2,0.7,1.8c0.0,0.0,0.0,0.1,0.0,0.1c6.2,15.2,15.5,29.4,27.8,41.7c11.8,11.8,25.3,20.7,39.7,27.0c14.4,6.2,30.1,9.9,46.7,10.5c1.4,0.0,2.9,0.1,4.3,0.1c29.6,0,57.8-10.0,80.6-28.7c0.3-0.2,0.6-0.5,0.8-0.7c0.5-0.4,1.0-0.9,1.5-1.3c0.4-0.4,0.8-0.7,1.3-1.1c0.4-0.3,0.7-0.6,1.1-1.0c0.4-0.4,0.8-0.8,1.3-1.1c0.3-0.3,0.5-0.5,0.8-0.8c0.1-0.1,0.2-0.2,0.3-0.3c0.4-0.4,0.8-0.7,1.2-1.1c0.4-0.4,0.8-0.8,1.3-1.2c0.1-0.1,0.2-0.2,0.3-0.3C218.6,217.5,218.6,217.4,218.7,217.4z"/></symbol><symbol id="icon-symbol-rotate-device" viewBox="0 0 256 256"><g><path d="M131.5,0H12.6C5.7,0,0,5.7,0,12.6v230.7C0,250.3,5.7,256,12.6,256h118.9c7.0,0,12.6-5.7,12.6-12.6V12.6C144.2,5.7,138.5,0,131.5,0zM137.1,243.4c0,3.1-2.5,5.6-5.6,5.6H12.6c-3.1,0-5.6-2.5-5.6-5.6V12.6c0-3.1,2.5-5.6,5.6-5.6h118.9c3.1,0,5.6,2.5,5.6,5.6V243.4z"/><path d="M72.1,223.6c-6.1,0-11.1,5.0-11.1,11.1s5.0,11.1,11.1,11.1c6.1,0,11.1-5.0,11.1-11.1S78.2,223.6,72.1,223.6zM72.1,238.8c-2.2,0-4.0-1.8-4.0-4.0s1.8-4.0,4.0-4.0c2.2,0,4.0,1.8,4.0,4.0S74.3,238.8,72.1,238.8z"/><path d="M82.2,12.6H62.0c-2.0,0-3.5,1.6-3.5,3.5c0,2.0,1.6,3.5,3.5,3.5h20.2c2.0,0,3.5-1.6,3.5-3.5C85.8,14.2,84.2,12.6,82.2,12.6z"/><path d="M243.4,111.8h-93.1c-2.0,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h93.1c3.1,0,5.6,2.5,5.6,5.6v118.9c0,3.1-2.5,5.6-5.6,5.6h-95.1c-2.0,0-3.5,1.6-3.5,3.5c0,2.0,1.6,3.5,3.5,3.5h95.1c7.0,0,12.6-5.7,12.6-12.6V124.5C256,117.5,250.3,111.8,243.4,111.8z"/><path d="M243.4,194.0v-20.2c0-2.0-1.6-3.5-3.5-3.5c-2.0,0-3.5,1.6-3.5,3.5v20.2c0,2.0,1.6,3.5,3.5,3.5C241.8,197.6,243.4,196.0,243.4,194.0z"/><path d="M172.0,45.5c0,0.0,0.0,0.0,0.0,0.1c0.0,0.1,0.0,0.1,0.0,0.2c0.0,0.1,0.0,0.2,0.0,0.3c0.0,0.0,0.0,0.1,0.0,0.1c0.0,0.1,0.1,0.2,0.1,0.3c0.0,0.1,0.0,0.1,0.0,0.2c0.0,0.0,0.0,0.1,0.0,0.1c0.0,0.0,0.0,0.1,0.0,0.1c0.0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.0,0.0,0.0,0.1,0.1,0.1c0.0,0.0,0.0,0.1,0.1,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.0,0.0,0.0,0.1,0.1,0.1l0.1,0.1c0.0,0,0.0,0,0.0,0l10.3,10.3c0.7,0.7,1.6,1.0,2.5,1.0s1.8-0.3,2.5-1.0c1.4-1.4,1.4-3.6,0-5.0l-2.4-2.4c11.0,4.2,18.8,14.9,18.8,27.4c0,2.0,1.6,3.5,3.5,3.5c2.0,0,3.5-1.6,3.5-3.5c0-15.3-9.5-28.5-23.0-33.8l2.0-0.7c1.8-0.6,2.8-2.7,2.2-4.5c-0.6-1.8-2.7-2.8-4.5-2.2l-14.4,5.0c-0.0,0.0-0.0,0.0-0.1,0.0c-0.0,0.0-0.1,0.0-0.1,0.0c-0.1,0.0-0.2,0.1-0.3,0.1c-0.1,0.0-0.2,0.1-0.3,0.1c-0.0,0.0-0.1,0.0-0.1,0.0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3s-0.1,0.2-0.2,0.3c-0.0,0.0-0.0,0.1-0.1,0.1c-0.0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c-0.0,0.0-0.0,0.1-0.1,0.1c-0.0,0.1-0.1,0.2-0.1,0.2c-0.0,0.1-0.1,0.2-0.1,0.3c-0.0,0.0-0.0,0.1-0.0,0.1c-0.0,0.1-0.0,0.2-0.0,0.2c-0.0,0.1-0.0,0.2-0.0,0.3c-0.0,0.0-0.0,0.0-0.0,0.1C172.0,45.5,172.0,45.5,172.0,45.5z"/></g></symbol><symbol id="icon-symbol-search" viewBox="-15 17 256 256"><path d="M145 17c-53 0-96 43-96 96 0 16.2 4.1 31.5 11.2 44.9l-66.8 66.7h.1c-5.2 5.1-8.5 12.2-8.5 20.1 0 15.6 12.6 28.2 28.2 28.2 7.9 0 15-3.2 20.1-8.5l66.7-66.7c13.4 7.1 28.7 11.2 44.9 11.2 53 0 96-43 96-96C241 60 198 17 145 17zM23.4 254.5c-2.6 2.7-6.1 4.3-10.1 4.3-7.8 0-14.1-6.3-14.1-14.1 0-4 1.7-7.5 4.3-10.1l-.1-.1L67.9 170c5.6 7.6 12.4 14.3 20 20l-64.5 64.5zM145 193c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zm0-136c2.2 0 4 1.8 4 4s-1.8 4-4 4c-26.5 0-48 21.5-48 48 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-30.9 25.1-56 56-56z"/></symbol><symbol id="icon-symbol-settings" viewBox="0 0 256 256"><path d="M243.1 101.4l-24.5-4.9c-1.2-3.5-2.7-7.0-4.3-10.3l13.9-20.8c4.2-6.3 3.4-14.8-2-20.2l-15.4-15.4c-3.1-3.1-7.2-4.7-11.3-4.7-3.1 0-6.2.88-8.9 2.7L169.8 41.7c-3.3-1.6-6.8-3.1-10.3-4.3l-4.9-24.5C153.1 5.4 146.5.004 138.9.004h-21.8c-7.6 0-14.2 5.4-15.7 12.9l-4.9 24.5C93.0 38.6 89.5 40.1 86.2 41.7l-20.8-13.9c-2.7-1.8-5.8-2.7-8.9-2.7-4.1 0-8.2 1.6-11.3 4.7L29.8 45.2c-5.4 5.4-6.2 13.8-2 20.2l13.9 20.8c-1.6 3.3-3.1 6.8-4.3 10.3l-24.5 4.9C5.4 102.9 0 109.5 0 117.1v21.8c0 7.6 5.4 14.2 12.9 15.7l24.5 4.9c1.2 3.5 2.7 7.0 4.3 10.3L27.8 190.6c-4.2 6.3-3.4 14.8 2 20.2l15.4 15.4c3.1 3.1 7.2 4.7 11.3 4.7 3.1 0 6.2-.888 8.9-2.7l20.8-13.9c3.3 1.6 6.8 3.1 10.3 4.3l4.9 24.5c1.5 7.5 8.1 12.9 15.7 12.9h21.8c7.6 0 14.2-5.4 15.7-12.9l4.9-24.5c3.5-1.2 7.0-2.7 10.3-4.3l20.8 13.9c2.7 1.8 5.8 2.7 8.9 2.7 4.1 0 8.2-1.6 11.3-4.7l15.4-15.4c5.4-5.4 6.2-13.8 2-20.2l-13.9-20.8c1.6-3.3 3.1-6.8 4.3-10.3l24.5-4.9c7.5-1.5 12.9-8.1 12.9-15.7v-21.8c0-7.6-5.4-14.2-12.9-15.7zm-27.7 42.4c-5.6 1.1-10.1 5.1-12.0 10.4-1.0 3.0-2.2 5.8-3.6 8.6-2.5 5.1-2.1 11.1 1.1 15.9l13.9 20.8-15.4 15.4-20.8-13.9c-2.7-1.8-5.8-2.7-8.9-2.7-2.4 0-4.8.528-7.0 1.6-2.8 1.3-5.6 2.6-8.6 3.6-5.3 1.9-9.3 6.4-10.4 12.0l-4.9 24.5h-21.8l-4.9-24.5c-1.1-5.6-5.1-10.1-10.4-12.0-3.0-1.0-5.8-2.2-8.6-3.6-2.2-1.1-4.6-1.6-7.0-1.6-3.1 0-6.2.904-8.9 2.7L56.5 214.9l-15.4-15.4 13.9-20.8c3.1-4.7 3.6-10.8 1.1-15.8-1.3-2.8-2.6-5.6-3.6-8.6-1.9-5.3-6.4-9.3-12.0-10.4l-24.5-4.9L16 117.1l24.5-4.9c5.6-1.1 10.1-5.1 12.0-10.4 1.0-3.0 2.2-5.8 3.6-8.6 2.5-5.1 2.1-11.1-1.1-15.8L41.1 56.5l15.4-15.4 20.8 13.9c2.7 1.8 5.8 2.7 8.9 2.7 2.4 0 4.8-.527 7.0-1.6 2.8-1.3 5.6-2.6 8.6-3.6 5.4-1.9 9.3-6.4 10.4-12.0l4.9-24.5 21.8-.01 4.9 24.5c1.1 5.5 5.1 10.1 10.4 12.0 3.0 1.0 5.8 2.2 8.6 3.6 2.2 1.1 4.6 1.6 7.0 1.6 3.1 0 6.2-.903 8.9-2.7l20.8-13.9L214.9 56.5 201 77.3c-3.1 4.7-3.5 10.7-1.1 15.8 1.3 2.8 2.6 5.6 3.6 8.6 1.9 5.4 6.4 9.3 12.0 10.4l24.5 4.9.023 21.8-24.5 4.9zM128 72.0c-30.9 0-56 25.1-56 56 0 30.9 25.1 56 56 56s56-25.1 56-56-25.1-56-56-56zm0 105.0c-27.1 0-49-22.0-49-49.0 0-27.1 21.9-49 49-49 27.0 0 49 21.9 49 49 0 27.1-22.0 49-49 49zm0-81.0c-17.7 0-32 14.3-32 32 0 17.7 14.3 32 32 32 17.7 0 32-14.3 32-32s-14.3-32-32-32zm0 56.0c-13.2 0-24-10.8-24-24.0s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"/></symbol><symbol id="icon-symbol-showpass" viewBox="0 0 256 256"><g><path d="M255.7,126.2c-0.1-0.3,0-0.7-0.2-1c0-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.1-0.4-0.2-0.6C231.9,79.8,181.4,47.9,128,47.9S24.1,79.7,0.8,124.2c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.3-0.1,0.7-0.2,1C0.1,126.8,0,127.3,0,128c0,0.6,0.1,1.2,0.3,1.8c0.1,0.3,0,0.7,0.2,1c0,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.1,0.4,0.2,0.6C24.1,176.2,74.6,208,128,208c53.3,0,103.9-31.8,127.2-76.3c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0.2-0.2,0.2-0.3c0.1-0.3,0.1-0.7,0.2-1c0.1-0.6,0.3-1.2,0.3-1.8C256,127.4,255.8,126.8,255.7,126.2zM128,192c-45,0-89-25.6-111-64.1c22.1-38.5,66-64,111-64s89,25.6,111,64C216.9,166.5,172.9,192,128,192z"/><circle cx="127.8" cy="128" r="56.1"/></g></symbol><symbol id="icon-symbol-speach-bubble" viewBox="0 0 256 256"><path d="M128 56c2.2 0 4 1.8 4 4s-1.8 4-4 4c-42.6 0-80 22.4-80 48 0 2.2-1.8 4-4 4s-4-1.8-4-4c0-30.4 40.3-56 88-56zm0-40C57.3 16 0 59.0 0 112c0 33.0 22.2 62.1 56.1 79.4 0 .216-.64.4-.64.6 0 14.3-10.7 29.8-15.4 37.9.008 0 .016 0 .016 0-.376.9-.592 1.9-.592 2.9 0 4 3.2 7.2 7.2 7.2.752 0 2.1-.2 2.0-.112 25-4.1 48.6-27.1 54.0-33.7C111.3 207.3 119.5 208 128 208c70.7 0 128-43.0 128-96s-57.3-96-128-96zm0 176c-7.3 0-14.9-.56-22.4-1.7-.776-.128-1.6-.168-2.3-.168-4.8 0-9.3 2.1-12.4 5.8-3.4 4.2-13.2 13.5-24.7 20.3 3.1-7.2 5.6-15.2 5.7-23.5.048-.512.1-1.0.072-1.5 0-6.0-3.4-11.5-8.7-14.2C33.7 162.0 16 137.7 16 112c0-44.1 50.2-80 112-80 61.7 0 112 35.9 112 80s-50.2 80-112 80z"/></symbol><symbol id="icon-symbol-study" viewBox="0 0 256 256"><g><g><path d="M24,209v5c0,8.9,6,16.8,14.6,19.1l73.5,23.1c1.7,0.5,3.5,0.7,5.2,0.7c4.3,0,8.5-1.4,12-4.1c4.9-3.8,7.8-12.7,7.8-19v-2.2h75c10.9,0,19.8-8.9,19.8-19.8V45.7c0-11-8.9-19.9-19.8-19.9h-74.8v-2.2c0-6.2-2.8-14.7-7.7-18.5c-4.9-3.8-11.1-5-17.1-3.5L38.8,23.7C30.1,26,24,33.9,24,43v5.6M24.2,180.5V191M24.2,152v10.5M24.2,123.5V134M24.2,95v10.5M24.2,66.6V77M119.3,233.9c0,0.7-0.4,1.2-0.7,1.4c-0.3,0.3-0.9,0.5-1.6,0.3l-14.6-3.9l-58.9-15.8c-0.8-0.2-1.3-0.9-1.3-1.8V43c0-0.8,0.6-1.5,1.3-1.8L102,25.9l15-3.9c0.2,0,0.3-0.1,0.5-0.1c0.5,0,0.8,0.2,1.1,0.4c0.3,0.3,0.7,0.7,0.7,1.4V233.9zM137.3,191v-10.4h31.4c5,0,9-4,9-9s-4-9-9-9h-31.4v-10.5h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4v-10.4h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4V95.1h56.4c5,0,9-4,9-9s-4-9-9-9h-56.4V66.6M137.3,48.6V44h74.9c1,0,1.8,0.8,1.8,1.8V212c0,1-0.8,1.8-1.8,1.8h-74.8v-4.6"/></g><path d="M59.1,104c-4.3,0-8.1-3.1-8.9-7.5c-0.8-4.9,2.4-9.6,7.3-10.4l40.5-7c4.9-0.8,9.6,2.4,10.4,7.3c0.8,4.9-2.4,9.6-7.3,10.4l-40.5,7C60.2,104,59.6,104,59.1,104z"/><path d="M59.1,128c-4.5,0-8.4-3.4-8.9-7.9c-0.6-4.9,3-9.4,7.9-10l25.5-3c4.9-0.6,9.4,3,10,7.9c0.6,4.9-3,9.4-7.9,10l-25.5,3C59.8,128,59.5,128,59.1,128z"/></g></symbol><symbol id="icon-symbol-test" viewBox="0 0 256 256"><g id="Layer_3"><g><path d="M199.6,0H56.4C44.5,0,34.9,9.7,34.9,21.6v212.9c0,11.9,9.7,21.6,21.6,21.6h143.1c11.9,0,21.6-9.7,21.6-21.6V21.6C221.1,9.7,211.5,0,199.6,0zM203.1,234.4c0,2-1.6,3.6-3.6,3.6H56.4c-2,0-3.6-1.6-3.6-3.6V21.6c0-2,1.6-3.6,3.6-3.6h143.1c2,0,3.6,1.6,3.6,3.6V234.4z"/><path d="M180.7,33.7H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,33.7,180.7,33.7z"/><path d="M180.7,62.1H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,62.1,180.7,62.1z"/><path d="M180.7,119H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,119,180.7,119z"/><path d="M111.7,147.4H75.3c-5,0-9,4-9,9s4,9,9,9h36.3c5,0,9-4,9-9S116.6,147.4,111.7,147.4z"/><path d="M180.7,90.6H75.3c-5,0-9,4-9,9s4,9,9,9h105.3c5,0,9-4,9-9S185.6,90.6,180.7,90.6z"/><path d="M173.9,175.2l-28,28.1l-7.4-7.2c-3.6-3.5-9.3-3.4-12.7,0.2c-3.5,3.6-3.4,9.3,0.2,12.7l13.8,13.4c1.7,1.7,4,2.5,6.3,2.5c2.3,0,4.6-0.9,6.4-2.7l34.3-34.4c3.5-3.5,3.5-9.2,0-12.7C183.1,171.7,177.4,171.7,173.9,175.2z"/></g></g></symbol><symbol id="icon-symbol-trash" viewBox="0 0 256 256"><path d="M103.6 0h48.8c10.1 0 18.7 3.6 25.9 10.7 7.1 7.1 10.7 15.8 10.7 25.9v12.2h48.8c3.4 0 6.2 1.2 8.6 3.6 2.4 2.4 3.6 5.3 3.6 8.6 0 3.4-1.2 6.2-3.6 8.6s-5.3 3.6-8.6 3.6h-12.2V219.4c0 10.1-3.6 18.7-10.7 25.9C207.7 252.4 199.0 256 189.0 256H67.0c-10.1 0-18.7-3.6-25.9-10.7-7.1-7.1-10.7-15.8-10.7-25.9V73.1h-12.2c-3.4 0-6.2-1.2-8.6-3.6s-3.6-5.3-3.6-8.6 1.2-6.2 3.6-8.6c2.4-2.4 5.3-3.6 8.6-3.6H67.0V36.6c0-10.1 3.6-18.7 10.7-25.9C84.9 3.6 93.5 0 103.6 0zm97.5 219.4V73.1H54.9V219.4c0 3.4 1.2 6.2 3.6 8.6s5.3 3.6 8.6 3.6H188.9c3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.6zM152.4 24.4h-48.8c-3.4 0-6.2 1.2-8.6 3.6-2.4 2.4-3.6 5.3-3.6 8.6v12.2h73.1V36.6c0-3.4-1.2-6.2-3.6-8.6-2.4-2.4-5.3-3.6-8.6-3.6z"/></symbol><symbol id="icon-symbol-undo" viewBox="0 0 256 256"><path d="M128 76.9V36c0-4.1-1.6-8.2-4.7-11.3C120.2 21.6 116.1 20 112 20s-8.2 1.6-11.3 4.7L0 124l100.7 99.3c3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7C126.4 220.2 128 216.1 128 212v-39.8c44 1.1 92.1 9.1 128 63.8v-16c0-74.1-56-135.1-128-143.1z"/></symbol><symbol id="icon-symbol-uppercase" viewBox="0 0 256 256"><g><path fill="none" d="M32.0,117.3h36.6c5.1,0,9.3,4.2,9.3,9.3v109.4h100.2V126.6c0-5.1,4.2-9.3,9.3-9.3h36.6L128,23.6L32.0,117.3z"/><path d="M253.2,120.0L134.5,4.0c-3.6-3.5-9.4-3.5-13.0,0L2.8,120.0c-2.7,2.6-3.5,6.6-2.1,10.1c1.4,3.5,4.8,5.8,8.6,5.8h50.1v109.4c0,5.1,4.2,9.3,9.3,9.3h118.7c5.1,0,9.3-4.2,9.3-9.3V135.9h50.1c3.8,0,7.2-2.3,8.6-5.8C256.7,126.6,255.9,122.6,253.2,120.0zM187.4,117.3c-5.1,0-9.3,4.2-9.3,9.3v109.4H77.9V126.6c0-5.1-4.2-9.3-9.3-9.3H32.0L128,23.6l96.0,93.7H187.4z"/></g></symbol><symbol id="icon-symbol-user" viewBox="0 0 256 256"><path d="M248.9 226.7c-1.6-1.1-30.8-20.2-74.2-29.6 15.9-20.2 26.1-47.3 30.5-65.4 6.0-25.0 3.7-74.0-20.3-104.5C170.8 9.4 151.1 0 128.0 0c-23.1 0-42.8 9.4-56.8 27.2-24.0 30.5-26.4 79.5-20.3 104.5 4.3 18.1 14.6 45.2 30.5 65.4-43.4 9.4-72.6 28.5-74.2 29.6-5.9 3.9-8.5 11.2-6.4 17.9C2.7 251.4 9.0 256 16.0 256h224c7.0 0 13.3-4.6 15.3-11.4 2.1-6.7-.57-14.0-6.4-17.9zm-86.7-39.5l-2.6 3.3c-19.1 21.9-44.0 21.9-63.0 0l-2.6-3.3c-22.3-28.2-33.3-65.6-28.6-101.2C69.7 51.8 89.3 16 128.0 16s58.3 35.8 62.7 70.0c4.7 35.6-6.3 72.9-28.6 101.2zM16.0 240c1.1-.736 28.2-18.5 68.7-27.3l19.9-4.3c7.1 4.7 14.9 7.6 23.4 7.6 8.6 0 16.3-2.9 23.4-7.6l19.9 4.3c40.2 8.7 67.2 26.3 68.7 27.3h-224z"/></symbol><symbol id="icon-symbol-x" viewBox="0 0 256 256"><path d="M235.1 205.6l-67.9-77.6 67.9-77.6c11.5-11.5 11.5-30.3 0-41.8s-30.3-11.5-41.8 0l-65.3 74.6L62.7 8.7C51.2-2.9 32.5-2.9 20.9 8.7c-11.5 11.5-11.5 30.3 0 41.8l67.9 77.6-67.9 77.6c-11.5 11.5-11.5 30.2 0 41.7 11.5 11.5 30.3 11.5 41.8 0l65.3-74.6 65.3 74.6c11.5 11.5 30.3 11.5 41.8 0s11.5-30.2.026-41.7z"/></symbol><symbol id="icon-symbor-camera" viewBox="0 0 256 256"><path d="M85.3 21.3h85.3l21.3 32h32c8.8 0 16.4 3.2 22.6 9.5S256 76.8 256 85.7v117.2c0 8.8-3.1 16.3-9.4 22.5s-13.8 9.3-22.6 9.3H32c-8.8 0-16.4-3.1-22.6-9.4S0 211.5 0 202.7V85.5c0-8.8 3.1-16.4 9.4-22.7 6.3-6.3 13.8-9.5 22.6-9.5h32l21.3-32zm42.7 64c7.2 0 14.1 1.4 20.7 4.3 6.6 2.8 12.3 6.6 17 11.4s8.5 10.4 11.4 17c2.8 6.6 4.3 13.5 4.3 20.7 0 7.2-1.4 14.1-4.3 20.7-2.8 6.6-6.6 12.3-11.4 17s-10.4 8.5-17 11.4C142.1 190.6 135.2 192 128 192c-7.2 0-14.1-1.4-20.7-4.3-6.6-2.8-12.3-6.6-17-11.4s-8.5-10.4-11.4-17-4.3-13.5-4.3-20.7c0-7.2 1.4-14.1 4.3-20.7 2.8-6.6 6.6-12.3 11.4-17s10.4-8.5 17-11.4c6.6-2.8 13.5-4.3 20.7-4.3zm0 21.3c-8.8 0-16.4 3.1-22.6 9.4S96 129.8 96 138.7c0 8.8 3.1 16.4 9.4 22.6s13.8 9.4 22.6 9.4 16.4-3.1 22.6-9.4S160 147.5 160 138.7c0-8.8-3.1-16.4-9.4-22.6s-13.8-9.4-22.6-9.4zm52.6-32l-20.9-32H96.8l-21.3 32H32c-2.9 0-5.5 1.1-7.5 3.2-2.1 2.1-3.1 4.7-3.1 7.7v117.2c0 2.9 1.0 5.5 3.1 7.5 2.1 2.1 4.6 3.1 7.5 3.1h192c3 0 5.5-1.0 7.6-3.0 2.1-2.0 3.1-4.5 3.1-7.5V85.7c0-3-1.1-5.6-3.2-7.8-2.1-2.2-4.6-3.3-7.5-3.3h-43.4z"/></symbol></svg>';
APP.$store.templates = {"add-users-list":"{{#if this.length > 0}} <ul class=\"list\"> {{#each this}} <li class=\"list--item\">{{this.name}} ({{this.email}}) <a style=\"float: right\" data-add-user-to-filter=\"{{this._id}}\" class=\"button button--small\">Hozzáadás</a></li> {{/each}} </ul> {{#else}} Nincs találat. Az egész nevet vagy email címet írd be! {{/if}}","basic-calculator":"<div class=\"basic-calculator\"> <div class=\"basic-calculator__result\" data-basic-calculator-result>404</div> <div class=\"basic-calculator__rows\"> <div class=\"basic-calculator__row basic-calculator__row--first\"> <button data-basic-calculator-delete class=\"basic-calculator__button basic-calculator__button--del\">C</button> <button data-basic-calculator-input=\"%\" class=\"basic-calculator__button basic-calculator__button--op\">%</button> <button data-basic-calculator-input=\"+\" class=\"basic-calculator__button basic-calculator__button--op\">+</button> </div> <div class=\"basic-calculator__row\"> <button data-basic-calculator-input=\"7\" class=\"basic-calculator__button\">7</button> <button data-basic-calculator-input=\"8\" class=\"basic-calculator__button\">8</button> <button data-basic-calculator-input=\"9\" class=\"basic-calculator__button\">9</button> <button data-basic-calculator-input=\"-\" class=\"basic-calculator__button basic-calculator__button--op\">-</button> </div> <div class=\"basic-calculator__row\"> <button data-basic-calculator-input=\"4\" class=\"basic-calculator__button\">4</button> <button data-basic-calculator-input=\"5\" class=\"basic-calculator__button\">5</button> <button data-basic-calculator-input=\"6\" class=\"basic-calculator__button\">6</button> <button data-basic-calculator-input=\"*\" class=\"basic-calculator__button basic-calculator__button--op\">*</button> </div> <div class=\"basic-calculator__row\"> <button data-basic-calculator-input=\"1\" class=\"basic-calculator__button\">1</button> <button data-basic-calculator-input=\"2\" class=\"basic-calculator__button\">2</button> <button data-basic-calculator-input=\"3\" class=\"basic-calculator__button\">3</button> <button data-basic-calculator-input=\"/\" class=\"basic-calculator__button basic-calculator__button--op\">/</button> </div> <div class=\"basic-calculator__row\"> <button data-basic-calculator-input=\"0\" class=\"basic-calculator__button basic-calculator__button--zero\">0</button> <button data-basic-calculator-input=\".\" class=\"basic-calculator__button\">.</button> <button data-basic-calculator-eq class=\"basic-calculator__button basic-calculator__button--eq\">=</button> </div> </div> </div>","calculator/abs":"<div data-formula=\"abs\"> <div class=\"gutter\"> <div data-formula-before><span></span></div> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div data-formula-after><span></span></div> </div> </div>","calculator/error":"<h3 data-formula-content>{0}</h3>","calculator/exp":"<div data-formula=\"exp\"> <div class=\"gutter\"> <div class=\"inline-block\"> <div data-formula=\"p\" data-formula-ghost-p=\"{ghost-phase}\" data-parenthesis data-parenthesis-type=\"1\"> <div class=\"gutter\"> <div data-formula-before><span></span></div> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div data-formula-after><span></span></div> </div> </div> </div> <div class=\"half-size exp-sup\" data-sup-sub=\"not-set\" data-argument=\"2\" data-formula-content data-input-placeholder data-formula-level>{1} </div> </div> </div>","calculator/lit":"lit({0})","calculator/literal":"<span data-formula=\"literal\">{0}</span>","calculator/log":"<div data-formula=\"log\"> <div class=\"gutter\"> <div class=\"inline-block\" data-formula-part=\"fnsub\"> <span data-formula-part=\"fn\" class=\"log\">log</span> <div data-formula-part=\"sub\" class=\"half-size log-sub\" data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> </div> <div class=\"inline-block log-body\"> <div data-formula=\"p\" data-formula-ghost-p=\"{ghost-phase}\" data-parenthesis data-parenthesis-type=\"1\"> <div class=\"gutter\"> <div data-formula-before><span></span></div> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{1} </div> <div data-formula-after><span></span></div> </div> </div> </div> </div> </div>","calculator/mark":"<span data-formula=\"mark\" data-mark=\"{1}\">{0}</span>","calculator/p":"<div data-formula=\"p\" data-parenthesis data-parenthesis-type=\"1\"> <div class=\"gutter\"> <div data-formula-before><span></span></div> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div data-formula-after><span></span></div> </div> </div>","calculator/per":"<div data-formula=\"per\"> <div class=\"gutter\"> <div data-formula-content-top> <div data-argument=\"1\" data-formula-level data-input-placeholder>{0}</div> </div> <div data-fit-box style=\"width:100%;height:1px;top:4px;position:relative;\"></div> <div data-formula-content-bottom> <div data-argument=\"2\" data-formula-level data-input-placeholder>{1}</div> </div> </div> </div>","calculator/placeholder":"<div class=\"calculator--placeholder\"></div>","calculator/root":"<div data-formula=\"root\"> <div class=\"half-size root-sup\" data-argument=\"2\" data-formula-content data-input-placeholder data-input-default=\"2\" data-formula-level>{0} </div> <div class=\"gutter inline-block\"> <div class=\"root-start\"> </div> <div class=\"root-body\"> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{1} </div> <div class=\"root-end\"></div> </div> </div> </div>","calculator/row-arrow-flag":"","calculator/shape":"<div data-formula=\"shape\" class=\"formula--shape-{0}\"> <i class=\"icon-wrapper\"> <svg viewBox=\"0 0 256 256\"> <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{0}\"></use> </svg> </i> </div>","calculator/sub":"<div data-formula=\"sub\"> <div class=\"gutter\"> <div data-fit-box class=\"inline-block\" data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div class=\"half-size sub-sub\" data-sup-sub=\"not-set\" data-argument=\"2\" data-formula-content data-input-placeholder data-formula-level>{1} </div> </div> </div>","calculator/unmark":"<span data-unmark>{0}</span>","calculator/wrapper":"<div class=\"calculator--element\" data-calculator-element data-calculator-element-type=\"{type}\" data-calculator-element-id=\"{id}\"><span data-calculator-element-before></span>{content}<span data-calculator-element-after></span></div>","challenge-users-list":"{{#if Object.keys(this).length > 0}} <div class=\"pro__table__wrapper\"> <table class=\"pro__table\"> <thead> <tr> <td> <label> <input type=\"checkbox\" checked=\"checked\" data-toggle-list=\"members\"> <span>Összes</span> </label> </td> <td> Tagok </td> </tr> </thead> <tbody> {{#each this['group-member']}} {{#if this._id}} <tr> <td> <input data-toggle-item=\"members\" id=\"member_list_{{this._id}}\" type=\"checkbox\" value=\"{{this._id}}\" checked=\"checked\" name=\"challenge-target\" /> </td> <td> <label for=\"member_list_{{this._id}}\" style=\"display: block\">{{this.name}}</label> </td> </tr> {{/if}} {{/each}} </tbody> </table> </div> {{/if}}","cookie-notification":"<div class=\"cookie-notification cookie-notification--show\" data-cookie-notification> <span class=\"cookie-notification__icon\">{{>icon 'symbol-cookie'}}</span> <div style=\"float: left; max-width: calc(100% - 80px);\"> <span>Az Akrielen cookie-kat (másnéven sütiket) használunk, hogy a lehető legjobb szolgáltatást nyújthassuk neked.</span> <br><br> <a class=\"button button--small button--dark\" target=\"_blank\" href=\"/hu/akriel/privacy\">Milyen a süti?</a> </div> <a class=\"cookie-notification__close\">{{>icon 'symbol-x'}}</a> </div> <div class=\"no-cookie-notification\" data-no-cookie-notification> <span class=\"no-cookie-notification__icon\">{{>icon 'symbol-cookie'}}</span> <div style=\"float: left; max-width: calc(100% - 80px);\"> <span> Jelenleg <b style=\"display: inline\">nincs engedélyezve a cookie-k (másnéven sütik) használata</b> a böngésződben. A sütik elengedhetetlenek az Akriel fő funkcióinak működéséhez. Kérjük, hogy engedélyezd őket a megfelelő felhasználói élmény érdekében. </span> </div> <a class=\"no-cookie-notification__close\">{{>icon 'symbol-x'}}</a> </div>","currents":"<div class=\"list collection__list\"> {{#each this.problems}} <a class=\"list--item collection__list__item\" href=\"/hu/problem/direct/{{btoa(this.formula)}}/?source=currents\"> <div data-f=\"{{this.formula}}\"> <div data-f-content></div> </div> </a> {{/each}} </div>","exam-live":"<table class=\"learn-period__table\"> {{#each this}} {{#if this.startTime}} <tr> <td class=\"learn-period__table__row-name\" style=\"vertical-align:middle;\" width=\"0\"> <a target=\"_blank\" href=\"/hu/exam/view/{{this.examId}}/{{this.examSecretId}}\" title=\"{{this.name}}\" class=\"learn-period__secondary-title\">{{this.name}}</a> </td> <td width=\"100%\"> <div class=\"learn-period__chart{{#if this.done}} learn-period__chart--purple{{/if}}\"> {{#if this.percentage > 0}} <div class=\"learn-period__chart__i2 learn-period__chart__done\" style=\"width: {{this.percentage}}%\"> {{#if this.percentage === 100}} {{this.points}} {{/if}} </div> {{/if}} {{#if this.percentage < 100}} <div class=\"learn-period__chart__i3\" style=\"width: {{100 - this.percentage}}%\"> {{this.points}} </div> {{/if}} </div> </td> <td class=\"learn-period__table__row-name\" width=\"0\"> {{#if this.done}} <span class=\"exam__mark grade-mark grade-mark__small\" style=\"position: relative;left: 0;top: 0;margin-left: 15px;\">{{this.percentage}}%</span> {{/if}} </td> </tr> {{#else}} <tr class=\"exam--waiting\"> <td class=\"learn-period__table__row-name\" style=\"vertical-align:middle;\" width=\"0\"> <span class=\"learn-period__secondary-title\">{{this.name}}</span> </td> <td width=\"100%\"> <div class=\"learn-period__chart\"> <div class=\"learn-period__chart__i3\" style=\"width: 100%;background-color: #eaeaec;\"> 0 </div> </div> </td> <td class=\"learn-period__table__row-name\" width=\"0\"> {{#if this.done}} <span class=\"exam__mark grade-mark\" style=\"position: relative;left: 0;top: 0;margin-left: 15px;\">{{this.percentage}}%</span> {{/if}} </td> </tr> {{/if}} {{/each}} </table>","exam-solution":"{{#if this.type === 'comment-text'}} <div data-exam-answer=\"{{this.index}}\"> {{>icon \"symbol-speach-bubble\"}}<p class=\"formula-flack\">{{this.display}}</p><div class=\"formula-actions\"><a data-switch-type=\"comment-text\" data-exam-text-edit=\"{{this.index}}\">{{>icon \"symbol-pen\"}}</a><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div> </div> {{#elseif this.type === 'comment-formula'}} <div data-exam-answer=\"{{this.index}}\" data-exam-answer-formula='{{this.displayJson}}'> {{>icon \"symbol-speach-bubble\"}}<div class=\"formula-flack\" data-f=\"{{this.display}}\"> <div data-f-content></div> </div><div class=\"formula-actions\"><a data-switch-type=\"comment-formula\" data-exam-answer-edit=\"{{this.index}}\">{{>icon \"symbol-pen\"}}</a><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div> </div> {{#elseif this.type === 'comment-doodle'}} <div data-exam-answer=\"{{this.index}}\"> {{>icon \"symbol-speach-bubble\"}}<p class=\"formula-flack\"> <img class=\"doodle-image\" data-editable=\"1\" data-doodle-id=\"{{this.display}}\" src=\"/doodle/{{this.display}}.svg\" /> </p><div class=\"formula-actions\" style=\"width: 50px\"><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div> </div> {{#elseif this.type === 'cta'}} <div data-exam-answer=\"{{this.index}}\" data-exam-answer-formula='{{this.displayJson}}'> <div class=\"formula-flack\" data-f=\"{{this.display}}\"> <div data-f-content></div> </div><div class=\"formula-actions\"><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div> </div> {{#else}} <div data-exam-answer=\"{{this.index}}\" data-exam-answer-formula='{{this.displayJson}}'> <div class=\"formula-flack\" data-f=\"{{this.display}}\"> <div data-f-content></div> </div><div class=\"formula-actions\"><a data-switch-type=\"solution\" data-exam-answer-edit=\"{{this.index}}\">{{>icon \"symbol-pen\"}}</a><a data-exam-answer-delete=\"{{this.index}}\">{{>icon \"symbol-x\"}}</a></div> </div> {{/if}}","formula/abs":"<div data-formula=\"abs\"> <div class=\"gutter\"> <div data-formula-before> <span></span> </div> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div data-formula-after> <span></span> </div> </div> </div>","formula/brakets":"<div data-formula=\"brakets\" class=\"problem--brakets\"> <div class=\"problem--braket-top\"></div> <div class=\"problem--braket-bottom\"></div> <div class=\"problem--row problem--group-row\"> <span class=\"problem--prefix\">{2}</span> <div class=\"problem--prefixed-formula\">{0}</div> </div> <div class=\"problem--row problem--group-row\"> <span class=\"problem--prefix\">{3}</span> <div class=\"problem--prefixed-formula\">{1}</div> </div> </div>","formula/error":"<h3 data-formula-content>{0}</h3>","formula/exp":"<div data-formula=\"exp\"> <div class=\"gutter\"> <div data-fit-box class=\"inline-block\" data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div class=\"half-size exp-sup\" data-sup-sub=\"not-set\" data-argument=\"2\" data-formula-content data-input-placeholder data-formula-level>{1} </div> </div> </div>","formula/lit":"lit({0})","formula/literal":"<span data-formula=\"literal\" data-literal-content=\"{0}\">{1}</span>","formula/log":"<div data-formula=\"log\"> <div class=\"gutter\"> <div class=\"inline-block\" data-formula-part=\"fnsub\"> <span data-formula-part=\"fn\" class=\"log\">log</span> <div data-formula-part=\"sub\" class=\"half-size log-sub\" data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> </div> <div class=\"inline-block log-body\"> <div data-fit-box data-argument=\"2\" data-formula-content data-input-placeholder data-formula-level>{1} </div> </div> </div> </div>","formula/mark":"<span data-formula=\"mark\" data-mark=\"{1}\">{0}</span>","formula/p":"<div data-formula=\"p\" data-parenthesis data-parenthesis-type=\"1\" data-parenthesis-force-type=\"{1}\"> <div class=\"gutter\"> <div data-formula-before> <span></span> </div> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div data-formula-after> <span></span> </div> </div> </div>","formula/per":"<div data-formula=\"per\"> <div class=\"gutter\"> <div data-formula-content-top> <div data-argument=\"1\" data-formula-level data-input-placeholder>{0}</div> </div> <div data-fit-box style=\"width:100%;height:1px;top:-1px;position:relative;\"></div> <div data-formula-content-bottom> <div data-argument=\"2\" data-formula-level data-input-placeholder>{1}</div> </div> </div> </div>","formula/root":"<div data-formula=\"root\"> <div class=\"half-size root-sup\" data-argument=\"2\" data-formula-content data-input-placeholder data-input-default=\"2\" data-formula-level> {1} </div> <div class=\"gutter inline-block\"> <div class=\"root-start\"> </div> <div class=\"root-body\"> <div data-fit-box data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level> {0} </div> <div class=\"root-end\"></div> </div> </div> </div>","formula/row-arrow-flag":"","formula/shape":"<div data-formula=\"shape\" class=\"formula--shape-{0}\"> <i class=\"icon-wrapper\"> <svg viewBox=\"0 0 256 256\"> <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{0}\"></use> </svg> </i> </div>","formula/sub":"<div data-formula=\"sub\"> <div class=\"gutter\"> <div data-fit-box class=\"inline-block\" data-argument=\"1\" data-formula-content data-input-placeholder data-formula-level>{0} </div> <div class=\"half-size sub-sub\" data-sup-sub=\"not-set\" data-argument=\"2\" data-formula-content data-input-placeholder data-formula-level>{1} </div> </div> </div>","formula/unmark":"<span data-unmark>{0}</span>","formula/wrapper":"<div class=\"calculator--element\" data-calculator-element data-calculator-element-type=\"{type}\" data-calculator-element-id=\"{id}\"><span data-calculator-element-before></span>{content}<span data-calculator-element-after></span></div>","formula":"<div class=\"formula-flack\" data-f=\"{{this}}\"> <div data-f-content></div> </div>","fromto":"<div class=\"problem--formula problem--formula-wrapper\"{{#if this.vertical}} data-problem-vertical{{/if}}> <div class=\"problem--formula-left\" data-formula style=\"{{#if !this.vertical}}padding: 10px 0;{{/if}} padding-right: 20px;\"> <div class=\"formula\" data-formula> {{#compute this.from /}} </div> {{#if this.vertical}} <div class=\"problem--formula-action\" {{#if !this.action}}style=\"visibility:hidden\"{{/if}} data-formula> <div class=\"formula\" data-fit-box> <span data-formula=\"literal\" class=\"problem--formula-action__per\">/</span> {{#compute this.action /}} </div> </div> {{#else}} <div class=\"problem--formula-arrow{{#if this.action}} problem--formula-arrow-no-action{{/if}}\" data-formula> {{>icon \"arrow-right\"}} </div> {{/if}} </div> <div class=\"problem--formula-right\" data-formula style=\"{{#if !this.vertical}}padding: 10px 0;{{/if}}}\"> <div class=\"problem--formula-arrow{{#if this.action}} problem--formula-arrow-no-action{{/if}}\" data-formula> {{>icon \"arrow-right\"}} </div> <div class=\"formula\" data-formula>{{#compute this.to /}}</div> </div> </div>","group-unapproveds":"{{#if this.users}} <div class=\"learn-period newsfeed__item\"> <span class=\"newsfeed__item__bold\">Csatlakozási kérelmek</span> {{#each this.users}} <div class=\"user-list__item\" style=\"border-top: 1px solid #fff; border-bottom: 1px solid #d6dbde;\"> <a class=\"user-list__name\" href=\"/hu/user/{{this._id}}\">{{this.name}}</a> <div class=\"user-list__actions\" data-group-join-approve-action> <a class=\"button button--iconed button--small\" data-user-action=\"approve-user:{{this._id}}\"> {{>icon \"symbol-pipe\"}} </a> <a class=\"button button--iconed button--small button--gray\" data-user-action=\"un-approve-user:{{this._id}}\"> {{>icon \"symbol-x\"}} </a> </div> </div> {{/each}} </div> {{/if}}","hcflcm":"{{#if this.cards}} {{#each this.cards}} <div class=\"card\"> {{#each this.parts}} {{#if this.message}} {{#if this.message.link}} <a class=\"card__message-link\" target=\"_blank\" href=\"{{#getLink this.message.link /}}&source=hcflcm\">{{#compute this.message.text /}}</a> {{#else}} <div class=\"card__p\">{{#compute this.message.text /}}</div> {{/if}} {{/if}} {{#if this.formula}} {{#each this.formula}} {{#if this.link}} <div class=\"academy-item card__formula{{#if this.highlighted}} card__formula--highlighted{{/if}}\"> <a class=\"card__formula__link\" target=\"_blank\" href=\"/hu/problem/direct/{{#base64 this.from/}}/?cmd={{this.link.cmd.replace(/#/g, '')}}&source=hcflcm\"> {{#if this.to}} <div data-fromto data-from=\"{{this.from}}\" data-to=\"{{this.to}}\" data-vertical=\"false\"></div> {{#else}} <div data-f=\"{{this.from}}\"><div data-f-content></div></div> {{/if}} </a> </div> {{#else}} <div style=\"display: block; max-width: 100%;text-align: left\" class=\"academy-item card__formula{{#if this.highlighted}} card__formula--highlighted{{/if}}\"> {{#if this.to}} <div data-fromto style=\"display: block; margin:0\" data-from=\"{{this.from}}\" data-to=\"{{this.to}}\" data-vertical=\"false\"></div> {{#else}} <div data-f=\"{{this.from}}\"><div data-f-content></div></div> {{/if}} </div> {{/if}} {{/each}} {{/if}} {{/each}} </div> {{/each}} {{/if}} {{#if this.final_message}} <div class=\"card\"> <strong>{{#compute this.final_message /}}</strong> </div> {{/if}}","icon":"<i class=\"icon-wrapper\"> <svg viewBox=\"0 0 256 256\"> <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-{{this}}\"></use> </svg> </i>","keyboard/5th-device":"<div class=\"pillar-box\" data-keyboard-var=\"5th\"> <div class=\"keyboard--section keyboard--section-characters\" style=\"width:60% !important;\"> <div class=\"keyboard--section-row\" style=\"padding-right:0;\"> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\"> <span>{{>icon \"formula-p\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"> <span>{{>icon \"formula-per\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span> {{>icon \"symbol-backspace\"}} </span> </button> </div> <div class=\"keyboard--section-row\"> {{#each '01234'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> {{#each '56789'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> </div> <div class=\"keyboard--section keyboard--section-actions\" style=\"width:40% !important;\"> <div class=\"keyboard--section-row\"> <div data-keyboard=\"extra-buttons\"></div> {{#each '+-*:'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"=\"> <span>=</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowup\"> <span> {{>icon \"arrow-key-up\"}} </span> </button> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-keyboard-alert=\"Hamarosan használható lesz.\"><span>,</span></button> </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowleft\"> <span> {{>icon \"arrow-key-left\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowdown\"> <span> {{>icon \"arrow-key-down\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowright\"> <span> {{>icon \"arrow-key-right\"}} </span> </button> </div> </div> </div>","keyboard/5th":"<div class=\"pillar-box\" data-keyboard-var=\"5th\"> <div class=\"keyboard--section keyboard--section-characters\"> <div class=\"keyboard--section-row\" style=\"font-size: 24px;padding-right:0;\"> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel – Gyorsbillentyű: (\"> <span>{{>icon \"formula-p\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\" title=\"Tört bevitel – Gyorsbillentyű: /\"> <span>{{>icon \"formula-per\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\" title=\"Törlés – Gyorsbillentyű: Backspace\"> <span> {{>icon \"symbol-backspace\"}} </span> </button> </div> <div class=\"keyboard--section-row\"> {{#each '0123456789'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> </div> <div class=\"keyboard--section keyboard--section-actions\" style=\"width:25%\"> <div class=\"keyboard--section-row\"> <div data-keyboard=\"extra-buttons\"></div> {{#each '+-*:'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"=\"> <span>=</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowup\"> <span> {{>icon \"arrow-key-up\"}} </span> </button> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-keyboard-alert=\"Hamarosan használható lesz.\" title=\"Hamarosan használható lesz.\"><span>,</span></button> </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowleft\"> <span> {{>icon \"arrow-key-left\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowdown\"> <span> {{>icon \"arrow-key-down\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowright\"> <span> {{>icon \"arrow-key-right\"}} </span> </button> </div> </div> </div>","keyboard/desktop":"<div class=\"pillar-box\" data-keyboard-var=\"default\"> <div class=\"keyboard--section keyboard--section-characters\"> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel – Gyorsbillentyű: (\"> <span>{{>icon \"formula-p\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\" title=\"Tört bevitel – Gyorsbillentyű: /\"> <span>{{>icon \"formula-per\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\" title=\"Hatvány bevitel – Gyorsbillentyű: Alt Gr\"> <span>{{>icon \"formula-exp\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\" title=\"Gyök bevitel – Gyorsbillentyű: Space\"> <span>{{>icon \"formula-root\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\" title=\"Logaritmus bevitel – Gyorsbillentyű: Ctrl+Space\"> <span>{{>icon \"formula-log\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span>{{>icon \"symbol-backspace\"}}</span> </button> </div> <div class=\"keyboard--section-row\"> {{#each '1234567890'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-qwerty title=\"QWERTY billentyűzet megjelenítése\"> <span>a-z</span> </button> {{#each 'xyabcdef'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> </div> <div class=\"keyboard--section keyboard--section-start\"> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-green\" data-keyboard-calculate> <span class=\"text\">start</span> <span class=\"icon\">{{>icon \"akriel-symbol\"}}</span> </button> </div> </div> <div class=\"keyboard--section keyboard--section-actions\"> <div class=\"keyboard--section-row\"> <div data-keyboard=\"extra-buttons\"></div> {{#each '+-*:'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"=\"> <span>=</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowup\"> <span> {{>icon \"arrow-key-up\"}} </span> </button> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-keyboard-alert=\"Hamarosan használható lesz.\" title=\"Hamarosan használható lesz.\"><span>,</span></button> </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowleft\"> <span> {{>icon \"arrow-key-left\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowdown\"> <span> {{>icon \"arrow-key-down\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowright\"> <span> {{>icon \"arrow-key-right\"}} </span> </button> </div> </div> </div>","keyboard/device":"<div class=\"pillar-box\" data-keyboard-var=\"default\"> <div class=\"keyboard--section\"> <div class=\"keyboard--section-row\" style=\"padding-right:20px;\"> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\"> <span>{{>icon \"formula-p\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"> <span>{{>icon \"formula-per\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\"> <span>{{>icon \"formula-exp\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"> <span>{{>icon \"formula-root\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"> <span>{{>icon \"formula-log\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span>{{>icon \"symbol-backspace\"}}</span> </button> </div> <div class=\"keyboard--section-row\"> {{#each '1234567890'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-qwerty> <span>a-z</span> </button> {{#each 'xyabcd'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowup\"> <span> {{>icon \"arrow-key-up\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--show-on-question\" data-keyboard-character-soon=\",\"> <span>,</span> </button> </div> <div class=\"keyboard--section-row\" style=\"margin-right:-10vw;\"> <div data-keyboard=\"extra-buttons\"></div> {{#each '+-*:'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"=\"> <span>=</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--hide-on-question\" data-keyboard-character-soon=\",\"> <span>,</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowleft\"> <span> {{>icon \"arrow-key-left\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowdown\"> <span> {{>icon \"arrow-key-down\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowright\"> <span> {{>icon \"arrow-key-right\"}} </span> </button> </div> </div> <div class=\"keyboard--section keyboard--section-start\"> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-green\" data-keyboard-calculate> <span class=\"text\">start</span> <span class=\"icon\">{{>icon \"akriel-symbol\"}}</span> </button> </div> </div> </div>","keyboard/extra-buttons":"{{#each this}}<button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button>{{/each}}","keyboard/qwerty-uppercase":"<div class=\"pillar-box\"> <div class=\"keyboard--section keyboard--section-allcharacters\"> <div class=\"keyboard--section-row\"> {{#each 'QWERTYUIOP'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> {{#each 'ASDFGHJKL'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-normal> <span>{{>icon \"symbol-more\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-qwerty> <span>{{>icon \"symbol-lowercase\"}}</span> </button> {{#each 'ZXCVBNM'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span> {{>icon \"symbol-backspace\"}} </span> </button> </div> </div> </div>","keyboard/qwerty":"<div class=\"pillar-box\"> <div class=\"keyboard--section keyboard--section-allcharacters\"> <div class=\"keyboard--section-row\"> {{#each 'qwertyuiop'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> {{#each 'asdfghjkl'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-normal> <span>{{>icon \"symbol-more\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-qwerty-uppercase> <span>{{>icon \"symbol-uppercase\"}}</span> </button> {{#each 'zxcvbnm'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span> {{>icon \"symbol-backspace\"}} </span> </button> </div> </div> </div>","keyboard/symbol-device":"<div class=\"pillar-box\" data-keyboard-var=\"symbol\"> <div class=\"keyboard--section keyboard--section-characters\" style=\"width:60% !important;\"> <div class=\"keyboard--section-row\" style=\"padding-right:0;\"> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\"> <span>{{>icon \"formula-p\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\"> <span>{{>icon \"formula-per\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\"> <span>{{>icon \"formula-exp\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\"> <span>{{>icon \"formula-root\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\"> <span>{{>icon \"formula-log\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span>{{>icon \"symbol-backspace\"}}</span> </button> </div> <div class=\"keyboard--section-row\"> {{#each '012x'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> {{#each 'ABCDEF'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"> <span data-formula=\"shape\" class=\"formula--shape-{{#lowercase this /}}\" style=\"display:inline\"> <i class=\"icon-wrapper\"><svg viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{{#lowercase this /}}\"></use></svg></i> </span> </button> {{/each}} </div> </div> <div class=\"keyboard--section keyboard--section-actions\" style=\"width:40% !important;\"> <div class=\"keyboard--section-row\"> <div data-keyboard=\"extra-buttons\"></div> {{#each '+-*:'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"=\"> <span>=</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowup\"> <span> {{>icon \"arrow-key-up\"}} </span> </button> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-keyboard-alert=\"Hamarosan használható lesz.\"><span>,</span></button> </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowleft\"> <span> {{>icon \"arrow-key-left\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowdown\"> <span> {{>icon \"arrow-key-down\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowright\"> <span> {{>icon \"arrow-key-right\"}} </span> </button> </div> </div> </div>","keyboard/symbol":"<div class=\"pillar-box\" data-keyboard-var=\"symbol\"> <div class=\"keyboard--section keyboard--section-characters\"> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"p\" title=\"Zárójel bevitel – Gyorsbillentyű: (\"> <span>{{>icon \"formula-p\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-p-placeholder\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"per\" title=\"Tört bevitel – Gyorsbillentyű: /\"> <span>{{>icon \"formula-per\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-per-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-per-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"exp\" title=\"Hatvány bevitel – Gyorsbillentyű: Alt Gr\"> <span>{{>icon \"formula-exp\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-exp-placeholder-1\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-exp-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"root\" title=\"Gyök bevitel – Gyorsbillentyű: Space\"> <span>{{>icon \"formula-root\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-root-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button--large\" data-keyboard-action=\"log\" title=\"Logaritmus bevitel – Gyorsbillentyű: Ctrl+Space\"> <span>{{>icon \"formula-log\"}}</span> <span class=\"keyboard--color-secondary\">{{>icon \"formula-log-placeholder-1\"}}</span> <span class=\"keyboard--color-primary\">{{>icon \"formula-log-placeholder-2\"}}</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"backspace\"> <span>{{>icon \"symbol-backspace\"}}</span> </button> </div> <div class=\"keyboard--section-row\"> {{#each '012x'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} {{#each 'ABCDEF'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"> <span data-formula=\"shape\" class=\"formula--shape-{{#lowercase this /}}\" style=\"display:inline\"> <i class=\"icon-wrapper\"><svg viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-shape-{{#lowercase this /}}\"></use></svg></i> </span> </button> {{/each}} </div> </div> <div class=\"keyboard--section keyboard--section-actions\" style=\"width:25%\"> <div class=\"keyboard--section-row\"> <div data-keyboard=\"extra-buttons\"></div> {{#each '+-*:'.split('')}} <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"{{this}}\"><span>{{this}}</span></button> {{/each}} </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character=\"=\"> <span>=</span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowup\"> <span> {{>icon \"arrow-key-up\"}} </span> </button> <button type=\"button\" class=\"keyboard--button\" data-keyboard-character-soon=\",\" data-keyboard-alert=\"Hamarosan használható lesz.\" title=\"Hamarosan használható lesz.\"><span>,</span></button> </div> <div class=\"keyboard--section-row\"> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowleft\"> <span> {{>icon \"arrow-key-left\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowdown\"> <span> {{>icon \"arrow-key-down\"}} </span> </button> <button type=\"button\" class=\"keyboard--button keyboard--button-transparent\" data-keyboard-method=\"arrowright\"> <span> {{>icon \"arrow-key-right\"}} </span> </button> </div> </div> </div>","learn/emocard":"<div class=\"emocard emocard--{{this.type}}\"> {{#if this.type === 'show-star'}} <div class=\"emocard__layer emocard__shine emocard__shine--white\"> <svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> <svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> </div> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-star\"></use></svg> {{#elseif this.type === 'show-medal'}} <div class=\"emocard__layer emocard__shine emocard__shine--white\"> <svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> <svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> </div> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-medal\"></use></svg> {{#elseif this.type === 'show-cup'}} <div class=\"emocard__layer emocard__shine emocard__shine--white\"> <svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> <svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> </div> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-cup\"></use></svg> {{#elseif this.type === 'show-cup-default'}} <div class=\"emocard__layer emocard__shine emocard__shine--white\"> <svg class=\"shine--1\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> <svg class=\"shine--2\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-shine\"></use></svg> </div> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-cup-default\"></use></svg> {{#elseif this.type === 'hide-star'}} <svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-star-shadow\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> {{#elseif this.type === 'hide-medal'}} <svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-medal-shadow\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> {{#elseif this.type === 'hide-cup'}} <svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-cup-shadow\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> {{#elseif this.type === 'okay'}} <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer emocard__float\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-arrow\"></use></svg> {{#elseif this.type === 'okay-gold'}} <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer emocard__float\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-checkmark-gold\"></use></svg> {{#elseif this.type === 'fail'}} <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg\"></use></svg> <svg class=\"emocard__layer emocard__float\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-x\"></use></svg> {{#elseif this.type === 'half-star'}} <svg class=\"emocard__layer emocard__shadow\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-star-shadow\"></use></svg> <svg class=\"emocard__layer\" viewBox=\"0 0 256 256\"><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#gamification-bg-gold\"></use></svg> {{/if}} </div>","learn-competition":"<table class=\"learn-period__table\" style=\"margin-bottom: .6em;\"> <tr> <td colspan=\"2\"> <span style=\"display:block;margin:0 0 .6em 0;font-weight:bold;font-size:1.2em;\">{{this.title}}</span> </td> </tr> {{#each this.competition.data}} <tr> <td class=\"learn-period__table__row-name\" style=\"vertical-align: middle\"> <span class=\"{{#if this.isMe}}learn-period__table__row-name--me{{/if}}\">{{this.name}}</span> </td> <td style=\"width: 100%\"> <div class=\"learn-period__chart\"> {{#if this.actual}} <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.actual)}}%\"> {{#if this.actual > 0 && !(this.counting && this.counting > 0)}} {{this.actual}} {{/if}} </div> {{/if}} {{#if this.counting && this.counting > 0}} <div class=\"learn-period__chart__i3\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.counting)}}%\">{{this.actual}}</div> {{/if}} </div> </td> </tr> {{/each}} </table>","learn-data":"{{#each this}} <div class=\"grid\" style=\"border-top: 0;\"> <h1 style=\"margin: 60px 0 0; border-bottom: 1px solid rgba(0,0,0,.2);max-width: 100%;\" data-learn-anchor=\"{{this.name}}\"> {{#compute this.title /}} </h1> </div> {{#each this.departments}} <div class=\"grid\" style=\"border-top: 0;\"> <h1 class=\"newsfeed__item__message\" data-learn-anchor=\"{{this.name}}\" style=\"display: block;text-align: center;margin: 30px 0;max-width: 100%;\"> {{this.index}}. {{#compute this.title /}} </h1> </div> {{#each this.topics}} {{#if this.type}} {{#if this.type === \"h1\"}} <span class=\"newsfeed__item__message\" style=\"display: block;text-align: center;margin: 60px 0 30px;font-size: 28px;line-height: 32px;\"> {{#compute this.value /}} </span> {{#elseif this.type === \"topic-h1\"}} <span class=\"newsfeed__item__message\" style=\"display: block;text-align: center;margin: 45px auto 0;border-bottom: 3px solid #ccc;padding: 0 0 7px 0;width: 33%;\"> Témakör </span> <span class=\"newsfeed__item__message\" style=\"display: block;text-align: center;margin: 15px 0 45px;font-size: 28px;line-height: 32px;\"> {{#compute this.value /}} </span> {{/if}} {{#else}} <a class=\"newsfeed__item {{#if this.stat.cup || this.stat.cupDefault}}newsfeed__item__cup{{/if}}{{#if this.paid}} newsfeed__item__paid{{/if}}\" href=\"/hu/learn/topic/{{this.id}}\" data-topic-card=\"{{this.id}}\"> <table style=\"width: 100%;margin-bottom: -5px;\"> <tr> <td> {{#if this.stat.cup || this.stat.cupDefault}} {{#if this.stat.cup}} <span class=\"learn__lesson__cup\"> {{>icon \"learn-cup-detailed\"}} </span> {{#else}} {{#if this.stat.cupDefault}} <span class=\"learn__lesson__cup\"> {{>icon \"learn-cup-default-detailed\"}} </span> {{/if}} {{/if}} {{/if}} </td> <td width=\"900\"> <div class=\"newsfeed__item__message\" style=\"margin: 0\"> {{#compute this.title /}} <span class=\"learn__lesson__title__score\"> - <span style=\"position:relative; top: -2px\">{{>icon \"learn-medal\"}}</span> {{this.stat.medal}} / <b style=\"font-weight: bold\">{{this.stat.allMedal}}</b> {{#if this.id.indexOf('Soon') > -1}} <br>{{#if this.subTitle}}{{#compute this.subTitle /}} {{/if}}(Bemutató lecke) {{#else}} {{#if this.subTitle}} <br>{{#compute this.subTitle /}} {{/if}} {{/if}} </span> </div> <div class=\"newsfeed__item__details\" style=\"margin-top: 5px;margin-bottom: -5px\"> <div style=\"display: flex; align-items: center\"> <table style=\"width: 100%\"> <tr> <td width=\"900\"> <div class=\"learn-period__chart\"> {{#if this.stat.percentage > 0}} <div class=\"learn-period__chart__i2\" style=\"width: {{this.stat.percentage}}%\"> {{#if this.stat.percentage === 100}} <span style=\"color: #6446FF\">{{this.stat.star}}</span> {{/if}} </div> {{/if}} {{#if this.stat.percentage < 100}} <div class=\"learn-period__chart__i3\" style=\"width: calc(100% - {{this.stat.percentage}}%)\"> {{#if this.stat.star}} {{this.stat.star}} {{/if}} </div> {{/if}} </div> </td> <td style=\"white-space: nowrap\"> {{#if this.paid}} <span class=\"button button--small button--gray\">Ugrás a leckére</span> {{#else}} <span class=\"button button--small\">Ugrás a leckére</span> {{/if}} </td> </tr> </table> </div> </div> </td> <td> {{#if this.stat.bestExam}} <span class=\"grade-mark\"><span>{{this.stat.bestExam}}%</span></span> {{/if}} </td> </tr> </table> <div data-onscroll-cosmetic> {{#if this.preview.length > 0}} <div class=\"newsfeed__item__message\" style=\"margin: 0; padding: 0 5px\"> <span class=\"learn__lesson__title__score\">Ízelítő:</span> </div> <ul class=\"learn__lectures\" style=\"margin: -15px; padding: 15px !important; display: block;\"> {{#if this.pictogram}} <li data-learn-has-medal=\"false\" class=\"academy-item\" style=\"box-sizing: border-box; width: initial; display: block; border: 0; white-space: initial\"> <div data-fromto data-from=\"{{#computeAcademyJSON this.pictogram.from /}}\" data-to=\"{{#computeAcademyJSON this.pictogram.to /}}\" data-action=\"{{#computeAcademyJSON this.pictogram.action /}}\" {{#if this.pictogram.vertical}}data-vertical=\"true\"{{/if}}> <div data-f-content></div> </div> </li> {{/if}} {{#each this.preview}} <li data-learn-has-medal=\"false\"> <div data-f=\"{{this}}\"> <div data-f-content></div> </div> </li> {{/each}} </ul> {{/if}} </div> </a> {{/if}} {{/each}} <div class=\"newsfeed__item\" style=\"text-align: center\"> <a class=\"button button--small\" data-open-overlay=\"select-year\">Ugrás egy témakörre</a> </div> {{/each}} {{/each}}","learn-error":"{{#if this.error && this.error.message}} {{#compute this.error.message /}} {{#else}} Valami hiba történt. {{/if}}","learn-period":"{{#if this.race && this.race.length > 0}} <table class=\"learn-period__table learn-period__table--race\" data-lp-live> {{#each this.race}} <tr data-lp-user-row=\"{{this.user.id}}\" data-lp-user-last-progress=\"{{this.lastProgressAt}}\" data-lp-user-last-signal=\"{{this.lastRaceSignalAt}}\" data-lp-user-last-focus-change=\"{{this.lastFocusChangeAt}}\" data-lp-user-focus=\"{{#if this.focus}}true{{#else}}false{{/if}}\" data-lp-user-focus-known=\"{{#if this.focusKnown}}true{{#else}}false{{/if}}\" data-lp-user-closed=\"{{#if this.closed}}true{{#else}}false{{/if}}\" data-lp-user-active=\"{{#if this.isRaceActive}}true{{#else}}false{{/if}}\" class=\"{{#if !this.isRaceActive}}row--inactive{{/if}}\"> <td class=\"learn-period__table__row-name\" width=\"0\"> <div class=\"learn-period__table__row-wrapper\"> <a href=\"?filterUser={{this.user.id}}\" title=\"{{this.user.name}}\" class=\"learn-period__secondary-title\"> {{this.user.name}} </a> </div> </td> <td width=\"100%\"> <div class=\"learn-period__chart\"> {{#if this.count}} <div class=\"learn-period__chart__i2\" data-lp-bar style=\"width: {{(this.count / meta.parent.context.max * 100)}}%\"></div> {{/if}} <div class=\"learn-period__chart__i3\" style=\"width: {{100 - (this.count / meta.parent.context.max * 100)}}%\"> {{this.count}} </div> </div> </td> <td class=\"learn-period__table__row-topic\" width=\"0\"> {{#if this.topic}} <a href=\"?filterTopic={{this.topic.id}}\" title=\"{{#computeSilence this.topic.title /}}\" class=\"learn-period__secondary-title\"> <b>{{this.topic.idx}}</b> <span class=\"topic-title\">{{#computeSilence this.topic.title /}}</span> </a> {{#else}} - {{/if}} </td> </tr> {{/each}} </table> {{/if}}{{#if this.sortedStars && this.sortedStars.length > 0}} <table class=\"learn-period__table\"> <tr> <td colspan=\"2\"> <span style=\"margin: 30px 0 15px 0\" class=\"learn-period__primary-title newsfeed__item__bold\"> <span style=\"color: #FFD700\">{{>icon \"star\"}}</span> Csillag összesítő </span> </td> </tr> {{#each this.sortedStars}} <tr> <td class=\"learn-period__table__row-name\" width=\"0\"> <div class=\"learn-period__table__row-wrapper\"> <a href=\"?filterUser={{this.user.id}}&fromView=cup\" title=\"{{this.user.name}}\" class=\"learn-period__secondary-title\">{{this.user.name}}</a> </div> </td> <td width=\"100%\"> <div class=\"learn-period__chart\"> {{#if this.count}} <div class=\"learn-period__chart__i2\" style=\"width: {{(this.count / meta.parent.context.maxStars * 100)}}%\"></div> {{/if}} <div class=\"learn-period__chart__i3\" style=\"width: {{100 - (this.count / meta.parent.context.maxStars * 100)}}%\">{{this.count}}</div> </div> </td> </tr> {{/each}} <tr> <td colspan=\"2\"> <div style=\"display: flex; text-align: center;border-top: 3px solid rgba(49,55,68,0.23); margin-top: 15px\"> <div style=\"width:100%\"> <span style=\"margin: 15px 0;\" class=\"learn-period__primary-title newsfeed__item__bold\"> {{this.allStars}} </span> Össz-csillagszám </div> <div style=\"width:100%\"> <span style=\"margin: 15px 0;\" class=\"learn-period__primary-title newsfeed__item__bold\"> {{this.averageStars}} </span> Átlag csillagszám </div> </div> </td> </tr> </table> {{/if}}{{#if (this.users || this.topics|| this.sortedCups)}} <table class=\"learn-period__table{{#if this.sortedCups}} learn-period__table--gold{{/if}}\"> {{#each this.users}} <tr> <td colspan=\"2\"> <table width=\"100%\"> <tr> <td width=\"100%\"> <a href=\"?filterUser={{this.id}}&fromView=user\" class=\"learn-period__primary-title newsfeed__item__bold\"> {{>icon \"symbol-user\"}} {{this.name}} {{#if this.lasActivity}} <span style=\"opacity: .5; font-size: 13px\"> - (<span style=\"text-transform: lowercase\"> Utolsó aktivitás <span data-ago-moment=\"{{this.lastActivity}}\"></span>.</span>) </span> {{/if}} </a> </td> <td style=\"text-align:right; white-space:nowrap\"> {{#if this.summary}} <div class=\"newsfeed__item__bold\" style=\"margin-top: 30px; margin-bottom: 5px;\"> {{#if this.summary.stars}} {{this.summary.stars}} <span style=\"color:#ff9f28; top: -2px; position: relative;\">{{>icon 'star'}}</span> {{/if}} {{#if this.summary.cups}} {{this.summary.cups}} <span class=\"learn-period__cup\" style=\"float:none; display:inline-block\"> {{>icon \"learn-cup\"}} </span> {{/if}} </div> {{/if}} </td> </tr> </table> </td> <td></td> </tr> {{#each this.topics}} {{#if this.department}} <tr> <td colspan=\"3\"> <span class=\"learn-period__subtitle\"> {{#compute this.department /}} </span> </td> </tr> {{/if}} <tr> <td class=\"learn-period__table__row-name\" width=\"0\"> <div class=\"learn-period__table__row-wrapper\"> {{#if this.cup}} <a href=\"?view=cup\" class=\"learn-period__cup\"> {{>icon \"learn-cup\"}} </a> {{#elseif this.defaultCup}} <a href=\"?view=cup\" class=\"learn-period__cup\"> {{>icon \"learn-cup-basic\"}} </a> {{/if}} <a href=\"?filterTopic={{this.id}}\" title='{{#computeSilence this.title /}}' class=\"learn-period__secondary-title\"> <b>{{this.idx}}</b> {{#compute this.title /}} </a> </div> </td> <td width=\"100%\"> <div class=\"learn-period__chart\"> {{#if this.before}} <div class=\"learn-period__chart__i1\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.before)}}%\">{{this.before}}</div> {{/if}} {{#if this.actual}} <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.actual)}}%\">{{#if this.actual > 0}}{{this.actual}}{{/if}}</div> {{/if}} {{#if this.counting && this.counting > 0}} <div class=\"learn-period__chart__i3\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.counting)}}%\"></div> {{/if}} </div> </td> <td width=\"0\"> {{#if this.bestExam}}<a class=\"grade-mark\" href=\"/hu/exam/{{this.bestExam.examId}}\" target=\"_blank\"><span title=\"Dolgozat\" style=\"{{#if this.bestExam.grade === 100}}font-weight:bold;color:#e06476{{#else}}color:#5e626a{{/if}}\">{{this.bestExam.grade}}%</span></a>{{/if}} </td> </tr> {{/each}} {{/each}} {{#each this.topics}} {{#if this.department}} <tr> <td colspan=\"3\"> <span class=\"learn-period__primary-title newsfeed__item__bold\" style=\"font-size: 28px; margin-top: 45px; text-align: center;\"> {{#compute this.department /}} </span> </td> </tr> {{/if}} <tr> <td colspan=\"2\"> <table width=\"100%\"> <tr> <td width=\"100%\"> <a href=\"?filterTopic={{this.id}}\" class=\"learn-period__primary-title newsfeed__item__bold\"> {{>icon \"menu-academy\"}} <b>{{this.idx}}</b> {{#compute this.title /}} </a> </td> <td style=\"text-align:right; white-space:nowrap\"> {{#if this.summary}} <div class=\"newsfeed__item__bold\" style=\"margin-top: 30px; margin-bottom: 5px;\"> {{#if this.summary.stars}} {{this.summary.stars}} <span style=\"color:#ff9f28; top: -2px; position: relative;\">{{>icon 'star'}}</span> {{/if}} {{#if this.summary.cups}} {{this.summary.cups}} <span class=\"learn-period__cup\" style=\"float:none; display:inline-block\"> {{>icon \"learn-cup\"}} </span> {{/if}} </div> {{/if}} </td> </tr> </table> </td> <td></td> </tr> {{#each this.users}} <tr> <td class=\"learn-period__table__row-name\" width=\"0\"> <div class=\"learn-period__table__row-wrapper\"> {{#if this.cup}} <a href=\"?view=cup\" class=\"learn-period__cup\"> {{>icon \"learn-cup\"}} </a> {{#elseif this.defaultCup}} <a href=\"?view=cup\" class=\"learn-period__cup\"> {{>icon \"learn-cup-basic\"}} </a> {{/if}} <a href=\"?filterUser={{this.id}}&fromView=topic\" title=\"{{this.name}}\" class=\"learn-period__secondary-title\">{{this.name}}</a> </div> </td> <td width=\"100%\"> <div class=\"learn-period__chart\"> {{#if this.before}} <div class=\"learn-period__chart__i1\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.before)}}%\">{{this.before}}</div> {{/if}} {{#if this.actual}} <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.actual)}}%\">{{#if this.actual > 0}}{{this.actual}}{{/if}}</div> {{/if}} {{#if this.after}} <div class=\"learn-period__chart__i1\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.after)}}%\">{{this.after}}</div> {{/if}} {{#if this.counting && this.counting > 0}} <div class=\"learn-period__chart__i3\" style=\"width: {{100 / (((this.before || 0) + (this.after || 0) + (this.actual || 0) + Math.max((this.counting || 0), 0)) / this.counting)}}%\"></div> {{/if}} </div> </td> <td width=\"0\"> {{#if this.bestExam}} <a class=\"grade-mark\" href=\"/hu/exam/{{this.bestExam.examId}}\" target=\"_blank\"> <span title=\"Dolgozat\" style=\"{{#if this.bestExam.grade === 100}}font-weight:bold;color:#e06476{{#else}}color:#5e626a{{/if}}\"> {{this.bestExam.grade}}% </span> </a> {{/if}} </td> </tr> {{/each}} {{/each}} {{#if this.sortedCups && this.sortedCups.length > 0}} <tr> <td colspan=\"3\"> <span style=\"margin: 15px 0; color: #fff\" class=\"learn-period__primary-title newsfeed__item__bold\"> <span style=\"color: #FFD700\">{{>icon \"learn-cup\"}}</span> Serleg összesítő </span> </td> </tr> {{#each this.sortedCups}} <tr> <td class=\"learn-period__table__row-name\" width=\"0\"> <div class=\"learn-period__table__row-wrapper\"> <a href=\"?filterUser={{this.user.id}}&fromView=cup\" title=\"{{this.user.name}}\" class=\"learn-period__secondary-title\">{{this.user.name}}</a> </div> </td> <td width=\"100%\"> <div class=\"learn-period__chart\"> {{#if this.count}} <div class=\"learn-period__chart__i2{{#if this.counting === 0}} learn-period__chart__done{{/if}}\" style=\"width: {{this.count / meta.parent.context.maxCups * 100}}%;\"></div> <div class=\"learn-period__chart__i3\" style=\"width: {{100 - (this.count / meta.parent.context.maxCups * 100)}}%\">{{this.count}}</div> {{#else}} <div class=\"learn-period__chart__i3\" style=\"width:100%\"></div> {{/if}} </div> </td> </tr> {{/each}} <tr> <td colspan=\"3\"> <div style=\"display: flex; color: #fff; text-align: center;border-top: 3px solid rgba(49,55,68,0.23); margin-top: 15px\"> <div style=\"width:100%\"> <span style=\"margin: 15px 0; color: #ffd700\" class=\"learn-period__primary-title newsfeed__item__bold\"> {{this.allCups}} </span> Össz-serlegszám </div> <div style=\"width:100%\"> <span style=\"margin: 15px 0; color: #ffd700\" class=\"learn-period__primary-title newsfeed__item__bold\"> {{this.averageCups}} </span> Átlag serlegszám </div> </div> </td> </tr> {{/if}} {{#if Object.keys(this.topics || {}).length + Object.keys(this.users || {}).length === 0 && (this.sortedCups || {}).length === 0}} <tr> <td colspan=\"3\"> {{#if this.sortedCups}} <span class=\"learn-period__primary-title newsfeed__item__bold\" style=\"color: #FFFFFF; margin: 0\"> Még senki nem szerzett serleget ebben a tanulócsoportban. </span> {{#else}} <span class=\"learn-period__primary-title newsfeed__item__bold\"> Nem történt még aktivitás ebben a tanciklusban. </span> {{/if}} </td> </tr> {{/if}} </table> {{/if}}","learn-solutions":"{{#each this.items}} <div class=\"newsfeed__item\" data-newsfeed-story=\"{{this._id}}\"> <div class=\"newsfeed__item__details\"> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.problem.clone}}\"><div data-f-content></div></div> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap; float: right; padding: 10px 0\"></a> <div data-nf-input-details></div> </div> <div data-nf-card-actions> <div class=\"newsfeed__item__actions\"> {{#if this.data.details && this.data.details.events}} <a class=\"button button--small\" data-group-show-details='{{#base64 JSON.stringify(this.data) /}}'> Saját megoldás ({{this.data.details.events.length}}) </a> <a class=\"button button--small button--purple\" target=\"_blank\" href=\"{{this.data.details.problem.solutionLink}}\"> Akrieles megoldás </a> {{/if}} </div> </div> </div> {{/each}}","live-client":"<div class=\"newsfeed__item newsfeed__item--lecture-history\"> <div class=\"newsfeed__item__details\"> <p class=\"newsfeed__item__text--global\"> <div data-live-client-block=\"0\" data-live-client-stamp=\"{{this.closed}}@{{this.userId}}@{{this.url}}@{{this.userName}}\"> <div class=\"newsfeed__item__bold\" style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:100%\"> <a href=\"/hu/user/{{this.userId}}\" style=\"font-weight:normal;\">{{this.userName}}</a> </div> {{#if !this.closed && this.url}} <div class=\"newsfeed__item__bold\" style=\"white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width:100%\"> <a target=\"_blank\" href=\"{{this.url}}\">{{this.title}} <span style=\"font-size:.66em\" title=\"{{this.url}}\">[<span style=\"opacity:.5;\">{{this.url.replaceAll('&', '&amp;')}}</span>]</span></a> </div> <a href=\"/hu/user/{{this.userId}}\">{{this.userName}}</a> <span data-ago-moment=\"{{this.timeStamp}}\"></span> a(z) <a href=\"{{this.url}}\" title=\"{{this.url}}\">{{this.title}}</a> oldalon tartózkodik. {{#else}} <a href=\"/hu/user/{{this.userId}}\">{{this.userName}}</a> jelenleg inaktív. {{/if}} </div> <div data-live-client-block=\"1\" data-live-client-stamp=\"{{this.focus}}@{{this.url}}\"> {{#if this.url && !this.closed && !this.focus}} Jelenleg épp inaktív. {{/if}} </div> <div data-live-client-block=\"2\" data-live-client-stamp=\"{{this.problemInstruction}}@{{this.problemClone}}\"> {{#if !this.closed && this.problemClone}} {{#if this.problemSolutionLink}} Az alábbi feladaton dolgozik épp: {{/if}} <div style=\"display:block;\" data-f=\"{{this.problemInstruction}}\"> <div data-f-content style=\"white-space: normal\"></div> </div> <div class=\"formula-flack\" data-f=\"{{this.problemClone}}\"> <div data-f-content></div> </div> {{/if}} </div> <div data-live-client-block=\"3\" data-live-client-block-type=\"single\" data-live-client-stamp=\"{{btoa(JSON.stringify(this.history || {}))}}\"> {{#if this.history && this.history.data && this.history.data.details && this.history.data.details.events && this.history.data.details.events.length}} <p>Eddigi lépések:</p> {{#each this.history.data.details.events}} <div style=\"padding: 15px;\"> <div style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\" data-f=\"{{this.formula}}\"><div data-f-content></div></div> {{#if this.type === 'fail'}} <span style=\"float: right; color: #e06476\" title='Nem jó az érték'>{{>icon 'symbol-x'}}</span> {{#elseif this.type === 'ok'}} <span style=\"float: right\" title='A formulának jó az értéke, de még nem a végeredmény'>{{>icon 'symbol-pipe'}}</span> {{#elseif this.type === 'perfect'}} <span style=\"float: right; color: #38d090\" title='Helyes végeredmény'>{{>icon 'symbol-pipe'}}</span> {{/if}} </div> {{/each}} {{/if}} </div> <div data-live-client-block=\"4\" data-live-client-block-type=\"list\" data-live-client-stamp=\"{{btoa(JSON.stringify(this.lastStep || {}))}}\"> {{#if this.lastStep}} Legutóbbi lépés: {{#if this.historyId}} {{#with this.lastStep}} <div style=\"padding: 15px;\"> {{#if this.formula}} <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\"> {{#compute this.formula /}} </div> {{#else}} {{#if this.type === 'text'}} <span style=\"float: right;\" title='Kommentár'>{{>icon 'symbol-speach-bubble'}}</span> <p style=\"margin-bottom: 15px\">{{this.content}}</p> {{#elseif this.type === 'formula'}} <span style=\"float: right;\" title='Kommentár'>{{>icon 'symbol-speach-bubble'}}</span> <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\"> {{#compute this.content /}} </div> {{#elseif this.type === 'comment-doodle'}} <span style=\"float: right;\" title='Kommentár'>{{>icon 'symbol-speach-bubble'}}</span> <p class=\"formula-flack\"> <img data-doodle-id=\"{{this.content}}\" class=\"doodle-image\" src=\"/doodle/{{this.content}}.svg\" /> </p> {{#elseif this.type === 'prime-table'}} <span style=\"float: right;\" title='Prímfelbontó számolótábla'>{{>icon 'symbol-prim-table'}}</span> <div class=\"prime-table\"> <div class=\"prime-table__left\"> {{#each this.content}} <div class=\"prime-table__cell\">{{this[0] > 0 ? this[0] : '&nbsp;'}}</div> {{/each}} </div> <div class=\"prime-table__right\"> {{#each this.content}} <div class=\"prime-table__cell\">{{this[1] > 0 ? this[1] : '&nbsp;'}}</div> {{/each}} </div> </div> {{/if}} {{/if}} {{#if this.type === 'fail'}} <span style=\"float: right; color: #e06476\" title='Nem jó az érték'>{{>icon 'symbol-x'}}</span> {{#elseif this.type === 'ok'}} <span style=\"float: right\" title='A formulának jó az értéke, de még nem a végeredmény'>{{>icon 'symbol-pipe'}}</span> {{#elseif this.type === 'perfect'}} <span style=\"float: right; color: #38d090\" title='Helyes végeredmény'>{{>icon 'symbol-pipe'}}</span> {{/if}} </div> {{/with}} {{#else}} {{#with this.lastStep}} <div class=\"exam__problem__solution\"> {{#if this.type === 'comment-doodle'}} {{>icon 'symbol-speach-bubble'}} <p class=\"formula-flack\"> <img data-doodle-id=\"{{this.display}}\" class=\"doodle-image\" src=\"/doodle/{{this.display}}.svg\" /> </p> {{#elseif this.type === 'comment-text'}} {{>icon 'symbol-speach-bubble'}} <p class=\"formula-flack\">{{this.display}}</p> {{#elseif this.type === 'comment-formula'}} {{>icon 'symbol-speach-bubble'}} <div class=\"formula-flack\" data-f=\"{{this.display}}\"> <div data-f-content></div> </div> {{#elseif this.type === 'solution'}} {{#if this.result === 0}} <span style=\"float: right; color: #e06476\" title='Nem jó az érték'>{{>icon 'symbol-x'}}</span> {{#elseif this.result === 1}} <span style=\"float: right\" title='A formulának jó az értéke, de még nem a végeredmény'>{{>icon 'symbol-pipe'}}</span> {{#elseif this.result === 2}} <span style=\"float: right; color: #38d090\" title='Helyes végeredmény'>{{>icon 'symbol-pipe'}}</span> {{/if}} <div class=\"formula-flack\" data-f=\"{{this.display}}\"> <div data-f-content></div> </div> {{/if}} </div> {{/with}} {{/if}} {{/if}} </div> <div data-live-client-block=\"5\" data-live-client-stamp=\"{{(this.input || {}).value}}@{{#if this.input && this.input.type === 'doodle'}}{{Math.random()}}{{/if}}\"> {{#if !this.closed && this.input && this.input.value}} Aktuális lépés: <div style=\"padding: 15px; overflow: auto;\"> {{#if this.input.type === 'formula'}} <div data-formula style=\"font-size: 22px; margin-bottom: 15px; color: #313744;\"> {{#compute this.input.value /}} </div> {{#elseif this.input.type === 'doodle'}} <p class=\"formula-flack\"> <img data-doodle-id=\"{{this.input.value}}\" class=\"doodle-image\" src=\"/doodle/{{this.input.value}}.svg?{{Math.random()}}\" /> </p> {{/if}} </div> {{/if}} </div> </p> </div> <div class=\"newsfeed__item__actions\" data-live-client-block=\"6\" data-live-client-stamp=\"{{this.winId}}@{{this.problemSolutionLink}}\"> {{#if !this.closed && this.winId}} <a class=\"button button--small\" href=\"/hu/mirror/{{this.winId}}\" target=\"_blank\"> Élő kép </a> {{/if}} {{#if !this.closed && this.problemSolutionLink}} <a class=\"button button--small button--purple\" target=\"_blank\" href=\"{{this.problemSolutionLink}}\"> Akrieles megoldás </a> {{/if}} </div> </div>","mail-to":"{{#if this.support}} <a href=\"mailto:{{base64Decode('c3VwcG9ydEBha3JpZWwuaW8=')}}\" class=\"strong\">{{base64Decode('c3VwcG9ydEBha3JpZWwuaW8=')}}</a> {{#else}} <a href=\"mailto:{{base64Decode('aW5mb0Bha3JpZWwuaW8=')}}\" class=\"strong\">{{base64Decode('aW5mb0Bha3JpZWwuaW8=')}}</a> {{/if}}","newsfeed-card-actions":"<div class=\"newsfeed__item__actions\"> {{#if this.category === 'exam' && this.data.examId}} {{#if this.data.type === 'exam-started'}} <a class=\"button button--green button--small\" href=\"/hu/group/exam/{{this.data.examId}}/live\"> Ugrás a dolgozatra </a> {{#else}} <a class=\"button button--green button--small\" href=\"/hu/exam/{{this.data.examId}}\"> Ugrás a dolgozatra </a> {{/if}} {{#elseif this.data.type === 'exam-collected'}} <a class=\"button button--green button--small\" href=\"/hu/group/exam/{{this.data.groupExamId}}/live\"> Ugrás a dolgozatra </a> {{/if}} {{#if this.data.type === 'group-topic' && this.data.topic}} <a class=\"button button--small\" href=\"/hu/learn/topic/{{this.data.topic.id}}\"> Ugrás a leckére </a> {{/if}} {{#if this.data.details && this.data.details.events && this.data.details.events.length}} <a class=\"button button--small\" data-group-show-details='{{#base64 JSON.stringify(this.data) /}}'> Saját megoldás ({{this.data.details.events.length}}) </a> <a class=\"button button--small button--purple\" target=\"_blank\" href=\"/hu{{this.data.details.problem.solutionLink}}\"> Akrieles megoldás </a> {{#elseif this.data.details && this.data.details.problem && this.data.details.problem.solutionLink}} <a class=\"button button--small button--purple\" target=\"_blank\" href=\"/hu{{this.data.details.problem.solutionLink}}\"> Akrieles megoldás </a> {{#elseif this.data.details && this.data.details.problem && typeof this.data.details.problem === 'string'}} <a class=\"button button--small button--purple\" target=\"_blank\" href=\"/hu/problem/{{this.data.details.problem}}\"> Akrieles megoldás </a> {{/if}} {{#if this.data.type === 'group-connect-request'}} <a class=\"button button--gray button--small\" data-group-join-approve-action data-show-unapproved-users=\"{{this.data.groupId}}\"> Kérelmek kezelése </a> {{/if}} {{#if this.data.type !== 'user-like'}} {{#if this.liked}} <a data-unlike-story=\"{{this._id}}\" class=\"button button--secondary button--small button--heart\" style=\"color:#e06476\"> {{>icon 'symbol-heart'}} <span data-count>{{#if this.like && this.like.length > 0}}{{this.like.length}}{{/if}}</span> </a> {{#else}} <a data-like-story=\"{{this._id}}\" class=\"button button--gray button--small button--heart\"> {{>icon 'symbol-heart-full'}} <span data-count>{{#if this.like && this.like.length > 0}}{{this.like.length}}{{/if}}</span> </a> {{/if}} {{/if}} {{#if this.reply && this.reply.length === 0}} <a href=\"/hu/story/{{this._id}}\" class=\"button button--secondary button--small newsfeed__item__actions__reply\">válasz</a> {{#elseif this.reply && this.reply.length > 0}} <a href=\"/hu/story/{{this._id}}\" class=\"button button--small newsfeed__item__actions__reply\">{{this.reply.length}} válasz</a> {{/if}} </div>","newsfeed-card":"<div data-newsfeed-story=\"{{this._id}}\"> <div class=\"newsfeed__item newsfeed__item--{{this.data.type}} {{#if this.data.highlighted}}newsfeed__item--highlighted{{/if}}\"> {{#if this.archived}} <div class=\"newsfeed__item__details\" style=\"margin: 0; opacity: .5;\">Ez a bejegyzés nem elérhető...</div> {{#else}} {{#if this.data.type === 'user-like' && this.user}} <div class=\"newsfeed__item__details\"> <span style=\"color:#e06476\">{{>icon 'symbol-heart-full'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> kedveli <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> </div> {{/if}} {{#if this.data.reply}} <div class=\"newsfeed__item__reply-wrapper\"> {{>newsFeedCard this.data.reply}} </div> {{/if}} {{#if this.data.type == 'connect-to-group' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> csatlakozott <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoporhoz. </div> {{#elseif this.data.type == 'group-connect-request'}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.data.executiveUserId}}\">{{this.data.executiveUser ? this.data.executiveUser.name : 'Névtelen felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> szeretné, ha csatlakozhatna, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoporthoz. {{#if this.data.message}} <div class=\"newsfeed__item__message\">{{#postReplacer this.data.message /}}</div> {{/if}} </div> {{#elseif this.data.type == 'disconnect-from-group' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> elhagyta <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportot. </div> {{#elseif this.data.type == 'approve-user' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> jelentkezését <a href=\"/hu/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Névtelen felhasználó'}).name}}</a> elfogadta <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. </div> {{#elseif this.data.type == 'un-approve-user' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> jelentkezését <a href=\"/hu/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Névtelen felhasználó'}).name}}</a> visszautasította <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. </div> {{#elseif this.data.type == 'remove-user' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Névtelen felhasználó'}).name}}</a> eltávolította <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> felhasználót <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportból. </div> {{#elseif this.data.type == 'add-owner-role' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> csoportvezető lett <a href=\"/hu/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Névtelen felhasználó'}).name}}</a> által <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. </div> {{#elseif this.data.type == 'remove-owner-role' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-user'}} </span> <a href=\"/hu/user/{{this.data.executiveUserId}}\">{{(this.data.executiveUser || {name: 'Névtelen felhasználó'}).name}}</a> visszavonta <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> csoportvezetői jogait <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. </div> {{#elseif this.data.type == 'create-group' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-pen'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> létrehozta a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportot. {{#if this.data.message}} <div class=\"newsfeed__item__message\">{{#postReplacer this.data.message /}}</div> {{/if}} </div> {{#elseif this.data.type == 'delete-group' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-trash'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> archiválta a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportot. </div> {{#elseif this.data.type == 'group-name-modified' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-pen'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> átnevezte, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group && this.data.group.name}}</a> nevű tanulócsoportot erre: \"<b style=\"font-weight: bold\">{{this.data.newName}}</b>\". </div> {{#elseif this.data.type == 'group-description-modified' && this.user}} <div class=\"newsfeed__item__details\"> <span>{{>icon 'symbol-pen'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> megváltoztatta a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoport leírását. <div class=\"newsfeed__item__message\">{{#postReplacer this.data.newDescription /}}</div> </div> {{#elseif this.data.type === 'earn-default-cup' && this.data.topic && this.user}} <div class=\"newsfeed__item__system-message\"> {{>icon 'learn-cup-basic'}} <div class=\"newsfeed__item__bold\"> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> szerzett egy serleget, </div> <p> amiért megoldott minden példából egyet a(z) <a href=\"/hu/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a> nevű leckében. </p> <p style=\"margin: 30px 0 0; opacity: .5\"><a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a></p> </div> {{#elseif this.data.type === 'earn-cup' && this.data.topic && this.user}} <div class=\"newsfeed__item__system-message\"> {{>icon 'learn-cup'}} <div class=\"newsfeed__item__bold\"> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> szerzett egy füles serleget, </div> <p> amiért megoldott minden példát, a(z) <a href=\"/hu/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a> nevű leckében. </p> <p style=\"margin: 30px 0 0; opacity: .5\"><a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a></p> </div> {{#elseif this.data.type == 'group-get-new-cup' && this.data.topic}} <div class=\"newsfeed__item__system-message\"> {{>icon 'learn-cup'}} <div class=\"newsfeed__item__bold\">Gratulálunk nyertetek egy csoport kupát,</div> <p> amiért minden feladatot megoldottatok, a(z) <a href=\"/hu/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a> nevű leckében, </p> <p style=\"margin: 30px 0 0; opacity: .5\"> <a href=\"/hu/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a>, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. </p> </div> {{#elseif this.data.type == 'lecture-history' && this.data.question && this.user}} <div class=\"newsfeed__item__details\"> <p class=\"newsfeed__item__text--global\"> {{#if this.data.details.success}} <span style=\"top: -2px; position: relative; color: #38d090\">{{>icon 'symbol-pipe'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> helyesen megoldotta, a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> lecke <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> nevű feladatát <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>. {{#elseif this.data.details.events.length === 0}} <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-eye'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> megtekintette a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> lecke <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> nevű feladatát <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>. {{#else}} <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-x'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> nem tudta megoldani a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> lecke <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> nevű feladatát <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>. {{/if}} </p> <p class=\"newsfeed__item__text--personal\"> {{#if this.data.details.success}} <span style=\"top: -2px; position: relative; color: #38d090\">{{>icon 'symbol-pipe'}} </span> Helyesen megoldottad a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> lecke <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> nevű feladatát <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>. {{#elseif this.data.details.length === 0}} <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-eye'}} </span> Megtekintetted a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> lecke <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> nevű feladatát <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>. {{#else}} <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-x'}} </span> Nem tudtad megoldani a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> lecke <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> nevű feladatát <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>. {{/if}} </p> <br> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.problem.clone}}\"><div data-f-content></div></div> <div data-nf-input-details></div> </div> {{#elseif this.data.type !== 'user-like' && (this.user || true)}} <div class=\"newsfeed__item__details\"> {{#if this.data.type === 'group-message'}} {{#if this.data.reply || this.data.replyTo }} <span>{{>icon 'symbol-redo'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> válasza <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. {{#else}} <span>{{>icon 'symbol-speach-bubble'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> üzenete <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. {{/if}} <div class=\"newsfeed__item__message\">{{#postReplacer this.data.message /}}</div> {{#elseif this.data.type === 'group-topic' && this.data.topic}} <span>{{>icon 'menu-academy'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> megosztott egy leckét <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. <a href=\"/hu/learn/topic/{{this.data.topic.id}}\" class=\"newsfeed__item__message\" style=\"display: block\">{{this.data.topic.title}}</a> {{#if this.data.message}} <p style=\"margin-top: 10px;\">{{this.data.message}}</p> {{/if}} {{#elseif this.data.type === 'earn-star' && this.data.question}} <span style=\"color:#ff9f28; top: -2px; position: relative;\">{{>icon 'star'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> szerzett {{this.data.quantity || 'egy'}} csillagot <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. {{#elseif this.data.type === 'earn-medal' && this.data.question}} <span style=\"color:#ff9f28; top: -1px; position: relative;\">{{>icon 'learn-medal'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> szerzett {{this.data.quantity || 'egy'}} medált <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. {{#elseif this.data.type === 'loose-star' && this.data.question}} <span style=\"top: -2px; position: relative;\">{{>icon 'star'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> elvesztett {{this.data.quantity || 'egy'}} csillagot <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. {{#elseif this.data.type === 'ok-answer' && this.data.question}} <span style=\"top: -2px; position: relative\">{{>icon 'symbol-pipe'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> helyes köztes eredményt adott meg <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. <br><br> <p>A kérdés:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div> <p>A bevitt eredmény:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div> {{#elseif this.data.type === 'perfect-answer' && this.data.question}} <span style=\"top: -2px; position: relative; color: #38d090\">{{>icon 'symbol-pipe'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> helyes eredményt adott meg <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. <br><br> <p>A kérdés:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div> <p>A bevitt eredmény:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div> {{#elseif this.data.type === 'ok-go-on-answer' && this.data.question}} <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-pipe'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> megadott egy helyes köztes eredményt <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. <br><br> <p>A kérdés:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div> <p>A bevitt eredmény:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div> {{#elseif this.data.type === 'ok-but-was-answer' && this.data.question}} <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-pipe'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> megadott egy már sikerrel bevitt helyes eredményt <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. <br><br> <p>A kérdés:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div> <p>A bevitt eredmény:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div> {{#elseif this.data.type === 'view-answer' && this.data.question}} <span style=\"top: -2px; position: relative;\">{{>icon 'symbol-eye'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> megtekintette a levezetését <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a>-nak. {{#if this.data.details}} <br><br><div style=\"font-size: 23px\" data-f=\"{{this.data.details.formula}}\"><div data-f-content></div></div> {{/if}} {{#elseif this.data.type === 'fail-answer' && this.data.question}} <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-x'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> helytelen eredményt adott meg <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>, a(z) <a href=\"/hu/learn/topic/{{this.data.topicId}}\">{{(this.data.topic || {}).title}}</a> leckében a(z) <a href=\"/hu/learn/question/{{this.data.question.id}}\">{{this.data.question.title}}</a> gyakorlása közben. <br><br> <p>A kérdés:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.question}}\"><div data-f-content></div></div> <p>A bevitt eredmény:</p> <div style=\"font-size: 23px\" data-f=\"{{this.data.details.answer}}\"><div data-f-content></div></div> {{#elseif this.category === 'problem-history'}} <span style=\"top: -2px; position: relative;\">{{>icon 'menu-new-problem'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Névtelen felhasználó'}}</a> megtekintette a következő példa levezetését <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>: <br><br><div style=\"font-size: 23px\" data-f=\"{{this.data.details.formula}}\"><div data-f-content></div></div> {{#elseif this.category === 'error'}} <span style=\"top: -2px; position: relative; color: #e06476\">{{>icon 'symbol-lab'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Nem regisztrált felhasználó'}}</a> <strong style=\"font-weight: bold\">{{this.data.type}}</strong> típusú hibába botlott <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a>: {{#if this.data.details.error && this.data.details.error.final_message}} <p style=\"margin-top: 15px\">{{#compute this.data.details.error.final_message /}}</p> {{/if}} <pre style=\"white-space: pre-line; margin-top: 15px; word-break: break-all;\">                      {{JSON.stringify(this.data.details.error)}}                  </pre> {{#elseif this.category === 'exam'}} {{#if this.data.type === 'exam-finished'}} <span style=\"top: -2px; position: relative;\">{{>icon 'menu-exam'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Nem regisztrált felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> megírt egy <strong style=\"font-weight: bold\">{{this.data.details.percentage}}</strong>%-os dolgozatot a <a style=\"font-weight: bold\" href=\"/hu/learn/topic/{{this.data.topic.id}}\">{{this.data.topic.title}}</a> leckében <strong style=\"font-weight: bold\">{{Math.round(this.data.details.length / 1000 / 60)}}</strong> perc alatt. {{#elseif this.data.type === 'exam-started'}} <span style=\"top: -2px; position: relative;\">{{>icon 'menu-exam'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Nem regisztrált felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> elindított egy dolgozatot a(z) <a href=\"/hu/learn/topic/{{this.data.topic.id}}\" style=\"font-weight: bold\">{{this.data.topic.title}}</a> nevű leckéből, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. {{#elseif this.data.type === 'exam-collected' && this.data.group}} <span style=\"top: -2px; position: relative;\">{{>icon 'menu-exam'}} </span> <a href=\"/hu/user/{{this.userId}}\">{{this.user ? this.user.name : 'Nem regisztrált felhasználó'}}</a> <a href=\"/hu/story/{{this._id}}\" data-ago-moment=\"{{this.date}}\" style=\"white-space:nowrap;\"></a> beszedte a(z) <strong style=\"font-weight: bold\">{{this.data.topic.title}}</strong> nevű leckéből írt dolgozatokat, a(z) <a href=\"/hu/group/{{this.data.groupId}}\">{{this.data.group.name}}</a> nevű tanulócsoportban. {{/if}} {{#else}} <div class=\"newsfeed__item__details\" style=\"margin: 0; opacity: .5;\">Ez a bejegyzés nem elérhető...</div> <pre class=\"debug-info\" style=\"overflow:auto;\">{{JSON.stringify(this, undefined, 2)}}</pre> {{/if}} <div data-nf-input-details></div> </div> {{#elseif this.data.type !== 'user-like'}} <div class=\"newsfeed__item__details\" style=\"margin: 0; opacity: .5;\">Ez a bejegyzés nem elérhető...</div> <pre class=\"debug-info\" style=\"overflow:auto;\">{{JSON.stringify(this, undefined, 2)}}</pre> {{/if}} {{#if this.data && this.data.details && this.data.details.responseTime}} <span style=\"font-weight: bold\" class=\"debug-info\"> Válaszidő: {{this.data.details.responseTime / 1000}} másodperc <br><br> </span> {{/if}} <div data-nf-card-actions> {{>newsFeedCardActions this}} </div> {{/if}} </div> </div>","newsfeed-input-details":"<div class=\"newsfeed__item__actions newsfeed__item__details-panel\" style=\"margin-top: 15px\"> <span class=\"newsfeed__item__details-panel__close\" data-group-hide-details title='Bezárás'>{{>icon 'arrow-small-down'}}</span> <div style=\"font-weight: bold; color: #313744; padding-bottom: 15px\">{{#compute this.details.problem.instruction /}}</div> {{#if this.details.events.length > 0}} {{#each this.details.events}} <div style=\"width: 100%; border-top: 2px solid #d6dbde; padding-top: 15px;\"> {{#if this.formula}} <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\"> {{#compute this.formula /}} </div> {{#else}} {{#if this.type === 'text'}} <span style=\"float: right;\" title='Kommentár'>{{>icon 'symbol-speach-bubble'}}</span> <p style=\"margin-bottom: 15px\">{{this.content}}</p> {{#elseif this.type === 'formula'}} <span style=\"float: right;\" title='Kommentár'>{{>icon 'symbol-speach-bubble'}}</span> <div data-formula style=\"{{#if this.type === 'perfect'}}font-weight:bold;{{/if}}font-size: 22px; margin-bottom: 15px; color: #313744;\"> {{#compute this.content /}} </div> {{#elseif this.type === 'comment-doodle'}} <span style=\"float: right;\" title='Kommentár'>{{>icon 'symbol-speach-bubble'}}</span> <p class=\"formula-flack\"> <img data-doodle-id=\"{{this.content}}\" class=\"doodle-image\" src=\"/doodle/{{this.content}}.svg\" /> </p> {{#elseif this.type === 'prime-table'}} <span style=\"float: right;\" title='Prímfelbontó számolótábla'>{{>icon 'symbol-prim-table'}}</span> <div class=\"prime-table\"> <div class=\"prime-table__left\"> {{#each this.content}} <div class=\"prime-table__cell\">{{this[0] > 0 ? this[0] : '&nbsp;'}}</div> {{/each}} </div> <div class=\"prime-table__right\"> {{#each this.content}} <div class=\"prime-table__cell\">{{this[1] > 0 ? this[1] : '&nbsp;'}}</div> {{/each}} </div> </div> {{/if}} {{/if}} {{#if this.type === 'fail'}} <span style=\"float: right; color: #e06476\" title='Nem jó az érték'>{{>icon 'symbol-x'}}</span> {{#elseif this.type === 'ok'}} <span style=\"float: right\" title='A formulának jó az értéke, de még nem a végeredmény'>{{>icon 'symbol-pipe'}}</span> {{#elseif this.type === 'perfect'}} <span style=\"float: right; color: #38d090\" title='Helyes végeredmény'>{{>icon 'symbol-pipe'}}</span> {{/if}} </div> {{/each}} <p> {{#if Math.floor((new Date(this.details.events[this.details.events.length - 1].date) - new Date(this.details.date)) / 60000) > 0}} {{#if Math.round((new Date(this.details.events[this.details.events.length - 1].date) - new Date(this.details.date)) % 60000 / 1000) > 0}} {{Math.floor((new Date(nth(this.details.events,this.details.events.length - 1).date) - new Date(this.details.date)) / 60000)}} perc {{Math.round((new Date(nth(this.details.events, this.details.events.length - 1).date) - new Date(this.details.date)) % 60000 / 1000)}} másodperc alatt. {{#else}} {{Math.floor((new Date(nth(this.details.events,this.details.events.length - 1).date) - new Date(this.details.date)) / 60000)}} perc alatt. {{/if}} {{#else}} {{Math.round((new Date(nth(this.details.events, this.details.events.length - 1).date) - new Date(this.details.date)) % 60000 / 1000)}} másodperc alatt. {{/if}} </p> {{#else}} Nem történt megoldás bevitele ezen a feladaton. {{/if}} </div>","newsfeed":"{{#if this.items.length > 0}} {{#each this.items}} {{>newsFeedCard this}} {{/each}} {{#if this.remaining === true}} <div data-newsfeed-content> <a class=\"button button--full button--gray\" data-newsfeed-load-more=\"{{this.lastDate}}\"> további történetek betöltése </a> </div> {{#elseif this.remaining > 0}} <div data-newsfeed-content> <a class=\"button button--full button--gray\" data-newsfeed-load-more=\"{{this.lastDate}}\"> további {{this.remaining}} történet betöltése </a> </div> {{/if}} {{#else}} <div class=\"newsfeed__item newsfeed__item--no-result\" data-hide-when-loaded> <span class=\"newsfeed__item__message\">Itt nem történt még semmi.</span> <small>Vagy nincs jogosultságod a megtekintésére.</small> </div> {{/if}}","notification-overlay":"<p>{{this.text}}</p> {{#if this.msg}}<p>{{this.msg}}</p>{{/if}} <div class=\"text-center\"> <a class=\"button button--secondary\" data-close-overlay>Bezárás</a> {{#if this.cta}} <a href=\"{{this.link}}\" class=\"button\">{{this.cta}}</a> {{/if}} </div>","notification":"{{#if this.length > 0}} {{#each this}} <div data-notification-href=\"{{this.link}}\" data-notification-id=\"{{this.id}}\" class=\"notification__item notification__item--{{this.key}}{{#if this.pro}} notification__item--pro{{/if}}{{#if this.seen}} notification__item--seen{{/if}}\"> <div class=\"notification__item__text\"> {{#if this.key === 'someone-liked-my-story'}} <span class=\"notification__item__icon\" style=\"color:#e06476\">{{>icon 'symbol-heart-full'}}</span> {{#elseif this.key === 'someone-replied-my-story' || this.key === 'new-message-in-a-group'}} <span class=\"notification__item__icon\">{{>icon 'symbol-speach-bubble'}}</span> {{#elseif ['group-connect-request','connect-to-group','you-connect-to-group','accept-connection-request','denied-connection-request'].indexOf(this.key) > -1}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-group'}}</span> {{#elseif ['pro-activated','pro-success-payment','dpro-success-payment','pro-de-activated','pro-subscription-joined'].indexOf(this.key) > -1}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-premium'}}</span> {{#elseif this.key === 'new-group-challenge'}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'symbol-paperplane'}}</span> {{#elseif this.key === 'new-group-topic'}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-academy'}}</span> {{#elseif this.key === 'win-group-cup'}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'learn-cup'}}</span> {{#elseif this.key === 'resolved-group-challenge'}} <span class=\"notification__item__icon\" style=\"color: #38d090;position: relative;top: -1px;\">{{>icon 'symbol-pipe'}}</span> {{#elseif this.key === 'group-exam-start' || this.key === 'group-exam-finished'}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'menu-exam'}}</span> {{#elseif this.key === 'bug-ticket-closed'}} <span class=\"notification__item__icon\" style=\"position: relative;top: -1px;\">{{>icon 'symbol-bug'}}</span> {{/if}} {{this.text}} </div> <span class=\"notification__item__msg\">{{#if this.msg}}{{this.msg}}{{/if}}</span> <span class=\"notification__item__time\" data-ago-moment=\"{{this.date}}\"></span> {{#if this.cta}} <span class=\"notification__item__cta\">{{this.cta}}</a> {{/if}} <div class=\"notification__item__seen\" data-notification-seen-toggle> <span class=\"notification__item__seen__decor\"></span> </div> </div> {{/each}} <div class=\"notification__inner-text\"> <span>{{>icon \"menu-notification\"}}</span> </div> {{/if}}","onboard":"<div class=\"onboard hide\" data-onboard> <div class=\"onboard__message\" data-onboard-content> <div class=\"onboard__message__text\" data-onboard-text></div> </div> <div class=\"onboard__blocker\" data-onboard-blocker></div> <div class=\"onboard__pointer\" data-onboard-pointer> <span class=\"onboard__pointer__decor\"></span> </div> <svg data-onboard-line class=\"onboard__line\" x=\"0px\" y=\"0px\" xml:space=\"preserve\"> <path data-onboard-line-path class=\"onboard__line__path\" /> </svg> </div> <div class=\"overlay\" data-overlay=\"failed-input\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\"> <i class=\"icon-wrapper\"> <svg viewBox=\"0 0 256 256\"> <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-symbol-x\"></use> </svg> </i> </span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> Ez nem a mintapélda. Próbálkozz tovább, vagy nézd meg a bemutató videót:<br><br> <div style=\"position: relative; padding-bottom: 56.2%\"> <iframe style=\"width:100%; height:100%; position:absolute; left:0;\" src=\"https://www.youtube.com/embed/_YWxEpk8y1A?rel=0\" frameborder=\"0\" allowfullscreen></iframe> </div> <br> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Bezárom</button> </div> </div> </div> </div>","overlays":"<div class=\"overlay\" data-overlay=\"alert\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> <p style=\"white-space: pre-line\" data-alert-content></p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Ok</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"users-list\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> <div data-users-list></div> <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\"> <button class=\"button button--secondary\" data-refresh-user-list>Lista frissítése</button> <button class=\"button\" data-close-overlay>Rendben</button> <br><br> <button class=\"button button--gray\" data-open-overlay=\"group-registration\">Új név felvétele</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"group-registration\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <form class=\"overlay--content content-wrapper center-box\" method=\"post\" action=\"/hu/service/group/sign-up\" data-callback=\"APP.Group.successGroupRegistration\"> <p>Ha több nevet szeretnél regisztrálni, írd a neveket külön sorba.</p> <textarea name=\"names\" placeholder=\"Írd be a regisztrálni kívánt nevet.\"></textarea> <span data-form-error=\"names\"></span> <input type=\"hidden\" name=\"groupId\" /> <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\"> <button class=\"button\">Regisztráció</button> <a class=\"button button--secondary\" data-close-last-overlay>Mégsem</a> </div> </form> </div> </div> <div class=\"overlay\" data-overlay=\"edit-user-name\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <form class=\"overlay--content content-wrapper center-box\" method=\"post\" action=\"/hu/service/group/user-edit\" data-callback=\"APP.Group.successMemberNameEdit\"> <p>Felhasználónév szerkesztése</p> <input type=\"hidden\" name=\"method\" value=\"edit-user-name\" /> <input type=\"text\" name=\"name\" placeholder=\"Felhasználónév\" /> <span data-form-error=\"name\"></span> <input type=\"hidden\" name=\"userId\" /> <input type=\"hidden\" name=\"groupId\" /> <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\"> <button class=\"button\">Mentés</button> <a class=\"button button--secondary\" data-close-last-overlay>Mégsem</a> </div> </form> </div> </div> <div class=\"overlay\" data-overlay=\"edit-user-email\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <form class=\"overlay--content content-wrapper center-box\" method=\"post\" action=\"/hu/service/group/user-edit\" data-callback=\"APP.Group.successAction\"> <p>Email cím szerkesztése</p> <input type=\"hidden\" name=\"method\" value=\"edit-user-email\" /> <input type=\"text\" name=\"email\" placeholder=\"Email cím\" /> <span data-form-error=\"email\"></span> <input type=\"hidden\" name=\"userId\" /> <input type=\"hidden\" name=\"groupId\" /> <div class=\"text-center\" style=\"border-top: 1px solid #b9bec1; padding-top: 15px;\"> <button class=\"button\">Mentés</button> <a class=\"button button--secondary\" data-close-last-overlay>Mégsem</a> </div> </form> </div> </div> <div class=\"overlay\" data-overlay=\"success-action\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> <p>A művelet sikerrel lezárult!</p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Ok</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"fail-action\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> <p>A művelet során valami hiba lépett fel. Elnézésed kérjük! Orvosoljuk a problémát, amint lehetőségünk lesz rá.</p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Ok</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"pro-activated\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content overlay--content--pro content-wrapper center-box\"> <h1>Akriel előfizetésed aktiválásra került!</h1> <p>Mostantól korlátlanul élvezheted az Akriel adta lehetőségeket.<br>Jó Akrielezést kívánunk!</p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Rendben</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"pro-deactivated\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> <h1>Akriel előfizetésed megszűnt.</h1> <p>Ha szeretnél újra előfizetni az Akrielre, akkor azt az \"Előfizetés\" menüpont alatt megteheted.</p> <div class=\"text-center\"> <a class=\"button\" href=\"/hu/pro\">Előfizetés</a> <button class=\"button button--secondary\" data-close-overlay>Mégsem</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"user-account-logged-in\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\" style=\"max-width: 400px\"> <h1 class=\"text-center\">Bejelentkeztél</h1> <p>Úgy tűnik menet közben bejelentkeztél az Akrielbe.</p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Rendben</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"user-account-logged-in-other-user\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\" style=\"max-width: 400px\"> <h1 class=\"text-center\">Fiók figyelmeztetés</h1> <p>Úgy tűnik menet közben egy másik felhasználói fiókkal bejelentkeztél az Akrielbe.</p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Rendben</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"user-account-logged-out\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\" style=\"max-width: 400px\"> <h1 class=\"text-center\">Kijelentkeztél</h1> <p>Úgy tűnik, túl sokáig voltál tétlen, vagy már egy másik ablakban kijelentkeztél az Akrielből.</p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay>Rendben</button> </div> </div> </div> </div> <div class=\"overlay\" data-overlay=\"youtube-video-overlay\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\" data-youtube-video-wrapper> </div> </div> <div class=\"overlay\" data-overlay=\"live-access\"> <div class=\"overlay--background\" data-close-overlay> <span class=\"overlay--close-icon\">{{>icon \"symbol-x\"}}</span> </div> <div class=\"overlay--content-wrapper\"> <div class=\"overlay--content content-wrapper center-box\"> <p> <span data-access-name></span> szeretne jogosultságot kapni arra, hogy együtt dolgozzon veled a felületeden, ebben az ablakban. </p> <div class=\"text-center\"> <button class=\"button\" data-close-overlay data-allow-live>Ok</button> <button class=\"button button--secondary\" data-close-overlay>Mégsem</button> </div> </div> </div> </div>","placeholder":"<div data-row-placeholder=\"{{this.id}}\" class=\"problem-row-placeholder\"> <div data-row-placeholder-content class=\"problem-row-placeholder__content\"></div> </div>","prime-table":"<div class=\"prime-table\"> <div class=\"prime-table__left\"> {{#each this}} <div class=\"prime-table__cell\">{{this[0] || '&nbsp;'}}</div> {{/each}} </div> <div class=\"prime-table__right\"> {{#each this}} <div class=\"prime-table__cell\">{{this[1] || '&nbsp;'}}</div> {{/each}} </div> </div>","problem/academy":"<div class=\"problem--toggler-button--wrapper\"> <span class=\"button button--small button--iconed problem--toggler-button button--purple\"> <i class=\"button__icon\"> {{>icon \"akriel-symbol-p1\"}} </i> <i class=\"button__icon\"> {{>icon \"akriel-symbol-p2\"}} </i> <span>Több info</span> </span> <span class=\"problem--row__close\"> {{>icon \"symbol-x\"}} </span> </div> <div data-href=\"/hu/academy/{{this.pictogram.id}}\" data-academy-overlay-trigger class=\"problem--child\" data-problem-gate data-problem-child data-problem-accordion data-traceid=\"{{this.traceid}}\"> <div class=\"problem--border\" data-academy-content=\"{{this.pictogram.id}}/{{this.pictogram.index}}\" style=\"border-color:transparent;padding-bottom:0;\"> </div> </div>","problem/child":"{{#if this.child}} {{#if !this.multiple_show}} <div class=\"problem--child\" {{#if this.link && this.link.method}} data-open-overlay=\"soon-{{this.link.method.type}}\" data-prevent{{/if}}> <span class=\"problem--title problem--title--primary\"> {{#if this.message && this.message.method}} <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\"> {{#compute this.message.method /}} </span> {{/if}} </span> {{#if this.extended_pictogram}} <div class=\"problem--title problem--title--secondary\"> <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\"> {{#compute this.extended_pictogram.message/}} </span> </div> {{/if}} </div> {{/if}} <div class=\"problem--toggler-button--wrapper\" {{#if this.fullymarked}}data-not-shown{{/if}}> <span class=\"button button--small button--iconed problem--toggler-button\" {{#if this.extended_pictogram}}data-open-primary-child{{/if}}> <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i> <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i> <span>Több info</span> </span> {{#if this.extended_pictogram && this.extended_pictogram.pictogram}} <span class=\"button button--small button--iconed button--purple problem--toggler-button\" data-open-secondary-child data-href=\"/hu/academy/{{this.extended_pictogram.pictogram.id}}\" data-academy-index=\"{{this.extended_pictogram.pictogram.index}}\" data-academy-trigger='[data-academy-content=\"{{this.extended_pictogram.pictogram.id}}/{{this.extended_pictogram.pictogram.index}}\"]'> <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i> <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i> <span>Több info</span> </span> {{/if}} </div> <div class=\"problem--child{{#if this.child && this.child.length === 1}} problem--child--single{{/if}}{{#if this.extended_pictogram}} problem--primary-child{{/if}}\" data-problem-gate data-problem-child data-problem-accordion> {{#each this.child}}{{>problemRow this}}{{/each}} </div> {{/if}}","problem/index":"{{>tree this}}","problem/row":"<div {{#if this.link && this.link.pictogram && this.link.pictogram.embed}} data-href=\"/hu/academy/{{this.link.pictogram.id}}\" data-academy-index=\"{{this.link.pictogram.index}}\" data-academy-trigger='[data-academy-content=\"{{this.link.pictogram.id}}/{{this.link.pictogram.index}}\"]' data-enable-href {{/if}} class=\"problem--row{{#if !this.child && !this.link}} problem--row-no-child{{/if}} problem--row-hide {{#if this.singlewhenclosed}} problem--hide-mark{{/if}} {{#if this.multiple_show}} problem--multiple-main-row{{/if}} {{#if this.show_mark_immediately}} problem--row--show-mark-immediately{{/if}}\" {{#if this.fullymarked}}data-row-fullymarked=\"true\"{{/if}} data-problem-action-type=\"{{this.actioncolor}}\" data-traceid=\"{{this.traceid}}\" data-problem-row data-row-index=\"{{this.index}}\" {{#if this.mainRow}}data-problem-main-row=\"0\"{{/if}} > <div class=\"problem--border problem--border-color-{{this.actioncolor}}\"> {{#if !(this.mainRow && (this.fullymarked || this.multiple_show))}} <span class=\"problem--row__close\"> {{>icon \"symbol-x\"}} </span> {{/if}} {{#if this.message && this.message.action}} <div class=\"problem--title{{#if this.headerindex && this.headerindex.action}} problem--title__indexed{{/if}} {{#if this.singlewhenclosed}} problem--title__hide{{/if}}\" {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}> <span class=\"problem--method-name\"> <span> {{#if this.headerindex && this.headerindex.action}} <span class=\"problem--index problem--index--active\">{{this.headerindex.action}}</span> {{/if}} {{#compute this.message.action /}} </span> </span> </div> {{/if}} {{#if !this.multiple_show && this.message}} <div class=\"problem--title{{#if this.headerindex && this.headerindex.row}} problem--title__indexed{{/if}} {{#if this.singlewhenclosed}} problem--title__hide{{/if}}\" {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}> {{#if this.knowledgebase}} <span class=\"problem--academy-indicator\"> {{>icon \"symbol-study\"}} </span> {{/if}} {{#if this.link && this.link.row && this.link.row.type === \"problem\"}} <span class=\"problem--formula-wrapper\" data-blank-href=\"/hu/problem/direct/{{#base64 this.link.row.value.formula/}}/?cmd={{this.link.row.value.cmd.replace(/#/g, '')}}&source=message\"> <span style=\"position:relative\"> {{#if this.headerindex && this.headerindex.row}} <span class=\"problem--index problem--index--active\" style=\"left:-20px\">{{this.headerindex.row}}</span> {{/if}} {{#if this.message}} {{#compute this.message.row /}} {{/if}} </span> {{#if this.message && this.message.trace}} <span class=\"debug-info\">[{{this.message.trace}}]</span> {{/if}} </span> {{#else}} <span class=\"problem--formula-wrapper\" {{#if this.link && this.link.row}} data-blank-href=\"{{JSON.stringify(this.link)}}\" data-prevent {{/if}}> <span style=\"position:relative\"> {{#if this.headerindex && this.headerindex.row}} <span class=\"problem--index problem--index--active\" style=\"left:-20px\">{{this.headerindex.row}}</span> {{/if}} {{#if this.message && this.message.row}} {{#compute this.message.row /}} {{/if}} </span> {{#if this.message && this.message.trace}} <span class=\"debug-info\">[{{this.message.trace}}]</span> {{/if}} </span> {{/if}} </div> {{/if}} <div class=\"problem--wrapper{{#if this.multiple_show}} problem--formula-multiple-main-row__wrapper{{/if}}\"> {{#if this.formula}} <div class=\"problem--details\"> <div class=\"problem--formula problem--formula-wrapper\" {{#if this.formula && this.formula.direction === \"vertical\"}}data-problem-vertical{{/if}}> <div class=\"problem--formula-left\" data-formula> <div class=\"formula\" data-formula>{{#compute this.formula.from /}}</div> {{#if this.formula && this.formula.direction !== \"vertical\"}} <div class=\"{{#if this.exception || (!this.multiple_show && this.formula && this.formula.to) && this.fullymarked}} problem--formula-hide-on-open{{/if}} {{#if this.singlewhenclosed}} problem--formula-hide-on-close{{/if}} problem--formula-arrow{{#if !(this.formula && this.formula.action)}} problem--formula-arrow-no-action{{/if}}\" data-formula> {{>icon \"arrow-right\"}} </div> {{/if}} {{#if this.formula.action}} <div class=\"problem--formula-action\" data-formula {{#if this.link && this.link.action}} data-blank-href=\"{{JSON.stringify(this.link)}}\" data-prevent {{/if}}> <div class=\"formula\" data-fit-box> <span data-formula=\"literal\" class=\"problem--formula-action__per\">/</span> {{#compute this.formula.action /}} </div> </div> {{/if}} </div> {{#if this.exception}} <div class=\"problem--formula-right{{#if this.fullymarked}} problem--formula-hide-on-open{{/if}}{{#if this.singlewhenclosed}} problem--formula-hide-on-close{{/if}}\" data-formula> <div class=\"problem--formula-arrow{{#if !(this.formula && this.formula.action)}} problem--formula-arrow-no-action{{/if}}\" data-formula> {{>icon \"arrow-right\"}} </div> <div class=\"formula\" data-formula>{{#compute this.exception /}}</div> </div> {{#elseif !this.multiple_show && this.formula && this.formula.to}} <div class=\"problem--formula-right {{#if this.fullymarked}} problem--formula-hide-on-open{{/if}}{{#if this.singlewhenclosed}} problem--formula-hide-on-close{{/if}}\" data-formula> <div class=\"problem--formula-arrow{{#if !this.formula.action}} problem--formula-arrow-no-action{{/if}}\" data-formula> {{>icon \"arrow-right\"}} </div> <div class=\"formula\" data-formula>{{#compute this.formula.to /}}</div> </div> {{/if}} {{#if this.mainRow}} <span class=\"problem--row-arrow-flag\"> <i class=\"icon-wrapper\">{{>icon \"arrow-small-down\"}}</i> </span><span class=\"problem--row-arrow-flag problem--row-arrow-flag--close\" data-main-row-close> <i class=\"icon-wrapper\">{{>icon \"arrow-small-down\"}}</i> </span> {{/if}} </div> {{/if}} {{#if this.primefactory}} <div class=\"prime-table\"> <div class=\"prime-table__left\"> {{#each this.primefactory}} <div class=\"prime-table__cell\">{{this.left || '&nbsp;'}}</div> {{/each}} </div> <div class=\"prime-table__right\"> {{#each this.primefactory}} <div class=\"prime-table__cell\">{{this.right || '&nbsp;'}}</div> {{/each}} </div> </div> {{/if}} {{#if this.animation}} <div data-operation='{{JSON.stringify(this.animation)}}'></div> {{/if}} </div> {{#if this.child}} {{#if !this.multiple_show}} <div class=\"problem--child\" {{#if this.link && this.link.method}} data-blank-href='{{#getLink this.link.method.value /}}' data-prevent {{/if}}> <span class=\"problem--title problem--title--primary\" {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}> {{#if this.message && this.message.method}} <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\"> {{#compute this.message.method /}} </span> {{/if}} </span> {{#if this.extended_pictogram}} <div class=\"problem--title problem--title--secondary\" {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}> <span class=\"problem--formula-wrapper\" style=\"padding-bottom: 0; margin-top: 20px\"> {{#compute this.extended_pictogram.message/}} </span> </div> {{/if}} </div> {{/if}} {{#if !(this.mainRow && this.multiple_show) && !this.singlewhenclosed}} <div class=\"problem--toggler-button--wrapper\" {{#if this.fullymarked}}data-not-shown{{/if}}> <span class=\"button button--small button--iconed problem--toggler-button\" {{#if this.extended_pictogram}}data-open-primary-child{{/if}}> <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i> <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i> <span>Több info</span> </span> {{#if this.extended_pictogram && this.extended_pictogram.pictogram}} <span class=\"button button--small button--iconed button--purple problem--toggler-button\" data-open-secondary-child data-href=\"/hu/academy/{{this.extended_pictogram.pictogram.id}}\" data-academy-index=\"{{this.extended_pictogram.pictogram.index}}\" data-academy-trigger='[data-academy-content=\"{{this.extended_pictogram.pictogram.id}}/{{this.extended_pictogram.pictogram.index}}\"]'> <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i> <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i> <span>Több info</span> </span> {{/if}} </div> {{/if}} <div class=\"problem--child{{#if this.child && this.child.length === 1}} problem--child--single{{/if}}{{#if this.extended_pictogram}} problem--primary-child{{/if}} problem--child-no-gutter problem--child-hide\" data-problem-gate data-problem-child data-problem-accordion> {{#each this.child}}{{#problemRow [this, {}] /}}{{/each}} </div> {{/if}} {{#if this.extended_pictogram}} <div class=\"problem--child problem--secondary-child\" data-problem-gate data-secondary-child data-problem-accordion> {{>problemAcademy this.extended_pictogram}} </div> {{/if}} {{#if this.link && this.link.pictogram}} {{#if !this.multiple_show}} <div class=\"problem--child\" {{#if this.link.method}} data-open-overlay=\"soon-{{this.link.row.type}}\" data-prevent{{/if}}> <span class=\"problem--title\" style=\"margin-bottom: -20px;display: block; {{#if this.link.pictogram && this.link.pictogram.embed}}margin-top:8px;{{/if}}\" {{#if this.mainRow}}data-problem-mainrow-accordion{{/if}}> {{#if this.message.method}} <span class=\"problem--formula-wrapper\"> {{#compute this.message.method /}} </span> {{/if}} </span> </div> {{/if}} {{#if this.link.pictogram.embed}} {{>problemAcademy this.link}} {{#elseif !(this.mainRow && this.multiple_show) || !this.singlewhenclosed}} <div class=\"problem--toggler-button--wrapper\" data-href=\"/hu/academy/{{this.link.pictogram.id}}\" data-academy-overlay-trigger> <span class=\"button button--small button--purple button--iconed problem--toggler-button\"> <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i> <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i> <span>Több info</span> </span> {{#if !(this.mainRow && (this.fullymarked || this.multiple_show))}} <span class=\"problem--row__close\"> {{>icon \"symbol-x\"}} </span> {{/if}} </div> {{/if}} {{/if}} {{#if this.link && this.link.sf && !(this.mainRow && this.multiple_show)}} <div class=\"problem--toggler-button--wrapper\"> <span class=\"button button--small button--iconed problem--toggler-button\" data-open-overlay=\"soon-SF\"> <i class=\"button__icon\">{{>icon \"akriel-symbol-p1\"}}</i> <i class=\"button__icon\">{{>icon \"akriel-symbol-p2\"}}</i> <span>Több info</span> </span> </div> {{/if}} </div> </div> </div>","problem/tree":"{{#if this.tree}} {{#each this.tree}} {{#if this.header}} <div class=\"problem--text\">{{#compute this.header /}}</div> {{/if}} <div class=\"problem__leaf\" data-formulas-root data-main-problem-section> {{#each this.result}}{{#problemRow [this, {mainRow:true}] /}}{{/each}} {{#if this.tree}}{{>tree this}}{{/if}} </div> {{/each}} {{#else}} {{#each this.group}} {{#if this.title}} {{#if this.command}} <div class=\"problem--text\" data-blank-href=\"{{#getLink this.command /}}\">{{#compute this.title /}}</div> {{#else}} <div class=\"problem--text\">{{#compute this.title /}}</div> {{/if}} {{/if}} {{#if this.showbrakets}} <div class=\"problem--brakets\"> <div class=\"problem--braket-top\"></div> <div class=\"problem--braket-bottom\"></div> {{#each this.child}} <div class=\"problem--row problem--group-row\"> <span class=\"problem--prefix\">{{#if this.prefix}}{{#compute this.prefix/}}{{/if}}</span> <div class=\"problem--prefixed-formula\">{{#compute this.formula/}}</div> </div> {{/each}} </div> {{#else}} {{#each this.tree}} {{#if this.prefix && this.prefix.indexOf(\"\\'I.\\'\") === -1 && this.prefix.indexOf(\"\\'II.\\'\") === -1}} <strong class=\"problem--text problem--prefix\" style=\"padding: .2rem; margin: 1em 3em 1.5em\">{{#compute this.prefix /}}</strong> {{/if}} {{#if this.header}} <strong class=\"problem--text\">{{#compute this.header /}}</strong> {{/if}} <div class=\"problem__leaf\" data-formulas-root data-main-problem-section> {{#each this.result}}{{#problemRow [this, {mainRow:true}] /}}{{/each}} {{#if this.tree}}{{>tree this}}{{/if}} </div> {{/each}} {{/if}} {{/each}} {{/if}} <div data-cosmetic-formulas> {{#if this.extension}} <div class=\"problem--text\" data-blank-href=\"{{#getLink this.extension.command /}}\"> <span>{{#compute this.extension.message /}}</span> </div> {{/if}} {{#if this.final_message}} <div class=\"problem--text\"> <span>{{#compute this.final_message /}}</span> </div> {{/if}} {{#if this.solutions}} {{#if this.solutions.dropdoubles}} <div class=\"problem--text\"> <span>{{#compute this.solutions.dropdoubles /}}</span> </div> {{/if}} {{#if this.solutions.fakes}} <strong class=\"problem--text\">{{#compute this.solutions.fakes.message /}}</strong> {{#each this.solutions.fakes.checks}} <span class=\"standalone-formula\">{{#compute this.solution /}}</span> {{#if this.message}} <div {{#if this.formula}} data-blank-href=\"/hu/problem/direct/{{#base64 this.formula /}}/?source=solution-fake&cmd={{this.cmd}}\"{{/if}} class=\"problem--text\" > <span>{{#compute this.message /}}</span> </div> {{/if}} {{/each}} {{/if}} {{#if this.solutions.valids}} <strong class=\"problem--text\">{{#compute this.solutions.valids.message /}}</strong> {{#each this.solutions.valids.checks}} {{#if this.solution}} <span class=\"standalone-formula\">{{#compute this.solution /}}</span> {{/if}} {{#if this.message}} <div {{#if this.formula}} data-blank-href=\"/hu/problem/direct/{{#base64 this.formula /}}/?source=solution-fake&cmd={{this.cmd}}\"{{/if}} class=\"problem--text\"> <span>{{#compute this.message /}}</span> </div> {{/if}} {{/each}} {{/if}} {{/if}} </div>","recent-topics-dashboard":"{{#if this.success}} {{#if Object.keys(this.result).length > 0}} <strong class=\"title\" style=\"padding:0\">Legutóbb megtekintett</strong> <div class=\"list collection__list\" style=\"margin-top:10px\"> {{#each this.result}} <a class=\"list--item collection__list__item\" href=\"{{this.url}}\"> <span class=\"collection__list__main-col\"><b>{{this.idx}}</b> <span>{{this.title}}</span></span> <small style=\"display: block; opacity: .5\"> <span data-ago-moment=\"{{this.lastVisited}}\"></span>. </small> </a> {{/each}} </div> {{#else}} <p>Itt jelennek meg a legutóbb megtekintett leckéid. Kattints a tananyagra, és böngéssz a leckék között!</p> {{/if}} {{#else}} <p style=\"opacity: 0.5\">Hiba történt a leckék betöltése során.</p> {{/if}}","recent-topics":"{{#if this.success}} {{#if Object.keys(this.result).length > 0}} <strong>Legutóbb látogatott</strong> <div class=\"list collection__list\" style=\"margin-top:10px\"> {{#each this.result}} <a class=\"list--item collection__list__item\" href=\"{{this.url}}\"> <span class=\"collection__list__main-col\"><b>{{this.idx}}</b> <span>{{this.title}}</span></span> <small style=\"display: block; opacity: .5\"> <span data-ago-moment=\"{{this.lastVisited}}\"></span>. </small> </a> {{/each}} </div> {{#else}} <p>Itt jelennek meg a legutóbb megtekintett leckéid. Nézz körül, és kattints bármelyik leckére!</p> {{/if}} {{#else}} <p style=\"opacity: 0.5;\">Hiba történt a leckék betöltése során.</p> {{/if}}","users-list":"{{#if Object.keys(this).length > 0}} {{#each this}} {{#if meta.key === 'group-director' && this.length > 0}} <strong>Csoportvezető(k)</strong> <div class=\"user-list\"> {{#each this}} {{#if this._id}} <div class=\"user-list__item\"> <a class=\"user-list__name\" href=\"/hu/user/{{this._id}}\">{{this.name}}{{#if this.email}}<br>{{this.email}}{{/if}}</a> <div class=\"user-list__actions\"> <a class=\"button button--iconed button--small button--gray\" data-user-action=\"remove-owner-role:{{this._id}}\"> {{>icon \"symbol-x\"}} </a> </div> </div> {{/if}} {{/each}} </div> {{#elseif meta.key === 'group-member' && this.length > 0}} <strong>Csoporttagok</strong> <div class=\"user-list\"> {{#each this}} {{#if this._id}} <div class=\"user-list__item\"> <span style=\"vertical-align:middle\">{{parseInt(meta.index, 10) > 99 ? (parseInt(meta.index, 10) + 1) : ('0' + (parseInt(meta.index, 10) + 1)).substr(-2,2)}}</span> <a class=\"user-list__name\" style=\"vertical-align:middle;margin-left:10px;padding-top:0\" href=\"?filterUser={{this._id}}\">{{this.name}}{{#if this.email}}<br>{{this.email}}{{/if}}</a> <div class=\"user-list__actions\"> <a class=\"button button--small button--gray\" data-user-action=\"add-owner-role:{{this._id}}\">Legyen csoportvezető</a> <a class=\"button button--iconed button--small button--gray\" data-user-edit=\"{{this._id}}::{{this.email}}::{{this.name}}\">{{>icon \"symbol-pen\"}}</a> <a class=\"button button--iconed button--small button--gray\" data-user-action=\"remove-user:{{this._id}}\"> {{>icon \"symbol-x\"}} </a> </div> </div> {{/if}} {{/each}} </div> {{#elseif meta.key === 'unapproved-group-member' && this.length > 0}} <strong>Csatlakozási kérelmek</strong> <div class=\"user-list\"> {{#each this}} {{#if this._id}} <div class=\"user-list__item\"> <a class=\"user-list__name\" href=\"/hu/user/{{this._id}}\">{{this.name}}</a> <div class=\"user-list__actions\" data-group-join-approve-action> <a class=\"button button--iconed button--small\" data-user-action=\"approve-user:{{this._id}}\"> {{>icon \"symbol-pipe\"}} </a> <a class=\"button button--iconed button--small button--gray\" data-user-action=\"un-approve-user:{{this._id}}\"> {{>icon \"symbol-x\"}} </a> </div> </div> {{/if}} {{/each}} </div> {{#elseif meta.key === 'liker' && this.length > 0}} <strong>Akiknek tetszik</strong> <div class=\"user-list\"> {{#each this}} {{#if this._id}} <div class=\"user-list__item\"> <a class=\"user-list__name\" href=\"/hu/user/{{this._id}}\">{{this.name}}</a> </div> {{/if}} {{/each}} </div> {{/if}} {{/each}} {{#else}} <strong style=\"margin-bottom: 30px;\">Nincs ilyen felhasználó.</strong> {{/if}}","youtube-video":"<div style=\"background-color:#fff;padding-bottom: calc(315 / 560 * 100%);position:absolute;width: 100%;top: 50%;transform: translateY(-50%);\"> <iframe src=\"https://www.youtube.com/embed/{{this.id}}?autoplay=1&theme=light&showinfo=0&rel=0&hd=1&controls=1&autohide=1&modestbranding=1&cc_load_policy=1&cc_lang_pref={{this.language.split('-')[0]}}\" style=\"position:absolute;width: 100%; height: 100%;left:0;top:0;\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe> </div>"};